import * as React from 'react';
import React__default, { forwardRef, useContext, useRef, useMemo, useEffect, useState, useLayoutEffect, useCallback, Children, isValidElement, cloneElement, useReducer, Fragment as Fragment$1, createElement as createElement$1, PureComponent, Suspense, Component, createContext as createContext$1 } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import _$1, { first, isEmpty, findLastIndex, findIndex as findIndex$1 } from 'lodash';
import { Transition, CSSTransition, SwitchTransition } from 'react-transition-group';
import { CopyToClipboard } from 'react-copy-to-clipboard';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production = {};

/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var REACT_ELEMENT_TYPE$1 = Symbol.for("react.transitional.element"),
  REACT_FRAGMENT_TYPE$1 = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
  var key = null;
  void 0 !== maybeKey && (key = "" + maybeKey);
  void 0 !== config.key && (key = "" + config.key);
  if ("key" in config) {
    maybeKey = {};
    for (var propName in config) "key" !== propName && (maybeKey[propName] = config[propName]);
  } else maybeKey = config;
  config = maybeKey.ref;
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: type,
    key: key,
    ref: void 0 !== config ? config : null,
    props: maybeKey
  };
}
reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE$1;
reactJsxRuntime_production.jsx = jsxProd;
reactJsxRuntime_production.jsxs = jsxProd;

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"production" !== process.env.NODE_ENV && function () {
  function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE$2 ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch (type) {
      case REACT_FRAGMENT_TYPE:
        return "Fragment";
      case REACT_PORTAL_TYPE:
        return "Portal";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
    }
    if ("object" === typeof type) switch ("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        return (type.displayName || "Context") + ".Provider";
      case REACT_CONSUMER_TYPE:
        return (type._context.displayName || "Context") + ".Consumer";
      case REACT_FORWARD_REF_TYPE:
        var innerType = type.render;
        type = type.displayName;
        type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
        return type;
      case REACT_MEMO_TYPE:
        return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
      case REACT_LAZY_TYPE:
        innerType = type._payload;
        type = type._init;
        try {
          return getComponentNameFromType(type(innerType));
        } catch (x) {}
    }
    return null;
  }
  function testStringCoercion(value) {
    return "" + value;
  }
  function checkKeyStringCoercion(value) {
    try {
      testStringCoercion(value);
      var JSCompiler_inline_result = !1;
    } catch (e) {
      JSCompiler_inline_result = !0;
    }
    if (JSCompiler_inline_result) {
      JSCompiler_inline_result = console;
      var JSCompiler_temp_const = JSCompiler_inline_result.error;
      var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
      JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
      return testStringCoercion(value);
    }
  }
  function disabledLog() {}
  function disableLogs() {
    if (0 === disabledDepth) {
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd;
      var props = {
        configurable: !0,
        enumerable: !0,
        value: disabledLog,
        writable: !0
      };
      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
    }
    disabledDepth++;
  }
  function reenableLogs() {
    disabledDepth--;
    if (0 === disabledDepth) {
      var props = {
        configurable: !0,
        enumerable: !0,
        writable: !0
      };
      Object.defineProperties(console, {
        log: assign({}, props, {
          value: prevLog
        }),
        info: assign({}, props, {
          value: prevInfo
        }),
        warn: assign({}, props, {
          value: prevWarn
        }),
        error: assign({}, props, {
          value: prevError
        }),
        group: assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: assign({}, props, {
          value: prevGroupEnd
        })
      });
    }
    0 > disabledDepth && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
  }
  function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
      throw Error();
    } catch (x) {
      var match = x.stack.trim().match(/\n( *(at )?)/);
      prefix = match && match[1] || "";
      suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
  }
  function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    var frame = componentFrameCache.get(fn);
    if (void 0 !== frame) return frame;
    reentry = !0;
    frame = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    var previousDispatcher = null;
    previousDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = null;
    disableLogs();
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function () {
          try {
            if (construct) {
              var Fake = function () {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function () {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  var control = x;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$0) {
                  control = x$0;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$1) {
                control = x$1;
              }
              (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function () {});
            }
          } catch (sample) {
            if (sample && control && "string" === typeof sample.stack) return [sample.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
        value: "DetermineComponentFrameRoot"
      });
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(),
        sampleStack = _RunInRootFrame$Deter[0],
        controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"),
          controlLines = controlStack.split("\n");
        for (_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes("DetermineComponentFrameRoot");) namePropDescriptor++;
        for (; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes("DetermineComponentFrameRoot");) _RunInRootFrame$Deter++;
        if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length) for (namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter];) _RunInRootFrame$Deter--;
        for (; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--) if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
          if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
            do if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
              var _frame = "\n" + sampleLines[namePropDescriptor].replace(" at new ", " at ");
              fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
              "function" === typeof fn && componentFrameCache.set(fn, _frame);
              return _frame;
            } while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
          }
          break;
        }
      }
    } finally {
      reentry = !1, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame;
    }
    sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
    "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
    return sampleLines;
  }
  function describeUnknownElementTypeFrameInDEV(type) {
    if (null == type) return "";
    if ("function" === typeof type) {
      var prototype = type.prototype;
      return describeNativeComponentFrame(type, !(!prototype || !prototype.isReactComponent));
    }
    if ("string" === typeof type) return describeBuiltInComponentFrame(type);
    switch (type) {
      case REACT_SUSPENSE_TYPE:
        return describeBuiltInComponentFrame("Suspense");
      case REACT_SUSPENSE_LIST_TYPE:
        return describeBuiltInComponentFrame("SuspenseList");
    }
    if ("object" === typeof type) switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return type = describeNativeComponentFrame(type.render, !1), type;
      case REACT_MEMO_TYPE:
        return describeUnknownElementTypeFrameInDEV(type.type);
      case REACT_LAZY_TYPE:
        prototype = type._payload;
        type = type._init;
        try {
          return describeUnknownElementTypeFrameInDEV(type(prototype));
        } catch (x) {}
    }
    return "";
  }
  function getOwner() {
    var dispatcher = ReactSharedInternals.A;
    return null === dispatcher ? null : dispatcher.getOwner();
  }
  function hasValidKey(config) {
    if (hasOwnProperty.call(config, "key")) {
      var getter = Object.getOwnPropertyDescriptor(config, "key").get;
      if (getter && getter.isReactWarning) return !1;
    }
    return void 0 !== config.key;
  }
  function defineKeyPropWarningGetter(props, displayName) {
    function warnAboutAccessingKey() {
      specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
    }
    warnAboutAccessingKey.isReactWarning = !0;
    Object.defineProperty(props, "key", {
      get: warnAboutAccessingKey,
      configurable: !0
    });
  }
  function elementRefGetterWithDeprecationWarning() {
    var componentName = getComponentNameFromType(this.type);
    didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
    componentName = this.props.ref;
    return void 0 !== componentName ? componentName : null;
  }
  function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    type = {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key,
      props: props,
      _owner: owner
    };
    null !== (void 0 !== self ? self : null) ? Object.defineProperty(type, "ref", {
      enumerable: !1,
      get: elementRefGetterWithDeprecationWarning
    }) : Object.defineProperty(type, "ref", {
      enumerable: !1,
      value: null
    });
    type._store = {};
    Object.defineProperty(type._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: 0
    });
    Object.defineProperty(type, "_debugInfo", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: null
    });
    Object.freeze && (Object.freeze(type.props), Object.freeze(type));
    return type;
  }
  function jsxDEVImpl(type, config, maybeKey, isStaticChildren, source, self) {
    if ("string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE$1 || void 0 !== type.getModuleId)) {
      var children = config.children;
      if (void 0 !== children) if (isStaticChildren) {
        if (isArrayImpl(children)) {
          for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++) validateChildKeys(children[isStaticChildren], type);
          Object.freeze && Object.freeze(children);
        } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
      } else validateChildKeys(children, type);
    } else {
      children = "";
      if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length) children += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
      null === type ? isStaticChildren = "null" : isArrayImpl(type) ? isStaticChildren = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (isStaticChildren = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", children = " Did you accidentally export a JSX literal instead of a component?") : isStaticChildren = typeof type;
      console.error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", isStaticChildren, children);
    }
    if (hasOwnProperty.call(config, "key")) {
      children = getComponentNameFromType(type);
      var keys = Object.keys(config).filter(function (k) {
        return "key" !== k;
      });
      isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
      didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', isStaticChildren, children, keys, children), didWarnAboutKeySpread[children + isStaticChildren] = !0);
    }
    children = null;
    void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
    hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
    if ("key" in config) {
      maybeKey = {};
      for (var propName in config) "key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    children && defineKeyPropWarningGetter(maybeKey, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
    return ReactElement(type, children, self, source, getOwner(), maybeKey);
  }
  function validateChildKeys(node, parentType) {
    if ("object" === typeof node && node && node.$$typeof !== REACT_CLIENT_REFERENCE) if (isArrayImpl(node)) for (var i = 0; i < node.length; i++) {
      var child = node[i];
      isValidElement(child) && validateExplicitKey(child, parentType);
    } else if (isValidElement(node)) node._store && (node._store.validated = 1);else if (null === node || "object" !== typeof node ? i = null : (i = MAYBE_ITERATOR_SYMBOL && node[MAYBE_ITERATOR_SYMBOL] || node["@@iterator"], i = "function" === typeof i ? i : null), "function" === typeof i && i !== node.entries && (i = i.call(node), i !== node)) for (; !(node = i.next()).done;) isValidElement(node.value) && validateExplicitKey(node.value, parentType);
  }
  function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  }
  function validateExplicitKey(element, parentType) {
    if (element._store && !element._store.validated && null == element.key && (element._store.validated = 1, parentType = getCurrentComponentErrorInfo(parentType), !ownerHasKeyUseWarning[parentType])) {
      ownerHasKeyUseWarning[parentType] = !0;
      var childOwner = "";
      element && null != element._owner && element._owner !== getOwner() && (childOwner = null, "number" === typeof element._owner.tag ? childOwner = getComponentNameFromType(element._owner.type) : "string" === typeof element._owner.name && (childOwner = element._owner.name), childOwner = " It was passed a child from " + childOwner + ".");
      var prevGetCurrentStack = ReactSharedInternals.getCurrentStack;
      ReactSharedInternals.getCurrentStack = function () {
        var stack = describeUnknownElementTypeFrameInDEV(element.type);
        prevGetCurrentStack && (stack += prevGetCurrentStack() || "");
        return stack;
      };
      console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', parentType, childOwner);
      ReactSharedInternals.getCurrentStack = prevGetCurrentStack;
    }
  }
  function getCurrentComponentErrorInfo(parentType) {
    var info = "",
      owner = getOwner();
    owner && (owner = getComponentNameFromType(owner.type)) && (info = "\n\nCheck the render method of `" + owner + "`.");
    info || (parentType = getComponentNameFromType(parentType)) && (info = "\n\nCheck the top-level render call using <" + parentType + ">.");
    return info;
  }
  var React = React__default,
    REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
    REACT_PORTAL_TYPE = Symbol.for("react.portal"),
    REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
    REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
    REACT_PROFILER_TYPE = Symbol.for("react.profiler");
  var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
    REACT_CONTEXT_TYPE = Symbol.for("react.context"),
    REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
    REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
    REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
    REACT_MEMO_TYPE = Symbol.for("react.memo"),
    REACT_LAZY_TYPE = Symbol.for("react.lazy"),
    REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"),
    MAYBE_ITERATOR_SYMBOL = Symbol.iterator,
    REACT_CLIENT_REFERENCE$2 = Symbol.for("react.client.reference"),
    ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    assign = Object.assign,
    REACT_CLIENT_REFERENCE$1 = Symbol.for("react.client.reference"),
    isArrayImpl = Array.isArray,
    disabledDepth = 0,
    prevLog,
    prevInfo,
    prevWarn,
    prevError,
    prevGroup,
    prevGroupCollapsed,
    prevGroupEnd;
  disabledLog.__reactDisabledLog = !0;
  var prefix,
    suffix,
    reentry = !1;
  var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
  var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"),
    specialPropKeyWarningShown;
  var didWarnAboutElementRef = {};
  var didWarnAboutKeySpread = {},
    ownerHasKeyUseWarning = {};
  reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_development.jsx = function (type, config, maybeKey, source, self) {
    return jsxDEVImpl(type, config, maybeKey, !1, source, self);
  };
  reactJsxRuntime_development.jsxs = function (type, config, maybeKey, source, self) {
    return jsxDEVImpl(type, config, maybeKey, !0, source, self);
  };
}();

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production;
} else {
  jsxRuntime.exports = reactJsxRuntime_development;
}

var isDevelopment$2 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here

  return undefined;
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}
var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === undefined ? !isDevelopment$2 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from$1 = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash(value, length) {
  return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}

/**
 * @param {string} value
 * @return {string}
 */
function trim(value) {
  return value.trim();
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof(value, search) {
  return value.indexOf(search);
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr(value, begin, end) {
  return value.slice(begin, end);
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen(value) {
  return value.length;
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof(value) {
  return value.length;
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append(value, array) {
  return array.push(value), value;
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine(array, callback) {
  return array.map(callback).join('');
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node(value, root, parent, type, props, children, length) {
  return {
    value: value,
    root: root,
    parent: parent,
    type: type,
    props: props,
    children: children,
    line: line,
    column: column,
    length: length,
    return: ''
  };
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy$2(root, props) {
  return assign$1(node('', null, null, '', null, null, 0), root, {
    length: -root.length
  }, props);
}

/**
 * @return {number}
 */
function char() {
  return character;
}

/**
 * @return {number}
 */
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}

/**
 * @return {number}
 */
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}

/**
 * @return {number}
 */
function peek() {
  return charat(characters, position);
}

/**
 * @return {number}
 */
function caret$1() {
  return position;
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice(begin, end) {
  return substr(characters, begin, end);
}

/**
 * @param {number} type
 * @return {number}
 */
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc(value) {
  return characters = '', value;
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace(type) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type) > 2 || token(character) > 3 ? '' : ' ';
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping(index, count) {
  while (--count && next())
  // not 0-9 A-F a-f
  if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice(index, caret$1() + (count < 6 && peek() == 32 && next() == 32));
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter(type) {
  while (next()) switch (character) {
    // ] ) " '
    case type:
      return position;
    // " '
    case 34:
    case 39:
      if (type !== 34 && type !== 39) delimiter(character);
      break;
    // (
    case 40:
      if (type === 41) delimiter(type);
      break;
    // \
    case 92:
      next();
      break;
  }
  return position;
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter(type, index) {
  while (next())
  // //
  if (type + character === 47 + 10) break;
  // /*
  else if (type + character === 42 + 42 && peek() === 47) break;
  return '/*' + slice(index, position - 1) + '*' + from$1(type === 47 ? type : next());
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier(index) {
  while (!token(peek())) next();
  return slice(index, position);
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile(value) {
  return dealloc(parse$5('', null, null, null, [''], value = alloc(value), 0, [0], value));
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$5(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character = 0;
  var type = '';
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters = type;
  while (scanning) switch (previous = character, character = next()) {
    // (
    case 40:
      if (previous != 108 && charat(characters, length - 1) == 58) {
        if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
        break;
      }
    // " ' [
    case 34:
    case 39:
    case 91:
      characters += delimit(character);
      break;
    // \t \n \r \s
    case 9:
    case 10:
    case 13:
    case 32:
      characters += whitespace(previous);
      break;
    // \
    case 92:
      characters += escaping(caret$1() - 1, 7);
      continue;
    // /
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append(comment(commenter(next(), caret$1()), root, parent), declarations);
          break;
        default:
          characters += '/';
      }
      break;
    // {
    case 123 * variable:
      points[index++] = strlen(characters) * ampersand;
    // } ; \0
    case 125 * variable:
    case 59:
    case 0:
      switch (character) {
        // \0 }
        case 0:
        case 125:
          scanning = 0;
        // ;
        case 59 + offset:
          if (ampersand == -1) characters = replace(characters, /\f/g, '');
          if (property > 0 && strlen(characters) - length) append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
          break;
        // @ ;
        case 59:
          characters += ';';
        // { rule/at-rule
        default:
          append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
          if (character === 123) if (offset === 0) parse$5(characters, root, reference, reference, props, rulesets, length, points, children);else switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
            // d l m s
            case 100:
            case 108:
            case 109:
            case 115:
              parse$5(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
              break;
            default:
              parse$5(characters, reference, reference, reference, [''], children, 0, points, children);
          }
      }
      index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
      break;
    // :
    case 58:
      length = 1 + strlen(characters), property = previous;
    default:
      if (variable < 1) if (character == 123) --variable;else if (character == 125 && variable++ == 0 && prev() == 125) continue;
      switch (characters += from$1(character), character * variable) {
        // &
        case 38:
          ampersand = offset > 0 ? 1 : (characters += '\f', -1);
          break;
        // ,
        case 44:
          points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
          break;
        // @
        case 64:
          // -
          if (peek() === 45) characters += delimit(next());
          atrule = peek(), offset = length = strlen(type = characters += identifier(caret$1())), character++;
          break;
        // -
        case 45:
          if (previous === 45 && strlen(characters) == 2) variable = 0;
      }
  }
  return rulesets;
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [''];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x) if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x]))) props[k++] = z;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length);
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from$1(char()), substr(value, 2, -2), 0);
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration(value, root, parent, length) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length);
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize(children, callback) {
  var output = '';
  var length = sizeof(children);
  for (var i = 0; i < length; i++) output += callback(children[i], i, children, callback) || '';
  return output;
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify$3(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return '';
    case KEYFRAMES:
      return element.return = element.value + '{' + serialize(element.children, callback) + '}';
    case RULESET:
      element.value = element.props.join(',');
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware(collection) {
  var length = sizeof(collection);
  return function (element, index, children, callback) {
    var output = '';
    for (var i = 0; i < length; i++) output += collection[i](element, index, children, callback) || '';
    return output;
  };
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet(callback) {
  return function (element) {
    if (!element.root) if (element = element.return) callback(element);
  };
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var isBrowser$4 = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (token(character)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;
  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character);
        break;
      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from$1(character);
    }
  } while (character = next());
  return parsed;
};
var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11

var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent ||
  // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case

  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */ && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"

  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;
    if (
    // charcode for l
    value.charCodeAt(0) === 108 &&
    // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }
      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;
    case KEYFRAMES:
      return serialize([copy$2(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy$2(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy$2(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy$2(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy$2(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }
        return '';
      });
  }
};
var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
  return memoize(function () {
    return {};
  });
});
var defaultStylisPlugins = [prefixer];
var createCache = function createCache(options) {
  var key = options.key;
  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');
      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (!getServerStylisCache) {
    var currentSheet;
    var finalizingPlugins = [stringify$3, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify$3];
    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };
    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$k.apply(null, arguments);
}

var reactIs$2 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g$1 = b ? Symbol.for("react.profiler") : 60114,
  h$1 = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l$1 = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l$1:
          case m:
          case e:
          case g$1:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
reactIs_production_min.AsyncMode = l$1;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h$1;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g$1;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function (a) {
  return A(a) || z(a) === l$1;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function (a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function (a) {
  return z(a) === h$1;
};
reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function (a) {
  return z(a) === n;
};
reactIs_production_min.isFragment = function (a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function (a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function (a) {
  return z(a) === r;
};
reactIs_production_min.isPortal = function (a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function (a) {
  return z(a) === g$1;
};
reactIs_production_min.isStrictMode = function (a) {
  return z(a) === f;
};
reactIs_production_min.isSuspense = function (a) {
  return z(a) === p;
};
reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g$1 || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h$1 || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function () {

    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development$1.AsyncMode = AsyncMode;
    reactIs_development$1.ConcurrentMode = ConcurrentMode;
    reactIs_development$1.ContextConsumer = ContextConsumer;
    reactIs_development$1.ContextProvider = ContextProvider;
    reactIs_development$1.Element = Element;
    reactIs_development$1.ForwardRef = ForwardRef;
    reactIs_development$1.Fragment = Fragment;
    reactIs_development$1.Lazy = Lazy;
    reactIs_development$1.Memo = Memo;
    reactIs_development$1.Portal = Portal;
    reactIs_development$1.Profiler = Profiler;
    reactIs_development$1.StrictMode = StrictMode;
    reactIs_development$1.Suspense = Suspense;
    reactIs_development$1.isAsyncMode = isAsyncMode;
    reactIs_development$1.isConcurrentMode = isConcurrentMode;
    reactIs_development$1.isContextConsumer = isContextConsumer;
    reactIs_development$1.isContextProvider = isContextProvider;
    reactIs_development$1.isElement = isElement;
    reactIs_development$1.isForwardRef = isForwardRef;
    reactIs_development$1.isFragment = isFragment;
    reactIs_development$1.isLazy = isLazy;
    reactIs_development$1.isMemo = isMemo;
    reactIs_development$1.isPortal = isPortal;
    reactIs_development$1.isProfiler = isProfiler;
    reactIs_development$1.isStrictMode = isStrictMode;
    reactIs_development$1.isSuspense = isSuspense;
    reactIs_development$1.isValidElementType = isValidElementType;
    reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min;
} else {
  reactIs$2.exports = reactIs_development$1;
}

var reactIs$1 = reactIs$2.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment$1 = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== undefined) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        var keyframes = interpolation;
        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }
        var serializedStyles = interpolation;
        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = serializedStyles.styles + ";";
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }
        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)

  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== 'object') {
        var asString = value;
        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$1) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$2 = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
  return create();
};
var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;

var isDevelopment = false;
var isBrowser$1 = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */React.createContext(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);
      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}
var ThemeContext$1 = /* #__PURE__ */React.createContext({});
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};
var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
    serialized = _ref.serialized,
    isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }
  return null;
};
var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext$1));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref) {
    newProps.ref = ref;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

var Fragment = jsxRuntime.exports.Fragment;
var jsx$3 = function jsx(type, props, key) {
  if (!hasOwn.call(props, 'css')) {
    return jsxRuntime.exports.jsx(type, props, key);
  }
  return jsxRuntime.exports.jsx(Emotion$1, createEmotionProps(type, props), key);
};
var jsxs = function jsxs(type, props, key) {
  if (!hasOwn.call(props, 'css')) {
    return jsxRuntime.exports.jsxs(type, props, key);
  }
  return jsxRuntime.exports.jsxs(Emotion$1, createEmotionProps(type, props), key);
};

function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles$1(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}
function _assertThisInitialized$3(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _classCallCheck$2(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass$2(e, r, t) {
  return r && _defineProperties$2(e.prototype, r), t && _defineProperties$2(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$3(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$j.apply(null, arguments);
}
function _getPrototypeOf$2(t) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf$2(t);
}
function _inherits$2(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf$3(t, e);
}
function _isNativeReflectConstruct$2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$2 = function () {
    return !!t;
  })();
}
function _iterableToArray$1(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty$3(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties$2(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn$2(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf$3(t, e) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$3(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray$1(r) {
  return _arrayWithoutHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread$1();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

var hexToRgb$1 = function hexToRgb(hex) {
  return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) {
    return '#' + r + r + g + g + b + b;
  }).substring(1).match(/.{2}/g).map(function (x) {
    return parseInt(x, 16);
  });
};
var palette = {
  White: "#fff",
  Grey10: "#f5f5f5",
  Grey15: "#e0e0e0",
  Grey20: "#CBD4DA",
  Grey25: "#C8C8C8",
  Grey30: "#A7A7A7",
  Grey40: "#858C95",
  Grey45: "#6F6F6F",
  Grey50: "#404040",
  Grey55: "#4D5765",
  Grey60: "#3A4454",
  Grey65: "#2B323D",
  Grey70: "#111925",
  Grey75: "#060B12",
  Blue10: "#F4FBFF",
  Blue20: "#DDF1FF",
  Blue25: "#C9E7F5",
  Blue30: "#B9D4FF",
  Blue40: "#84B0FF",
  Blue50: "#0860ED",
  Blue60: "#405EBD",
  Blue70: "#0067C5",
  Blue80: "#1E4A93",
  Red10: "#FFF5F5",
  Red20: "#EB797B",
  Red30: "#DA1E21",
  Red40: "#A30D0F",
  Orange10: "#FFF6EF",
  Orange12: "#FFF2AD",
  Orange15: "#FEAF58",
  Orange20: "#EB9E41",
  Orange30: "#E7BE36",
  Orange40: "#FDC300",
  Orange50: "#F7941D",
  Orange60: "#EF6C01",
  Orange70: "#FE5502",
  Orange80: "#E47C5D",
  Orange90: "#615200",
  Green10: "#F2FCF9",
  Green20: "#ACDA6F",
  Green30: "#B2D234",
  Green40: "#A3B94C",
  Green50: "#68C6B3",
  Green60: "#48A08B",
  Green70: "#316200",
  Cyan10: "#EDF6FF",
  Cyan20: "#5E8DCD",
  Cyan25: "#5EA1FB",
  Cyan30: "#518BEC",
  Cyan40: "#7AC6EF",
  Cyan45: "#80EEF9",
  Cyan50: "#0BAFFC",
  Cyan55: "#2085B1",
  Cyan60: "#95A6F0",
  Cyan65: "#0054D7",
  Cyan70: "#012CAD",
  Purple01: "#EADCFC",
  Purple02: "#DEE9FA",
  Purple03: "#E8EEFD",
  Purple04: "#DEE0FA",
  Purple10: "#BB85C7",
  Purple15: "#DE9EFF",
  Purple16: "#AE80FD",
  Purple17: "#E974FC",
  Purple18: "#E424FF",
  Purple20: "#A815F3",
  Purple22: "#7B27FF",
  Purple25: "#6B31AB",
  Purple30: "#550057"
};
var enhance = function enhance(palette) {
  var out = _objectSpread2({}, palette);
  for (var key in palette) {
    out[key + "_RGB"] = hexToRgb$1(palette[key]).join(" ");
  }
  return out;
};
var palette$1 = enhance(palette);

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1;
var lightStyles = (function (css, palette) {
  var bg = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n      --main-background: ", ";\n      --main-background-rgb: ", ";\n      --content-background: ", ";\n      --hover-background: ", ";\n      --table-header-background: ", ";\n      --mask-background: ", ";\n    "])), palette.Grey10, palette.Grey10_RGB, palette.White, palette.Blue10, palette.Blue20, palette.Grey50);
  var text = css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n      --text-primary: ", ";\n      --text-secondary: ", ";\n      --text-disabled: ", ";\n      --text-on-color: ", ";\n      --text-button-disabled: ", ";\n      --text-button-primary: ", ";\n      --text-button-primary-hover: ", ";\n      --text-button-secondary: ", ";\n      --text-button-secondary-hover: ", ";\n      --text-button-light: ", ";\n      --text-title: ", ";\n    "])), palette.Grey50, palette.Grey45, palette.Grey30, palette.White, palette.Grey30, palette.Blue70, palette.Blue80, palette.Grey45, palette.Grey50, palette.Blue70, palette.Grey50);
  var buttons = css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n      --button-primary-bg: ", ";\n      --button-primary-bg-hover: ", ";\n      --button-primary-bg-disabled: ", ";\n      --button-primary-disabled: ", ";\n      --button-secondary: ", ";\n      --button-secondary-hover: ", ";\n      --button-secondary-disabled: ", ";\n      --button-card-footer: ", ";\n      --button-card-footer-hover: ", ";\n      --button-destructive-bg: ", ";\n      --button-destructive-bg-hover: ", ";\n    "])), palette.Blue70, palette.Blue80, palette.Grey15, palette.Grey30, palette.Blue70, palette.Blue80, palette.Grey30, palette.Blue10, palette.Blue20, palette.Red30, palette.Red40);
  var icons = css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n      --icon-primary: ", ";\n      --icon-primary-hover: ", ";\n      --icon-primary-disabled: ", ";\n\n      --icon-secondary: ", ";\n      --icon-secondary-hover: ", ";\n      --icon-secondary-disabled: ", ";\n\n      --icon-tertiary: ", ";\n      --icon-tertiary-hover: ", ";\n      --icon-tertiary-disabled: ", ";\n\n      --icon-on-color: ", ";\n      --icon-on-color-white: ", ";\n\n      --icon-round-border: ", ";\n\n      --icon-2colors-stroke: ", ";\n      --icon-2colors-stroke-disabled: ", ";\n      --icon-2colors-fill-disabled: ", ";\n\n      --tooltip-icon-default: ", ";\n      --tooltip-icon-hover: ", ";\n      --tooltip-icon-disabled: ", ";\n      --tooltip-info-bg: ", ";\n    "])), palette.Blue70, palette.Blue80, palette.Grey30, palette.Grey50, palette.Grey45, palette.Grey30, palette.Grey45, palette.Grey40, palette.Grey30, palette.White, palette.White, palette.Grey15, palette.Cyan70, palette.Grey30, palette.Grey25, palette.Grey30, palette.Blue70, palette.Grey15, palette.White);
  var notifications = css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n      --error: ", ";\n      --error-bg: ", ";\n      --warning: ", ";\n      --warning-bg: ", ";\n      --information: ", ";\n      --information-bg: ", ";\n      --info: ", ";\n      --info-bg: ", ";\n      --success: ", ";\n      --success-bg: ", ";\n      --group-item-bg: ", ";\n    "])), palette.Red30, palette.Red10, palette.Orange60, palette.Orange10, palette.Cyan30, palette.Cyan10, palette.Cyan30, palette.Cyan10, palette.Green60, palette.Green10, palette.White);
  var other = css(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n      --border: ", ";\n      --drop-shadow: ", ";\n      --drop-shadow-dialogs: ", ";\n      --scroller: ", ";\n      --scroller-track: #eee;\n      --mask-bg: ", ";\n      --date-picker-bg: ", ";\n      --item-selection-bg: ", ";\n      --item-selection-border: ", ";\n      --underline-default: ", ";\n      --underline-selected: ", ";\n      --focus-outline: ", ";\n      --focus-outline-header: ", ";\n    "])), palette.Grey15, palette.Grey15, palette.Grey45, palette.Grey25, palette.Grey50, palette.Grey10, palette.Grey10, palette.White, palette.Grey30, palette.Blue70, palette.Blue70, palette.White);
  var shell = css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n      --main-nav-bg: ", ";\n      --main-nav-bg-hover: ", ";\n      --main-nav-bg-selected: ", ";\n      --main-nav-icon-text: ", ";\n      --main-nav-icon-text-selected: ", ";\n      --header-netapp-bg: ", ";\n      --header-service-bg: ", ";\n      --header-netapp-primary-text: ", ";\n      --header-netapp-text-hover: ", ";\n      --header-netapp-secondary-text: ", ";\n      --header-netapp-icons: ", ";\n      --header-notification-text: ", ";\n      --header-notification-text-2: ", ";\n      --header-separator-1: ", ";\n      --header-separator-2: ", ";\n    "])), palette.White, palette.Grey10, palette.Blue10, palette.Grey45, palette.Blue70, palette.Blue70, palette.White, palette.White, palette.Blue30, palette.Blue10, palette.White, palette.Blue80, palette.White, palette.White, palette.White);
  var chart = css(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n      --chart-1: ", ";\n      --chart-2: ", ";\n      --chart-3: ", ";\n      --chart-4: ", ";\n      --chart-5: ", ";\n      --chart-6: ", ";\n      --chart-7: ", ";\n      --chart-8: ", ";\n      --chart-9: ", ";\n      --chart-10: ", ";\n      --chart-11: ", ";\n      --chart-3-gradient: ", ";\n      --chart-9-gradient: ", ";\n      --chart-disabled: ", ";\n      --chart-background: ", ";\n      \n      --chart-brand-12: ", ";\n      --chart-brand-13: ", ";\n      --chart-brand-14: ", ";\n      --chart-brand-15: ", ";\n      --chart-brand-16: ", ";\n    "])), palette.Cyan70, palette.Cyan20, palette.Cyan50, palette.Green50, palette.Green30, palette.Orange40, palette.Orange50, palette.Orange70, palette.Purple20, palette.Purple30, palette.Purple15, palette.Cyan50, palette.Purple20, palette.Grey15, palette.Purple03, palette.Purple18, palette.Purple22, palette.Green70, palette.Cyan65, palette.Cyan45);
  var tag = css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n      --tag-1-text: ", ";\n      --tag-1-bg: ", ";\n      --tag-2-text: ", ";\n      --tag-2-bg: ", ";\n      --tag-3-text: ", ";\n      --tag-3-bg: ", ";\n      --tag-4-text: ", ";\n      --tag-4-bg: ", ";\n      --tag-new-bg: ", ";\n    "])), palette.Cyan70, palette.Blue25, palette.Purple25, palette.Purple01, palette.Blue80, palette.Purple02, palette.Orange90, palette.Orange12, palette.Purple04);
  var selectors = css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n      --selector-off-border: ", ";\n      --selector-off-border-hover: ", ";\n      --selector-off-border-disabled: ", ";\n      --selector-off-bg-disabled: ", ";\n      --selector-on-bg: ", ";\n      --selector-on-bg-disabled: ", ";\n      --selector-on-bg-hover: ", ";\n      --toggle-off: ", ";\n      --toggle-off-bg: ", ";\n      --toggle-off-disabled: ", ";\n      --toggle-off-bg-hover: ", ";\n    "])), palette.Grey50, palette.Grey45, palette.Grey30, palette.Grey10, palette.Blue70, palette.Grey30, palette.Blue80, palette.White, palette.Grey25, palette.Grey25, palette.Grey30);
  var loaders = css(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n      --loader-wheel-line: ", ";\n      --loader-dot: ", ";\n      --loader-line-bg: ", ";\n      --loader-skeleton: ", ";\n      --loader-skeleton-bg: ", ";\n    "])), palette.Blue70, palette.Cyan30, palette.Grey15, palette.Grey15, palette.Grey10);
  var fields = css(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n      --field-border: ", ";\n      --field-border-disabled: ", ";\n      --field-bg-disabled: ", ";\n      --field-border-selected: ", ";\n      --field-icon: ", ";\n      --field-icon-disabled: ", ";\n    "])), palette.Grey30, palette.Grey25, palette.Grey10, palette.Blue70, palette.Grey45, palette.Grey25);
  var thirdPartyTokens = css(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n      --third-party-aws-smile: #FF9900;\n      --third-party-aws-text: #252F3E;\n    "])));
  var canvas = css(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n      --canvas-cloud-shadow: ", ";\n    "])), palette.Grey25);
  var components = css(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n      --ux-icon-2-color-stroke: var(--icon-2colors-stroke);\n      --ux-icon-2-color-fill: var(--chart-11);\n    "])));
  return [bg, text, buttons, icons, notifications, other, shell, chart, selectors, loaders, fields, thirdPartyTokens, canvas, components, tag].join("\n");
});

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var darkStyles = (function (css, palette) {
  var bg = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      --main-background: ", ";\n      --main-background-rgb: ", ";\n      --content-background: ", ";\n      --hover-background: ", ";\n      --table-header-background: ", ";\n      --mask-background: ", ";\n    "])), palette.Grey70, palette.Grey70_RGB, palette.Grey65, palette.Grey60, palette.Grey55, palette.Grey40);
  var text = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      --text-primary: ", ";\n      --text-secondary: ", ";\n      --text-disabled: ", ";\n      --text-on-color: ", ";\n      --text-button-disabled: ", ";\n      --text-button-primary: ", ";\n      --text-button-primary-hover: ", ";\n      --text-button-secondary: ", ";\n      --text-button-secondary-hover: ", ";\n      --text-button-light: ", ";\n      --text-title: ", ";\n    "])), palette.White, palette.Grey20, palette.Grey40, palette.White, palette.Grey40, palette.Blue40, palette.Blue30, palette.Grey20, palette.Grey15, palette.Blue30, palette.White);
  var buttons = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      --button-primary-bg: ", ";\n      --button-primary-bg-hover: ", ";\n      --button-primary-bg-disabled: ", ";\n      --button-primary-disabled: ", ";\n      --button-secondary: ", ";\n      --button-secondary-hover: ", ";\n      --button-secondary-disabled: ", ";\n      --button-card-footer: ", ";\n      --button-card-footer-hover: ", ";\n      --button-destructive-bg: ", ";\n      --button-destructive-bg-hover: ", ";\n    "])), palette.Blue50, palette.Blue60, palette.Grey40, palette.Grey50, palette.Blue40, palette.Blue30, palette.Grey40, palette.Grey60, palette.Grey55, palette.Red30, palette.Red40);
  var icons = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      --icon-primary: ", ";\n      --icon-primary-hover: ", ";\n      --icon-primary-disabled: ", ";\n\n      --icon-secondary: ", ";\n      --icon-secondary-hover: ", ";\n      --icon-secondary-disabled: ", ";\n\n      --icon-tertiary: ", ";\n      --icon-tertiary-hover: ", ";\n      --icon-tertiary-disabled: ", ";\n      \n      --icon-on-color: ", ";\n      --icon-on-color-white: ", ";\n\n      --icon-round-border: ", ";\n\n      --icon-2colors-stroke: ", ";\n      --icon-2colors-stroke-disabled: ", ";\n      --icon-2colors-fill-disabled: ", ";\n\n      --tooltip-icon-default: ", ";\n      --tooltip-icon-hover: ", ";\n      --tooltip-icon-disabled: ", ";\n      --tooltip-info-bg: ", ";\n    "])), palette.White, palette.Blue30, palette.Grey40, palette.White, palette.Grey20, palette.Grey40, palette.Grey20, palette.Grey30, palette.Grey40, palette.Grey70, palette.White, palette.Grey40, palette.White, palette.Grey40, palette.Grey70, palette.Grey20, palette.Blue40, palette.Grey40, palette.Grey70);
  var notifications = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      --error: ", ";\n      --error-bg: ", ";\n      --warning: ", ";\n      --warning-bg: ", ";\n      --information: ", ";\n      --information-bg: ", ";\n      --info: ", ";\n      --info-bg: ", ";\n      --success: ", ";\n      --success-bg: ", ";\n      --group-item-bg: ", ";\n    "])), palette.Red20, palette.Grey60, palette.Orange15, palette.Grey60, palette.Blue40, palette.Grey60, palette.Blue30, palette.Grey60, palette.Green20, palette.Grey60, palette.Grey60);
  var other = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      --border: ", ";\n      --drop-shadow: ", ";\n      --drop-shadow-dialogs: ", ";\n      --scroller: ", ";\n      --scroller-track: ", ";\n      --mask-bg: ", ";\n      --mask-bg: ", ";\n      --date-picker-bg: ", ";\n      --item-selection-bg: ", ";\n      --item-selection-border: ", ";\n      --underline-default: ", ";\n      --underline-selected: ", ";\n      --focus-outline: ", ";\n      --focus-outline-header: ", ";\n    "])), palette.Grey55, palette.Grey70, palette.Grey70, palette.Grey40, palette.Grey70, palette.Grey40, palette.Grey40, palette.Grey65, palette.Grey60, palette.Grey40, palette.Grey40, palette.Blue40, palette.Blue40, palette.Blue40);
  var shell = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      --main-nav-bg: ", ";\n      --main-nav-bg-hover: ", ";\n      --main-nav-bg-selected: ", ";\n      --main-nav-icon-text: ", ";\n      --main-nav-icon-text-selected: ", ";\n      --header-netapp-bg: ", ";\n      --header-service-bg: ", ";\n      --header-netapp-primary-text: ", ";\n      --header-netapp-text-hover: ", ";\n      --header-netapp-secondary-text: ", ";\n      --header-netapp-icons: ", ";\n      --header-notification-text: ", ";\n      --header-notification-text-2: ", ";\n      --header-separator-1: ", ";\n      --header-separator-2: ", ";\n    "])), palette.Grey65, palette.Grey60, palette.Grey60, palette.Grey20, palette.Cyan40, palette.Grey65, palette.Grey65, palette.White, palette.Blue40, palette.Grey15, palette.Grey15, palette.Grey70, palette.Grey70, palette.Grey40, palette.Grey55);
  var chart = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      --chart-1: ", ";\n      --chart-2: ", ";\n      --chart-3: ", ";\n      --chart-4: ", ";\n      --chart-5: ", ";\n      --chart-6: ", ";\n      --chart-7: ", ";\n      --chart-8: ", ";\n      --chart-9: ", ";\n      --chart-10: ", ";\n      --chart-11: ", ";\n      --chart-3-gradient: ", ";\n      --chart-9-gradient: ", ";\n      --chart-disabled: ", ";\n      --chart-background: ", ";\n      \n      --chart-brand-12: ", ";\n      --chart-brand-13: ", ";\n      --chart-brand-14: ", ";\n      --chart-brand-15: ", ";\n      --chart-brand-16: ", ";\n    "])), palette.Cyan60, palette.Cyan25, palette.Cyan40, palette.Green50, palette.Green40, palette.Orange30, palette.Orange20, palette.Orange80, palette.Purple15, palette.Grey20, palette.Purple10, palette.Cyan50, palette.Purple20, palette.Grey60, palette.Grey60, palette.Purple17, palette.Purple16, palette.Green50, palette.Cyan50, palette.Cyan55);
  var tag = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      --tag-1-text: ", ";\n      --tag-1-bg: ", ";\n      --tag-2-text: ", ";\n      --tag-2-bg: ", ";\n      --tag-3-text: ", ";\n      --tag-3-bg: ", ";\n      --tag-4-text: ", ";\n      --tag-4-bg: ", ";\n      --tag-new-bg: ", ";\n    "])), palette.Cyan70, palette.Blue25, palette.Purple25, palette.Purple01, palette.Blue80, palette.Purple02, palette.Orange90, palette.Orange12, palette.Purple04);
  var selectors = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      --selector-off-border: ", ";\n      --selector-off-border-hover: ", ";\n      --selector-off-border-disabled: ", ";\n      --selector-off-bg-disabled: ", ";\n      --selector-on-bg: ", ";\n      --selector-on-bg-disabled: ", ";\n      --selector-on-bg-hover: ", ";\n      --toggle-off: ", ";\n      --toggle-off-bg: ", ";\n      --toggle-off-disabled: ", ";\n      --toggle-off-bg-hover: ", ";\n    "])), palette.White, palette.Grey20, palette.Grey40, palette.Grey65, palette.Blue40, palette.Grey40, palette.Blue30, palette.White, palette.Grey25, palette.Grey40, palette.Grey30);
  var loaders = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      --loader-wheel-line: ", "; \n      --loader-dot: ", "; \n      --loader-line-bg: ", "; \n      --loader-skeleton: ", ";\n      --loader-skeleton-bg: ", ";\n    "])), palette.Blue40, palette.Blue40, palette.Grey40, palette.Grey60, palette.Grey55);
  var fields = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      --field-border: ", ";\n      --field-border-disabled: ", ";\n      --field-bg-disabled: ", ";\n      --field-border-selected: ", ";\n      --field-icon: ", ";\n      --field-icon-disabled: ", ";\n    "])), palette.Grey20, palette.Grey40, palette.Grey60, palette.Blue40, palette.Grey20, palette.Grey40);
  var thirdPartyTokens = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      --third-party-aws-smile: #FFFFFF;\n      --third-party-aws-text: #FFFFFF;\n    "])));
  var canvas = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      --canvas-cloud-shadow: ", ";\n    "])), palette.Grey70);
  var components = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      --ux-icon-2-color-stroke: var(--icon-2colors-stroke);\n      --ux-icon-2-color-fill: var(--chart-11);\n    "])));
  return [bg, text, buttons, icons, notifications, other, shell, chart, selectors, loaders, fields, thirdPartyTokens, canvas, components, tag, "color-scheme: dark;"].join("\n");
});

const styles$1h = {
    light: lightStyles,
    dark: darkStyles
};
/**
 * Template function does nothing, but webstorm uses it to properly syntax highlight css
 */
const css$3 = (strings, ...values) => {
    return strings.map(function (e, i) {
        return [e, values[i]];
    }).flat().join(" ");
};
const emptyTheme = { theme: "", styleString: "", tokens: {} };
const ThemeContext = React__default.createContext(emptyTheme);
const useCurrentTheme = () => {
    return useContext(ThemeContext);
};
const ThemeProvider = React__default.memo(({ children, theme, isRoot, className, container }) => {
    const wrapperRef = useRef(null);
    const themeState = useMemo(() => {
        const style = styles$1h[theme];
        if (!style) {
            return emptyTheme;
        }
        const styleString = style(css$3, palette$1);
        const tokens = {};
        styleString.trim().replace(/\n/g, "").split(";").forEach(style => {
            style = style.trim();
            let [token, hex] = style.split(":");
            if (token && hex) {
                hex = hex.trim();
                tokens[token] = hex;
            }
        });
        return { theme, styleString, tokens };
    }, [theme]);
    useEffect(() => {
        if (isRoot) {
            const styleTag = window.document.createElement('style');
            styleTag.innerHTML = `
                :root, ::before, ::after {
                    ${themeState.styleString};
                }
            `;
            // @ts-ignore
            ThemeProvider.activeStyles = themeState.styleString;
            document.head.appendChild(styleTag);
            return () => {
                document.head.removeChild(styleTag);
            };
        }
        else {
            if (container) {
                const styleTag = window.document.createElement('style');
                const className = `theme-provider-${crypto.randomUUID()}`;
                styleTag.innerHTML = `
                    .${className}, .${className}::before, .${className}::after {
                        ${themeState.styleString}
                    }
                `;
                styleTag.setAttribute("data-component", "ThemeProviderStyle");
                container.appendChild(styleTag);
                container.classList.add(className);
                return () => {
                    container.removeChild(styleTag);
                    container.classList.remove(className);
                };
            }
            else if (wrapperRef.current) {
                wrapperRef.current.setAttribute("style", themeState.styleString);
            }
        }
    }, [themeState, isRoot]);
    return jsx$3(ThemeContext.Provider, { value: themeState, children: container ? children : jsx$3("div", { ref: wrapperRef, className: className, children: children }) });
});

var styles$1g = {"popover-trigger":"Popover-module_popover-trigger__2-AU_","trigger-wrapper":"Popover-module_trigger-wrapper__GPHDv","info-button":"Popover-module_info-button__2uFaP","info-button-active":"Popover-module_info-button-active__1yIpD","popover":"Popover-module_popover__3y3W8","top-left":"Popover-module_top-left__SiiSe","top-right":"Popover-module_top-right__mzWyP","top-center":"Popover-module_top-center__ovRpD","center-left":"Popover-module_center-left__38hJ-","center-right":"Popover-module_center-right__3XN0X","bottom-left":"Popover-module_bottom-left__3TvZO","bottom-center":"Popover-module_bottom-center__1fM_G","bottom-right":"Popover-module_bottom-right__2DHrU"};

let rootComponent = document.body;
let styleRoot = document.head;
const getRootComponent = () => rootComponent;
const setRootComponent = (component) => rootComponent = component;
const getStyleRoot = () => styleRoot;
const setStyleRoot = (component) => styleRoot = component;

var _excluded$g = ["Component", "children"],
  _excluded2$6 = ["triggerOnClick", "Trigger", "TriggerButton", "renderPosition", "triggerStyle", "triggerClassName", "popoverClassName", "popoverStyle", "children", "arrowClassName", "arrowStyle", "contentClassName", "contentStyle", "Popover", "disabled", "tooltip"];
var closeActive = null;
var setActivePosition = null;
var activeButtonRef = null;
var activeRenderPosition = null;
var activePopoverRef = null;
var calculatePosition = function calculatePosition(ref) {
  var rect = ref.current.getBoundingClientRect();
  var left = rect.left;
  if (activeRenderPosition === "center") {
    left = left + rect.width / 2;
  } else if (activeRenderPosition === "right") {
    left = left + rect.width;
  }
  var top = rect.top + rect.height;
  return {
    left: left,
    top: top
  };
};
var closeActivePopover$1 = function closeActivePopover() {
  if (closeActive) {
    closeActive(false);
    closeActive = null;
    activeButtonRef = null;
    activePopoverRef = null;
    setActivePosition = null;
    activeRenderPosition = null;
  }
};
var updatePosition = function updatePosition() {
  if (!activeButtonRef || !activeButtonRef.current) return;
  setActivePosition(calculatePosition(activeButtonRef));
};
window.addEventListener("resize", updatePosition);
window.addEventListener("scroll", updatePosition, true);
var observer = new MutationObserver(updatePosition);
observer.observe(document, {
  attributes: true,
  childList: true,
  characterData: true,
  subtree: true
});
var Context = /*#__PURE__*/React__default.createContext();
var PopoverContext = function PopoverContext(_ref) {
  var _ref$Component = _ref.Component,
    Component = _ref$Component === void 0 ? "div" : _ref$Component,
    children = _ref.children,
    props = _objectWithoutProperties$2(_ref, _excluded$g);
  var ref = useRef(null);
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: ref
  }, /*#__PURE__*/React__default.createElement(Component, _extends$j({
    ref: ref
  }, props), children));
};
var RenderPopover = function RenderPopover(_ref2) {
  var children = _ref2.children;
  var popoverContextRef = useContext(Context);
  return /*#__PURE__*/ReactDOM.createPortal(children, (popoverContextRef === null || popoverContextRef === void 0 ? void 0 : popoverContextRef.current) || getRootComponent());
};
var PopoverMechanism = (function (_ref3) {
  var triggerOnClick = _ref3.triggerOnClick,
    Trigger = _ref3.Trigger,
    TriggerButton = _ref3.TriggerButton,
    _ref3$renderPosition = _ref3.renderPosition,
    renderPosition = _ref3$renderPosition === void 0 ? "center" : _ref3$renderPosition,
    triggerStyle = _ref3.triggerStyle,
    triggerClassName = _ref3.triggerClassName,
    popoverClassName = _ref3.popoverClassName,
    popoverStyle = _ref3.popoverStyle,
    children = _ref3.children,
    arrowClassName = _ref3.arrowClassName,
    arrowStyle = _ref3.arrowStyle,
    contentClassName = _ref3.contentClassName,
    contentStyle = _ref3.contentStyle,
    Popover = _ref3.Popover,
    disabled = _ref3.disabled,
    tooltip = _ref3.tooltip,
    rest = _objectWithoutProperties$2(_ref3, _excluded2$6);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isEntering = _useState4[0],
    setIsEntering = _useState4[1];
  var _useState5 = useState({
      top: 0,
      left: 0
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    position = _useState6[0],
    setPosition = _useState6[1];
  var buttonRef = useRef(null);
  var popoverRef = useRef(null);
  var registerAsActive = function registerAsActive() {
    activeRenderPosition = renderPosition;
    setPosition(calculatePosition(buttonRef));
    setActive(true);
    setIsEntering(true);
    setTimeout(function () {
      if (activePopoverRef === popoverRef) {
        setIsEntering(false);
      }
    }, 0);
    closeActive && closeActive(false);
    closeActive = setActive;
    setActivePosition = setPosition;
    activeButtonRef = buttonRef;
    activePopoverRef = popoverRef;
  };
  var triggerProps = {
    style: triggerStyle,
    className: classNames(styles$1g['popover-trigger'], triggerClassName),
    disabled: disabled
  };
  var close = function close() {
    setActive(false);
    closeActive = null;
    activeButtonRef = null;
    activePopoverRef = null;
    setActivePosition = null;
    activeRenderPosition = null;
  };
  if (disabled && isActive) {
    setTimeout(function () {
      close();
    });
  }
  if (triggerOnClick) {
    triggerProps.onClick = function (event) {
      if (isActive) {
        close();
      } else {
        registerAsActive();
      }
      event.preventDefault();
      event.stopPropagation();
    };
  } else {
    triggerProps.onMouseEnter = function () {
      registerAsActive();
    };
    triggerProps.onMouseLeave = function () {
      close();
    };
  }
  var style = _objectSpread2(_objectSpread2(_objectSpread2({}, popoverStyle), position), {}, {
    opacity: isEntering ? 0 : 1
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !TriggerButton && /*#__PURE__*/React__default.createElement("button", _extends$j({
    type: "button",
    ref: buttonRef
  }, triggerProps), /*#__PURE__*/React__default.createElement(Trigger, {
    isActive: isActive
  })), TriggerButton && /*#__PURE__*/React__default.createElement(TriggerButton, _extends$j({
    buttonRef: buttonRef
  }, triggerProps, {
    tooltip: tooltip,
    isActive: isActive
  })), isActive && /*#__PURE__*/React__default.createElement(RenderPopover, null, /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: classNames(styles$1g['popover'], popoverClassName),
    ref: popoverRef
  }, /*#__PURE__*/React__default.createElement(ClickAway, {
    ignoreParentClick: true,
    listener: close
  }), /*#__PURE__*/React__default.createElement(Popover, _extends$j({
    position: position,
    arrowClassName: arrowClassName,
    arrowStyle: arrowStyle,
    contentClassName: contentClassName,
    contentStyle: contentStyle,
    close: close
  }, rest), children))));
});

var ClickAway = ({ listener, ignoreParentClick, capture, ignoreTargetDataAction, closeOnModalClick }) => {
    const ref = useRef(null);
    const _listener = React__default.useCallback((e) => {
        let target = e.target;
        if (target.shadowRoot) {
            target = e.composedPath()[0];
        }
        if (ignoreParentClick) {
            if ((ref.current && ref.current.parentNode && ref.current.parentNode.contains(target))) {
                return;
            }
            else if (activePopoverRef && activePopoverRef.current && activePopoverRef.current.contains(target)) {
                return;
            }
        }
        if (ignoreTargetDataAction && target.getAttribute("data-action") === ignoreTargetDataAction) {
            return;
        }
        if (target.closest("[data-modal]") && !closeOnModalClick) {
            return;
        }
        listener(e);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listener, ignoreParentClick]);
    useEffect(() => {
        let added = false;
        setTimeout(() => {
            document.body.addEventListener('click', _listener, capture);
            added = true;
        });
        return () => {
            if (added) {
                document.body.removeEventListener('click', _listener, capture);
            }
            else {
                setTimeout(() => {
                    document.body.removeEventListener('click', _listener, capture);
                });
            }
        };
    }, [_listener]);
    return jsx$3("div", { ref: ref, style: { display: "none" } });
};

var useTimeout = (function (callback, delay) {
  var savedCallback = useRef(null);
  var pollCount = useRef(0);

  // Remember the latest callback.
  useEffect(function () {
    savedCallback.current = callback;
    pollCount.current = 0;
  }, [callback]);

  // Set up the interval.
  useEffect(function () {
    var tick = function tick() {
      pollCount.current = pollCount.current + 1;
      savedCallback.current(pollCount.current);
    };
    if (delay !== null) {
      var id = setTimeout(tick, delay);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [delay]);
});

var usePoller = (function (pollFunc, interval, shouldPoll) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pollingStarted = _useState2[0],
    triggerPolling = _useState2[1];
  useTimeout(pollFunc, shouldPoll && pollingStarted ? interval : null);
  useEffect(function () {
    pollFunc(0);
    triggerPolling(true);
  }, [pollFunc, triggerPolling]);
});

var useModal = (function () {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var closeModal = function closeModal() {
    setIsModalOpen(false);
  };
  var openModal = function openModal() {
    setIsModalOpen(true);
  };
  return {
    isModalOpen: isModalOpen,
    closeModal: closeModal,
    openModal: openModal
  };
});

var count = 0;
var originalScroll = 0;
var disableScroll = function disableScroll() {
  document.documentElement.scrollTop = originalScroll;
  return false;
};
var DisableScroll = (function () {
  useLayoutEffect(function () {
    if (count === 0) {
      originalScroll = document.documentElement.scrollTop;
      document.addEventListener('scroll', disableScroll);
    }
    count = count + 1;
    return function () {
      count = count - 1;
      if (count === 0) {
        document.removeEventListener('scroll', disableScroll);
      }
    };
  }, []);
  return "";
});

var DontExit = function DontExit(_ref) {
  var message = _ref.message;
  useEffect(function () {
    var _confirmExit = function confirmExit(e) {
      e.returnValue = _confirmExit;
      return _confirmExit;
    };
    window.addEventListener("beforeunload", _confirmExit);
    return function () {
      window.removeEventListener("beforeunload", _confirmExit);
    };
  }, [message]);
  return "";
};
var DontExit$1 = DontExit;

var styles$1f = {"modal-container":"Modal-module_modal-container__1ddiE","mask":"Modal-module_mask__2LcBK","modal":"Modal-module_modal__FqeFw","header":"Modal-module_header__at9sT","content":"Modal-module_content__I6vZk","flex":"Modal-module_flex__3bhVz","footer":"Modal-module_footer__2vOst","footer-content":"Modal-module_footer-content__fTVUm","bgshimmer":"Modal-module_bgshimmer__30_j7"};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var typography = {"b":"typography-module_b__Ixcry","i":"typography-module_i__2oVPd","h040":"typography-module_h040__25uXK","u":"typography-module_u__Vb7ed","h032":"typography-module_h032__2ux0r","h024":"typography-module_h024__29y51","h020":"typography-module_h020__1OeT_","h016":"typography-module_h016__3gtmq","h01":"typography-module_h01__3GyZw","h02":"typography-module_h02__3Li0i","h03":"typography-module_h03__2mIlU typography-module_b__Ixcry","h04":"typography-module_h04__3m39X typography-module_b__Ixcry","c":"typography-module_c__28kuT","body14":"typography-module_body14__1OH3C","body13":"typography-module_body13__2eYbD","body12":"typography-module_body12__3zobO","text-title":"typography-module_text-title__2HQWD","text-disabled":"typography-module_text-disabled__3oB1s","text-secondary":"typography-module_text-secondary__3sHvv","error":"typography-module_error__1mWGG","success":"typography-module_success__1i0sg","information":"typography-module_information__hLP2y","info":"typography-module_info__2nIwn","warning":"typography-module_warning__2oNC6","ellipsis":"typography-module_ellipsis__1gpn1","no-wrap":"typography-module_no-wrap__1CfmJ","notice":"typography-module_notice__2_b1n","on-color":"typography-module_on-color__1ErsT","bgshimmer":"typography-module_bgshimmer__2x2c3"};

const Heading = (_a) => {
    var { children, level = "24", color, bold, italic, underline, center, ellipsis, nowrap, className, thin } = _a, rest = __rest(_a, ["children", "level", "color", "bold", "italic", "underline", "center", "ellipsis", "nowrap", "className", "thin"]);
    const _className = classNames(typography[`h0${level}`], {
        [typography.b]: bold,
        [typography.u]: underline,
        [typography.thin]: thin,
        [typography.i]: italic,
        [typography.c]: center,
        [typography.ellipsis]: ellipsis,
        [typography[color]]: color
    }, className);
    return jsx$3("div", Object.assign({ role: "heading", className: _className }, rest, { children: children }));
};
const Text = (_a) => {
    var { children, level = "14", color, bold, italic, center, ellipsis, nowrap, className } = _a, rest = __rest(_a, ["children", "level", "color", "bold", "italic", "center", "ellipsis", "nowrap", "className"]);
    const _className = classNames(typography[`body${level}`], {
        [typography.b]: bold,
        [typography.i]: italic,
        [typography.c]: center,
        [typography.ellipsis]: ellipsis,
        [typography[color]]: color,
        [typography['no-wrap']]: nowrap
    }, className);
    return jsx$3("p", Object.assign({ className: _className }, rest, { children: children }));
};
const Span = (_a) => {
    var { children, level = "14", color, bold, italic, ellipsis, nowrap, className } = _a, rest = __rest(_a, ["children", "level", "color", "bold", "italic", "ellipsis", "nowrap", "className"]);
    const _className = classNames(typography[`body${level}`], {
        [typography.b]: bold,
        [typography.i]: italic,
        [typography.ellipsis]: ellipsis,
        [typography[color]]: color,
        [typography['no-wrap']]: nowrap
    }, className);
    return jsx$3("span", Object.assign({ className: _className }, rest, { children: children }));
};
const Notice = ({ children, noticeLabel = "Notice", level = "14", className, style, bold, color = "warning" }) => {
    return jsxs("div", { className: className, style: style, children: [jsxs(Span, { bold: bold, color: color, level: level, className: typography.notice, children: [noticeLabel, ":"] }), jsx$3(Span, { bold: bold, level: level, children: children })] });
};

var styles$1e = {"base":"FieldError-module_base__A8M0d","popover-trigger":"FieldError-module_popover-trigger__9ClH2"};

function _extends$i(){return _extends$i=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r]);}return n;},_extends$i.apply(null,arguments);}const colors$1={error:"var(--error)",warning:"var(--warning)",information:"var(--info)",info:"var(--info)",success:"var(--success)",text:"var(--icon-secondary)","icon-secondary":"var(--icon-secondary)","icon-tertiary":"var(--icon-tertiary)",disabled:"var(--icon-primary-disabled)","on-color":"var(--icon-on-color)"};const resolveParams=(color,size,style)=>{const colorResolved=colors$1[color];let result={...style};if(colorResolved){result["--icon-primary"]=colorResolved;}if(size){result.height=size;result.width=size;}return result;};const ActionsMenuCircleIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12ZM24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M17 13.5C16.6022 13.5 16.2206 13.342 15.9393 13.0607C15.658 12.7794 15.5 12.3978 15.5 12C15.5 11.6022 15.658 11.2206 15.9393 10.9393C16.2206 10.658 16.6022 10.5 17 10.5C17.3978 10.5 17.7794 10.658 18.0607 10.9393C18.342 11.2206 18.5 11.6022 18.5 12C18.5 12.3978 18.342 12.7794 18.0607 13.0607C17.7794 13.342 17.3978 13.5 17 13.5ZM12 13.5C11.6022 13.5 11.2206 13.342 10.9393 13.0607C10.658 12.7794 10.5 12.3978 10.5 12C10.5 11.6022 10.658 11.2206 10.9393 10.9393C11.2206 10.658 11.6022 10.5 12 10.5C12.3978 10.5 12.7794 10.658 13.0607 10.9393C13.342 11.2206 13.5 11.6022 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5ZM7 13.5C6.60218 13.5 6.22064 13.342 5.93933 13.0607C5.65803 12.7794 5.5 12.3978 5.5 12C5.5 11.6022 5.65803 11.2206 5.93933 10.9393C6.22064 10.658 6.60218 10.5 7 10.5C7.39782 10.5 7.77936 10.658 8.06067 10.9393C8.34197 11.2206 8.5 11.6022 8.5 12C8.5 12.3978 8.34197 12.7794 8.06067 13.0607C7.77936 13.342 7.39782 13.5 7 13.5Z",fill:"var(--icon-primary)"}));ActionsMenuCircleIcon.displayName="ActionsMenuCircleIcon";const AddIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Add"),/*#__PURE__*/React__default.createElement("path",{d:"M12.7982 12.7984L17.9099 12.8189C18.02 12.8185 18.1289 12.7963 18.2304 12.7536C18.3318 12.7109 18.4238 12.6485 18.501 12.57C18.6405 12.4211 18.7155 12.2231 18.7096 12.0192C18.7023 11.8098 18.6158 11.611 18.4676 11.4629C18.3195 11.3147 18.1207 11.2282 17.9113 11.2209L12.7982 11.2018L12.8187 6.0901C12.8183 5.98002 12.7961 5.8711 12.7534 5.76964C12.7107 5.66819 12.6483 5.57619 12.5698 5.49896C12.4209 5.35945 12.2229 5.28447 12.019 5.29036C11.8115 5.30419 11.6158 5.392 11.4675 5.53785C11.3881 5.60904 11.3262 5.69754 11.2866 5.7965C11.247 5.89546 11.2307 6.00222 11.2391 6.10848L11.2016 11.2018L6.08991 11.1813C5.98016 11.1817 5.87157 11.2038 5.77038 11.2462C5.66918 11.2887 5.57736 11.3507 5.50018 11.4288C5.36068 11.5776 5.28569 11.7756 5.29158 11.9796C5.30541 12.1871 5.39322 12.3828 5.53907 12.5311C5.61194 12.6083 5.70072 12.6687 5.79925 12.7081C5.89779 12.7476 6.00372 12.7651 6.1097 12.7595L11.2016 12.7984L11.1811 17.9101C11.1782 18.0158 11.1969 18.1209 11.2362 18.2191C11.2755 18.3172 11.3345 18.4063 11.4095 18.4807L11.4286 18.4998C11.5774 18.6393 11.7755 18.7143 11.9794 18.7084C12.1867 18.699 12.3837 18.615 12.5339 18.4718C12.6842 18.3286 12.7775 18.1358 12.7968 17.9292L12.7982 12.7984Z",fill:"var(--icon-primary)",stroke:"var(--icon-primary)",strokeWidth:0.2}));AddIcon.displayName="AddIcon";const AddRemoveColumnIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Add and remove columns"),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M20 3.7H4C3.83432 3.7 3.7 3.83431 3.7 4V20C3.7 20.1657 3.83431 20.3 4 20.3H20C20.1657 20.3 20.3 20.1657 20.3 20V4C20.3 3.83432 20.1657 3.7 20 3.7ZM4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7.99995 20.3L7.99995 3.7H9.69995L9.69995 20.3H7.99995Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M14 20.3L14 3.7H15.7L15.7 20.3H14Z",fill:"var(--icon-primary)"}));AddRemoveColumnIcon.displayName="AddRemoveColumnIcon";const ArrowLeftIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M10.3791 6.16605C10.1775 6.01449 9.92873 5.93924 9.67694 5.95365C9.42515 5.96805 9.18655 6.07112 9.00356 6.24468L4.20782 11.3405C4.03915 11.5156 3.94568 11.7505 3.95004 11.9939L3.95007 11.995C3.95946 12.2338 4.04931 12.4624 4.20507 12.6436L9.00054 17.7393L9.0029 17.7416C9.18674 17.9133 9.4247 18.0155 9.6758 18.0306C9.9269 18.0457 10.1758 17.9734 10.379 17.825L10.3849 17.8189C10.5656 17.633 10.6658 17.3833 10.6639 17.1241C10.6619 16.8651 10.5581 16.6173 10.3749 16.4342L7.08385 12.942H18.849C19.101 12.942 19.3426 12.8419 19.5208 12.6638C19.6989 12.4856 19.799 12.244 19.799 11.992C19.799 11.7401 19.6989 11.4984 19.5208 11.3203C19.3426 11.1421 19.101 11.042 18.849 11.042H7.0839L10.3754 7.55132L10.3762 7.5504C10.5456 7.36161 10.6402 7.11742 10.6421 6.86379C10.6441 6.61015 10.5532 6.36454 10.3867 6.17319L10.3876 6.17245L10.3791 6.16605Z",fill:"var(--icon-primary)"}));ArrowLeftIcon.displayName="ArrowLeftIcon";const BreadcrumbsArrowIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("path",{d:"M13.9905 11.9429C13.9791 11.8551 13.9415 11.7728 13.8827 11.7069L10.7027 8.15186C10.6696 8.10771 10.6274 8.07131 10.5788 8.0452C10.5303 8.01909 10.4766 8.00389 10.4216 8.00065C10.3666 7.99742 10.3116 8.00622 10.2603 8.02646C10.2091 8.04671 10.1628 8.07789 10.1248 8.11786C10.0447 8.20131 10 8.31259 10 8.42836C10 8.54413 10.0447 8.6554 10.1248 8.73886L13.0443 12.0009L10.1278 15.2629C10.048 15.3463 10.0035 15.4573 10.0035 15.5729C10.0035 15.6884 10.048 15.7995 10.1278 15.8829C10.1663 15.923 10.2129 15.9542 10.2647 15.9744C10.3164 15.9946 10.3718 16.0033 10.4272 15.9999C10.4822 15.9962 10.5357 15.9808 10.5842 15.9548C10.6328 15.9287 10.6752 15.8926 10.7087 15.8489L13.8887 12.2939C13.9305 12.2464 13.9617 12.1905 13.9803 12.13C13.9989 12.0695 14.0044 12.0057 13.9965 11.9429H13.9905Z",fill:"var(--icon-primary)"}));BreadcrumbsArrowIcon.displayName="BreadcrumbsArrowIcon";const CardArrowCollapseIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Collapse"),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M20.816 15.8491L20.9689 16.0469C20.7962 16.1803 20.5842 16.2527 20.366 16.2527C20.1479 16.2527 19.9358 16.1803 19.7632 16.0469L19.7564 16.0416L11.9829 9.5957L4.1825 16.0515L4.16944 16.0599C3.99757 16.1694 3.79603 16.2232 3.5924 16.2139C3.38937 16.2046 3.19415 16.1329 3.0333 16.0088C2.95211 15.9473 2.88498 15.8693 2.83642 15.7798C2.78758 15.6898 2.75868 15.5903 2.75167 15.4881C2.74467 15.386 2.75972 15.2835 2.79582 15.1876C2.83191 15.0918 2.8882 15.0048 2.96087 14.9327L2.96883 14.9248L11.3563 7.97061C11.5287 7.82606 11.7478 7.74748 11.9728 7.75006C12.1931 7.7507 12.4067 7.82616 12.5785 7.96411L12.5816 7.96657L20.9548 14.9078C21.0408 14.9715 21.1119 15.0533 21.163 15.1476C21.2155 15.2445 21.2456 15.3521 21.2508 15.4623L21.2513 15.4742C21.2512 15.5841 21.2259 15.6926 21.1778 15.7914C21.1298 15.8902 21.0599 15.9768 20.9734 16.0447L20.819 15.8481L20.816 15.8491Z",fill:"var(--icon-primary)"}));CardArrowCollapseIcon.displayName="CardArrowCollapseIcon";const CloseIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Close"),/*#__PURE__*/React__default.createElement("path",{d:"M13.129 12L16.758 8.40003C16.8356 8.32189 16.8969 8.22917 16.9384 8.12722C16.9799 8.02527 17.0009 7.91611 17 7.80603C16.9934 7.6021 16.9064 7.40907 16.758 7.26902C16.6047 7.12619 16.403 7.04677 16.1935 7.04677C15.984 7.04677 15.7823 7.12619 15.629 7.26902L12 10.871L8.40001 7.24203C8.32187 7.16448 8.22916 7.10317 8.12721 7.06164C8.02526 7.0201 7.91609 6.99916 7.80601 7.00003C7.60209 7.00666 7.40906 7.09365 7.26901 7.24203C7.13204 7.39856 7.05575 7.59903 7.05401 7.80702C7.04825 7.91346 7.06709 8.0198 7.10905 8.11778C7.15102 8.21576 7.21499 8.30276 7.29601 8.37203L10.871 12L7.24201 15.6C7.16471 15.6779 7.10354 15.7703 7.06201 15.8719C7.02048 15.9735 6.99941 16.0823 7.00001 16.192C7.00665 16.3959 7.09364 16.589 7.24201 16.729C7.39855 16.866 7.59902 16.9423 7.80701 16.944C7.9131 16.9471 8.01858 16.927 8.11614 16.8852C8.2137 16.8434 8.30101 16.7809 8.37201 16.702L12 13.129L15.6 16.758C15.6727 16.8348 15.7603 16.8959 15.8575 16.9375C15.9546 16.9791 16.0593 17.0004 16.165 17H16.192C16.3959 16.9934 16.589 16.9064 16.729 16.758C16.869 16.6048 16.9488 16.4061 16.9538 16.1986C16.9588 15.9911 16.8885 15.7888 16.756 15.629L13.129 12Z",fill:"var(--icon-primary)",stroke:"var(--icon-primary)",strokeWidth:0.2}));CloseIcon.displayName="CloseIcon";const CopyIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Copy"),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M3.5 8.5V20.5H15.5V8.5H3.5ZM3 7C2.44772 7 2 7.44772 2 8V21C2 21.5523 2.44772 22 3 22H16C16.5523 22 17 21.5523 17 21V8C17 7.44772 16.5523 7 16 7H3Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M8.5 7V3.5H20.5V15.5H17V17H21C21.5523 17 22 16.5523 22 16V3C22 2.44772 21.5523 2 21 2H8C7.44772 2 7 2.44772 7 3V7H8.5Z",fill:"var(--icon-primary)"}));CopyIcon.displayName="CopyIcon";const DownloadIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Download"),/*#__PURE__*/React__default.createElement("path",{d:"M12.6121 17.624C12.4394 17.7725 12.2216 17.8581 11.9941 17.867C11.764 17.8712 11.5417 17.7828 11.3761 17.623L6.2821 12.829C6.11668 12.6546 6.01838 12.4273 6.00465 12.1873C5.99093 11.9473 6.06265 11.7102 6.2071 11.518C6.38925 11.3596 6.62305 11.2731 6.86449 11.2749C7.10594 11.2768 7.33839 11.3668 7.5181 11.528L11.0931 14.899V3.01804C11.0931 2.77935 11.1879 2.55043 11.3567 2.38165C11.5255 2.21286 11.7544 2.11804 11.9931 2.11804C12.2318 2.11804 12.4607 2.21286 12.6295 2.38165C12.7983 2.55043 12.8931 2.77935 12.8931 3.01804V14.899L16.4701 11.528C16.644 11.3538 16.8794 11.2551 17.1255 11.2532C17.3717 11.2513 17.6086 11.3465 17.7851 11.518C17.9266 11.7118 17.9962 11.9488 17.9818 12.1883C17.9674 12.4277 17.8699 12.6547 17.7061 12.83L12.6121 17.624Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M2.5 20.5C1.94772 20.5 1.5 20.9477 1.5 21.5C1.5 22.0523 1.94772 22.5 2.5 22.5H21.5C22.0523 22.5 22.5 22.0523 22.5 21.5C22.5 20.9477 22.0523 20.5 21.5 20.5H2.5Z",fill:"var(--icon-primary)"}));DownloadIcon.displayName="DownloadIcon";const DropdownArrowDownIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("path",{d:"M12.0001 15L6.80396 10.5L17.1963 10.5L12.0001 15Z",fill:"var(--icon-primary)"}));DropdownArrowDownIcon.displayName="DropdownArrowDownIcon";const DropdownArrowUpIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("path",{d:"M11.9999 9L17.196 13.5L6.80374 13.5L11.9999 9Z",fill:"var(--icon-primary)"}));DropdownArrowUpIcon.displayName="DropdownArrowUpIcon";const ErrorIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("g",{clipPath:"url(#clip0_162_109)"},/*#__PURE__*/React__default.createElement("path",{d:"M11.9999 13.3491L15.3719 16.7201C15.4604 16.8086 15.5655 16.8778 15.6811 16.9257C15.7968 16.9736 15.9207 16.9982 16.0459 16.9982C16.1711 16.9982 16.295 16.9736 16.4107 16.9257C16.5263 16.8778 16.6314 16.8076 16.7199 16.7191C16.8084 16.6305 16.8786 16.5255 16.9265 16.4098C16.9744 16.2942 16.9991 16.1702 16.9991 16.0451C16.9991 15.9199 16.9744 15.7959 16.9265 15.6803C16.8786 15.5646 16.8084 15.4596 16.7199 15.3711L13.3489 11.9991L16.7199 8.62706C16.8084 8.53855 16.8786 8.43347 16.9265 8.31782C16.9744 8.20218 16.9991 8.07823 16.9991 7.95306C16.9991 7.82788 16.9744 7.70394 16.9265 7.58829C16.8786 7.47265 16.8084 7.36757 16.7199 7.27906C16.6314 7.19055 16.5263 7.12034 16.4107 7.07243C16.295 7.02453 16.1711 6.99988 16.0459 6.99988C15.7931 6.99988 15.5507 7.1003 15.3719 7.27906L11.9999 10.6501L8.62791 7.27906C8.5394 7.19055 8.43432 7.12034 8.31868 7.07243C8.20303 7.02453 8.07909 6.99988 7.95391 6.99988C7.82874 6.99988 7.70479 7.02453 7.58915 7.07243C7.4735 7.12034 7.36842 7.19055 7.27991 7.27906C7.1914 7.36757 7.12119 7.47265 7.07329 7.58829C7.02539 7.70394 7.00073 7.82788 7.00073 7.95306C7.00073 8.07823 7.02539 8.20218 7.07329 8.31782C7.12119 8.43347 7.1914 8.53855 7.27991 8.62706L10.6509 11.9991L7.27991 15.3721C7.1914 15.4606 7.12119 15.5656 7.07329 15.6813C7.02539 15.7969 7.00073 15.9209 7.00073 16.0461C7.00073 16.1712 7.02539 16.2952 7.07329 16.4108C7.12119 16.5265 7.1914 16.6315 7.27991 16.7201C7.36842 16.8086 7.4735 16.8788 7.58915 16.9267C7.70479 16.9746 7.82874 16.9992 7.95391 16.9992C8.07909 16.9992 8.20303 16.9746 8.31868 16.9267C8.43432 16.8788 8.5394 16.8086 8.62791 16.7201L11.9999 13.3491Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",fill:"var(--icon-primary)"})),/*#__PURE__*/React__default.createElement("defs",null,/*#__PURE__*/React__default.createElement("clipPath",{id:"clip0_162_109"},/*#__PURE__*/React__default.createElement("rect",{width:24,height:24,fill:"white"}))));ErrorIcon.displayName="ErrorIcon";const ExternalLinkIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"External link"),/*#__PURE__*/React__default.createElement("path",{d:"M14.79 4.96999H17.15L10.16 11.96C9.98 12.14 9.88 12.39 9.88 12.64C9.88 12.89 9.98 13.14 10.16 13.32C10.34 13.5 10.58 13.6 10.84 13.6C11.1 13.6 11.34 13.5 11.52 13.32L18.52 6.32999V8.68999C18.52 9.21999 18.95 9.65999 19.48 9.65999C20.01 9.65999 20.45 9.22999 20.45 8.68999V4.00999C20.45 4.00999 20.45 3.91999 20.45 3.87999C20.45 3.81999 20.43 3.75999 20.41 3.70999C20.36 3.56999 20.28 3.42999 20.17 3.31999C20.07 3.21999 19.96 3.14999 19.83 3.09999C19.72 3.05999 19.6 3.03999 19.48 3.03999H14.79C14.26 3.03999 13.83 3.46999 13.83 4.00999C13.83 4.54999 14.26 4.97999 14.79 4.97999V4.96999Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M19.52 12.9C18.99 12.9 18.56 13.33 18.56 13.87V18.56H4.93V4.92999H9.63C10.16 4.92999 10.59 4.49999 10.59 3.95999C10.59 3.41999 10.16 2.98999 9.63 2.98999H3.97C3.43 2.99999 3 3.42999 3 3.96999V19.53C3 20.06 3.43 20.49 3.97 20.49H19.53C20.06 20.49 20.5 20.06 20.5 19.53V13.87C20.5 13.34 20.07 12.9 19.53 12.9H19.52Z",fill:"var(--icon-primary)"}));ExternalLinkIcon.displayName="ExternalLinkIcon";const FileIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"File"),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M18.7335 20.3636C18.7321 20.4634 18.6917 20.5587 18.6207 20.6292C18.5497 20.6997 18.4539 20.7399 18.3535 20.7413H5.64651C5.54614 20.7399 5.45026 20.6997 5.37928 20.6292C5.30831 20.5587 5.26786 20.4634 5.26654 20.3636V10.0973H10.2881C10.7593 10.0867 11.207 9.89113 11.5334 9.55333C11.8598 9.21553 12.0383 8.76301 12.0299 8.29475V3.25976H18.3535C18.4539 3.26106 18.5497 3.30126 18.6207 3.3718C18.6917 3.44234 18.7321 3.53763 18.7335 3.63738V20.3636ZM8.86353 5.43286C9.70857 4.62659 10.3418 4.01937 10.7633 3.6112V8.29475C10.7704 8.42891 10.7249 8.56057 10.6362 8.662C10.5476 8.76343 10.4228 8.82671 10.2881 8.83853H5.33544C5.92515 8.23634 7.65271 6.58487 8.86353 5.43286ZM18.3535 2H10.8556C10.764 2.00041 10.6736 2.0203 10.5904 2.05834C10.5072 2.09638 10.4331 2.15169 10.3733 2.22053C10.2355 2.37762 9.03983 3.51855 7.98404 4.52455C5.41853 6.97558 4.31005 8.04199 4.11956 8.3028C4.04166 8.41009 3.99982 8.53907 4 8.67137V20.3636C4.00027 20.7975 4.17383 21.2136 4.48255 21.5204C4.79127 21.8272 5.20991 21.9997 5.64651 22H18.3535C18.79 21.9995 19.2085 21.8269 19.5172 21.5201C19.8258 21.2134 19.9995 20.7975 20 20.3636V3.63637C19.9995 3.20254 19.8258 2.78664 19.5172 2.47987C19.2085 2.17311 18.79 2.00053 18.3535 2Z",fill:"var(--icon-primary)",stroke:"var(--icon-primary)",strokeWidth:0.3}));FileIcon.displayName="FileIcon";const HideIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Hidden"),/*#__PURE__*/React__default.createElement("path",{d:"M17.4679 6.23425C15.7815 5.38028 13.9034 4.95295 11.9999 5.00001C9.65034 4.94192 7.33955 5.60664 5.37996 6.90433C3.42038 8.20202 1.90648 10.0701 1.04293 12.256C0.985689 12.4133 0.985689 12.5857 1.04293 12.743C1.71332 14.4407 2.77601 15.9468 4.13514 17.1429L5.33757 16.1591C4.16548 15.17 3.23332 13.919 2.62093 12.5C3.40726 10.6783 4.72058 9.13354 6.39197 8.06431C8.06336 6.99507 10.0164 6.45028 11.9999 6.50001C13.4361 6.46391 14.8562 6.7395 16.1651 7.30018L17.4679 6.23425Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M14.412 8.73452C13.6833 8.32383 12.8492 8.11826 11.9999 8.15101C10.7973 8.10437 9.83659 8.5356 8.95088 9.35048C8.06517 10.1654 7.76498 11.2977 7.71145 12.5C7.75469 13.017 7.83878 13.5187 7.99249 13.9869L9.35664 12.8707C9.31027 12.5097 9.33183 12.1415 9.42212 11.7853C9.56095 11.2376 9.85626 10.7422 10.272 10.3596C10.6877 9.97703 11.2058 9.72377 11.7631 9.63077C12.2378 9.55156 12.7233 9.59155 13.1766 9.74533L14.412 8.73452Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M14.1121 10.2719L15.2495 9.34136C15.253 9.34452 15.2564 9.34768 15.2598 9.35084C15.6304 9.69184 15.9382 10.0884 16.1748 10.5224L14.9751 11.504C14.8992 11.2957 14.7994 11.0958 14.6769 10.9084C14.52 10.6685 14.3294 10.4543 14.1121 10.2719Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M9.68757 13.892L8.43106 14.9201C8.58761 15.1625 8.77528 15.3889 8.99993 15.5955C9.15861 15.7415 9.31923 15.8757 9.48296 15.9975L10.7243 14.9819C10.6311 14.9249 10.5408 14.8624 10.4541 14.7948C10.138 14.5486 9.87764 14.2408 9.68757 13.892Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M11.8191 15.3782L10.4064 16.5341C10.8913 16.7397 11.4145 16.8477 11.9994 16.8477C13.1889 16.8477 14.335 16.4008 15.2104 15.5955C16.0859 14.7902 16.6268 13.6854 16.7259 12.5C16.7107 12.1569 16.6568 11.8195 16.567 11.4935L15.1394 12.6616C15.0668 13.4023 14.7242 14.0927 14.1738 14.5992C13.5834 15.1426 12.8018 15.4302 11.9999 15.399C11.9393 15.394 11.879 15.387 11.8191 15.3782Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M19.2055 9.33481C20.1241 10.2342 20.8644 11.3078 21.3789 12.5C20.5926 14.3217 19.2793 15.8665 17.6079 16.9357C15.9365 18.005 13.9835 18.5497 11.9999 18.5C10.8459 18.529 9.70221 18.3568 8.61828 17.9971L7.26432 19.1049C8.75431 19.732 10.3678 20.0404 11.9999 20C14.3495 20.0581 16.6603 19.3934 18.6199 18.0957C20.5795 16.798 22.0934 14.9299 22.9569 12.744C23.0142 12.5864 23.0142 12.4136 22.9569 12.256C22.377 10.7879 21.5036 9.46318 20.399 8.35833L19.2055 9.33481Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M18.401 6.7629L17.1487 7.78747C17.304 7.87538 17.4571 7.96762 17.608 8.06413C17.8986 8.25002 18.1783 8.45027 18.4463 8.66386L19.6538 7.67595C19.3251 7.40053 18.98 7.1428 18.6199 6.90433C18.5474 6.85632 18.4744 6.80917 18.401 6.7629Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M6.26811 18.6279L7.55508 17.5749C7.15508 17.3888 6.7664 17.1755 6.39186 16.9359C6.31271 16.8853 6.23437 16.8336 6.15684 16.7808L4.93169 17.7832C5.07825 17.8907 5.2276 17.9948 5.37963 18.0955C5.66849 18.2868 5.96499 18.4644 6.26811 18.6279Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M23.4749 3.58051C23.7372 3.9011 23.69 4.37361 23.3694 4.63591L2.53032 21.6861C2.20974 21.9483 1.73722 21.9011 1.47493 21.5805C1.21263 21.2599 1.25988 20.7874 1.58047 20.5251L22.4195 3.47497C22.7401 3.21268 23.2126 3.25993 23.4749 3.58051Z",fill:"var(--icon-primary)"}));HideIcon.displayName="HideIcon";const InfoIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"More information"),/*#__PURE__*/React__default.createElement("g",{clipPath:"url(#clip0_162_114)"},/*#__PURE__*/React__default.createElement("path",{d:"M10.647 10.75V17.249C10.6808 17.5845 10.8353 17.8963 11.0818 18.1265C11.3283 18.3566 11.65 18.4893 11.987 18.5C12.3299 18.5103 12.6628 18.3847 12.9134 18.1505C13.1641 17.9164 13.312 17.5927 13.325 17.25V10.75C13.2911 10.415 13.1368 10.1037 12.8907 9.8738C12.6447 9.64393 12.3236 9.51111 11.987 9.5C11.6439 9.48919 11.3104 9.61456 11.0593 9.84875C10.8083 10.0829 10.6601 10.4069 10.647 10.75Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M10.9394 5.43934C10.6581 5.72064 10.5 6.10218 10.5 6.5C10.4917 6.69921 10.5248 6.89798 10.5972 7.08374C10.6697 7.26951 10.7799 7.43822 10.9208 7.5792C11.0618 7.72019 11.2305 7.83038 11.4163 7.90281C11.6021 7.97524 11.8008 8.00834 12 8C12.1992 8.00834 12.398 7.97524 12.5838 7.90281C12.7695 7.83038 12.9383 7.72019 13.0792 7.5792C13.2202 7.43822 13.3304 7.26951 13.4029 7.08374C13.4753 6.89798 13.5084 6.69921 13.5 6.5C13.5 6.10218 13.342 5.72064 13.0607 5.43934C12.7794 5.15804 12.3979 5 12 5C11.6022 5 11.2207 5.15804 10.9394 5.43934Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",fill:"var(--icon-primary)"})),/*#__PURE__*/React__default.createElement("defs",null,/*#__PURE__*/React__default.createElement("clipPath",{id:"clip0_162_114"},/*#__PURE__*/React__default.createElement("rect",{width:24,height:24,fill:"white"}))));InfoIcon.displayName="InfoIcon";const NoticeIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Notice"),/*#__PURE__*/React__default.createElement("g",{clipPath:"url(#clip0_162_124)"},/*#__PURE__*/React__default.createElement("path",{d:"M13.2109 12.695V6.63198C13.2109 6.30537 13.0812 5.99213 12.8502 5.76118C12.6193 5.53023 12.3061 5.40048 11.9794 5.40048C11.6528 5.40048 11.3396 5.53023 11.1086 5.76118C10.8777 5.99213 10.7479 6.30537 10.7479 6.63198V12.695C10.7479 13.0216 10.8777 13.3348 11.1086 13.5658C11.3396 13.7967 11.6528 13.9265 11.9794 13.9265C12.3061 13.9265 12.6193 13.7967 12.8502 13.5658C13.0812 13.3348 13.2109 13.0216 13.2109 12.695Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M12.9186 15.6065C12.6541 15.3891 12.3223 15.2702 11.9799 15.27C11.7855 15.2699 11.593 15.308 11.4134 15.3823C11.2337 15.4566 11.0705 15.5656 10.9329 15.703C10.6907 15.945 10.5399 16.2635 10.5062 16.6042C10.4725 16.9449 10.5579 17.2868 10.748 17.5716C10.9381 17.8564 11.221 18.0665 11.5486 18.166C11.8762 18.2656 12.2282 18.2485 12.5446 18.1176C12.861 17.9868 13.1222 17.7503 13.2838 17.4484C13.4454 17.1465 13.4973 16.798 13.4307 16.4621C13.3641 16.1263 13.1831 15.8239 12.9186 15.6065Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",fill:"var(--icon-primary)"})),/*#__PURE__*/React__default.createElement("defs",null,/*#__PURE__*/React__default.createElement("clipPath",{id:"clip0_162_124"},/*#__PURE__*/React__default.createElement("rect",{width:24,height:24,fill:"white"}))));NoticeIcon.displayName="NoticeIcon";const NoticeTriangleIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Notice"),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M2.56766 20.582H21.8206L12.2809 3.14119L2.56766 20.582ZM22.6728 22.0884H1.70806C0.935022 22.0884 0.44507 21.2692 0.817804 20.6L11.3946 1.6084C11.7824 0.912039 12.7963 0.915832 13.1788 1.61508L23.5668 20.6066C23.9327 21.2757 23.4425 22.0884 22.6728 22.0884ZM13.2151 9.60086V14.2483C13.2151 14.4987 13.1171 14.7388 12.9427 14.9158C12.7683 15.0929 12.5317 15.1923 12.285 15.1923C12.0383 15.1923 11.8018 15.0929 11.6273 14.9158C11.4529 14.7388 11.3549 14.4987 11.3549 14.2483V9.60086C11.3549 9.3505 11.4529 9.1104 11.6273 8.93336C11.8018 8.75633 12.0383 8.65688 12.285 8.65688C12.5317 8.65688 12.7683 8.75633 12.9427 8.93336C13.1171 9.1104 13.2151 9.3505 13.2151 9.60086ZM12.2854 16.2222C12.544 16.2223 12.7945 16.3135 12.9943 16.4801C13.1941 16.6468 13.3308 16.8785 13.3811 17.136C13.4314 17.3934 13.3922 17.6606 13.2702 17.892C13.1481 18.1234 12.9508 18.3047 12.7119 18.405C12.4729 18.5053 12.2071 18.5184 11.9596 18.4421C11.7122 18.3658 11.4985 18.2047 11.3549 17.9864C11.2114 17.7681 11.1468 17.5061 11.1723 17.2449C11.1978 16.9837 11.3117 16.7396 11.4946 16.5541C11.5985 16.4487 11.7218 16.3652 11.8575 16.3083C11.9932 16.2513 12.1386 16.2221 12.2854 16.2222Z",fill:"var(--icon-primary)"}));NoticeTriangleIcon.displayName="NoticeTriangleIcon";const PaginationFirstIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Pagination first"),/*#__PURE__*/React__default.createElement("path",{d:"M6 12.103C6.01703 12.2769 6.08272 12.4454 6.19707 12.5788L9.80054 16.7802C10.0693 17.0935 10.4719 17.0523 10.7737 16.7802C11.0754 16.508 11.0754 16.0009 10.7737 15.6456L7.64869 12.0021L10.7737 8.35442C11.0754 7.99915 11.0754 7.49199 10.7737 7.21983C10.4719 6.94766 10.0693 6.90651 9.80054 7.21983L6.19707 11.4212C6.08272 11.5546 6.01703 11.7231 6 11.897L6 12.103Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M13 12.103C13.017 12.2769 13.0827 12.4454 13.1971 12.5788L16.8005 16.7802C17.0693 17.0935 17.4719 17.0523 17.7737 16.7802C18.0754 16.508 18.0754 16.0009 17.7737 15.6456L14.6487 12.0021L17.7737 8.35442C18.0754 7.99915 18.0754 7.49199 17.7737 7.21983C17.4719 6.94766 17.0693 6.90651 16.8005 7.21983L13.1971 11.4212C13.0827 11.5546 13.017 11.7231 13 11.897V12.103Z",fill:"var(--icon-primary)"}));PaginationFirstIcon.displayName="PaginationFirstIcon";const PaginationLastIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Pagination last"),/*#__PURE__*/React__default.createElement("path",{d:"M18 11.897C17.983 11.7231 17.9173 11.5546 17.8029 11.4212L14.1995 7.21983C13.9307 6.90651 13.5281 6.94766 13.2263 7.21983C12.9246 7.49199 12.9246 7.99915 13.2263 8.35442L16.3513 11.9979L13.2263 15.6456C12.9246 16.0009 12.9246 16.508 13.2263 16.7802C13.5281 17.0523 13.9307 17.0935 14.1995 16.7802L17.8029 12.5788C17.9173 12.4454 17.983 12.2769 18 12.103L18 11.897Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M11 11.897C10.983 11.7231 10.9173 11.5546 10.8029 11.4212L7.19946 7.21982C6.93074 6.90651 6.52812 6.94766 6.22634 7.21982C5.92455 7.49199 5.92455 7.99915 6.22634 8.35442L9.35131 11.9979L6.22634 15.6456C5.92455 16.0009 5.92455 16.508 6.22634 16.7802C6.52812 17.0523 6.93074 17.0935 7.19946 16.7802L10.8029 12.5788C10.9173 12.4454 10.983 12.2769 11 12.103L11 11.897Z",fill:"var(--icon-primary)"}));PaginationLastIcon.displayName="PaginationLastIcon";const PaginationNextIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Next page"),/*#__PURE__*/React__default.createElement("path",{d:"M15.5 11.397C15.483 11.2231 15.4173 11.0546 15.3029 10.9212L11.6995 6.71982C11.4307 6.40651 11.0281 6.44766 10.7263 6.71982C10.4246 6.99199 10.4246 7.49915 10.7263 7.85442L13.8513 11.4979L10.7263 15.1456C10.4246 15.5009 10.4246 16.008 10.7263 16.2802C11.0281 16.5523 11.4307 16.5935 11.6995 16.2802L15.3029 12.0788C15.4173 11.9454 15.483 11.7769 15.5 11.603L15.5 11.397Z",fill:"var(--icon-primary)"}));PaginationNextIcon.displayName="PaginationNextIcon";const PaginationPreviousIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Previous page"),/*#__PURE__*/React__default.createElement("path",{d:"M9.5 11.603C9.51703 11.7769 9.58272 11.9454 9.69707 12.0788L13.3005 16.2802C13.5693 16.5935 13.9719 16.5523 14.2737 16.2802C14.5754 16.008 14.5754 15.5009 14.2737 15.1456L11.1487 11.5021L14.2737 7.85442C14.5754 7.49915 14.5754 6.99199 14.2737 6.71983C13.9719 6.44766 13.5693 6.40651 13.3005 6.71983L9.69707 10.9212C9.58272 11.0546 9.51703 11.2231 9.5 11.397L9.5 11.603Z",fill:"var(--icon-primary)"}));PaginationPreviousIcon.displayName="PaginationPreviousIcon";const SearchIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Search"),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M15.2795 17.2896C13.7965 18.3656 11.9723 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 12.0966 18.2831 14.0257 17.0811 15.5557L21.9726 20.4472C22.4607 20.9353 22.4607 21.7268 21.9726 22.2149C21.4844 22.7031 20.6929 22.7031 20.2048 22.2149L15.2795 17.2896ZM17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",fill:"var(--icon-primary)"}));SearchIcon.displayName="SearchIcon";const ShowIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Visible"),/*#__PURE__*/React__default.createElement("path",{d:"M22.9569 12.256C22.0934 10.07 20.5795 8.20197 18.6199 6.90428C16.6603 5.60659 14.3495 4.94187 11.9999 4.99997C9.65034 4.94187 7.33955 5.60659 5.37996 6.90428C3.42038 8.20197 1.90648 10.07 1.04293 12.256C0.985689 12.4133 0.985689 12.5857 1.04293 12.743C1.9062 14.9292 3.42 16.7975 5.37963 18.0954C7.33926 19.3933 9.65019 20.0581 11.9999 20C14.3495 20.0581 16.6603 19.3933 18.6199 18.0957C20.5795 16.798 22.0934 14.9299 22.9569 12.744C23.0142 12.5863 23.0142 12.4136 22.9569 12.256ZM11.9999 18.5C10.0164 18.5498 8.06328 18.0051 6.39186 16.9359C4.72044 15.8666 3.40715 14.3217 2.62093 12.5C3.40726 10.6783 4.72058 9.1335 6.39197 8.06426C8.06336 6.99502 10.0164 6.45024 11.9999 6.49997C13.9835 6.4501 15.9366 6.99483 17.608 8.06409C19.2794 9.13334 20.5927 10.6782 21.3789 12.5C20.5926 14.3216 19.2793 15.8664 17.6079 16.9357C15.9365 18.0049 13.9835 18.5497 11.9999 18.5Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M11.9999 8.15097C10.7973 8.10433 9.83659 8.53555 8.95088 9.35044C8.06517 10.1653 7.76498 11.2976 7.71145 12.5C7.81059 13.6853 8.12448 14.7902 8.99993 15.5955C9.87537 16.4007 10.8099 16.8477 11.9994 16.8477C13.1889 16.8477 14.335 16.4007 15.2104 15.5955C16.0859 14.7902 16.6268 13.6853 16.7259 12.5C16.6724 11.2978 16.1453 10.1657 15.2598 9.3508C14.3744 8.53595 13.2024 8.1046 11.9999 8.15097ZM11.9999 15.399C11.4369 15.352 10.8997 15.142 10.4541 14.7948C10.0084 14.4475 9.67346 13.978 9.4902 13.4436C9.30695 12.9092 9.28329 12.3329 9.42212 11.7852C9.56095 11.2376 9.85626 10.7422 10.272 10.3596C10.6877 9.97699 11.2058 9.72372 11.7631 9.63072C12.3204 9.53773 12.8927 9.60903 13.4101 9.83592C13.9276 10.0628 14.3677 10.4355 14.6769 10.9084C14.986 11.3813 15.1507 11.934 15.1509 12.499C15.1156 13.3007 14.7643 14.0557 14.1738 14.5992C13.5834 15.1426 12.8018 15.4301 11.9999 15.399Z",fill:"var(--icon-primary)"}));ShowIcon.displayName="ShowIcon";const SuccessIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.2264 8.43934C17.5193 8.73223 17.5193 9.20711 17.2264 9.5L11.2124 15.9051C10.7659 16.3517 10.0289 16.3058 9.64116 15.8073L6.5 12.8399C6.2457 12.5129 6.3046 12.0417 6.63156 11.7874C6.95852 11.5331 7.42973 11.592 7.68403 11.919L10.5122 14.484L16.1658 8.43934C16.4587 8.14645 16.9335 8.14645 17.2264 8.43934Z",fill:"var(--icon-primary)"}));SuccessIcon.displayName="SuccessIcon";const UploadIcon=({color,size,...props})=>/*#__PURE__*/React__default.createElement("svg",_extends$i({width:24,height:24,viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg","data-bxp-icon":"OneColor"},props,{style:resolveParams(color,size,props?.style)}),/*#__PURE__*/React__default.createElement("desc",null,"Upload"),/*#__PURE__*/React__default.createElement("path",{d:"M12.509 3.00001C12.2815 3.00835 12.0637 3.08818 11.891 3.22653L6.79699 7.69548C6.63322 7.85893 6.53573 8.0705 6.52131 8.29375C6.50689 8.51699 6.57645 8.73794 6.71799 8.91852C6.89447 9.07845 7.13142 9.16715 7.37754 9.1654C7.62366 9.16366 7.85914 9.07161 8.03299 8.9092L11.61 5.76677L11.61 16.8422C11.61 17.0647 11.7048 17.2781 11.8736 17.4354C12.0424 17.5928 12.2713 17.6812 12.51 17.6812C12.7487 17.6812 12.9776 17.5928 13.1464 17.4354C13.3152 17.2781 13.41 17.0647 13.41 16.8422L13.41 5.76677L16.985 8.9092C17.1647 9.05952 17.3972 9.14343 17.6386 9.14515C17.88 9.14686 18.1138 9.06627 18.296 8.91852C18.4404 8.73941 18.5122 8.51839 18.4984 8.29467C18.4847 8.07095 18.3864 7.859 18.221 7.69641L13.127 3.22746C12.9613 3.07858 12.7391 2.99617 12.509 3.00001Z",fill:"var(--icon-primary)"}),/*#__PURE__*/React__default.createElement("path",{d:"M4.9001 18C4.9001 17.503 4.49715 17.1 4.0001 17.1C3.50304 17.1 3.1001 17.503 3.1001 18V21C3.1001 21.4971 3.50304 21.9 4.0001 21.9H21.0001C21.4972 21.9 21.9001 21.4971 21.9001 21V18C21.9001 17.503 21.4972 17.1 21.0001 17.1C20.503 17.1 20.1001 17.503 20.1001 18V20.1H4.9001V18Z",fill:"var(--icon-primary)"}));UploadIcon.displayName="UploadIcon";

var styles$1d = {"listener":"Tooltip-module_listener__g4Fn9","content":"Tooltip-module_content__3ydbB","noWrap":"Tooltip-module_noWrap__1iLyr","popover":"Tooltip-module_popover__1Jt9g","tooltip":"Tooltip-module_tooltip__3gnif","list-content":"Tooltip-module_list-content__1kwZq"};

let active = null;
const closeActivePopover = () => {
    if (active) {
        active.forceClose();
        active = null;
    }
};
const setActivePopover = ({ triggerRef, popoverRef, forceClose }) => {
    if (active && active.ref !== popoverRef) {
        closeActivePopover();
    }
    active = {
        popoverRef,
        triggerRef,
        forceClose
    };
};
const Popover$2 = ({ children, triggerRef, setIsHovered, horizontalPlacement, verticalPlacement, calculatePositionFromCursor, forceClose, className, style }) => {
    const popoverRef = useRef(null);
    const [isEntering, setIsEntering] = useState(true);
    useLayoutEffect(() => {
        var _a;
        const startTime = new Date().valueOf();
        if (!triggerRef || !triggerRef.current) {
            return;
        }
        const updateBasedOnXY = (x, y) => {
            var _a, _b;
            if (!popoverRef.current) {
                return;
            }
            let left = x + 25;
            let top = y + 10;
            const popoverWidth = (_a = popoverRef.current.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width;
            if (popoverWidth) {
                const outsideViewAmount = popoverWidth + left + 16 - document.body.clientWidth;
                if (outsideViewAmount > 0) {
                    left = left - outsideViewAmount;
                }
            }
            const popoverHeight = (_b = popoverRef.current.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height;
            if (popoverHeight) {
                const outsideViewAmount = popoverHeight + top + 8 - document.body.clientHeight;
                if (outsideViewAmount > 0) {
                    top = top - outsideViewAmount;
                }
            }
            popoverRef.current.style.top = `${top}px`;
            popoverRef.current.style.left = `${left}px`;
        };
        const mouseMoveListener = (e) => {
            const currentTime = new Date().valueOf();
            if (currentTime - startTime > 225) {
                window.removeEventListener("mousemove", mouseMoveListener);
            }
            else {
                updateBasedOnXY(e.clientX, e.clientY);
            }
        };
        if (calculatePositionFromCursor) {
            if (calculatePositionFromCursor.current) {
                updateBasedOnXY(calculatePositionFromCursor.current.clientX, calculatePositionFromCursor.current.clientY);
            }
            window.addEventListener("mousemove", mouseMoveListener);
        }
        if (!(calculatePositionFromCursor === null || calculatePositionFromCursor === void 0 ? void 0 : calculatePositionFromCursor.current)) {
            if (popoverRef.current && triggerRef.current) {
                const boundNode = triggerRef.current;
                const boundingRect = boundNode.getBoundingClientRect();
                let placementHeight = boundingRect.height;
                let placementWidth = 0;
                if (verticalPlacement === "center") {
                    placementHeight = boundingRect.height / 2;
                }
                else if (verticalPlacement === 'top') {
                    placementHeight = 0;
                }
                if (horizontalPlacement === "center") {
                    placementWidth = boundingRect.width / 2;
                }
                else if (horizontalPlacement === "right") {
                    placementWidth = boundingRect.width;
                }
                let left = boundingRect.left + placementWidth;
                const popoverWidth = (_a = popoverRef.current.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width;
                if (popoverWidth) {
                    const outsideViewAmount = popoverWidth + left - document.body.clientWidth;
                    if (outsideViewAmount > 0) {
                        left = left - outsideViewAmount;
                    }
                }
                popoverRef.current.style.top = `${boundingRect.top + placementHeight}px`;
                popoverRef.current.style.left = `${left}px`;
            }
        }
        return () => {
            if (calculatePositionFromCursor) {
                window.removeEventListener("mousemove", mouseMoveListener);
            }
        };
    }, []);
    useEffect(() => {
        setActivePopover({ triggerRef, popoverRef, forceClose });
        setTimeout(() => {
            if (popoverRef === (active === null || active === void 0 ? void 0 : active.popoverRef)) {
                setIsEntering(false);
            }
        }, 250);
        return () => {
            if (popoverRef === (active === null || active === void 0 ? void 0 : active.popoverRef)) {
                closeActivePopover();
            }
        };
    }, []);
    return ReactDOM.createPortal(jsx$3("div", { className: classNames(styles$1d.popover, className), ref: popoverRef, onMouseOver: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), style: Object.assign(Object.assign({}, style), { opacity: isEntering ? 0 : 1 }), children: children }), getRootComponent());
};
const Render = React__default.memo(({ children, triggerRef, isTriggerHovered, calculatePositionFromCursor, verticalPlacement, horizontalPlacement, className, style, onIsShowing }) => {
    const [isPopoverHovered, setIsPopoverHovered] = useState(false);
    const [isShowing, setIsShowing] = useState(false);
    const stateRef = useRef({});
    useEffect(() => {
        if (isTriggerHovered || isPopoverHovered) {
            setIsShowing(true);
            if (stateRef.current.timeout) {
                stateRef.current.timeout && window.clearTimeout(stateRef.current.timeout);
                stateRef.current.timeout = null;
            }
        }
        else {
            if (!stateRef.current.timeout) {
                stateRef.current.timeout = window.setTimeout(() => {
                    setIsShowing(false);
                }, 250);
            }
        }
        return () => {
            if (stateRef.current.timeout) {
                stateRef.current.timeout && window.clearTimeout(stateRef.current.timeout);
                stateRef.current.timeout = null;
            }
        };
    }, [isTriggerHovered, isPopoverHovered]);
    const forceClose = useCallback(() => {
        if (stateRef.current.timeout) {
            stateRef.current.timeout && window.clearTimeout(stateRef.current.timeout);
            delete stateRef.current.timeout;
            setIsShowing(false);
        }
    }, [setIsShowing]);
    useEffect(() => {
        onIsShowing && onIsShowing(isShowing);
    }, [onIsShowing, isShowing]);
    if (isShowing) {
        return jsx$3(Popover$2, { triggerRef: triggerRef, setIsHovered: setIsPopoverHovered, calculatePositionFromCursor: calculatePositionFromCursor, verticalPlacement: verticalPlacement, horizontalPlacement: horizontalPlacement, className: className, style: style, forceClose: forceClose, children: children });
    }
    else {
        return "";
    }
});
const stopPropagation = e => e.stopPropagation();
const TooltipContent = React__default.memo(({ children, className, style, nowrap, dataTestId }) => {
    return jsx$3("div", { "data-testid": dataTestId, className: classNames(styles$1d.content, { [styles$1d.noWrap]: nowrap }, className), style: style, onClick: stopPropagation, children: children });
});
const TooltipListContent = React__default.memo(({ children, className, style }) => {
    return jsx$3("div", { className: classNames(styles$1d["list-content"], className), style: style, children: children });
});
const Tooltip$1 = React__default.memo(({ children, className, style, contentClassName, contentStyle, Content = TooltipContent, nowrap }) => {
    const ref = useRef(null);
    const mouseRef = useRef(null);
    const [isHovered, setHovered] = useState(false);
    useEffect(() => {
        const enterListener = (e) => {
            mouseRef.current = e;
            setHovered(true);
        };
        const exitListener = () => {
            mouseRef.current = null;
            setHovered(false);
        };
        if (ref.current) {
            let parentNode = ref.current.parentNode;
            if (parentNode) {
                ref.current.parentNode.addEventListener("mouseenter", enterListener);
                ref.current.parentNode.addEventListener("mouseleave", exitListener);
            }
            return () => {
                if (parentNode) {
                    parentNode.removeEventListener("mouseenter", enterListener);
                    parentNode.removeEventListener("mouseleave", exitListener);
                }
            };
        }
    }, []);
    return jsx$3("div", { className: styles$1d.listener, ref: ref, children: jsx$3(Render, { className: classNames(styles$1d.tooltip, className), style: style, triggerRef: ref, calculatePositionFromCursor: mouseRef, isTriggerHovered: isHovered, children: jsx$3(Content, { dataTestId: 'tooltip', className: contentClassName, style: contentStyle, nowrap: nowrap, children: children }) }) });
});

var _desc$d, _path$c;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
var SvgIcTooltipI = function SvgIcTooltipI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$d || (_desc$d = /*#__PURE__*/React.createElement("desc", null, "More information")), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.01621 7.09091V11.8175C7.04077 12.0615 7.15313 12.2883 7.3324 12.4556C7.51167 12.623 7.74563 12.7195 7.99075 12.7273C8.24007 12.7347 8.48224 12.6434 8.6645 12.4731C8.84677 12.3028 8.95436 12.0674 8.96384 11.8182V7.09091C8.93915 6.84727 8.82692 6.62085 8.64797 6.45367C8.46903 6.28649 8.23551 6.1899 7.99075 6.18182C7.74119 6.17396 7.49864 6.26513 7.31606 6.43545C7.13348 6.60577 7.02569 6.8414 7.01621 7.09091ZM7.22882 3.22861C7.02423 3.4332 6.9093 3.71067 6.9093 4C6.90323 4.14488 6.9273 4.28944 6.97998 4.42454C7.03266 4.55964 7.1128 4.68234 7.21533 4.78487C7.31787 4.88741 7.44057 4.96755 7.57567 5.02023C7.71077 5.07291 7.85533 5.09697 8.00021 5.09091C8.14509 5.09697 8.28965 5.07291 8.42475 5.02023C8.55985 4.96755 8.68255 4.88741 8.78508 4.78487C8.88762 4.68234 8.96776 4.55964 9.02043 4.42454C9.07311 4.28944 9.09718 4.14488 9.09112 4C9.09112 3.71067 8.97618 3.4332 8.7716 3.22861C8.56701 3.02403 8.28953 2.90909 8.00021 2.90909C7.71088 2.90909 7.4334 3.02403 7.22882 3.22861Z",
    fill: "var(--icon-primary)"
  })));
};

const DefaultTrigger = ({ isActive }) => {
    return jsx$3(SvgIcTooltipI, { className: classNames(styles$1g[`info-button`], { [styles$1g[`info-button-active`]]: isActive }) });
};
const ErrorTrigger = () => {
    return jsx$3(ErrorIcon, { color: "error" });
};
const HighNoticeTrigger = () => {
    return jsx$3(NoticeIcon, { color: "error" });
};
const NoticeTrigger = () => {
    return jsx$3(NoticeIcon, { color: "warning" });
};
const InfoTrigger = () => {
    return jsx$3(InfoIcon, { color: "information" });
};
const SuccessTrigger = () => {
    return jsx$3(SuccessIcon, { color: "success" });
};
var Popover$1 = React__default.memo(({ contentClassName, contentStyle, className, style, triggerStyle, triggerClassName, children, Trigger: _Trigger, Content = TooltipContent, placement: horizontalPlacement = "center", verticalPlacement = "bottom" }) => {
    const ref = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);
    let placementClassName = `${verticalPlacement}-${horizontalPlacement}`;
    if (verticalPlacement === "bottom" || verticalPlacement === "top") {
        if (horizontalPlacement === "right") {
            horizontalPlacement = "left";
        }
        else if (horizontalPlacement === "left") {
            horizontalPlacement = "right";
        }
    }
    let Trigger = _Trigger;
    if (!Trigger) {
        Trigger = DefaultTrigger;
    }
    else if (Trigger === "error") {
        Trigger = ErrorTrigger;
    }
    else if (Trigger === "urgent-notice") {
        Trigger = HighNoticeTrigger;
    }
    else if (Trigger === "notice") {
        Trigger = NoticeTrigger;
    }
    else if (Trigger === "info") {
        Trigger = InfoTrigger;
    }
    else if (Trigger === "success") {
        Trigger = SuccessTrigger;
    }
    return jsxs("span", { className: classNames(styles$1g['trigger-wrapper'], triggerClassName), style: triggerStyle, ref: ref, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), children: [jsx$3(Trigger, { isActive: isActive }), jsx$3(Render, { onIsShowing: setIsActive, className: classNames(styles$1g[placementClassName], className), style: style, triggerRef: ref, isTriggerHovered: isHovered, horizontalPlacement: horizontalPlacement, verticalPlacement: verticalPlacement, children: jsx$3(Content, { className: contentClassName, style: contentStyle, children: children }) })] });
});

const FieldError = React__default.memo(({ message, type = "error", className, style, dataTestId }) => {
    const ref = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);
    useEffect(() => {
        setIsOverflow(false);
        setTimeout(() => {
            if (ref.current && ref.current.isConnected) {
                const spanNode = ref.current.children[1];
                setIsOverflow(spanNode.scrollWidth > spanNode.clientWidth);
            }
        });
    }, [message]);
    return jsxs("div", { "data-component": "FieldError", className: classNames(styles$1e.base, className), style: style, ref: ref, "data-testid": dataTestId, children: [type === "warning" ? jsx$3(NoticeTriangleIcon, { color: "warning" }) : jsx$3(ErrorIcon, { color: "error" }), jsxs(Span, { level: 13, ellipsis: true, children: [jsx$3("strong", { children: type === "warning" ? "Warning: " : "Error: " }), message] }), isOverflow && jsx$3(Popover$1, { placement: "center", verticalPlacement: "bottom", triggerClassName: styles$1e["popover-trigger"], children: message })] });
});

var styles$1c = {"primary":"buttons-module_primary__HC_JW","secondary":"buttons-module_secondary__K1zSo","destructive":"buttons-module_destructive__1TUkw","loader":"buttons-module_loader__2HCJ_","large":"buttons-module_large__uXKOu","is-submitting":"buttons-module_is-submitting__2ATx0","center":"buttons-module_center__Uxcz2","right":"buttons-module_right__-yHFP","icon":"buttons-module_icon__BC1Ey","icon-secondary":"buttons-module_icon-secondary__3I9he","icon-actual-secondary":"buttons-module_icon-actual-secondary__2wOgK","text":"buttons-module_text__vfa1g","text-secondary":"buttons-module_text-secondary__2mFiu","dropdown-button":"buttons-module_dropdown-button__3UVwn","dropdown-button-triangle":"buttons-module_dropdown-button-triangle__1WACg","active-triangle":"buttons-module_active-triangle__B9mVg","round-dropdown-button":"buttons-module_round-dropdown-button__4AtLv","text-loader":"buttons-module_text-loader__1KJa2","square-group":"buttons-module_square-group__1K65P","mixed-group":"buttons-module_mixed-group__2okPT","bgshimmer":"buttons-module_bgshimmer__3_qjS"};

var reactIs = {exports: {}};

var reactIs_production = {};

/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
  REACT_PORTAL_TYPE = Symbol.for("react.portal"),
  REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
  REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
  REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
  REACT_CONTEXT_TYPE = Symbol.for("react.context"),
  REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
  REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
  REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
  REACT_MEMO_TYPE = Symbol.for("react.memo"),
  REACT_LAZY_TYPE = Symbol.for("react.lazy"),
  REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"),
  REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
  if ("object" === typeof object && null !== object) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        switch (((object = object.type), object)) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return object;
          default:
            switch (((object = object && object.$$typeof), object)) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
                return object;
              case REACT_CONSUMER_TYPE:
                return object;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
}
reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
reactIs_production.Element = REACT_ELEMENT_TYPE;
reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
reactIs_production.Lazy = REACT_LAZY_TYPE;
reactIs_production.Memo = REACT_MEMO_TYPE;
reactIs_production.Portal = REACT_PORTAL_TYPE;
reactIs_production.Profiler = REACT_PROFILER_TYPE;
reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
reactIs_production.isContextConsumer = function (object) {
  return typeOf(object) === REACT_CONSUMER_TYPE;
};
reactIs_production.isContextProvider = function (object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
};
reactIs_production.isElement = function (object) {
  return (
    "object" === typeof object &&
    null !== object &&
    object.$$typeof === REACT_ELEMENT_TYPE
  );
};
reactIs_production.isForwardRef = function (object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
reactIs_production.isFragment = function (object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
};
reactIs_production.isLazy = function (object) {
  return typeOf(object) === REACT_LAZY_TYPE;
};
reactIs_production.isMemo = function (object) {
  return typeOf(object) === REACT_MEMO_TYPE;
};
reactIs_production.isPortal = function (object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
};
reactIs_production.isProfiler = function (object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
};
reactIs_production.isStrictMode = function (object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
reactIs_production.isSuspense = function (object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
};
reactIs_production.isSuspenseList = function (object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
reactIs_production.isValidElementType = function (type) {
  return "string" === typeof type ||
    "function" === typeof type ||
    type === REACT_FRAGMENT_TYPE ||
    type === REACT_PROFILER_TYPE ||
    type === REACT_STRICT_MODE_TYPE ||
    type === REACT_SUSPENSE_TYPE ||
    type === REACT_SUSPENSE_LIST_TYPE ||
    type === REACT_OFFSCREEN_TYPE ||
    ("object" === typeof type &&
      null !== type &&
      (type.$$typeof === REACT_LAZY_TYPE ||
        type.$$typeof === REACT_MEMO_TYPE ||
        type.$$typeof === REACT_CONTEXT_TYPE ||
        type.$$typeof === REACT_CONSUMER_TYPE ||
        type.$$typeof === REACT_FORWARD_REF_TYPE ||
        type.$$typeof === REACT_CLIENT_REFERENCE ||
        void 0 !== type.getModuleId))
    ? !0
    : !1;
};
reactIs_production.typeOf = typeOf;

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV &&
  (function () {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (((object = object.type), object)) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
                return object;
              default:
                switch (((object = object && object.$$typeof), object)) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
      REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
      REACT_MEMO_TYPE = Symbol.for("react.memo"),
      REACT_LAZY_TYPE = Symbol.for("react.lazy"),
      REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"),
      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development.Element = REACT_ELEMENT_TYPE;
    reactIs_development.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development.Lazy = REACT_LAZY_TYPE;
    reactIs_development.Memo = REACT_MEMO_TYPE;
    reactIs_development.Portal = REACT_PORTAL_TYPE;
    reactIs_development.Profiler = REACT_PROFILER_TYPE;
    reactIs_development.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development.isContextConsumer = function (object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development.isContextProvider = function (object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development.isElement = function (object) {
      return (
        "object" === typeof object &&
        null !== object &&
        object.$$typeof === REACT_ELEMENT_TYPE
      );
    };
    reactIs_development.isForwardRef = function (object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development.isFragment = function (object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development.isLazy = function (object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development.isMemo = function (object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development.isPortal = function (object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development.isProfiler = function (object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development.isStrictMode = function (object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development.isSuspense = function (object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development.isSuspenseList = function (object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development.isValidElementType = function (type) {
      return "string" === typeof type ||
        "function" === typeof type ||
        type === REACT_FRAGMENT_TYPE ||
        type === REACT_PROFILER_TYPE ||
        type === REACT_STRICT_MODE_TYPE ||
        type === REACT_SUSPENSE_TYPE ||
        type === REACT_SUSPENSE_LIST_TYPE ||
        type === REACT_OFFSCREEN_TYPE ||
        ("object" === typeof type &&
          null !== type &&
          (type.$$typeof === REACT_LAZY_TYPE ||
            type.$$typeof === REACT_MEMO_TYPE ||
            type.$$typeof === REACT_CONTEXT_TYPE ||
            type.$$typeof === REACT_CONSUMER_TYPE ||
            type.$$typeof === REACT_FORWARD_REF_TYPE ||
            type.$$typeof === REACT_CLIENT_REFERENCE ||
            void 0 !== type.getModuleId))
        ? !0
        : !1;
    };
    reactIs_development.typeOf = typeOf;
  })();

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production;
} else {
  reactIs.exports = reactIs_development;
}

// index.ts
function isFragmentWithChildren(node) {
  return reactIs.exports.isFragment(node);
}
function flattenChildren(children, depth = 0, keys = []) {
  return Children.toArray(children).reduce(
    (acc, node, nodeIndex) => {
      if (isFragmentWithChildren(node)) {
        acc.push.apply(
          acc,
          flattenChildren(
            node.props.children,
            depth + 1,
            keys.concat(node.key || nodeIndex)
          )
        );
      } else {
        if (isValidElement(node)) {
          acc.push(
            cloneElement(node, {
              key: keys.concat(String(node.key)).join(".")
            })
          );
        } else if (typeof node === "string" || typeof node === "number") {
          acc.push(node);
        }
      }
      return acc;
    },
    []
  );
}

const ButtonsGroup = ({ children, className, style }) => {
    const mixed = !!flattenChildren(children).find((child) => { var _a, _b; return ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.variant) && ((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.variant) !== "square"; });
    return jsx$3("div", { className: classNames(mixed ? styles$1c['mixed-group'] : styles$1c['square-group'], className), style: style, children: children });
};

let lastTarget = null;
const Container$1 = ({ children, className, style: _style, dataTestId }) => {
    const [style, setStyle] = useState(Object.assign({}, _style));
    const modalRef = useRef(null);
    const positionStateRef = useRef(false);
    useLayoutEffect(() => {
        const target = (lastTarget && lastTarget.isConnected) ? lastTarget : getRootComponent();
        lastTarget = null;
        if (target && modalRef.current && !positionStateRef.current) {
            const targetBoundingRect = target.getBoundingClientRect();
            const modalRect = modalRef.current.getBoundingClientRect();
            positionStateRef.current = true;
            const x = (targetBoundingRect.left + targetBoundingRect.width / 2) - modalRect.left;
            const y = (targetBoundingRect.top + targetBoundingRect.height / 2) - (modalRect.top + modalRect.height);
            setStyle(Object.assign({ opacity: 0, transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(0)` }, _style));
            setTimeout(() => {
                setStyle(Object.assign({ transition: "transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)", transformOrigin: "0 100%", opacity: 1, transform: "translate(-50%, -50%)" }, _style));
            }, 100);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return jsxs(PopoverContext, { className: styles$1f['modal-container'], "data-modal": true, "data-component": "Modal", children: [jsx$3("div", { className: styles$1f['mask'] }), jsx$3("div", { className: classNames(styles$1f["modal"], className), ref: modalRef, style: style, "data-testid": dataTestId, children: children })] });
};
const Content$1 = ({ children, className, style, flex, dataTestId = 'modal-content' }) => {
    if (_$1.isString(children)) {
        children = jsx$3(Text, { children: children });
    }
    return jsx$3("div", { className: classNames(styles$1f["content"], { [styles$1f.flex]: !!flex }, className), style: style, "data-testid": dataTestId, children: children });
};
const Header = ({ children, dataTestId = 'modal-header' }) => {
    return jsx$3("header", { className: styles$1f.header, "data-testid": dataTestId, children: jsx$3(Heading, { level: 20, color: "text-title", children: children }) });
};
function isModalError(obj) {
    return _$1.isPlainObject(obj) && !!obj.description;
}
const ModalFooter = React__default.memo(({ children, Content, error, warning, dataTestId = 'modal-footer' }) => {
    const errorOrWarning = error || warning;
    let hasMessage = false;
    let message = null;
    if (errorOrWarning) {
        hasMessage = true;
        if (isModalError(errorOrWarning)) {
            if (errorOrWarning.moreInfo) {
                message = errorOrWarning.description + " - " + errorOrWarning.moreInfo;
            }
            else {
                message = errorOrWarning.description;
            }
        }
        else {
            message = errorOrWarning;
        }
    }
    return jsxs("footer", { className: styles$1f["footer"], "data-testid": dataTestId, children: [jsxs("div", { className: styles$1f["footer-content"], children: [Content && !error && jsx$3(Content, {}), hasMessage && jsx$3(FieldError, { message: message, type: warning ? "warning" : "error", dataTestId: `${dataTestId}-error` })] }), jsx$3(ButtonsGroup, { children: children })] });
});
const initModalTargetListener = _$1.once(() => {
    getRootComponent().addEventListener("click", (e) => {
        lastTarget = e.target;
    }, true);
});
var Modal = ({ children, className, style, dataTestId }) => {
    return ReactDOM.createPortal(jsx$3(Container$1, { className: className, style: style, dataTestId: dataTestId, children: children }), getRootComponent());
};

var init$2 = function init(initialState) {
  return calculateIndices({
    stepsMap: initialState.stepsMap,
    stepPaths: initialState.stepPaths,
    currentStep: initialState.initialStep,
    currentStepPath: initialState.initialPath,
    previousStep: null,
    state: initialState.initialState || {}
  });
};
var calculateIndices = function calculateIndices(state) {
  var stepPaths = state.stepPaths,
    currentStepPath = state.currentStepPath,
    currentStep = state.currentStep,
    previousStep = state.previousStep;
  var currentStepIndex = _$1.findIndex(stepPaths[currentStepPath], {
    key: currentStep
  });
  var previousStepIndex = _$1.findIndex(stepPaths[currentStepPath], {
    key: previousStep
  });
  var showSteps = _$1.take(stepPaths[currentStepPath], currentStepIndex + 1);
  return _objectSpread2(_objectSpread2({}, state), {}, {
    currentStepIndex: currentStepIndex,
    previousStepIndex: previousStepIndex,
    showSteps: showSteps
  });
};
var reducer$2 = function reducer(state, action) {
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case "SET-STEP":
      {
        var step = payload.step;
        return calculateIndices(_objectSpread2(_objectSpread2({}, state), {}, {
          currentStep: step,
          previousStep: state.currentStep
        }));
      }
    case "SET-STEP-PATH":
      {
        var _step = payload.step,
          stepPath = payload.stepPath;
        return calculateIndices(_objectSpread2(_objectSpread2({}, state), {}, {
          currentStep: _step,
          previousStep: state.currentStep,
          currentStepPath: stepPath
        }));
      }
    case "SET-STATE":
      {
        var mergeState = payload.mergeState;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          state: _objectSpread2(_objectSpread2({}, state.state), mergeState)
        });
      }
    case "RESET-STATE":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          state: {}
        });
      }
    case "GO-TO-PREVIOUS-STEP":
      {
        var _step2 = state.stepPaths[state.currentStepPath][state.currentStepIndex - 1].key;
        return calculateIndices(_objectSpread2(_objectSpread2({}, state), {}, {
          currentStep: _step2,
          previousStep: state.currentStep
        }));
      }
    case "GO-TO-NEXT-STEP":
      {
        var _step3 = state.stepPaths[state.currentStepPath][state.currentStepIndex + 1].key;
        return calculateIndices(_objectSpread2(_objectSpread2({}, state), {}, {
          currentStep: _step3,
          previousStep: state.currentStep
        }));
      }
  }
  return state;
};
var useWizardController = (function (_ref) {
  var stepsMap = _ref.stepsMap,
    stepPaths = _ref.stepPaths,
    initialStep = _ref.initialStep,
    initialPath = _ref.initialPath,
    initialState = _ref.initialState;
  var _useReducer = useReducer(reducer$2, {
      stepsMap: stepsMap,
      stepPaths: stepPaths,
      initialStep: initialStep,
      initialPath: initialPath,
      initialState: initialState
    }, init$2),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    wizardState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var currentStep = wizardState.currentStep,
    previousStep = wizardState.previousStep,
    currentStepPath = wizardState.currentStepPath,
    currentStepIndex = wizardState.currentStepIndex,
    previousStepIndex = wizardState.previousStepIndex,
    showSteps = wizardState.showSteps,
    state = wizardState.state;
  var stateRef = useRef(null);
  stateRef.current = state;
  var gotoPreviousStep = useCallback(function () {
    dispatch({
      type: "GO-TO-PREVIOUS-STEP"
    });
  }, [dispatch]);
  var setStep = useCallback(function (step) {
    dispatch({
      type: "SET-STEP",
      payload: {
        step: step
      }
    });
  }, [dispatch]);
  var setStepPath = useCallback(function (step, stepPath) {
    dispatch({
      type: "SET-STEP-PATH",
      payload: {
        step: step,
        stepPath: stepPath
      }
    });
  }, [dispatch]);
  var setState = useCallback(function (state) {
    dispatch({
      type: "SET-STATE",
      payload: {
        mergeState: state
      }
    });
  }, [dispatch]);
  var resetState = useCallback(function () {
    dispatch({
      type: "RESET-STATE"
    });
  }, [dispatch]);
  var goToNextStep = useCallback(function () {
    dispatch({
      type: "GO-TO-NEXT-STEP"
    });
  }, [dispatch]);
  var getState = useCallback(function () {
    return stateRef.current;
  }, []);
  return useMemo(function () {
    return {
      setStep: setStep,
      setStepPath: setStepPath,
      currentStep: currentStep,
      previousStep: previousStep,
      currentStepPath: currentStepPath,
      currentStepIndex: currentStepIndex,
      previousStepIndex: previousStepIndex,
      showSteps: showSteps,
      setState: setState,
      state: state,
      stepsMap: stepsMap,
      stepPaths: stepPaths,
      gotoPreviousStep: gotoPreviousStep,
      resetState: resetState,
      getState: getState,
      goToNextStep: goToNextStep
    };
  }, [setStep, setStepPath, currentStep, previousStep, currentStepPath, currentStepIndex, previousStepIndex, showSteps, setState, state, stepsMap, stepPaths, gotoPreviousStep, resetState, getState, goToNextStep]);
});

const WizardContext = React__default.createContext(undefined);
const Wizard = ({ children, stepsMap, stepPaths, initialStep, initialPath, initialState }) => {
    const controller = useWizardController({ stepsMap, stepPaths, initialStep, initialPath, initialState });
    return (jsx$3(WizardContext.Provider, { value: controller, children: children }));
};
var Wizard$1 = React__default.memo(Wizard);

var useWizard = (function () {
  return useContext(WizardContext);
});

var styles$1b = {"ltr-enter":"animations-module_ltr-enter__3VsMe","ltr-absolute-enter":"animations-module_ltr-absolute-enter__3JTiT","ltr-enter-active":"animations-module_ltr-enter-active__31yqH","ltr-absolute-enter-active":"animations-module_ltr-absolute-enter-active__3Uub5","ltr-exit":"animations-module_ltr-exit__2HH3r","ltr-absolute-exit":"animations-module_ltr-absolute-exit__1Zlle","ltr-exit-active":"animations-module_ltr-exit-active__vQYze","ltr-absolute-exit-active":"animations-module_ltr-absolute-exit-active__lRExH","rtl-enter":"animations-module_rtl-enter__38eLp","rtl-absolute-enter":"animations-module_rtl-absolute-enter__1dEIP","rtl-enter-active":"animations-module_rtl-enter-active__3KxHt","rtl-absolute-enter-active":"animations-module_rtl-absolute-enter-active__1yl0i","rtl-exit":"animations-module_rtl-exit__15GWX","rtl-absolute-exit":"animations-module_rtl-absolute-exit__1HmNI","rtl-exit-active":"animations-module_rtl-exit-active__qAMky","rtl-absolute-exit-active":"animations-module_rtl-absolute-exit-active__3WMO8","top-to-bottom-enter":"animations-module_top-to-bottom-enter__2L9je","top-to-bottom-enter-active":"animations-module_top-to-bottom-enter-active__2vBUk","top-to-bottom-exit":"animations-module_top-to-bottom-exit__3Xfqq","top-to-bottom-exit-active":"animations-module_top-to-bottom-exit-active__3XBwj","fade-exit-active":"animations-module_fade-exit-active__2QdJp","fade-enter":"animations-module_fade-enter__2B6Yo","fade-enter-active":"animations-module_fade-enter-active__2e-Jd","height":"animations-module_height__2wOuz"};

var standardEasing = "cubic-bezier(.25,.8,.25,1)";
var standardDuration = 400;
var slideLtrClassNames = {
  enter: styles$1b['ltr-enter'],
  enterActive: styles$1b['ltr-enter-active'],
  exit: styles$1b['ltr-exit'],
  exitActive: styles$1b['ltr-exit-active']
};
var slideLtrAbsoluteClassNames = {
  enter: styles$1b['ltr-absolute-enter'],
  enterActive: styles$1b['ltr-absolute-enter-active'],
  exit: styles$1b['ltr-absolute-exit'],
  exitActive: styles$1b['ltr-absolute-exit-active']
};
var slideRtlClassNames = {
  enter: styles$1b['rtl-enter'],
  enterActive: styles$1b['rtl-enter-active'],
  exit: styles$1b['rtl-exit'],
  exitActive: styles$1b['rtl-exit-active']
};
var slideRtlAbsoluteClassNames = {
  enter: styles$1b['rtl-absolute-enter'],
  enterActive: styles$1b['rtl-absolute-enter-active'],
  exit: styles$1b['rtl-absolute-exit'],
  exitActive: styles$1b['rtl-absolute-exit-active']
};
var slideTopToBottomClassNames = {
  enter: styles$1b['top-to-bottom-enter'],
  enterActive: styles$1b['top-to-bottom-enter-active'],
  exit: styles$1b['top-to-bottom-exit'],
  exitActive: styles$1b['top-to-bottom-exit-active']
};
var fadeClassNames = {
  enter: styles$1b['fade-enter'],
  enterActive: styles$1b['fade-enter-active'],
  exit: styles$1b['fade-exit'],
  exitActive: styles$1b['fade-exit-active']
};
var height = styles$1b.height;

var clearEnter = function clearEnter(el) {
  if (el) {
    el.classList.remove(slideRtlAbsoluteClassNames.enter);
    el.classList.remove(slideLtrAbsoluteClassNames.enter);
    el.classList.remove(slideRtlAbsoluteClassNames.enterActive);
    el.classList.remove(slideLtrAbsoluteClassNames.enterActive);
  }
};
var clearExit = function clearExit(el) {
  if (el) {
    el.classList.remove(slideLtrAbsoluteClassNames.exit);
    el.classList.remove(slideRtlAbsoluteClassNames.exit);
    el.classList.remove(slideLtrAbsoluteClassNames.exitActive);
    el.classList.remove(slideRtlAbsoluteClassNames.exitActive);
  }
};
var WizardTransition = (function (_ref) {
  var renderedStep = _ref.renderedStep,
    renderedIndex = _ref.renderedIndex,
    className = _ref.className,
    children = _ref.children,
    style = _ref.style;
  var _useWizard = useWizard(),
    currentStep = _useWizard.currentStep,
    currentStepIndex = _useWizard.currentStepIndex,
    previousStepIndex = _useWizard.previousStepIndex;
  var contentRef = useRef(null);
  var stateRef = useRef({
    enter: false,
    exit: false
  });
  return /*#__PURE__*/React__default.createElement(Transition, {
    nodeRef: contentRef,
    onEnter: function onEnter() {
      if (stateRef.current.exit) {
        clearExit(contentRef.current);
        stateRef.current.exit = false;
      }
      var anim = renderedIndex > previousStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
      contentRef.current && contentRef.current.classList.add(anim.enter);
      stateRef.current.enter = true;
    },
    onEntering: function onEntering() {
      setTimeout(function () {
        if (!stateRef.current.enter) return;
        var anim = renderedIndex > previousStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
        contentRef.current && contentRef.current.classList.add(anim.enterActive);
      });
    },
    onEntered: function onEntered() {
      clearEnter(contentRef.current);
      stateRef.current.enter = false;
    },
    onExit: function onExit() {
      if (stateRef.current.enter) {
        clearEnter(contentRef.current);
        stateRef.current.enter = false;
      }
      var anim = renderedIndex > currentStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
      contentRef.current && contentRef.current.classList.add(anim.exit);
      stateRef.current.exit = true;
    },
    onExiting: function onExiting() {
      if (!stateRef.current.exit) return;
      var anim = renderedIndex > currentStepIndex ? slideRtlAbsoluteClassNames : slideLtrAbsoluteClassNames;
      contentRef.current && contentRef.current.classList.add(anim.exitActive);
    },
    onExited: function onExited() {
      clearExit(contentRef.current);
      stateRef.current.exit = false;
    },
    "in": currentStep === renderedStep,
    unmountOnExit: true,
    appear: renderedIndex !== 0,
    timeout: 400
  }, /*#__PURE__*/React__default.createElement("div", {
    className: className,
    ref: contentRef,
    style: style
  }, children));
});

var WizardStepTransitionRenderer = (function (_ref) {
  var className = _ref.className,
    children = _ref.children,
    style = _ref.style;
  var _useWizard = useWizard(),
    stepPaths = _useWizard.stepPaths,
    currentStepPath = _useWizard.currentStepPath,
    stepsMap = _useWizard.stepsMap;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, stepPaths[currentStepPath].map(function (_ref2, stepIndex) {
    var key = _ref2.key;
    return /*#__PURE__*/React__default.createElement(WizardTransition, {
      renderedIndex: stepIndex,
      renderedStep: key,
      className: className,
      style: style,
      key: key
    }, children(stepsMap[key]));
  }));
});

var styles$1a = {"base":"WizardHeader-module_base__rsIJH","label":"WizardHeader-module_label__39Reb","widgets-container":"WizardHeader-module_widgets-container__HZAaJ","close":"WizardHeader-module_close__25ljN","title":"WizardHeader-module_title__1L20Y","contents":"WizardHeader-module_contents__1J8Ij"};

// src/index.ts

// src/helpers.ts
var styleToObject = input => {
  if (typeof input !== "string") {
    return {};
  }
  return input.split(/ ?; ?/).reduce((acc, item) => {
    const [key, value] = item.split(/ ?: ?/).map((d, index) => index === 0 ? d.replace(/\s+/g, "") : d.trim());
    if (key && value) {
      const nextKey = key.replace(/(\w)-(\w)/g, (_$0, $1, $2) => `${$1}${$2.toUpperCase()}`);
      let nextValue = value.trim();
      if (!Number.isNaN(Number(value))) {
        nextValue = Number(value);
      }
      acc[key.startsWith("-") ? key : nextKey] = nextValue;
    }
    return acc;
  }, {});
};
function randomString$1(length = 6) {
  const characters = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";
  for (let index = length; index > 0; --index) {
    result += characters[Math.round(Math.random() * (characters.length - 1))];
  }
  return result;
}
var noTextChildNodes = ["br", "col", "colgroup", "dl", "hr", "iframe", "img", "input", "link", "menuitem", "meta", "ol", "param", "select", "table", "tbody", "tfoot", "thead", "tr", "ul", "wbr"];
var possibleStandardNames = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};

// src/index.ts
function getReactNode(node, options) {
  const {
    key,
    level,
    ...rest
  } = options;
  switch (node.nodeType) {
    case 1:
      {
        return React.createElement(parseName(node.nodeName), parseAttributes(node, key), parseChildren(node.childNodes, level, rest));
      }
    case 3:
      {
        const nodeText = node.nodeValue?.toString() ?? "";
        if (!rest.allowWhiteSpaces && /^\s+$/.test(nodeText) && !/[\u00A0\u202F]/.test(nodeText)) {
          return null;
        }
        if (!node.parentNode) {
          return nodeText;
        }
        const parentNodeName = node.parentNode.nodeName.toLowerCase();
        if (noTextChildNodes.includes(parentNodeName)) {
          if (/\S/.test(nodeText)) {
            console.warn(`A textNode is not allowed inside '${parentNodeName}'. Your text "${nodeText}" will be ignored`);
          }
          return null;
        }
        return nodeText;
      }
    case 8:
      {
        return null;
      }
    case 11:
      {
        return parseChildren(node.childNodes, level, options);
      }
    /* c8 ignore next 3 */
    default:
      {
        return null;
      }
  }
}
function parseAttributes(node, reactKey) {
  const attributes = {
    key: reactKey
  };
  if (node instanceof Element) {
    const nodeClassNames = node.getAttribute("class");
    if (nodeClassNames) {
      attributes.className = nodeClassNames;
    }
    [...node.attributes].forEach(d => {
      switch (d.name) {
        // this is manually handled above, so break;
        case "class":
          break;
        case "style":
          attributes[d.name] = styleToObject(d.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          attributes[possibleStandardNames[d.name] || d.name] = true;
          break;
        default:
          attributes[possibleStandardNames[d.name] || d.name] = d.value;
      }
    });
  }
  return attributes;
}
function parseChildren(childNodeList, level, options) {
  const children = [...childNodeList].map((node, index) => convertFromNode(node, {
    ...options,
    index,
    level: level + 1
  })).filter(Boolean);
  if (!children.length) {
    return null;
  }
  return children;
}
function parseName(nodeName) {
  if (/[a-z]+[A-Z]+[a-z]+/.test(nodeName)) {
    return nodeName;
  }
  return nodeName.toLowerCase();
}
function convert(input, options = {}) {
  if (typeof input === "string") {
    return convertFromString(input, options);
  }
  if (input instanceof Node) {
    return convertFromNode(input, options);
  }
  return null;
}
function convertFromNode(input, options = {}) {
  if (!input || !(input instanceof Node)) {
    return null;
  }
  const {
    actions = [],
    index = 0,
    level = 0,
    randomKey
  } = options;
  let node = input;
  let key = `${level}-${index}`;
  const result = [];
  if (randomKey && level === 0) {
    key = `${randomString$1()}-${key}`;
  }
  if (Array.isArray(actions)) {
    actions.forEach(action => {
      if (action.condition(node, key, level)) {
        if (typeof action.pre === "function") {
          node = action.pre(node, key, level);
          if (!(node instanceof Node)) {
            node = input;
            if (process.env.NODE_ENV !== "production") {
              console.warn("The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)");
            }
          }
        }
        if (typeof action.post === "function") {
          result.push(action.post(node, key, level));
        }
      }
    });
  }
  if (result.length) {
    return result;
  }
  return getReactNode(node, {
    key,
    level,
    ...options
  });
}
function convertFromString(input, options = {}) {
  if (!input || typeof input !== "string") {
    return null;
  }
  const {
    includeAllNodes = false,
    nodeOnly = false,
    selector = "body > *",
    type = "text/html"
  } = options;
  try {
    const parser = new DOMParser();
    const document = parser.parseFromString(input, type);
    if (includeAllNodes) {
      const {
        childNodes
      } = document.body;
      if (nodeOnly) {
        return childNodes;
      }
      return [...childNodes].map(node2 => convertFromNode(node2, options));
    }
    const node = document.querySelector(selector) || document.body.childNodes[0];
    if (!(node instanceof Node)) {
      throw new TypeError("Error parsing input");
    }
    if (nodeOnly) {
      return node;
    }
    return convertFromNode(node, options);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error(error);
    }
  }
  return null;
}

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __publicField$1 = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/config.ts
var CACHE_NAME = "react-inlinesvg";
var CACHE_MAX_RETRIES = 10;
var STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};

// src/modules/helpers.ts
function randomCharacter(character) {
  return character[Math.floor(Math.random() * character.length)];
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document?.createElement);
}
function isSupportedEnvironment() {
  return supportsInlineSVG() && typeof window !== "undefined" && window !== null;
}
function omit(input, ...filter) {
  const output = {};
  for (const key in input) {
    if ({}.hasOwnProperty.call(input, key)) {
      if (!filter.includes(key)) {
        output[key] = input[key];
      }
    }
  }
  return output;
}
function randomString(length) {
  const letters = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "1234567890";
  const charset = `${letters}${letters.toUpperCase()}${numbers}`;
  let R = "";
  for (let index = 0; index < length; index++) {
    R += randomCharacter(charset);
  }
  return R;
}
async function request(url, options) {
  const response = await fetch(url, options);
  const contentType = response.headers.get("content-type");
  const [fileType] = (contentType ?? "").split(/ ?; ?/);
  if (response.status > 299) {
    throw new Error("Not found");
  }
  if (!["image/svg+xml", "text/plain"].some(d => fileType.includes(d))) {
    throw new Error(`Content type isn't valid: ${fileType}`);
  }
  return response.text();
}
function sleep(seconds = 1) {
  return new Promise(resolve => {
    setTimeout(resolve, seconds * 1e3);
  });
}
function supportsInlineSVG() {
  if (!document) {
    return false;
  }
  const div = document.createElement("div");
  div.innerHTML = "<svg />";
  const svg = div.firstChild;
  return !!svg && svg.namespaceURI === "http://www.w3.org/2000/svg";
}

// src/modules/cache.ts
var CacheStore = class {
  constructor() {
    __publicField$1(this, "cacheApi");
    __publicField$1(this, "cacheStore");
    __publicField$1(this, "subscribers", []);
    __publicField$1(this, "isReady", false);
    this.cacheStore = /* @__PURE__ */new Map();
    let cacheName = CACHE_NAME;
    let usePersistentCache = false;
    if (canUseDOM()) {
      cacheName = window.REACT_INLINESVG_CACHE_NAME ?? CACHE_NAME;
      usePersistentCache = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window;
    }
    if (usePersistentCache) {
      caches.open(cacheName).then(cache => {
        this.cacheApi = cache;
      }).catch(error => {
        console.error(`Failed to open cache: ${error.message}`);
        this.cacheApi = void 0;
      }).finally(() => {
        this.isReady = true;
        const callbacks = [...this.subscribers];
        this.subscribers.length = 0;
        callbacks.forEach(callback => {
          try {
            callback();
          } catch (error) {
            console.error(`Error in CacheStore subscriber callback: ${error.message}`);
          }
        });
      });
    } else {
      this.isReady = true;
    }
  }
  onReady(callback) {
    if (this.isReady) {
      callback();
    } else {
      this.subscribers.push(callback);
    }
  }
  async get(url, fetchOptions) {
    await (this.cacheApi ? this.fetchAndAddToPersistentCache(url, fetchOptions) : this.fetchAndAddToInternalCache(url, fetchOptions));
    return this.cacheStore.get(url)?.content ?? "";
  }
  set(url, data) {
    this.cacheStore.set(url, data);
  }
  isCached(url) {
    return this.cacheStore.get(url)?.status === STATUS.LOADED;
  }
  async fetchAndAddToInternalCache(url, fetchOptions) {
    const cache = this.cacheStore.get(url);
    if (cache?.status === STATUS.LOADING) {
      await this.handleLoading(url, async () => {
        this.cacheStore.set(url, {
          content: "",
          status: STATUS.IDLE
        });
        await this.fetchAndAddToInternalCache(url, fetchOptions);
      });
      return;
    }
    if (!cache?.content) {
      this.cacheStore.set(url, {
        content: "",
        status: STATUS.LOADING
      });
      try {
        const content = await request(url, fetchOptions);
        this.cacheStore.set(url, {
          content,
          status: STATUS.LOADED
        });
      } catch (error) {
        this.cacheStore.set(url, {
          content: "",
          status: STATUS.FAILED
        });
        throw error;
      }
    }
  }
  async fetchAndAddToPersistentCache(url, fetchOptions) {
    const cache = this.cacheStore.get(url);
    if (cache?.status === STATUS.LOADED) {
      return;
    }
    if (cache?.status === STATUS.LOADING) {
      await this.handleLoading(url, async () => {
        this.cacheStore.set(url, {
          content: "",
          status: STATUS.IDLE
        });
        await this.fetchAndAddToPersistentCache(url, fetchOptions);
      });
      return;
    }
    this.cacheStore.set(url, {
      content: "",
      status: STATUS.LOADING
    });
    const data = await this.cacheApi?.match(url);
    if (data) {
      const content = await data.text();
      this.cacheStore.set(url, {
        content,
        status: STATUS.LOADED
      });
      return;
    }
    try {
      await this.cacheApi?.add(new Request(url, fetchOptions));
      const response = await this.cacheApi?.match(url);
      const content = (await response?.text()) ?? "";
      this.cacheStore.set(url, {
        content,
        status: STATUS.LOADED
      });
    } catch (error) {
      this.cacheStore.set(url, {
        content: "",
        status: STATUS.FAILED
      });
      throw error;
    }
  }
  async handleLoading(url, callback) {
    for (let retryCount = 0; retryCount < CACHE_MAX_RETRIES; retryCount++) {
      if (this.cacheStore.get(url)?.status !== STATUS.LOADING) {
        return;
      }
      await sleep(0.1);
    }
    await callback();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([key, value]) => ({
      [key]: value
    }));
  }
  async delete(url) {
    if (this.cacheApi) {
      await this.cacheApi.delete(url);
    }
    this.cacheStore.delete(url);
  }
  async clear() {
    if (this.cacheApi) {
      const keys = await this.cacheApi.keys();
      await Promise.allSettled(keys.map(key => this.cacheApi.delete(key)));
    }
    this.cacheStore.clear();
  }
};
function usePrevious(state) {
  const ref = useRef(void 0);
  useEffect(() => {
    ref.current = state;
  });
  return ref.current;
}
function getNode(options) {
  const {
    baseURL,
    content,
    description,
    handleError,
    hash,
    preProcessor,
    title,
    uniquifyIDs = false
  } = options;
  try {
    const svgText = processSVG(content, preProcessor);
    const node = convert(svgText, {
      nodeOnly: true
    });
    if (!node || !(node instanceof SVGSVGElement)) {
      throw new Error("Could not convert the src to a DOM Node");
    }
    const svg = updateSVGAttributes(node, {
      baseURL,
      hash,
      uniquifyIDs
    });
    if (description) {
      const originalDesc = svg.querySelector("desc");
      if (originalDesc?.parentNode) {
        originalDesc.parentNode.removeChild(originalDesc);
      }
      const descElement = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      descElement.innerHTML = description;
      svg.prepend(descElement);
    }
    if (typeof title !== "undefined") {
      const originalTitle = svg.querySelector("title");
      if (originalTitle?.parentNode) {
        originalTitle.parentNode.removeChild(originalTitle);
      }
      if (title) {
        const titleElement = document.createElementNS("http://www.w3.org/2000/svg", "title");
        titleElement.innerHTML = title;
        svg.prepend(titleElement);
      }
    }
    return svg;
  } catch (error) {
    return handleError(error);
  }
}
function processSVG(content, preProcessor) {
  if (preProcessor) {
    return preProcessor(content);
  }
  return content;
}
function updateSVGAttributes(node, options) {
  const {
    baseURL = "",
    hash,
    uniquifyIDs
  } = options;
  const replaceableAttributes = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"];
  const linkAttributes = ["href", "xlink:href"];
  const isDataValue = (name, value) => linkAttributes.includes(name) && (value ? !value.includes("#") : false);
  if (!uniquifyIDs) {
    return node;
  }
  [...node.children].forEach(d => {
    if (d.attributes?.length) {
      const attributes = Object.values(d.attributes).map(a => {
        const attribute = a;
        const match = /url\((.*?)\)/.exec(a.value);
        if (match?.[1]) {
          attribute.value = a.value.replace(match[0], `url(${baseURL}${match[1]}__${hash})`);
        }
        return attribute;
      });
      replaceableAttributes.forEach(r => {
        const attribute = attributes.find(a => a.name === r);
        if (attribute && !isDataValue(r, attribute.value)) {
          attribute.value = `${attribute.value}__${hash}`;
        }
      });
    }
    if (d.children.length) {
      return updateSVGAttributes(d, options);
    }
    return d;
  });
  return node;
}

// src/index.tsx
var cacheStore;
function ReactInlineSVG(props) {
  const {
    cacheRequests = true,
    children = null,
    description,
    fetchOptions,
    innerRef,
    loader = null,
    onError,
    onLoad,
    src,
    title,
    uniqueHash
  } = props;
  const [state, setState] = useReducer((previousState2, nextState) => ({
    ...previousState2,
    ...nextState
  }), {
    content: "",
    element: null,
    isCached: cacheRequests && cacheStore.isCached(props.src),
    status: STATUS.IDLE
  });
  const {
    content,
    element,
    isCached,
    status
  } = state;
  const previousProps = usePrevious(props);
  const previousState = usePrevious(state);
  const hash = useRef(uniqueHash ?? randomString(8));
  const isActive = useRef(false);
  const isInitialized = useRef(false);
  const handleError = useCallback(error => {
    if (isActive.current) {
      setState({
        status: error.message === "Browser does not support SVG" ? STATUS.UNSUPPORTED : STATUS.FAILED
      });
      onError?.(error);
    }
  }, [onError]);
  const handleLoad = useCallback((loadedContent, hasCache = false) => {
    if (isActive.current) {
      setState({
        content: loadedContent,
        isCached: hasCache,
        status: STATUS.LOADED
      });
    }
  }, []);
  const fetchContent = useCallback(async () => {
    const responseContent = await request(src, fetchOptions);
    handleLoad(responseContent);
  }, [fetchOptions, handleLoad, src]);
  const getElement = useCallback(() => {
    try {
      const node = getNode({
        ...props,
        handleError,
        hash: hash.current,
        content
      });
      const convertedElement = convert(node);
      if (!convertedElement || !isValidElement(convertedElement)) {
        throw new Error("Could not convert the src to a React element");
      }
      setState({
        element: convertedElement,
        status: STATUS.READY
      });
    } catch (error) {
      handleError(error);
    }
  }, [content, handleError, props]);
  const getContent = useCallback(async () => {
    const dataURI = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(src);
    let inlineSrc;
    if (dataURI) {
      inlineSrc = dataURI[1] ? window.atob(dataURI[2]) : decodeURIComponent(dataURI[2]);
    } else if (src.includes("<svg")) {
      inlineSrc = src;
    }
    if (inlineSrc) {
      handleLoad(inlineSrc);
      return;
    }
    try {
      if (cacheRequests) {
        const cachedContent = await cacheStore.get(src, fetchOptions);
        handleLoad(cachedContent, true);
      } else {
        await fetchContent();
      }
    } catch (error) {
      handleError(error);
    }
  }, [cacheRequests, fetchContent, fetchOptions, handleError, handleLoad, src]);
  const load = useCallback(async () => {
    if (isActive.current) {
      setState({
        content: "",
        element: null,
        isCached: false,
        status: STATUS.LOADING
      });
    }
  }, []);
  useEffect(() => {
    isActive.current = true;
    if (!canUseDOM() || isInitialized.current) {
      return void 0;
    }
    try {
      if (status === STATUS.IDLE) {
        if (!isSupportedEnvironment()) {
          throw new Error("Browser does not support SVG");
        }
        if (!src) {
          throw new Error("Missing src");
        }
        load();
      }
    } catch (error) {
      handleError(error);
    }
    isInitialized.current = true;
    return () => {
      isActive.current = false;
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(() => {
    if (!canUseDOM() || !previousProps) {
      return;
    }
    if (previousProps.src !== src) {
      if (!src) {
        handleError(new Error("Missing src"));
        return;
      }
      load();
    }
  }, [handleError, load, previousProps, src]);
  useEffect(() => {
    if (status === STATUS.LOADED) {
      getElement();
    }
  }, [status, getElement]);
  useEffect(() => {
    if (!canUseDOM() || !previousProps || previousProps.src !== src) {
      return;
    }
    if (previousProps.title !== title || previousProps.description !== description) {
      getElement();
    }
  }, [description, getElement, previousProps, src, title]);
  useEffect(() => {
    if (!previousState) {
      return;
    }
    switch (status) {
      case STATUS.LOADING:
        {
          if (previousState.status !== STATUS.LOADING) {
            getContent();
          }
          break;
        }
      case STATUS.LOADED:
        {
          if (previousState.status !== STATUS.LOADED) {
            getElement();
          }
          break;
        }
      case STATUS.READY:
        {
          if (previousState.status !== STATUS.READY) {
            onLoad?.(src, isCached);
          }
          break;
        }
    }
  }, [getContent, getElement, isCached, onLoad, previousState, src, status]);
  const elementProps = omit(props, "baseURL", "cacheRequests", "children", "description", "fetchOptions", "innerRef", "loader", "onError", "onLoad", "preProcessor", "src", "title", "uniqueHash", "uniquifyIDs");
  if (!canUseDOM()) {
    return loader;
  }
  if (element) {
    return cloneElement(element, {
      ref: innerRef,
      ...elementProps
    });
  }
  if ([STATUS.UNSUPPORTED, STATUS.FAILED].includes(status)) {
    return children;
  }
  return loader;
}
function InlineSVG(props) {
  if (!cacheStore) {
    cacheStore = new CacheStore();
  }
  const {
    loader
  } = props;
  const [isReady, setReady] = useState(cacheStore.isReady);
  useEffect(() => {
    if (isReady) {
      return;
    }
    cacheStore.onReady(() => {
      setReady(true);
    });
  }, [isReady]);
  if (!isReady) {
    return loader;
  }
  return /* @__PURE__ */React__default.createElement(ReactInlineSVG, {
    ...props
  });
}

var _desc$c, _path$b, _animateTransform;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
var SvgIcSmallSpinner = function SvgIcSmallSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$c || (_desc$c = /*#__PURE__*/React.createElement("desc", null, "Loading")), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M2.24 16C1.00289 16 -0.0160949 17.0077 0.156543 18.2327C0.490832 20.6048 1.35505 22.8815 2.69649 24.8891C4.45459 27.5203 6.95345 29.5711 9.87707 30.7821C12.8007 31.9931 16.0178 32.3099 19.1214 31.6926C22.2251 31.0752 25.0761 29.5513 27.3137 27.3137C29.5513 25.0761 31.0752 22.2251 31.6926 19.1214C32.3099 16.0177 31.9931 12.8007 30.7821 9.87707C29.5711 6.95345 27.5203 4.45459 24.8891 2.69649C22.8815 1.35505 20.6048 0.49083 18.2327 0.156541C17.0077 -0.0160976 16 1.00288 16 2.24V2.24C16 3.47712 17.0122 4.45805 18.226 4.6971C19.7104 4.98944 21.1301 5.57282 22.4002 6.42147C24.2946 7.6873 25.7712 9.48648 26.6431 11.5915C27.515 13.6965 27.7432 16.0128 27.2986 18.2474C26.8541 20.4821 25.757 22.5348 24.1459 24.1459C22.5348 25.757 20.4821 26.8541 18.2474 27.2986C16.0128 27.7431 13.6965 27.515 11.5915 26.6431C9.48648 25.7712 7.68731 24.2946 6.42147 22.4002C5.57282 21.1301 4.98944 19.7104 4.6971 18.226C4.45805 17.0122 3.47712 16 2.24 16V16Z",
    fill: "var(--icon-primary)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1.2s",
    repeatCount: "indefinite",
    type: "rotate",
    from: 0,
    to: 360
  })));
};

var styles$19 = {"default":"InlineLoader-module_default__3Hr9-","on-color":"InlineLoader-module_on-color__gouxI","inherit":"InlineLoader-module_inherit__261Sj","base":"InlineLoader-module_base__1tWxo"};

var InlineLoader = ({ color = "default", className, style }) => {
    return jsx$3(SvgIcSmallSpinner, { className: classNames(styles$19['base'], styles$19[color], className), style: style });
};

const getBaseClassName = ({ color, variant }) => {
    let baseClassName;
    if ((!variant) || variant === "square") {
        if (color === "secondary") {
            baseClassName = styles$1c.secondary;
        }
        else if (color === "destructive" || color === "error") {
            baseClassName = styles$1c.destructive;
        }
        else {
            baseClassName = styles$1c.primary;
        }
    }
    else if (variant === "text") {
        if (color === "secondary") {
            baseClassName = styles$1c['text-secondary'];
        }
        else {
            baseClassName = styles$1c['text'];
        }
    }
    else if (variant === "icon") {
        if (color === "secondary") {
            baseClassName = styles$1c['icon-secondary'];
        }
        else {
            baseClassName = styles$1c['icon'];
        }
    }
    else if (variant === "none") {
        baseClassName = styles$1c["none"];
    }
    return baseClassName;
};
const TextLoader = ({ originalText }) => {
    const ref = useRef(null);
    const [width, setWidth] = useState(null);
    useLayoutEffect(() => {
        setWidth(ref.current.getBoundingClientRect().width);
    }, [setWidth]);
    if (width === null) {
        return jsx$3("span", { ref: ref, children: originalText });
    }
    else {
        return jsx$3("span", { style: { minWidth: width || 0 }, className: styles$1c['text-loader'], children: jsx$3(InlineLoader, { className: styles$1c.loader }) });
    }
};
const handleIconButtonAria = (el) => {
    var _a, _b;
    if (((_a = el === null || el === void 0 ? void 0 : el.childNodes[0]) === null || _a === void 0 ? void 0 : _a.nodeName) === "svg" && ((_b = el.childNodes[0].childNodes[0]) === null || _b === void 0 ? void 0 : _b.nodeName) === "desc") {
        el.setAttribute("aria-label", el.childNodes[0].childNodes[0].textContent);
    }
};
const Button$2 = (_a) => {
    var { children, className, style, color, variant, large, disabled, isDisabled, isSubmitting, tooltip, submit, onClick, isActive, dataTestId } = _a, rest = __rest(_a, ["children", "className", "style", "color", "variant", "large", "disabled", "isDisabled", "isSubmitting", "tooltip", "submit", "onClick", "isActive", "dataTestId"]);
    const actualDisabled = isDisabled || disabled;
    const baseClassName = getBaseClassName({ color, variant });
    const _className = classNames(baseClassName, className, { [styles$1c.large]: large, "active": isActive });
    return jsxs("button", Object.assign({ "data-testid": dataTestId, "data-component": "Button", ref: variant === "icon" ? handleIconButtonAria : undefined, type: submit ? "submit" : "button", disabled: isSubmitting || actualDisabled, onClick: onClick, className: _className }, rest, { style: style, children: [isSubmitting ? ((variant === "text") ? jsx$3(TextLoader, { originalText: children }) : jsx$3(InlineLoader, { className: styles$1c.loader, color: "inherit" })) : children, tooltip && jsx$3(Tooltip$1, { children: tooltip })] }));
};

const DefaultLink = ({ to, className, style, children, disabled, onClick, dataTestId }) => {
    return jsx$3("a", { href: to, className: className, style: style, "data-testid": dataTestId, onClick: disabled ? e => {
            e.preventDefault();
        } : onClick, children: children });
};
let Link$2 = DefaultLink;
let NavLink = DefaultLink;
const setLinkProvider = ({ Link: _Link, NavLink: _NavLink }) => {
    Link$2 = _Link;
    NavLink = _NavLink;
};

const StyledLink = (_a) => {
    var { children, className, style, color, variant, large, disabled, isDisabled, tooltip, to, onClick } = _a, rest = __rest(_a, ["children", "className", "style", "color", "variant", "large", "disabled", "isDisabled", "tooltip", "to", "onClick"]);
    const baseClassName = getBaseClassName({ color, variant });
    const actualDisabled = disabled || isDisabled;
    const _className = classNames(baseClassName, className, { [styles$1c.large]: large });
    return jsxs(Link$2, Object.assign({ onClick: actualDisabled ? e => {
            e.preventDefault();
        } : onClick, disabled: actualDisabled, className: _className }, rest, { to: actualDisabled ? "" : to, style: style, children: [children, tooltip && jsx$3(Tooltip$1, { children: tooltip })] }));
};

var WizardHeader = function WizardHeader(_ref) {
  var logo = _ref.logo,
    Icon = _ref.Icon,
    label = _ref.label,
    children = _ref.children,
    onClose = _ref.onClose,
    closeLink = _ref.closeLink,
    Widgets = _ref.Widgets;
  return /*#__PURE__*/React__default.createElement("header", {
    className: styles$1a.base
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1a.label
  }, logo && /*#__PURE__*/React__default.createElement(InlineSVG, {
    src: logo
  }), Icon && /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement(Heading, {
    level: 20,
    color: "text-title"
  }, label)), children && /*#__PURE__*/React__default.createElement("div", {
    className: styles$1a.contents
  }, children), !children && /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1a['widgets-container']
  }, Widgets && /*#__PURE__*/React__default.createElement(Widgets, null), onClose && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "icon",
    color: "secondary",
    onClick: onClose,
    className: styles$1a.close
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), closeLink && /*#__PURE__*/React__default.createElement(StyledLink, {
    variant: "icon",
    color: "secondary",
    className: styles$1a.close,
    to: closeLink
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))));
};
var WizardHeader$1 = WizardHeader;

var WizardHeaderTitle = function WizardHeaderTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$1a.title
  }, children);
};
var WizardHeaderTitle$1 = WizardHeaderTitle;

var styles$18 = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","previous-step":"WizardContent-module_previous-step__Ukice","bgshimmer":"WizardContent-module_bgshimmer__2ZGrL"};

var styles$17 = {"white":"Layout-module_white__1l1j-","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","page":"Layout-module_page__uwxFk","breadcrumbs-container":"Layout-module_breadcrumbs-container__L83DN","content":"Layout-module_content__23chO","sticky-container":"Layout-module_sticky-container__2qxls","container":"Layout-module_container__2EaUW","wizard-content":"Layout-module_wizard-content__16NL9","breadcrumbsWidgets":"Layout-module_breadcrumbsWidgets__2dp-X","splitPane":"Layout-module_splitPane__2ZdoG","rigidGrid":"Layout-module_rigidGrid__sQb7U","grid":"Layout-module_grid__124qj","gap-xs":"Layout-module_gap-xs__3L86z","gap-sm":"Layout-module_gap-sm__1bSWN","gap-md":"Layout-module_gap-md__39C8t","gap-lg":"Layout-module_gap-lg__2Ws81","gap-xl":"Layout-module_gap-xl__1Jq-2","center-content":"Layout-module_center-content__3ffs8","grid-item":"Layout-module_grid-item__K7Ga5","grow":"Layout-module_grow__-wfvT","c_12":"Layout-module_c_12__11RpY","lg-1":"Layout-module_lg-1__3lijS","default":"Layout-module_default__2sMAG","lg-2":"Layout-module_lg-2__1_5Ob","lg-3":"Layout-module_lg-3__1Rsir","lg-4":"Layout-module_lg-4__79PRT","lg-5":"Layout-module_lg-5__3LhNn","lg-6":"Layout-module_lg-6__1jZ8r","lg-7":"Layout-module_lg-7__1bOj8","lg-8":"Layout-module_lg-8__2A9pF","lg-9":"Layout-module_lg-9__AtxMQ","lg-10":"Layout-module_lg-10__2cmTB","lg-11":"Layout-module_lg-11__S3bWq","lg-12":"Layout-module_lg-12__2hCo6","md-1":"Layout-module_md-1__1Dy27","md-2":"Layout-module_md-2__2yLlb","md-3":"Layout-module_md-3__1YyCX","md-4":"Layout-module_md-4__1fgAt","md-5":"Layout-module_md-5__3MSXk","md-6":"Layout-module_md-6__kZujs","md-7":"Layout-module_md-7__23RPg","md-8":"Layout-module_md-8__3xxQW","md-9":"Layout-module_md-9__1oI2N","md-10":"Layout-module_md-10__110zQ","md-11":"Layout-module_md-11__2uvjw","md-12":"Layout-module_md-12__fgKQw","sm-1":"Layout-module_sm-1__13kJ3","sm-2":"Layout-module_sm-2__348aF","sm-3":"Layout-module_sm-3__3KG0w","sm-4":"Layout-module_sm-4__3xpyo","sm-5":"Layout-module_sm-5__1Fijt","sm-6":"Layout-module_sm-6__2yLhK","sm-7":"Layout-module_sm-7__2ivnI","sm-8":"Layout-module_sm-8__ZasMJ","sm-9":"Layout-module_sm-9__3GiIk","sm-10":"Layout-module_sm-10__Xtno1","sm-11":"Layout-module_sm-11__1n16d","sm-12":"Layout-module_sm-12__26Im-","c_8":"Layout-module_c_8__KR-Xo","c_7":"Layout-module_c_7__3rXkh","column":"Layout-module_column__3K-4c","s_6":"Layout-module_s_6__2a61U","s_7":"Layout-module_s_7__1wy9Z","s_8":"Layout-module_s_8__2r2JF","s_9":"Layout-module_s_9__1qi0a","s_10":"Layout-module_s_10__22iX5","fixed-panel":"Layout-module_fixed-panel__2p9Ej","with-top-padding":"Layout-module_with-top-padding__17oPj","bgshimmer":"Layout-module_bgshimmer__3cgC9"};

var WizardContent = function WizardContent(_ref) {
  var children = _ref.children,
    onPreviousStep = _ref.onPreviousStep,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$17['wizard-content'], className),
    style: style
  }, onPreviousStep && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: styles$18["previous-step"],
    onClick: onPreviousStep
  }, /*#__PURE__*/React__default.createElement(ArrowLeftIcon, null), "Previous Step"), children);
};
var WizardContent$1 = WizardContent;

var styles$16 = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"WizardFooter-module_base__3gYPf","active":"WizardFooter-module_active__3IKWq"};

var classes = {};
var useBodyClass = function useBodyClass(className) {
  useEffect(function () {
    classes[className] = classes[className] ? classes[className] + 1 : 1;
    if (classes[className] === 1) {
      document.body.classList.add(className);
    }
    return function () {
      classes[className] = classes[className] - 1;
      if (classes[className] === 0) {
        document.body.classList.remove(className);
      }
    };
  }, [className]);
};
var useBodyClass$1 = useBodyClass;

var WizardFooter = function WizardFooter(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  useBodyClass$1(styles$16.active);
  return /*#__PURE__*/React__default.createElement("footer", {
    className: classNames(styles$16.base, className),
    style: style
  }, children);
};
var WizardFooter$1 = WizardFooter;

var styles$15 = {"base":"WizardSteps-module_base__zbsIw","overflow":"WizardSteps-module_overflow__SaRkn","steps":"WizardSteps-module_steps__2JTxR","left-arrow":"WizardSteps-module_left-arrow__1_rPJ","right-arrow":"WizardSteps-module_right-arrow__G9T3X","step":"WizardSteps-module_step__1yy4C","label":"WizardSteps-module_label__1S1Ji","index":"WizardSteps-module_index__1vxbf","done-icon":"WizardSteps-module_done-icon__KN3_p","active":"WizardSteps-module_active__1sLuF","scroll-duplicator":"WizardSteps-module_scroll-duplicator__2FA8p","hold-button":"WizardSteps-module_hold-button__23zXi"};

var _desc$b, _path$a;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
var SvgIcWizardStepArrowLeft = function SvgIcWizardStepArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$b || (_desc$b = /*#__PURE__*/React.createElement("desc", null, "Arrow left")), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M14.3265 20.7974C14.4376 20.6644 14.5 20.4843 14.5 20.2966C14.5 20.1089 14.4376 19.9289 14.3265 19.7959L6.92611 10.9826L14.3265 2.15229C14.4178 2.01592 14.4638 1.84421 14.4556 1.66998C14.4475 1.49575 14.3857 1.33122 14.2823 1.20783C14.1788 1.08444 14.0408 1.01084 13.8947 1.00111C13.7485 0.991369 13.6045 1.04617 13.4902 1.15504L5.67871 10.4648C5.62211 10.5296 5.57709 10.6073 5.54637 10.6934C5.51566 10.7794 5.49988 10.872 5.5 10.9656C5.50254 11.1539 5.56667 11.3336 5.67871 11.4663L13.4902 20.7803C13.5435 20.8482 13.6077 20.9026 13.6791 20.9403C13.7504 20.9781 13.8273 20.9983 13.9053 20.9999C13.9833 21.0015 14.0608 20.9844 14.1332 20.9496C14.2055 20.9148 14.2713 20.863 14.3265 20.7974Z",
    fill: "var(--icon-primary)",
    stroke: "var(--icon-primary)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
};

var _desc$a, _path$9;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
var SvgIcWizardStepArrowRight = function SvgIcWizardStepArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$a || (_desc$a = /*#__PURE__*/React.createElement("desc", null, "Arrow right")), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67347 1.20262C6.56238 1.33561 6.5 1.51567 6.5 1.70337C6.5 1.89108 6.56238 2.07114 6.67347 2.20413L14.0739 11.0174L6.67347 19.8477C6.58216 19.9841 6.5362 20.1558 6.54437 20.33C6.55253 20.5042 6.61426 20.6688 6.71774 20.7922C6.82123 20.9156 6.95922 20.9892 7.10534 20.9989C7.25146 21.0086 7.39547 20.9538 7.50984 20.845L15.3213 11.5352C15.3779 11.4704 15.4229 11.3927 15.4536 11.3066C15.4843 11.2206 15.5001 11.128 15.5 11.0344C15.4975 10.8461 15.4333 10.6664 15.3213 10.5337L7.50984 1.21967C7.45649 1.15179 7.39226 1.09738 7.32094 1.05966C7.24963 1.02194 7.17268 1.00169 7.09468 1.0001C7.01668 0.99851 6.9392 1.01562 6.86684 1.05041C6.79449 1.08519 6.72873 1.13696 6.67347 1.20262Z",
    fill: "var(--icon-primary)",
    stroke: "var(--icon-primary)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
};

var Step = function Step(_ref) {
  var index = _ref.index,
    label = _ref.label,
    isActive = _ref.isActive,
    onTabSelected = _ref.onTabSelected,
    done = _ref.done;
  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return onTabSelected(index);
    },
    className: classNames(styles$15["step"], _defineProperty$3({}, styles$15['active'], isActive)),
    disabled: !done
  }, done ? /*#__PURE__*/React__default.createElement(SuccessIcon, {
    className: classNames(styles$15["done-icon"])
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$15["index"])
  }, index), /*#__PURE__*/React__default.createElement(Heading, {
    level: 16,
    className: styles$15.label
  }, label));
};
var HoldButton = /*#__PURE__*/React__default.memo(function (_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    style = _ref2.style,
    onHold = _ref2.onHold,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "none" : _ref2$variant;
  var timeoutRef = useRef(null);
  var onHoldRef = useRef(function () {});
  onHoldRef.current = onHold;
  useEffect(function () {
    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
    }
  }, []);
  var capture = useCallback(function (e) {
    if (!timeoutRef.current) {
      onHoldRef.current();
      e.target.setPointerCapture(e.pointerId);
      timeoutRef.current = setInterval(function () {
        onHoldRef.current();
      }, 50);
    }
  }, []);
  var release = useCallback(function (e) {
    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
      e.target.releasePointerCapture(e.pointerId);
      timeoutRef.current = null;
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Button$2, {
    variant: variant,
    className: classNames(styles$15['hold-button'], className),
    style: style,
    onPointerDown: capture,
    onPointerUp: release
  }, children);
});
var WizardSteps = function WizardSteps(_ref3) {
  var steps = _ref3.steps,
    currentStepIndex = _ref3.currentStepIndex,
    setStep = _ref3.setStep,
    className = _ref3.className;
  var ref = useRef(null);
  var scrollDuplicatorRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    overflowDetails = _useState2[0],
    setOverflowDetails = _useState2[1];
  var isOverflow = !!overflowDetails;
  useLayoutEffect(function () {
    var handleResize = function handleResize() {
      if (ref.current && ref.current.parentNode) {
        var _ref$current$getBound = ref.current.getBoundingClientRect(),
          width = _ref$current$getBound.width;
        var _ref$current$parentNo = ref.current.parentNode.getBoundingClientRect(),
          parentWidth = _ref$current$parentNo.width;
        var _isOverflow = width > parentWidth;
        if (_isOverflow) {
          setOverflowDetails({
            thumbSize: parentWidth / width * 100
          });
          setTimeout(function () {
            handleScrollSpy();
          });
        } else {
          setOverflowDetails(null);
        }
      }
    };
    var handleScrollSpy = function handleScrollSpy() {
      if (scrollDuplicatorRef.current) {
        var percent = ref.current.parentNode.scrollLeft / ref.current.parentNode.clientWidth;
        scrollDuplicatorRef.current.childNodes[0].style.left = "".concat(percent * 100, "%");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    ref.current.parentNode.addEventListener("scroll", handleScrollSpy);
    return function () {
      window.removeEventListener("resize", handleResize);
      ref.current.parentNode.addEventListener("scroll", handleScrollSpy);
    };
  }, [setOverflowDetails]);
  useEffect(function () {
    if (overflowDetails) {
      var _ref$current$getBound2 = ref.current.getBoundingClientRect(),
        width = _ref$current$getBound2.width;
      var _ref$current$parentNo2 = ref.current.parentNode.getBoundingClientRect(),
        parentWidth = _ref$current$parentNo2.width;
      if (Math.abs(parentWidth / width * 100 - overflowDetails.thumbSize) > 0.5) {
        setOverflowDetails({
          thumbSize: parentWidth / width * 100
        });
      }
    }
  }, [overflowDetails, setOverflowDetails]);
  useEffect(function () {
    ref.current.childNodes[currentStepIndex].scrollIntoView();
  }, [currentStepIndex]);
  var leftArrowClick = useCallback(function () {
    ref.current.parentNode.scrollBy({
      top: 0,
      left: -10,
      behavior: 'smooth'
    });
  }, []);
  var rightArrowClick = useCallback(function () {
    ref.current.parentNode.scrollBy({
      top: 0,
      left: 10,
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isOverflow && /*#__PURE__*/React__default.createElement(HoldButton, {
    className: styles$15['left-arrow'],
    onHold: leftArrowClick
  }, /*#__PURE__*/React__default.createElement(SvgIcWizardStepArrowLeft, null)), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$15.base, className, _defineProperty$3({}, styles$15["overflow"], isOverflow))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$15.steps,
    ref: ref
  }, _$1.map(steps, function (_ref4, index) {
    var label = _ref4.label,
      key = _ref4.key;
    var isDone = index < currentStepIndex;
    return /*#__PURE__*/React__default.createElement(Step, {
      key: key,
      done: isDone,
      onTabSelected: function onTabSelected() {
        return setStep(key);
      },
      isActive: index === currentStepIndex,
      label: label,
      index: index + 1
    });
  }))), isOverflow && /*#__PURE__*/React__default.createElement(HoldButton, {
    className: styles$15['right-arrow'],
    onHold: rightArrowClick
  }, /*#__PURE__*/React__default.createElement(SvgIcWizardStepArrowRight, null)), isOverflow && /*#__PURE__*/React__default.createElement("div", {
    className: styles$15['scroll-duplicator'],
    ref: scrollDuplicatorRef,
    onClick: function onClick(e) {
      if (e.target === scrollDuplicatorRef.current) {
        var percent = e.nativeEvent.offsetX / scrollDuplicatorRef.current.clientWidth;
        ref.current.parentNode.scrollLeft = percent * ref.current.parentNode.clientWidth;
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "".concat(overflowDetails.thumbSize, "%")
    },
    onPointerDown: function onPointerDown(e) {
      scrollDuplicatorRef.current.childNodes[0].onpointermove = function (e) {
        ref.current.parentNode.scrollLeft = ref.current.parentNode.scrollLeft + e.movementX;
      };
      scrollDuplicatorRef.current.childNodes[0].setPointerCapture(e.pointerId);
    },
    onPointerUp: function onPointerUp(e) {
      scrollDuplicatorRef.current.childNodes[0].onpointermove = null;
      scrollDuplicatorRef.current.childNodes[0].releasePointerCapture(e.pointerId);
    }
  })));
};
var WizardSteps$1 = WizardSteps;

var styles$14 = {"base":"WidgetDivider-module_base__35_Me","small":"WidgetDivider-module_small__3gdAk WidgetDivider-module_base__35_Me","expand":"WidgetDivider-module_expand__1vQDg WidgetDivider-module_base__35_Me"};

const WidgetDivider = ({ expand }) => {
    return jsx$3("div", { className: expand ? styles$14.expand : styles$14.small });
};

var styles$13 = {"base":"SpaceBetween-module_base__3AC6s","column":"SpaceBetween-module_column__2MPrE SpaceBetween-module_base__3AC6s","xss":"SpaceBetween-module_xss__28sQ8","child":"SpaceBetween-module_child__1-E3M","includeBorder":"SpaceBetween-module_includeBorder__16Jas","xs":"SpaceBetween-module_xs__zIzJt","sm":"SpaceBetween-module_sm__3yqYh","md":"SpaceBetween-module_md__1P139","lg":"SpaceBetween-module_lg__3NOZu","xl":"SpaceBetween-module_xl__3EOHu","row":"SpaceBetween-module_row__3eEtZ SpaceBetween-module_base__3AC6s","align-center":"SpaceBetween-module_align-center__YHl1B","align-start":"SpaceBetween-module_align-start__2uZeK","align-end":"SpaceBetween-module_align-end__1OyRX","justify-center":"SpaceBetween-module_justify-center__2NMgK","justify-start":"SpaceBetween-module_justify-start__3xYx7","justify-end":"SpaceBetween-module_justify-end__2mG4n"};

const SpaceBetween = ({ children, direction = "row", size = "md", includeBorder, alignItems, justifyContent, }) => {
    return jsx$3("div", { className: classNames(styles$13[direction], styles$13[size], {
            [styles$13.includeBorder]: includeBorder,
            [styles$13[`align-${alignItems}`]]: !!alignItems,
            [styles$13[`justify-${justifyContent}`]]: !!justifyContent
        }), children: flattenChildren(children).map((child) => {
            if (!child) {
                return;
            }
            const key = typeof child === 'object' && 'key' in child ? child.key : undefined;
            return (jsx$3(Fragment$1, { children: jsx$3("div", { className: styles$13.child, children: child }) }, key));
        }) });
};

var styles$12 = {"input-children":"FormFieldInputNew-module_input-children__20IVA","input-container":"FormFieldInputNew-module_input-container__1-CEu","margin-bottom":"FormFieldInputNew-module_margin-bottom__1VGLp","label":"FormFieldInputNew-module_label__2K73W","disabled":"FormFieldInputNew-module_disabled__3dTsR","input-buttons":"FormFieldInputNew-module_input-buttons__211wo","form-field-input-button":"FormFieldInputNew-module_form-field-input-button__1uOaU","invalid":"FormFieldInputNew-module_invalid__PUyPB","input-wrapper":"FormFieldInputNew-module_input-wrapper__3uSvk","has-input-buttons":"FormFieldInputNew-module_has-input-buttons__25_Kr","inline-input":"FormFieldInputNew-module_inline-input__2mm-l","inline-loader":"FormFieldInputNew-module_inline-loader__13VYa","inline-loader-inside":"FormFieldInputNew-module_inline-loader-inside__1Mhyp FormFieldInputNew-module_inline-loader__13VYa","input-children-inside":"FormFieldInputNew-module_input-children-inside__9yJVf FormFieldInputNew-module_input-children-inside__9yJVf","label-children":"FormFieldInputNew-module_label-children__2_CFc","error":"FormFieldInputNew-module_error__3HqJB","icon-only":"FormFieldInputNew-module_icon-only__1SnLU","hide":"FormFieldInputNew-module_hide__9geKa","show":"FormFieldInputNew-module_show__1-awl","show-password-children":"FormFieldInputNew-module_show-password-children__1kf5x","char-counter":"FormFieldInputNew-module_char-counter__1xndi"};

var _excluded$f = ["Component", "isOptional", "label", "labelChildren", "useLabelMargin", "bottomMargin", "type", "name", "onChange", "value", "errorMessage", "showError", "errorType", "disabled", "maxChars", "charCount", "inputChildren", "inputButtons", "inputChildrenClassName", "inputChildrenStyle", "className", "style", "inputStyle", "labelStyle", "inputClassName", "labelClassName", "errorClassName", "errorStyle", "pending", "dataTestId", "ref"],
  _excluded2$5 = ["ref"],
  _excluded3$1 = ["ref"],
  _excluded4 = ["ref"],
  _excluded5 = ["ref"],
  _excluded6 = ["ref"],
  _excluded7 = ["ref"],
  _excluded8 = ["ref"];
var LabelChildren = function LabelChildren(_ref) {
  var isOptional = _ref.isOptional,
    labelChildren = _ref.labelChildren,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$12["label-children"]
  }, isOptional && /*#__PURE__*/React__default.createElement(Span, {
    italic: true,
    color: disabled ? "text-disabled" : undefined
  }, "Optional"), labelChildren);
};
var Error$1 = function Error(_ref2) {
  var showError = _ref2.showError,
    errorClassName = _ref2.errorClassName,
    errorStyle = _ref2.errorStyle,
    errorMessage = _ref2.errorMessage,
    _ref2$errorType = _ref2.errorType,
    errorType = _ref2$errorType === void 0 ? "error" : _ref2$errorType,
    _ref2$dataTestId = _ref2.dataTestId,
    dataTestId = _ref2$dataTestId === void 0 ? 'field-error' : _ref2$dataTestId;
  if (showError) {
    return /*#__PURE__*/React__default.createElement(FieldError, {
      className: classNames(styles$12.error, errorClassName),
      dataTestId: dataTestId,
      type: errorType,
      style: errorStyle,
      message: errorMessage
    });
  } else {
    return "";
  }
};
var Formidable = function Formidable(props) {
  var Component = props.Component,
    form = props.form,
    name = props.name,
    _onChange = props.onChange,
    _value = props.value,
    _errorMessage = props.errorMessage,
    _showError = props.showError,
    _onBlur = props.onBlur,
    useHandleFormChangeWrapper = props.useHandleFormChangeWrapper,
    ref = props.ref;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasFocused = _useState2[0],
    setWasFocused = _useState2[1];
  var _formHandler = formHandler({
      _onChange: _onChange,
      _value: _value,
      _errorMessage: _errorMessage,
      _showError: _showError,
      form: form,
      name: name,
      wasFocused: wasFocused,
      useHandleFormChangeWrapper: useHandleFormChangeWrapper
    }),
    onChange = _formHandler.onChange,
    value = _formHandler.value,
    errorMessage = _formHandler.errorMessage,
    showError = _formHandler.showError;
  var onBlur = useCallback(function (e) {
    setWasFocused(true);
    _onBlur && _onBlur(e);
  }, [setWasFocused, _onBlur]);
  return /*#__PURE__*/React__default.createElement(Component, _extends$j({
    onBlur: onBlur
  }, props, {
    form: undefined,
    onChange: onChange,
    value: value,
    errorMessage: errorMessage,
    showError: showError,
    ref: ref
  }));
};
var formHandler = function formHandler(_ref3) {
  var _onChange = _ref3._onChange,
    _value = _ref3._value,
    _showError = _ref3._showError,
    _errorMessage = _ref3._errorMessage,
    form = _ref3.form,
    name = _ref3.name,
    useHandleFormChangeWrapper = _ref3.useHandleFormChangeWrapper,
    wasFocused = _ref3.wasFocused;
  var onChange = _onChange;
  var value = _value;
  var errorMessage = _errorMessage;
  var showError = _showError;
  if (form && name) {
    value = _value || form.formState[name];
    onChange = _onChange || (useHandleFormChangeWrapper ? form.wrappedHandleFormChange(name) : form.handleFormChange);
    errorMessage = _errorMessage || form.formErrors[name];
    if (_$1.isUndefined(_showError)) {
      showError = (form.submissionAttempted || form.dirty[name] && wasFocused) && form.formErrors[name];
    }
  }
  return {
    onChange: onChange,
    value: value,
    errorMessage: errorMessage,
    showError: showError
  };
};
var CharCounter = function CharCounter(_ref4) {
  var length = _ref4.length,
    maxChars = _ref4.maxChars,
    disabled = _ref4.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$12["char-counter"]
  }, /*#__PURE__*/React__default.createElement(Span, {
    color: disabled ? "text-disabled" : undefined
  }, length, "/", maxChars));
};
var Base = function Base(props) {
  var Component = props.Component,
    isOptional = props.isOptional,
    label = props.label,
    labelChildren = props.labelChildren,
    useLabelMargin = props.useLabelMargin,
    _props$bottomMargin = props.bottomMargin,
    bottomMargin = _props$bottomMargin === void 0 ? true : _props$bottomMargin,
    type = props.type,
    name = props.name,
    onChange = props.onChange,
    value = props.value,
    errorMessage = props.errorMessage,
    showError = props.showError,
    errorType = props.errorType,
    disabled = props.disabled,
    maxChars = props.maxChars,
    charCount = props.charCount,
    inputChildren = props.inputChildren,
    inputButtons = props.inputButtons,
    inputChildrenClassName = props.inputChildrenClassName,
    inputChildrenStyle = props.inputChildrenStyle,
    className = props.className,
    style = props.style,
    inputStyle = props.inputStyle,
    labelStyle = props.labelStyle,
    inputClassName = props.inputClassName,
    labelClassName = props.labelClassName,
    errorClassName = props.errorClassName,
    errorStyle = props.errorStyle,
    pending = props.pending,
    dataTestId = props.dataTestId,
    ref = props.ref,
    rest = _objectWithoutProperties$2(props, _excluded$f);
  var handleInput = function handleInput(e) {
    if (maxChars && e.target.value.length > maxChars) {
      return;
    }
    onChange(e);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$12["input-container"], _defineProperty$3({}, styles$12["margin-bottom"], bottomMargin), className),
    style: style
  }, /*#__PURE__*/React__default.createElement(LabelChildren, {
    disabled: disabled,
    isOptional: isOptional,
    labelChildren: labelChildren
  }), /*#__PURE__*/React__default.createElement("label", {
    className: classNames(_defineProperty$3(_defineProperty$3({}, styles$12["disabled"], disabled), styles$12["invalid"], showError))
  }, label && /*#__PURE__*/React__default.createElement("span", {
    className: classNames(labelClassName, styles$12["label"]),
    style: labelStyle
  }, label), useLabelMargin && /*#__PURE__*/React__default.createElement("span", null, "\xA0"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$12['input-wrapper']
  }, /*#__PURE__*/React__default.createElement(Component, _extends$j({
    type: type ? type : "text",
    "data-testid": dataTestId
  }, rest, {
    name: name,
    value: value,
    ref: ref,
    onChange: handleInput,
    className: classNames(inputClassName, _defineProperty$3({}, styles$12['has-input-buttons'], !!inputButtons)),
    style: inputStyle,
    disabled: disabled
  })), pending && !inputButtons && /*#__PURE__*/React__default.createElement(InlineLoader, {
    className: styles$12["inline-loader"]
  }), inputChildren && !inputButtons && /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$12["input-children"], inputChildrenClassName),
    style: inputChildrenStyle
  }, inputChildren), inputButtons && /*#__PURE__*/React__default.createElement("div", {
    className: styles$12['input-buttons']
  }, pending && /*#__PURE__*/React__default.createElement(InlineLoader, {
    className: classNames(styles$12["inline-loader-inside"])
  }), inputChildren && /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$12["input-children-inside"], inputChildrenClassName),
    style: inputChildrenStyle
  }, inputChildren), inputButtons))), charCount && /*#__PURE__*/React__default.createElement(CharCounter, {
    length: (value === null || value === void 0 ? void 0 : value.length) || 0,
    maxChars: maxChars,
    disabled: disabled
  }), /*#__PURE__*/React__default.createElement(Error$1, {
    showError: showError,
    errorClassName: errorClassName,
    errorStyle: errorStyle,
    errorType: errorType,
    errorMessage: errorMessage
  }));
};
var FormFieldInline_ = /*#__PURE__*/React__default.memo(function (_ref5) {
  var ref = _ref5.ref,
    rest = _objectWithoutProperties$2(_ref5, _excluded2$5);
  return /*#__PURE__*/React__default.createElement(Base, _extends$j({}, rest, {
    Component: "input",
    ref: ref
  }));
});
var FormFieldInline = function FormFieldInline(_ref6) {
  var ref = _ref6.ref,
    rest = _objectWithoutProperties$2(_ref6, _excluded3$1);
  return /*#__PURE__*/React__default.createElement(Formidable, _extends$j({}, rest, {
    className: classNames(rest.className, styles$12['inline-input']),
    ref: ref,
    Component: FormFieldInline_
  }));
};
var FormFieldTextArea_ = /*#__PURE__*/React__default.memo(function (_ref7) {
  var ref = _ref7.ref,
    rest = _objectWithoutProperties$2(_ref7, _excluded4);
  return /*#__PURE__*/React__default.createElement(Base, _extends$j({}, rest, {
    Component: "textarea",
    ref: ref
  }));
});
var FormFieldTextArea = function FormFieldTextArea(_ref8) {
  var ref = _ref8.ref,
    rest = _objectWithoutProperties$2(_ref8, _excluded5);
  return /*#__PURE__*/React__default.createElement(Formidable, _extends$j({}, rest, {
    ref: ref,
    Component: FormFieldTextArea_
  }));
};
var FormFieldInput_ = /*#__PURE__*/React__default.memo(function (_ref9) {
  var ref = _ref9.ref,
    rest = _objectWithoutProperties$2(_ref9, _excluded6);
  return /*#__PURE__*/React__default.createElement(Base, _extends$j({}, rest, {
    Component: "input",
    ref: ref
  }));
});
var FormFieldPassword = /*#__PURE__*/React__default.memo(function (_ref10) {
  var ref = _ref10.ref,
    rest = _objectWithoutProperties$2(_ref10, _excluded7);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPassword = _useState4[0],
    setShowPassword = _useState4[1];
  return /*#__PURE__*/React__default.createElement(Base, _extends$j({}, rest, {
    type: showPassword ? "text" : "password",
    autoComplete: "new-password",
    Component: "input",
    inputChildrenClassName: styles$12['show-password-children'],
    inputChildren: /*#__PURE__*/React__default.createElement(Button$2, {
      tabIndex: -1,
      variant: "icon",
      color: "secondary",
      disabled: rest.disabled,
      onClick: function onClick(e) {
        setShowPassword(!showPassword);
        e.preventDefault();
        e.stopPropagation();
      }
    }, showPassword ? /*#__PURE__*/React__default.createElement(HideIcon, {
      className: styles$12.hide
    }) : /*#__PURE__*/React__default.createElement(ShowIcon, {
      className: styles$12.show
    })),
    ref: ref
  }));
});
var FormFieldInputNew = (function (_ref11) {
  var ref = _ref11.ref,
    rest = _objectWithoutProperties$2(_ref11, _excluded8);
  return /*#__PURE__*/React__default.createElement(Formidable, _extends$j({}, rest, {
    ref: ref,
    Component: rest.type === "password" ? FormFieldPassword : FormFieldInput_
  }));
});

var styles$11 = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"FormFieldUploadFile-module_base__1JTGW","input":"FormFieldUploadFile-module_input__1sddu"};

var propTypes = {exports: {}};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$2.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$2.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var focusable = 'a:not([disabled]), button:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
var saveToDisk = function saveToDisk(_ref) {
  var contents = _ref.contents,
    fileName = _ref.fileName,
    origin = _ref.origin;
  if (window['FS'] && window['FS'].event && origin !== null && origin !== void 0 && origin.name) {
    window['FS'].event('Download-CodeBox', {
      origin: origin.name,
      type: origin.type
    });
  }
  if (window.navigator.msSaveOrOpenBlob) {
    // EDGE workaround
    var blob = new Blob([decodeURIComponent(encodeURI(contents))], {
      type: 'text/csv;charset=utf-8;'
    });
    navigator.msSaveBlob(blob, fileName);
  } else {
    var element = document.createElement('a');
    element.setAttribute('href', "data:text/plain;charset=utf-8,".concat(encodeURIComponent(contents)));
    element.setAttribute('download', fileName);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
};

/**
 Extracts error from given error object
 Handles:
    - errors from axios (have e.response.data)
        => error can the the response payload, message property of response payload, or nested payload.error.message
    - error which is Error/object that has message property
    - error which is only a string
 * @returns {*|string}
 */
var extractErrorMessage = function extractErrorMessage(e) {
  var _e$response;
  if (!e) {
    return e;
  }
  var data = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data;
  if (_$1.isString(data)) {
    return data;
  } else if (_$1.isObject(data)) {
    if (data.message) {
      return data.message;
    } else if (_$1.isString(data === null || data === void 0 ? void 0 : data.error)) {
      return data.error;
    } else {
      var _data$error;
      return (data === null || data === void 0 || (_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.message) || "Unknown";
    }
  } else if (_$1.isString(e)) {
    return e;
  } else {
    return e.message;
  }
};
var readFileFromEvent = function readFileFromEvent(e) {
  return new Promise(function (resolve) {
    var file = e.target.files[0];
    if (file) {
      var fileReader = new FileReader();
      fileReader.readAsText(file);
      fileReader.onloadend = function () {
        resolve({
          fileName: file.name,
          contents: fileReader.result,
          fileSize: file.size
        });
      };
    }
  });
};
var matchPropType = function matchPropType(propType) {
  var isRequired = false;
  var type = _$1.findKey(PropTypes, function (val) {
    if (propType === val.isRequired) {
      isRequired = true;
      return true;
    } else {
      return propType === val;
    }
  }) || "uknown";
  return {
    type: type,
    isRequired: isRequired
  };
};

var _excluded$e = ["form", "name", "hideText", "disabled", "showError"];
var FormFieldUploadFile = (function (_ref) {
  var _form$formState$name;
  var form = _ref.form,
    name = _ref.name,
    hideText = _ref.hideText,
    disabled = _ref.disabled,
    _showError = _ref.showError,
    rest = _objectWithoutProperties$2(_ref, _excluded$e);
  var handleFormChange = form.handleFormChange;
  var showError = !_$1.isUndefined(_showError) ? _showError : form.submissionAttempted && form.formErrors[name];
  var readFile = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var file;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return readFileFromEvent(e);
          case 2:
            file = _context.sent;
            handleFormChange(file, {
              name: name
            });
            e.target.value = '';
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [handleFormChange]);
  return /*#__PURE__*/React__default.createElement(FormFieldInputNew, _extends$j({}, rest, {
    showError: showError,
    form: form,
    value: ((_form$formState$name = form.formState[name]) === null || _form$formState$name === void 0 ? void 0 : _form$formState$name.fileName) || "",
    name: name,
    disabled: disabled,
    type: "text",
    readOnly: true,
    inputClassName: disabled || showError ? undefined : styles$11["input"],
    inputButtons: /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles$12["form-field-input-button"], styles$11["base"], _defineProperty$3({}, styles$12["icon-only"], hideText))
    }, /*#__PURE__*/React__default.createElement("input", {
      disabled: disabled,
      type: "file",
      onChange: readFile
    }), /*#__PURE__*/React__default.createElement(UploadIcon, null), !hideText && /*#__PURE__*/React__default.createElement("span", {
      className: styles$11['label']
    }, "Upload"))
  }));
});

var styles$10 = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"OptionalGroup-module_base__2kC5t","header":"OptionalGroup-module_header__2Up9X","slider-chevron":"OptionalGroup-module_slider-chevron__3JmJF","animation":"OptionalGroup-module_animation__1nZx3"};

var styles$$ = {"base":"TransitionChevron-module_base__1gXdh","icon-on-color":"TransitionChevron-module_icon-on-color__3QW1Y","icon-secondary":"TransitionChevron-module_icon-secondary__3Ef6e","icon-primary":"TransitionChevron-module_icon-primary__H2Z24","icon-tertiary":"TransitionChevron-module_icon-tertiary__3tkoZ","primary":"TransitionChevron-module_primary__I_r_8","text":"TransitionChevron-module_text__qLFpS","grey":"TransitionChevron-module_grey__1Qpwj","grey-5":"TransitionChevron-module_grey-5__26WGl","thin":"TransitionChevron-module_thin__C_vqJ","left":"TransitionChevron-module_left__3p-1g","right":"TransitionChevron-module_right__3UqRr","disabled":"TransitionChevron-module_disabled__1Ep17","wide":"TransitionChevron-module_wide__2ZSEE","left-active":"TransitionChevron-module_left-active__3zLQ9","right-active":"TransitionChevron-module_right-active__3Minj","medium":"TransitionChevron-module_medium__3NmiF"};

/**
 * colors: icon-primary, icon-secondary, icon-tertiary, icon-on-color, disabled
 * the original colors still exist but are deprecated (primary, text, grey, grey-5)
 */
var TransitionChevron = /*#__PURE__*/React__default.memo(function (_ref) {
  var isActive = _ref.isActive,
    className = _ref.className,
    style = _ref.style,
    color = _ref.color,
    thin = _ref.thin,
    wide = _ref.wide,
    medium = _ref.medium;
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(styles$$['base'], className, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$$[color], color), styles$$.thin, thin), styles$$.wide, wide), styles$$.medium, medium)),
    style: style
  }, /*#__PURE__*/React__default.createElement("span", {
    className: classNames(styles$$['left'], _defineProperty$3({}, styles$$['left-active'], isActive))
  }), /*#__PURE__*/React__default.createElement("span", {
    className: classNames(styles$$['right'], _defineProperty$3({}, styles$$['right-active'], isActive))
  }));
});

var Collapse$2 = {};

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$2(obj);
}
Object.defineProperty(Collapse$2, "__esModule", {
  value: true
});
Collapse$2.Collapse = void 0;
var _react$1 = _interopRequireDefault$1(React__default);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$2(o, p);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self);
}
function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Collapse$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$1(Collapse, _React$Component);
  var _super = _createSuper$1(Collapse);
  function Collapse(props) {
    var _this;
    _classCallCheck$1(this, Collapse);
    _this = _super.call(this, props);
    _defineProperty$2(_assertThisInitialized$2(_this), "timeout", undefined);
    _defineProperty$2(_assertThisInitialized$2(_this), "container", undefined);
    _defineProperty$2(_assertThisInitialized$2(_this), "content", undefined);
    _defineProperty$2(_assertThisInitialized$2(_this), "onResize", function () {
      clearTimeout(_this.timeout);
      if (!_this.container || !_this.content) {
        return;
      }
      var _this$props = _this.props,
        isOpened = _this$props.isOpened,
        checkTimeout = _this$props.checkTimeout;
      var containerHeight = Math.floor(_this.container.clientHeight);
      var contentHeight = Math.floor(_this.content.clientHeight);
      var isFullyOpened = isOpened && Math.abs(contentHeight - containerHeight) <= 1;
      var isFullyClosed = !isOpened && Math.abs(containerHeight) <= 1;
      if (isFullyOpened || isFullyClosed) {
        _this.onRest({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      } else {
        _this.onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
        _this.timeout = setTimeout(function () {
          return _this.onResize();
        }, checkTimeout);
      }
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onRest", function (_ref) {
      var isFullyOpened = _ref.isFullyOpened,
        isFullyClosed = _ref.isFullyClosed,
        isOpened = _ref.isOpened,
        containerHeight = _ref.containerHeight,
        contentHeight = _ref.contentHeight;
      if (!_this.container || !_this.content) {
        return;
      }
      var hasOpened = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var hasClosed = !isOpened && _this.container.style.height === '0px';
      if (hasOpened || hasClosed) {
        _this.container.style.overflow = isOpened ? 'initial' : 'hidden';
        _this.container.style.height = isOpened ? 'auto' : '0px';
        var onRest = _this.props.onRest;
        if (onRest) {
          onRest({
            isFullyOpened: isFullyOpened,
            isFullyClosed: isFullyClosed,
            isOpened: isOpened,
            containerHeight: containerHeight,
            contentHeight: contentHeight
          });
        }
      }
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onWork", function (_ref2) {
      var isFullyOpened = _ref2.isFullyOpened,
        isFullyClosed = _ref2.isFullyClosed,
        isOpened = _ref2.isOpened,
        containerHeight = _ref2.containerHeight,
        contentHeight = _ref2.contentHeight;
      if (!_this.container || !_this.content) {
        return;
      }
      var isOpenining = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var isClosing = !isOpened && _this.container.style.height === '0px';
      if (isOpenining || isClosing) {
        // No need to do any work
        return;
      }
      _this.container.style.overflow = 'hidden';
      _this.container.style.height = isOpened ? "".concat(contentHeight, "px") : '0px';
      var onWork = _this.props.onWork;
      if (onWork) {
        onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      }
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onRefContainer", function (container) {
      _this.container = container;
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onRefContent", function (content) {
      _this.content = content;
    });
    if (props.initialStyle) {
      _this.initialStyle = props.initialStyle;
    } else {
      _this.initialStyle = props.isOpened ? {
        height: 'auto',
        overflow: 'initial'
      } : {
        height: '0px',
        overflow: 'hidden'
      };
    }
    return _this;
  }
  _createClass$1(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
        theme = _this$props2.theme,
        isOpened = _this$props2.isOpened,
        children = _this$props2.children;
      return children !== nextProps.children || isOpened !== nextProps.isOpened || Object.keys(theme).some(function (c) {
        return theme[c] !== nextProps.theme[c];
      });
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      if (!this.container || !this.content) {
        return null;
      }
      if (this.container.style.height === 'auto') {
        var contentHeight = this.content.clientHeight;
        this.container.style.height = "".concat(contentHeight, "px");
      }
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        theme = _this$props3.theme,
        children = _this$props3.children,
        isOpened = _this$props3.isOpened;
      return /*#__PURE__*/_react$1["default"].createElement("div", {
        ref: this.onRefContainer,
        className: theme.collapse,
        style: this.initialStyle,
        "aria-hidden": !isOpened
      }, /*#__PURE__*/_react$1["default"].createElement("div", {
        ref: this.onRefContent,
        className: theme.content
      }, children));
    }
  }]);
  return Collapse;
}(_react$1["default"].Component);
Collapse$2.Collapse = Collapse$1;
_defineProperty$2(Collapse$1, "defaultProps", {
  theme: {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
  },
  initialStyle: undefined,
  onRest: undefined,
  onWork: undefined,
  checkTimeout: 50
});

var UnmountClosed$2 = {};

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$1(obj);
}
Object.defineProperty(UnmountClosed$2, "__esModule", {
  value: true
});
UnmountClosed$2.UnmountClosed = void 0;
var _react = _interopRequireDefault(React__default);
var _Collapse = Collapse$2;
var _excluded$d = ["isOpened"],
  _excluded2$4 = ["isOpened"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$d.apply(this, arguments);
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self);
}
function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var UnmountClosed$1 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);
  var _super = _createSuper(UnmountClosed);
  function UnmountClosed(props) {
    var _this;
    _classCallCheck(this, UnmountClosed);
    _this = _super.call(this, props);
    _defineProperty$1(_assertThisInitialized$1(_this), "onWork", function (_ref) {
      var isOpened = _ref.isOpened,
        rest = _objectWithoutProperties$1(_ref, _excluded$d);
      _this.setState({
        isResting: false,
        isOpened: isOpened
      });
      var onWork = _this.props.onWork;
      if (onWork) {
        onWork(_objectSpread$2({
          isOpened: isOpened
        }, rest));
      }
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "onRest", function (_ref2) {
      var isOpened = _ref2.isOpened,
        rest = _objectWithoutProperties$1(_ref2, _excluded2$4);
      _this.setState({
        isResting: true,
        isOpened: isOpened,
        isInitialRender: false
      });
      var onRest = _this.props.onRest;
      if (onRest) {
        onRest(_objectSpread$2({
          isOpened: isOpened
        }, rest));
      }
    });
    _defineProperty$1(_assertThisInitialized$1(_this), "getInitialStyle", function () {
      var _this$state = _this.state,
        isOpened = _this$state.isOpened,
        isInitialRender = _this$state.isInitialRender;
      if (isInitialRender) {
        return isOpened ? {
          height: 'auto',
          overflow: 'initial'
        } : {
          height: '0px',
          overflow: 'hidden'
        };
      }
      return {
        height: '0px',
        overflow: 'hidden'
      };
    });
    _this.state = {
      isResting: true,
      isOpened: props.isOpened,
      isInitialRender: true
    };
    return _this;
  }
  _createClass(UnmountClosed, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpened = this.props.isOpened;
      if (prevProps.isOpened !== isOpened) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isResting: false,
          isOpened: isOpened,
          isInitialRender: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        isResting = _this$state2.isResting,
        isOpened = _this$state2.isOpened;
      return isResting && !isOpened ? null : /*#__PURE__*/_react["default"].createElement(_Collapse.Collapse, _extends$d({}, this.props, {
        initialStyle: this.getInitialStyle(),
        onWork: this.onWork,
        onRest: this.onRest
      }));
    }
  }]);
  return UnmountClosed;
}(_react["default"].PureComponent);
UnmountClosed$2.UnmountClosed = UnmountClosed$1;
_defineProperty$1(UnmountClosed$1, "defaultProps", {
  onWork: undefined,
  onRest: undefined
});

var _require = Collapse$2,
  Collapse = _require.Collapse;
var _require2 = UnmountClosed$2,
  UnmountClosed = _require2.UnmountClosed; // Default export

var lib = UnmountClosed; // Extra "named exports"

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

var OptionalGroup = (function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? false : _ref$defaultValue,
    contentClassName = _ref.contentClassName,
    title = _ref.title,
    Title = _ref.Title,
    _ref$Component = _ref.Component,
    Component = _ref$Component === void 0 ? "button" : _ref$Component,
    optional = _ref.optional,
    _onClick = _ref.onClick,
    _isOpen = _ref.isOpen,
    id = _ref.id;
  var hasParent = !!_onClick;
  var items = children ? _$1.isArray(children) ? children : [children] : null;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var pOpen = _onClick ? _isOpen : isOpen;
  var _onClick2 = function onClick() {
    _onClick ? _onClick(id) : setIsOpen(!isOpen);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$10.base, className),
    style: style
  }, /*#__PURE__*/React__default.createElement(Component, {
    className: styles$10.header,
    onClick: function onClick(e) {
      return _onClick2();
    }
  }, Title && /*#__PURE__*/React__default.createElement(Title, {
    isOpen: pOpen
  }), title && title, optional && /*#__PURE__*/React__default.createElement("span", {
    className: typography.i
  }, "(Optional)"), /*#__PURE__*/React__default.createElement(TransitionChevron, {
    isActive: pOpen,
    className: styles$10['slider-chevron']
  })), /*#__PURE__*/React__default.createElement(lib.UnmountClosed, {
    isOpened: pOpen,
    theme: {
      collapse: styles$10['animation']
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: contentClassName
  }, !hasParent && children, hasParent && items && items.map(function (child, index) {
    if (child) {
      var clone = /*#__PURE__*/React__default.cloneElement(child, {
        close: _onClick2
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: index
      }, clone);
    } else {
      return "";
    }
  }))));
});

var styles$_ = {};

var _excluded$c = ["children", "className"];
var OptionalGroupAccordion = (function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties$2(_ref, _excluded$c);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    openItem = _useState2[0],
    setOpenItem = _useState2[1];
  var items = _$1.isArray(children) ? children : [children];
  var onItemClick = function onItemClick(itemId) {
    itemId === openItem ? setOpenItem(null) : setOpenItem(itemId);
  };
  return /*#__PURE__*/React__default.createElement("div", _extends$j({
    className: classNames(styles$_["container"], className)
  }, props), items && items.map(function (child, index) {
    if (!child) {
      return;
    }
    var isOpen = 'isOpen' in child.props ? child.props.isOpen : openItem === index;
    var clone = /*#__PURE__*/React__default.cloneElement(child, {
      id: index,
      onClick: function onClick() {
        return onItemClick(index);
      },
      isOpen: isOpen
    });
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, clone);
  }));
});

var styles$Z = {"base":"Checkbox-module_base__2hR7R","disabled":"Checkbox-module_disabled__2SXVF","error":"Checkbox-module_error__1zcbK","border":"Checkbox-module_border__3bwKR","active":"Checkbox-module_active__3zKs8","bg":"Checkbox-module_bg__14Uax","check":"Checkbox-module_check__3noO6","errorWrapper":"Checkbox-module_errorWrapper__1YiX-","bgshimmer":"Checkbox-module_bgshimmer__8_JVA"};

const CheckboxImage = () => {
    return jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsx$3("rect", { width: "16", height: "16", className: styles$Z['bg'] }), jsx$3("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "1.5", className: styles$Z['border'] }), jsx$3("path", { d: "M2.59996 7.57717C2.26787 7.9118 2.26787 8.45165 2.59996 8.78628L5.57564 11.7848C5.96677 12.1789 6.60411 12.1789 6.99524 11.7848L13.4005 5.3304C13.7327 4.99566 13.7336 4.45593 13.4026 4.12V4.12C13.0663 3.77872 12.5161 3.77774 12.1786 4.11782L6.28544 10.0562L3.81749 7.57631C3.48165 7.23885 2.93532 7.23924 2.59996 7.57717V7.57717Z", stroke: "none", className: styles$Z['check'] })] });
};
const PartialImage = () => {
    return jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsx$3("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "1.5", className: styles$Z['bg'] }), jsx$3("rect", { x: "3", y: "7", width: "10", height: "2", rx: "1", className: styles$Z['check'] }), jsx$3("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "1.5", className: styles$Z['border'] })] });
};
var Checkbox = React__default.memo((_a) => {
    var { form, isPartial, name, value, style, onChange: _onChange, checked: _checked, disabled, isDisabled, className, children, showError: _showError, hideErrorMessage, errorStyle, dataTestId } = _a, rest = __rest(_a, ["form", "isPartial", "name", "value", "style", "onChange", "checked", "disabled", "isDisabled", "className", "children", "showError", "hideErrorMessage", "errorStyle", "dataTestId"]);
    let onChange = _onChange;
    let checked = _checked;
    let showError = _showError;
    const actualDisabled = disabled || isDisabled;
    if (form && name) {
        checked = checked || form.formState[name];
        onChange = onChange || form.handleFormChange;
        if (!_showError) {
            showError = (form.submissionAttempted || (form.dirty[name])) && form.formErrors[name];
        }
    }
    const Image = isPartial ? PartialImage : CheckboxImage;
    return jsxs("div", { "data-component": "Checkbox", className: classNames(styles$Z["base"], className, {
            [styles$Z["disabled"]]: actualDisabled,
            [styles$Z["active"]]: checked || isPartial,
            [styles$Z["error"]]: showError
        }), style: style, "data-testid": dataTestId, children: [jsxs("label", { children: [jsx$3("input", Object.assign({ checked: checked, onChange: onChange, readOnly: !onChange, type: "checkbox", name: name, value: value === undefined ? name : value, disabled: actualDisabled }, rest)), jsx$3(Image, {}), children] }), showError && !hideErrorMessage && jsx$3(FieldError, { className: classNames(styles$Z.errorWrapper), style: errorStyle, message: showError, dataTestId: dataTestId && `${dataTestId}-error` })] });
});

var styles$Y = {"base":"RadioButton-module_base__3RRtu","disabled":"RadioButton-module_disabled__1pmYt","circle":"RadioButton-module_circle__1Cofh","inner-circle":"RadioButton-module_inner-circle__1T85C","outer-circle":"RadioButton-module_outer-circle__6mojA","active":"RadioButton-module_active__XHBt3","error":"RadioButton-module_error__2D72_","selection":"RadioButton-module_selection__QAGZP RadioButton-module_base__3RRtu","label":"RadioButton-module_label__2s6LL","tag":"RadioButton-module_tag__17vYb","radio-wrapper":"RadioButton-module_radio-wrapper__ikA2H","selection-children":"RadioButton-module_selection-children__2XnqM","default":"RadioButton-module_default__D4s34 RadioButton-module_base__3RRtu"};

var styles$X = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"Tag-module_base__1nVjG","chart-1":"Tag-module_chart-1__hVilB","chart-2":"Tag-module_chart-2__2cLfW","chart-3":"Tag-module_chart-3__3vmvW","chart-9":"Tag-module_chart-9__7o7xJ","disabled":"Tag-module_disabled__3_mxL","tag-new-bg":"Tag-module_tag-new-bg__32aC9","tag-1-bg":"Tag-module_tag-1-bg__3YoT0"};

const Tag = ({ children, className, style, color = "chart-1", dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$X['base'], styles$X[color], className), style: style, "data-testid": dataTestId, children: children });
};

var _excluded$b = ["value", "label", "description", "tagText", "tagColor", "onChange", "checked", "isDisabled", "className", "tooltip", "style", "children"],
  _excluded2$3 = ["form", "name", "value", "children", "onChange", "checked", "disabled", "isDisabled", "className", "tooltip", "style"];
var RadioCircle = function RadioCircle() {
  return /*#__PURE__*/React__default.createElement("svg", {
    overflow: "visible",
    className: styles$Y["circle"]
  }, /*#__PURE__*/React__default.createElement("circle", {
    stroke: "1",
    cx: "8.5",
    cy: "8.5",
    r: "8",
    className: styles$Y["outer-circle"]
  }), /*#__PURE__*/React__default.createElement("circle", {
    stroke: "none",
    cx: "8.5",
    cy: "8.5",
    r: "1",
    className: classNames(styles$Y["inner-circle"])
  }));
};
var RadioSelectionGroupContext = /*#__PURE__*/React__default.createContext(null);
var RadioSelectionGroup = function RadioSelectionGroup(_ref) {
  var form = _ref.form,
    name = _ref.name,
    children = _ref.children;
  var idRef = useRef(crypto.randomUUID());
  var ref = useRef();
  useLayoutEffect(function () {
    var accordionTableHeaderStyle = window.document.createElement('style');
    accordionTableHeaderStyle.type = 'text/css';
    getStyleRoot().appendChild(accordionTableHeaderStyle);
    var max = 0;
    var _iterator = _createForOfIteratorHelper(ref.current.getElementsByClassName("rsg-tag-".concat(idRef.current))),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var card = _step.value;
        max = Math.max(card.clientWidth, max);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    accordionTableHeaderStyle.innerHTML = ".rsg-tag-".concat(idRef.current, " { width: ").concat(max, "px;  }");
    return function () {
      getStyleRoot().removeChild(accordionTableHeaderStyle);
    };
  }, [children, idRef]);
  var controller = useMemo(function () {
    return {
      form: form,
      name: name,
      id: idRef.current
    };
  }, [form, name, idRef]);
  return /*#__PURE__*/React__default.createElement(RadioSelectionGroupContext.Provider, {
    value: controller
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$Y['selection-group'],
    ref: ref
  }, children));
};
var RadioSelection = function RadioSelection(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    description = _ref2.description,
    tagText = _ref2.tagText,
    tagColor = _ref2.tagColor,
    _onChange = _ref2.onChange,
    _checked = _ref2.checked,
    isDisabled = _ref2.isDisabled,
    className = _ref2.className,
    tooltip = _ref2.tooltip,
    style = _ref2.style,
    children = _ref2.children,
    rest = _objectWithoutProperties$2(_ref2, _excluded$b);
  var _useContext = useContext(RadioSelectionGroupContext),
    form = _useContext.form,
    name = _useContext.name,
    id = _useContext.id;
  var onChange = _onChange;
  var checked = _checked;
  var showError = false;
  if (form && name) {
    checked = checked || form.formState[name] === value;
    onChange = onChange || form.handleFormChange;
    showError = form.submissionAttempted && form.formErrors[name];
  }
  return /*#__PURE__*/React__default.createElement("label", {
    className: classNames(styles$Y["selection"], _defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$Y["disabled"], isDisabled), styles$Y["active"], checked), styles$Y["error"], showError), className),
    style: style
  }, /*#__PURE__*/React__default.createElement("input", _extends$j({
    checked: checked,
    onChange: onChange,
    type: "radio",
    name: name,
    value: value,
    disabled: isDisabled
  }, rest)), /*#__PURE__*/React__default.createElement("div", {
    className: styles$Y['radio-wrapper']
  }, /*#__PURE__*/React__default.createElement(RadioCircle, null)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, null, tooltip), tagText && /*#__PURE__*/React__default.createElement(Tag, {
    color: isDisabled ? "disabled" : tagColor,
    className: "".concat(styles$Y.tag, " rsg-tag-").concat(id)
  }, tagText), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text, {
    className: styles$Y.label,
    bold: true,
    level: 13,
    color: isDisabled ? "text-disabled" : undefined
  }, label), /*#__PURE__*/React__default.createElement(Text, {
    color: isDisabled ? "text-disabled" : undefined
  }, description)), children && /*#__PURE__*/React__default.createElement("div", {
    className: styles$Y["selection-children"]
  }, children));
};
var RadioButton = (function (_ref3) {
  var form = _ref3.form,
    name = _ref3.name,
    value = _ref3.value,
    children = _ref3.children,
    _onChange = _ref3.onChange,
    _checked = _ref3.checked,
    disabled = _ref3.disabled,
    isDisabled = _ref3.isDisabled,
    className = _ref3.className,
    tooltip = _ref3.tooltip,
    style = _ref3.style,
    rest = _objectWithoutProperties$2(_ref3, _excluded2$3);
  isDisabled = isDisabled || disabled;
  var onChange = _onChange;
  var checked = _checked;
  var showError = false;
  if (form && name) {
    checked = checked || form.formState[name] === value;
    onChange = onChange || form.handleFormChange;
    showError = form.submissionAttempted && form.formErrors[name];
  }
  return /*#__PURE__*/React__default.createElement("label", {
    className: classNames(styles$Y["default"], _defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$Y["disabled"], isDisabled), styles$Y["active"], checked), styles$Y["error"], showError), className),
    style: style
  }, /*#__PURE__*/React__default.createElement("input", _extends$j({
    checked: checked,
    onChange: onChange,
    type: "radio",
    name: name,
    value: value,
    disabled: isDisabled
  }, rest)), /*#__PURE__*/React__default.createElement(RadioCircle, null), tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, null, tooltip), children);
});

var styles$W = {"toggle":"Toggle-module_toggle__3JTj7","active":"Toggle-module_active__11C-P","disabled":"Toggle-module_disabled__1IX3P","rail":"Toggle-module_rail__3U8LP","shadow":"Toggle-module_shadow__2U1Rw","thumb":"Toggle-module_thumb__3Jmai","pending":"Toggle-module_pending__1TM4o","pending-circle":"Toggle-module_pending-circle__21QEN","rotate":"Toggle-module_rotate__1wNpk","bgshimmer":"Toggle-module_bgshimmer__LDu7t"};

var Toggle = ({ form, name, value: _value, toggle: _toggle, className, disabled: _disabled, isDisabled, ariaLabel, Component = "button", pending, children, style, dataTestId }) => {
    let toggle = _toggle;
    let value = _value;
    const disabled = _disabled || isDisabled;
    if (form && name) {
        value = value || form.formState[name];
        toggle = toggle || form.wrappedHandleFormChange(name);
    }
    const circleTransform = value ? "translate(17)" : "translate(0)";
    return (jsxs(Component, { "data-component": "Toggle", style: style, "data-testid": dataTestId, className: classNames(styles$W['toggle'], className, {
            [styles$W['pending']]: pending,
            [styles$W['disabled']]: disabled,
            [styles$W['active']]: !!value
        }), disabled: pending || disabled, onClick: () => !disabled && toggle(!value), "aria-label": ariaLabel, role: "switch", "aria-checked": value, children: [jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "36", height: "19", viewBox: "0 0 36 19", overflow: "visible", children: [jsx$3("defs", { children: jsxs("filter", { id: "prefix__a", width: "172.2%", height: "172.2%", x: "-30.6%", y: "-30.6%", filterUnits: "objectBoundingBox", children: [jsx$3("feOffset", { dx: "1", dy: "1", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsx$3("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "2" }), jsx$3("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" })] }) }), jsxs("g", { fill: "none", children: [jsx$3("path", { className: styles$W.rail, d: "M6.782 3.5h22.436c3.39-.076 6.202 2.61 6.282 6-.08 3.39-2.891 6.076-6.282 6H6.782C3.392 15.576.58 12.89.5 9.5c.08-3.39 2.891-6.076 6.282-6z" }), jsx$3("circle", { className: styles$W.shadow, transform: circleTransform, fill: "#000", cx: "9.5", cy: "9.5", r: "9", filter: "url(#prefix__a)" }), jsx$3("circle", { className: styles$W.thumb, transform: circleTransform, cx: "9.5", cy: "9.5", r: "9" })] }), pending &&
                        jsx$3("circle", { className: classNames(styles$W['pending-circle'], styles$W['toggle-transition']), cx: value ? "26.5" : "9.5", style: { transformOrigin: value ? "26.5px center" : "9.5px center" }, cy: "9.5", r: "5", strokeWidth: "1", fill: "none" })] }), children && jsx$3("span", { children: children })] }));
};

var styles$V = {"base":"Slider-module_base__3eNXw","disabled":"Slider-module_disabled__5OvvY","slider":"Slider-module_slider__1S6gC","progress":"Slider-module_progress__1eXeB","thumb":"Slider-module_thumb__WbdYP","indicator":"Slider-module_indicator__2t0sF","minMax":"Slider-module_minMax__1DrrL","track":"Slider-module_track__LWdD3"};

const calculateValue = (e, ref, step, max, min) => {
    const { clientX } = e;
    const { left, width } = ref.current.getBoundingClientRect();
    if (clientX > (left + width)) {
        return max;
    }
    else if (clientX < left) {
        return min;
    }
    else {
        const proportion = (clientX - left) / width;
        const calc = Math.round(((proportion * (max - min)) + min) / step) * step;
        return calc < min ? min : calc;
    }
};
const Slider = ({ form, name, onChange: _onChange, value: _value, className, style, isDisabled, min = 0, max = 100, step = 1, unitSuffix = "" }) => {
    const [isDragging, setIsDragging] = useState(false);
    const sliderRef = useRef(null);
    let onChange = _onChange;
    let value = _value;
    if (form && name) {
        value = _value || form.formState[name];
        onChange = onChange || form.handleFormChange;
    }
    const [inputValue, setInputValue] = useState(_value);
    const digits = max.toString().length;
    const percent = (value - min) / (max - min) * 100;
    const handleInput = (e) => {
        setInputValue(e.target.value);
        if (e.target.value > max) {
            onChange(max, { name });
        }
        else if (e.target.value < min || e.target.value === "") {
            onChange(min, { name });
        }
        else {
            onChange(Number(e.target.value), { name });
        }
    };
    const handleBlur = () => {
        setInputValue(value);
    };
    const handleMouseDown = (e) => {
        if (isDisabled) {
            return;
        }
        const value = calculateValue(e, sliderRef, step, max, min);
        setInputValue(value);
        onChange(value, { name });
        setIsDragging(true);
        e.stopPropagation();
        e.preventDefault();
    };
    useEffect(() => {
        if (isDragging) {
            const moveListener = (e) => {
                const value = calculateValue(e, sliderRef, step, max, min);
                setInputValue(value);
                onChange(value, { name });
            };
            const upListener = () => {
                setIsDragging(false);
            };
            window.addEventListener("mousemove", moveListener);
            window.addEventListener("mouseup", upListener);
            return () => {
                window.removeEventListener("mousemove", moveListener);
                window.removeEventListener("mouseup", upListener);
            };
        }
    }, [isDragging, setIsDragging, onChange, step, max, min, setInputValue, inputValue]);
    return jsxs("div", { className: classNames(styles$V.base, className, { [styles$V['disabled']]: isDisabled }), style: style, children: [jsx$3("div", { className: styles$V.indicator, children: jsxs("span", { children: [jsx$3("input", { type: "number", disabled: isDisabled, onChange: handleInput, onBlur: handleBlur, name: name, value: inputValue, min: min, max: max, style: { width: 32 + digits * 8 } }), unitSuffix] }) }), jsxs("div", { className: styles$V.minMax, children: [min, unitSuffix] }), jsxs("div", { className: styles$V.slider, ref: sliderRef, children: [jsx$3("div", { className: styles$V.track, onMouseDown: handleMouseDown }), jsx$3("div", { className: styles$V.progress, style: { width: `${percent}%` }, onMouseDown: handleMouseDown }), jsx$3("div", { className: styles$V.thumb, style: { left: `${percent}%` }, onMouseDown: handleMouseDown })] }), jsxs("div", { className: styles$V.minMax, children: [max, unitSuffix] })] });
};
var Slider$1 = Slider;

var styles$U = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"Card-module_base__3g5yG","flex":"Card-module_flex__2a0N8","card-group":"Card-module_card-group__23KjY","has-hover-effect":"Card-module_has-hover-effect__2o4DV","selectable":"Card-module_selectable__3ns-F","disabled":"Card-module_disabled__3vqfE","check":"Card-module_check__1ULam","selected":"Card-module_selected__1Rq8e","selected-icon":"Card-module_selected-icon__20yIk","header":"Card-module_header__1735O","content":"Card-module_content__h-5rs","default":"Card-module_default__2kwum","small":"Card-module_small__2L6o6","table-content":"Card-module_table-content__2g3ua","lg-1":"Card-module_lg-1__2narh","md-1":"Card-module_md-1__3UyTq","sm-1":"Card-module_sm-1___34nm","lg-2":"Card-module_lg-2__GhGvb","md-2":"Card-module_md-2__1j646","sm-2":"Card-module_sm-2__2mdRd","lg-3":"Card-module_lg-3__1OiJo","md-3":"Card-module_md-3__S8o79","sm-3":"Card-module_sm-3__5RZEB","lg-4":"Card-module_lg-4__cXxMY","md-4":"Card-module_md-4__3zrgU","sm-4":"Card-module_sm-4__flNZv","lg-5":"Card-module_lg-5__2oD0e","md-5":"Card-module_md-5__1VL7W","sm-5":"Card-module_sm-5__2Xd78","lg-6":"Card-module_lg-6__1mKRO","md-6":"Card-module_md-6__2AyJv","sm-6":"Card-module_sm-6__cE20h","title":"Card-module_title__lwZ_R","sub-header":"Card-module_sub-header__14jJO","table-item":"Card-module_table-item__Vxviq","cardWidgets":"Card-module_cardWidgets__1mYrv","cardMetricContent":"Card-module_cardMetricContent__3FebG","cardContentLoading":"Card-module_cardContentLoading__EeVhh","bgshimmer":"Card-module_bgshimmer__zW7XA"};

var styles$T = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"CheckComponent-module_base__AEt3V","hovered":"CheckComponent-module_hovered__3jLKI","disabled":"CheckComponent-module_disabled__2eiQo","selected":"CheckComponent-module_selected__1pB9B","hoverable":"CheckComponent-module_hoverable__1Y72K","bgshimmer":"CheckComponent-module_bgshimmer__2lQ8n"};

var _desc$9, _circle$3, _path$8;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
var SvgIcCheckComponent = function SvgIcCheckComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$9 || (_desc$9 = /*#__PURE__*/React.createElement("desc", null, "Check")), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "var(--ux-check-bg)",
    stroke: "var(--ux-check-border)"
  })), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2425 7.75749C19.6525 8.16754 19.6525 8.83236 19.2425 9.24241L11.2425 17.2424C10.8324 17.6525 10.1676 17.6525 9.75755 17.2424L5.75755 13.2424C5.3475 12.8324 5.3475 12.1675 5.75755 11.7575C6.1676 11.3474 6.83242 11.3474 7.24247 11.7575L10.5 15.015L17.7576 7.75749C18.1676 7.34744 18.8324 7.34744 19.2425 7.75749Z",
    fill: "var(--ux-check-fg)"
  })));
};

const CheckComponent = ({ isSelected, className, style, isParentHovered, isDisabled, isHoverable }) => {
    return jsx$3(SvgIcCheckComponent, { className: classNames(styles$T.base, className, {
            [styles$T['hovered']]: isParentHovered,
            [styles$T['selected']]: isSelected,
            [styles$T['disabled']]: isDisabled,
            [styles$T['hoverable']]: isHoverable
        }), style: style });
};

var styles$S = {"base":"ComponentLoader-module_base__2gj-T","rotate":"ComponentLoader-module_rotate__3Pu39","dash":"ComponentLoader-module_dash___KCYE","color":"ComponentLoader-module_color__3JZsB"};

var ComponentLoader = ({ className, style, dataTestId = 'component-loader' }) => {
    return jsx$3("div", { className: classNames(styles$S['base'], className), style: style, "data-testid": dataTestId, children: jsx$3("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", overflow: "visible", children: jsx$3("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }) }) });
};

const Card = (_a) => {
    var { children, className, style, hasHoverEffect, Component = "div", flex, dataTestId } = _a, rest = __rest(_a, ["children", "className", "style", "hasHoverEffect", "Component", "flex", "dataTestId"]);
    return jsx$3(Component, Object.assign({ className: classNames(styles$U.base, className, { [styles$U.flex]: flex }), style: style, "data-testid": dataTestId }, rest, { children: children }));
};
const SelectableCard = ({ children, className, style, isSelected, selectedIconStyle, Component = "button", isDisabled, onClick, dataTestId }) => {
    return jsxs(Component, { className: classNames(styles$U.base, className, styles$U['selectable'], {
            [styles$U['selected']]: isSelected,
            [styles$U['disabled']]: isDisabled,
            [styles$U['has-hover-effect']]: !isDisabled
        }), style: style, disabled: Component === "button" ? isDisabled : undefined, onClick: isDisabled ? undefined : onClick, "data-testid": dataTestId, children: [!isDisabled && jsx$3(CheckComponent, { className: styles$U['check'], style: selectedIconStyle, isSelected: isSelected }), children] });
};
const CardHeader = ({ children, className, style, dataTestId, }) => {
    return jsx$3("div", { className: classNames(styles$U.header, className), style: style, "data-testid": dataTestId, children: children });
};
const CardContent = ({ children, className, style, size = "default", dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$U.content, styles$U[size], className), style: style, "data-testid": dataTestId, children: children });
};
const CardTitle = ({ children, className, style, SubHeader, isDisabled, dataTestId }) => {
    const isString = _$1.isString(children);
    return jsxs("div", { className: classNames(styles$U.title, className, { [styles$U.disabled]: isDisabled }), style: style, title: isString ? children : undefined, "data-testid": dataTestId, children: [children, SubHeader && jsx$3("div", { className: styles$U['sub-header'], children: SubHeader })] });
};
const CardTableContent = ({ children, className, style, columns = "lg-3", dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$U['table-content'], styles$U[columns], className), style: style, "data-testid": dataTestId, children: children });
};
const CardTableItem = ({ children, dataTestId }) => {
    return jsx$3("div", { className: styles$U['table-item'], "data-testid": dataTestId, children: children });
};
const CardWidgets = ({ children, dataTestId }) => {
    return jsx$3("div", { className: styles$U.cardWidgets, "data-testid": dataTestId, children: children });
};
const CardMetricContent = ({ children, dataTestId }) => {
    return jsx$3("div", { className: styles$U.cardMetricContent, "data-testid": dataTestId, children: children });
};
const LoadingCard = () => {
    return jsx$3(Card, { children: jsx$3(CardContent, { children: jsx$3(InlineLoader, {}) }) });
};
const CardContentLoading = ({ style, className, dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$U.cardContentLoading, className), style: style, "data-testid": dataTestId, children: jsx$3(ComponentLoader, {}) });
};

var styles$R = {"base":"CardRadioGroup-module_base__1ZDg2","blue":"CardRadioGroup-module_blue__1WuoO","label":"CardRadioGroup-module_label__16YXV","radios":"CardRadioGroup-module_radios__lu6n3"};

var CardRadioGroup = function CardRadioGroup(_ref) {
  var label = _ref.label,
    labelStyle = _ref.labelStyle,
    children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "white" : _ref$color;
  return /*#__PURE__*/React__default.createElement(Card, {
    className: classNames(styles$R.base, _defineProperty$3({}, styles$R['blue'], color === "blue"), className),
    style: style
  }, label && /*#__PURE__*/React__default.createElement("div", {
    style: labelStyle,
    className: styles$R.label
  }, label, ":"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$R.radios
  }, children));
};
var CardRadioGroup$1 = CardRadioGroup;

/**
 * set enabled to false will not ensure -> use this for things like loading previous states that may not have valid options
 * @param selector -> string will use _.find,
 */
var useOptionEnsure = function useOptionEnsure(options, form, key, selector) {
  var enabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var ref = useRef(null);
  ref.current = {
    form: form,
    key: key,
    selector: selector
  };
  useEffect(function () {
    if (!enabled) {
      return;
    }
    var _ref$current = ref.current,
      form = _ref$current.form,
      key = _ref$current.key,
      selector = _ref$current.selector;
    if (options && options.length > 0) {
      var _form$formState$key;
      if (!form.formState[key] || _$1.isArray(form.formState[key]) && form.formState[key].length === 0) {
        //form field is empty
        var option = selector ? _$1.find(options, selector) : options[0];
        form.handleFormChange(option, {
          name: key,
          ignoreDirty: true
        });
      } else if (!_$1.isArray(form.formState[key]) && !_$1.find(options, {
        value: (_form$formState$key = form.formState[key]) === null || _form$formState$key === void 0 ? void 0 : _form$formState$key.value
      })) {
        //form field has single value that isnt in options
        var _option = selector ? _$1.find(options, selector) : options[0];
        form.handleFormChange(_option, {
          name: key,
          ignoreDirty: true
        });
      }
    } else if (form.formState[key]) {
      //form field has value but there are no options
      form.handleFormChange(null, {
        name: key,
        ignoreDirty: true
      });
    }
  }, [options, enabled]);
};
var useOptionEnsure$1 = useOptionEnsure;

var _excluded$a = ["Icon", "label", "className", "style", "children", "ref", "dataTestId"];
var FormFieldInputButton = function FormFieldInputButton(_ref) {
  var Icon = _ref.Icon,
    label = _ref.label,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    ref = _ref.ref,
    dataTestId = _ref.dataTestId,
    rest = _objectWithoutProperties$2(_ref, _excluded$a);
  return /*#__PURE__*/React__default.createElement("button", _extends$j({
    "data-testid": dataTestId,
    ref: ref,
    type: "button",
    className: classNames(styles$12["form-field-input-button"], className, _defineProperty$3({}, styles$12["icon-only"], !label)),
    style: style
  }, rest), Icon && /*#__PURE__*/React__default.createElement(Icon, null), label && /*#__PURE__*/React__default.createElement("span", {
    className: styles$12["label"]
  }, label), children);
};
var FormFieldInputButton$1 = FormFieldInputButton;

var noValidator = function noValidator() {
  return {};
};
var yupValidator = function yupValidator(schema) {
  return function (state) {
    var errors = {};
    try {
      schema.validateSync(state, {
        abortEarly: false
      });
    } catch (e) {
      e.inner && _$1.forEach(e.inner, function (_ref) {
        var path = _ref.path,
          message = _ref.message;
        errors[path] = errors[path] || message;
      });
    }
    return errors;
  };
};
var init$1 = function init(state) {
  return {
    fields: state,
    isValid: false,
    isDirty: false,
    dirty: {},
    errorState: {},
    submissionAttempted: false
  };
};
var reducer$1 = function reducer(state, action) {
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case "RESET":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          submissionAttempted: payload.resetSubmissionAttempted ? false : state.submissionAttempted,
          fields: payload.fields,
          dirty: {},
          isDirty: false
        });
      }
    case "MERGE":
      {
        var fields = payload.fields,
          dirty = payload.dirty,
          ignoreDirty = payload.ignoreDirty;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          fields: _objectSpread2(_objectSpread2({}, state.fields), fields),
          dirty: _objectSpread2(_objectSpread2({}, state.dirty), dirty),
          isDirty: ignoreDirty ? state.isDirty : true
        });
      }
    case "SUBMISSION-ATTEMPTED":
      {
        if (state.submissionAttempted) {
          return state;
        } else {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            submissionAttempted: true
          });
        }
      }
    case "RESET-SUBMISSION-ATTEMPTED":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          submissionAttempted: false
        });
      }
    case "VALIDITY":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isValid: payload.isValid,
          errorState: payload.errorState
        });
      }
  }
  return state;
};
var useForm = (function (initialState) {
  var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noValidator;
  var _useReducer = useReducer(reducer$1, initialState, init$1),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var stateRef = useRef({});
  var _useMemo = useMemo(function () {
      var validator = validate.validateSync ? yupValidator(validate) : validate;
      var errors = validator(state.fields);
      return {
        isValid: _$1.isEmpty(errors),
        errorState: errors
      };
    }, [validate, state.fields]),
    isValid = _useMemo.isValid,
    errorState = _useMemo.errorState;
  stateRef.current = {
    state: state,
    isValid: isValid
  };
  var resetForm = useCallback(function (state) {
    var resetSubmissionAttempted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    dispatch({
      type: "RESET",
      payload: {
        fields: state,
        resetSubmissionAttempted: resetSubmissionAttempted
      }
    });
  }, [dispatch]);
  var resetSubmissionAttempted = useCallback(function () {
    dispatch({
      type: "RESET-SUBMISSION-ATTEMPTED"
    });
  }, [dispatch]);
  var handleFormSubmit = useCallback(function (callback) {
    return function (event) {
      dispatch({
        type: "SUBMISSION-ATTEMPTED"
      });
      event.preventDefault();
      if (stateRef.current.isValid) {
        callback(event, stateRef.current.state.fields);
      }
    };
  }, [dispatch]);
  var setSubmissionAttempted = useCallback(function () {
    dispatch({
      type: "SUBMISSION-ATTEMPTED"
    });
  }, [dispatch]);
  var handleFormChange = useCallback(function (_valueOrEvent, _Event) {
    if (_$1.isArray(_valueOrEvent) && !_Event) {
      var mergeState = {};
      var mergeDirty = {};
      var ignoreDirty = true;
      _$1.forEach(_valueOrEvent, function (_ref2) {
        var value = _ref2.value,
          event = _ref2.event;
        mergeState[event.name] = value;
        if (!event.ignoreDirty) {
          mergeDirty[event.name] = true;
          ignoreDirty = true;
        }
      });
      dispatch({
        type: "MERGE",
        payload: {
          fields: mergeState,
          dirty: mergeDirty,
          ignoreDirty: ignoreDirty
        }
      });
    } else {
      var name = null;
      var value = null;
      var _ignoreDirty = false;
      if (_Event) {
        name = _Event.name;
        value = _valueOrEvent;
        if (_Event.ignoreDirty) {
          _ignoreDirty = true;
        }
      } else {
        var event = _valueOrEvent;
        if (event.target.type === "checkbox") {
          value = event.target.checked;
          name = event.target.value;
        } else {
          value = event.target.value;
          name = event.target.name;
        }
      }
      if (name) {
        var payload = {
          fields: _defineProperty$3({}, name, value)
        };
        if (!_ignoreDirty) {
          payload.dirty = _defineProperty$3({}, name, true);
        } else {
          payload.ignoreDirty = true;
        }
        dispatch({
          type: "MERGE",
          payload: payload
        });
      } else {
        console.warn("Form event received without form name. Value ignored.");
      }
    }
  }, [dispatch]);
  var wrappedHandleFormChange = useCallback(function (name) {
    return function (value, event) {
      handleFormChange(value, _objectSpread2(_objectSpread2({}, event), {}, {
        name: name
      }));
    };
  }, [handleFormChange]);
  return useMemo(function () {
    return {
      resetForm: resetForm,
      handleFormSubmit: handleFormSubmit,
      setSubmissionAttempted: setSubmissionAttempted,
      handleFormChange: handleFormChange,
      wrappedHandleFormChange: wrappedHandleFormChange,
      formState: state.fields,
      dirty: state.dirty,
      isDirty: state.isDirty,
      isValid: isValid,
      formErrors: errorState,
      submissionAttempted: state.submissionAttempted,
      resetSubmissionAttempted: resetSubmissionAttempted
    };
  }, [resetForm, handleFormSubmit, setSubmissionAttempted, handleFormChange, wrappedHandleFormChange, state, isValid, errorState, resetSubmissionAttempted]);
});

var useSelectionStateToForm = function useSelectionStateToForm(handleFormChange, field, selectionState) {
  useEffect(function () {
    handleFormChange(selectionState.rows, {
      name: field,
      ignoreDirty: !selectionState.isDirty
    });
  }, [selectionState, handleFormChange, field]);
};
var useSelectionStateToForm$1 = useSelectionStateToForm;

var styles$Q = {"base":"Select-module_base__1__aH","margin-bottom":"Select-module_margin-bottom__2T7Kq","label":"Select-module_label__MaLF4","disabled":"Select-module_disabled__380Pe","control":"Select-module_control__1D3gn","read-only":"Select-module_read-only__1TI-C","open":"Select-module_open__375Wr","input-buttons":"Select-module_input-buttons__w7Xbm","invalid":"Select-module_invalid__1CRh-","placeholder":"Select-module_placeholder__3Cfa-","loading":"Select-module_loading__3wqCE","single-value":"Select-module_single-value__3Rt7X","multi-value":"Select-module_multi-value__2tAwv","multi-value-chip":"Select-module_multi-value-chip__2VOKJ","no-remove":"Select-module_no-remove__36eua","multi-value-remainder-chip":"Select-module_multi-value-remainder-chip__Y95QD","multi-value-remainder-tooltip-content":"Select-module_multi-value-remainder-tooltip-content__1Dmle","controls":"Select-module_controls__1xgMb","menu":"Select-module_menu__2hYm9","ported-menu":"Select-module_ported-menu__Y4qc2","no-options":"Select-module_no-options__2FVae","virtualized":"Select-module_virtualized__2Zc32","option":"Select-module_option__2ojUk","multi-line":"Select-module_multi-line__3ToZG","checkbox-option":"Select-module_checkbox-option__1vzTX","multi-line-checkbox":"Select-module_multi-line-checkbox__QtCXJ","primaryLabel":"Select-module_primaryLabel__1F7J0","secondary-label":"Select-module_secondary-label__1LOIe","sub-label":"Select-module_sub-label__2YQuu","tag":"Select-module_tag__3lKqe","selected":"Select-module_selected__2T0yB","error":"Select-module_error__3_Nmg","bg":"Select-module_bg__3Pn5Y","border":"Select-module_border__1fBz4","check":"Select-module_check__FJhI-","search-bar":"Select-module_search-bar__3UaN_","close":"Select-module_close__3787p","search-controls":"Select-module_search-controls__dHVs2","menu-actions":"Select-module_menu-actions__1fauq","select-all":"Select-module_select-all__2SJal","bgshimmer":"Select-module_bgshimmer__Qhezz"};

var styles$P = {"base":"ThreeDotLoader-module_base__3wZjq","d1":"ThreeDotLoader-module_d1__SGAss","dot-flashing":"ThreeDotLoader-module_dot-flashing__1xHKO","d2":"ThreeDotLoader-module_d2__1kxdb","d3":"ThreeDotLoader-module_d3__unHF0"};

const ThreeDotLoader = ({ className, style, dataTestId }) => {
    return jsxs("div", { className: classNames(styles$P.base, className), style: style, "data-testid": dataTestId, children: [jsx$3("div", { className: styles$P.d1 }), jsx$3("div", { className: styles$P.d2 }), jsx$3("div", { className: styles$P.d3 })] });
};

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();
  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }
  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }
  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);
    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;
      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }
    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }
  return cachedRTLResult;
}
if (process.env.NODE_ENV !== 'production') ;
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.

var devWarningsDirection = null;
var devWarningsTagName$1 = null;
if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection = /*#__PURE__*/new WeakSet();
    devWarningsTagName$1 = /*#__PURE__*/new WeakSet();
  }
}
function createListComponent(_ref) {
  var _class;
  var getItemOffset = _ref.getItemOffset,
    getEstimatedTotalSize = _ref.getEstimatedTotalSize,
    getItemSize = _ref.getItemSize,
    getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
    getStartIndexForOffset = _ref.getStartIndexForOffset,
    getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
    initInstanceProps = _ref.initInstanceProps,
    shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
    validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;
      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;
      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
          direction = _this$props.direction,
          itemSize = _this$props.itemSize,
          layout = _this$props.layout;
        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
        var style;
        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);
          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }
        return style;
      };
      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function (_, __, ___) {
        return {};
      });
      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
          clientWidth = _event$currentTarget.clientWidth,
          scrollLeft = _event$currentTarget.scrollLeft,
          scrollWidth = _event$currentTarget.scrollWidth;
        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }
          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;
              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.

          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
          clientHeight = _event$currentTarget2.clientHeight,
          scrollHeight = _event$currentTarget2.scrollHeight,
          scrollTop = _event$currentTarget2.scrollTop;
        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.

          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;
        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };
      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }
        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };
      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;
        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };
      return _this;
    }
    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };
    var _proto = List.prototype;
    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }
        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };
    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }
      var _this$props2 = this.props,
        itemCount = _this$props2.itemCount,
        layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.
      // This is an edge case for lists; normally they only scroll in the dominant direction.

      var scrollbarSize = 0;
      if (this._outerRef) {
        var outerRef = this._outerRef;
        if (layout === 'vertical') {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }
      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
        direction = _this$props3.direction,
        initialScrollOffset = _this$props3.initialScrollOffset,
        layout = _this$props3.layout;
      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props,
        direction = _this$props4.direction,
        layout = _this$props4.layout;
      var _this$state = this.state,
        scrollOffset = _this$state.scrollOffset,
        scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;
              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;
              default:
                var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };
    _proto.render = function render() {
      var _this$props5 = this.props,
        children = _this$props5.children,
        className = _this$props5.className,
        direction = _this$props5.direction,
        height = _this$props5.height,
        innerRef = _this$props5.innerRef,
        innerElementType = _this$props5.innerElementType,
        innerTagName = _this$props5.innerTagName,
        itemCount = _this$props5.itemCount,
        itemData = _this$props5.itemData,
        _this$props5$itemKey = _this$props5.itemKey,
        itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey,
        layout = _this$props5.layout,
        outerElementType = _this$props5.outerElementType,
        outerTagName = _this$props5.outerTagName,
        style = _this$props5.style,
        useIsScrolling = _this$props5.useIsScrolling,
        width = _this$props5.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
      var _this$_getRangeToRend = this._getRangeToRender(),
        startIndex = _this$_getRangeToRend[0],
        stopIndex = _this$_getRangeToRend[1];
      var items = [];
      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement$1(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.

      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return createElement$1(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: _extends$k({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, createElement$1(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };
    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;
        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
            _overscanStartIndex = _this$_getRangeToRend2[0],
            _overscanStopIndex = _this$_getRangeToRend2[1],
            _visibleStartIndex = _this$_getRangeToRend2[2],
            _visibleStopIndex = _this$_getRangeToRend2[3];
          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }
      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
          _scrollDirection = _this$state2.scrollDirection,
          _scrollOffset = _this$state2.scrollOffset,
          _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;
    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props,
        itemCount = _this$props6.itemCount,
        overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state,
        isScrolling = _this$state3.isScrolling,
        scrollDirection = _this$state3.scrollDirection,
        scrollOffset = _this$state3.scrollOffset;
      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }
      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };
    return List;
  }(PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
    direction = _ref2.direction,
    height = _ref2.height,
    layout = _ref2.layout,
    innerTagName = _ref2.innerTagName,
    outerTagName = _ref2.outerTagName,
    width = _ref2.width;
  var instance = _ref3.instance;
  if (process.env.NODE_ENV !== 'production') {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }
        break;
      case 'ltr':
      case 'rtl':
        // Valid values
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }
    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }
    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }
    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};
var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
    itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
    lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  if (index > lastMeasuredIndex) {
    var offset = 0;
    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }
    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }
    instanceProps.lastMeasuredIndex = index;
  }
  return itemMetadataMap[index];
};
var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
    lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};
var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;
    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;
  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }
  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
    estimatedItemSize = _ref3.estimatedItemSize,
    lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }
  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }
  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var VariableSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = props.direction,
      height = props.height,
      layout = props.layout,
      width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }
    switch (align) {
      case 'start':
        return maxOffset;
      case 'end':
        return minOffset;
      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);
      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
      height = props.height,
      itemCount = props.itemCount,
      layout = props.layout,
      width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;
    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }
    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
      estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };
    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }
      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);
      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };
    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;
    if (process.env.NODE_ENV !== 'production') {
      if (typeof itemSize !== 'function') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var _excluded$9 = ["controlRef", "menuPortalTarget"];
var SingleLineOption = function SingleLineOption(_ref) {
  var style = _ref.style,
    className = _ref.className,
    onClick = _ref.onClick,
    option = _ref.option;
  var label = option.label,
    secondaryLabel = option.secondaryLabel,
    subLabel = option.subLabel,
    tag = option.tag,
    tooltip = option.tooltip,
    value = option.value;
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: classNames(styles$Q["option"], className),
    onClick: onClick,
    title: label || value
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["secondary-label"]
  }, label || value), " ", !secondaryLabel && subLabel && /*#__PURE__*/React__default.createElement("span", {
    className: styles$Q['sub-label']
  }, subLabel), " ", tag && /*#__PURE__*/React__default.createElement("span", {
    className: styles$Q.tag
  }, /*#__PURE__*/React__default.createElement(Tag, {
    level: 12
  }, tag)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, null, tooltip));
};
var SingleLineCheckboxOption = function SingleLineCheckboxOption(_ref2) {
  var style = _ref2.style,
    className = _ref2.className,
    onClick = _ref2.onClick,
    option = _ref2.option;
  var label = option.label,
    secondaryLabel = option.secondaryLabel,
    subLabel = option.subLabel,
    tag = option.tag,
    tooltip = option.tooltip,
    value = option.value;
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: classNames(styles$Q["option"], styles$Q["checkbox-option"], className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "16",
    height: "16",
    className: styles$Q['bg']
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    rx: "1.5",
    className: styles$Q['border']
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.59996 7.57717C2.26787 7.9118 2.26787 8.45165 2.59996 8.78628L5.57564 11.7848C5.96677 12.1789 6.60411 12.1789 6.99524 11.7848L13.4005 5.3304C13.7327 4.99566 13.7336 4.45593 13.4026 4.12V4.12C13.0663 3.77872 12.5161 3.77774 12.1786 4.11782L6.28544 10.0562L3.81749 7.57631C3.48165 7.23885 2.93532 7.23924 2.59996 7.57717V7.57717Z",
    stroke: "none",
    className: styles$Q['check']
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["secondary-label"]
  }, label || value), " ", !secondaryLabel && subLabel && /*#__PURE__*/React__default.createElement("span", {
    className: styles$Q['sub-label']
  }, subLabel), " ", tag && /*#__PURE__*/React__default.createElement("span", {
    className: styles$Q.tag
  }, /*#__PURE__*/React__default.createElement(Tag, {
    level: 12
  }, tag)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, null, tooltip));
};
var MultiLineOption = function MultiLineOption(_ref3) {
  var style = _ref3.style,
    className = _ref3.className,
    onClick = _ref3.onClick,
    option = _ref3.option;
  var label = option.label,
    secondaryLabel = option.secondaryLabel,
    tooltip = option.tooltip;
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: classNames(styles$Q["option"], styles$Q["multi-line"], className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q.primaryLabel
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["secondary-label"]
  }, secondaryLabel), tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, null, tooltip));
};
var MultiLineCheckboxOption = function MultiLineCheckboxOption(_ref4) {
  var style = _ref4.style,
    className = _ref4.className,
    onClick = _ref4.onClick,
    option = _ref4.option;
  var label = option.label,
    secondaryLabel = option.secondaryLabel,
    tooltip = option.tooltip;
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: classNames(styles$Q["option"], styles$Q["multi-line-checkbox"], className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "16",
    height: "16",
    className: styles$Q['bg']
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    rx: "1.5",
    className: styles$Q['border']
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.59996 7.57717C2.26787 7.9118 2.26787 8.45165 2.59996 8.78628L5.57564 11.7848C5.96677 12.1789 6.60411 12.1789 6.99524 11.7848L13.4005 5.3304C13.7327 4.99566 13.7336 4.45593 13.4026 4.12V4.12C13.0663 3.77872 12.5161 3.77774 12.1786 4.11782L6.28544 10.0562L3.81749 7.57631C3.48165 7.23885 2.93532 7.23924 2.59996 7.57717V7.57717Z",
    stroke: "none",
    className: styles$Q['check']
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q.primaryLabel
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["secondary-label"]
  }, secondaryLabel)), tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, null, tooltip));
};
var Option = function Option(_ref5) {
  var option = _ref5.option,
    isSelected = _ref5.isSelected,
    toggleOption = _ref5.toggleOption,
    setMenuOpen = _ref5.setMenuOpen,
    style = _ref5.style,
    isMulti = _ref5.isMulti,
    isSelectAllOption = _ref5.isSelectAllOption;
  var secondaryLabel = option.secondaryLabel,
    isDisabled = option.isDisabled,
    value = option.value,
    noRemove = option.noRemove;
  var onClick = function onClick(e) {
    if (!isDisabled && !noRemove) {
      toggleOption(option);
    }
    if (!isMulti) {
      setMenuOpen(false);
    }
    e.stopPropagation();
    e.preventDefault();
  };
  var className = _defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$Q["selected"], isSelected), styles$Q["disabled"], isDisabled || _$1.isUndefined(value) || _$1.isNull(value)), styles$Q["select-all"], isSelectAllOption);
  if (!secondaryLabel && !isMulti) {
    return /*#__PURE__*/React__default.createElement(SingleLineOption, {
      style: style,
      onClick: onClick,
      option: option,
      className: className
    });
  } else if (secondaryLabel && !isMulti) {
    return /*#__PURE__*/React__default.createElement(MultiLineOption, {
      style: style,
      onClick: onClick,
      option: option,
      className: className
    });
  } else if (!secondaryLabel && isMulti) {
    return /*#__PURE__*/React__default.createElement(SingleLineCheckboxOption, {
      style: style,
      onClick: onClick,
      option: option,
      className: className
    });
  } else if (secondaryLabel && isMulti) {
    return /*#__PURE__*/React__default.createElement(MultiLineCheckboxOption, {
      style: style,
      onClick: onClick,
      option: option,
      className: className
    });
  } else {
    return /*#__PURE__*/React__default.createElement(SingleLineOption, {
      style: style,
      onClick: onClick,
      option: option,
      className: className
    });
  }
};
var VirtualizedMenu = function VirtualizedMenu(_ref6) {
  var _selectionState$selec;
  var options = _ref6.options,
    setMenuOpen = _ref6.setMenuOpen,
    toggleOption = _ref6.toggleOption,
    selectionState = _ref6.selectionState,
    isMulti = _ref6.isMulti;
  var isAllOptionsSelected = options.filter(function (option) {
    return !option.isSelectAllOption;
  }).length === ((_selectionState$selec = selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectedOptions.length) !== null && _selectionState$selec !== void 0 ? _selectionState$selec : 0);
  if (options.length < 6) return options.map(function (option) {
    var _option$value;
    return /*#__PURE__*/React__default.createElement(Option, {
      setMenuOpen: setMenuOpen,
      toggleOption: toggleOption,
      isSelected: option.isSelectAllOption && isAllOptionsSelected || (option.value ? selectionState === null || selectionState === void 0 ? void 0 : selectionState.valuesSet.has(option.value) : false),
      key: ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.id) || option.value,
      option: option,
      isMulti: isMulti,
      isSelectAllOption: option.isSelectAllOption
    });
  });
  var getItemSize = function getItemSize(index) {
    var _options$index;
    if ((_options$index = options[index]) !== null && _options$index !== void 0 && _options$index.secondaryLabel) {
      return doubleRowHeight;
    } else {
      return singleRowHeight;
    }
  };
  var singleRowHeight = 48;
  var doubleRowHeight = 64;
  var selectedIndex = 0;
  var initialOffset = 0;
  if (selectionState) {
    selectedIndex = _$1.findIndex(options, {
      value: selectionState.selectedOptions[0].value
    }) || 0;
    var itemSize = getItemSize(selectedIndex); ////Assumes every row is same height

    if (selectedIndex < 6) {
      //first 6
      initialOffset = 0;
    } else if (options.length - selectedIndex < 6) {
      //last 6
      selectedIndex = options.length - 6;
      initialOffset = selectedIndex * itemSize;
    } else {
      //middle
      initialOffset = (selectedIndex - 3) * itemSize + itemSize / 2;
    }
  }
  return /*#__PURE__*/React__default.createElement(VariableSizeList, {
    itemSize: getItemSize,
    height: getItemSize(selectedIndex) * 6,
    itemCount: options.length,
    initialScrollOffset: initialOffset,
    className: styles$Q["virtualized"]
  }, function (_ref7) {
    var _option$value2;
    var index = _ref7.index,
      style = _ref7.style;
    var option = options[index];
    return /*#__PURE__*/React__default.createElement(Option, {
      style: style,
      setMenuOpen: setMenuOpen,
      toggleOption: toggleOption,
      isSelected: option.isSelectAllOption && isAllOptionsSelected || (option.value ? selectionState === null || selectionState === void 0 ? void 0 : selectionState.valuesSet.has(option.value) : false),
      key: ((_option$value2 = option.value) === null || _option$value2 === void 0 ? void 0 : _option$value2.id) || option.value,
      option: option,
      isMulti: isMulti,
      isSelectAllOption: option.isSelectAllOption
    });
  });
};
var PortedMenuOptions = function PortedMenuOptions(_ref8) {
  var controlRef = _ref8.controlRef,
    menuPortalTarget = _ref8.menuPortalTarget,
    props = _objectWithoutProperties$2(_ref8, _excluded$9);
  var menuRef = useRef(null);
  useLayoutEffect(function () {
    var resize = function resize() {
      var controlRect = controlRef.current.getBoundingClientRect();
      var portalParentScrollTop = menuPortalTarget.parentNode.scrollTop;
      var portalParentScrollLeft = menuPortalTarget.parentNode.scrollLeft;
      menuRef.current.style.left = portalParentScrollLeft + controlRect.left + "px";
      menuRef.current.style.top = portalParentScrollTop + controlRect.top + controlRect.height + "px";
      menuRef.current.style.width = controlRect.width + "px";
    };
    resize();
    var resizeObserver = new ResizeObserver(function () {
      resize();
    });
    resizeObserver.observe(controlRef.current);
    menuRef.current.addEventListener("mouseenter", resize);
    return function () {
      resizeObserver.disconnect();
    };
  }, [controlRef, menuPortalTarget]);
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React__default.createElement(MenuOptions, _extends$j({}, props, {
    menuRef: menuRef,
    className: styles$Q["ported-menu"]
  })), menuPortalTarget);
};
var SearchBar = /*#__PURE__*/React__default.memo(function (_ref9) {
  var setFilter = _ref9.setFilter,
    createOption = _ref9.createOption,
    isCreatable = _ref9.isCreatable,
    creationText = _ref9.creationText;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var throttledSetFilter = useMemo(function () {
    return _$1.debounce(function (value) {
      setFilter(value);
    }, 300);
  }, [setFilter]);
  var clear = function clear() {
    setTimeout(function () {
      setValue("");
      throttledSetFilter("");
    });
  };
  var handleChange = function handleChange(event) {
    var currValue = event.target.value;
    throttledSetFilter(currValue);
    setValue(currValue);
  };
  var handleKeyDown = function handleKeyDown(event) {
    var currValue = event.target.value;
    if (event.key === 'Enter' || event.key === 'Backspace') {
      throttledSetFilter(currValue);
    }
    setValue(currValue);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["search-bar"]
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    color: "secondary",
    size: 16
  }), /*#__PURE__*/React__default.createElement("input", {
    placeholder: isCreatable ? "Search or add" : "Search",
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["search-controls"]
  }, value && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: styles$Q['close'],
    onClick: clear
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), isCreatable && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "text",
    disabled: !value,
    onClick: function onClick() {
      createOption(value);
      clear();
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    size: 16,
    style: {
      marginRight: 0
    }
  }), creationText)));
});
var MenuOptions = function MenuOptions(_ref10) {
  var options = _ref10.options,
    name = _ref10.name,
    toggleOption = _ref10.toggleOption,
    selectionState = _ref10.selectionState,
    acceptChanges = _ref10.acceptChanges,
    setMenuOpen = _ref10.setMenuOpen,
    menuRef = _ref10.menuRef,
    isSearchable = _ref10.isSearchable,
    isCreatable = _ref10.isCreatable,
    isMulti = _ref10.isMulti,
    noOptionsMessage = _ref10.noOptionsMessage,
    componentId = _ref10.componentId,
    isRequireAcceptOnChange = _ref10.isRequireAcceptOnChange,
    createOption = _ref10.createOption,
    style = _ref10.style,
    className = _ref10.className,
    creationText = _ref10.creationText,
    isSelectAll = _ref10.isSelectAll,
    selectAllLabel = _ref10.selectAllLabel;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    filter = _useState4[0],
    setFilter = _useState4[1];
  var filteredOptions = useMemo(function () {
    var _options = options;
    if (isSelectAll) {
      _options = [{
        value: "ALL",
        label: selectAllLabel,
        isSelectAllOption: true
      }].concat(options);
    }
    if (filter) {
      var lowerCasedFilter = _$1.toLower(filter);
      return _$1.filter(_options, function (option) {
        return option.label && _$1.includes(_$1.toLower(option.label), lowerCasedFilter) || option.secondaryLabel && _$1.includes(_$1.toLower(option.secondaryLabel), lowerCasedFilter) || _$1.toLower(option.value) === lowerCasedFilter;
      });
    } else {
      return _options;
    }
  }, [filter, options]);
  var clickAway = useCallback(function (e) {
    var _e$nativeEvent;
    if (e.__multiSelectMainClick === componentId.current || (e === null || e === void 0 || (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : _e$nativeEvent.__multiSelectMainClick) === componentId.current) {
      return;
    }
    setMenuOpen(false);
    e.__multiSelectClose = componentId.current;
  }, [setMenuOpen, componentId]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: menuRef,
    style: style,
    className: classNames(styles$Q["menu"], className)
  }, /*#__PURE__*/React__default.createElement(ClickAway, {
    listener: clickAway,
    ignoreParentClick: true,
    closeOnModalClick: true
  }), isSearchable && /*#__PURE__*/React__default.createElement(SearchBar, {
    setFilter: setFilter,
    createOption: createOption,
    isCreatable: isCreatable,
    creationText: creationText
  }), (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) > 0 && /*#__PURE__*/React__default.createElement(VirtualizedMenu, {
    options: filteredOptions,
    setMenuOpen: setMenuOpen,
    name: name,
    toggleOption: toggleOption,
    selectionState: selectionState,
    isMulti: isMulti,
    isSelectAll: isSelectAll
  }), !(filteredOptions !== null && filteredOptions !== void 0 && filteredOptions.length) && /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["no-options"]
  }, /*#__PURE__*/React__default.createElement(Span, {
    bold: true
  }, noOptionsMessage ? noOptionsMessage() : "No Options")), isRequireAcceptOnChange && /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["menu-actions"]
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick() {
      acceptChanges();
      setMenuOpen(false);
    }
  }, "Accept"), /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick() {
      return setMenuOpen(false);
    }
  }, "Cancel")));
};
var Menu = function Menu(props) {
  if (props.menuPortalTarget) {
    return /*#__PURE__*/React__default.createElement(PortedMenuOptions, props);
  } else {
    return /*#__PURE__*/React__default.createElement(MenuOptions, props);
  }
};
var Menu$1 = Menu;

var RemoveButton = function RemoveButton(_ref) {
  var unselectOption = _ref.unselectOption;
  return /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick(e) {
      e.__multiSelectRemove = true;

      /**
       * Some wierd propagation shit is happening, so if the click isn't within the button, don't handle it
       */
      var boundingRect = e.target.getBoundingClientRect();
      if (e.clientX < boundingRect.x || e.clientX > boundingRect.x + boundingRect.width || e.clientY < boundingRect.y || e.clientY > boundingRect.y + boundingRect.height) {
        return;
      }

      /**
       * Its in a timeout so that the element only gets removed after the click finishes handling,
       * otherwise the element gets removed, and the click triggers on the chip that takes its place
       */
      setTimeout(function () {
        unselectOption();
      });
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null));
};
var MultiSelectedOptionChip = function MultiSelectedOptionChip(_ref2) {
  var option = _ref2.option,
    _unselectOption = _ref2.unselectOption,
    style = _ref2.style,
    isClipped = _ref2.isClipped,
    isRequireAcceptOnChange = _ref2.isRequireAcceptOnChange,
    isDisabled = _ref2.isDisabled;
  var noRemove = isRequireAcceptOnChange || option.noRemove;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames([styles$Q["multi-value-chip"], _defineProperty$3({}, styles$Q["no-remove"], noRemove || isDisabled)]),
    style: style
  }, /*#__PURE__*/React__default.createElement(Span, {
    ellipsis: true,
    color: "on-color"
  }, option.label || option.value), !noRemove && !isDisabled && /*#__PURE__*/React__default.createElement(RemoveButton, {
    unselectOption: function unselectOption() {
      return _unselectOption(option);
    }
  }), isClipped && /*#__PURE__*/React__default.createElement(Tooltip$1, null, option.label || option.value));
};
var MultiSelectedOptionsRenderer = /*#__PURE__*/React__default.memo(function (_ref4) {
  var selectionState = _ref4.selectionState,
    _unselectOption2 = _ref4.unselectOption,
    isRequireAcceptOnChange = _ref4.isRequireAcceptOnChange,
    isDisabled = _ref4.isDisabled;
  var containerRef = useRef(null);
  var remainderChipRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    overflowState = _useState2[0],
    setOverflowState = _useState2[1];
  var previousSelectedOptions = useRef(null);
  useLayoutEffect(function () {
    var remainderChipMinSize = 55;
    var viableChipMinSize = 60;
    var rightBound = containerRef.current.clientWidth;
    var clippedChildIndex = null;
    var currentChild = containerRef.current.lastChild;
    var collapsedCount = 0;
    var index = selectionState.selectedOptions.length - 1;
    if (currentChild === remainderChipRef.current) {
      currentChild = currentChild.previousSibling;
    }
    while (!clippedChildIndex && currentChild) {
      if (currentChild.offsetLeft >= rightBound) {
        //Completely out
        collapsedCount = collapsedCount + 1;
      } else if (currentChild.offsetLeft + currentChild.offsetWidth >= rightBound) {
        //clipped
        var visibleSize = rightBound - currentChild.offsetLeft;
        if (collapsedCount > 0) {
          if (visibleSize > viableChipMinSize + remainderChipMinSize) {
            clippedChildIndex = index;
          } else {
            collapsedCount = collapsedCount + 1;
          }
        } else if (visibleSize > viableChipMinSize) {
          clippedChildIndex = index;
        } else {
          collapsedCount = collapsedCount + 1;
        }
      } else if (currentChild.offsetLeft + currentChild.offsetWidth >= rightBound - remainderChipMinSize) {
        //clipped cause of remainder chip
        var _visibleSize = rightBound - remainderChipMinSize - currentChild.offsetLeft;
        if (_visibleSize < viableChipMinSize) {
          collapsedCount = collapsedCount + 1;
        } else {
          clippedChildIndex = index;
        }
      }
      currentChild = currentChild.previousSibling;
      index = index - 1;
    }
    previousSelectedOptions.current = selectionState.selectedOptions;
    setOverflowState({
      clippedChildIndex: clippedChildIndex,
      collapsedCount: collapsedCount
    });
  }, [selectionState.selectedOptions]);
  var isCalculating = previousSelectedOptions.current !== selectionState.selectedOptions;
  var remainingOptions = (overflowState === null || overflowState === void 0 ? void 0 : overflowState.collapsedCount) > 0 ? _$1.takeRight(selectionState.selectedOptions, overflowState === null || overflowState === void 0 ? void 0 : overflowState.collapsedCount) : [];
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["multi-value"],
    ref: containerRef
  }, selectionState.selectedOptions.map(function (option, index) {
    var _option$value;
    var style = undefined;
    var isClipped = false;
    if (!overflowState || isCalculating) {
      style = {
        opacity: 0
      };
    } else if (index >= selectionState.selectedOptions.length - overflowState.collapsedCount) {
      style = {
        display: "none"
      };
    } else if (index === overflowState.clippedChildIndex) {
      style = {
        overflow: "hidden"
      };
      isClipped = true;
    }
    return /*#__PURE__*/React__default.createElement(MultiSelectedOptionChip, {
      isRequireAcceptOnChange: isRequireAcceptOnChange,
      style: style,
      isClipped: isClipped,
      unselectOption: _unselectOption2,
      key: ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.id) || option.value,
      option: option,
      isDisabled: isDisabled
    });
  }), remainingOptions.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["multi-value-remainder-chip"],
    ref: remainderChipRef
  }, "+", remainingOptions.length, /*#__PURE__*/React__default.createElement(Tooltip$1, {
    contentClassName: styles$Q["multi-value-remainder-tooltip-content"]
  }, remainingOptions.map(function (option) {
    var _option$value2;
    var noRemove = isRequireAcceptOnChange || option.noRemove;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: ((_option$value2 = option.value) === null || _option$value2 === void 0 ? void 0 : _option$value2.id) || option.value
    }, /*#__PURE__*/React__default.createElement(Span, {
      ellipsis: true,
      level: 13
    }, option.label || option.value), !noRemove && !isDisabled && /*#__PURE__*/React__default.createElement(RemoveButton, {
      unselectOption: function unselectOption() {
        return _unselectOption2(option);
      }
    }));
  }))));
});
var SelectedOptionRenderer = function SelectedOptionRenderer(_ref5) {
  var selectionState = _ref5.selectionState,
    showSecondaryLabelInSelectedOption = _ref5.showSecondaryLabelInSelectedOption,
    isDisabled = _ref5.isDisabled;
  var _selectionState$selec = selectionState.selectedOptions[0],
    label = _selectionState$selec.label,
    value = _selectionState$selec.value,
    secondaryLabel = _selectionState$selec.secondaryLabel;
  return /*#__PURE__*/React__default.createElement("div", {
    disabled: isDisabled,
    className: styles$Q["single-value"]
  }, label || value, showSecondaryLabelInSelectedOption && secondaryLabel && " | ".concat(secondaryLabel));
};

var valueToState = function valueToState(value, isMulti) {
  var valuesSet = new Set();
  if (!value || isMulti && _$1.isArray(value) && (value === null || value === void 0 ? void 0 : value.length) === 0) {
    return null;
  }
  var valueAsArray = _$1.isArray(value) ? value : [value];
  if (isMulti) {
    _$1.forEach(valueAsArray, function (v) {
      valuesSet.add(v.value);
    });
  } else {
    valuesSet.add(valueAsArray[0].value);
  }
  return {
    selectedOptions: valueAsArray,
    valuesSet: valuesSet
  };
};
var Label$1 = function Label(_ref) {
  var labelClassName = _ref.labelClassName,
    labelStyle = _ref.labelStyle,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(labelClassName, styles$Q["label"]),
    style: labelStyle
  }, children);
};
var useStateManager = function useStateManager(componentId, isRequireAcceptOnChange, value, isMulti, onChange, name, isMenuOpen, isSelectAll, options) {
  var stateRef = useRef(null);
  var _useState = useState(isRequireAcceptOnChange ? value : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  var selectionState = useMemo(function () {
    return valueToState(value, isMulti);
  }, [value, isMulti]);
  var internalSelectionState = useMemo(function () {
    if (!isRequireAcceptOnChange) {
      return null;
    }
    return valueToState(internalValue, isMulti);
  }, [internalValue, isMulti, isRequireAcceptOnChange]);
  stateRef.current = {
    selectionState: selectionState,
    internalSelectionState: internalSelectionState,
    internalValue: internalValue,
    value: value
  };
  var updateValue = useCallback(function (newValueOrFunction) {
    var _stateRef$current = stateRef.current,
      internalSelectionState = _stateRef$current.internalSelectionState,
      externalSelectionState = _stateRef$current.selectionState;
    var selectionState = isRequireAcceptOnChange ? internalSelectionState : externalSelectionState;
    var newValue = _$1.isFunction(newValueOrFunction) ? newValueOrFunction(selectionState) : newValueOrFunction;
    if (isRequireAcceptOnChange) {
      setInternalValue(newValue);
    } else {
      onChange(newValue, {
        name: name
      });
    }
  }, [onChange, name, isRequireAcceptOnChange]);
  var acceptChanges = useCallback(function () {
    onChange(stateRef.current.internalValue, {
      name: name
    });
  }, [onChange, name]);
  useEffect(function () {
    if (isMenuOpen) {
      setInternalValue(stateRef.current.value);
    }
  }, [isMenuOpen]);
  var clearAll = useCallback(function (e) {
    /**
     * Some wierd propagation shit is happening, so if the click isn't within the button, don't handle it
     */
    var boundingRect = e.target.getBoundingClientRect();
    if (e.clientX < boundingRect.x || e.clientX > boundingRect.x + boundingRect.width || e.clientY < boundingRect.y || e.clientY > boundingRect.y + boundingRect.height) {
      return;
    }
    updateValue(null);
    e.__multiSelectClear = componentId.current;
  }, [updateValue, componentId]);
  var toggleOption = useCallback(function (option) {
    updateValue(function (selectionState) {
      var isSelected = (selectionState === null || selectionState === void 0 ? void 0 : selectionState.valuesSet.has(option.value)) || false;
      if (isSelectAll && option.isSelectAllOption) {
        var _selectionState$selec;
        var isAllOptionsSelected = options.filter(function (option) {
          return !option.isSelectAllOption;
        }).length === ((_selectionState$selec = selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectedOptions.length) !== null && _selectionState$selec !== void 0 ? _selectionState$selec : 0);
        return isAllOptionsSelected ? [] : options;
      }
      if (isMulti) {
        if (isSelected) {
          return _$1.reject(selectionState.selectedOptions, {
            value: option.value
          });
        } else {
          if (!selectionState) {
            return [option];
          } else {
            return selectionState.selectedOptions.concat(option);
          }
        }
      } else {
        return option;
      }
    });
  }, [updateValue, isMulti, options]);
  var unselectOption = useCallback(function (option) {
    if (isMulti) {
      updateValue(function (selectionState) {
        return _$1.reject(selectionState.selectedOptions, {
          value: option.value
        });
      });
    } else {
      updateValue(function (selectionState) {
        return selectionState !== null && selectionState !== void 0 && selectionState.valuesSet.has(option.value) ? null : selectionState.selectedOptions;
      });
    }
  }, [updateValue, isMulti]);
  var createOption = useCallback(function (value) {
    var _stateRef$current$sel;
    var existingOption = _$1.find((_stateRef$current$sel = stateRef.current.selectionState) === null || _stateRef$current$sel === void 0 ? void 0 : _stateRef$current$sel.selectedOptions, {
      value: value
    });
    if (existingOption) {
      var _stateRef$current$sel2;
      //if option with same value exists, toggle it only if its not currently selected
      if (!((_stateRef$current$sel2 = stateRef.current.selectionState) !== null && _stateRef$current$sel2 !== void 0 && _stateRef$current$sel2.valuesSet.has(value))) {
        toggleOption(existingOption);
      }
    } else {
      toggleOption({
        value: value,
        label: value,
        _isNew: true
      });
    }
  }, [toggleOption]);
  return {
    selectionState: selectionState,
    internalSelectionState: internalSelectionState,
    toggleOption: toggleOption,
    unselectOption: unselectOption,
    clearAll: clearAll,
    acceptChanges: acceptChanges,
    createOption: createOption
  };
};
var Select = /*#__PURE__*/React__default.memo(function (_ref2) {
  var placeholder = _ref2.placeholder,
    value = _ref2.value,
    isLoading = _ref2.isLoading,
    showSecondaryLabelInSelectedOption = _ref2.showSecondaryLabelInSelectedOption,
    isDisabled = _ref2.isDisabled,
    options = _ref2.options,
    isClearable = _ref2.isClearable,
    onChange = _ref2.onChange,
    name = _ref2.name,
    hasError = _ref2.hasError,
    menuPortalTarget = _ref2.menuPortalTarget,
    isSearchable = _ref2.isSearchable,
    isMulti = _ref2.isMulti,
    noOptionsMessage = _ref2.noOptionsMessage,
    isRequireAcceptOnChange = _ref2.isRequireAcceptOnChange,
    isCreatable = _ref2.isCreatable,
    _ref2$creationText = _ref2.creationText,
    creationText = _ref2$creationText === void 0 ? "Add" : _ref2$creationText,
    menuClassName = _ref2.menuClassName,
    menuStyle = _ref2.menuStyle,
    inputClassName = _ref2.inputClassName,
    dataTestId = _ref2.dataTestId;
  var componentId = useRef(crypto.randomUUID());
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMenuOpen = _useState4[0],
    setMenuOpen = _useState4[1];
  var controlRef = useRef(null);
  var _useStateManager = useStateManager(componentId, isRequireAcceptOnChange, value, isMulti, onChange, name, isMenuOpen),
    selectionState = _useStateManager.selectionState,
    internalSelectionState = _useStateManager.internalSelectionState,
    toggleOption = _useStateManager.toggleOption,
    unselectOption = _useStateManager.unselectOption,
    clearAll = _useStateManager.clearAll,
    acceptChanges = _useStateManager.acceptChanges,
    createOption = _useStateManager.createOption;
  var handleKeyDown = isDisabled || isLoading ? undefined : function (e) {
    if (e.key === 'Enter' || e.key === 'Backspace') {
      setMenuOpen(function (isOpen) {
        return !isOpen;
      });
      e.stopPropagation();
      e.preventDefault();
    }
  };
  var onClick = useCallback(function (e) {
    var _e$nativeEvent;
    e.preventDefault();
    if (e.__multiSelectClose === componentId.current || (e === null || e === void 0 || (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : _e$nativeEvent.__multiSelectClose) === componentId.current || e.__multiSelectRemove || e !== null && e !== void 0 && e.nativeEvent.__multiSelectRemove || e.__multiSelectClear || e !== null && e !== void 0 && e.nativeEvent.__multiSelectClear || e.__multiSelectMainClick || e !== null && e !== void 0 && e.nativeEvent.__multiSelectMainClick) {
      return;
    }
    e.__multiSelectMainClick = componentId.current;
    setMenuOpen(function (isOpen) {
      return !isOpen;
    });
  }, [setMenuOpen]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    "data-testid": dataTestId,
    "aria-label": name,
    className: classNames(inputClassName, styles$Q["control"], _defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$Q["invalid"], hasError), styles$Q["disabled"], isDisabled), styles$Q["open"], isMenuOpen)),
    onClick: isDisabled || isLoading ? undefined : onClick,
    ref: controlRef,
    tabIndex: isDisabled ? -1 : 0,
    onKeyDown: handleKeyDown
  }, !selectionState && /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["placeholder"]
  }, placeholder || "Select..."), isLoading && /*#__PURE__*/React__default.createElement(ThreeDotLoader, {
    className: styles$Q["loading"]
  }), selectionState && !isMulti && /*#__PURE__*/React__default.createElement(SelectedOptionRenderer, {
    selectionState: selectionState,
    showSecondaryLabelInSelectedOption: showSecondaryLabelInSelectedOption,
    isDisabled: isDisabled
  }), selectionState && isMulti && /*#__PURE__*/React__default.createElement(MultiSelectedOptionsRenderer, {
    unselectOption: unselectOption,
    toggleOption: toggleOption,
    name: name,
    selectionState: selectionState,
    showSecondaryLabelInSelectedOption: showSecondaryLabelInSelectedOption,
    isRequireAcceptOnChange: isRequireAcceptOnChange,
    isDisabled: isDisabled
  }), !isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q["controls"]
  }, isClearable && !isDisabled && selectionState && /*#__PURE__*/React__default.createElement("button", {
    onClick: clearAll
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), isMenuOpen ? /*#__PURE__*/React__default.createElement(DropdownArrowUpIcon, null) : /*#__PURE__*/React__default.createElement(DropdownArrowDownIcon, null))), isMenuOpen && /*#__PURE__*/React__default.createElement(Menu$1, {
    noOptionsMessage: noOptionsMessage,
    options: options,
    name: name,
    unselectOption: unselectOption,
    toggleOption: toggleOption,
    selectionState: isRequireAcceptOnChange ? internalSelectionState : selectionState,
    controlRef: controlRef,
    setMenuOpen: setMenuOpen,
    menuPortalTarget: menuPortalTarget,
    isSearchable: isSearchable,
    isCreatable: isCreatable,
    creationText: creationText,
    isMulti: isMulti,
    componentId: componentId,
    isRequireAcceptOnChange: isRequireAcceptOnChange,
    acceptChanges: acceptChanges,
    createOption: createOption,
    className: menuClassName,
    style: menuStyle
  }));
});

var _excluded$8 = ["isOptional", "label", "labelChildren", "useLabelMargin", "bottomMargin", "type", "name", "onChange", "value", "errorMessage", "showError", "errorType", "isDisabled", "disabled", "inputChildren", "inputButtons", "inputChildrenClassName", "inputChildrenStyle", "className", "style", "inputStyle", "labelStyle", "inputClassName", "labelClassName", "errorClassName", "errorStyle", "menuClassName", "menuStyle", "pending", "showSecondaryLabelInSelectedOption", "placeholder", "isLoading", "noOptionsMessage", "options", "isClearable", "menuPortalTarget", "isSearchable", "isMulti", "isRequireAcceptOnChange", "isCreatable", "creationText", "dataTestId", "ref"],
  _excluded2$2 = ["ref"];
var FormFieldSelect = /*#__PURE__*/React__default.memo(function (_ref) {
  var isOptional = _ref.isOptional,
    label = _ref.label,
    labelChildren = _ref.labelChildren,
    useLabelMargin = _ref.useLabelMargin,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? true : _ref$bottomMargin;
    _ref.type;
    var name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    errorMessage = _ref.errorMessage,
    showError = _ref.showError,
    errorType = _ref.errorType,
    isDisabled = _ref.isDisabled,
    disabled = _ref.disabled;
    _ref.inputChildren;
    _ref.inputButtons;
    _ref.inputChildrenClassName;
    _ref.inputChildrenStyle;
    var className = _ref.className,
    style = _ref.style;
    _ref.inputStyle;
    var labelStyle = _ref.labelStyle,
    inputClassName = _ref.inputClassName,
    labelClassName = _ref.labelClassName,
    errorClassName = _ref.errorClassName,
    errorStyle = _ref.errorStyle,
    menuClassName = _ref.menuClassName,
    menuStyle = _ref.menuStyle;
    _ref.pending;
    var showSecondaryLabelInSelectedOption = _ref.showSecondaryLabelInSelectedOption,
    placeholder = _ref.placeholder,
    isLoading = _ref.isLoading,
    noOptionsMessage = _ref.noOptionsMessage,
    options = _ref.options,
    isClearable = _ref.isClearable,
    menuPortalTarget = _ref.menuPortalTarget,
    isSearchable = _ref.isSearchable,
    isMulti = _ref.isMulti,
    isRequireAcceptOnChange = _ref.isRequireAcceptOnChange,
    isCreatable = _ref.isCreatable,
    creationText = _ref.creationText,
    dataTestId = _ref.dataTestId,
    ref = _ref.ref;
    _objectWithoutProperties$2(_ref, _excluded$8);
  var hasError = showError && errorMessage;
  if (_$1.isUndefined(isDisabled) && disabled === true) {
    isDisabled = true;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$Q.base, _defineProperty$3({}, styles$Q['margin-bottom'], bottomMargin), className),
    style: style,
    ref: ref,
    "data-testid": dataTestId && "".concat(dataTestId, "-wrapper")
  }, /*#__PURE__*/React__default.createElement(LabelChildren, {
    disabled: isDisabled,
    isOptional: isOptional,
    labelChildren: labelChildren
  }), /*#__PURE__*/React__default.createElement("label", {
    className: classNames(_defineProperty$3({}, styles$Q["disabled"], isDisabled))
  }, label && /*#__PURE__*/React__default.createElement(Label$1, {
    labelClassName: labelClassName,
    labelStyle: labelStyle
  }, label), useLabelMargin && /*#__PURE__*/React__default.createElement("span", {
    className: classNames(labelClassName, styles$Q["label"]),
    style: labelStyle
  }, "\xA0"), /*#__PURE__*/React__default.createElement(Select, {
    inputClassName: classNames(inputClassName),
    placeholder: placeholder,
    value: value,
    isLoading: isLoading,
    showSecondaryLabelInSelectedOption: showSecondaryLabelInSelectedOption,
    isDisabled: isDisabled,
    options: options,
    isClearable: !isRequireAcceptOnChange && isClearable,
    onChange: onChange,
    name: name,
    hasError: hasError,
    menuPortalTarget: menuPortalTarget,
    isSearchable: isSearchable || isCreatable,
    isMulti: isMulti,
    noOptionsMessage: noOptionsMessage,
    isRequireAcceptOnChange: isRequireAcceptOnChange,
    isCreatable: isCreatable,
    creationText: creationText,
    menuClassName: menuClassName,
    menuStyle: menuStyle,
    dataTestId: dataTestId
  })), /*#__PURE__*/React__default.createElement(Error$1, {
    showError: showError,
    errorClassName: errorClassName,
    errorStyle: errorStyle,
    errorType: errorType,
    errorMessage: errorMessage,
    dataTestId: dataTestId && "".concat(dataTestId, "-error")
  }));
});
var FormFieldSelect$1 = (function (_ref2) {
  var ref = _ref2.ref,
    rest = _objectWithoutProperties$2(_ref2, _excluded2$2);
  return /*#__PURE__*/React__default.createElement(Formidable, _extends$j({}, rest, {
    ref: ref,
    Component: FormFieldSelect
  }));
});

var styles$O = {"base":"InlineSelectorStyles-module_base__2-gmg","marginBottom":"InlineSelectorStyles-module_marginBottom__2qqnP","controlWrapper":"InlineSelectorStyles-module_controlWrapper__1U8u-","tooltip":"InlineSelectorStyles-module_tooltip__2lcGn","control":"InlineSelectorStyles-module_control__AOS1H","disabled":"InlineSelectorStyles-module_disabled__1AsAv","controls":"InlineSelectorStyles-module_controls__12uqR","invalid":"InlineSelectorStyles-module_invalid__3vfJ5","placeholder":"InlineSelectorStyles-module_placeholder__t6QSn","loading":"InlineSelectorStyles-module_loading__28paH","menu":"InlineSelectorStyles-module_menu__mX_-y","ported-menu":"InlineSelectorStyles-module_ported-menu__3MmhN","option":"InlineSelectorStyles-module_option__25mxG","selected":"InlineSelectorStyles-module_selected__-ICdZ","value":"InlineSelectorStyles-module_value__AEU-n","bgshimmer":"InlineSelectorStyles-module_bgshimmer__38r4d"};

var InlineSelector = React__default.memo((_a) => {
    var _b, _c;
    var { onChange, value, options, name, isLoading, isDisabled, className, style, tooltip, hasError, placeholder, isClearable, errorClassName, errorStyle, errorMessage, showError, errorType, menuClassName, menuStyle, isSearchable, bottomMargin = true, isMulti, isRequireAcceptOnChange, selectionLabel, isSelectAll } = _a, rest = __rest(_a, ["onChange", "value", "options", "name", "isLoading", "isDisabled", "className", "style", "tooltip", "hasError", "placeholder", "isClearable", "errorClassName", "errorStyle", "errorMessage", "showError", "errorType", "menuClassName", "menuStyle", "isSearchable", "bottomMargin", "isMulti", "isRequireAcceptOnChange", "selectionLabel", "isSelectAll"]);
    if ((options === null || options === void 0 ? void 0 : options.length) === 0) {
        isDisabled = true;
    }
    const componentId = useRef(crypto.randomUUID());
    const [isMenuOpen, setMenuOpen] = useState(false);
    const controlRef = useRef(null);
    const handleKeyDown = (isDisabled || isLoading) ? undefined : e => {
        if (e.key === 'Enter' || e.key === 'Backspace') {
            setMenuOpen(isOpen => !isOpen);
            e.stopPropagation();
            e.preventDefault();
        }
    };
    const onClick = useCallback((e) => {
        var _a;
        if (e.__multiSelectClose === componentId.current || ((_a = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _a === void 0 ? void 0 : _a.__multiSelectClose) === componentId.current ||
            e.__multiSelectRemove || (e === null || e === void 0 ? void 0 : e.nativeEvent.__multiSelectRemove) ||
            e.__multiSelectClear || (e === null || e === void 0 ? void 0 : e.nativeEvent.__multiSelectClear)) {
            return;
        }
        setMenuOpen(isOpen => !isOpen);
        e.preventDefault();
    }, [setMenuOpen]);
    const { selectionState, internalSelectionState, toggleOption, unselectOption, clearAll, acceptChanges, createOption } = useStateManager(componentId, isRequireAcceptOnChange, value, isMulti, onChange, name, isMenuOpen, isSelectAll, options);
    const _value = first((_b = selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectedOptions) !== null && _b !== void 0 ? _b : []);
    const _label = ((_c = selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectedOptions) !== null && _c !== void 0 ? _c : []).map(option => option.label || option.value);
    return jsxs("div", Object.assign({ className: classNames(styles$O.base, { [styles$O.marginBottom]: bottomMargin }, className), style: style }, rest, { children: [jsxs("div", { className: styles$O.controlWrapper, children: [tooltip && jsx$3(Popover$1, { triggerClassName: styles$O.tooltip, children: tooltip }), jsxs("div", { role: "button", "aria-label": name, ref: controlRef, className: classNames(styles$O["control"], {
                            [styles$O["invalid"]]: hasError,
                            [styles$O["disabled"]]: isDisabled,
                            [styles$O["open"]]: isMenuOpen
                        }), tabIndex: isDisabled ? -1 : 0, onKeyDown: handleKeyDown, onClick: (isDisabled || isLoading) ? undefined : onClick, children: [!_value && (selectionLabel ? jsx$3("div", { className: styles$O.value, children: selectionLabel }) :
                                jsx$3("div", { className: styles$O["placeholder"], children: placeholder || "Select..." })), _value &&
                                jsx$3("div", { className: styles$O.value, children: selectionState.selectedOptions.length > 1 || selectionLabel ? `${selectionLabel} (${selectionState.selectedOptions.length})` : _label }), isLoading && jsx$3(ThreeDotLoader, { className: styles$O["loading"] }), !isLoading && jsxs("div", { className: styles$O["controls"], children: [isClearable && _value && jsx$3("button", { onClick: clearAll, children: jsx$3(CloseIcon, {}) }), isMenuOpen ? jsx$3(DropdownArrowUpIcon, {}) : jsx$3(DropdownArrowDownIcon, {})] })] })] }), !isEmpty(_label) && !isMenuOpen && jsx$3(Tooltip$1, { nowrap: true, children: _label.map((label) => jsx$3(Text, { nowrap: true, children: label }, label)) }), jsx$3(Error$1, { showError: showError, errorClassName: errorClassName, errorStyle: errorStyle, errorType: errorType, errorMessage: errorMessage }), isMenuOpen &&
                jsx$3(Menu$1, { selectionState: isRequireAcceptOnChange ? internalSelectionState : selectionState, toggleOption: toggleOption, setMenuOpen: setMenuOpen, componentId: componentId, options: options, className: classNames(styles$O.menu, menuClassName), style: menuStyle, isSearchable: isSearchable, isMulti: isMulti, isRequireAcceptOnChange: isRequireAcceptOnChange, unselectOption: unselectOption, acceptChanges: acceptChanges, createOption: createOption, isSelectAll: isMulti && isSelectAll, selectAllLabel: isSelectAll && selectionLabel ? `Select all` : undefined })] }));
});

var styles$N = {"base":"NoForm-module_base__20PNt"};

const NoForm = ({ style, className, children }) => {
    return jsx$3("form", { className: classNames(className, styles$N.base), style: style, onSubmit: e => {
            e.preventDefault();
            return false;
        }, children: children });
};

const BreadcrumbsContainer = ({ children, className, style }) => {
    return jsx$3("div", { className: classNames(styles$17['breadcrumbs-container'], className), style: style, "data-testid": 'breadcrumb-container', children: children });
};

const BreadcrumbsWidgets = ({ children }) => {
    return jsx$3("div", { className: styles$17.breadcrumbsWidgets, "data-testid": 'breadcrumb-widgets', children: children });
};

const Content = ({ className, style, children, white, dataTestId }) => {
    return jsx$3("section", { className: classNames(styles$17.content, className, { [styles$17["white"]]: white }), style: style, "data-testid": dataTestId, children: children });
};

const Container = ({ className, style, children, dataTestId }) => {
    return jsx$3("section", { className: classNames(styles$17.container, className), style: style, "data-testid": dataTestId, children: children });
};

var Column = function Column(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$17.column, className),
    style: style,
    "data-testid": dataTestId
  }, children);
};
var Column$1 = Column;

const Page = ({ className, style, children, dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$17.page, className), style: style, "data-testid": dataTestId, children: children });
};

var FixedPanel = /*#__PURE__*/React__default.memo(function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    forwardRef = _ref.ref;
  var localRef = useRef();
  var ref = forwardRef || localRef;
  useLayoutEffect(function () {
    var _ref$current$parentNo = ref.current.parentNode.getBoundingClientRect(),
      top = _ref$current$parentNo.top;
    ref.current.style.top = "".concat(top, "px");
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: classNames(styles$17['fixed-panel'], className),
    style: style
  }, children);
});
var FixedPanel$1 = FixedPanel;

var StickyContainer = function StickyContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    _ref$includeTopPaddin = _ref.includeTopPadding,
    includeTopPadding = _ref$includeTopPaddin === void 0 ? false : _ref$includeTopPaddin;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$17['sticky-container'], className, _defineProperty$3({}, styles$17['with-top-padding'], includeTopPadding)),
    style: style
  }, children);
};
var StickyContainer$1 = StickyContainer;

const SplitPane = ({ left, right, split = 8, dataTestId }) => {
    return jsxs("div", { className: classNames(styles$17.splitPane, styles$17["s_" + split]), "data-testid": dataTestId, children: [jsx$3("div", { children: left }), jsx$3("div", { children: right })] });
};

const GridBreak = () => {
    return jsx$3(GridItem, { lg: 12 });
};
const Grid = ({ children, className, style, centerContent = false, variant = "flex", columns, rowGap, dataTestId }) => {
    return jsx$3("div", { className: classNames(className, columns ? styles$17["c_" + columns] : styles$17.default, variant === "flex" ? styles$17.grid : styles$17.rigidGrid, rowGap && styles$17[`gap-${rowGap}`], { [styles$17['center-content']]: centerContent }), style: style, "data-testid": dataTestId, children: children });
};
const GridItem = ({ children, className, style, grow, lg, md, sm, dataTestId }) => {
    return jsx$3("div", { className: classNames(className, styles$17['grid-item'], grow && styles$17.grow, lg && styles$17[`lg-${lg}`], md && styles$17[`md-${md}`], sm && styles$17[`sm-${sm}`]), style: style, "data-testid": dataTestId, children: children });
};

var styles$M = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"TabHeader-module_base__GPqMp","service":"TabHeader-module_service__EDqZx","tab-widgets":"TabHeader-module_tab-widgets__2Za3F"};

var TabHeader = (function (_ref) {
  var logo = _ref.logo,
    Icon = _ref.Icon,
    label = _ref.label,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("header", {
    className: styles$M.base
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$M["service"]
  }, logo && /*#__PURE__*/React__default.createElement(InlineSVG, {
    src: logo
  }), Icon && /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement(Heading, {
    level: 20,
    color: "text-title"
  }, label)), children);
});

var styles$L = {"container":"TabLinks-module_container__3rBc2","link":"TabLinks-module_link__2OZXG"};

var TabLinks = ({ children: _children = [] }) => {
    const children = _$1.isArray(_children) ? _children : [_children];
    return jsx$3("div", { className: styles$L['container'], children: children.map((child, index) => {
            var _a, _b;
            if (child) {
                return React__default.cloneElement(child, { key: index, activeClassName: styles$L['active-link'], className: classNames(styles$L['link'], (_a = child.props) === null || _a === void 0 ? void 0 : _a.className) }, (_b = child.props) === null || _b === void 0 ? void 0 : _b.children);
            }
            else {
                return child;
            }
        }) });
};

var styles$K = {"tab-with-nav":"TabLayout-module_tab-with-nav__1BIjz","nav":"TabLayout-module_nav__QT_e3","content":"TabLayout-module_content__f6hlQ","content-container":"TabLayout-module_content-container__1fUMa","link":"TabLayout-module_link__3ykKJ","active-link":"TabLayout-module_active-link__2pH0O","column-content":"TabLayout-module_column-content__gWk7I","bgshimmer":"TabLayout-module_bgshimmer__3AkdK"};

var InnerNav = /*#__PURE__*/React__default.memo(function (_ref) {
  var _ref$children = _ref.children,
    _children = _ref$children === void 0 ? [] : _ref$children;
  var children = _$1.filter(_$1.isArray(_children) ? _children : [_children], _$1.identity);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$K.nav
  }, children.map(function (child, index) {
    var _child$props, _child$props2;
    return /*#__PURE__*/React__default.cloneElement(child, {
      key: index,
      activeClassName: styles$K['active-link'],
      className: classNames(styles$K['link'], (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className)
    }, (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.children);
  }));
});
var InnerNav$1 = InnerNav;

var TabWidgets = function TabWidgets(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$M['tab-widgets'], className)
  }, children);
};
var TabWidgets$1 = TabWidgets;

var TabWithNavContent = function TabWithNavContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$K['content']
  }, children);
};
var TabWithNavContentContainer = function TabWithNavContentContainer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$K['content-container']
  }, children);
};
var TabWithNav = function TabWithNav(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$K['tab-with-nav']
  }, children);
};

var styles$J = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"SlidingManagementWidget-module_base__19uTd","header":"SlidingManagementWidget-module_header__3tTVc","back-button":"SlidingManagementWidget-module_back-button__3JtFB","bgshimmer":"SlidingManagementWidget-module_bgshimmer__1D7HM"};

var SlidingManagementWidgetBackButton = function SlidingManagementWidgetBackButton(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: classNames(typography.body14, styles$J['back-button'], className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(ArrowLeftIcon, null), /*#__PURE__*/React__default.createElement("span", null, "Back"));
};
var SlidingManagementWidgetHeader = function SlidingManagementWidgetHeader(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("header", {
    className: styles$J.header
  }, children);
};
var SlidingManagementWidget = (function (_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React__default.createElement(PopoverContext, {
    Component: "section",
    className: styles$J.base
  }, children);
});

let loadCount = 1;
const decrement = () => {
    loadCount = loadCount - 1;
    if (loadCount === 0) {
        document.getElementById("main-loader").style.display = "none";
    }
};
const increment$1 = () => {
    loadCount = loadCount + 1;
    if (loadCount === 1) {
        document.getElementById("main-loader").style.display = "block";
    }
};
const removeMainLoader = _$1.once((ignoreTimer = false) => {
    const now = (new Date()).valueOf();
    // @ts-ignore
    const then = window.__loadStart;
    const diff = now - then;
    if (diff < 1400 && !ignoreTimer) {
        setTimeout(() => {
            decrement();
        }, 1400 - diff);
    }
    else {
        decrement();
    }
});
var MainLoader = () => {
    useEffect(() => {
        increment$1();
        return decrement;
    }, []);
    return jsx$3(Fragment, {});
};

var DialogLazy = ({ children }) => {
    return jsx$3(Suspense, { fallback: jsx$3(MainLoader, {}), children: children });
};

var styles$I = {"track":"ProgressLoader-module_track__2URLg","small":"ProgressLoader-module_small__qX0Tt","thumb":"ProgressLoader-module_thumb__25erM","indeterminate":"ProgressLoader-module_indeterminate__3a2xE","move-it-move-it":"ProgressLoader-module_move-it-move-it__3bzZU"};

var ProgressLoader = ({ percent, thumbClassName, thumbStyle, className, style, indeterminate, size = "large" }) => {
    return jsx$3("div", { className: classNames(styles$I.track, className, { [styles$I['indeterminate']]: indeterminate, [styles$I['small']]: size === "small" }), style: style, children: jsx$3("div", { className: classNames(styles$I.thumb, thumbClassName), style: Object.assign(Object.assign({}, thumbStyle), { width: indeterminate ? undefined : `${percent}%` }) }) });
};

var SvgLazy = React__default.memo(({ srcP }) => {
    const [src, setSrc] = useState(null);
    useEffect(() => {
        srcP.then(src => {
            setSrc(src.default);
        });
    }, []);
    if (!src) {
        return jsx$3("span", {});
    }
    else {
        return jsx$3(InlineSVG, { src: src });
    }
});

const Loader = () => jsx$3("div", { style: { display: "flex", justifyContent: "center", padding: 40 }, children: jsx$3(ComponentLoader, {}) });
var ComponentLazy = ({ children }) => jsx$3(Suspense, { fallback: jsx$3(Loader, {}), children: children });

var styles$H = {"base":"LoadingMask-module_base__AySly","bgshimmer":"LoadingMask-module_bgshimmer__1gSsy"};

const LoadingMask = ({ className, style }) => {
    return jsx$3("div", { className: classNames(styles$H.base, className), style: style, children: jsx$3("div", {}) });
};

var styles$G = {"base":"SlidingHeaderMenu-module_base__3bWIv","header":"SlidingHeaderMenu-module_header__j1NRr","title-center":"SlidingHeaderMenu-module_title-center__1_Ow8","title":"SlidingHeaderMenu-module_title__1-zG5","icon":"SlidingHeaderMenu-module_icon__3w8tR","container":"SlidingHeaderMenu-module_container__3KLdh","bgshimmer":"SlidingHeaderMenu-module_bgshimmer__1_Qvl"};

var slidingMenuStyles = {"sliding-menu":"SlidingMenu-module_sliding-menu__3oVJD","sliding-menu-mask":"SlidingMenu-module_sliding-menu-mask__3MRXB"};

var animationStyles = {"enter":"animationStyles-module_enter__3qhaM","enter-active":"animationStyles-module_enter-active__10v6A","exit":"animationStyles-module_exit__M2cf0","exit-active":"animationStyles-module_exit-active__37DkH"};

var slideInClassNames = {
  enter: animationStyles['enter'],
  enterActive: animationStyles['enter-active'],
  exit: animationStyles['exit'],
  exitActive: animationStyles['exit-active']
};
var SlidingMenu = (function (_ref) {
  var children = _ref.children,
    isActive = _ref.isActive,
    closeTrigger = _ref.closeTrigger,
    className = _ref.className,
    top = _ref.top,
    maskClassName = _ref.maskClassName;
  var nodeRef = React__default.useRef(null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CSSTransition, {
    nodeRef: nodeRef,
    classNames: slideInClassNames,
    "in": isActive,
    unmountOnExit: true,
    timeout: 400
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: nodeRef,
    className: classNames(slidingMenuStyles["sliding-menu"], className),
    style: {
      top: top
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isActive && /*#__PURE__*/React__default.createElement(ClickAway, {
    ignoreParentClick: true,
    listener: function listener(e) {
      closeTrigger(e);
    }
  }), children))), isActive && /*#__PURE__*/React__default.createElement("div", {
    className: classNames(slidingMenuStyles['sliding-menu-mask'], maskClassName),
    style: {
      top: top
    }
  }));
});

var SlidingHeaderMenu = (function (_ref) {
  var title = _ref.title,
    Icon = _ref.Icon,
    ActionButton = _ref.ActionButton,
    HeaderContents = _ref.HeaderContents,
    children = _ref.children,
    isActive = _ref.isActive,
    closeTrigger = _ref.closeTrigger,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    maskClassName = _ref.maskClassName,
    top = _ref.top,
    Footer = _ref.Footer,
    contentClassName = _ref.contentClassName,
    _ref$showOnlyTitle = _ref.showOnlyTitle,
    showOnlyTitle = _ref$showOnlyTitle === void 0 ? false : _ref$showOnlyTitle,
    ref = _ref.ref;
  return /*#__PURE__*/React__default.createElement(SlidingMenu, {
    top: top,
    isActive: isActive,
    closeTrigger: closeTrigger,
    className: containerClassName,
    maskClassName: maskClassName
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: classNames(styles$G.base, className),
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Escape") {
        closeTrigger(e, true);
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$G.header, showOnlyTitle ? styles$G["title-center"] : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$G.title
  }, Icon && /*#__PURE__*/React__default.createElement(Icon, {
    className: styles$G.icon
  }), /*#__PURE__*/React__default.createElement(Heading, {
    level: 16,
    color: "text-title"
  }, title)), !showOnlyTitle && ActionButton && /*#__PURE__*/React__default.createElement(ActionButton, null), !showOnlyTitle && HeaderContents && /*#__PURE__*/React__default.createElement(HeaderContents, null)), /*#__PURE__*/React__default.createElement(PopoverContext, {
    className: classNames(styles$G['container'], contentClassName)
  }, children), Footer && /*#__PURE__*/React__default.createElement(Footer, null)));
});

var styles$F = {"base":"InnerTab-module_base__sst2r","general":"InnerTab-module_general__2IYRV","link":"InnerTab-module_link__3ehJe","disabled":"InnerTab-module_disabled__2Db9B","card":"InnerTab-module_card__3YlHl","expand":"InnerTab-module_expand__1lO_t"};

const Button$1 = ({ isActive, onClick, className, style, children, isDisabled, dataTestId }) => {
    return jsx$3("button", { "data-testid": dataTestId, onClick: onClick, style: style, className: classNames(styles$F['link'], className, { "active": isActive }), disabled: isDisabled, children: children });
};
const Link$1 = ({ to, className, style, children, isDisabled, onClick, dataTestId }) => {
    return jsx$3(NavLink, { "data-testid": dataTestId, to: to, onClick: isDisabled ? e => {
            e.preventDefault();
        } : onClick, className: classNames(styles$F['link'], className), disabled: isDisabled, style: style, children: children });
};
const InnerTab = ({ children, className, style, variant = "general", expand, dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$F.base, className), style: style, children: jsx$3("div", { "data-testid": dataTestId, className: classNames(variant === "general" ? styles$F.general : styles$F.card, { [styles$F.expand]: expand }), children: children }) });
};
InnerTab.Button = Button$1;
InnerTab.Link = Link$1;

var extractValue = function extractValue(row, accessor) {
  return _$1.get(row, accessor);
};
function addIdToTreeRows(rows, childKey, parentId) {
  _$1.forEach(rows, function (row, index) {
    if (_$1.isUndefined(row.id)) {
      row.id = _$1.isUndefined(parentId) ? index : "".concat(parentId, "-").concat(index);
    }
    if (!_$1.isEmpty(row[childKey])) {
      addIdToTreeRows(row[childKey], childKey, row.id);
    }
  });
  return rows;
}
function getFlattenTreeNodes(rows, childKey) {
  var flattenTreeNodes = [];
  _$1.forEach(rows, function (row) {
    if (!_$1.isEmpty(row[childKey])) {
      flattenTreeNodes.push.apply(flattenTreeNodes, _toConsumableArray$1(getFlattenTreeNodes(row[childKey], childKey)));
    }
    flattenTreeNodes.push(row);
  });
  return flattenTreeNodes;
}
function sortTreeNodes(sortState, columnIdToSort, rows, childKey) {
  var sortedNodes = _$1.orderBy(rows, [columnIdToSort], [sortState.sortOrder]);
  _$1.forEach(sortedNodes, function (row) {
    if (!_$1.isEmpty(row[childKey])) {
      row[childKey] = sortTreeNodes(sortState, columnIdToSort, row[childKey], childKey);
    }
  });
  return sortedNodes;
}
var sort = function sort(sortState, columnsMap, rows) {
  return _$1.orderBy(rows, [columnsMap[sortState.column].accessor], [sortState.sortOrder]);
};
var defaultFilter = function defaultFilter(value, row, filter) {
  if (_$1.isArray(value)) {
    var existsOne = _$1.find(value, function (subValue) {
      return filter.values[subValue];
    });
    return !!existsOne;
  } else {
    return !!filter.values[value];
  }
};
var filter = function filter(filterState, rows, columns, columnsMap) {
  var textFilter = filterState.textFilter;
  return _$1.filter(rows, function (row) {
    var lowerCaseTextFilter = textFilter && textFilter.toLowerCase();
    var isTextFilterMatch = !textFilter;
    if (textFilter) {
      _$1.forEach(columns, function (column) {
        var value = extractValue(row, column.accessor);
        if (_$1.isString(value) && value.toLowerCase().includes(lowerCaseTextFilter)) {
          isTextFilterMatch = true;
          return false;
        } else if (_$1.isArray(value) && value.join(", ").toLowerCase().includes(lowerCaseTextFilter)) {
          isTextFilterMatch = true;
          return false;
        }
      });
    }
    var isMultiFilterMatch = true;
    _$1.forEach(filterState.columns, function (filter, key) {
      if (_$1.isObject(filter) && filter.activeCount > 0) {
        var _columnsMap$key = columnsMap[key],
          accessor = _columnsMap$key.accessor,
          filterDefinition = _columnsMap$key.filter;
        var value = extractValue(row, accessor);
        var filterFunc = (filterDefinition === null || filterDefinition === void 0 ? void 0 : filterDefinition.filter) || defaultFilter;
        var match = filterFunc(value, row, filter);
        if (!match) {
          isMultiFilterMatch = false;
          return false;
        }
      }
    });
    return isTextFilterMatch && isMultiFilterMatch;
  });
};
var init = function init(initialState) {
  var sortState = null;
  if (initialState.isSorting) {
    sortState = {
      column: _$1.isString(initialState.columns[0]) ? initialState.columns[0] : initialState.columns[0].id || "0",
      sortOrder: "asc"
    };
  }
  var initialPageState = initialState.pageSize ? {
    pageIndex: 0
  } : undefined;
  var selectionState = undefined;
  if (initialState.defaultSelectionState) {
    var count = _$1.values(initialState.defaultSelectionState.rows).filter(function (value) {
      return !!value;
    }).length;
    var rows = initialState.defaultSelectionState.rows;
    var isMulti = initialState.isMultiSelect !== false || false;
    selectionState = {
      count: count,
      rows: rows,
      isDirty: false,
      isMulti: isMulti
    };
  } else if (initialState.isRowSelecting) {
    selectionState = {
      rows: {},
      count: 0,
      isDirty: false,
      isMulti: initialState.isMultiSelect !== false
    };
  }
  return {
    sortState: initialState.defaultSortState || sortState,
    defaultSortState: initialState.defaultSortState || sortState,
    defaultFilterState: initialState.defaultFilterState || {
      columns: {},
      count: 0
    },
    tableState: _objectSpread2({}, initialState.defaultTableState) || {},
    rowState: {},
    columnState: _objectSpread2({}, initialState.savedColumnState || initialState.defaultColumnState),
    selectionState: selectionState,
    filterState: initialState.defaultFilterState || {
      columns: {},
      count: 0
    },
    pageState: initialPageState,
    initialPageState: initialPageState
  };
};
var reducer = function reducer(state, action) {
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case "TOGGLE-SORT":
      {
        var id = payload.id;
        var newSortState = {};
        var currentSortOrder = state.sortState.sortOrder;
        var currentSortColumn = state.sortState.column;
        if (currentSortColumn === id) {
          if (currentSortOrder === "asc") {
            newSortState.sortOrder = "desc";
            newSortState.column = id;
          } else if (currentSortColumn !== state.defaultSortState.column) {
            newSortState = state.defaultSortState;
          } else {
            newSortState.sortOrder = "asc";
            newSortState.column = id;
          }
        } else {
          newSortState.sortOrder = "asc";
          newSortState.column = id;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          sortState: newSortState,
          pageState: state.initialPageState
        });
      }
    case "SET-FILTER":
      {
        var _id = payload.id,
          values = payload.values;
        var newValues = _$1.pickBy(values);
        var newColumnFilter = {
          values: newValues,
          valuesArray: _$1.values(values),
          activeCount: _$1.size(newValues)
        };
        var columns = _objectSpread2(_objectSpread2({}, state.filterState.columns), {}, _defineProperty$3({}, _id, newColumnFilter));
        var count = 0;
        _$1.forEach(columns, function (state) {
          if (state.activeCount > 0) {
            count = count + 1;
          }
        });
        return _objectSpread2(_objectSpread2({}, state), {}, {
          filterState: _objectSpread2(_objectSpread2({}, state.filterState), {}, {
            columns: columns,
            count: count
          }),
          pageState: state.initialPageState
        });
      }
    case "RESET-FILTERS":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          filterState: _objectSpread2(_objectSpread2({}, state.filterState), state.defaultFilterState),
          pageState: state.initialPageState
        });
      }
    case "UPDATE-ROW":
      {
        var _id2 = payload.id,
          newState = payload.state;
        var currentState = state.rowState[_id2] || {};
        return _objectSpread2(_objectSpread2({}, state), {}, {
          rowState: _objectSpread2(_objectSpread2({}, state.rowState), {}, _defineProperty$3({}, _id2, _objectSpread2(_objectSpread2({}, currentState), newState)))
        });
      }
    case "UPDATE-COLUMN-STATE":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          columnState: payload.state
        });
      }
    case "TOGGLE-ROW-SELECTION":
      {
        var _id3 = payload.id,
          value = payload.value,
          ignoreDirty = payload.ignoreDirty;
        if (state.selectionState.isMulti) {
          var _count = state.selectionState.count;
          var currentValue = state.selectionState.rows[_id3] || false;
          if (currentValue && !value) {
            _count = _count - 1;
          } else if (!currentValue && value) {
            _count = _count + 1;
          }
          return _objectSpread2(_objectSpread2({}, state), {}, {
            selectionState: {
              count: _count,
              rows: _objectSpread2(_objectSpread2({}, state.selectionState.rows), {}, _defineProperty$3({}, _id3, value)),
              isMulti: true,
              isDirty: !ignoreDirty
            }
          });
        } else {
          if (!value) {
            return state;
          } else {
            return _objectSpread2(_objectSpread2({}, state), {}, {
              selectionState: {
                count: 1,
                rows: _defineProperty$3({}, _id3, true),
                isMulti: false,
                isDirty: !ignoreDirty
              }
            });
          }
        }
      }
    case "TOGGLE-SELECT-ALL":
      {
        var _value = payload.value,
          rows = payload.rows,
          resetDirty = payload.resetDirty;
        if (!state.selectionState.isMulti) {
          return state;
        }
        var selectionState = {
          rows: {},
          count: 0,
          allSelected: _value,
          isMulti: true,
          isDirty: !resetDirty
        };
        if (_value) {
          _$1.forEach(rows, function (row) {
            selectionState.rows[row.id] = !row.isDisabled ? _value : false;
          });
          selectionState.count = rows.filter(function (row) {
            return !row.isDisabled;
          }).length;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          selectionState: selectionState
        });
      }
    case "UPDATE-TEXT-FILTER":
      {
        var _value2 = payload.value;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          filterState: _objectSpread2(_objectSpread2({}, state.filterState), {}, {
            textFilter: _value2
          }),
          pageState: state.initialPageState
        });
      }
    case "GO-TO-PAGE":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          pageState: {
            pageIndex: payload.index
          }
        });
      }
  }
  return state;
};
var useTable = (function (_ref) {
  var isSorting = _ref.isSorting,
    isRowSelecting = _ref.isRowSelecting,
    isMultiSelect = _ref.isMultiSelect,
    columns = _ref.columns,
    data = _ref.rows,
    externalSort = _ref.externalSort,
    externalFilter = _ref.externalFilter,
    defaultSortState = _ref.defaultSortState,
    defaultFilterState = _ref.defaultFilterState,
    defaultSelectionState = _ref.defaultSelectionState,
    pageSize = _ref.pageSize,
    defaultColumnState = _ref.defaultColumnState,
    savedColumnState = _ref.savedColumnState,
    _ref$renderMode = _ref.renderMode,
    renderMode = _ref$renderMode === void 0 ? {
      type: 'list'
    } : _ref$renderMode;
  var processedRows = useMemo(function () {
    if (renderMode.type === 'tree') {
      var deepCopyRows = _$1.cloneDeep(data);
      return addIdToTreeRows(deepCopyRows, renderMode.childKey);
    } else {
      return _$1.map(data, function (row, index) {
        return _objectSpread2(_objectSpread2({}, row), {}, {
          id: _$1.isUndefined(row.id) ? index : row.id
        });
      });
    }
  }, [data]);
  var _useMemo = useMemo(function () {
      var columnsMap = {};
      var pColumns = columns.map(function (column, index) {
        var pColumn = null;
        if (_$1.isString(column)) {
          pColumn = {
            id: column,
            accessor: column
          };
        } else {
          pColumn = _objectSpread2(_objectSpread2({}, column), {}, {
            id: _$1.isUndefined(column.id) ? index.toString() : column.id
          });
        }
        columnsMap[pColumn.id] = pColumn;
        return pColumn;
      });
      return {
        pColumns: pColumns,
        columnsMap: columnsMap
      };
    }, [columns]),
    pColumns = _useMemo.pColumns,
    columnsMap = _useMemo.columnsMap;
  var _useReducer = useReducer(reducer, {
      columns: columns,
      isSorting: isSorting,
      isRowSelecting: isRowSelecting,
      isMultiSelect: isMultiSelect,
      defaultSortState: defaultSortState,
      defaultFilterState: defaultFilterState,
      defaultSelectionState: defaultSelectionState,
      pageSize: pageSize,
      defaultColumnState: defaultColumnState,
      savedColumnState: savedColumnState
    }, init),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    table = _useReducer2[0],
    dispatch = _useReducer2[1];
  var tableRef = useRef(null);
  tableRef.current = table;
  var shownColumns = useMemo(function () {
    return pColumns.filter(function (column) {
      var _table$columnState$co;
      return !((_table$columnState$co = table.columnState[column.id]) !== null && _table$columnState$co !== void 0 && _table$columnState$co.isHidden);
    });
  }, [pColumns, table.columnState]);
  var toggleSort = useCallback(function (_ref2) {
    var id = _ref2.id;
    dispatch({
      type: "TOGGLE-SORT",
      payload: {
        id: id
      }
    });
  }, [dispatch]);
  var updateFilterState = useCallback(function (payload) {
    dispatch({
      type: "SET-FILTER",
      payload: payload
    });
  }, [dispatch]);
  var resetFilters = useCallback(function () {
    dispatch({
      type: "RESET-FILTERS"
    });
  }, [dispatch]);
  var updateRowState = useCallback(function (id) {
    return function (stateOrFunc) {
      var state = _$1.isFunction(stateOrFunc) ? stateOrFunc(tableRef.current.rowState[id]) : stateOrFunc;
      dispatch({
        type: "UPDATE-ROW",
        payload: {
          id: id,
          state: state
        }
      });
    };
  }, [dispatch]);
  var updateColumnState = useCallback(function (state) {
    dispatch({
      type: "UPDATE-COLUMN-STATE",
      payload: {
        state: state
      }
    });
  }, [dispatch]);
  var restoreColumnStateDefaults = useCallback(function () {
    updateColumnState(defaultColumnState || {});
  }, [updateColumnState]);
  var updateTextFilter = useCallback(function (value) {
    dispatch({
      type: "UPDATE-TEXT-FILTER",
      payload: {
        value: value
      }
    });
  }, [dispatch]);
  var filteredRows = useMemo(function () {
    if ((table.filterState.count > 0 || table.filterState.textFilter) && !externalFilter) {
      return filter(table.filterState, processedRows, shownColumns, columnsMap);
    } else {
      return processedRows;
    }
  }, [table.filterState, processedRows, externalFilter, shownColumns, columnsMap]);
  var organizedRows = useMemo(function () {
    if (isSorting && !externalSort) {
      if (renderMode.type === 'tree') {
        return sortTreeNodes(table.sortState, columnsMap[table.sortState.column].accessor, filteredRows, renderMode.childKey);
      } else {
        return sort(table.sortState, columnsMap, filteredRows);
      }
    } else {
      return filteredRows;
    }
  }, [isSorting, externalSort, filteredRows, table.sortState, columnsMap]);
  var toggleRowSelection = useCallback(function (id) {
    return function (value) {
      var ignoreDirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      dispatch({
        type: "TOGGLE-ROW-SELECTION",
        payload: {
          id: id,
          value: value,
          ignoreDirty: ignoreDirty
        }
      });
    };
  }, [dispatch]);
  var selectAllRows = useCallback(function (value) {
    var resetDirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    dispatch({
      type: "TOGGLE-SELECT-ALL",
      payload: {
        value: value,
        rows: renderMode.type === 'tree' ? getFlattenTreeNodes(organizedRows, renderMode.childKey) : organizedRows,
        resetDirty: resetDirty
      }
    });
  }, [dispatch, organizedRows]);
  var pageChunks = useMemo(function () {
    if (pageSize) {
      return _$1.chunk(organizedRows, pageSize);
    } else {
      return null;
    }
  }, [organizedRows, pageSize]);
  var pagination = useMemo(function () {
    if (pageChunks) {
      var pageIndex = table.pageState.pageIndex;
      var pageCount = pageChunks.length;
      var gotoPage = function gotoPage(i) {
        if (i >= 0 && i < pageCount) {
          dispatch({
            type: "GO-TO-PAGE",
            payload: {
              index: i
            }
          });
        }
      };
      return {
        pageIndex: pageIndex,
        pageRows: pageChunks[pageIndex],
        pageCount: pageCount,
        gotoPage: gotoPage
      };
    } else {
      return null;
    }
  }, [pageChunks, table.pageState, dispatch]);
  return useMemo(function () {
    return {
      rows: processedRows,
      organizedRows: organizedRows,
      columns: shownColumns,
      sortState: table.sortState,
      filterState: table.filterState,
      tableState: table.tableState,
      rowState: table.rowState,
      selectionState: table.selectionState,
      columnState: table.columnState,
      toggleSort: toggleSort,
      updateFilterState: updateFilterState,
      updateRowState: updateRowState,
      updateTextFilter: updateTextFilter,
      toggleRowSelection: toggleRowSelection,
      selectAllRows: selectAllRows,
      resetFilters: resetFilters,
      pagination: pagination,
      updateColumnState: updateColumnState,
      restoreColumnStateDefaults: restoreColumnStateDefaults
    };
  }, [table, organizedRows, toggleSort, updateFilterState, updateRowState, updateTextFilter, toggleRowSelection, selectAllRows, processedRows, resetFilters, pagination, updateColumnState, restoreColumnStateDefaults]);
});

var styles$E = {"base":"TableCounter-module_base__O9j4D","reset":"TableCounter-module_reset__1ju8n","divider":"TableCounter-module_divider__3pxOm"};

const Divider = () => {
    return jsxs(Fragment, { children: ["\u00A0", jsx$3("div", { className: styles$E.divider }), "\u00A0"] });
};
var TableCounter = ({ totalCount, filteredCount, singularLabel, pluralLabel, selectedCount, className, style, onResetFilter, activeFiltersCount, pageSize }) => {
    const hasFilteredCount = _$1.isNumber(filteredCount) && filteredCount < totalCount;
    const hasTotalCount = _$1.isNumber(totalCount);
    const hasActiveFilters = activeFiltersCount > 0;
    const hasRowsSelected = selectedCount > 0;
    let hasAllRowsSelected = false;
    if (hasTotalCount && hasRowsSelected) {
        if (_$1.isNumber(pageSize)) {
            hasAllRowsSelected = selectedCount === pageSize;
        }
        else {
            hasAllRowsSelected = selectedCount === totalCount;
        }
    }
    return jsxs("div", { className: classNames(styles$E['base'], className), style: style, children: [jsxs("span", { children: [jsxs("span", { children: [totalCount === 1 ? singularLabel : pluralLabel, "\u00A0"] }), hasFilteredCount && hasTotalCount && jsxs("span", { children: ["(", filteredCount, " / ", totalCount, ")"] }), !hasFilteredCount && hasTotalCount && jsxs("span", { children: ["(", totalCount, ")"] }), !hasFilteredCount && !hasTotalCount && jsx$3("span", { children: "(-)" })] }), hasActiveFilters && jsxs("span", { children: [jsx$3(Divider, {}), "Filters applied (", activeFiltersCount, ")"] }), !!selectedCount && selectedCount > 0 && jsxs("span", { children: [jsx$3(Divider, {}), hasAllRowsSelected && jsx$3("span", { children: "All rows selected" }), !hasAllRowsSelected && jsxs("span", { children: ["Selected rows (", selectedCount, ")"] })] }), onResetFilter && hasActiveFilters &&
                jsx$3(Button$2, { variant: "text", onClick: onResetFilter, className: styles$E.reset, children: "Reset filter" })] });
};

var styles$D = {"base":"TablePager-module_base__35Cer","counter":"TablePager-module_counter__2msO-","buttons":"TablePager-module_buttons__32PKC","current":"TablePager-module_current__3W-A0"};

var numeral$1 = {exports: {}};

/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (module) {
(function (global, factory) {
  if (module.exports) {
    module.exports = factory();
  } else {
    global.numeral = factory();
  }
})(commonjsGlobal, function () {
  /************************************
      Variables
  ************************************/

  var numeral,
    _,
    VERSION = '2.0.6',
    formats = {},
    locales = {},
    defaults = {
      currentLocale: 'en',
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: '0,0',
      scalePercentBy100: true
    },
    options = {
      currentLocale: defaults.currentLocale,
      zeroFormat: defaults.zeroFormat,
      nullFormat: defaults.nullFormat,
      defaultFormat: defaults.defaultFormat,
      scalePercentBy100: defaults.scalePercentBy100
    };

  /************************************
      Constructors
  ************************************/

  // Numeral prototype object
  function Numeral(input, number) {
    this._input = input;
    this._value = number;
  }
  numeral = function (input) {
    var value, kind, unformatFunction, regexp;
    if (numeral.isNumeral(input)) {
      value = input.value();
    } else if (input === 0 || typeof input === 'undefined') {
      value = 0;
    } else if (input === null || _.isNaN(input)) {
      value = null;
    } else if (typeof input === 'string') {
      if (options.zeroFormat && input === options.zeroFormat) {
        value = 0;
      } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
        value = null;
      } else {
        for (kind in formats) {
          regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
          if (regexp && input.match(regexp)) {
            unformatFunction = formats[kind].unformat;
            break;
          }
        }
        unformatFunction = unformatFunction || numeral._.stringToNumber;
        value = unformatFunction(input);
      }
    } else {
      value = Number(input) || null;
    }
    return new Numeral(input, value);
  };

  // version number
  numeral.version = VERSION;

  // compare numeral object
  numeral.isNumeral = function (obj) {
    return obj instanceof Numeral;
  };

  // helper functions
  numeral._ = _ = {
    // formats numbers separators, decimals places, signs, abbreviations
    numberToFormat: function (value, format, roundingFunction) {
      var locale = locales[numeral.options.currentLocale],
        negP = false,
        optDec = false,
        leadingCount = 0,
        abbr = '',
        trillion = 1000000000000,
        billion = 1000000000,
        million = 1000000,
        thousand = 1000,
        decimal = '',
        neg = false,
        abbrForce,
        // force abbreviation
        abs,
        int,
        precision,
        signed,
        thousands,
        output;

      // make sure we never format a null value
      value = value || 0;
      abs = Math.abs(value);

      // see if we should use parentheses for negative number or if we should prefix with a sign
      // if both are present we default to parentheses
      if (numeral._.includes(format, '(')) {
        negP = true;
        format = format.replace(/[\(|\)]/g, '');
      } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
        signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
        format = format.replace(/[\+|\-]/g, '');
      }

      // see if abbreviation is wanted
      if (numeral._.includes(format, 'a')) {
        abbrForce = format.match(/a(k|m|b|t)?/);
        abbrForce = abbrForce ? abbrForce[1] : false;

        // check for space before abbreviation
        if (numeral._.includes(format, ' a')) {
          abbr = ' ';
        }
        format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
        if (abs >= trillion && !abbrForce || abbrForce === 't') {
          // trillion
          abbr += locale.abbreviations.trillion;
          value = value / trillion;
        } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
          // billion
          abbr += locale.abbreviations.billion;
          value = value / billion;
        } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
          // million
          abbr += locale.abbreviations.million;
          value = value / million;
        } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
          // thousand
          abbr += locale.abbreviations.thousand;
          value = value / thousand;
        }
      }

      // check for optional decimals
      if (numeral._.includes(format, '[.]')) {
        optDec = true;
        format = format.replace('[.]', '.');
      }

      // break number and format
      int = value.toString().split('.')[0];
      precision = format.split('.')[1];
      thousands = format.indexOf(',');
      leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
      if (precision) {
        if (numeral._.includes(precision, '[')) {
          precision = precision.replace(']', '');
          precision = precision.split('[');
          decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
        } else {
          decimal = numeral._.toFixed(value, precision.length, roundingFunction);
        }
        int = decimal.split('.')[0];
        if (numeral._.includes(decimal, '.')) {
          decimal = locale.delimiters.decimal + decimal.split('.')[1];
        } else {
          decimal = '';
        }
        if (optDec && Number(decimal.slice(1)) === 0) {
          decimal = '';
        }
      } else {
        int = numeral._.toFixed(value, 0, roundingFunction);
      }

      // check abbreviation again after rounding
      if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
        int = String(Number(int) / 1000);
        switch (abbr) {
          case locale.abbreviations.thousand:
            abbr = locale.abbreviations.million;
            break;
          case locale.abbreviations.million:
            abbr = locale.abbreviations.billion;
            break;
          case locale.abbreviations.billion:
            abbr = locale.abbreviations.trillion;
            break;
        }
      }

      // format number
      if (numeral._.includes(int, '-')) {
        int = int.slice(1);
        neg = true;
      }
      if (int.length < leadingCount) {
        for (var i = leadingCount - int.length; i > 0; i--) {
          int = '0' + int;
        }
      }
      if (thousands > -1) {
        int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
      }
      if (format.indexOf('.') === 0) {
        int = '';
      }
      output = int + decimal + (abbr ? abbr : '');
      if (negP) {
        output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
      } else {
        if (signed >= 0) {
          output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
        } else if (neg) {
          output = '-' + output;
        }
      }
      return output;
    },
    // unformats numbers separators, decimals places, signs, abbreviations
    stringToNumber: function (string) {
      var locale = locales[options.currentLocale],
        stringOriginal = string,
        abbreviations = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        },
        abbreviation,
        value,
        regexp;
      if (options.zeroFormat && string === options.zeroFormat) {
        value = 0;
      } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
        value = null;
      } else {
        value = 1;
        if (locale.delimiters.decimal !== '.') {
          string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
        }
        for (abbreviation in abbreviations) {
          regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
          if (stringOriginal.match(regexp)) {
            value *= Math.pow(10, abbreviations[abbreviation]);
            break;
          }
        }

        // check for negative number
        value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

        // remove non numbers
        string = string.replace(/[^0-9\.]+/g, '');
        value *= Number(string);
      }
      return value;
    },
    isNaN: function (value) {
      return typeof value === 'number' && isNaN(value);
    },
    includes: function (string, search) {
      return string.indexOf(search) !== -1;
    },
    insert: function (string, subString, start) {
      return string.slice(0, start) + subString + string.slice(start);
    },
    reduce: function (array, callback /*, initialValue*/) {
      if (this === null) {
        throw new TypeError('Array.prototype.reduce called on null or undefined');
      }
      if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
      }
      var t = Object(array),
        len = t.length >>> 0,
        k = 0,
        value;
      if (arguments.length === 3) {
        value = arguments[2];
      } else {
        while (k < len && !(k in t)) {
          k++;
        }
        if (k >= len) {
          throw new TypeError('Reduce of empty array with no initial value');
        }
        value = t[k++];
      }
      for (; k < len; k++) {
        if (k in t) {
          value = callback(value, t[k], k, t);
        }
      }
      return value;
    },
    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */
    multiplier: function (x) {
      var parts = x.toString().split('.');
      return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
    },
    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */
    correctionFactor: function () {
      var args = Array.prototype.slice.call(arguments);
      return args.reduce(function (accum, next) {
        var mn = _.multiplier(next);
        return accum > mn ? accum : mn;
      }, 1);
    },
    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     */
    toFixed: function (value, maxDecimals, roundingFunction, optionals) {
      var splitValue = value.toString().split('.'),
        minDecimals = maxDecimals - (optionals || 0),
        boundedPrecision,
        optionalsRegExp,
        power,
        output;

      // Use the smallest precision value possible to avoid errors from floating point representation
      if (splitValue.length === 2) {
        boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
      } else {
        boundedPrecision = minDecimals;
      }
      power = Math.pow(10, boundedPrecision);

      // Multiply up by precision, round accurately, then divide and use native toFixed():
      output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
      if (optionals > maxDecimals - boundedPrecision) {
        optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
        output = output.replace(optionalsRegExp, '');
      }
      return output;
    }
  };

  // avaliable options
  numeral.options = options;

  // avaliable formats
  numeral.formats = formats;

  // avaliable formats
  numeral.locales = locales;

  // This function sets the current locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.
  numeral.locale = function (key) {
    if (key) {
      options.currentLocale = key.toLowerCase();
    }
    return options.currentLocale;
  };

  // This function provides access to the loaded locale data.  If
  // no arguments are passed in, it will simply return the current
  // global locale object.
  numeral.localeData = function (key) {
    if (!key) {
      return locales[options.currentLocale];
    }
    key = key.toLowerCase();
    if (!locales[key]) {
      throw new Error('Unknown locale : ' + key);
    }
    return locales[key];
  };
  numeral.reset = function () {
    for (var property in defaults) {
      options[property] = defaults[property];
    }
  };
  numeral.zeroFormat = function (format) {
    options.zeroFormat = typeof format === 'string' ? format : null;
  };
  numeral.nullFormat = function (format) {
    options.nullFormat = typeof format === 'string' ? format : null;
  };
  numeral.defaultFormat = function (format) {
    options.defaultFormat = typeof format === 'string' ? format : '0.0';
  };
  numeral.register = function (type, name, format) {
    name = name.toLowerCase();
    if (this[type + 's'][name]) {
      throw new TypeError(name + ' ' + type + ' already registered.');
    }
    this[type + 's'][name] = format;
    return format;
  };
  numeral.validate = function (val, culture) {
    var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;

    //coerce val to string
    if (typeof val !== 'string') {
      val += '';
      if (console.warn) {
        console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
      }
    }

    //trim whitespaces from either sides
    val = val.trim();

    //if val is just digits return true
    if (!!val.match(/^\d+$/)) {
      return true;
    }

    //if val is empty return false
    if (val === '') {
      return false;
    }

    //get the decimal and thousands separator from numeral.localeData
    try {
      //check if the culture is understood by numeral. if not, default it to current locale
      localeData = numeral.localeData(culture);
    } catch (e) {
      localeData = numeral.localeData(numeral.locale());
    }

    //setup the delimiters and currency symbol based on culture/locale
    _currSymbol = localeData.currency.symbol;
    _abbrObj = localeData.abbreviations;
    _decimalSep = localeData.delimiters.decimal;
    if (localeData.delimiters.thousands === '.') {
      _thousandSep = '\\.';
    } else {
      _thousandSep = localeData.delimiters.thousands;
    }

    // validating currency symbol
    temp = val.match(/^[^\d]+/);
    if (temp !== null) {
      val = val.substr(1);
      if (temp[0] !== _currSymbol) {
        return false;
      }
    }

    //validating abbreviation symbol
    temp = val.match(/[^\d]+$/);
    if (temp !== null) {
      val = val.slice(0, -1);
      if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
        return false;
      }
    }
    _thousandRegEx = new RegExp(_thousandSep + '{2}');
    if (!val.match(/[^\d.,]/g)) {
      _valArray = val.split(_decimalSep);
      if (_valArray.length > 2) {
        return false;
      } else {
        if (_valArray.length < 2) {
          return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
        } else {
          if (_valArray[0].length === 1) {
            return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
          } else {
            return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
          }
        }
      }
    }
    return false;
  };

  /************************************
      Numeral Prototype
  ************************************/

  numeral.fn = Numeral.prototype = {
    clone: function () {
      return numeral(this);
    },
    format: function (inputString, roundingFunction) {
      var value = this._value,
        format = inputString || options.defaultFormat,
        kind,
        output,
        formatFunction;

      // make sure we have a roundingFunction
      roundingFunction = roundingFunction || Math.round;

      // format based on value
      if (value === 0 && options.zeroFormat !== null) {
        output = options.zeroFormat;
      } else if (value === null && options.nullFormat !== null) {
        output = options.nullFormat;
      } else {
        for (kind in formats) {
          if (format.match(formats[kind].regexps.format)) {
            formatFunction = formats[kind].format;
            break;
          }
        }
        formatFunction = formatFunction || numeral._.numberToFormat;
        output = formatFunction(value, format, roundingFunction);
      }
      return output;
    },
    value: function () {
      return this._value;
    },
    input: function () {
      return this._input;
    },
    set: function (value) {
      this._value = Number(value);
      return this;
    },
    add: function (value) {
      var corrFactor = _.correctionFactor.call(null, this._value, value);
      function cback(accum, curr, currI, O) {
        return accum + Math.round(corrFactor * curr);
      }
      this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
      return this;
    },
    subtract: function (value) {
      var corrFactor = _.correctionFactor.call(null, this._value, value);
      function cback(accum, curr, currI, O) {
        return accum - Math.round(corrFactor * curr);
      }
      this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
      return this;
    },
    multiply: function (value) {
      function cback(accum, curr, currI, O) {
        var corrFactor = _.correctionFactor(accum, curr);
        return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
      }
      this._value = _.reduce([this._value, value], cback, 1);
      return this;
    },
    divide: function (value) {
      function cback(accum, curr, currI, O) {
        var corrFactor = _.correctionFactor(accum, curr);
        return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
      }
      this._value = _.reduce([this._value, value], cback);
      return this;
    },
    difference: function (value) {
      return Math.abs(numeral(this._value).subtract(value).value());
    }
  };

  /************************************
      Default Locale && Format
  ************************************/

  numeral.register('locale', 'en', {
    delimiters: {
      thousands: ',',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function (number) {
      var b = number % 10;
      return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
    },
    currency: {
      symbol: '$'
    }
  });
  (function () {
    numeral.register('format', 'bps', {
      regexps: {
        format: /(BPS)/,
        unformat: /(BPS)/
      },
      format: function (value, format, roundingFunction) {
        var space = numeral._.includes(format, ' BPS') ? ' ' : '',
          output;
        value = value * 10000;

        // check for space before BPS
        format = format.replace(/\s?BPS/, '');
        output = numeral._.numberToFormat(value, format, roundingFunction);
        if (numeral._.includes(output, ')')) {
          output = output.split('');
          output.splice(-1, 0, space + 'BPS');
          output = output.join('');
        } else {
          output = output + space + 'BPS';
        }
        return output;
      },
      unformat: function (string) {
        return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
      }
    });
  })();
  (function () {
    var decimal = {
        base: 1000,
        suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      },
      binary = {
        base: 1024,
        suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
      };
    var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function (item) {
      return decimal.suffixes.indexOf(item) < 0;
    }));
    var unformatRegex = allSuffixes.join('|');
    // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
    unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
    numeral.register('format', 'bytes', {
      regexps: {
        format: /([0\s]i?b)/,
        unformat: new RegExp(unformatRegex)
      },
      format: function (value, format, roundingFunction) {
        var output,
          bytes = numeral._.includes(format, 'ib') ? binary : decimal,
          suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
          power,
          min,
          max;

        // check for space before
        format = format.replace(/\s?i?b/, '');
        for (power = 0; power <= bytes.suffixes.length; power++) {
          min = Math.pow(bytes.base, power);
          max = Math.pow(bytes.base, power + 1);
          if (value === null || value === 0 || value >= min && value < max) {
            suffix += bytes.suffixes[power];
            if (min > 0) {
              value = value / min;
            }
            break;
          }
        }
        output = numeral._.numberToFormat(value, format, roundingFunction);
        return output + suffix;
      },
      unformat: function (string) {
        var value = numeral._.stringToNumber(string),
          power,
          bytesMultiplier;
        if (value) {
          for (power = decimal.suffixes.length - 1; power >= 0; power--) {
            if (numeral._.includes(string, decimal.suffixes[power])) {
              bytesMultiplier = Math.pow(decimal.base, power);
              break;
            }
            if (numeral._.includes(string, binary.suffixes[power])) {
              bytesMultiplier = Math.pow(binary.base, power);
              break;
            }
          }
          value *= bytesMultiplier || 1;
        }
        return value;
      }
    });
  })();
  (function () {
    numeral.register('format', 'currency', {
      regexps: {
        format: /(\$)/
      },
      format: function (value, format, roundingFunction) {
        var locale = numeral.locales[numeral.options.currentLocale],
          symbols = {
            before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          },
          output,
          symbol,
          i;

        // strip format of spaces and $
        format = format.replace(/\s?\$\s?/, '');

        // format the number
        output = numeral._.numberToFormat(value, format, roundingFunction);

        // update the before and after based on value
        if (value >= 0) {
          symbols.before = symbols.before.replace(/[\-\(]/, '');
          symbols.after = symbols.after.replace(/[\-\)]/, '');
        } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) {
          symbols.before = '-' + symbols.before;
        }

        // loop through each before symbol
        for (i = 0; i < symbols.before.length; i++) {
          symbol = symbols.before[i];
          switch (symbol) {
            case '$':
              output = numeral._.insert(output, locale.currency.symbol, i);
              break;
            case ' ':
              output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
              break;
          }
        }

        // loop through each after symbol
        for (i = symbols.after.length - 1; i >= 0; i--) {
          symbol = symbols.after[i];
          switch (symbol) {
            case '$':
              output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
              break;
            case ' ':
              output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
              break;
          }
        }
        return output;
      }
    });
  })();
  (function () {
    numeral.register('format', 'exponential', {
      regexps: {
        format: /(e\+|e-)/,
        unformat: /(e\+|e-)/
      },
      format: function (value, format, roundingFunction) {
        var output,
          exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
          parts = exponential.split('e');
        format = format.replace(/e[\+|\-]{1}0/, '');
        output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
        return output + 'e' + parts[1];
      },
      unformat: function (string) {
        var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
          value = Number(parts[0]),
          power = Number(parts[1]);
        power = numeral._.includes(string, 'e-') ? power *= -1 : power;
        function cback(accum, curr, currI, O) {
          var corrFactor = numeral._.correctionFactor(accum, curr),
            num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
          return num;
        }
        return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
      }
    });
  })();
  (function () {
    numeral.register('format', 'ordinal', {
      regexps: {
        format: /(o)/
      },
      format: function (value, format, roundingFunction) {
        var locale = numeral.locales[numeral.options.currentLocale],
          output,
          ordinal = numeral._.includes(format, ' o') ? ' ' : '';

        // check for space before
        format = format.replace(/\s?o/, '');
        ordinal += locale.ordinal(value);
        output = numeral._.numberToFormat(value, format, roundingFunction);
        return output + ordinal;
      }
    });
  })();
  (function () {
    numeral.register('format', 'percentage', {
      regexps: {
        format: /(%)/,
        unformat: /(%)/
      },
      format: function (value, format, roundingFunction) {
        var space = numeral._.includes(format, ' %') ? ' ' : '',
          output;
        if (numeral.options.scalePercentBy100) {
          value = value * 100;
        }

        // check for space before %
        format = format.replace(/\s?\%/, '');
        output = numeral._.numberToFormat(value, format, roundingFunction);
        if (numeral._.includes(output, ')')) {
          output = output.split('');
          output.splice(-1, 0, space + '%');
          output = output.join('');
        } else {
          output = output + space + '%';
        }
        return output;
      },
      unformat: function (string) {
        var number = numeral._.stringToNumber(string);
        if (numeral.options.scalePercentBy100) {
          return number * 0.01;
        }
        return number;
      }
    });
  })();
  (function () {
    numeral.register('format', 'time', {
      regexps: {
        format: /(:)/,
        unformat: /(:)/
      },
      format: function (value, format, roundingFunction) {
        var hours = Math.floor(value / 60 / 60),
          minutes = Math.floor((value - hours * 60 * 60) / 60),
          seconds = Math.round(value - hours * 60 * 60 - minutes * 60);
        return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
      },
      unformat: function (string) {
        var timeArray = string.split(':'),
          seconds = 0;

        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
          // hours
          seconds = seconds + Number(timeArray[0]) * 60 * 60;
          // minutes
          seconds = seconds + Number(timeArray[1]) * 60;
          // seconds
          seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
          // minutes
          seconds = seconds + Number(timeArray[0]) * 60;
          // seconds
          seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
      }
    });
  })();
  return numeral;
});
}(numeral$1));

var numeral = numeral$1.exports;

var TablePager = React__default.memo(({ pageRows, rows, pageSize, pageIndex, pageCount, style, className, gotoPage }) => {
    const from = (pageSize * pageIndex) + 1;
    const to = from + pageRows.length - 1;
    const of = numeral(rows.length).format('0,0');
    return jsxs("div", { className: classNames(styles$D.base, className), style: style, children: [jsxs("div", { className: styles$D.counter, children: [from, " - ", to, " of ", of] }), jsxs("div", { className: styles$D.buttons, children: [jsx$3("button", { type: "button", disabled: pageIndex === 0, onClick: () => {
                            gotoPage(0);
                        }, children: jsx$3(PaginationFirstIcon, {}) }), jsx$3("button", { type: "button", disabled: pageIndex === 0, onClick: () => gotoPage(pageIndex - 1), children: jsx$3(PaginationPreviousIcon, {}) }), jsx$3("span", { className: styles$D.current, children: pageIndex + 1 }), jsx$3("button", { type: "button", disabled: pageIndex === pageCount - 1, onClick: () => gotoPage(pageIndex + 1), children: jsx$3(PaginationNextIcon, {}) }), jsx$3("button", { type: "button", disabled: pageIndex === pageCount - 1, onClick: () => {
                            gotoPage(pageCount - 1);
                        }, children: jsx$3(PaginationLastIcon, {}) })] })] });
});

var styles$C = {"base":"TableWidgets-module_base__1hBsy"};

var TableWidgets = (function (_ref) {
  var children = _ref.children,
    style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$C.base,
    style: style
  }, children);
});

var styles$B = {"base":"ExternalTableFilters-module_base__oG2rP","filters":"ExternalTableFilters-module_filters__3iRF6","external-filter":"ExternalTableFilters-module_external-filter__3NFHt","select-columns-popover":"ExternalTableFilters-module_select-columns-popover__2DDRV","external-column-filter-button":"ExternalTableFilters-module_external-column-filter-button__eNtB-","open":"ExternalTableFilters-module_open__2431q","close":"ExternalTableFilters-module_close__3S4YW","add-filter":"ExternalTableFilters-module_add-filter__1NI9a"};

var _desc$8, _rect$3;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgIcTableAddExternalFilter = function SvgIcTableAddExternalFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__filter_plus",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _desc$8 || (_desc$8 = /*#__PURE__*/React.createElement("desc", null, "Add filter")), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    fill: "var(--icon-primary)",
    width: 32,
    height: 32,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--icon-on-color)",
    stroke: "var(--icon-on-color)",
    d: "M22.253 15.562a.578.578 0 0 0-.6.611v5.415h-5.417a.6.6 0 1 0 0 1.205h5.415v5.415a.6.6 0 1 0 1.205 0v-5.415h5.415a.6.6 0 1 0 0-1.205h-5.415v-5.415a.578.578 0 0 0-.603-.611z",
    transform: "translate(-6.625 -6.562)",
    style: {
      strokeWidth: ".4px"
    }
  }));
};

var _desc$7, _path$7;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgIcExternalFilterUpArrow = function SvgIcExternalFilterUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5,
    viewBox: "0 0 10 5"
  }, props), _desc$7 || (_desc$7 = /*#__PURE__*/React.createElement("desc", null, "Arrow Up")), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0l5 5H0z",
    fill: "var(--icon-primary)"
  })));
};

var styles$A = {"internal-filter-button":"InternalTableFilterStyles-module_internal-filter-button__MkKpy","internal-filter-popover":"InternalTableFilterStyles-module_internal-filter-popover__3W2eP"};

var _desc$6, _path$6;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgIcTableFilter = function SvgIcTableFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$6 || (_desc$6 = /*#__PURE__*/React.createElement("desc", null, "Filter")), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 1.45002C12.0086 1.69165 11.9221 1.92718 11.7585 2.10505C11.595 2.28292 11.3677 2.38863 11.1264 2.39902H0.889053C0.648096 2.38336 0.422121 2.27645 0.257004 2.10002C0.091886 1.92358 0 1.69083 0 1.44902C0 1.20721 0.091886 0.974466 0.257004 0.798029C0.422121 0.621592 0.648096 0.514689 0.889053 0.499023H11.1264C11.2461 0.504039 11.3636 0.532621 11.4722 0.583136C11.5809 0.63365 11.6785 0.705108 11.7596 0.793425C11.8406 0.881742 11.9035 0.985187 11.9446 1.09785C11.9857 1.21051 12.0043 1.33018 11.9992 1.45002ZM10.4253 4.99995C10.4319 5.1181 10.4152 5.23639 10.3761 5.34806C10.337 5.45973 10.2763 5.56258 10.1975 5.65073C10.1186 5.73888 10.0232 5.81059 9.91665 5.86176C9.81011 5.91293 9.69453 5.94256 9.57654 5.94895H2.43874C2.20216 5.92718 1.98225 5.81769 1.82213 5.64193C1.66201 5.46618 1.57324 5.23686 1.57324 4.99895C1.57324 4.76104 1.66201 4.53172 1.82213 4.35596C1.98225 4.18021 2.20216 4.07071 2.43874 4.04895H9.57654C9.69471 4.05533 9.81046 4.08503 9.91714 4.13633C10.0238 4.18762 10.1193 4.25952 10.1982 4.34788C10.2771 4.43624 10.3377 4.53933 10.3767 4.65123C10.4157 4.76313 10.4322 4.88164 10.4253 4.99995ZM8.30062 9.22299C8.47833 9.04502 8.57818 8.80364 8.57818 8.55195C8.57857 8.4272 8.55438 8.30361 8.50698 8.18825C8.45958 8.07288 8.38992 7.96802 8.30197 7.87967C8.21403 7.79132 8.10954 7.72123 7.99449 7.6734C7.87944 7.62557 7.7561 7.60095 7.63153 7.60095H4.38517C4.13357 7.60095 3.89228 7.70104 3.71437 7.8792C3.53647 8.05736 3.43652 8.29899 3.43652 8.55095C3.43652 8.80291 3.53647 9.04454 3.71437 9.2227C3.89228 9.40086 4.13357 9.50095 4.38517 9.50095H7.63053C7.88186 9.50095 8.1229 9.40096 8.30062 9.22299Z",
    fill: "var(--icon-primary)"
  })));
};

var filterStyles = {"filter":"Filters-module_filter__3zPad","drop-down-label":"Filters-module_drop-down-label__1DcJu","base-filter-content":"Filters-module_base-filter-content__3x06V","checkbox-filter-content":"Filters-module_checkbox-filter-content__34Lkl Filters-module_base-filter-content__3x06V","dropdown-filter-content":"Filters-module_dropdown-filter-content__1LmkV Filters-module_base-filter-content__3x06V","no-options":"Filters-module_no-options__SvV3e","bgshimmer":"Filters-module_bgshimmer__t3XDt"};

var styles$z = {"base":"ActionMenuButtonsRow-module_base__33Bml"};

var ActionMenuButtonsRow = function ActionMenuButtonsRow(_ref) {
  var children = _ref.children,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? 'action-menu-buttons-row' : _ref$dataTestId;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$z.base,
    "data-testid": dataTestId
  }, children);
};
var ActionMenuButtonsRow$1 = ActionMenuButtonsRow;

var styles$y = {"base":"ActionMenuCheckbox-module_base__FRt07"};

var _excluded$7 = ["className", "children", "dataTestId"];
var ActionMenuCheckbox = function ActionMenuCheckbox(_ref) {
  var className = _ref.className,
    children = _ref.children,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties$2(_ref, _excluded$7);
  return /*#__PURE__*/React__default.createElement(Checkbox, _extends$j({}, props, {
    className: classNames(styles$y.base, className),
    dataTestId: dataTestId
  }), children);
};
var ActionMenuCheckbox$1 = ActionMenuCheckbox;

var NoOptions = function NoOptions() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: filterStyles["no-options"]
  }, "No options");
};
var DropdownFilter = function DropdownFilter(_ref) {
  var filterOptions = _ref.filterOptions,
    filterState = _ref.filterState,
    close = _ref.close,
    updateFilter = _ref.updateFilter,
    className = _ref.className,
    filterConfig = _ref.filterConfig;
  var _useState = useState(filterState.valuesArray || []),
    _useState2 = _slicedToArray(_useState, 2),
    internalState = _useState2[0],
    setInternalState = _useState2[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(filterStyles['filter'], className),
    style: {
      minWidth: 285
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: filterStyles['dropdown-filter-content']
  }, !filterOptions || filterOptions.length === 0 && /*#__PURE__*/React__default.createElement(NoOptions, null), filterOptions && filterOptions.length > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Label$1, null, filterConfig.label), /*#__PURE__*/React__default.createElement(Select, {
    onChange: setInternalState,
    options: filterOptions,
    value: internalState,
    isSearchable: true,
    isMulti: true,
    placeholder: filterConfig.placeholder
  }))), /*#__PURE__*/React__default.createElement(ActionMenuButtonsRow$1, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick(e) {
      updateFilter(_$1.pickBy(_$1.keyBy(internalState, 'value')));
      close(e);
    }
  }, "Apply"), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setInternalState([]);
    }
  }, "Cancel")));
};
var CheckboxFilter = function CheckboxFilter(_ref2) {
  var filterOptions = _ref2.filterOptions,
    filterState = _ref2.filterState,
    close = _ref2.close,
    updateFilter = _ref2.updateFilter,
    className = _ref2.className;
  var _useState3 = useState(filterState.values || {}),
    _useState4 = _slicedToArray(_useState3, 2),
    internalState = _useState4[0],
    setInternalState = _useState4[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(filterStyles['filter'], className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: filterStyles['checkbox-filter-content']
  }, !filterOptions || filterOptions.length === 0 && /*#__PURE__*/React__default.createElement(NoOptions, null), filterOptions && filterOptions.length > 0 && filterOptions.map(function (_ref3) {
    var value = _ref3.value,
      label = _ref3.label,
      disabled = _ref3.disabled;
    return /*#__PURE__*/React__default.createElement(ActionMenuCheckbox$1, {
      key: value,
      disabled: disabled,
      name: value,
      checked: internalState[value] || false,
      dataTestId: "checkbox-filter-".concat(label),
      onChange: function onChange() {
        return setInternalState(_objectSpread2(_objectSpread2({}, internalState), {}, _defineProperty$3({}, value, !internalState[value])));
      }
    }, /*#__PURE__*/React__default.createElement("span", null, label));
  })), /*#__PURE__*/React__default.createElement(ActionMenuButtonsRow$1, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick(e) {
      updateFilter(internalState);
      close(e);
    }
  }, "Apply"), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setInternalState({});
    }
  }, "Cancel")));
};

var styles$x = {"chipsFilter":"ChipsFilter-module_chipsFilter__as6up","newChipInputWrapper":"ChipsFilter-module_newChipInputWrapper__3BFRs","addNewChipButton":"ChipsFilter-module_addNewChipButton__3FV4w","chipsContainer":"ChipsFilter-module_chipsContainer__2EnX-","noChipsContainer":"ChipsFilter-module_noChipsContainer__3L_iF","chip":"ChipsFilter-module_chip__1pRDJ"};

const defaultInputPlaceholder = "Enter filter value";
const defaultChipsPlaceholder = "Add values to filter column";
const defaultAddLabel = "Add";
const NewChipInput = ({ setInternalState, inputPlaceholder, addLabel }) => {
    const [value, setValue] = useState("");
    return jsxs("div", { "data-testid": 'add-new-chip-wrapper', className: styles$x.newChipInputWrapper, children: [jsx$3("input", { placeholder: inputPlaceholder, "data-testid": 'add-new-chip-input', value: value, onChange: e => setValue(e.target.value) }), jsxs("button", { className: styles$x.addNewChipButton, disabled: !value, "data-testid": 'add-new-chip-button', onClick: () => {
                    setInternalState(prevState => new Set(prevState.add(value)));
                    setValue("");
                }, children: [jsx$3(AddIcon, {}), addLabel] })] });
};
const Chips = ({ setInternalState, internalState }) => {
    return jsx$3("div", { className: styles$x.chipsContainer, children: Array.from(internalState).map(value => {
            return jsxs("div", { "data-testid": `chip-filter-${value}`, className: styles$x.chip, children: [jsx$3(Span, { ellipsis: true, color: "on-color", children: value }), jsx$3("button", { onClick: () => {
                            setTimeout(() => {
                                setInternalState(prevState => {
                                    prevState.delete(value);
                                    return new Set(prevState);
                                });
                            });
                        }, children: jsx$3(CloseIcon, {}) })] }, value);
        }) });
};
const NoChips = ({ chipsPlaceholder }) => {
    return jsx$3("div", { "data-testid": 'no-chips-filter', className: styles$x.noChipsContainer, children: jsx$3(Span, { color: "text-disabled", children: chipsPlaceholder }) });
};
const ChipsFilter = ({ filterState, close, updateFilter, className, filterConfig }) => {
    const [internalState, setInternalState] = useState(() => new Set(Object.keys(filterState.values || {})));
    return jsxs("div", { "data-testid": 'chips-filter-wrapper', className: classNames(filterStyles.filter, styles$x.chipsFilter, className), children: [jsx$3(NewChipInput, { addLabel: filterConfig.addLabel || defaultAddLabel, inputPlaceholder: filterConfig.inputPlaceholder || defaultInputPlaceholder, setInternalState: setInternalState }), internalState.size > 0 && jsx$3(Chips, { setInternalState: setInternalState, internalState: internalState }), internalState.size === 0 &&
                jsx$3(NoChips, { chipsPlaceholder: filterConfig.chipsPlaceholder || defaultChipsPlaceholder }), jsxs(ActionMenuButtonsRow$1, { children: [jsx$3("button", { type: "button", onClick: (e) => {
                            const out = {};
                            internalState.forEach(value => out[value] = true);
                            updateFilter(out);
                            close(e);
                        }, children: "Apply" }), jsx$3("button", { type: "button", onClick: () => {
                            setInternalState(new Set());
                        }, children: "Cancel" })] })] });
};

var PopoverFilter = function PopoverFilter(_ref) {
  var columnFilterOptions = _ref.columnFilterOptions,
    columnFilterState = _ref.columnFilterState,
    close = _ref.close,
    updateColumnFilter = _ref.updateColumnFilter,
    Filter = _ref.Filter,
    filterConfig = _ref.filterConfig;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Filter, {
    filterOptions: columnFilterOptions,
    filterConfig: filterConfig,
    filterState: columnFilterState,
    close: close,
    updateFilter: updateColumnFilter
  }));
};
var InternalTrigger = function InternalTrigger() {
  return /*#__PURE__*/React__default.createElement(SvgIcTableFilter, null);
};
var internalFilters = {
  checkbox: CheckboxFilter,
  dropdown: DropdownFilter,
  chips: ChipsFilter
};
var NoFilter = function NoFilter() {
  return /*#__PURE__*/React__default.createElement("div", null, "Invalid Render Filter");
};
var chooseFilter = function chooseFilter() {
  var filterConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _$1.isFunction(filterConfig.RenderFilter) ? filterConfig.RenderFilter : internalFilters[filterConfig.RenderFilter || "checkbox"] || NoFilter;
};
var InternalFilter = function InternalFilter(_ref2) {
  var columnFilterOptions = _ref2.columnFilterOptions,
    columnFilterState = _ref2.columnFilterState,
    updateColumnFilter = _ref2.updateColumnFilter,
    filterConfig = _ref2.filterConfig;
  var Filter = chooseFilter(filterConfig);
  return /*#__PURE__*/React__default.createElement(PopoverMechanism, {
    Popover: PopoverFilter,
    Filter: Filter,
    Trigger: InternalTrigger,
    popoverClassName: styles$A['internal-filter-popover'],
    triggerClassName: styles$A['internal-filter-button'],
    triggerOnClick: true,
    columnFilterOptions: columnFilterOptions,
    columnFilterState: columnFilterState,
    updateColumnFilter: updateColumnFilter,
    filterConfig: filterConfig
  });
};

var ExternalColumnFilterButton = /*#__PURE__*/React__default.memo(function (_ref) {
  var columnId = _ref.columnId,
    label = _ref.label,
    columnFilterOptions = _ref.columnFilterOptions,
    _ref$columnFilterStat = _ref.columnFilterState,
    columnFilterState = _ref$columnFilterStat === void 0 ? {
      activeCount: 0
    } : _ref$columnFilterStat,
    setColumnFilterInvisible = _ref.setColumnFilterInvisible,
    updateColumnFilter = _ref.updateColumnFilter,
    filterConfig = _ref.filterConfig,
    filterClassName = _ref.filterClassName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var count = columnFilterState.activeCount;
  var Filter = chooseFilter(filterConfig);
  var arrowStyle = isOpen ? {
    transform: "scaleY(-1)"
  } : undefined;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$B['external-column-filter-button']
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setIsOpen(true);
    },
    className: styles$B['open']
  }, label, count > 0 && " (".concat(count, ")"), /*#__PURE__*/React__default.createElement(SvgIcExternalFilterUpArrow, {
    style: arrowStyle
  })), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setColumnFilterInvisible({
        id: columnId
      });
      updateColumnFilter({});
    },
    className: styles$B['close']
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), isOpen && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ClickAway, {
    ignoreParentClick: true,
    listener: function listener() {
      return setIsOpen(false);
    }
  }), /*#__PURE__*/React__default.createElement(Filter, {
    className: classNames(styles$B["external-filter"], filterClassName),
    filterConfig: filterConfig,
    filterOptions: columnFilterOptions,
    filterState: columnFilterState,
    close: function close() {
      return setIsOpen(false);
    },
    updateFilter: updateColumnFilter
  })));
});
var SelectColumns = function SelectColumns(_ref2) {
  var unfilteredColumns = _ref2.unfilteredColumns,
    setColumnFilterVisible = _ref2.setColumnFilterVisible;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$B["select-columns-popover"]
  }, unfilteredColumns.map(function (_ref3) {
    var id = _ref3.id,
      header = _ref3.header;
    return /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      key: id,
      onClick: function onClick() {
        return setColumnFilterVisible({
          id: id
        });
      }
    }, header);
  }));
};
var AddFilterTrigger = function AddFilterTrigger() {
  return /*#__PURE__*/React__default.createElement(SvgIcTableAddExternalFilter, null);
};
var AddFilterPopover = function AddFilterPopover(_ref4) {
  var unfilteredColumns = _ref4.unfilteredColumns,
    setColumnFilterVisible = _ref4.setColumnFilterVisible;
  return /*#__PURE__*/React__default.createElement(PopoverMechanism, {
    Popover: SelectColumns,
    Trigger: AddFilterTrigger,
    popoverStyle: {
      transform: "translate(-35px, 11px)",
      transition: "none"
    },
    triggerClassName: styles$B['add-filter'],
    triggerOnClick: true,
    setColumnFilterVisible: setColumnFilterVisible,
    unfilteredColumns: unfilteredColumns,
    disabled: unfilteredColumns.length === 0
  });
};
var ExternalTableFilters = /*#__PURE__*/React__default.memo(function (_ref5) {
  var filterOptions = _ref5.filterOptions,
    filterState = _ref5.filterState,
    updateFilterState = _ref5.updateFilterState,
    columns = _ref5.columns,
    style = _ref5.style,
    className = _ref5.className,
    resetFilters = _ref5.resetFilters,
    filterClassName = _ref5.filterClassName;
  var _useState3 = useState({
      map: {},
      array: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    visibleFilters = _useState4[0],
    setVisibleFilters = _useState4[1];
  var columnsMap = _$1.keyBy(columns, "id");
  var setColumnFilterVisible = function setColumnFilterVisible(_ref6) {
    var id = _ref6.id;
    var array = visibleFilters.array.concat([id]);
    var map = _objectSpread2(_objectSpread2({}, visibleFilters.map), {}, _defineProperty$3({}, id, true));
    setVisibleFilters({
      map: map,
      array: array
    });
  };
  var setColumnFilterInvisible = function setColumnFilterInvisible(_ref7) {
    var id = _ref7.id;
    var array = _$1.pull(visibleFilters.array, id);
    var map = _objectSpread2(_objectSpread2({}, visibleFilters.map), {}, _defineProperty$3({}, id, false));
    setVisibleFilters({
      map: map,
      array: array
    });
  };
  var unfilteredColumns = _$1.filter(columns, function (column) {
    return filterOptions[column.id] && !visibleFilters.map[column.id];
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$B.base, className),
    style: style
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "text-title"
  }, "Filter By"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$B.filters
  }, visibleFilters.array.map(function (columnId) {
    var updateColumnFilter = function updateColumnFilter(values) {
      updateFilterState({
        id: columnId,
        values: values
      });
    };
    return /*#__PURE__*/React__default.createElement(ExternalColumnFilterButton, {
      key: columnId,
      label: columnsMap[columnId].header,
      columnFilterState: filterState.columns[columnId],
      columnFilterOptions: filterOptions[columnId],
      filterConfig: columnsMap[columnId].filter,
      columnId: columnId,
      setColumnFilterInvisible: setColumnFilterInvisible,
      updateColumnFilter: updateColumnFilter,
      filterClassName: filterClassName
    });
  })), /*#__PURE__*/React__default.createElement(AddFilterPopover, {
    setColumnFilterVisible: setColumnFilterVisible,
    unfilteredColumns: unfilteredColumns
  }), (filterState === null || filterState === void 0 ? void 0 : filterState.count) > 0 && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "text",
    className: styles$B.reset,
    onClick: resetFilters
  }, "Reset"));
});

var styles$w = {"base":"NotAvailableCellData-module_base__Dpigz"};

const NotAvailableCellData = () => {
    return jsx$3("span", { className: styles$w.base, children: "N/A" });
};

var styles$v = {"base":"Table-module_base__28Th_","headers-group-container":"Table-module_headers-group-container__1Bfsx","sticky-header":"Table-module_sticky-header__3d_3I","header-row":"Table-module_header-row__3N8B1","header-cell":"Table-module_header-cell__1EeX8","header-label":"Table-module_header-label__27Xiw","widgets":"Table-module_widgets__2GsDL","sort-icons":"Table-module_sort-icons__3QRVN","active-sort-icons":"Table-module_active-sort-icons__7NLKt","header-handle":"Table-module_header-handle__3Tr3Q","header-cell-popover-trigger":"Table-module_header-cell-popover-trigger__3bS0z","no-table-data":"Table-module_no-table-data__PyCpk","rows-group-container":"Table-module_rows-group-container__JFFhM","fixed-height":"Table-module_fixed-height__3oMKn","row":"Table-module_row__2vf5x","disabled-row":"Table-module_disabled-row__3BcDr","expanded":"Table-module_expanded__WEoJT","cell":"Table-module_cell__20b5U Table-module_cell-base__yutws","sub-row":"Table-module_sub-row__3wATq","clickable":"Table-module_clickable__2xqLP","sub-row-transition-parent":"Table-module_sub-row-transition-parent__2dJLp","cell-base":"Table-module_cell-base__yutws","disabled-cell":"Table-module_disabled-cell__bLi9I","selected":"Table-module_selected__DE3E3","cell-checkbox":"Table-module_cell-checkbox__3DObG","menu-cell":"Table-module_menu-cell__1ZT7Q Table-module_cell-base__yutws","selection-cell":"Table-module_selection-cell__2qmUU Table-module_cell-base__yutws","cell-value":"Table-module_cell-value__ss5_Y","large-cell":"Table-module_large-cell__4KGmK","table-menu":"Table-module_table-menu__2XY4R","toggle-column-selector":"Table-module_toggle-column-selector__3Ck7V","rows-group-cover":"Table-module_rows-group-cover__1uC6o","last-column-sticky":"Table-module_last-column-sticky__34XA7","blank":"Table-module_blank__3pi3t","bgshimmer":"Table-module_bgshimmer__1JXb-"};

var scrollFixStyles = {"scroll-duplicator":"ScrollFix-module_scroll-duplicator__3zYA3","scroll-duplicator-sticky":"ScrollFix-module_scroll-duplicator-sticky__31buf","scroll-divider":"ScrollFix-module_scroll-divider__28ok3"};

var styles$u = {"content":"MenuPopover-module_content__12vKO","trigger":"MenuPopover-module_trigger__14fPr","small-trigger":"MenuPopover-module_small-trigger__24IT_","large-trigger":"MenuPopover-module_large-trigger__1hu2Z","trigger-active":"MenuPopover-module_trigger-active__3vMQh","menu-popover":"MenuPopover-module_menu-popover__2opF1","button-style-menu-popover":"MenuPopover-module_button-style-menu-popover__2UYSJ","popover-menu-vertical":"MenuPopover-module_popover-menu-vertical__3DBy9","menu-item":"MenuPopover-module_menu-item__3xlmf","tooltip":"MenuPopover-module_tooltip__1bELn","oval-trigger":"MenuPopover-module_oval-trigger__c6N0j","oval-trigger-active":"MenuPopover-module_oval-trigger-active__2W5KH","text-with-arrow-trigger":"MenuPopover-module_text-with-arrow-trigger__3N40n","disabled":"MenuPopover-module_disabled__1wxLv","active":"MenuPopover-module_active__3hT47","buttonTriggerWrapper":"MenuPopover-module_buttonTriggerWrapper__1ENlK","bgshimmer":"MenuPopover-module_bgshimmer__1EnaR"};

var _circle$2, _path$5;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgMenuCircle = function SvgMenuCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    overflow: "visible"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    stroke: "var(--icon-primary)",
    cx: 12,
    cy: 12,
    r: 11.5
  })), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--icon-primary)",
    d: "M12 9a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 9zm0 4.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0 4.5a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 18z"
  })));
};

var _rect$2, _circle$1, _circle2$1, _circle3$1;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgIcOvalCircle = function SvgIcOvalCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 16,
    viewBox: "0 0 32 16"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "primary-fill",
    x: 1,
    y: 1,
    width: 30,
    height: 14,
    rx: 8,
    ry: 8
  })), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    fill: "primary-fill",
    cx: 16,
    cy: 8,
    r: 2
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React.createElement("circle", {
    fill: "primary-fill",
    cx: 10.5,
    cy: 8,
    r: 2
  })), _circle3$1 || (_circle3$1 = /*#__PURE__*/React.createElement("circle", {
    fill: "primary-fill",
    cx: 21.5,
    cy: 8,
    r: 2
  })));
};

var copyButtonStyles = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","button":"CopyButton-module_button__CfES7","bubble":"CopyButton-module_bubble__HO_VR","left":"CopyButton-module_left__3YREw","with-children":"CopyButton-module_with-children__1hu2y","icon":"CopyButton-module_icon__gothr"};

var CopyButton$1 = ({ text: _text, className, style, children, type = "default", includeIcon, variant, color, iconClassName, iconStyle, isDisabled, label, origin, dataTestId = 'copy-button' }) => {
    const [showBubble, setShowBubble] = useState(false);
    const [bubblePosition, setBubblePosition] = useState({ top: 0, left: 0, isLeft: false });
    const buttonRef = useRef(null);
    const bubbleRef = useRef(null);
    const text = _$1.isObject(_text) ? JSON.stringify(_text, null, 4) : _text;
    useEffect(() => {
        if (showBubble && buttonRef.current) {
            const { top, left, width } = buttonRef.current.getBoundingClientRect();
            const maxWidth = document.body.clientWidth;
            let isLeft = false;
            if (left + width + 60 > maxWidth) {
                isLeft = true;
            }
            setBubblePosition({ top: top - 31, left: left + (isLeft ? 0 : width), isLeft });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showBubble]);
    let baseClassName = copyButtonStyles['button'];
    if ((variant === "square" && color === "secondary") || type === "secondary") {
        baseClassName = styles$1c.secondary;
    }
    else if (variant === "square" || type === "primary") {
        baseClassName = styles$1c.primary;
    }
    else if (variant === "icon") {
        if (color === "secondary") {
            baseClassName = styles$1c["icon-actual-secondary"];
        }
        else {
            baseClassName = styles$1c.icon;
        }
    }
    else if (variant === "text") {
        if (color === "secondary") {
            baseClassName = styles$1c['text-secondary'];
        }
        else {
            baseClassName = styles$1c['text'];
        }
    }
    if (type === "default" && !variant && !children) {
        variant = "icon";
    }
    if (variant === "icon" && _$1.isUndefined(includeIcon)) {
        includeIcon = true;
    }
    return jsx$3(CopyToClipboard, { text: text, origin: origin, onCopy: () => {
            if (window['FS'] && window['FS'].event && (origin === null || origin === void 0 ? void 0 : origin.name)) {
                window['FS'].event('Copy-CodeBox', {
                    origin: origin.name,
                    type: origin.type,
                });
            }
            setShowBubble(true);
            setTimeout(() => {
                setShowBubble(false);
            });
        }, children: jsxs("button", { "data-testid": dataTestId, disabled: isDisabled, type: "button", ref: buttonRef, className: classNames(className, baseClassName), style: style, "aria-label": `Copy${label ? " label" : ""}`, children: [includeIcon && jsx$3(CopyIcon, { className: classNames(copyButtonStyles.icon, iconClassName, { [copyButtonStyles['with-children']]: !!children }), style: iconStyle }), children, jsx$3(CSSTransition, { nodeRef: bubbleRef, in: showBubble, unmountOnExit: true, timeout: 1000, children: jsx$3("span", { ref: bubbleRef, children: ReactDOM.createPortal(jsx$3("div", { className: classNames(copyButtonStyles['bubble'], { [copyButtonStyles['left']]: bubblePosition.isLeft }), style: { top: bubblePosition.top, left: bubblePosition.left }, children: jsx$3(TooltipContent, { children: "Copied!" }) }), getRootComponent()) }) })] }) });
};

const RoundDropdownButton = ({ buttonRef, isActive, children, color = "primary", large, disabled, isDisabled, tooltip, onClick, style, className, dataTestId }) => {
    return jsxs("button", { onClick: onClick, ref: buttonRef, "data-testid": dataTestId, type: "button", disabled: disabled || isDisabled, className: classNames(styles$1c[color], styles$1c['round-dropdown-button'], { [styles$1c.large]: large }, className), style: style, children: [children, jsx$3("span", { className: classNames(styles$1c['dropdown-button-triangle'], { [styles$1c["active-triangle"]]: isActive }) }), tooltip && jsx$3(Tooltip$1, { children: tooltip })] });
};
const DropdownButton = ({ buttonRef, isActive, children, color = "primary", large, disabled, isDisabled, tooltip, onClick, className, dataTestId }) => {
    return jsxs("button", { "data-testid": dataTestId, onClick: onClick, ref: buttonRef, type: "button", disabled: disabled || isDisabled, className: classNames(styles$1c[color], styles$1c['dropdown-button'], { [styles$1c.large]: large }, className), children: [children, jsx$3("span", { className: classNames(styles$1c['dropdown-button-triangle'], { [styles$1c["active-triangle"]]: isActive }) }), tooltip && jsx$3(Tooltip$1, { children: tooltip })] });
};

var _excluded$6 = ["isActive", "buttonRef"],
  _excluded2$1 = ["popoverClassName", "Trigger", "TriggerButton", "children", "disabled", "tooltip"],
  _excluded3 = ["round", "buttonChildren", "large", "color", "popoverClassName", "triggerClassName"];
var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
    _onClick = _ref.onClick,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip;
  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: styles$u["menu-item"],
    disabled: disabled,
    onClick: function onClick(e) {
      var keepMenuOpen = _onClick(e);
      if (!keepMenuOpen) {
        closeActivePopover$1();
      }
    }
  }, _$1.isArray(children) ? children.map(function (child) {
    if (_$1.isString(child)) {
      return /*#__PURE__*/React__default.createElement("span", null, child);
    }
    return child;
  }) : children, tooltip && /*#__PURE__*/React__default.createElement(Tooltip$1, {
    placement: "center"
  }, tooltip));
};
var CopyMenuItem = function CopyMenuItem(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    hideValue = _ref2.hideValue;
  return /*#__PURE__*/React__default.createElement("span", {
    className: styles$u["menu-item"]
  }, /*#__PURE__*/React__default.createElement("span", null, label, !hideValue && ": ".concat(value)), /*#__PURE__*/React__default.createElement(CopyButton$1, {
    text: value
  }));
};
var Popover = function Popover(_ref3) {
  var contentClassName = _ref3.contentClassName,
    contentStyle = _ref3.contentStyle,
    _menu = _ref3.menu,
    menuChildren = _ref3.menuChildren;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    verticalPlacement = _useState2[0],
    setVerticalPlacement = _useState2[1];
  var menuRef = useRef();
  var menu = useMemo(function () {
    if (menuChildren) {
      if (_$1.isArray(menuChildren)) {
        return menuChildren;
      } else {
        return [menuChildren];
      }
    } else {
      return _$1.filter(_$1.isFunction(_menu) ? _menu() : _menu, _$1.identity);
    }
  }, [_menu, menuChildren]);
  useLayoutEffect(function () {
    if (menuRef.current) {
      var rect = menuRef.current.getBoundingClientRect();
      if (rect.height + rect.top > window.innerHeight) {
        setVerticalPlacement(true);
      }
    }
  }, [menu]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$u["content"], _defineProperty$3({}, styles$u['popover-menu-vertical'], verticalPlacement), contentClassName),
    style: contentStyle,
    ref: menuRef
  }, menuChildren && menu.map(function (child, index) {
    var _child$props, _child$props2, _child$props3;
    if (!child) {
      return "";
    }
    var needClone = child.type !== MenuItem && child.type !== CopyMenuItem && !(child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.className);
    if (needClone && child !== null && child !== void 0 && child.props.disabled) {
      return /*#__PURE__*/React__default.createElement(MenuItem, {
        key: index,
        tooltip: child.props.tooltip,
        disabled: true
      }, child === null || child === void 0 ? void 0 : child.props.children);
    }
    var clone = needClone ? /*#__PURE__*/React__default.cloneElement(child, {
      className: styles$u["menu-item"],
      onClick: function onClick(e) {
        var keepMenuOpen = child.onClick ? child.onClick(e) : false;
        if (!keepMenuOpen) {
          closeActivePopover$1();
        }
      }
    }, _$1.isArray(child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.children) ? child.props.children.map(function (child) {
      if (_$1.isString(child)) {
        return /*#__PURE__*/React__default.createElement("span", null, child);
      }
      return child;
    }) : child === null || child === void 0 || (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.children) : child;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, clone);
  }), !menuChildren && menu.map(function (_ref4, index) {
    var key = _ref4.key,
      label = _ref4.label,
      onClick = _ref4.onClick,
      Component = _ref4.Component,
      Icon = _ref4.Icon,
      iconStyle = _ref4.iconStyle,
      disabled = _ref4.disabled,
      tooltip = _ref4.tooltip;
    if (Component) {
      return /*#__PURE__*/React__default.createElement(Component, {
        key: key || label || index,
        className: styles$u["menu-item"]
      });
    } else if (label) {
      return /*#__PURE__*/React__default.createElement(MenuItem, {
        key: key || label || index,
        onClick: onClick,
        disabled: disabled,
        tooltip: tooltip
      }, Icon && /*#__PURE__*/React__default.createElement(Icon, {
        style: iconStyle
      }), /*#__PURE__*/React__default.createElement("span", null, label));
    }
  })));
};
var ActionMenuContent$1 = /*#__PURE__*/React__default.memo(function (_ref5) {
  var children = _ref5.children,
    className = _ref5.className,
    style = _ref5.style;
  children = !children || _$1.isArray(children) ? children : [children];
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$u.content, className),
    style: style
  }, children && children.map(function (child, index) {
    if (!child) {
      return "";
    }
    var needClone = child.type !== MenuItem && child.type !== CopyMenuItem;
    if (needClone && child !== null && child !== void 0 && child.props.disabled) {
      return /*#__PURE__*/React__default.createElement(MenuItem, {
        key: index,
        tooltip: child.props.tooltip,
        disabled: true
      }, child === null || child === void 0 ? void 0 : child.props.children);
    }
    var clone = needClone ? /*#__PURE__*/React__default.cloneElement(child, {
      className: styles$u["menu-item"],
      onClick: function onClick(e) {
        var keepMenuOpen = child.onClick ? child.onClick(e) : false;
        if (!keepMenuOpen) {
          closeActivePopover$1();
        }
      }
    }) : child;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, clone);
  }));
});
var OvalTrigger$1 = function OvalTrigger(_ref6) {
  var isActive = _ref6.isActive;
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(styles$u['oval-trigger'], _defineProperty$3({}, styles$u['oval-trigger-active'], isActive))
  }, /*#__PURE__*/React__default.createElement(SvgIcOvalCircle, null));
};
var TextWithArrowTrigger = function TextWithArrowTrigger(_ref7) {
  var isActive = _ref7.isActive,
    children = _ref7.children,
    disabled = _ref7.disabled,
    className = _ref7.className,
    style = _ref7.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$u['text-with-arrow-trigger'], className, _defineProperty$3(_defineProperty$3({}, styles$u['disabled'], disabled), styles$u['active'], isActive)),
    style: style
  }, /*#__PURE__*/React__default.createElement("span", null, children), /*#__PURE__*/React__default.createElement(DropdownArrowDownIcon, null));
};
var MenuTriggerIcon = function MenuTriggerIcon(_ref8) {
  var isActive = _ref8.isActive,
    Icon = _ref8.Icon,
    className = _ref8.className;
  return /*#__PURE__*/React__default.createElement(Icon, {
    className: classNames(className, [styles$u['trigger']], _defineProperty$3({}, styles$u['trigger-active'], isActive))
  });
};
var BigTrigger = function BigTrigger(_ref9) {
  var isActive = _ref9.isActive;
  return /*#__PURE__*/React__default.createElement(MenuTriggerIcon, {
    Icon: SvgMenuCircle,
    isActive: isActive,
    className: styles$u['large-trigger']
  });
};
var SmallTrigger = function SmallTrigger(_ref10) {
  var isActive = _ref10.isActive,
    buttonRef = _ref10.buttonRef,
    props = _objectWithoutProperties$2(_ref10, _excluded$6);
  var className = isActive ? "active" : undefined;
  return /*#__PURE__*/React__default.createElement("span", {
    ref: buttonRef,
    className: styles$u.buttonTriggerWrapper
  }, /*#__PURE__*/React__default.createElement(Button$2, _extends$j({
    variant: "icon"
  }, props, {
    className: className
  }), /*#__PURE__*/React__default.createElement(ActionsMenuCircleIcon, null)));
};

/**
 *
 triggerClassName,
 popoverClassName, popoverStyle, children,
 arrowClassName,
 arrowStyle,
 contentClassName,
 contentStyle,
 menu
 */
var MenuPopover = function MenuPopover(_ref11) {
  var popoverClassName = _ref11.popoverClassName,
    _Trigger = _ref11.Trigger,
    _TriggerButton = _ref11.TriggerButton,
    children = _ref11.children,
    disabled = _ref11.disabled,
    tooltip = _ref11.tooltip,
    props = _objectWithoutProperties$2(_ref11, _excluded2$1);
  var Trigger = undefined;
  var TriggerButton = undefined;
  if (_Trigger === "oval") {
    Trigger = OvalTrigger$1;
  } else if (_Trigger === "small") {
    TriggerButton = SmallTrigger;
  } else if (_Trigger) {
    Trigger = _Trigger;
  } else if (_TriggerButton) {
    TriggerButton = _TriggerButton;
  } else {
    Trigger = BigTrigger;
  }
  return /*#__PURE__*/React__default.createElement(PopoverMechanism, _extends$j({
    popoverClassName: classNames(styles$u['menu-popover'], popoverClassName),
    disabled: disabled,
    tooltip: tooltip
  }, props, {
    menuChildren: children,
    Popover: Popover,
    Trigger: Trigger,
    TriggerButton: TriggerButton,
    triggerOnClick: true
  }));
};
var ButtonStyleMenuPopover = function ButtonStyleMenuPopover(_ref12) {
  var round = _ref12.round,
    buttonChildren = _ref12.buttonChildren,
    large = _ref12.large,
    color = _ref12.color,
    popoverClassName = _ref12.popoverClassName,
    triggerClassName = _ref12.triggerClassName,
    props = _objectWithoutProperties$2(_ref12, _excluded3);
  var _TriggerButton2 = round ? RoundDropdownButton : DropdownButton;
  return /*#__PURE__*/React__default.createElement(MenuPopover, _extends$j({}, props, {
    popoverClassName: classNames(styles$u['button-style-menu-popover'], popoverClassName),
    renderPosition: "right",
    TriggerButton: function TriggerButton(props) {
      return /*#__PURE__*/React__default.createElement(_TriggerButton2, _extends$j({}, props, {
        large: large,
        color: color,
        className: triggerClassName
      }), buttonChildren);
    }
  }));
};
var MenuPopover$1 = MenuPopover;

var styles$t = {"base":"ColumnsSelector-module_base__LGgQb","content":"ColumnsSelector-module_content__O_Mju","select-all":"ColumnsSelector-module_select-all__1cjs5","bgshimmer":"ColumnsSelector-module_bgshimmer__3HYC8"};

var ColumnsSelector = function ColumnsSelector(_ref) {
  var isSticky = _ref.isSticky,
    originalColumns = _ref.originalColumns,
    columnState = _ref.columnState,
    restoreColumnStateDefaults = _ref.restoreColumnStateDefaults,
    updateColumnState = _ref.updateColumnState,
    closeSelector = _ref.closeSelector,
    className = _ref.className,
    ref = _ref.ref;
  var _useState = useState(_$1.mapValues(columnState, function (column) {
      return column.isHidden;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    columnSelection = _useState2[0],
    setColumnSelection = _useState2[1];
  var _useState3 = useState(!_$1.some(columnSelection)),
    _useState4 = _slicedToArray(_useState3, 2),
    checkAll = _useState4[0],
    setCheckAll = _useState4[1];
  var columns = useMemo(function () {
    return _$1.reject(originalColumns, "hideFromColumnSelector");
  }, [originalColumns]);
  var columnsMap = _$1.keyBy(originalColumns, "id");
  useEffect(function () {
    setColumnSelection(_$1.mapValues(columnState, function (column) {
      return column.isHidden;
    }));
  }, [columnState]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$t.base, className),
    ref: ref
  }, /*#__PURE__*/React__default.createElement(ClickAway, {
    ignoreParentClick: true,
    listener: closeSelector
  }), isSticky && /*#__PURE__*/React__default.createElement(DisableScroll, null), /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.content
  }, /*#__PURE__*/React__default.createElement(ActionMenuCheckbox$1, {
    className: styles$t["select-all"],
    dataTestId: 'table-header-column-options-select-all',
    onChange: function onChange() {
      setColumnSelection(_$1.mapValues(columnSelection, function () {
        return checkAll;
      }));
      setCheckAll(!checkAll);
    },
    checked: checkAll,
    isPartial: !checkAll
  }, "All (".concat(columns.length, ")")), _$1.map(columns, function (_ref2) {
    var id = _ref2.id;
    return /*#__PURE__*/React__default.createElement(ActionMenuCheckbox$1, {
      disabled: columnsMap[id].mustShow,
      dataTestId: "table-header-column-options-".concat(columnsMap[id].header),
      key: id,
      onChange: function onChange() {
        setColumnSelection(_objectSpread2(_objectSpread2({}, columnSelection), {}, _defineProperty$3({}, id, !columnSelection[id])));
        setCheckAll(false);
      },
      checked: !columnSelection[id]
    }, columnsMap[id].header);
  })), /*#__PURE__*/React__default.createElement(ActionMenuButtonsRow$1, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      var newColumnState = _objectSpread2({}, columnState);
      _$1.forEach(columnSelection, function (isHidden, id) {
        newColumnState[id] = _objectSpread2(_objectSpread2({}, columnState[id]), {}, {
          isHidden: isHidden
        });
      });
      updateColumnState(newColumnState);
      closeSelector();
    }
  }, "Apply"), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      restoreColumnStateDefaults();
      setCheckAll(false);
      closeSelector();
    }
  }, "Cancel")));
};
var ColumnsSelector$1 = ColumnsSelector;

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/observe.ts
var observerMap = /* @__PURE__ */new Map();
var RootIds = /* @__PURE__ */new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== void 0).map(key => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {};
  }
  const {
    id,
    observer,
    elements
  } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", node => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({
            inView: !!this.props.initialInView,
            entry: void 0
          });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({
          inView,
          entry
        });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const {
      children
    } = this.props;
    if (typeof children === "function") {
      const {
        inView,
        entry
      } = this.state;
      return children({
        inView,
        entry,
        ref: this.handleNode
      });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(as || "div", {
      ref: this.handleNode,
      ...props
    }, children);
  }
};

var BlankRow = /*#__PURE__*/React__default.memo(function (_ref) {
  var stickColumnIndex = _ref.stickColumnIndex,
    stickyColumnStyleRef = _ref.stickyColumnStyleRef,
    columns = _ref.columns,
    widths = _ref.widths;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$v['row'], styles$v['blank'])
  }, columns.map(function (column, index) {
    var className = classNames(styles$v['cell'], column.cellClass, _defineProperty$3({}, stickyColumnStyleRef.current.dataset.styleid, index <= stickColumnIndex));
    var style = {
      flex: column.fixedWidth ? "0 0 ".concat(widths[index], "px") : "1 0 ".concat(widths[index], "px")
    };
    return /*#__PURE__*/React__default.createElement("div", {
      key: column.id,
      className: className,
      style: style
    }, /*#__PURE__*/React__default.createElement("span", null));
  }));
});

var DefaultCellRenderer$1 = (function (_ref) {
  var value = _ref.value;
  var pValue = value;
  if (_$1.isArray(value)) {
    pValue = value.join(", ");
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, pValue === "N/A" && /*#__PURE__*/React__default.createElement(NotAvailableCellData, null), pValue && pValue !== "N/A" && /*#__PURE__*/React__default.createElement("span", {
    className: styles$v['cell-value'],
    title: pValue.toString()
  }, pValue));
});

var DefaultRowRenderer = /*#__PURE__*/React__default.memo(function (_ref) {
  var columns = _ref.columns,
    row = _ref.row,
    rowId = _ref.rowId,
    rowClassName = _ref.rowClassName,
    cellClassName = _ref.cellClassName,
    widths = _ref.widths,
    totalWidth = _ref.totalWidth,
    isRowSelectingEnabled = _ref.isRowSelectingEnabled,
    isMultiSelect = _ref.isMultiSelect,
    isRowSelected = _ref.isRowSelected,
    toggleRowSelection = _ref.toggleRowSelection,
    rowState = _ref.rowState,
    updateRowState = _ref.updateRowState,
    onRowClick = _ref.onRowClick,
    onRowDoubleClick = _ref.onRowDoubleClick,
    lastColumnSticky = _ref.lastColumnSticky,
    lastColumnStickyStyleRef = _ref.lastColumnStickyStyleRef,
    stickColumnIndex = _ref.stickColumnIndex,
    stickyColumnStyleRef = _ref.stickyColumnStyleRef,
    SubRowRenderer = _ref.SubRowRenderer,
    isRowDisabled = _ref.isRowDisabled,
    disabledTitle = _ref.disabledTitle;
  var updateRow = updateRowState && updateRowState(rowId);
  var selectRow = isRowSelectingEnabled && toggleRowSelection(rowId);
  var disabled = row.isDisabled || (_$1.isFunction(isRowDisabled) ? isRowDisabled(row) : false);
  var onClick = onRowClick && function () {
    return onRowClick(row);
  };
  var onDoubleClick = onRowDoubleClick && function () {
    return onRowDoubleClick(row);
  };
  var isSelected = rowState === null || rowState === void 0 ? void 0 : rowState.isSelected;
  var isExpanded = rowState === null || rowState === void 0 ? void 0 : rowState.isExpanded;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    title: disabled ? disabledTitle : undefined,
    "data-testid": "table-row-".concat(rowId),
    className: classNames(styles$v['row'], rowClassName, _defineProperty$3(_defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$v['selected'], isSelected), styles$v['expanded'], isExpanded), styles$v['clickable'], !!onClick), styles$v['disabled-row'], disabled)),
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    style: {
      width: totalWidth
    }
  }, columns.map(function (column, index) {
    var stickCustomColumn = index <= stickColumnIndex;
    var stickLastColumn = lastColumnSticky && index === columns.length - 1;
    var className = classNames(styles$v['cell'], column.cellClass, cellClassName, _defineProperty$3(_defineProperty$3(_defineProperty$3({}, lastColumnStickyStyleRef === null || lastColumnStickyStyleRef === void 0 ? void 0 : lastColumnStickyStyleRef.current.dataset.styleid, stickLastColumn), styles$v['disabled-cell'], disabled), stickyColumnStyleRef === null || stickyColumnStyleRef === void 0 ? void 0 : stickyColumnStyleRef.current.dataset.styleid, stickCustomColumn));
    var CellRenderer = column.Renderer || DefaultCellRenderer$1;
    var value = extractValue(row, column.accessor);
    var additionalStyles = column.cellStyle ? column.cellStyle({
      value: value,
      row: row,
      rowState: rowState,
      isRowSelected: isRowSelected
    }) : undefined;
    var style = _objectSpread2({
      flex: column.fixedWidth ? "0 0 ".concat(widths[index], "px") : "1 0 ".concat(widths[index], "px")
    }, additionalStyles);
    return /*#__PURE__*/React__default.createElement("div", {
      key: column.id,
      className: className,
      style: style,
      "data-testid": "table-cell-column-".concat(column.header === "" ? column.id : column.header, "-row-").concat(rowId)
    }, /*#__PURE__*/React__default.createElement(CellRenderer, {
      row: row,
      value: value,
      column: column,
      isMultiSelect: isMultiSelect,
      isRowSelected: isRowSelected,
      updateRow: updateRow,
      selectRow: selectRow,
      rowState: rowState,
      disabled: disabled
    }));
  })), SubRowRenderer && /*#__PURE__*/React__default.createElement(lib.UnmountClosed, {
    isOpened: isExpanded,
    theme: {
      collapse: styles$v['sub-row-transition-parent'],
      content: classNames(styles$v['sub-row'], stickyColumnStyleRef.current.dataset.styleid)
    }
  }, /*#__PURE__*/React__default.createElement(SubRowRenderer, {
    row: row,
    rowState: rowState,
    updateRow: updateRow
  })));
});

var _desc$5, _path$4;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var SvgIcTableSortAsc = function SvgIcTableSortAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none"
  }, props), _desc$5 || (_desc$5 = /*#__PURE__*/React.createElement("desc", null, "Sort ascending")), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59637 0.355413C4.79062 0.159127 5.10721 0.157483 5.30349 0.351742L9.13575 4.14463C9.45324 4.45885 9.23072 5 8.78402 5H1.19826C0.75406 5 0.530411 4.46402 0.842862 4.1483L4.59637 0.355413Z",
    fill: "var(--icon-primary)"
  })));
};

var _desc$4, _path$3;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgIcTableSortAscActive = function SvgIcTableSortAscActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$4 || (_desc$4 = /*#__PURE__*/React.createElement("desc", null, "Sorted ascending")), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00011 13.8594C5.5524 13.8594 6.00011 13.4117 6.00011 12.8594L6.00011 5.85937L8.93259 5.85937C9.35651 5.85937 9.58809 5.36495 9.3167 5.03928L5.38422 0.320307C5.18433 0.0804306 4.8159 0.0804296 4.616 0.320306L0.683523 5.03928C0.412137 5.36495 0.643716 5.85937 1.06763 5.85937L4.00011 5.85937L4.00011 12.8594C4.00011 13.4117 4.44783 13.8594 5.00011 13.8594Z",
    fill: "var(--icon-primary)"
  })));
};

var _desc$3, _path$2;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgIcTableSortDesc = function SvgIcTableSortDesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none"
  }, props), _desc$3 || (_desc$3 = /*#__PURE__*/React.createElement("desc", null, "Sort descending")), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35355 4.64645C5.15829 4.84171 4.84171 4.84171 4.64645 4.64645L0.853552 0.853552C0.538569 0.53857 0.761653 -1.30397e-07 1.20711 -1.70094e-07L8.79289 -8.46103e-07C9.23835 -8.85799e-07 9.46143 0.53857 9.14645 0.853553L5.35355 4.64645Z",
    fill: "var(--icon-primary)"
  })));
};

var _desc$2, _path$1;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgIcTableSortDescActive = function SvgIcTableSortDescActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc$2 || (_desc$2 = /*#__PURE__*/React.createElement("desc", null, "Sorted descending")), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99984 0.140625C4.44756 0.140625 3.99984 0.58834 3.99984 1.14062V8.14062H1.06736C0.643443 8.14062 0.411865 8.63505 0.683251 8.96072L4.61573 13.6797C4.81563 13.9196 5.18405 13.9196 5.38395 13.6797L9.31643 8.96072C9.58782 8.63505 9.35624 8.14062 8.93232 8.14062H5.99984V1.14062C5.99984 0.58834 5.55213 0.140625 4.99984 0.140625Z",
    fill: "var(--icon-primary)"
  })));
};

var RenderHeaderCell$1 = function RenderHeaderCell(_ref) {
  var sortState = _ref.sortState,
    column = _ref.column,
    toggleSort = _ref.toggleSort,
    width = _ref.width,
    columnFilterOptions = _ref.columnFilterOptions,
    _ref$columnFilterStat = _ref.columnFilterState,
    columnFilterState = _ref$columnFilterStat === void 0 ? {} : _ref$columnFilterStat,
    updateFilterState = _ref.updateFilterState,
    stickLastColumn = _ref.stickLastColumn,
    lastColumnStickyStyleRef = _ref.lastColumnStickyStyleRef,
    stickyColumnStyleRef = _ref.stickyColumnStyleRef,
    stickColumn = _ref.stickColumn,
    headerCellClassName = _ref.headerCellClassName,
    headerHandleClassName = _ref.headerHandleClassName,
    dataTestId = _ref.dataTestId;
  var id = column.id;
  var sortingEnabled = !!sortState && _$1.get(column, "sort.enabled", true);
  var filterEnabled = _$1.get(column, "filter.enabled", false);
  var isSorted = sortingEnabled && sortState.column === id;
  var sortOrder = sortingEnabled && isSorted && sortState.sortOrder;
  var hideHeaderHandle = _$1.get(column, "hideHeaderHandle", false);
  var className = classNames(column.headerClass, styles$v['header-cell'], headerCellClassName, _defineProperty$3(_defineProperty$3({}, lastColumnStickyStyleRef.current.dataset.styleid, stickLastColumn), stickyColumnStyleRef.current.dataset.styleid, stickColumn));
  var style = {
    flex: column.fixedWidth ? "0 0 ".concat(width, "px") : "1 0 ".concat(width, "px")
  };
  var updateColumnFilter = function updateColumnFilter(values) {
    updateFilterState({
      id: id,
      values: values
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: style,
    "data-testid": dataTestId
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$v["header-label"]
  }, column.popoverText && /*#__PURE__*/React__default.createElement(Popover$1, {
    triggerClassName: styles$v['header-cell-popover-trigger']
  }, column.popoverText), /*#__PURE__*/React__default.createElement("span", null, column.header, filterEnabled && columnFilterState.activeCount > 0 && " (".concat(columnFilterState.activeCount, ")"))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$v.widgets
  }, filterEnabled && /*#__PURE__*/React__default.createElement(InternalFilter, {
    filterConfig: column.filter,
    columnFilterOptions: columnFilterOptions,
    columnFilterState: columnFilterState,
    updateColumnFilter: updateColumnFilter
  }), sortingEnabled && !isSorted && /*#__PURE__*/React__default.createElement("button", {
    className: styles$v['sort-icons'],
    onClick: function onClick() {
      return toggleSort({
        id: id
      });
    }
  }, /*#__PURE__*/React__default.createElement(SvgIcTableSortAsc, null), /*#__PURE__*/React__default.createElement(SvgIcTableSortDesc, null)), isSorted && /*#__PURE__*/React__default.createElement("button", {
    className: styles$v["active-sort-icons"],
    onClick: function onClick() {
      return toggleSort({
        id: id
      });
    }
  }, sortOrder === "asc" ? /*#__PURE__*/React__default.createElement(SvgIcTableSortAscActive, null) : /*#__PURE__*/React__default.createElement(SvgIcTableSortDescActive, null))), !hideHeaderHandle ? /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$v['header-handle'], headerHandleClassName)
  }) : /*#__PURE__*/React__default.createElement("div", null));
};
var RenderHeaderCell$2 = RenderHeaderCell$1;

var loadingStyles = {"loading-row":"TableLoading-module_loading-row___uE5M","loading-cell":"TableLoading-module_loading-cell__1ZY38","loading-cell-with-mask":"TableLoading-module_loading-cell-with-mask__3t6EW TableLoading-module_loading-cell__1ZY38","bgshimmer":"TableLoading-module_bgshimmer__3BI7L"};

var emptyRowState = {};
var RenderRows = /*#__PURE__*/React__default.memo(function (_ref) {
  var isLoading = _ref.isLoading,
    rows = _ref.rows,
    columns = _ref.columns,
    RenderRow = _ref.RenderRow,
    rowClassName = _ref.rowClassName,
    lastColumnSticky = _ref.lastColumnSticky,
    widths = _ref.widths,
    totalWidth = _ref.totalWidth,
    cellClassName = _ref.cellClassName,
    selectionState = _ref.selectionState,
    isRowSelectingEnabled = _ref.isRowSelectingEnabled,
    toggleRowSelection = _ref.toggleRowSelection,
    rowState = _ref.rowState,
    updateRowState = _ref.updateRowState,
    tableWidth = _ref.tableWidth,
    onRowClick = _ref.onRowClick,
    onRowDoubleClick = _ref.onRowDoubleClick,
    lastColumnStickyStyleRef = _ref.lastColumnStickyStyleRef,
    stickyColumnStyleRef = _ref.stickyColumnStyleRef,
    stickColumnIndex = _ref.stickColumnIndex,
    SubRowRenderer = _ref.SubRowRenderer,
    isRowDisabled = _ref.isRowDisabled,
    disabledTitle = _ref.disabledTitle;
  if (isLoading) {
    return _$1.range(5).map(function (row) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: row,
        className: loadingStyles['loading-row']
      }, _$1.range(columns.length).map(function (column) {
        var style = {
          flex: "1 0 ".concat(widths[column], "px")
        };
        var includeMask = _$1.sum(_$1.take(widths, column + 1)) < tableWidth && column < 5;
        return /*#__PURE__*/React__default.createElement("div", {
          style: style,
          key: column,
          className: classNames(_defineProperty$3(_defineProperty$3({}, loadingStyles["loading-cell"], !includeMask), loadingStyles["loading-cell-with-mask"], includeMask))
        });
      }));
    });
  } else {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BlankRow, {
      stickColumnIndex: stickColumnIndex,
      stickyColumnStyleRef: stickyColumnStyleRef,
      columns: columns,
      widths: widths
    }), rows.map(function (row, index) {
      var rowId = _$1.isUndefined(row.id) ? index : row.id;
      var currentRowState = rowState && rowState[rowId] || emptyRowState;
      var isRowSelected = selectionState && selectionState.rows[rowId];
      return /*#__PURE__*/React__default.createElement(RenderRow, {
        rowClassName: rowClassName,
        stickColumnIndex: stickColumnIndex,
        stickyColumnStyleRef: stickyColumnStyleRef,
        lastColumnSticky: lastColumnSticky,
        lastColumnStickyStyleRef: lastColumnStickyStyleRef,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        widths: widths,
        totalWidth: totalWidth,
        key: rowId,
        rowId: rowId,
        row: row,
        columns: columns,
        cellClassName: cellClassName,
        isRowSelected: isRowSelected,
        isMultiSelect: isRowSelectingEnabled && selectionState.isMulti,
        isRowSelectingEnabled: isRowSelectingEnabled,
        toggleRowSelection: toggleRowSelection,
        rowState: currentRowState,
        updateRowState: updateRowState,
        SubRowRenderer: SubRowRenderer,
        isRowDisabled: isRowDisabled,
        disabledTitle: disabledTitle
      });
    }));
  }
});

var ToggleColumnSelectorButton = function ToggleColumnSelectorButton(_ref) {
  var isActive = _ref.isActive,
    toggle = _ref.toggle,
    columnStickyStyleRef = _ref.columnStickyStyleRef,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: toggle,
    style: style,
    className: classNames(columnStickyStyleRef.current.dataset.styleid, styles$v['toggle-column-selector'], _defineProperty$3({}, styles$v['active'], isActive), className)
  }, /*#__PURE__*/React__default.createElement(AddRemoveColumnIcon, null));
};
var ToggleColumnSelectorButton$1 = ToggleColumnSelectorButton;

var selectingColumn = function selectingColumn() {
  return {
    id: "rowSelector",
    width: 72,
    fixedWidth: true,
    header: "",
    accessor: "",
    cellClass: styles$v['selection-cell'],
    Renderer: function Renderer(_ref) {
      var isRowSelected = _ref.isRowSelected,
        selectRow = _ref.selectRow,
        isMultiSelect = _ref.isMultiSelect,
        disabled = _ref.disabled;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isMultiSelect && /*#__PURE__*/React__default.createElement(Checkbox, {
        isDisabled: disabled,
        isHoverable: !disabled,
        checked: isRowSelected || false,
        name: "row",
        className: styles$v['cell-checkbox'],
        onChange: function onChange() {
          selectRow(!isRowSelected);
        }
      }), !isMultiSelect && /*#__PURE__*/React__default.createElement("button", {
        onClick: disabled ? undefined : function () {
          selectRow(true);
        }
      }, /*#__PURE__*/React__default.createElement(CheckComponent, {
        isDisabled: disabled,
        isHoverable: !disabled,
        isSelected: isRowSelected || false,
        className: styles$v['cell-checkbox']
      })));
    },
    HeaderRenderer: function HeaderRenderer(_ref2) {
      var column = _ref2.column,
        width = _ref2.width,
        selectAllRows = _ref2.selectAllRows,
        selectionState = _ref2.selectionState,
        headerCellClassName = _ref2.headerCellClassName,
        stickLastColumn = _ref2.stickLastColumn,
        stickColumn = _ref2.stickColumn,
        lastColumnStickyStyleRef = _ref2.lastColumnStickyStyleRef,
        stickyColumnStyleRef = _ref2.stickyColumnStyleRef;
      var className = classNames(column.headerClass, styles$v['header-cell'], headerCellClassName, _defineProperty$3(_defineProperty$3({}, lastColumnStickyStyleRef.current.dataset.styleid, stickLastColumn), stickyColumnStyleRef.current.dataset.styleid, stickColumn));
      var style = {
        flex: column.fixedWidth ? "0 0 ".concat(width, "px") : "1 0 ".concat(width, "px")
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: className,
        style: style
      }, selectAllRows && /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: (selectionState === null || selectionState === void 0 ? void 0 : selectionState.allSelected) || false,
        onChange: function onChange() {
          selectAllRows(!selectionState.allSelected);
        },
        className: styles$v['cell-checkbox']
      }));
    }
  };
};
var selectingColumn$1 = selectingColumn;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }
      return false;
    });
    return result;
  }
  return /** @class */function () {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      /**
       * @returns {boolean}
       */
      get: function () {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    /**
     * @param {*} key
     * @returns {*}
     */
    class_1.prototype.get = function (key) {
      var index = getIndex(this.__entries__, key);
      var entry = this.__entries__[index];
      return entry && entry[1];
    };
    /**
     * @param {*} key
     * @param {*} value
     * @returns {void}
     */
    class_1.prototype.set = function (key, value) {
      var index = getIndex(this.__entries__, key);
      if (~index) {
        this.__entries__[index][1] = value;
      } else {
        this.__entries__.push([key, value]);
      }
    };
    /**
     * @param {*} key
     * @returns {void}
     */
    class_1.prototype.delete = function (key) {
      var entries = this.__entries__;
      var index = getIndex(entries, key);
      if (~index) {
        entries.splice(index, 1);
      }
    };
    /**
     * @param {*} key
     * @returns {void}
     */
    class_1.prototype.has = function (key) {
      return !!~getIndex(this.__entries__, key);
    };
    /**
     * @returns {void}
     */
    class_1.prototype.clear = function () {
      this.__entries__.splice(0);
    };
    /**
     * @param {Function} callback
     * @param {*} [ctx=null]
     * @returns {void}
     */
    class_1.prototype.forEach = function (callback, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
        var entry = _a[_i];
        callback.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }
  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }
  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
  // eslint-disable-next-line no-new-func
  return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }
  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
  var leadingCall = false,
    trailingCall = false,
    lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */
  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */
  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);
    // Remove observer if it's present in registry.
    if (~index) {
      observers.splice(index, 1);
    }
    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */
  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();
    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */
  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
      return;
    }
    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */
  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
      propertyName = _b === void 0 ? '' : _b;
    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */
  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }
    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */
  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function (target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf$1 = function (target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  // Return the local global object if it's not possible extract one from
  // provided element.
  return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
    clientHeight = target.clientHeight;
  // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf$1(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.
  var width = toFloat(styles.width),
    height = toFloat(styles.height);
  // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).
  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  }
  // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.
  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf$1(target).SVGGraphicsElement;
    };
  }
  // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens
  return function (target) {
    return target instanceof getWindowOf$1(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
  return target === getWindowOf$1(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect$1(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
  var x = _a.x,
    y = _a.y,
    width = _a.width,
    height = _a.height;
  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  // Rectangle's properties are not writable and non-enumerable.
  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */
  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect$1(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */
  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }
  return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();
    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf$1(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is already being observed.
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    // Force the update of observations.
    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf$1(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */
  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver$1.prototype[method] = function () {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index$1 = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();

var types$4 = ['client', 'offset', 'scroll', 'bounds', 'margin'];
function getTypes(props) {
  var allowedTypes = [];
  types$4.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}
function getContentRect(node, types) {
  var calculations = {};
  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }
  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }
  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }
  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }
  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: styles ? parseInt(styles.marginTop) : 0,
      right: styles ? parseInt(styles.marginRight) : 0,
      bottom: styles ? parseInt(styles.marginBottom) : 0,
      left: styles ? parseInt(styles.marginLeft) : 0
    };
  }
  return calculations;
}

/**
 * Returns the global window object associated with provided element.
 */
function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
  // provided element.

  return ownerGlobal || window;
}
function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(WithContentRect, _Component);
      function WithContentRect() {
        var _this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        };
        _this._animationFrameID = null;
        _this._resizeObserver = null;
        _this._node = null;
        _this._window = null;
        _this.measure = function (entries) {
          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));
          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }
          _this._animationFrameID = _this._window.requestAnimationFrame(function () {
            if (_this._resizeObserver !== null) {
              _this.setState({
                contentRect: contentRect
              });
              if (typeof _this.props.onResize === 'function') {
                _this.props.onResize(contentRect);
              }
            }
          });
        };
        _this._handleRef = function (node) {
          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.unobserve(_this._node);
          }
          _this._node = node;
          _this._window = getWindowOf(_this._node);
          var innerRef = _this.props.innerRef;
          if (innerRef) {
            if (typeof innerRef === 'function') {
              innerRef(_this._node);
            } else {
              innerRef.current = _this._node;
            }
          }
          if (_this._resizeObserver !== null && _this._node !== null) {
            _this._resizeObserver.observe(_this._node);
          }
        };
        return _this;
      }
      var _proto = WithContentRect.prototype;
      _proto.componentDidMount = function componentDidMount() {
        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new index$1(this.measure);
        if (this._node !== null) {
          this._resizeObserver.observe(this._node);
          if (typeof this.props.onResize === 'function') {
            this.props.onResize(getContentRect(this._node, types || getTypes(this.props)));
          }
        }
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this._window !== null) {
          this._window.cancelAnimationFrame(this._animationFrameID);
        }
        if (this._resizeObserver !== null) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
        }
      };
      _proto.render = function render() {
        var _this$props = this.props;
          _this$props.innerRef;
          _this$props.onResize;
          var props = _objectWithoutPropertiesLoose(_this$props, ["innerRef", "onResize"]);
        return createElement$1(WrappedComponent, _extends$k({}, props, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      };
      return WithContentRect;
    }(Component), _class.propTypes = {
      client: PropTypes.bool,
      offset: PropTypes.bool,
      scroll: PropTypes.bool,
      bounds: PropTypes.bool,
      margin: PropTypes.bool,
      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
      onResize: PropTypes.func
    }, _temp;
  };
}
var Measure = withContentRect()(function (_ref) {
  var measure = _ref.measure,
    measureRef = _ref.measureRef,
    contentRect = _ref.contentRect,
    children = _ref.children;
  return children({
    measure: measure,
    measureRef: measureRef,
    contentRect: contentRect
  });
});
Measure.displayName = 'Measure';
Measure.propTypes.children = PropTypes.func;

var emptyFilterState = {
  columns: {},
  count: 0
};
var emptyFilterOptions = {};
var emptyRows = [];

/**
 * rowMenu can be function to generate menu array or {menu, isDisabled}
 */
var menuColumn = function menuColumn(rowMenu) {
  var rowMenuFunc = _$1.isFunction(rowMenu) ? rowMenu : rowMenu.menu;
  var isDisabledFunc = rowMenu.isDisabled;
  return {
    id: "menu",
    width: 79,
    fixedWidth: true,
    header: "",
    accessor: "",
    cellClass: styles$v['menu-cell'],
    sort: {
      enabled: false
    },
    filter: {
      enabled: false
    },
    Renderer: function Renderer(_ref) {
      var row = _ref.row;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MenuPopover$1, {
        popoverClassName: styles$v['table-menu'],
        disabled: isDisabledFunc && isDisabledFunc(row),
        Trigger: "oval",
        menu: function menu() {
          return rowMenuFunc(row);
        }
      }));
    }
  };
};
var Table = /*#__PURE__*/React__default.memo(function (_ref2) {
  var _rows = _ref2.rows,
    _columns = _ref2.columns,
    table = _ref2.table,
    fixedHeight = _ref2.fixedHeight,
    _sortState = _ref2.sortState,
    _toggleSort = _ref2.toggleSort,
    _filterOptions = _ref2.filterOptions,
    _filterState = _ref2.filterState,
    _updateFilterState = _ref2.updateFilterState,
    _selectionState = _ref2.selectionState,
    _toggleRowSelection = _ref2.toggleRowSelection,
    _rowState = _ref2.rowState,
    _updateRowState = _ref2.updateRowState,
    _selectAllRows = _ref2.selectAllRows,
    className = _ref2.className,
    cellClassName = _ref2.cellClassName,
    rowClassName = _ref2.rowClassName,
    rowsContainerClassName = _ref2.rowsContainerClassName,
    headerContainerClassName = _ref2.headerContainerClassName,
    headerCellClassName = _ref2.headerCellClassName,
    headerHandleClassName = _ref2.headerHandleClassName,
    headerRowClassName = _ref2.headerRowClassName,
    headerContainerStyle = _ref2.headerContainerStyle,
    isSticky = _ref2.isSticky,
    autoSticky = _ref2.autoSticky,
    lastColumnSticky = _ref2.lastColumnSticky,
    _ref2$stickColumnInde = _ref2.stickColumnIndex,
    stickColumnIndex = _ref2$stickColumnInde === void 0 ? 0 : _ref2$stickColumnInde,
    isLoading = _ref2.isLoading,
    _ref2$RenderRow = _ref2.RenderRow,
    RenderRow = _ref2$RenderRow === void 0 ? DefaultRowRenderer : _ref2$RenderRow,
    rowMenu = _ref2.rowMenu,
    onRowClick = _ref2.onRowClick,
    onRowDoubleClick = _ref2.onRowDoubleClick,
    _columnState = _ref2.columnState,
    _updateColumnState = _ref2.updateColumnState,
    isTogglingColumns = _ref2.isTogglingColumns,
    _restoreColumnStateDefaults = _ref2.restoreColumnStateDefaults,
    originalColumns = _ref2.originalColumns,
    toggleColumnSelectorClassName = _ref2.toggleColumnSelectorClassName,
    toggleColumnSelectorStyle = _ref2.toggleColumnSelectorStyle,
    columnSelectorClassName = _ref2.columnSelectorClassName,
    SubRowRenderer = _ref2.SubRowRenderer,
    _ref2$noDataLabel = _ref2.noDataLabel,
    noDataLabel = _ref2$noDataLabel === void 0 ? "No Data" : _ref2$noDataLabel,
    isRowDisabled = _ref2.isRowDisabled,
    disabledTitle = _ref2.disabledTitle;
  var headersContainerRef = useRef(null);
  var tableRef = useRef(null);
  var rowsContainerRef = useRef(null);
  var scrollDuplicatorRef = useRef(null);
  var lastColumnStickyStyleRef = useRef({
    dataset: {
      styleid: "Table-last-sticky-".concat(Math.random().toString(36).substr(2))
    }
  });
  var customColumnStickyStyleRef = useRef({
    dataset: {
      styleid: "Table-custom-sticky-".concat(Math.random().toString(36).substr(2))
    }
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    addColumnsOverlayActive = _useState2[0],
    setAddColumnsOverlayState = _useState2[1];
  var columnSelectorRef = useRef(null);
  var rows = _rows || (table === null || table === void 0 ? void 0 : table.organizedRows) || emptyRows;
  var $columns = _columns || (table === null || table === void 0 ? void 0 : table.columns) || [];
  var sortState = _sortState || (table === null || table === void 0 ? void 0 : table.sortState);
  var toggleSort = _toggleSort || (table === null || table === void 0 ? void 0 : table.toggleSort);
  var filterOptions = _filterOptions || (table === null || table === void 0 ? void 0 : table.filterOptions) || emptyFilterOptions;
  var filterState = _filterState || (table === null || table === void 0 ? void 0 : table.filterState) || emptyFilterState;
  var updateFilterState = _updateFilterState || (table === null || table === void 0 ? void 0 : table.updateFilterState) || _$1.noop;
  var selectionState = _selectionState || (table === null || table === void 0 ? void 0 : table.selectionState);
  var toggleRowSelection = _toggleRowSelection || (table === null || table === void 0 ? void 0 : table.toggleRowSelection);
  var rowState = _rowState || (table === null || table === void 0 ? void 0 : table.rowState);
  var updateRowState = _updateRowState || (table === null || table === void 0 ? void 0 : table.updateRowState);
  var selectAllRows = _selectAllRows || (table === null || table === void 0 ? void 0 : table.selectAllRows);
  var columnState = _columnState || (table === null || table === void 0 ? void 0 : table.columnState);
  var updateColumnState = _updateColumnState || (table === null || table === void 0 ? void 0 : table.updateColumnState);
  var restoreColumnStateDefaults = _restoreColumnStateDefaults || (table === null || table === void 0 ? void 0 : table.restoreColumnStateDefaults);
  var isRowSelectingEnabled = !!selectionState;
  var columns = React__default.useMemo(function () {
    var pColumns = $columns.map(function (column) {
      return _objectSpread2(_objectSpread2({}, column), {}, {
        width: column.width || 1
      });
    });
    if (rowMenu) {
      pColumns.push(menuColumn(rowMenu));
    }
    if (isRowSelectingEnabled) {
      pColumns.unshift(selectingColumn$1());
    }
    return pColumns;
  }, [$columns, rowMenu, isRowSelectingEnabled]);
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollDividerTop = _useState4[0],
    setScrollDividerTop = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasScroll = _useState6[0],
    setHasScroll = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isScrolled = _useState8[0],
    setIsScrolled = _useState8[1];
  var _useState9 = useState(_$1.range(columns.length).map(function () {
      return 0;
    })),
    _useState10 = _slicedToArray(_useState9, 2),
    widths = _useState10[0],
    setWidths = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalWidth = _useState12[0],
    setTotalWidth = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    tableWidth = _useState14[0],
    setTableWidth = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    scrollDividerLeft = _useState16[0],
    setScrollDividerLeft = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    stickyTop = _useState18[0],
    setStickyTop = _useState18[1];
  var scrollRows = function scrollRows(e) {
    var newScrollLeft = e.target.scrollLeft;
    if (headersContainerRef.current && rowsContainerRef.current) {
      headersContainerRef.current.scrollLeft = newScrollLeft;
      rowsContainerRef.current.scrollLeft = newScrollLeft;
      if (newScrollLeft > 0) {
        setIsScrolled(true);
        customColumnStickyStyleRef.current.innerHTML = ".".concat(customColumnStickyStyleRef.current.dataset.styleid, " {\n                    z-index: 1;\n                    transform: translateX(").concat(newScrollLeft, "px);\n                }");
        lastColumnStickyStyleRef.current.innerHTML = ".".concat(lastColumnStickyStyleRef.current.dataset.styleid, " {\n                    z-index: 1;\n                    transform: translateX(-").concat(totalWidth - tableWidth - newScrollLeft, "px);\n                }");
      } else if (newScrollLeft === 0) {
        setIsScrolled(false);
        customColumnStickyStyleRef.current.innerHTML = "";
        lastColumnStickyStyleRef.current.innerHTML = ".".concat(lastColumnStickyStyleRef.current.dataset.styleid, " {\n                    z-index: 1;\n                    transform: translateX(-").concat(totalWidth - tableWidth, "px);\n                }");
      }
    }
  };
  useLayoutEffect(function () {
    var handleResize = function handleResize() {
      var width = tableRef.current.getBoundingClientRect().width;
      var totalWidth = _$1.sumBy(columns, "width");
      setWidths(_$1.map(columns, "width"));
      if (totalWidth > width) {
        setTotalWidth(totalWidth);
        setHasScroll(true);
      } else {
        setTotalWidth(width);
      }
      setTableWidth(width);
      setTimeout(function () {
        var _headersContainerRef$, _headersContainerRef$2;
        var childNodes = headersContainerRef === null || headersContainerRef === void 0 || (_headersContainerRef$ = headersContainerRef.current) === null || _headersContainerRef$ === void 0 || (_headersContainerRef$ = _headersContainerRef$.childNodes[0]) === null || _headersContainerRef$ === void 0 ? void 0 : _headersContainerRef$.childNodes;
        // calculating the devider by summing all column widths up to column which equal to the sticky index
        var leftDivider = _$1.sumBy(_$1.take(childNodes, stickColumnIndex + 1), function (node) {
          var _node$getBoundingClie;
          return (node === null || node === void 0 || (_node$getBoundingClie = node.getBoundingClientRect()) === null || _node$getBoundingClie === void 0 ? void 0 : _node$getBoundingClie.width) || 0;
        });
        setScrollDividerLeft(leftDivider);
        lastColumnStickyStyleRef.current.innerHTML = ".".concat(lastColumnStickyStyleRef.current.dataset.styleid, " {\n                    z-index: 1;\n                    transform: translateX(-").concat(totalWidth - width - ((headersContainerRef === null || headersContainerRef === void 0 || (_headersContainerRef$2 = headersContainerRef.current) === null || _headersContainerRef$2 === void 0 ? void 0 : _headersContainerRef$2.scrollLeft) || 0), "px);\n                }");
      });
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [tableRef, setWidths, setTotalWidth, columns, isLoading]);
  useLayoutEffect(function () {
    var _headersContainerRef$3;
    setScrollDividerTop((headersContainerRef === null || headersContainerRef === void 0 || (_headersContainerRef$3 = headersContainerRef.current) === null || _headersContainerRef$3 === void 0 || (_headersContainerRef$3 = _headersContainerRef$3.childNodes[0]) === null || _headersContainerRef$3 === void 0 || (_headersContainerRef$3 = _headersContainerRef$3.childNodes[0]) === null || _headersContainerRef$3 === void 0 || (_headersContainerRef$3 = _headersContainerRef$3.getBoundingClientRect()) === null || _headersContainerRef$3 === void 0 ? void 0 : _headersContainerRef$3.height) || 0);
  }, []);
  var hasExpandedRow = useMemo(function () {
    return _$1.some(rowState, 'isExpanded');
  }, [rowState]);
  useEffect(function () {
    var lastColumnStyleId = lastColumnStickyStyleRef.current.dataset.styleid;
    lastColumnStickyStyleRef.current = window.document.createElement('style');
    lastColumnStickyStyleRef.current.type = 'text/css';
    lastColumnStickyStyleRef.current.dataset.styleid = lastColumnStyleId;
    var customColumnStyleId = customColumnStickyStyleRef.current.dataset.styleid;
    customColumnStickyStyleRef.current = window.document.createElement('style');
    customColumnStickyStyleRef.current.type = 'text/css';
    customColumnStickyStyleRef.current.dataset.styleid = customColumnStyleId;
    getStyleRoot().appendChild(lastColumnStickyStyleRef.current);
    getStyleRoot().appendChild(customColumnStickyStyleRef.current);
    return function () {
      getStyleRoot().removeChild(lastColumnStickyStyleRef.current);
      getStyleRoot().removeChild(customColumnStickyStyleRef.current);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$v['base'], className),
    ref: tableRef
  }, isSticky && autoSticky && /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: function onResize(contentRect) {
      setStickyTop(contentRect.bounds.height + contentRect.bounds.top - (_$1.isNumber(autoSticky) ? autoSticky : 0));
    }
  }, function (_ref3) {
    var measureRef = _ref3.measureRef;
    return /*#__PURE__*/React__default.createElement("div", {
      ref: measureRef
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$v['headers-group-container'], headerContainerClassName, _defineProperty$3({}, styles$v['sticky-header'], isSticky)),
    style: _objectSpread2({
      top: stickyTop
    }, headerContainerStyle),
    ref: headersContainerRef
  }, /*#__PURE__*/React__default.createElement(BlankRow, {
    stickColumnIndex: stickColumnIndex,
    stickyColumnStyleRef: customColumnStickyStyleRef,
    columns: columns,
    widths: widths
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$v['header-row'], headerRowClassName),
    "data-testid": 'table-header-row'
  }, columns.map(function (column, index) {
    var stickLastColumn = lastColumnSticky && index === columns.length - 1;
    var stickColumn = index <= stickColumnIndex;
    var HeaderRenderer = column.HeaderRenderer || RenderHeaderCell$2;
    return /*#__PURE__*/React__default.createElement(HeaderRenderer, {
      headerCellClassName: headerCellClassName,
      headerHandleClassName: headerHandleClassName,
      stickLastColumn: stickLastColumn,
      lastColumnStickyStyleRef: lastColumnStickyStyleRef,
      stickyColumnStyleRef: customColumnStickyStyleRef,
      stickColumn: stickColumn,
      selectionState: selectionState,
      selectAllRows: selectAllRows,
      columnFilterOptions: filterOptions[column.id],
      columnFilterState: filterState.columns[column.id],
      updateFilterState: updateFilterState,
      columnIndex: index,
      key: column.id,
      width: widths ? widths[index] : 0,
      column: column,
      sortState: sortState,
      toggleSort: toggleSort,
      dataTestId: "table-column-header-".concat(column.header === "" ? column.id : column.header)
    });
  })), isTogglingColumns && /*#__PURE__*/React__default.createElement(ToggleColumnSelectorButton$1, {
    className: toggleColumnSelectorClassName,
    style: toggleColumnSelectorStyle,
    columnStickyStyleRef: customColumnStickyStyleRef,
    isActive: addColumnsOverlayActive,
    toggle: function toggle() {
      return setAddColumnsOverlayState(!addColumnsOverlayActive);
    }
  })), isTogglingColumns && /*#__PURE__*/React__default.createElement(CSSTransition, {
    nodeRef: columnSelectorRef,
    "in": addColumnsOverlayActive,
    unmountOnExit: true,
    timeout: 400,
    classNames: fadeClassNames
  }, /*#__PURE__*/React__default.createElement(ColumnsSelector$1, {
    className: columnSelectorClassName,
    ref: columnSelectorRef,
    isSticky: isSticky,
    originalColumns: originalColumns,
    columnState: columnState,
    updateColumnState: updateColumnState,
    restoreColumnStateDefaults: restoreColumnStateDefaults,
    closeSelector: function closeSelector() {
      return setAddColumnsOverlayState(false);
    }
  })), !isLoading && rows.length === 0 && /*#__PURE__*/React__default.createElement("div", {
    className: styles$v['no-table-data']
  }, /*#__PURE__*/React__default.createElement(FileIcon, null), noDataLabel), hasScroll && isScrolled && stickColumnIndex >= 0 && !hasExpandedRow && /*#__PURE__*/React__default.createElement("div", {
    className: scrollFixStyles['scroll-divider'],
    style: {
      top: scrollDividerTop,
      left: scrollDividerLeft
    }
  }), addColumnsOverlayActive && /*#__PURE__*/React__default.createElement("div", {
    className: styles$v['rows-group-cover']
  }), (isLoading || rows.length > 0) && /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$v['rows-group-container'], rowsContainerClassName, _defineProperty$3({}, styles$v['fixed-height'], !!fixedHeight))
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: rowsContainerRef,
    style: fixedHeight ? {
      maxHeight: fixedHeight
    } : undefined
  }, /*#__PURE__*/React__default.createElement(RenderRows, {
    isLoading: isLoading,
    rows: rows,
    columns: columns,
    RenderRow: RenderRow,
    widths: widths,
    totalWidth: totalWidth,
    tableWidth: tableWidth,
    onRowClick: onRowClick,
    onRowDoubleClick: onRowDoubleClick,
    cellClassName: cellClassName,
    selectionState: selectionState,
    isRowSelectingEnabled: isRowSelectingEnabled,
    rowState: rowState,
    updateRowState: updateRowState,
    toggleRowSelection: toggleRowSelection,
    lastColumnSticky: lastColumnSticky,
    lastColumnStickyStyleRef: lastColumnStickyStyleRef,
    stickColumnIndex: stickColumnIndex,
    stickyColumnStyleRef: customColumnStickyStyleRef,
    SubRowRenderer: SubRowRenderer,
    rowClassName: rowClassName,
    isRowDisabled: isRowDisabled,
    disabledTitle: disabledTitle
  }))), /*#__PURE__*/React__default.createElement(InView, null, function (_ref4) {
    var inView = _ref4.inView,
      ref = _ref4.ref;
      _ref4.entry;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      ref: ref
    }), !isLoading && hasScroll && /*#__PURE__*/React__default.createElement("div", {
      className: classNames(scrollFixStyles["scroll-duplicator"], _defineProperty$3({}, scrollFixStyles["scroll-duplicator-sticky"], isSticky && !inView)),
      style: {
        width: tableWidth
      },
      onScroll: function onScroll(e) {
        return scrollRows(e);
      },
      ref: scrollDuplicatorRef
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: totalWidth
      }
    })));
  })));
});
Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    headerClass: PropTypes.string,
    id: PropTypes.string,
    accessor: PropTypes.string,
    sort: PropTypes.shape({
      enabled: PropTypes.bool //default: true
    }),
    popoverText: PropTypes.string
  }).isRequired).isRequired,
  className: PropTypes.string,
  sortState: PropTypes.object,
  toggleSort: PropTypes.func,
  filterOptions: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }))),
  filterState: PropTypes.object,
  updateFilterState: PropTypes.func,
  isLoading: PropTypes.bool
};
Table.displayName = "Table";
var Table$1 = Table;

var styles$s = {"base":"SubTable-module_base__3wmwq","headers-group-container":"SubTable-module_headers-group-container__9Kphk","header-cell":"SubTable-module_header-cell__2-8Tx","header-handle":"SubTable-module_header-handle__15-Jp","header-row":"SubTable-module_header-row__1CO4j","cell":"SubTable-module_cell__sgCQj"};

var _excluded$5 = ["cellClassName", "headerContainerClassName", "headerCellClassName", "headerRowClassName", "rowClassName", "rowsContainerClassName", "headerHandleClassName"];
var SubTable = /*#__PURE__*/React__default.memo(function (_ref) {
  var cellClassName = _ref.cellClassName,
    headerContainerClassName = _ref.headerContainerClassName,
    headerCellClassName = _ref.headerCellClassName,
    headerRowClassName = _ref.headerRowClassName,
    rowClassName = _ref.rowClassName,
    rowsContainerClassName = _ref.rowsContainerClassName,
    headerHandleClassName = _ref.headerHandleClassName,
    rest = _objectWithoutProperties$2(_ref, _excluded$5);
  return /*#__PURE__*/React__default.createElement(Table$1, _extends$j({}, rest, {
    className: styles$s.base,
    cellClassName: classNames(styles$s['cell'], cellClassName),
    headerContainerClassName: classNames(styles$s['headers-group-container'], headerContainerClassName),
    headerCellClassName: classNames(styles$s['header-cell'], headerCellClassName),
    headerRowClassName: classNames(styles$s['header-row'], headerRowClassName),
    headerHandleClassName: classNames(styles$s['header-handle'], headerHandleClassName),
    rowClassName: classNames(styles$s['row'], rowClassName),
    rowsContainerClassName: classNames(styles$s['rows-container'], rowsContainerClassName)
  }));
});
var SubTable$1 = SubTable;

var styles$r = {"status":"CommonCellRenderers-module_status__KeiL4","loader":"CommonCellRenderers-module_loader__3HCq4","circle":"CommonCellRenderers-module_circle__2Yca4","on":"CommonCellRenderers-module_on__3IiU5","failed":"CommonCellRenderers-module_failed__2Q8xO","warning":"CommonCellRenderers-module_warning__1kRbE","disabled":"CommonCellRenderers-module_disabled__3aQJB","text":"CommonCellRenderers-module_text__1WNVa","popover-renderer":"CommonCellRenderers-module_popover-renderer__2yRyZ","two-item-renderer":"CommonCellRenderers-module_two-item-renderer__3s2yZ","cta":"CommonCellRenderers-module_cta__1dEYA","aws-icon":"CommonCellRenderers-module_aws-icon__2VE5J","azure-icon":"CommonCellRenderers-module_azure-icon__3wrG6","on-prem-icon":"CommonCellRenderers-module_on-prem-icon__1gJV5","gcp-icon":"CommonCellRenderers-module_gcp-icon__3eSP0","provider-circle-icon":"CommonCellRenderers-module_provider-circle-icon__3b5Ns","valueAndButton":"CommonCellRenderers-module_valueAndButton__3-gYJ"};

function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
const AwsCircleIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--content-background)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.0674 31.451C25.0584 31.8008 25.1015 32.15 25.1954 32.487C25.2986 32.7751 25.423 33.0552 25.5674 33.325C25.6191 33.4049 25.6471 33.4978 25.6484 33.593C25.6412 33.6644 25.6175 33.7331 25.5792 33.7937C25.5408 33.8542 25.4888 33.905 25.4274 33.942L24.6944 34.431C24.6061 34.4926 24.5019 34.5273 24.3944 34.531C24.2619 34.5218 24.1375 34.4637 24.0454 34.368C23.8885 34.1995 23.7482 34.0163 23.6264 33.821C23.5104 33.621 23.3934 33.402 23.2654 33.134C22.8558 33.6471 22.3342 34.0596 21.7405 34.3399C21.1468 34.6202 20.4968 34.7608 19.8404 34.751C19.4161 34.7734 18.9916 34.7108 18.5918 34.5669C18.1921 34.423 17.8251 34.2007 17.5124 33.913C17.2226 33.6199 16.9965 33.2701 16.8483 32.8855C16.7001 32.5009 16.6331 32.0898 16.6514 31.678C16.6346 31.2239 16.7212 30.7719 16.9047 30.3561C17.0881 29.9404 17.3636 29.5717 17.7104 29.278C18.5188 28.6383 19.5329 28.3155 20.5624 28.37C20.9753 28.3733 21.3876 28.4044 21.7964 28.463C22.2274 28.521 22.6694 28.614 23.1354 28.719V27.869C23.2024 27.2008 23.0062 26.5328 22.5884 26.007C22.0462 25.5934 21.3667 25.402 20.6884 25.472C20.2649 25.4719 19.8428 25.5226 19.4314 25.623C19.0034 25.7263 18.5834 25.86 18.1744 26.023C18.0421 26.0821 17.9062 26.1326 17.7674 26.174C17.7072 26.1939 17.6447 26.2057 17.5814 26.209C17.4184 26.209 17.3374 26.093 17.3374 25.848V25.271C17.3248 25.1304 17.353 24.9891 17.4184 24.864C17.5062 24.7581 17.618 24.6744 17.7444 24.62C18.2113 24.3886 18.7036 24.2124 19.2114 24.095C19.8046 23.9429 20.415 23.8686 21.0274 23.874C22.1279 23.7805 23.2217 24.1186 24.0774 24.817C24.4232 25.2046 24.687 25.6581 24.853 26.1503C25.019 26.6425 25.0838 27.1632 25.0434 27.681V31.451H25.0674ZM20.3414 33.222C20.7501 33.2175 21.1554 33.1466 21.5414 33.012C21.9687 32.8643 22.3499 32.6075 22.6474 32.267C22.8365 32.0529 22.9734 31.7979 23.0474 31.522C23.1273 31.1903 23.1662 30.8501 23.1634 30.509V30.02C22.8104 29.9334 22.4528 29.8666 22.0924 29.82C21.7295 29.7739 21.3642 29.7505 20.9984 29.75C20.384 29.7017 19.7717 29.8662 19.2644 30.216C19.0716 30.3794 18.9197 30.5855 18.8208 30.818C18.7218 31.0505 18.6785 31.3028 18.6944 31.555C18.6682 31.7789 18.6929 32.0059 18.7666 32.2189C18.8402 32.432 18.9609 32.6257 19.1198 32.7857C19.2786 32.9457 19.4715 33.0678 19.684 33.143C19.8965 33.2182 20.1233 33.2445 20.3474 33.22L20.3414 33.222ZM29.6884 34.479C29.5319 34.4951 29.3748 34.4539 29.2464 34.363C29.1247 34.2371 29.0403 34.08 29.0024 33.909L26.2664 24.909C26.2149 24.7581 26.1813 24.6017 26.1664 24.443C26.1606 24.4049 26.1636 24.366 26.1751 24.3292C26.1866 24.2924 26.2062 24.2587 26.2326 24.2306C26.259 24.2025 26.2914 24.1807 26.3273 24.1669C26.3633 24.1532 26.402 24.1477 26.4404 24.151H27.5814C27.7419 24.1314 27.9039 24.1728 28.0354 24.267C28.1529 24.3943 28.2335 24.5513 28.2684 24.721L30.2244 32.427L32.0394 24.724C32.0632 24.5531 32.1406 24.3942 32.2604 24.27C32.3998 24.1835 32.5625 24.1419 32.7264 24.151H33.6574C33.8202 24.1356 33.9833 24.1777 34.1184 24.27C34.2401 24.3928 34.3178 24.5524 34.3394 24.724L36.1784 32.524L38.1924 24.724C38.2295 24.5551 38.3098 24.3986 38.4254 24.27C38.5617 24.1823 38.7226 24.1406 38.8844 24.151H39.9674C40.0068 24.1457 40.047 24.1496 40.0847 24.1624C40.1224 24.1752 40.1567 24.1964 40.1848 24.2246C40.2129 24.2527 40.2342 24.287 40.247 24.3247C40.2598 24.3624 40.2636 24.4026 40.2584 24.442C40.2557 24.5045 40.248 24.5667 40.2354 24.628C40.2172 24.7273 40.1901 24.8247 40.1544 24.919L37.3494 33.919C37.3142 34.0912 37.2289 34.2491 37.1044 34.373C36.9729 34.4571 36.8182 34.4977 36.6624 34.489H35.6624C35.4982 34.5065 35.3332 34.4654 35.1964 34.373C35.0747 34.2453 34.9973 34.082 34.9754 33.907L33.1754 26.399L31.3824 33.899C31.3552 34.0724 31.2784 34.2342 31.1614 34.365C31.0238 34.4557 30.8594 34.4966 30.6954 34.481L29.6884 34.479ZM44.6464 34.793C44.0425 34.7936 43.4407 34.7231 42.8534 34.583C42.3882 34.4883 41.9378 34.3316 41.5144 34.117C41.3645 34.0464 41.2388 33.933 41.1534 33.791C41.108 33.6883 41.0842 33.5773 41.0834 33.465V32.872C41.0834 32.628 41.1764 32.511 41.3514 32.511C41.4225 32.5113 41.4931 32.5231 41.5604 32.546C41.6304 32.569 41.7354 32.616 41.8514 32.662C42.2624 32.8427 42.6915 32.9791 43.1314 33.069C43.5872 33.1616 44.0512 33.2085 44.5164 33.209C45.1085 33.2447 45.6986 33.1119 46.2184 32.826C46.407 32.7109 46.5619 32.548 46.6673 32.3538C46.7726 32.1595 46.8248 31.9409 46.8184 31.72C46.8226 31.5701 46.797 31.4209 46.7431 31.281C46.6892 31.1411 46.608 31.0133 46.5044 30.905C46.1638 30.616 45.7615 30.4091 45.3284 30.3L43.6404 29.776C42.9093 29.5883 42.2571 29.1725 41.7784 28.589C41.4037 28.1059 41.199 27.5124 41.1964 26.901C41.1893 26.4496 41.3003 26.0043 41.5184 25.609C41.7249 25.2336 42.0097 24.9069 42.3534 24.651C42.7165 24.3785 43.1267 24.1751 43.5634 24.051C44.04 23.913 44.5342 23.8456 45.0304 23.851C45.2911 23.8493 45.5517 23.865 45.8104 23.898C46.0784 23.933 46.3224 23.979 46.5674 24.026C46.8124 24.073 47.0214 24.142 47.2314 24.212C47.4005 24.2645 47.5638 24.3346 47.7184 24.421C47.8554 24.4902 47.9747 24.5897 48.0674 24.712C48.1414 24.8258 48.1765 24.9606 48.1674 25.096V25.643C48.1674 25.887 48.0744 26.015 47.8994 26.015C47.7444 25.9972 47.5943 25.9497 47.4574 25.875C46.7539 25.564 45.9914 25.4092 45.2224 25.421C44.6865 25.3892 44.1519 25.5018 43.6744 25.747C43.4968 25.8527 43.3517 26.0053 43.2552 26.1881C43.1587 26.3709 43.1145 26.5767 43.1274 26.783C43.1243 26.9375 43.1538 27.0909 43.2139 27.2332C43.274 27.3755 43.3635 27.5036 43.4764 27.609C43.8541 27.9088 44.2899 28.1267 44.7564 28.249L46.4094 28.773C47.1128 28.9517 47.7444 29.3424 48.2184 29.892C48.5736 30.3604 48.7619 30.9342 48.7534 31.522C48.7602 31.9893 48.6574 32.4516 48.4534 32.872C48.2467 33.2703 47.9568 33.6195 47.6034 33.896C47.2191 34.1951 46.7803 34.4166 46.3114 34.548C45.7721 34.7137 45.2106 34.796 44.6464 34.792V34.793Z",
  fill: "var(--third-party-aws-text)"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.8461 40.451C42.6637 43.2885 37.7222 44.7976 32.6681 44.781C26.2774 44.8143 20.1044 42.4607 15.3581 38.181C14.9971 37.855 15.3231 37.413 15.7581 37.669C21.0331 40.6836 27.0035 42.2692 33.0791 42.269C37.6177 42.2452 42.1071 41.3277 46.2911 39.5691C46.9271 39.2751 47.4741 39.985 46.8461 40.451ZM48.4411 38.6351C47.9521 38.0061 45.2051 38.3351 43.9591 38.4841C43.5861 38.5311 43.5281 38.205 43.8661 37.96C46.0541 36.423 49.6511 36.866 50.0661 37.378C50.4811 37.89 49.9501 41.4991 47.9011 43.2221C47.5871 43.4901 47.2841 43.35 47.4241 43.001C47.8901 41.849 48.9241 39.2531 48.4371 38.6361L48.4411 38.6351Z",
  fill: "var(--third-party-aws-smile)"
}));
const AwsIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.00003802776336669922 -0.00038831596611998975 34.38534164428711 20.936731338500977"
}, props), /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  fill: "var(--third-party-aws-text)",
  d: "M9.69 7.604c-.01.35.033.701.126 1.04.101.287.223.568.365.838.05.08.078.172.08.268a.462.462 0 01-.219.35l-.72.488a.542.542 0 01-.298.105.523.523 0 01-.343-.163 3.596 3.596 0 01-.412-.547 9.039 9.039 0 01-.355-.687 4.195 4.195 0 01-3.359 1.603 3.102 3.102 0 01-2.287-.838 3.021 3.021 0 01-.847-2.236 3.022 3.022 0 011.041-2.399 4.111 4.111 0 012.8-.908c.406.003.81.034 1.212.092.423.058.858.149 1.313.257v-.85a2.613 2.613 0 00-.533-1.864 2.599 2.599 0 00-1.864-.535 5.115 5.115 0 00-1.235.148c-.42.102-.833.234-1.235.396-.13.058-.264.108-.4.148a.69.69 0 01-.184.035c-.16 0-.24-.116-.24-.36V1.42a.748.748 0 01.08-.407.857.857 0 01.32-.245A6.505 6.505 0 013.939.244 6.816 6.816 0 015.721.022a4.128 4.128 0 012.996.943 3.898 3.898 0 01.948 2.864v3.773l.024.002zm-4.646 1.77a3.648 3.648 0 001.177-.21 2.55 2.55 0 001.087-.743 1.86 1.86 0 00.388-.742c.08-.333.12-.676.118-1.019v-.489a9.399 9.399 0 00-1.052-.198 8.466 8.466 0 00-1.074-.07 2.602 2.602 0 00-1.705.466c-.383.33-.59.825-.56 1.336a1.52 1.52 0 00.416 1.23 1.46 1.46 0 001.205.438zm9.187 1.257a.63.63 0 01-.437-.117.954.954 0 01-.24-.454l-2.687-9a2.064 2.064 0 01-.102-.466.258.258 0 01.067-.214.248.248 0 01.207-.077h1.121a.626.626 0 01.447.116.959.959 0 01.229.455l1.92 7.708L16.54.873c.024-.171.1-.33.218-.454a.775.775 0 01.458-.117h.915a.679.679 0 01.457.117.79.79 0 01.219.454l1.804 7.801 1.979-7.8a.993.993 0 01.229-.455.736.736 0 01.446-.117h1.064a.252.252 0 01.213.074.262.262 0 01.072.218 1.691 1.691 0 01-.103.477l-2.756 9.001a.896.896 0 01-.24.455.72.72 0 01-.438.116h-.98a.679.679 0 01-.458-.116.831.831 0 01-.218-.466l-1.772-7.51-1.76 7.498a.916.916 0 01-.22.465.699.699 0 01-.456.117h-.982zm14.696.314a7.44 7.44 0 01-1.761-.21 5.14 5.14 0 01-1.313-.465.829.829 0 01-.354-.326.835.835 0 01-.069-.326v-.594c0-.244.092-.36.264-.36.07 0 .139.011.205.034.069.023.172.07.286.117a6.2 6.2 0 001.258.407c.448.093.904.14 1.361.14a3.04 3.04 0 001.67-.385 1.26 1.26 0 00.595-1.106 1.145 1.145 0 00-.31-.816 2.85 2.85 0 00-1.154-.606l-1.666-.522a3.482 3.482 0 01-1.829-1.188 2.807 2.807 0 01-.572-1.688 2.63 2.63 0 01.31-1.293c.204-.375.484-.7.823-.955.357-.274.76-.48 1.19-.605A4.901 4.901 0 0129.303 0c.256-.002.512.014.766.047.263.035.503.081.743.128.229.058.446.117.652.187.166.052.328.122.48.209.135.069.252.169.344.291.074.113.11.248.102.385v.547c0 .244-.09.37-.263.37a1.174 1.174 0 01-.437-.139 5.152 5.152 0 00-2.196-.454 2.907 2.907 0 00-1.521.326 1.13 1.13 0 00-.537 1.04 1.11 1.11 0 00.343.826c.371.3.8.519 1.258.641l1.624.524a3.47 3.47 0 011.775 1.115c.35.47.535 1.045.526 1.634.006.467-.096.93-.298 1.35a3.12 3.12 0 01-.834 1.025c-.378.299-.81.52-1.27.652a5.348 5.348 0 01-1.635.244l.002-.003z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "var(--third-party-aws-smile)",
  d: "M31.087 16.604c-3.763 2.83-9.23 4.332-13.928 4.332-6.278.033-12.343-2.321-17.007-6.602-.354-.326-.034-.768.389-.512a33.823 33.823 0 0017.017 4.603 33.436 33.436 0 0012.979-2.702c.63-.295 1.168.416.55.881zm1.567-1.816c-.481-.63-3.18-.303-4.403-.149-.365.047-.423-.279-.091-.524 2.15-1.537 5.684-1.094 6.095-.582.412.524-.115 4.122-2.127 5.845-.309.268-.606.128-.469-.223.457-1.153 1.475-3.749.995-4.366v-.001z"
})));
const AzureCircleIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--content-background)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M32.3246 32.325H23.4326V23.433H32.3246V32.325Z",
  fill: "#F1511B"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M42.1 32.325H33.208V23.433H42.099V32.325H42.1Z",
  fill: "#80CC28"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M32.3246 42.1H23.4326V33.208H32.3246V42.1Z",
  fill: "#00ADEF"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M42.1 42.1H33.208V33.208H42.099V42.1H42.1Z",
  fill: "#FBBC09"
}));
const AzureIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0.2900000214576721 23.996999740600586 24.433998107910156"
}, props), /*#__PURE__*/React__default.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React__default.createElement("path", {
  fill: "#F1511B",
  d: "M11.43 11.928H0V.29h11.43z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#80CC28",
  d: "M23.997 11.928h-11.43V.29h11.43v11.638z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#00ADEF",
  d: "M11.43 24.724H0V13.085h11.43z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#FBBC09",
  d: "M23.997 24.724h-11.43V13.085h11.43v11.639z"
})));
const GcpCircleIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--content-background)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.9664 28.166H36.0454L35.9974 28.127L38.9854 25.139L38.9914 25.085C37.7533 23.993 36.2574 23.2345 34.6448 22.8812C33.0323 22.5279 31.3563 22.5914 29.775 23.0656C28.1938 23.5399 26.7595 24.4093 25.6076 25.5918C24.4557 26.7743 23.6241 28.2309 23.1914 29.824C23.2435 29.803 23.2969 29.7856 23.3514 29.772C24.8794 28.7596 26.7448 28.39 28.5434 28.743C28.5617 28.73 28.5841 28.7243 28.6064 28.727C29.5324 27.7093 30.8126 27.0843 32.1846 26.9802C33.5566 26.8761 34.9164 27.3007 35.9854 28.167H35.9664",
  fill: "#EA4335"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.9678 29.82C41.4695 27.9915 40.4497 26.3476 39.0328 25.089L36.0018 28.126C36.634 28.6427 37.1406 29.2963 37.4834 30.0373C37.8262 30.7784 37.9963 31.5876 37.9808 32.404V32.941C38.6969 32.941 39.3836 33.2255 39.89 33.7318C40.3963 34.2381 40.6808 34.9249 40.6808 35.641C40.6808 36.3571 40.3963 37.0438 39.89 37.5502C39.3836 38.0565 38.6969 38.341 37.9808 38.341H32.5808L32.5728 38.35V42.635H32.5498L32.5808 42.666H37.9808C39.4898 42.6784 40.9627 42.2045 42.1814 41.3145C43.4001 40.4244 44.2997 39.1655 44.747 37.7243C45.1943 36.283 45.1656 34.736 44.665 33.3124C44.1644 31.8887 43.2187 30.6641 41.9678 29.82",
  fill: "#4285F4"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.1736 42.635H32.5736V38.314H27.1736C26.7907 38.3141 26.4123 38.2311 26.0646 38.071L22.9426 41.192L22.9346 41.225C24.1553 42.1459 25.6444 42.6412 27.1736 42.635",
  fill: "#34A853"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.1738 28.617C25.7121 28.6271 24.29 29.093 23.1058 29.9499C21.9216 30.8068 21.0343 32.0118 20.5677 33.397C20.101 34.7822 20.0783 36.2785 20.5026 37.6773C20.9269 39.0761 21.7772 40.3075 22.9348 41.2L26.0678 38.069C25.6693 37.8895 25.3204 37.616 25.051 37.272C24.7815 36.928 24.5996 36.5237 24.5208 36.0939C24.442 35.664 24.4688 35.2215 24.5987 34.8043C24.7287 34.3871 24.9579 34.0076 25.2669 33.6985C25.5758 33.3894 25.9551 33.1599 26.3722 33.0298C26.7894 32.8996 27.2319 32.8726 27.6618 32.9511C28.0917 33.0297 28.4961 33.2114 28.8402 33.4806C29.1844 33.7499 29.4581 34.0987 29.6378 34.497L32.7698 31.366C32.112 30.5075 31.2647 29.8126 30.2939 29.3357C29.3232 28.8589 28.2553 28.6129 27.1738 28.617Z",
  fill: "#FBBC05"
}));
const GcpIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.008762270212173462 0.29384422302246094 29.272241592407227 23.986434936523438"
}, props), /*#__PURE__*/React__default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("path", {
  fill: "#EA4335",
  d: "M18.573 6.897h.093l-.057-.047 3.517-3.58.008-.065A11.284 11.284 0 0011.283.783C7.498 1.938 4.567 5 3.53 8.884c.06-.025.122-.046.184-.063a8.086 8.086 0 016.113-1.234.105.105 0 01.075-.02 6.264 6.264 0 018.686-.672h-.019"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#4285F4",
  d: "M25.641 8.885a11.733 11.733 0 00-3.455-5.67l-3.575 3.634a6.513 6.513 0 012.33 5.131v.644c4.237 0 4.237 6.472 0 6.472h-6.356l-.01.01v5.136h-.026l.037.038h6.357c3.647.03 6.883-2.375 7.965-5.92 1.082-3.547-.245-7.396-3.267-9.475"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#34A853",
  d: "M8.22 24.24h6.354v-5.177H8.22c-.45 0-.896-.1-1.305-.292L3.24 22.512l-.01.04a8.134 8.134 0 004.991 1.691"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "#FBBC05",
  d: "M8.215 7.437c-3.527.026-6.65 2.328-7.774 5.732-1.125 3.404-.005 7.16 2.79 9.352l3.692-3.754c-1.292-.59-2.045-1.977-1.848-3.404.197-1.428 1.297-2.55 2.699-2.753a3.167 3.167 0 013.346 1.876l3.688-3.753a8.209 8.209 0 00-6.593-3.296"
})));
const OnpremCircleIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
  fill: "var(--content-background)",
  stroke: "var(--icon-round-border)",
  className: "circle-icon-shadow"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5 24.5V31.967H16.5V24.5H48.5ZM46.5 27.3H44.5V29.167H46.5V27.3ZM42.5 27.3H40.5V29.167H42.5V27.3ZM38.5 27.3H36.5V29.167H38.5V27.3Z",
  fill: "#5498E0"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5 33.033V40.5H16.5V33.033H48.5ZM46.5 35.833H44.5V37.7H46.5V35.833ZM42.5 35.833H40.5V37.7H42.5V35.833ZM38.5 35.833H36.5V37.7H38.5V35.833Z",
  fill: "#3279C5"
}));
const OnpremIcon = props => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 18.200000762939453"
}, props), /*#__PURE__*/React__default.createElement("rect", {
  width: 26,
  height: 8.667,
  fill: "#5498E0",
  rx: 1.733
}), /*#__PURE__*/React__default.createElement("circle", {
  cx: 20.8,
  cy: 5.2,
  r: 1.733,
  fill: "#F1F1F1"
}), /*#__PURE__*/React__default.createElement("rect", {
  width: 26,
  height: 8.667,
  y: 9.533,
  fill: "#2C6BCC",
  rx: 1.733
}), /*#__PURE__*/React__default.createElement("circle", {
  cx: 20.8,
  cy: 13,
  r: 1.733,
  fill: "#F1F1F1"
}));

const CapacityRenderer = ({ value }) => {
    return jsx$3("span", { children: numeral(value).format("0,0.[00] ib") });
};
const CapacityRendererTiB = ({ value }) => {
    return jsx$3("span", { children: numeral(value / 1024 / 1024 / 1024 / 1024).format("0,0.[00]") });
};
const CapacityRendererGib = ({ value }) => {
    return jsx$3("span", { children: numeral(value / 1024 / 1024 / 1024).format("0,0.[00]") });
};
const StatusRenderer = (statusesMap) => ({ value }) => {
    if (!value)
        return;
    else {
        const resolvedStatus = statusesMap[value];
        if (resolvedStatus) {
            const classname = resolvedStatus;
            const label = value;
            const isLoadingStatus = resolvedStatus === "loading";
            return jsxs("div", { className: styles$r["status"], children: [isLoadingStatus ? jsx$3(InlineLoader, { className: styles$r["loader"] }) :
                        jsx$3("span", { className: classNames(styles$r["circle"], styles$r[classname]) }), jsx$3("span", { className: classNames(styles$r["text"], styles$r[classname]), children: label })] });
        }
        return jsxs("div", { className: styles$r["status"], children: [jsx$3("span", { className: classNames(styles$r["circle"], styles$r.warning) }), jsxs("span", { children: ["Unknown Status - $", value] })] });
    }
};
const RowClickCellButton = (label) => () => {
    return jsx$3("div", { className: styles$r['cta'], children: label });
};
const PopoverRenderer = Contents => row => {
    return jsx$3("div", { className: styles$r["popover-renderer"], children: jsx$3(Contents, Object.assign({}, row)) });
};
const TwoItemRenderer = Contents => row => {
    return jsx$3("div", { className: styles$r["two-item-renderer"], children: jsx$3(Contents, Object.assign({}, row)) });
};
const providersMap = {
    aws: { icon: AwsIcon, circleIcon: AwsCircleIcon, tableIconClassName: styles$r['aws-icon'] },
    azure: { icon: AzureIcon, circleIcon: AzureCircleIcon, tableIconClassName: styles$r['azure-icon'] },
    gcp: { icon: GcpIcon, circleIcon: GcpCircleIcon, tableIconClassName: styles$r['gcp-icon'] },
    "on-prem": { icon: OnpremIcon, circleIcon: OnpremCircleIcon, tableIconClassName: styles$r['on-prem-icon'] }
};
const ProviderRenderer = ({ value }) => {
    var _a, _b;
    const Icon = (_a = providersMap[value]) === null || _a === void 0 ? void 0 : _a.icon;
    const className = (_b = providersMap[value]) === null || _b === void 0 ? void 0 : _b.tableIconClassName;
    return Icon ? jsx$3(Icon, { className: className }) : jsx$3(NotAvailableCellData, {});
};
const ProviderCircleRenderer = ({ value }) => {
    var _a;
    const Icon = (_a = providersMap[value]) === null || _a === void 0 ? void 0 : _a.circleIcon;
    return Icon ? jsx$3(Icon, { className: styles$r["provider-circle-icon"] }) : jsx$3(NotAvailableCellData, {});
};
const TimestampAsDateTimeRenderer = ({ value }) => {
    return jsx$3("span", { children: new Date(value).toLocaleTimeString([], {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
        }) });
};
const DateAsDateTimeRenderer = ({ value }) => {
    return jsx$3("span", { children: value.toLocaleTimeString([], {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
        }) });
};

var CommonCellRenderers = /*#__PURE__*/Object.freeze({
	__proto__: null,
	CapacityRenderer: CapacityRenderer,
	CapacityRendererTiB: CapacityRendererTiB,
	CapacityRendererGib: CapacityRendererGib,
	StatusRenderer: StatusRenderer,
	RowClickCellButton: RowClickCellButton,
	PopoverRenderer: PopoverRenderer,
	TwoItemRenderer: TwoItemRenderer,
	ProviderRenderer: ProviderRenderer,
	ProviderCircleRenderer: ProviderCircleRenderer,
	TimestampAsDateTimeRenderer: TimestampAsDateTimeRenderer,
	DateAsDateTimeRenderer: DateAsDateTimeRenderer
});

const CtaButton = ({ children, isDisabled, onClick }) => {
    return jsx$3("button", { className: styles$r['cta'], disabled: isDisabled, onClick: onClick, children: children });
};
const ValueAndButton = ({ value, label, onClick, isDisabled }) => {
    return jsxs("span", { className: classNames(styles$r.valueAndButton, { [styles$r['disabled']]: isDisabled }), children: [jsx$3(Span, { children: value }), label && jsx$3(Button$2, { variant: "text", onClick: onClick, children: label })] });
};

var CommonCellAtoms = /*#__PURE__*/Object.freeze({
	__proto__: null,
	CtaButton: CtaButton,
	ValueAndButton: ValueAndButton,
	NotAvailableCellData: NotAvailableCellData
});

var styles$q = {"menuCell":"CommonColumns-module_menuCell__3iIpI"};

var styles$p = {"trigger":"ActionMenu-module_trigger__gVTt7","menuContent":"ActionMenu-module_menuContent__-i53c","contentWrapper":"ActionMenu-module_contentWrapper__Px2pA","baseMenuItem":"ActionMenu-module_baseMenuItem__3x-Mu","disabled":"ActionMenu-module_disabled__18q0V","menuItem":"ActionMenu-module_menuItem__2aXr8 ActionMenu-module_baseMenuItem__3x-Mu","subMenuItem":"ActionMenu-module_subMenuItem__2ovT1 ActionMenu-module_baseMenuItem__3x-Mu","chevron":"ActionMenu-module_chevron__1BdK9","copyMenuItem":"ActionMenu-module_copyMenuItem__J-w2o ActionMenu-module_baseMenuItem__3x-Mu","destructive":"ActionMenu-module_destructive__3srwo ActionMenu-module_baseMenuItem__3x-Mu","bgshimmer":"ActionMenu-module_bgshimmer__1WnhK"};

var styles$o = {"ovalHidden":"ActionMenuTriggers-module_ovalHidden__3beDf"};

var _desc$1, _rect$1, _path;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgIcOvalTrigger = function SvgIcOvalTrigger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none"
  }, props), _desc$1 || (_desc$1 = /*#__PURE__*/React.createElement("desc", null, "Actions")), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 15,
    rx: 7.5,
    stroke: "var(--icon-primary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C12 9.10457 11.1046 10 10 10C8.89543 10 8 9.10457 8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8ZM18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8ZM22 10C23.1046 10 24 9.10457 24 8C24 6.89543 23.1046 6 22 6C20.8954 6 20 6.89543 20 8C20 9.10457 20.8954 10 22 10Z",
    fill: "var(--icon-primary)"
  })));
};

var _desc, _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgIcOvalHiddenTrigger = function SvgIcOvalHiddenTrigger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 16,
    viewBox: "0 0 32 16"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Actions")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "var(--icon-primary)",
    x: 1,
    y: 1,
    width: 30,
    height: 14,
    rx: 8,
    ry: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "var(--icon-primary)",
    cx: 16,
    cy: 8,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "var(--icon-primary)",
    cx: 10.5,
    cy: 8,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "var(--icon-primary)",
    cx: 21.5,
    cy: 8,
    r: 2
  })));
};

const OvalTrigger = ({ onClick, isActive, isDisabled }) => {
    return jsx$3(Button$2, { variant: "icon", onClick: onClick, isActive: isActive, isDisabled: isDisabled, children: jsx$3(SvgIcOvalTrigger, {}) });
};
const OvalHiddenTrigger = ({ onClick, isActive, isDisabled }) => {
    return jsx$3(Button$2, { variant: "icon", onClick: onClick, isActive: isActive, isDisabled: isDisabled, className: styles$o.ovalHidden, children: jsx$3(SvgIcOvalHiddenTrigger, {}) });
};
const CircleTrigger = ({ onClick, isActive, isDisabled }) => {
    return jsx$3(Button$2, { variant: "icon", onClick: onClick, isActive: isActive, isDisabled: isDisabled, children: jsx$3(ActionsMenuCircleIcon, {}) });
};

const ActionMenuContext = createContext$1({ horizontalPlacement: "auto", closeActiveMenu: () => { } });
const useActionMenu = () => {
    return useContext(ActionMenuContext);
};

const ParentContext = createContext$1({
    activeSubItem: undefined, setActiveSubItem: () => {
    }
});
const useSubMenu = () => {
    return useContext(ParentContext);
};

const ActionMenuContent = ({ children }) => {
    const [activeSubItem, setActiveSubItem] = useState(null);
    const contentRef = useRef(null);
    return jsx$3(ParentContext.Provider, { value: { activeSubItem, setActiveSubItem }, children: jsx$3("div", { ref: contentRef, className: styles$p.menuContent, onMouseOver: e => {
                if (activeSubItem && activeSubItem.current && contentRef.current !== e.target) {
                    const closestSubItem = e.target.closest('[data-component="ActionMenuSubItem"]');
                    if (!closestSubItem || closestSubItem.contains(contentRef.current)) {
                        setActiveSubItem(null);
                    }
                }
            }, children: children }) });
};

const rightSideMinimumMargin$1 = 48;
const wrapStrings = (children) => {
    return Children.map(children, child => {
        if (typeof child === "string") {
            return jsx$3("span", { children: child });
        }
        else {
            return child;
        }
    });
};
const Button = ({ children, onClick, isDisabled, tooltip, className, dataTestId, style, }) => {
    const { closeActiveMenu } = useActionMenu();
    return jsxs("button", { type: "button", className: classNames(styles$p.menuItem, className), style: style, disabled: isDisabled, "data-testid": dataTestId, onClick: (e) => {
            const keepMenuOpen = onClick(e);
            if (!keepMenuOpen) {
                closeActiveMenu();
            }
        }, children: [wrapStrings(children), tooltip && jsx$3(Tooltip$1, { children: tooltip })] });
};
const RenderSubMenu = ({ children }) => {
    const [position, setPosition] = useState({ isLeft: true, top: 0 });
    const contentRef = useRef(null);
    const { horizontalPlacement } = useActionMenu();
    useLayoutEffect(() => {
        const selfRect = contentRef.current.getBoundingClientRect();
        const parentRect = contentRef.current.closest("[data-component='ActionMenuSubItem']").getBoundingClientRect();
        const hasParentFacingLeft = contentRef.current.closest("[data-direction='left'] [data-component='ActionMenuSubItem']");
        let top = 0;
        const bottom = selfRect.top + selfRect.height;
        if (bottom > window.innerHeight) {
            top = window.innerHeight - bottom - 10;
        }
        if (hasParentFacingLeft || horizontalPlacement === "end" || (parentRect.left + parentRect.width + selfRect.width + rightSideMinimumMargin$1 > window.innerWidth)) {
            setPosition({ isLeft: true, top });
        }
        else {
            setPosition({ isLeft: false, top });
        }
    }, [horizontalPlacement]);
    return jsx$3("div", { ref: contentRef, "data-direction": position.isLeft ? "left" : "right", style: {
            position: "absolute",
            top: position.top,
            zIndex: 1,
            left: position.isLeft ? undefined : "100%",
            right: position.isLeft ? "100%" : undefined
        }, children: jsx$3(ActionMenuContent, { children: children }) });
};
const SubMenu = ({ children, className, style, isDisabled, label, tooltip, dataTestId }) => {
    const itemRef = useRef(null);
    const { setActiveSubItem, activeSubItem } = useSubMenu();
    const isActive = itemRef === activeSubItem;
    return jsxs("div", { className: classNames(styles$p.subMenuItem, className, { "active": isActive, [styles$p.disabled]: isDisabled }), "data-component": "ActionMenuSubItem", style: style, ref: itemRef, tabIndex: 0, "data-testid": dataTestId, onMouseEnter: isDisabled ? undefined : () => {
            setActiveSubItem(itemRef);
        }, onKeyDown: e => {
            if (e.key === "Enter" || e.key === " ") {
                setActiveSubItem(current => current === itemRef ? null : itemRef);
                e.preventDefault();
                e.stopPropagation();
            }
        }, children: [wrapStrings(label), jsx$3(CardArrowCollapseIcon, { className: styles$p.chevron }), tooltip && jsx$3(Tooltip$1, { children: tooltip }), isActive && jsx$3(RenderSubMenu, { children: children })] });
};
const Link = (_a) => {
    var { children, onClick, isDisabled, tooltip, className, style, to, dataTestId } = _a, rest = __rest(_a, ["children", "onClick", "isDisabled", "tooltip", "className", "style", "to", "dataTestId"]);
    const { closeActiveMenu } = useActionMenu();
    return jsxs(Link$2, Object.assign({ className: classNames(styles$p.menuItem, className), style: style, disabled: isDisabled, dataTestId: dataTestId, onClick: (e) => {
            if (isDisabled) {
                e.preventDefault();
            }
            else {
                const keepMenuOpen = onClick && onClick(e);
                if (!keepMenuOpen) {
                    closeActiveMenu();
                }
            }
        } }, rest, { to: isDisabled ? "" : to, children: [wrapStrings(children), tooltip && jsx$3(Tooltip$1, { children: tooltip })] }));
};
const CopyButton = ({ label, value, hideValue, className, style, dataTestId }) => {
    return jsxs("div", { className: classNames(styles$p.copyMenuItem, className), "data-testid": dataTestId, style: style, children: [label && jsxs("span", { children: [label, !hideValue && `: ${value}`] }), jsx$3(CopyButton$1, { text: value, color: "secondary" })] });
};
const DestructiveButton = ({ children, onClick, isDisabled, tooltip, className, dataTestId, style }) => {
    const { closeActiveMenu } = useActionMenu();
    return jsxs("button", { type: "button", className: classNames(styles$p.destructive, className), "data-testid": dataTestId, style: style, disabled: isDisabled, onClick: (e) => {
            const keepMenuOpen = onClick(e);
            if (!keepMenuOpen) {
                closeActiveMenu();
            }
        }, children: [wrapStrings(children), tooltip && jsx$3(Tooltip$1, { children: tooltip })] });
};

const rightSideMinimumMargin = 48;
const verticalGap = 8;
const RenderMenu = ({ triggerRef, children, MenuContent, contentWrapperRef, close, verticalPlacement, horizontalPlacement, horizontalOffset, dataTestId }) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    useLayoutEffect(() => {
        const updatePosition = () => {
            const parentRect = triggerRef.current.getBoundingClientRect();
            const selfRect = contentWrapperRef.current.getBoundingClientRect();
            let left;
            let top;
            let _horizontalPlacement = horizontalPlacement;
            if (_horizontalPlacement === "auto") {
                if (parentRect.left - horizontalOffset + selfRect.width + rightSideMinimumMargin > window.innerWidth) {
                    _horizontalPlacement = "end";
                }
                else {
                    _horizontalPlacement = "start";
                }
            }
            if (_horizontalPlacement === "start") {
                left = parentRect.left - horizontalOffset;
            }
            else if (_horizontalPlacement === "end") {
                left = parentRect.left + parentRect.width - selfRect.width + horizontalOffset;
            }
            else if (_horizontalPlacement === "center") {
                left = parentRect.left + (parentRect.width / 2) - (selfRect.width / 2);
            }
            let _verticalPlacement = verticalPlacement;
            if (_verticalPlacement === "auto") {
                if ((selfRect.height + parentRect.top + parentRect.height + verticalGap) > window.innerHeight) {
                    _verticalPlacement = "top";
                }
                else {
                    _verticalPlacement = "bottom";
                }
            }
            if (_verticalPlacement === "top") {
                top = parentRect.top - verticalGap - selfRect.height;
            }
            else if (_verticalPlacement === "bottom") {
                top = parentRect.top + parentRect.height + verticalGap;
            }
            setPosition({ top, left });
        };
        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true);
        return () => {
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition, true);
        };
    }, [verticalPlacement, horizontalPlacement]);
    useLayoutEffect(() => {
        var _a;
        (_a = contentWrapperRef.current.querySelectorAll(focusable)[0]) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return ReactDOM.createPortal(jsxs("span", { className: styles$p.contentWrapper, ref: contentWrapperRef, style: position, "data-component": "ActionMenuContainer", "data-testid": dataTestId, children: [jsx$3(ClickAway, { ignoreParentClick: true, listener: close }), jsx$3(MenuContent, { children: typeof children === "function" ? children() : children })] }), getRootComponent());
};
const timeout = { enter: 400, exit: 0 };
const ActionMenu = ({ className, style, isDisabled, trigger, Trigger, children, MenuContent = ActionMenuContent, horizontalPlacement = "auto", horizontalOffset = 16, verticalPlacement = "auto", dataTestId }) => {
    const triggerRef = useRef(null);
    const contentWrapperRef = useRef(null);
    const [isActive, setIsActive] = useState(null);
    const onClick = useCallback(() => {
        setIsActive(true);
    }, [setIsActive]);
    if (isDisabled && isActive) {
        setTimeout(() => {
            setIsActive(false);
        });
    }
    const triggerProps = {
        isActive,
        isDisabled,
        onClick: isDisabled ? undefined : onClick
    };
    if (!Trigger && !trigger) {
        Trigger = "oval";
    }
    if (Trigger === "oval") {
        Trigger = OvalTrigger;
    }
    else if (Trigger === "circle") {
        Trigger = CircleTrigger;
    }
    else if (Trigger === "oval-hidden") {
        Trigger = OvalHiddenTrigger;
    }
    const controller = useMemo(() => {
        return {
            horizontalPlacement,
            closeActiveMenu: () => {
                setIsActive(false);
            }
        };
    }, [setIsActive, horizontalPlacement]);
    return jsxs(ActionMenuContext.Provider, { value: controller, children: [jsx$3("span", { ref: triggerRef, className: classNames(styles$p.trigger, className), style: style, "data-component": "ActionMenuTrigger", "data-testid": dataTestId, children: Trigger && jsx$3(Trigger, Object.assign({}, triggerProps)) }), jsx$3(CSSTransition, { nodeRef: contentWrapperRef, in: isActive, unmountOnExit: true, timeout: timeout, classNames: fadeClassNames, children: jsx$3(RenderMenu, { triggerRef: triggerRef, contentWrapperRef: contentWrapperRef, MenuContent: MenuContent, children: children, close: controller.closeActiveMenu, horizontalPlacement: horizontalPlacement, verticalPlacement: verticalPlacement, horizontalOffset: horizontalOffset, dataTestId: `${dataTestId}-container` }) })] });
};
ActionMenu.Button = Button;
ActionMenu.SubMenu = SubMenu;
ActionMenu.Link = Link;
ActionMenu.CopyButton = CopyButton;
ActionMenu.DestructiveButton = DestructiveButton;
const ActionMenuButtonStyle = (props) => {
    return jsx$3(ActionMenu, Object.assign({ Trigger: ({ onClick, isActive, isDisabled }) => cloneElement(props.button, { onClick, isActive, isDisabled }), horizontalOffset: 0 }, props, { children: props.children }));
};

const rowMenu = (createMenu, opts, dataTestId) => {
    return {
        id: "menu",
        width: 56,
        fixedWidth: true,
        header: "",
        accessor: "",
        cellClass: styles$q.menuCell,
        sort: {
            enabled: false
        },
        filter: {
            enabled: false
        },
        hideFromColumnSelector: true,
        Renderer: ({ row }) => {
            const isDisabled = (opts === null || opts === void 0 ? void 0 : opts.isDisabled) ? opts.isDisabled(row) : !!(row === null || row === void 0 ? void 0 : row.isDisabled);
            return jsx$3(Fragment, { children: jsx$3(ActionMenu, { horizontalPlacement: (opts === null || opts === void 0 ? void 0 : opts.horizontalPlacement) || "end", isDisabled: isDisabled, Trigger: "oval-hidden", dataTestId: `${dataTestId}-${row.id}`, children: () => createMenu(row) }) });
        }
    };
};

var CommonColumns = /*#__PURE__*/Object.freeze({
	__proto__: null,
	rowMenu: rowMenu
});

var styles$n = {"base":"SearchWidget-module_base__1q_wQ","widget":"SearchWidget-module_widget__3-daD","open":"SearchWidget-module_open__1_oQc","open-button":"SearchWidget-module_open-button__1oP2y","focussed":"SearchWidget-module_focussed__24qi1","always-open":"SearchWidget-module_always-open__3G4ee","close-button":"SearchWidget-module_close-button__-DeVL","show-close-button":"SearchWidget-module_show-close-button__1sBTM","input":"SearchWidget-module_input__13c3p","bgshimmer":"SearchWidget-module_bgshimmer__2oWVG"};

var SearchWidget = React__default.memo(({ setFilter, alwaysOpen, className, placeholder, style, widgetStyle, widgetClassName, color = "primary", dataTestId = 'search' }) => {
    const input = useRef(null);
    const [isOpen, setIsOpen] = useState(!!alwaysOpen);
    const [value, setValue] = useState("");
    const [isFocussed, setIsFocussed] = useState(false);
    const throttledSetFilter = useMemo(() => {
        return _$1.debounce(value => {
            setFilter(value);
        }, 300);
    }, [setFilter]);
    const open = () => {
        setIsOpen(true);
        setTimeout(() => {
            input.current.focus();
        });
    };
    const close = () => {
        if (!alwaysOpen) {
            setIsOpen(false);
        }
        setValue("");
        throttledSetFilter("");
    };
    const handleBlur = () => {
        setIsFocussed(false);
        if (!value)
            close();
    };
    const handleChange = event => {
        const currValue = event.target.value;
        throttledSetFilter(currValue);
        setValue(currValue);
    };
    const handleKeyDown = event => {
        const currValue = event.target.value;
        if (event.key === 'Enter' || event.key === 'Backspace')
            throttledSetFilter(currValue);
        setValue(currValue);
    };
    return jsx$3("div", { className: classNames(styles$n.base, className), style: style, children: jsxs("div", { className: classNames(styles$n.widget, widgetClassName, { [styles$n['open']]: isOpen, [styles$n['focussed']]: isFocussed }), "data-testid": dataTestId && `${dataTestId}-wrapper`, style: widgetStyle, children: [jsx$3(Button$2, { variant: "icon", color: color === "primary" ? undefined : "secondary", "data-testid": dataTestId && `${dataTestId}-button`, className: classNames(styles$n['open-button'], { [styles$n['always-open']]: alwaysOpen }), tabIndex: alwaysOpen ? -1 : undefined, onClick: alwaysOpen ? undefined : open, children: jsx$3(SearchIcon, {}) }), jsx$3("input", { className: classNames(styles$n['input']), placeholder: placeholder || 'Search', onBlur: () => handleBlur(), onFocus: () => setIsFocussed(true), ref: input, value: value, onChange: handleChange, onKeyDown: handleKeyDown, tabIndex: isOpen ? undefined : -1, "data-testid": dataTestId && `${dataTestId}-input` }), jsx$3("button", { type: "button", "data-testid": dataTestId && `${dataTestId}-clear-button`, className: classNames(styles$n['close-button'], { [styles$n["show-close-button"]]: value.length > 0 }), onClick: close, "aria-label": "Clear search", children: jsx$3(CloseIcon, {}) })] }) });
});

// ------------------ Helpers
function isNumber$1(n) {
  const number = parseFloat(n);
  return !isNaN(number) && isFinite(number);
}
function isPercentage(height) {
  // Percentage height
  return typeof height === 'string' && height[height.length - 1] === '%' && isNumber$1(height.substring(0, height.length - 1));
}
function hideContent(element, height, disableDisplayNone) {
  // Check for element?.style is added cause this would fail in tests (react-test-renderer)
  // Read more here: https://github.com/Stanko/react-animate-height/issues/17
  if (height === 0 && !disableDisplayNone && (element === null || element === void 0 ? void 0 : element.style) && (element === null || element === void 0 ? void 0 : element.children.length) > 0) {
    element.style.display = 'none';
  }
}
function showContent(element, height) {
  // Check for element?.style is added cause this would fail in tests (react-test-renderer)
  // Read more here: https://github.com/Stanko/react-animate-height/issues/17
  if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) {
    element.style.display = '';
  }
}
const ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};
function getStaticStateClasses(animationStateClasses, height) {
  return [animationStateClasses.static, height === 0 && animationStateClasses.staticHeightZero, typeof height === 'number' && height > 0 ? animationStateClasses.staticHeightSpecific : null, height === 'auto' && animationStateClasses.staticHeightAuto].filter(v => v).join(' ');
}
// ------------------ Component
const propsToOmitFromDiv = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'children', 'className', 'contentClassName', 'contentRef', 'delay', 'duration', 'easing', 'height', 'onHeightAnimationEnd', 'onHeightAnimationStart', 'style', 'disableDisplayNone'];
const AnimateHeight = React__default.forwardRef((componentProps, ref) => {
  // const AnimateHeight = forwardRef((componentProps: AnimateHeightProps, ref) => {
  // const AnimateHeight: React.FC<AnimateHeightProps> = (componentProps) => {
  const {
    animateOpacity = false,
    animationStateClasses = {},
    applyInlineTransitions = true,
    children,
    className = '',
    contentClassName,
    delay: userDelay = 0,
    disableDisplayNone = false,
    duration: userDuration = 500,
    easing = 'ease',
    height,
    onHeightAnimationEnd,
    onHeightAnimationStart,
    style,
    contentRef
  } = componentProps;
  const divProps = Object.assign({}, componentProps);
  propsToOmitFromDiv.forEach(propKey => {
    delete divProps[propKey];
  });
  // ------------------ Initialization
  const prevHeight = useRef(height);
  const contentElement = useRef(null);
  const animationClassesTimeoutID = useRef();
  const timeoutID = useRef();
  const stateClasses = useRef(Object.assign(Object.assign({}, ANIMATION_STATE_CLASSES), animationStateClasses));
  const isBrowser = typeof window !== 'undefined';
  const prefersReducedMotion = useRef(isBrowser && window.matchMedia ? window.matchMedia('(prefers-reduced-motion)').matches : false);
  const delay = prefersReducedMotion.current ? 0 : userDelay;
  const duration = prefersReducedMotion.current ? 0 : userDuration;
  let initHeight = height;
  let initOverflow = 'visible';
  if (typeof height === 'number') {
    // Reset negative height to 0
    initHeight = height < 0 ? 0 : height;
    initOverflow = 'hidden';
  } else if (isPercentage(initHeight)) {
    // If value is string "0%" make sure we convert it to number 0
    initHeight = height === '0%' ? 0 : height;
    initOverflow = 'hidden';
  }
  const [currentHeight, setCurrentHeight] = useState(initHeight);
  const [overflow, setOverflow] = useState(initOverflow);
  const [useTransitions, setUseTransitions] = useState(false);
  const [animationStateClassNames, setAnimationStateClassNames] = useState(getStaticStateClasses(stateClasses.current, height));
  // ------------------ Did mount
  useEffect(() => {
    // Hide content if height is 0 (to prevent tabbing into it)
    hideContent(contentElement.current, currentHeight, disableDisplayNone);
    // This should be explicitly run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ------------------ Height update
  useEffect(() => {
    if (height !== prevHeight.current && contentElement.current) {
      showContent(contentElement.current, prevHeight.current);
      // Cache content height
      contentElement.current.style.overflow = 'hidden';
      const contentHeight = contentElement.current.offsetHeight;
      contentElement.current.style.overflow = '';
      // set total animation time
      const totalDuration = duration + delay;
      let newHeight;
      let timeoutHeight;
      let timeoutOverflow = 'hidden';
      let timeoutUseTransitions;
      const isCurrentHeightAuto = prevHeight.current === 'auto';
      if (typeof height === 'number') {
        // Reset negative height to 0
        newHeight = height < 0 ? 0 : height;
        timeoutHeight = newHeight;
      } else if (isPercentage(height)) {
        // If value is string "0%" make sure we convert it to number 0
        newHeight = height === '0%' ? 0 : height;
        timeoutHeight = newHeight;
      } else {
        // If not, animate to content height
        // and then reset to auto
        newHeight = contentHeight; // TODO solve contentHeight = 0
        timeoutHeight = 'auto';
        timeoutOverflow = undefined;
      }
      if (isCurrentHeightAuto) {
        // This is the height to be animated to
        timeoutHeight = newHeight;
        // If previous height was 'auto'
        // set starting height explicitly to be able to use transition
        newHeight = contentHeight;
      }
      // Animation classes
      const newAnimationStateClassNames = [stateClasses.current.animating, (prevHeight.current === 'auto' || height < prevHeight.current) && stateClasses.current.animatingUp, (height === 'auto' || height > prevHeight.current) && stateClasses.current.animatingDown, timeoutHeight === 0 && stateClasses.current.animatingToHeightZero, timeoutHeight === 'auto' && stateClasses.current.animatingToHeightAuto, typeof timeoutHeight === 'number' && timeoutHeight > 0 ? stateClasses.current.animatingToHeightSpecific : null].filter(v => v).join(' ');
      // Animation classes to be put after animation is complete
      const timeoutAnimationStateClasses = getStaticStateClasses(stateClasses.current, timeoutHeight);
      // Set starting height and animating classes
      // When animating from 'auto' we first need to set fixed height
      // that change should be animated
      setCurrentHeight(newHeight);
      setOverflow('hidden');
      setUseTransitions(!isCurrentHeightAuto);
      setAnimationStateClassNames(newAnimationStateClassNames);
      // Clear timeouts
      clearTimeout(timeoutID.current);
      clearTimeout(animationClassesTimeoutID.current);
      if (isCurrentHeightAuto) {
        // When animating from 'auto' we use a short timeout to start animation
        // after setting fixed height above
        timeoutUseTransitions = true;
        // Short timeout to allow rendering of the initial animation state first
        timeoutID.current = setTimeout(() => {
          setCurrentHeight(timeoutHeight);
          setOverflow(timeoutOverflow);
          setUseTransitions(timeoutUseTransitions);
          // ANIMATION STARTS, run a callback if it exists
          onHeightAnimationStart === null || onHeightAnimationStart === void 0 ? void 0 : onHeightAnimationStart(timeoutHeight);
        }, 50);
        // Set static classes and remove transitions when animation ends
        animationClassesTimeoutID.current = setTimeout(() => {
          setUseTransitions(false);
          setAnimationStateClassNames(timeoutAnimationStateClasses);
          // ANIMATION ENDS
          // Hide content if height is 0 (to prevent tabbing into it)
          hideContent(contentElement.current, timeoutHeight, disableDisplayNone);
          // Run a callback if it exists
          onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 ? void 0 : onHeightAnimationEnd(timeoutHeight);
        }, totalDuration);
      } else {
        // ANIMATION STARTS, run a callback if it exists
        onHeightAnimationStart === null || onHeightAnimationStart === void 0 ? void 0 : onHeightAnimationStart(newHeight);
        // Set end height, classes and remove transitions when animation is complete
        timeoutID.current = setTimeout(() => {
          setCurrentHeight(timeoutHeight);
          setOverflow(timeoutOverflow);
          setUseTransitions(false);
          setAnimationStateClassNames(timeoutAnimationStateClasses);
          // ANIMATION ENDS
          // If height is auto, don't hide the content
          // (case when element is empty, therefore height is 0)
          if (height !== 'auto') {
            // Hide content if height is 0 (to prevent tabbing into it)
            hideContent(contentElement.current, newHeight, disableDisplayNone); // TODO solve newHeight = 0
          }
          // Run a callback if it exists
          onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 ? void 0 : onHeightAnimationEnd(newHeight);
        }, totalDuration);
      }
    }
    prevHeight.current = height;
    return () => {
      clearTimeout(timeoutID.current);
      clearTimeout(animationClassesTimeoutID.current);
    };
    // This should be explicitly run only on height change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height]);
  // ------------------ Render
  const componentStyle = Object.assign(Object.assign({}, style), {
    height: currentHeight,
    overflow: overflow || (style === null || style === void 0 ? void 0 : style.overflow)
  });
  if (useTransitions && applyInlineTransitions) {
    componentStyle.transition = `height ${duration}ms ${easing} ${delay}ms`;
    // Include transition passed through styles
    if (style === null || style === void 0 ? void 0 : style.transition) {
      componentStyle.transition = `${style.transition}, ${componentStyle.transition}`;
    }
    // Add webkit vendor prefix still used by opera, blackberry...
    componentStyle.WebkitTransition = componentStyle.transition;
  }
  const contentStyle = {};
  if (animateOpacity) {
    contentStyle.transition = `opacity ${duration}ms ${easing} ${delay}ms`;
    // Add webkit vendor prefix still used by opera, blackberry...
    contentStyle.WebkitTransition = contentStyle.transition;
    if (currentHeight === 0) {
      contentStyle.opacity = 0;
    }
  }
  // Check if user passed aria-hidden prop
  const hasAriaHiddenProp = typeof divProps['aria-hidden'] !== 'undefined';
  const ariaHidden = hasAriaHiddenProp ? divProps['aria-hidden'] : height === 0;
  return React__default.createElement("div", Object.assign({}, divProps, {
    "aria-hidden": ariaHidden,
    className: `${animationStateClassNames} ${className}`,
    style: componentStyle,
    ref: ref
  }), React__default.createElement("div", {
    className: contentClassName,
    style: contentStyle,
    ref: el => {
      contentElement.current = el;
      if (contentRef) {
        contentRef.current = el;
      }
    }
  }, children));
});

var styles$m = {"grouped-container":"Notification-module_grouped-container__1_Gfz","global":"Notification-module_global__3EDYF","active":"Notification-module_active__13LTD","base":"Notification-module_base__2NV0q","success":"Notification-module_success__1iugg","error":"Notification-module_error__1fmBu","urgent":"Notification-module_urgent__3Hc1B","warning":"Notification-module_warning__1Gxy4","info":"Notification-module_info__32LIF","show-less":"Notification-module_show-less__33t6H","margin-right":"Notification-module_margin-right__2lEfl","icon":"Notification-module_icon__31p3S","more":"Notification-module_more__1NX-4","more-wrapper":"Notification-module_more-wrapper__3pQIu","close":"Notification-module_close__1lPuC","show-more":"Notification-module_show-more__-FoB8","bgshimmer":"Notification-module_bgshimmer__RwRvd"};

const iconTypeMapper$1 = {
    error: { icon: ErrorIcon },
    warning: { icon: NoticeTriangleIcon },
    success: { icon: SuccessIcon },
    info: { icon: InfoIcon },
    urgent: { icon: NoticeTriangleIcon }
};
var Notification = ({ type, children, moreInfoClassName, moreInfo, onClose, className, style, messageStyle, isGlobal, isAlwaysOpen, dataTestId = `${type}-notification` }) => {
    const [showMore, setShowMore] = useState(isAlwaysOpen || false);
    const Icon = iconTypeMapper$1[type].icon;
    const hasMore = !!moreInfo;
    const closeable = !!onClose;
    return (jsxs("div", { "data-testid": dataTestId, className: classNames(styles$m["base"], styles$m[type], className, { [styles$m['global']]: isGlobal }), style: style, children: [jsx$3(Icon, { className: styles$m["icon"] }), jsxs("div", { style: messageStyle, children: [jsxs("div", { children: [jsx$3(Span, { bold: true, children: children }), hasMore && !isAlwaysOpen && jsx$3(Button$2, { variant: "text", onClick: () => setShowMore(!showMore), className: styles$m['show-more'], children: showMore ? "Show Less" : "Show More" })] }), jsx$3(AnimateHeight, { duration: 400, easing: "cubic-bezier(.25,.8,.25,1)", height: showMore ? "auto" : 0, contentClassName: styles$m['more-wrapper'], children: jsx$3("div", { className: classNames(styles$m["more"], moreInfoClassName), children: jsx$3(Span, { children: moreInfo }) }) })] }), closeable && jsx$3(Button$2, { variant: "icon", color: "secondary", onClick: onClose, className: styles$m.close, children: jsx$3(CloseIcon, {}) }), !closeable && jsx$3("div", {})] }));
};

const values = {
    error: 4,
    warning: 3,
    info: 2,
    success: 1,
    urgent: 5
};
const compare = (type1, type2) => {
    const val1 = values[type1] || 0;
    const val2 = values[type2] || 0;
    return val2 > val1 ? type2 : type1;
};
const GroupedNotifications = ({ maxType, notifications, className, style }) => {
    const [showAll, setShowAll] = useState(false);
    const Icon = iconTypeMapper$1[maxType].icon;
    const notificationsCount = notifications.length;
    const dismissAll = () => {
        notifications.forEach(notification => {
            if (notification.onClose) {
                notification.onClose();
            }
        });
    };
    return notificationsCount === 0 ? null : jsx$3(AnimateHeight, { duration: 400, easing: "cubic-bezier(.25,.8,.25,1)", height: showAll ? "auto" : 67, className: classNames(styles$m["grouped-container"], className, { [styles$m["active"]]: showAll }), style: style, children: jsxs(Fragment, { children: [jsxs("div", { style: { display: "flex" }, children: [showAll && jsx$3(Button$2, { variant: "none", className: classNames(styles$m["show-less"], styles$m["margin-right"]), onClick: () => setShowAll(false), children: "Show less" }), showAll && jsx$3(Button$2, { variant: "none", className: styles$m["show-less"], onClick: () => dismissAll(), children: "Dismiss All" })] }), !showAll && jsxs("div", { className: classNames(styles$m["base"], styles$m[maxType]), children: [jsx$3(Icon, { className: styles$m["icon"] }), jsxs("div", { children: [jsxs(Span, { bold: true, children: ["You have ", notificationsCount, " new ", notificationsCount > 1 ? "notifications" : "notification", "."] }), jsx$3(Button$2, { variant: "text", onClick: () => setShowAll(true), className: styles$m["show-more"], children: "See Details" })] }), jsx$3("div", {})] }), showAll && jsx$3("div", { style: { maxHeight: 296, overflowX: "auto" }, children: notifications.map((notification, index) => {
                        return jsx$3(Notification, Object.assign({}, notification, { children: notification.description }), index);
                    }) })] }) });
};
var Notifications = ({ notifications: _notifications, className, style, isGlobal }) => {
    const { notifications, maxType } = useMemo(() => {
        const notifications = (_notifications || []).filter(notification => notification && notification.type);
        let maxType = null;
        notifications.forEach(({ type }) => {
            maxType = compare(maxType, type);
        });
        return { notifications, maxType };
    }, [_notifications]);
    const _className = classNames(className, { [styles$m['global']]: isGlobal });
    if (notifications.length === 0) {
        return "";
    }
    else if (notifications.length < 4) {
        return jsx$3("div", { className: _className, style: style, children: notifications.map((notification, index) => {
                return jsx$3(Notification, Object.assign({}, notification, { children: notification.description }), notification.notificationId || index);
            }) });
    }
    else {
        return jsx$3(GroupedNotifications, { maxType: maxType, notifications: notifications, className: _className, style: style });
    }
};

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

// Get all possible permutations of all power sets
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function powerSetPermutations(arr) {
  var arrLength = arr.length;
  if (arrLength === 0 || arrLength === 1) return arr;
  if (arrLength === 2) {
    // prettier-ignore
    return [arr[0], arr[1], "".concat(arr[0], ".").concat(arr[1]), "".concat(arr[1], ".").concat(arr[0])];
  }
  if (arrLength === 3) {
    return [arr[0], arr[1], arr[2], "".concat(arr[0], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[2]), "".concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])];
  }
  if (arrLength >= 4) {
    // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [arr[0], arr[1], arr[2], arr[3], "".concat(arr[0], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[3]), "".concat(arr[3], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]), "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]), "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]), "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])];
  }
}
var classNameCombinations = {};
function getClassNameCombinations(classNames) {
  if (classNames.length === 0 || classNames.length === 1) return classNames;
  var key = classNames.join('.');
  if (!classNameCombinations[key]) {
    classNameCombinations[key] = powerSetPermutations(classNames);
  }
  return classNameCombinations[key];
}
function createStyleObject(classNames) {
  var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
  var nonTokenClassNames = classNames.filter(function (className) {
    return className !== 'token';
  });
  var classNamesCombinations = getClassNameCombinations(nonTokenClassNames);
  return classNamesCombinations.reduce(function (styleObject, className) {
    return _objectSpread$1(_objectSpread$1({}, styleObject), stylesheet[className]);
  }, elementStyle);
}
function createClassNameString(classNames) {
  return classNames.join(' ');
}
function createChildren(stylesheet, useInlineStyles) {
  var childrenCount = 0;
  return function (children) {
    childrenCount += 1;
    return children.map(function (child, i) {
      return createElement({
        node: child,
        stylesheet: stylesheet,
        useInlineStyles: useInlineStyles,
        key: "code-segment-".concat(childrenCount, "-").concat(i)
      });
    });
  };
}
function createElement(_ref) {
  var node = _ref.node,
    stylesheet = _ref.stylesheet,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    useInlineStyles = _ref.useInlineStyles,
    key = _ref.key;
  var properties = node.properties,
    type = node.type,
    TagName = node.tagName,
    value = node.value;
  if (type === 'text') {
    return value;
  } else if (TagName) {
    var childrenCreator = createChildren(stylesheet, useInlineStyles);
    var props;
    if (!useInlineStyles) {
      props = _objectSpread$1(_objectSpread$1({}, properties), {}, {
        className: createClassNameString(properties.className)
      });
    } else {
      var allStylesheetSelectors = Object.keys(stylesheet).reduce(function (classes, selector) {
        selector.split('.').forEach(function (className) {
          if (!classes.includes(className)) classes.push(className);
        });
        return classes;
      }, []);

      // For compatibility with older versions of react-syntax-highlighter
      var startingClassName = properties.className && properties.className.includes('token') ? ['token'] : [];
      var className = properties.className && startingClassName.concat(properties.className.filter(function (className) {
        return !allStylesheetSelectors.includes(className);
      }));
      props = _objectSpread$1(_objectSpread$1({}, properties), {}, {
        className: createClassNameString(className) || undefined,
        style: createStyleObject(properties.className, Object.assign({}, properties.style, style), stylesheet)
      });
    }
    var children = childrenCreator(node.children);
    return /*#__PURE__*/React__default.createElement(TagName, _extends$k({
      key: key
    }, props), children);
  }
}

var checkForListedLanguage = (function (astGenerator, language) {
  var langs = astGenerator.listLanguages();
  return langs.indexOf(language) !== -1;
});

var _excluded$4 = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var newLineRegex = /\n/g;
function getNewLines(str) {
  return str.match(newLineRegex);
}
function getAllLineNumbers(_ref) {
  var lines = _ref.lines,
    startingLineNumber = _ref.startingLineNumber,
    style = _ref.style;
  return lines.map(function (_, i) {
    var number = i + startingLineNumber;
    return /*#__PURE__*/React__default.createElement("span", {
      key: "line-".concat(i),
      className: "react-syntax-highlighter-line-number",
      style: typeof style === 'function' ? style(number) : style
    }, "".concat(number, "\n"));
  });
}
function AllLineNumbers(_ref2) {
  var codeString = _ref2.codeString,
    codeStyle = _ref2.codeStyle,
    _ref2$containerStyle = _ref2.containerStyle,
    containerStyle = _ref2$containerStyle === void 0 ? {
      "float": 'left',
      paddingRight: '10px'
    } : _ref2$containerStyle,
    _ref2$numberStyle = _ref2.numberStyle,
    numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle,
    startingLineNumber = _ref2.startingLineNumber;
  return /*#__PURE__*/React__default.createElement("code", {
    style: Object.assign({}, codeStyle, containerStyle)
  }, getAllLineNumbers({
    lines: codeString.replace(/\n$/, '').split('\n'),
    style: numberStyle,
    startingLineNumber: startingLineNumber
  }));
}
function getEmWidthOfNumber(num) {
  return "".concat(num.toString().length, ".25em");
}
function getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
  return {
    type: 'element',
    tagName: 'span',
    properties: {
      key: "line-number--".concat(lineNumber),
      className: ['comment', 'linenumber', 'react-syntax-highlighter-line-number'],
      style: inlineLineNumberStyle
    },
    children: [{
      type: 'text',
      value: lineNumber
    }]
  };
}
function assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
  // minimally necessary styling for line numbers
  var defaultLineNumberStyle = {
    display: 'inline-block',
    minWidth: getEmWidthOfNumber(largestLineNumber),
    paddingRight: '1em',
    textAlign: 'right',
    userSelect: 'none'
  };
  // prep custom styling
  var customLineNumberStyle = typeof lineNumberStyle === 'function' ? lineNumberStyle(lineNumber) : lineNumberStyle;
  // combine
  var assembledStyle = _objectSpread(_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
  return assembledStyle;
}
function createLineElement(_ref3) {
  var children = _ref3.children,
    lineNumber = _ref3.lineNumber,
    lineNumberStyle = _ref3.lineNumberStyle,
    largestLineNumber = _ref3.largestLineNumber,
    showInlineLineNumbers = _ref3.showInlineLineNumbers,
    _ref3$lineProps = _ref3.lineProps,
    lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? [] : _ref3$className,
    showLineNumbers = _ref3.showLineNumbers,
    wrapLongLines = _ref3.wrapLongLines,
    _ref3$wrapLines = _ref3.wrapLines,
    wrapLines = _ref3$wrapLines === void 0 ? false : _ref3$wrapLines;
  var properties = wrapLines ? _objectSpread({}, typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) : {};
  properties['className'] = properties['className'] ? [].concat(_toConsumableArray(properties['className'].trim().split(/\s+/)), _toConsumableArray(className)) : className;
  if (lineNumber && showInlineLineNumbers) {
    var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
    children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
  }
  if (wrapLongLines & showLineNumbers) {
    properties.style = _objectSpread({
      display: 'flex'
    }, properties.style);
  }
  return {
    type: 'element',
    tagName: 'span',
    properties: properties,
    children: children
  };
}
function flattenCodeTree(tree) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  for (var i = 0; i < tree.length; i++) {
    var node = tree[i];
    if (node.type === 'text') {
      newTree.push(createLineElement({
        children: [node],
        className: _toConsumableArray(new Set(className))
      }));
    } else if (node.children) {
      var classNames = className.concat(node.properties.className);
      flattenCodeTree(node.children, classNames).forEach(function (i) {
        return newTree.push(i);
      });
    }
  }
  return newTree;
}
function processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
  var _ref4;
  var tree = flattenCodeTree(codeTree.value);
  var newTree = [];
  var lastLineBreakIndex = -1;
  var index = 0;
  function createWrappedLine(children, lineNumber) {
    var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return createLineElement({
      children: children,
      lineNumber: lineNumber,
      lineNumberStyle: lineNumberStyle,
      largestLineNumber: largestLineNumber,
      showInlineLineNumbers: showInlineLineNumbers,
      lineProps: lineProps,
      className: className,
      showLineNumbers: showLineNumbers,
      wrapLongLines: wrapLongLines,
      wrapLines: wrapLines
    });
  }
  function createUnwrappedLine(children, lineNumber) {
    if (showLineNumbers && lineNumber && showInlineLineNumbers) {
      var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
      children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    return children;
  }
  function createLine(children, lineNumber) {
    var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
  }
  var _loop = function _loop() {
    var node = tree[index];
    var value = node.children[0].value;
    var newLines = getNewLines(value);
    if (newLines) {
      var splitValue = value.split('\n');
      splitValue.forEach(function (text, i) {
        var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
        var newChild = {
          type: 'text',
          value: "".concat(text, "\n")
        };

        // if it's the first line
        if (i === 0) {
          var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({
            children: [newChild],
            className: node.properties.className
          }));
          var _line = createLine(_children, lineNumber);
          newTree.push(_line);

          // if it's the last line
        } else if (i === splitValue.length - 1) {
          var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
          var lastLineInPreviousSpan = {
            type: 'text',
            value: "".concat(text)
          };
          if (stringChild) {
            var newElem = createLineElement({
              children: [lastLineInPreviousSpan],
              className: node.properties.className
            });
            tree.splice(index + 1, 0, newElem);
          } else {
            var _children2 = [lastLineInPreviousSpan];
            var _line2 = createLine(_children2, lineNumber, node.properties.className);
            newTree.push(_line2);
          }

          // if it's neither the first nor the last line
        } else {
          var _children3 = [newChild];
          var _line3 = createLine(_children3, lineNumber, node.properties.className);
          newTree.push(_line3);
        }
      });
      lastLineBreakIndex = index;
    }
    index++;
  };
  while (index < tree.length) {
    _loop();
  }
  if (lastLineBreakIndex !== tree.length - 1) {
    var children = tree.slice(lastLineBreakIndex + 1, tree.length);
    if (children && children.length) {
      var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
      var line = createLine(children, lineNumber);
      newTree.push(line);
    }
  }
  return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function defaultRenderer(_ref5) {
  var rows = _ref5.rows,
    stylesheet = _ref5.stylesheet,
    useInlineStyles = _ref5.useInlineStyles;
  return rows.map(function (node, i) {
    return createElement({
      node: node,
      stylesheet: stylesheet,
      useInlineStyles: useInlineStyles,
      key: "code-segement".concat(i)
    });
  });
}

// only highlight.js has the highlightAuto method
function isHighlightJs(astGenerator) {
  return astGenerator && typeof astGenerator.highlightAuto !== 'undefined';
}
function getCodeTree(_ref6) {
  var astGenerator = _ref6.astGenerator,
    language = _ref6.language,
    code = _ref6.code,
    defaultCodeValue = _ref6.defaultCodeValue;
  // figure out whether we're using lowlight/highlight or refractor/prism
  // then attempt highlighting accordingly

  // lowlight/highlight?
  if (isHighlightJs(astGenerator)) {
    var hasLanguage = checkForListedLanguage(astGenerator, language);
    if (language === 'text') {
      return {
        value: defaultCodeValue,
        language: 'text'
      };
    } else if (hasLanguage) {
      return astGenerator.highlight(language, code);
    } else {
      return astGenerator.highlightAuto(code);
    }
  }

  // must be refractor/prism, then
  try {
    return language && language !== 'text' ? {
      value: astGenerator.highlight(code, language)
    } : {
      value: defaultCodeValue
    };
  } catch (e) {
    return {
      value: defaultCodeValue
    };
  }
}
function highlight$1 (defaultAstGenerator, defaultStyle) {
  return function SyntaxHighlighter(_ref7) {
    var language = _ref7.language,
      children = _ref7.children,
      _ref7$style = _ref7.style,
      style = _ref7$style === void 0 ? defaultStyle : _ref7$style,
      _ref7$customStyle = _ref7.customStyle,
      customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle,
      _ref7$codeTagProps = _ref7.codeTagProps,
      codeTagProps = _ref7$codeTagProps === void 0 ? {
        className: language ? "language-".concat(language) : undefined,
        style: _objectSpread(_objectSpread({}, style['code[class*="language-"]']), style["code[class*=\"language-".concat(language, "\"]")])
      } : _ref7$codeTagProps,
      _ref7$useInlineStyles = _ref7.useInlineStyles,
      useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles,
      _ref7$showLineNumbers = _ref7.showLineNumbers,
      showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers,
      _ref7$showInlineLineN = _ref7.showInlineLineNumbers,
      showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN,
      _ref7$startingLineNum = _ref7.startingLineNumber,
      startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum,
      lineNumberContainerStyle = _ref7.lineNumberContainerStyle,
      _ref7$lineNumberStyle = _ref7.lineNumberStyle,
      lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle,
      wrapLines = _ref7.wrapLines,
      _ref7$wrapLongLines = _ref7.wrapLongLines,
      wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines,
      _ref7$lineProps = _ref7.lineProps,
      lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps,
      renderer = _ref7.renderer,
      _ref7$PreTag = _ref7.PreTag,
      PreTag = _ref7$PreTag === void 0 ? 'pre' : _ref7$PreTag,
      _ref7$CodeTag = _ref7.CodeTag,
      CodeTag = _ref7$CodeTag === void 0 ? 'code' : _ref7$CodeTag,
      _ref7$code = _ref7.code,
      code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || '' : _ref7$code,
      astGenerator = _ref7.astGenerator,
      rest = _objectWithoutProperties(_ref7, _excluded$4);
    astGenerator = astGenerator || defaultAstGenerator;
    var allLineNumbers = showLineNumbers ? /*#__PURE__*/React__default.createElement(AllLineNumbers, {
      containerStyle: lineNumberContainerStyle,
      codeStyle: codeTagProps.style || {},
      numberStyle: lineNumberStyle,
      startingLineNumber: startingLineNumber,
      codeString: code
    }) : null;
    var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
      backgroundColor: '#fff'
    };
    var generatorClassName = isHighlightJs(astGenerator) ? 'hljs' : 'prismjs';
    var preProps = useInlineStyles ? Object.assign({}, rest, {
      style: Object.assign({}, defaultPreStyle, customStyle)
    }) : Object.assign({}, rest, {
      className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
      style: Object.assign({}, customStyle)
    });
    if (wrapLongLines) {
      codeTagProps.style = _objectSpread({
        whiteSpace: 'pre-wrap'
      }, codeTagProps.style);
    } else {
      codeTagProps.style = _objectSpread({
        whiteSpace: 'pre'
      }, codeTagProps.style);
    }
    if (!astGenerator) {
      return /*#__PURE__*/React__default.createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/React__default.createElement(CodeTag, codeTagProps, code));
    }

    /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */
    if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
    renderer = renderer || defaultRenderer;
    var defaultCodeValue = [{
      type: 'text',
      value: code
    }];
    var codeTree = getCodeTree({
      astGenerator: astGenerator,
      language: language,
      code: code,
      defaultCodeValue: defaultCodeValue
    });
    if (codeTree.language === null) {
      codeTree.value = defaultCodeValue;
    }

    // determine largest line number so that we can force minWidth on all linenumber elements
    var lineCount = codeTree.value.length;
    if (lineCount === 1 && codeTree.value[0].type === 'text') {
      // Since codeTree for an unparsable text (e.g. 'a\na\na') is [{ type: 'text', value: 'a\na\na' }]
      lineCount = codeTree.value[0].value.split('\n').length;
    }
    var largestLineNumber = lineCount + startingLineNumber;
    var rows = processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
    return /*#__PURE__*/React__default.createElement(PreTag, preProps, /*#__PURE__*/React__default.createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
      rows: rows,
      stylesheet: style,
      useInlineStyles: useInlineStyles
    })));
  };
}

var immutable = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
  var target = {};
  for (var i = 0; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
}

var schema$1 = Schema$3;
var proto$1 = Schema$3.prototype;
proto$1.space = null;
proto$1.normal = {};
proto$1.property = {};
function Schema$3(property, normal, space) {
  this.property = property;
  this.normal = normal;
  if (space) {
    this.space = space;
  }
}

var xtend = immutable;
var Schema$2 = schema$1;
var merge_1 = merge$2;
function merge$2(definitions) {
  var length = definitions.length;
  var property = [];
  var normal = [];
  var index = -1;
  var info;
  var space;
  while (++index < length) {
    info = definitions[index];
    property.push(info.property);
    normal.push(info.normal);
    space = info.space;
  }
  return new Schema$2(xtend.apply(null, property), xtend.apply(null, normal), space);
}

var normalize_1 = normalize$3;
function normalize$3(value) {
  return value.toLowerCase();
}

var info = Info$2;
var proto = Info$2.prototype;
proto.space = null;
proto.attribute = null;
proto.property = null;
proto.boolean = false;
proto.booleanish = false;
proto.overloadedBoolean = false;
proto.number = false;
proto.commaSeparated = false;
proto.spaceSeparated = false;
proto.commaOrSpaceSeparated = false;
proto.mustUseProperty = false;
proto.defined = false;
function Info$2(property, attribute) {
  this.property = property;
  this.attribute = attribute;
}

var types$3 = {};

var powers = 0;
types$3.boolean = increment();
types$3.booleanish = increment();
types$3.overloadedBoolean = increment();
types$3.number = increment();
types$3.spaceSeparated = increment();
types$3.commaSeparated = increment();
types$3.commaOrSpaceSeparated = increment();
function increment() {
  return Math.pow(2, ++powers);
}

var Info$1 = info;
var types$2 = types$3;
var definedInfo = DefinedInfo$2;
DefinedInfo$2.prototype = new Info$1();
DefinedInfo$2.prototype.defined = true;
var checks = ['boolean', 'booleanish', 'overloadedBoolean', 'number', 'commaSeparated', 'spaceSeparated', 'commaOrSpaceSeparated'];
var checksLength = checks.length;
function DefinedInfo$2(property, attribute, mask, space) {
  var index = -1;
  var check;
  mark(this, 'space', space);
  Info$1.call(this, property, attribute);
  while (++index < checksLength) {
    check = checks[index];
    mark(this, check, (mask & types$2[check]) === types$2[check]);
  }
}
function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

var normalize$2 = normalize_1;
var Schema$1 = schema$1;
var DefinedInfo$1 = definedInfo;
var create_1 = create$6;
function create$6(definition) {
  var space = definition.space;
  var mustUseProperty = definition.mustUseProperty || [];
  var attributes = definition.attributes || {};
  var props = definition.properties;
  var transform = definition.transform;
  var property = {};
  var normal = {};
  var prop;
  var info;
  for (prop in props) {
    info = new DefinedInfo$1(prop, transform(attributes, prop), props[prop], space);
    if (mustUseProperty.indexOf(prop) !== -1) {
      info.mustUseProperty = true;
    }
    property[prop] = info;
    normal[normalize$2(prop)] = prop;
    normal[normalize$2(info.attribute)] = prop;
  }
  return new Schema$1(property, normal, space);
}

var create$5 = create_1;
var xlink$1 = create$5({
  space: 'xlink',
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function xlinkTransform(_, prop) {
  return 'xlink:' + prop.slice(5).toLowerCase();
}

var create$4 = create_1;
var xml$1 = create$4({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase();
}

var caseSensitiveTransform_1 = caseSensitiveTransform$1;
function caseSensitiveTransform$1(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}

var caseSensitiveTransform = caseSensitiveTransform_1;
var caseInsensitiveTransform_1 = caseInsensitiveTransform$2;
function caseInsensitiveTransform$2(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase());
}

var create$2 = create_1;
var caseInsensitiveTransform$1 = caseInsensitiveTransform_1;
var xmlns$1 = create$2({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform$1,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
});

var types$1 = types$3;
var create$1 = create_1;
var booleanish$1 = types$1.booleanish;
var number$2 = types$1.number;
var spaceSeparated$1 = types$1.spaceSeparated;
var aria$1 = create$1({
  transform: ariaTransform,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$1,
    ariaAutoComplete: null,
    ariaBusy: booleanish$1,
    ariaChecked: booleanish$1,
    ariaColCount: number$2,
    ariaColIndex: number$2,
    ariaColSpan: number$2,
    ariaControls: spaceSeparated$1,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$1,
    ariaDetails: null,
    ariaDisabled: booleanish$1,
    ariaDropEffect: spaceSeparated$1,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$1,
    ariaFlowTo: spaceSeparated$1,
    ariaGrabbed: booleanish$1,
    ariaHasPopup: null,
    ariaHidden: booleanish$1,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$1,
    ariaLevel: number$2,
    ariaLive: null,
    ariaModal: booleanish$1,
    ariaMultiLine: booleanish$1,
    ariaMultiSelectable: booleanish$1,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$1,
    ariaPlaceholder: null,
    ariaPosInSet: number$2,
    ariaPressed: booleanish$1,
    ariaReadOnly: booleanish$1,
    ariaRelevant: null,
    ariaRequired: booleanish$1,
    ariaRoleDescription: spaceSeparated$1,
    ariaRowCount: number$2,
    ariaRowIndex: number$2,
    ariaRowSpan: number$2,
    ariaSelected: booleanish$1,
    ariaSetSize: number$2,
    ariaSort: null,
    ariaValueMax: number$2,
    ariaValueMin: number$2,
    ariaValueNow: number$2,
    ariaValueText: null,
    role: null
  }
});
function ariaTransform(_, prop) {
  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}

var types = types$3;
var create = create_1;
var caseInsensitiveTransform = caseInsensitiveTransform_1;
var boolean$1 = types.boolean;
var overloadedBoolean = types.overloadedBoolean;
var booleanish = types.booleanish;
var number$1 = types.number;
var spaceSeparated = types.spaceSeparated;
var commaSeparated = types.commaSeparated;
var html$2 = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean$1,
    allowPaymentRequest: boolean$1,
    allowUserMedia: boolean$1,
    alt: null,
    as: null,
    async: boolean$1,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean$1,
    autoPlay: boolean$1,
    capture: boolean$1,
    charSet: null,
    checked: boolean$1,
    cite: null,
    className: spaceSeparated,
    cols: number$1,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean$1,
    controlsList: spaceSeparated,
    coords: number$1 | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean$1,
    defer: boolean$1,
    dir: null,
    dirName: null,
    disabled: boolean$1,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean$1,
    formTarget: null,
    headers: spaceSeparated,
    height: number$1,
    hidden: boolean$1,
    high: number$1,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: commaSeparated,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean$1,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean$1,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean$1,
    low: number$1,
    manifest: null,
    max: null,
    maxLength: number$1,
    media: null,
    method: null,
    min: null,
    minLength: number$1,
    multiple: boolean$1,
    muted: boolean$1,
    name: null,
    nonce: null,
    noModule: boolean$1,
    noValidate: boolean$1,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean$1,
    optimum: number$1,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean$1,
    poster: null,
    preload: null,
    readOnly: boolean$1,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean$1,
    reversed: boolean$1,
    rows: number$1,
    rowSpan: number$1,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean$1,
    seamless: boolean$1,
    selected: boolean$1,
    shape: null,
    size: number$1,
    sizes: null,
    slot: null,
    span: number$1,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: commaSeparated,
    start: number$1,
    step: null,
    style: null,
    tabIndex: number$1,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean$1,
    useMap: null,
    value: booleanish,
    width: number$1,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$1,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$1,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean$1,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean$1,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$1,
    // `<img>` and `<object>`
    leftMargin: number$1,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$1,
    // `<body>`
    marginWidth: number$1,
    // `<body>`
    noResize: boolean$1,
    // `<frame>`
    noHref: boolean$1,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean$1,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean$1,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$1,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$1,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$1,
    // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean$1,
    disableRemotePlayback: boolean$1,
    prefix: null,
    property: null,
    results: number$1,
    security: null,
    unselectable: null
  }
});

var merge$1 = merge_1;
var xlink = xlink$1;
var xml = xml$1;
var xmlns = xmlns$1;
var aria = aria$1;
var html$1 = html$2;
var html_1$1 = merge$1([xml, xlink, xmlns, aria, html$1]);

var normalize$1 = normalize_1;
var DefinedInfo = definedInfo;
var Info = info;
var data = 'data';
var find_1 = find$1;
var valid = /^data[-\w.:]+$/i;
var dash$1 = /-[a-z]/g;
var cap$1 = /[A-Z]/g;
function find$1(schema, value) {
  var normal = normalize$1(value);
  var prop = value;
  var Type = Info;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      prop = datasetToProperty(value);
    } else {
      value = datasetToAttribute(value);
    }
    Type = DefinedInfo;
  }
  return new Type(prop, value);
}
function datasetToProperty(attribute) {
  var value = attribute.slice(5).replace(dash$1, camelcase);
  return data + value.charAt(0).toUpperCase() + value.slice(1);
}
function datasetToAttribute(property) {
  var value = property.slice(4);
  if (dash$1.test(value)) {
    return property;
  }
  value = value.replace(cap$1, kebab);
  if (value.charAt(0) !== '-') {
    value = '-' + value;
  }
  return data + value;
}
function kebab($0) {
  return '-' + $0.toLowerCase();
}
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}

var hastUtilParseSelector = parse$4;
var search = /[#.]/g;

// Create a hast element from a simple CSS selector.
function parse$4(selector, defaultTagName) {
  var value = selector || '';
  var name = defaultTagName || 'div';
  var props = {};
  var start = 0;
  var subvalue;
  var previous;
  var match;
  while (start < value.length) {
    search.lastIndex = start;
    match = search.exec(value);
    subvalue = value.slice(start, match ? match.index : value.length);
    if (subvalue) {
      if (!previous) {
        name = subvalue;
      } else if (previous === '#') {
        props.id = subvalue;
      } else if (props.className) {
        props.className.push(subvalue);
      } else {
        props.className = [subvalue];
      }
      start += subvalue.length;
    }
    if (match) {
      previous = match[0];
      start++;
    }
  }
  return {
    type: 'element',
    tagName: name,
    properties: props,
    children: []
  };
}

var spaceSeparatedTokens = {};

spaceSeparatedTokens.parse = parse$3;
spaceSeparatedTokens.stringify = stringify$2;
var empty$2 = '';
var space$2 = ' ';
var whiteSpace = /[ \t\n\r\f]+/g;
function parse$3(value) {
  var input = String(value || empty$2).trim();
  return input === empty$2 ? [] : input.split(whiteSpace);
}
function stringify$2(values) {
  return values.join(space$2).trim();
}

var commaSeparatedTokens = {};

commaSeparatedTokens.parse = parse$2;
commaSeparatedTokens.stringify = stringify$1;
var comma$1 = ',';
var space$1 = ' ';
var empty$1 = '';

// Parse comma-separated tokens to an array.
function parse$2(value) {
  var values = [];
  var input = String(value || empty$1);
  var index = input.indexOf(comma$1);
  var lastIndex = 0;
  var end = false;
  var val;
  while (!end) {
    if (index === -1) {
      index = input.length;
      end = true;
    }
    val = input.slice(lastIndex, index).trim();
    if (val || !end) {
      values.push(val);
    }
    lastIndex = index + 1;
    index = input.indexOf(comma$1, lastIndex);
  }
  return values;
}

// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify$1(values, options) {
  var settings = options || {};
  var left = settings.padLeft === false ? empty$1 : space$1;
  var right = settings.padRight ? space$1 : empty$1;

  // Ensure the last empty entry is seen.
  if (values[values.length - 1] === empty$1) {
    values = values.concat(empty$1);
  }
  return values.join(right + comma$1 + left).trim();
}

var find = find_1;
var normalize = normalize_1;
var parseSelector = hastUtilParseSelector;
var spaces = spaceSeparatedTokens.parse;
var commas = commaSeparatedTokens.parse;
var factory_1 = factory$1;
var own$3 = {}.hasOwnProperty;
function factory$1(schema, defaultTagName, caseSensitive) {
  var adjust = caseSensitive ? createAdjustMap(caseSensitive) : null;
  return h;

  // Hyperscript compatible DSL for creating virtual hast trees.
  function h(selector, properties) {
    var node = parseSelector(selector, defaultTagName);
    var children = Array.prototype.slice.call(arguments, 2);
    var name = node.tagName.toLowerCase();
    var property;
    node.tagName = adjust && own$3.call(adjust, name) ? adjust[name] : name;
    if (properties && isChildren(properties, node)) {
      children.unshift(properties);
      properties = null;
    }
    if (properties) {
      for (property in properties) {
        addProperty(node.properties, property, properties[property]);
      }
    }
    addChild(node.children, children);
    if (node.tagName === 'template') {
      node.content = {
        type: 'root',
        children: node.children
      };
      node.children = [];
    }
    return node;
  }
  function addProperty(properties, key, value) {
    var info;
    var property;
    var result;

    // Ignore nullish and NaN values.
    if (value === null || value === undefined || value !== value) {
      return;
    }
    info = find(schema, key);
    property = info.property;
    result = value;

    // Handle list values.
    if (typeof result === 'string') {
      if (info.spaceSeparated) {
        result = spaces(result);
      } else if (info.commaSeparated) {
        result = commas(result);
      } else if (info.commaOrSpaceSeparated) {
        result = spaces(commas(result).join(' '));
      }
    }

    // Accept `object` on style.
    if (property === 'style' && typeof value !== 'string') {
      result = style$1(result);
    }

    // Class-names (which can be added both on the `selector` and here).
    if (property === 'className' && properties.className) {
      result = properties.className.concat(result);
    }
    properties[property] = parsePrimitives(info, property, result);
  }
}
function isChildren(value, node) {
  return typeof value === 'string' || 'length' in value || isNode(node.tagName, value);
}
function isNode(tagName, value) {
  var type = value.type;
  if (tagName === 'input' || !type || typeof type !== 'string') {
    return false;
  }
  if (typeof value.children === 'object' && 'length' in value.children) {
    return true;
  }
  type = type.toLowerCase();
  if (tagName === 'button') {
    return type !== 'menu' && type !== 'submit' && type !== 'reset' && type !== 'button';
  }
  return 'value' in value;
}
function addChild(nodes, value) {
  var index;
  var length;
  if (typeof value === 'string' || typeof value === 'number') {
    nodes.push({
      type: 'text',
      value: String(value)
    });
    return;
  }
  if (typeof value === 'object' && 'length' in value) {
    index = -1;
    length = value.length;
    while (++index < length) {
      addChild(nodes, value[index]);
    }
    return;
  }
  if (typeof value !== 'object' || !('type' in value)) {
    throw new Error('Expected node, nodes, or string, got `' + value + '`');
  }
  nodes.push(value);
}

// Parse a (list of) primitives.
function parsePrimitives(info, name, value) {
  var index;
  var length;
  var result;
  if (typeof value !== 'object' || !('length' in value)) {
    return parsePrimitive(info, name, value);
  }
  length = value.length;
  index = -1;
  result = [];
  while (++index < length) {
    result[index] = parsePrimitive(info, name, value[index]);
  }
  return result;
}

// Parse a single primitives.
function parsePrimitive(info, name, value) {
  var result = value;
  if (info.number || info.positiveNumber) {
    if (!isNaN(result) && result !== '') {
      result = Number(result);
    }
  } else if (info.boolean || info.overloadedBoolean) {
    // Accept `boolean` and `string`.
    if (typeof result === 'string' && (result === '' || normalize(value) === normalize(name))) {
      result = true;
    }
  }
  return result;
}
function style$1(value) {
  var result = [];
  var key;
  for (key in value) {
    result.push([key, value[key]].join(': '));
  }
  return result.join('; ');
}
function createAdjustMap(values) {
  var length = values.length;
  var index = -1;
  var result = {};
  var value;
  while (++index < length) {
    value = values[index];
    result[value.toLowerCase()] = value;
  }
  return result;
}

var schema = html_1$1;
var factory = factory_1;
var html = factory(schema, 'div');
html.displayName = 'html';
var html_1 = html;

var hastscript = html_1;

var AElig$1 = "Æ";
var AMP$1 = "&";
var Aacute$1 = "Á";
var Acirc$1 = "Â";
var Agrave$1 = "À";
var Aring$1 = "Å";
var Atilde$1 = "Ã";
var Auml$1 = "Ä";
var COPY$1 = "©";
var Ccedil$1 = "Ç";
var ETH$1 = "Ð";
var Eacute$1 = "É";
var Ecirc$1 = "Ê";
var Egrave$1 = "È";
var Euml$1 = "Ë";
var GT$1 = ">";
var Iacute$1 = "Í";
var Icirc$1 = "Î";
var Igrave$1 = "Ì";
var Iuml$1 = "Ï";
var LT$1 = "<";
var Ntilde$1 = "Ñ";
var Oacute$1 = "Ó";
var Ocirc$1 = "Ô";
var Ograve$1 = "Ò";
var Oslash$1 = "Ø";
var Otilde$1 = "Õ";
var Ouml$1 = "Ö";
var QUOT$1 = "\"";
var REG$1 = "®";
var THORN$1 = "Þ";
var Uacute$1 = "Ú";
var Ucirc$1 = "Û";
var Ugrave$1 = "Ù";
var Uuml$1 = "Ü";
var Yacute$1 = "Ý";
var aacute$1 = "á";
var acirc$1 = "â";
var acute$1 = "´";
var aelig$1 = "æ";
var agrave$1 = "à";
var amp$1 = "&";
var aring$1 = "å";
var atilde$1 = "ã";
var auml$1 = "ä";
var brvbar$1 = "¦";
var ccedil$1 = "ç";
var cedil$1 = "¸";
var cent$1 = "¢";
var copy$1 = "©";
var curren$1 = "¤";
var deg$1 = "°";
var divide$1 = "÷";
var eacute$1 = "é";
var ecirc$1 = "ê";
var egrave$1 = "è";
var eth$1 = "ð";
var euml$1 = "ë";
var frac12$1 = "½";
var frac14$1 = "¼";
var frac34$1 = "¾";
var gt$1 = ">";
var iacute$1 = "í";
var icirc$1 = "î";
var iexcl$1 = "¡";
var igrave$1 = "ì";
var iquest$1 = "¿";
var iuml$1 = "ï";
var laquo$1 = "«";
var lt$1 = "<";
var macr$1 = "¯";
var micro$1 = "µ";
var middot$1 = "·";
var nbsp$1 = " ";
var not$1 = "¬";
var ntilde$1 = "ñ";
var oacute$1 = "ó";
var ocirc$1 = "ô";
var ograve$1 = "ò";
var ordf$1 = "ª";
var ordm$1 = "º";
var oslash$1 = "ø";
var otilde$1 = "õ";
var ouml$1 = "ö";
var para$1 = "¶";
var plusmn$1 = "±";
var pound$1 = "£";
var quot$1 = "\"";
var raquo$1 = "»";
var reg$1 = "®";
var sect$1 = "§";
var shy$1 = "­";
var sup1$1 = "¹";
var sup2$1 = "²";
var sup3$1 = "³";
var szlig$1 = "ß";
var thorn$1 = "þ";
var times$1 = "×";
var uacute$1 = "ú";
var ucirc$1 = "û";
var ugrave$1 = "ù";
var uml$1 = "¨";
var uuml$1 = "ü";
var yacute$1 = "ý";
var yen$1 = "¥";
var yuml$1 = "ÿ";
var require$$0$1 = {
	AElig: AElig$1,
	AMP: AMP$1,
	Aacute: Aacute$1,
	Acirc: Acirc$1,
	Agrave: Agrave$1,
	Aring: Aring$1,
	Atilde: Atilde$1,
	Auml: Auml$1,
	COPY: COPY$1,
	Ccedil: Ccedil$1,
	ETH: ETH$1,
	Eacute: Eacute$1,
	Ecirc: Ecirc$1,
	Egrave: Egrave$1,
	Euml: Euml$1,
	GT: GT$1,
	Iacute: Iacute$1,
	Icirc: Icirc$1,
	Igrave: Igrave$1,
	Iuml: Iuml$1,
	LT: LT$1,
	Ntilde: Ntilde$1,
	Oacute: Oacute$1,
	Ocirc: Ocirc$1,
	Ograve: Ograve$1,
	Oslash: Oslash$1,
	Otilde: Otilde$1,
	Ouml: Ouml$1,
	QUOT: QUOT$1,
	REG: REG$1,
	THORN: THORN$1,
	Uacute: Uacute$1,
	Ucirc: Ucirc$1,
	Ugrave: Ugrave$1,
	Uuml: Uuml$1,
	Yacute: Yacute$1,
	aacute: aacute$1,
	acirc: acirc$1,
	acute: acute$1,
	aelig: aelig$1,
	agrave: agrave$1,
	amp: amp$1,
	aring: aring$1,
	atilde: atilde$1,
	auml: auml$1,
	brvbar: brvbar$1,
	ccedil: ccedil$1,
	cedil: cedil$1,
	cent: cent$1,
	copy: copy$1,
	curren: curren$1,
	deg: deg$1,
	divide: divide$1,
	eacute: eacute$1,
	ecirc: ecirc$1,
	egrave: egrave$1,
	eth: eth$1,
	euml: euml$1,
	frac12: frac12$1,
	frac14: frac14$1,
	frac34: frac34$1,
	gt: gt$1,
	iacute: iacute$1,
	icirc: icirc$1,
	iexcl: iexcl$1,
	igrave: igrave$1,
	iquest: iquest$1,
	iuml: iuml$1,
	laquo: laquo$1,
	lt: lt$1,
	macr: macr$1,
	micro: micro$1,
	middot: middot$1,
	nbsp: nbsp$1,
	not: not$1,
	ntilde: ntilde$1,
	oacute: oacute$1,
	ocirc: ocirc$1,
	ograve: ograve$1,
	ordf: ordf$1,
	ordm: ordm$1,
	oslash: oslash$1,
	otilde: otilde$1,
	ouml: ouml$1,
	para: para$1,
	plusmn: plusmn$1,
	pound: pound$1,
	quot: quot$1,
	raquo: raquo$1,
	reg: reg$1,
	sect: sect$1,
	shy: shy$1,
	sup1: sup1$1,
	sup2: sup2$1,
	sup3: sup3$1,
	szlig: szlig$1,
	thorn: thorn$1,
	times: times$1,
	uacute: uacute$1,
	ucirc: ucirc$1,
	ugrave: ugrave$1,
	uml: uml$1,
	uuml: uuml$1,
	yacute: yacute$1,
	yen: yen$1,
	yuml: yuml$1
};

var require$$1 = {
	"0": "�",
	"128": "€",
	"130": "‚",
	"131": "ƒ",
	"132": "„",
	"133": "…",
	"134": "†",
	"135": "‡",
	"136": "ˆ",
	"137": "‰",
	"138": "Š",
	"139": "‹",
	"140": "Œ",
	"142": "Ž",
	"145": "‘",
	"146": "’",
	"147": "“",
	"148": "”",
	"149": "•",
	"150": "–",
	"151": "—",
	"152": "˜",
	"153": "™",
	"154": "š",
	"155": "›",
	"156": "œ",
	"158": "ž",
	"159": "Ÿ"
};

var isDecimal = decimal$2;

// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal$2(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character;
  return code >= 48 && code <= 57; /* 0-9 */
}

var isHexadecimal = hexadecimal$1;

// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal$1(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character;
  return code >= 97 /* a */ && code <= 102 /* z */ || code >= 65 /* A */ && code <= 70 /* Z */ || code >= 48 /* A */ && code <= 57 /* Z */;
}

var isAlphabetical = alphabetical$1;

// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical$1(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character;
  return code >= 97 && code <= 122 /* a-z */ || code >= 65 && code <= 90 /* A-Z */;
}

var alphabetical = isAlphabetical;
var decimal$1 = isDecimal;
var isAlphanumerical = alphanumerical$1;

// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical$1(character) {
  return alphabetical(character) || decimal$1(character);
}

var AEli = "Æ";
var AElig = "Æ";
var AM = "&";
var AMP = "&";
var Aacut = "Á";
var Aacute = "Á";
var Abreve = "Ă";
var Acir = "Â";
var Acirc = "Â";
var Acy = "А";
var Afr = "𝔄";
var Agrav = "À";
var Agrave = "À";
var Alpha = "Α";
var Amacr = "Ā";
var And = "⩓";
var Aogon = "Ą";
var Aopf = "𝔸";
var ApplyFunction = "⁡";
var Arin = "Å";
var Aring = "Å";
var Ascr = "𝒜";
var Assign = "≔";
var Atild = "Ã";
var Atilde = "Ã";
var Aum = "Ä";
var Auml = "Ä";
var Backslash = "∖";
var Barv = "⫧";
var Barwed = "⌆";
var Bcy = "Б";
var Because = "∵";
var Bernoullis = "ℬ";
var Beta = "Β";
var Bfr = "𝔅";
var Bopf = "𝔹";
var Breve = "˘";
var Bscr = "ℬ";
var Bumpeq = "≎";
var CHcy = "Ч";
var COP = "©";
var COPY = "©";
var Cacute = "Ć";
var Cap = "⋒";
var CapitalDifferentialD = "ⅅ";
var Cayleys = "ℭ";
var Ccaron = "Č";
var Ccedi = "Ç";
var Ccedil = "Ç";
var Ccirc = "Ĉ";
var Cconint = "∰";
var Cdot = "Ċ";
var Cedilla = "¸";
var CenterDot = "·";
var Cfr = "ℭ";
var Chi = "Χ";
var CircleDot = "⊙";
var CircleMinus = "⊖";
var CirclePlus = "⊕";
var CircleTimes = "⊗";
var ClockwiseContourIntegral = "∲";
var CloseCurlyDoubleQuote = "”";
var CloseCurlyQuote = "’";
var Colon = "∷";
var Colone = "⩴";
var Congruent = "≡";
var Conint = "∯";
var ContourIntegral = "∮";
var Copf = "ℂ";
var Coproduct = "∐";
var CounterClockwiseContourIntegral = "∳";
var Cross = "⨯";
var Cscr = "𝒞";
var Cup = "⋓";
var CupCap = "≍";
var DD = "ⅅ";
var DDotrahd = "⤑";
var DJcy = "Ђ";
var DScy = "Ѕ";
var DZcy = "Џ";
var Dagger = "‡";
var Darr = "↡";
var Dashv = "⫤";
var Dcaron = "Ď";
var Dcy = "Д";
var Del = "∇";
var Delta = "Δ";
var Dfr = "𝔇";
var DiacriticalAcute = "´";
var DiacriticalDot = "˙";
var DiacriticalDoubleAcute = "˝";
var DiacriticalGrave = "`";
var DiacriticalTilde = "˜";
var Diamond = "⋄";
var DifferentialD = "ⅆ";
var Dopf = "𝔻";
var Dot = "¨";
var DotDot = "⃜";
var DotEqual = "≐";
var DoubleContourIntegral = "∯";
var DoubleDot = "¨";
var DoubleDownArrow = "⇓";
var DoubleLeftArrow = "⇐";
var DoubleLeftRightArrow = "⇔";
var DoubleLeftTee = "⫤";
var DoubleLongLeftArrow = "⟸";
var DoubleLongLeftRightArrow = "⟺";
var DoubleLongRightArrow = "⟹";
var DoubleRightArrow = "⇒";
var DoubleRightTee = "⊨";
var DoubleUpArrow = "⇑";
var DoubleUpDownArrow = "⇕";
var DoubleVerticalBar = "∥";
var DownArrow = "↓";
var DownArrowBar = "⤓";
var DownArrowUpArrow = "⇵";
var DownBreve = "̑";
var DownLeftRightVector = "⥐";
var DownLeftTeeVector = "⥞";
var DownLeftVector = "↽";
var DownLeftVectorBar = "⥖";
var DownRightTeeVector = "⥟";
var DownRightVector = "⇁";
var DownRightVectorBar = "⥗";
var DownTee = "⊤";
var DownTeeArrow = "↧";
var Downarrow = "⇓";
var Dscr = "𝒟";
var Dstrok = "Đ";
var ENG = "Ŋ";
var ET = "Ð";
var ETH = "Ð";
var Eacut = "É";
var Eacute = "É";
var Ecaron = "Ě";
var Ecir = "Ê";
var Ecirc = "Ê";
var Ecy = "Э";
var Edot = "Ė";
var Efr = "𝔈";
var Egrav = "È";
var Egrave = "È";
var Element$2 = "∈";
var Emacr = "Ē";
var EmptySmallSquare = "◻";
var EmptyVerySmallSquare = "▫";
var Eogon = "Ę";
var Eopf = "𝔼";
var Epsilon = "Ε";
var Equal = "⩵";
var EqualTilde = "≂";
var Equilibrium = "⇌";
var Escr = "ℰ";
var Esim = "⩳";
var Eta = "Η";
var Eum = "Ë";
var Euml = "Ë";
var Exists = "∃";
var ExponentialE = "ⅇ";
var Fcy = "Ф";
var Ffr = "𝔉";
var FilledSmallSquare = "◼";
var FilledVerySmallSquare = "▪";
var Fopf = "𝔽";
var ForAll = "∀";
var Fouriertrf = "ℱ";
var Fscr = "ℱ";
var GJcy = "Ѓ";
var G = ">";
var GT = ">";
var Gamma = "Γ";
var Gammad = "Ϝ";
var Gbreve = "Ğ";
var Gcedil = "Ģ";
var Gcirc = "Ĝ";
var Gcy = "Г";
var Gdot = "Ġ";
var Gfr = "𝔊";
var Gg = "⋙";
var Gopf = "𝔾";
var GreaterEqual = "≥";
var GreaterEqualLess = "⋛";
var GreaterFullEqual = "≧";
var GreaterGreater = "⪢";
var GreaterLess = "≷";
var GreaterSlantEqual = "⩾";
var GreaterTilde = "≳";
var Gscr = "𝒢";
var Gt = "≫";
var HARDcy = "Ъ";
var Hacek = "ˇ";
var Hat = "^";
var Hcirc = "Ĥ";
var Hfr = "ℌ";
var HilbertSpace = "ℋ";
var Hopf = "ℍ";
var HorizontalLine = "─";
var Hscr = "ℋ";
var Hstrok = "Ħ";
var HumpDownHump = "≎";
var HumpEqual = "≏";
var IEcy = "Е";
var IJlig = "Ĳ";
var IOcy = "Ё";
var Iacut = "Í";
var Iacute = "Í";
var Icir = "Î";
var Icirc = "Î";
var Icy = "И";
var Idot = "İ";
var Ifr = "ℑ";
var Igrav = "Ì";
var Igrave = "Ì";
var Im = "ℑ";
var Imacr = "Ī";
var ImaginaryI = "ⅈ";
var Implies = "⇒";
var Int = "∬";
var Integral = "∫";
var Intersection = "⋂";
var InvisibleComma = "⁣";
var InvisibleTimes = "⁢";
var Iogon = "Į";
var Iopf = "𝕀";
var Iota = "Ι";
var Iscr = "ℐ";
var Itilde = "Ĩ";
var Iukcy = "І";
var Ium = "Ï";
var Iuml = "Ï";
var Jcirc = "Ĵ";
var Jcy = "Й";
var Jfr = "𝔍";
var Jopf = "𝕁";
var Jscr = "𝒥";
var Jsercy = "Ј";
var Jukcy = "Є";
var KHcy = "Х";
var KJcy = "Ќ";
var Kappa = "Κ";
var Kcedil = "Ķ";
var Kcy = "К";
var Kfr = "𝔎";
var Kopf = "𝕂";
var Kscr = "𝒦";
var LJcy = "Љ";
var L = "<";
var LT = "<";
var Lacute = "Ĺ";
var Lambda = "Λ";
var Lang = "⟪";
var Laplacetrf = "ℒ";
var Larr = "↞";
var Lcaron = "Ľ";
var Lcedil = "Ļ";
var Lcy = "Л";
var LeftAngleBracket = "⟨";
var LeftArrow = "←";
var LeftArrowBar = "⇤";
var LeftArrowRightArrow = "⇆";
var LeftCeiling = "⌈";
var LeftDoubleBracket = "⟦";
var LeftDownTeeVector = "⥡";
var LeftDownVector = "⇃";
var LeftDownVectorBar = "⥙";
var LeftFloor = "⌊";
var LeftRightArrow = "↔";
var LeftRightVector = "⥎";
var LeftTee = "⊣";
var LeftTeeArrow = "↤";
var LeftTeeVector = "⥚";
var LeftTriangle = "⊲";
var LeftTriangleBar = "⧏";
var LeftTriangleEqual = "⊴";
var LeftUpDownVector = "⥑";
var LeftUpTeeVector = "⥠";
var LeftUpVector = "↿";
var LeftUpVectorBar = "⥘";
var LeftVector = "↼";
var LeftVectorBar = "⥒";
var Leftarrow = "⇐";
var Leftrightarrow = "⇔";
var LessEqualGreater = "⋚";
var LessFullEqual = "≦";
var LessGreater = "≶";
var LessLess = "⪡";
var LessSlantEqual = "⩽";
var LessTilde = "≲";
var Lfr = "𝔏";
var Ll = "⋘";
var Lleftarrow = "⇚";
var Lmidot = "Ŀ";
var LongLeftArrow = "⟵";
var LongLeftRightArrow = "⟷";
var LongRightArrow = "⟶";
var Longleftarrow = "⟸";
var Longleftrightarrow = "⟺";
var Longrightarrow = "⟹";
var Lopf = "𝕃";
var LowerLeftArrow = "↙";
var LowerRightArrow = "↘";
var Lscr = "ℒ";
var Lsh = "↰";
var Lstrok = "Ł";
var Lt = "≪";
var Mcy = "М";
var MediumSpace = " ";
var Mellintrf = "ℳ";
var Mfr = "𝔐";
var MinusPlus = "∓";
var Mopf = "𝕄";
var Mscr = "ℳ";
var Mu = "Μ";
var NJcy = "Њ";
var Nacute = "Ń";
var Ncaron = "Ň";
var Ncedil = "Ņ";
var Ncy = "Н";
var NegativeMediumSpace = "​";
var NegativeThickSpace = "​";
var NegativeThinSpace = "​";
var NegativeVeryThinSpace = "​";
var NestedGreaterGreater = "≫";
var NestedLessLess = "≪";
var NewLine = "\n";
var Nfr = "𝔑";
var NoBreak = "⁠";
var NonBreakingSpace = " ";
var Nopf = "ℕ";
var Not = "⫬";
var NotCongruent = "≢";
var NotCupCap = "≭";
var NotDoubleVerticalBar = "∦";
var NotElement = "∉";
var NotEqual = "≠";
var NotEqualTilde = "≂̸";
var NotExists = "∄";
var NotGreater = "≯";
var NotGreaterEqual = "≱";
var NotGreaterFullEqual = "≧̸";
var NotGreaterGreater = "≫̸";
var NotGreaterLess = "≹";
var NotGreaterSlantEqual = "⩾̸";
var NotGreaterTilde = "≵";
var NotHumpDownHump = "≎̸";
var NotHumpEqual = "≏̸";
var NotLeftTriangle = "⋪";
var NotLeftTriangleBar = "⧏̸";
var NotLeftTriangleEqual = "⋬";
var NotLess = "≮";
var NotLessEqual = "≰";
var NotLessGreater = "≸";
var NotLessLess = "≪̸";
var NotLessSlantEqual = "⩽̸";
var NotLessTilde = "≴";
var NotNestedGreaterGreater = "⪢̸";
var NotNestedLessLess = "⪡̸";
var NotPrecedes = "⊀";
var NotPrecedesEqual = "⪯̸";
var NotPrecedesSlantEqual = "⋠";
var NotReverseElement = "∌";
var NotRightTriangle = "⋫";
var NotRightTriangleBar = "⧐̸";
var NotRightTriangleEqual = "⋭";
var NotSquareSubset = "⊏̸";
var NotSquareSubsetEqual = "⋢";
var NotSquareSuperset = "⊐̸";
var NotSquareSupersetEqual = "⋣";
var NotSubset = "⊂⃒";
var NotSubsetEqual = "⊈";
var NotSucceeds = "⊁";
var NotSucceedsEqual = "⪰̸";
var NotSucceedsSlantEqual = "⋡";
var NotSucceedsTilde = "≿̸";
var NotSuperset = "⊃⃒";
var NotSupersetEqual = "⊉";
var NotTilde = "≁";
var NotTildeEqual = "≄";
var NotTildeFullEqual = "≇";
var NotTildeTilde = "≉";
var NotVerticalBar = "∤";
var Nscr = "𝒩";
var Ntild = "Ñ";
var Ntilde = "Ñ";
var Nu = "Ν";
var OElig = "Œ";
var Oacut = "Ó";
var Oacute = "Ó";
var Ocir = "Ô";
var Ocirc = "Ô";
var Ocy = "О";
var Odblac = "Ő";
var Ofr = "𝔒";
var Ograv = "Ò";
var Ograve = "Ò";
var Omacr = "Ō";
var Omega = "Ω";
var Omicron = "Ο";
var Oopf = "𝕆";
var OpenCurlyDoubleQuote = "“";
var OpenCurlyQuote = "‘";
var Or = "⩔";
var Oscr = "𝒪";
var Oslas = "Ø";
var Oslash = "Ø";
var Otild = "Õ";
var Otilde = "Õ";
var Otimes = "⨷";
var Oum = "Ö";
var Ouml = "Ö";
var OverBar = "‾";
var OverBrace = "⏞";
var OverBracket = "⎴";
var OverParenthesis = "⏜";
var PartialD = "∂";
var Pcy = "П";
var Pfr = "𝔓";
var Phi = "Φ";
var Pi = "Π";
var PlusMinus = "±";
var Poincareplane = "ℌ";
var Popf = "ℙ";
var Pr = "⪻";
var Precedes = "≺";
var PrecedesEqual = "⪯";
var PrecedesSlantEqual = "≼";
var PrecedesTilde = "≾";
var Prime = "″";
var Product = "∏";
var Proportion = "∷";
var Proportional = "∝";
var Pscr = "𝒫";
var Psi = "Ψ";
var QUO = "\"";
var QUOT = "\"";
var Qfr = "𝔔";
var Qopf = "ℚ";
var Qscr = "𝒬";
var RBarr = "⤐";
var RE = "®";
var REG = "®";
var Racute = "Ŕ";
var Rang = "⟫";
var Rarr = "↠";
var Rarrtl = "⤖";
var Rcaron = "Ř";
var Rcedil = "Ŗ";
var Rcy = "Р";
var Re = "ℜ";
var ReverseElement = "∋";
var ReverseEquilibrium = "⇋";
var ReverseUpEquilibrium = "⥯";
var Rfr = "ℜ";
var Rho = "Ρ";
var RightAngleBracket = "⟩";
var RightArrow = "→";
var RightArrowBar = "⇥";
var RightArrowLeftArrow = "⇄";
var RightCeiling = "⌉";
var RightDoubleBracket = "⟧";
var RightDownTeeVector = "⥝";
var RightDownVector = "⇂";
var RightDownVectorBar = "⥕";
var RightFloor = "⌋";
var RightTee = "⊢";
var RightTeeArrow = "↦";
var RightTeeVector = "⥛";
var RightTriangle = "⊳";
var RightTriangleBar = "⧐";
var RightTriangleEqual = "⊵";
var RightUpDownVector = "⥏";
var RightUpTeeVector = "⥜";
var RightUpVector = "↾";
var RightUpVectorBar = "⥔";
var RightVector = "⇀";
var RightVectorBar = "⥓";
var Rightarrow = "⇒";
var Ropf = "ℝ";
var RoundImplies = "⥰";
var Rrightarrow = "⇛";
var Rscr = "ℛ";
var Rsh = "↱";
var RuleDelayed = "⧴";
var SHCHcy = "Щ";
var SHcy = "Ш";
var SOFTcy = "Ь";
var Sacute = "Ś";
var Sc = "⪼";
var Scaron = "Š";
var Scedil = "Ş";
var Scirc = "Ŝ";
var Scy = "С";
var Sfr = "𝔖";
var ShortDownArrow = "↓";
var ShortLeftArrow = "←";
var ShortRightArrow = "→";
var ShortUpArrow = "↑";
var Sigma = "Σ";
var SmallCircle = "∘";
var Sopf = "𝕊";
var Sqrt = "√";
var Square = "□";
var SquareIntersection = "⊓";
var SquareSubset = "⊏";
var SquareSubsetEqual = "⊑";
var SquareSuperset = "⊐";
var SquareSupersetEqual = "⊒";
var SquareUnion = "⊔";
var Sscr = "𝒮";
var Star = "⋆";
var Sub = "⋐";
var Subset = "⋐";
var SubsetEqual = "⊆";
var Succeeds = "≻";
var SucceedsEqual = "⪰";
var SucceedsSlantEqual = "≽";
var SucceedsTilde = "≿";
var SuchThat = "∋";
var Sum = "∑";
var Sup = "⋑";
var Superset = "⊃";
var SupersetEqual = "⊇";
var Supset = "⋑";
var THOR = "Þ";
var THORN = "Þ";
var TRADE = "™";
var TSHcy = "Ћ";
var TScy = "Ц";
var Tab = "\t";
var Tau = "Τ";
var Tcaron = "Ť";
var Tcedil = "Ţ";
var Tcy = "Т";
var Tfr = "𝔗";
var Therefore = "∴";
var Theta = "Θ";
var ThickSpace = "  ";
var ThinSpace = " ";
var Tilde = "∼";
var TildeEqual = "≃";
var TildeFullEqual = "≅";
var TildeTilde = "≈";
var Topf = "𝕋";
var TripleDot = "⃛";
var Tscr = "𝒯";
var Tstrok = "Ŧ";
var Uacut = "Ú";
var Uacute = "Ú";
var Uarr = "↟";
var Uarrocir = "⥉";
var Ubrcy = "Ў";
var Ubreve = "Ŭ";
var Ucir = "Û";
var Ucirc = "Û";
var Ucy = "У";
var Udblac = "Ű";
var Ufr = "𝔘";
var Ugrav = "Ù";
var Ugrave = "Ù";
var Umacr = "Ū";
var UnderBar = "_";
var UnderBrace = "⏟";
var UnderBracket = "⎵";
var UnderParenthesis = "⏝";
var Union = "⋃";
var UnionPlus = "⊎";
var Uogon = "Ų";
var Uopf = "𝕌";
var UpArrow = "↑";
var UpArrowBar = "⤒";
var UpArrowDownArrow = "⇅";
var UpDownArrow = "↕";
var UpEquilibrium = "⥮";
var UpTee = "⊥";
var UpTeeArrow = "↥";
var Uparrow = "⇑";
var Updownarrow = "⇕";
var UpperLeftArrow = "↖";
var UpperRightArrow = "↗";
var Upsi = "ϒ";
var Upsilon = "Υ";
var Uring = "Ů";
var Uscr = "𝒰";
var Utilde = "Ũ";
var Uum = "Ü";
var Uuml = "Ü";
var VDash = "⊫";
var Vbar = "⫫";
var Vcy = "В";
var Vdash = "⊩";
var Vdashl = "⫦";
var Vee = "⋁";
var Verbar = "‖";
var Vert = "‖";
var VerticalBar = "∣";
var VerticalLine = "|";
var VerticalSeparator = "❘";
var VerticalTilde = "≀";
var VeryThinSpace = " ";
var Vfr = "𝔙";
var Vopf = "𝕍";
var Vscr = "𝒱";
var Vvdash = "⊪";
var Wcirc = "Ŵ";
var Wedge = "⋀";
var Wfr = "𝔚";
var Wopf = "𝕎";
var Wscr = "𝒲";
var Xfr = "𝔛";
var Xi = "Ξ";
var Xopf = "𝕏";
var Xscr = "𝒳";
var YAcy = "Я";
var YIcy = "Ї";
var YUcy = "Ю";
var Yacut = "Ý";
var Yacute = "Ý";
var Ycirc = "Ŷ";
var Ycy = "Ы";
var Yfr = "𝔜";
var Yopf = "𝕐";
var Yscr = "𝒴";
var Yuml = "Ÿ";
var ZHcy = "Ж";
var Zacute = "Ź";
var Zcaron = "Ž";
var Zcy = "З";
var Zdot = "Ż";
var ZeroWidthSpace = "​";
var Zeta = "Ζ";
var Zfr = "ℨ";
var Zopf = "ℤ";
var Zscr = "𝒵";
var aacut = "á";
var aacute = "á";
var abreve = "ă";
var ac = "∾";
var acE = "∾̳";
var acd = "∿";
var acir = "â";
var acirc = "â";
var acut = "´";
var acute = "´";
var acy = "а";
var aeli = "æ";
var aelig = "æ";
var af = "⁡";
var afr = "𝔞";
var agrav = "à";
var agrave = "à";
var alefsym = "ℵ";
var aleph = "ℵ";
var alpha$1 = "α";
var amacr = "ā";
var amalg = "⨿";
var am = "&";
var amp = "&";
var and = "∧";
var andand = "⩕";
var andd = "⩜";
var andslope = "⩘";
var andv = "⩚";
var ang = "∠";
var ange = "⦤";
var angle = "∠";
var angmsd = "∡";
var angmsdaa = "⦨";
var angmsdab = "⦩";
var angmsdac = "⦪";
var angmsdad = "⦫";
var angmsdae = "⦬";
var angmsdaf = "⦭";
var angmsdag = "⦮";
var angmsdah = "⦯";
var angrt = "∟";
var angrtvb = "⊾";
var angrtvbd = "⦝";
var angsph = "∢";
var angst = "Å";
var angzarr = "⍼";
var aogon = "ą";
var aopf = "𝕒";
var ap = "≈";
var apE = "⩰";
var apacir = "⩯";
var ape = "≊";
var apid = "≋";
var apos = "'";
var approx = "≈";
var approxeq = "≊";
var arin = "å";
var aring = "å";
var ascr = "𝒶";
var ast = "*";
var asymp = "≈";
var asympeq = "≍";
var atild = "ã";
var atilde = "ã";
var aum = "ä";
var auml = "ä";
var awconint = "∳";
var awint = "⨑";
var bNot = "⫭";
var backcong = "≌";
var backepsilon = "϶";
var backprime = "‵";
var backsim = "∽";
var backsimeq = "⋍";
var barvee = "⊽";
var barwed = "⌅";
var barwedge = "⌅";
var bbrk = "⎵";
var bbrktbrk = "⎶";
var bcong = "≌";
var bcy = "б";
var bdquo = "„";
var becaus = "∵";
var because = "∵";
var bemptyv = "⦰";
var bepsi = "϶";
var bernou = "ℬ";
var beta = "β";
var beth = "ℶ";
var between = "≬";
var bfr = "𝔟";
var bigcap = "⋂";
var bigcirc = "◯";
var bigcup = "⋃";
var bigodot = "⨀";
var bigoplus = "⨁";
var bigotimes = "⨂";
var bigsqcup = "⨆";
var bigstar = "★";
var bigtriangledown = "▽";
var bigtriangleup = "△";
var biguplus = "⨄";
var bigvee = "⋁";
var bigwedge = "⋀";
var bkarow = "⤍";
var blacklozenge = "⧫";
var blacksquare = "▪";
var blacktriangle = "▴";
var blacktriangledown = "▾";
var blacktriangleleft = "◂";
var blacktriangleright = "▸";
var blank = "␣";
var blk12 = "▒";
var blk14 = "░";
var blk34 = "▓";
var block = "█";
var bne = "=⃥";
var bnequiv = "≡⃥";
var bnot = "⌐";
var bopf = "𝕓";
var bot = "⊥";
var bottom = "⊥";
var bowtie = "⋈";
var boxDL = "╗";
var boxDR = "╔";
var boxDl = "╖";
var boxDr = "╓";
var boxH = "═";
var boxHD = "╦";
var boxHU = "╩";
var boxHd = "╤";
var boxHu = "╧";
var boxUL = "╝";
var boxUR = "╚";
var boxUl = "╜";
var boxUr = "╙";
var boxV = "║";
var boxVH = "╬";
var boxVL = "╣";
var boxVR = "╠";
var boxVh = "╫";
var boxVl = "╢";
var boxVr = "╟";
var boxbox = "⧉";
var boxdL = "╕";
var boxdR = "╒";
var boxdl = "┐";
var boxdr = "┌";
var boxh = "─";
var boxhD = "╥";
var boxhU = "╨";
var boxhd = "┬";
var boxhu = "┴";
var boxminus = "⊟";
var boxplus = "⊞";
var boxtimes = "⊠";
var boxuL = "╛";
var boxuR = "╘";
var boxul = "┘";
var boxur = "└";
var boxv = "│";
var boxvH = "╪";
var boxvL = "╡";
var boxvR = "╞";
var boxvh = "┼";
var boxvl = "┤";
var boxvr = "├";
var bprime = "‵";
var breve = "˘";
var brvba = "¦";
var brvbar = "¦";
var bscr = "𝒷";
var bsemi = "⁏";
var bsim = "∽";
var bsime = "⋍";
var bsol = "\\";
var bsolb = "⧅";
var bsolhsub = "⟈";
var bull = "•";
var bullet = "•";
var bump = "≎";
var bumpE = "⪮";
var bumpe = "≏";
var bumpeq = "≏";
var cacute = "ć";
var cap = "∩";
var capand = "⩄";
var capbrcup = "⩉";
var capcap = "⩋";
var capcup = "⩇";
var capdot = "⩀";
var caps = "∩︀";
var caret = "⁁";
var caron = "ˇ";
var ccaps = "⩍";
var ccaron = "č";
var ccedi = "ç";
var ccedil = "ç";
var ccirc = "ĉ";
var ccups = "⩌";
var ccupssm = "⩐";
var cdot = "ċ";
var cedi = "¸";
var cedil = "¸";
var cemptyv = "⦲";
var cen = "¢";
var cent = "¢";
var centerdot = "·";
var cfr = "𝔠";
var chcy = "ч";
var check = "✓";
var checkmark = "✓";
var chi = "χ";
var cir = "○";
var cirE = "⧃";
var circ = "ˆ";
var circeq = "≗";
var circlearrowleft = "↺";
var circlearrowright = "↻";
var circledR = "®";
var circledS = "Ⓢ";
var circledast = "⊛";
var circledcirc = "⊚";
var circleddash = "⊝";
var cire = "≗";
var cirfnint = "⨐";
var cirmid = "⫯";
var cirscir = "⧂";
var clubs = "♣";
var clubsuit = "♣";
var colon = ":";
var colone = "≔";
var coloneq = "≔";
var comma = ",";
var commat = "@";
var comp = "∁";
var compfn = "∘";
var complement = "∁";
var complexes = "ℂ";
var cong = "≅";
var congdot = "⩭";
var conint = "∮";
var copf = "𝕔";
var coprod = "∐";
var cop = "©";
var copy = "©";
var copysr = "℗";
var crarr = "↵";
var cross = "✗";
var cscr = "𝒸";
var csub = "⫏";
var csube = "⫑";
var csup = "⫐";
var csupe = "⫒";
var ctdot = "⋯";
var cudarrl = "⤸";
var cudarrr = "⤵";
var cuepr = "⋞";
var cuesc = "⋟";
var cularr = "↶";
var cularrp = "⤽";
var cup = "∪";
var cupbrcap = "⩈";
var cupcap = "⩆";
var cupcup = "⩊";
var cupdot = "⊍";
var cupor = "⩅";
var cups = "∪︀";
var curarr = "↷";
var curarrm = "⤼";
var curlyeqprec = "⋞";
var curlyeqsucc = "⋟";
var curlyvee = "⋎";
var curlywedge = "⋏";
var curre = "¤";
var curren = "¤";
var curvearrowleft = "↶";
var curvearrowright = "↷";
var cuvee = "⋎";
var cuwed = "⋏";
var cwconint = "∲";
var cwint = "∱";
var cylcty = "⌭";
var dArr = "⇓";
var dHar = "⥥";
var dagger = "†";
var daleth = "ℸ";
var darr = "↓";
var dash = "‐";
var dashv = "⊣";
var dbkarow = "⤏";
var dblac = "˝";
var dcaron = "ď";
var dcy = "д";
var dd = "ⅆ";
var ddagger = "‡";
var ddarr = "⇊";
var ddotseq = "⩷";
var de = "°";
var deg = "°";
var delta = "δ";
var demptyv = "⦱";
var dfisht = "⥿";
var dfr = "𝔡";
var dharl = "⇃";
var dharr = "⇂";
var diam = "⋄";
var diamond = "⋄";
var diamondsuit = "♦";
var diams = "♦";
var die = "¨";
var digamma = "ϝ";
var disin = "⋲";
var div = "÷";
var divid = "÷";
var divide = "÷";
var divideontimes = "⋇";
var divonx = "⋇";
var djcy = "ђ";
var dlcorn = "⌞";
var dlcrop = "⌍";
var dollar = "$";
var dopf = "𝕕";
var dot = "˙";
var doteq = "≐";
var doteqdot = "≑";
var dotminus = "∸";
var dotplus = "∔";
var dotsquare = "⊡";
var doublebarwedge = "⌆";
var downarrow = "↓";
var downdownarrows = "⇊";
var downharpoonleft = "⇃";
var downharpoonright = "⇂";
var drbkarow = "⤐";
var drcorn = "⌟";
var drcrop = "⌌";
var dscr = "𝒹";
var dscy = "ѕ";
var dsol = "⧶";
var dstrok = "đ";
var dtdot = "⋱";
var dtri = "▿";
var dtrif = "▾";
var duarr = "⇵";
var duhar = "⥯";
var dwangle = "⦦";
var dzcy = "џ";
var dzigrarr = "⟿";
var eDDot = "⩷";
var eDot = "≑";
var eacut = "é";
var eacute = "é";
var easter = "⩮";
var ecaron = "ě";
var ecir = "ê";
var ecirc = "ê";
var ecolon = "≕";
var ecy = "э";
var edot = "ė";
var ee = "ⅇ";
var efDot = "≒";
var efr = "𝔢";
var eg = "⪚";
var egrav = "è";
var egrave = "è";
var egs = "⪖";
var egsdot = "⪘";
var el = "⪙";
var elinters = "⏧";
var ell = "ℓ";
var els = "⪕";
var elsdot = "⪗";
var emacr = "ē";
var empty = "∅";
var emptyset = "∅";
var emptyv = "∅";
var emsp13 = " ";
var emsp14 = " ";
var emsp = " ";
var eng = "ŋ";
var ensp = " ";
var eogon = "ę";
var eopf = "𝕖";
var epar = "⋕";
var eparsl = "⧣";
var eplus = "⩱";
var epsi = "ε";
var epsilon = "ε";
var epsiv = "ϵ";
var eqcirc = "≖";
var eqcolon = "≕";
var eqsim = "≂";
var eqslantgtr = "⪖";
var eqslantless = "⪕";
var equals = "=";
var equest = "≟";
var equiv = "≡";
var equivDD = "⩸";
var eqvparsl = "⧥";
var erDot = "≓";
var erarr = "⥱";
var escr = "ℯ";
var esdot = "≐";
var esim = "≂";
var eta = "η";
var et = "ð";
var eth = "ð";
var eum = "ë";
var euml = "ë";
var euro = "€";
var excl = "!";
var exist = "∃";
var expectation = "ℰ";
var exponentiale = "ⅇ";
var fallingdotseq = "≒";
var fcy = "ф";
var female = "♀";
var ffilig = "ﬃ";
var fflig = "ﬀ";
var ffllig = "ﬄ";
var ffr = "𝔣";
var filig = "ﬁ";
var fjlig = "fj";
var flat = "♭";
var fllig = "ﬂ";
var fltns = "▱";
var fnof = "ƒ";
var fopf = "𝕗";
var forall = "∀";
var fork = "⋔";
var forkv = "⫙";
var fpartint = "⨍";
var frac1 = "¼";
var frac12 = "½";
var frac13 = "⅓";
var frac14 = "¼";
var frac15 = "⅕";
var frac16 = "⅙";
var frac18 = "⅛";
var frac23 = "⅔";
var frac25 = "⅖";
var frac3 = "¾";
var frac34 = "¾";
var frac35 = "⅗";
var frac38 = "⅜";
var frac45 = "⅘";
var frac56 = "⅚";
var frac58 = "⅝";
var frac78 = "⅞";
var frasl = "⁄";
var frown = "⌢";
var fscr = "𝒻";
var gE = "≧";
var gEl = "⪌";
var gacute = "ǵ";
var gamma = "γ";
var gammad = "ϝ";
var gap = "⪆";
var gbreve = "ğ";
var gcirc = "ĝ";
var gcy = "г";
var gdot = "ġ";
var ge = "≥";
var gel = "⋛";
var geq = "≥";
var geqq = "≧";
var geqslant = "⩾";
var ges = "⩾";
var gescc = "⪩";
var gesdot = "⪀";
var gesdoto = "⪂";
var gesdotol = "⪄";
var gesl = "⋛︀";
var gesles = "⪔";
var gfr = "𝔤";
var gg = "≫";
var ggg = "⋙";
var gimel = "ℷ";
var gjcy = "ѓ";
var gl = "≷";
var glE = "⪒";
var gla = "⪥";
var glj = "⪤";
var gnE = "≩";
var gnap = "⪊";
var gnapprox = "⪊";
var gne = "⪈";
var gneq = "⪈";
var gneqq = "≩";
var gnsim = "⋧";
var gopf = "𝕘";
var grave = "`";
var gscr = "ℊ";
var gsim = "≳";
var gsime = "⪎";
var gsiml = "⪐";
var g = ">";
var gt = ">";
var gtcc = "⪧";
var gtcir = "⩺";
var gtdot = "⋗";
var gtlPar = "⦕";
var gtquest = "⩼";
var gtrapprox = "⪆";
var gtrarr = "⥸";
var gtrdot = "⋗";
var gtreqless = "⋛";
var gtreqqless = "⪌";
var gtrless = "≷";
var gtrsim = "≳";
var gvertneqq = "≩︀";
var gvnE = "≩︀";
var hArr = "⇔";
var hairsp = " ";
var half = "½";
var hamilt = "ℋ";
var hardcy = "ъ";
var harr = "↔";
var harrcir = "⥈";
var harrw = "↭";
var hbar = "ℏ";
var hcirc = "ĥ";
var hearts = "♥";
var heartsuit = "♥";
var hellip = "…";
var hercon = "⊹";
var hfr = "𝔥";
var hksearow = "⤥";
var hkswarow = "⤦";
var hoarr = "⇿";
var homtht = "∻";
var hookleftarrow = "↩";
var hookrightarrow = "↪";
var hopf = "𝕙";
var horbar = "―";
var hscr = "𝒽";
var hslash = "ℏ";
var hstrok = "ħ";
var hybull = "⁃";
var hyphen = "‐";
var iacut = "í";
var iacute = "í";
var ic = "⁣";
var icir = "î";
var icirc = "î";
var icy = "и";
var iecy = "е";
var iexc = "¡";
var iexcl = "¡";
var iff = "⇔";
var ifr = "𝔦";
var igrav = "ì";
var igrave = "ì";
var ii = "ⅈ";
var iiiint = "⨌";
var iiint = "∭";
var iinfin = "⧜";
var iiota = "℩";
var ijlig = "ĳ";
var imacr = "ī";
var image = "ℑ";
var imagline = "ℐ";
var imagpart = "ℑ";
var imath = "ı";
var imof = "⊷";
var imped = "Ƶ";
var incare = "℅";
var infin = "∞";
var infintie = "⧝";
var inodot = "ı";
var int = "∫";
var intcal = "⊺";
var integers = "ℤ";
var intercal = "⊺";
var intlarhk = "⨗";
var intprod = "⨼";
var iocy = "ё";
var iogon = "į";
var iopf = "𝕚";
var iota = "ι";
var iprod = "⨼";
var iques = "¿";
var iquest = "¿";
var iscr = "𝒾";
var isin = "∈";
var isinE = "⋹";
var isindot = "⋵";
var isins = "⋴";
var isinsv = "⋳";
var isinv = "∈";
var it = "⁢";
var itilde = "ĩ";
var iukcy = "і";
var ium = "ï";
var iuml = "ï";
var jcirc = "ĵ";
var jcy = "й";
var jfr = "𝔧";
var jmath = "ȷ";
var jopf = "𝕛";
var jscr = "𝒿";
var jsercy = "ј";
var jukcy = "є";
var kappa = "κ";
var kappav = "ϰ";
var kcedil = "ķ";
var kcy = "к";
var kfr = "𝔨";
var kgreen = "ĸ";
var khcy = "х";
var kjcy = "ќ";
var kopf = "𝕜";
var kscr = "𝓀";
var lAarr = "⇚";
var lArr = "⇐";
var lAtail = "⤛";
var lBarr = "⤎";
var lE = "≦";
var lEg = "⪋";
var lHar = "⥢";
var lacute = "ĺ";
var laemptyv = "⦴";
var lagran = "ℒ";
var lambda = "λ";
var lang = "⟨";
var langd = "⦑";
var langle = "⟨";
var lap = "⪅";
var laqu = "«";
var laquo = "«";
var larr = "←";
var larrb = "⇤";
var larrbfs = "⤟";
var larrfs = "⤝";
var larrhk = "↩";
var larrlp = "↫";
var larrpl = "⤹";
var larrsim = "⥳";
var larrtl = "↢";
var lat = "⪫";
var latail = "⤙";
var late = "⪭";
var lates = "⪭︀";
var lbarr = "⤌";
var lbbrk = "❲";
var lbrace = "{";
var lbrack = "[";
var lbrke = "⦋";
var lbrksld = "⦏";
var lbrkslu = "⦍";
var lcaron = "ľ";
var lcedil = "ļ";
var lceil = "⌈";
var lcub = "{";
var lcy = "л";
var ldca = "⤶";
var ldquo = "“";
var ldquor = "„";
var ldrdhar = "⥧";
var ldrushar = "⥋";
var ldsh = "↲";
var le = "≤";
var leftarrow = "←";
var leftarrowtail = "↢";
var leftharpoondown = "↽";
var leftharpoonup = "↼";
var leftleftarrows = "⇇";
var leftrightarrow = "↔";
var leftrightarrows = "⇆";
var leftrightharpoons = "⇋";
var leftrightsquigarrow = "↭";
var leftthreetimes = "⋋";
var leg = "⋚";
var leq = "≤";
var leqq = "≦";
var leqslant = "⩽";
var les = "⩽";
var lescc = "⪨";
var lesdot = "⩿";
var lesdoto = "⪁";
var lesdotor = "⪃";
var lesg = "⋚︀";
var lesges = "⪓";
var lessapprox = "⪅";
var lessdot = "⋖";
var lesseqgtr = "⋚";
var lesseqqgtr = "⪋";
var lessgtr = "≶";
var lesssim = "≲";
var lfisht = "⥼";
var lfloor = "⌊";
var lfr = "𝔩";
var lg = "≶";
var lgE = "⪑";
var lhard = "↽";
var lharu = "↼";
var lharul = "⥪";
var lhblk = "▄";
var ljcy = "љ";
var ll = "≪";
var llarr = "⇇";
var llcorner = "⌞";
var llhard = "⥫";
var lltri = "◺";
var lmidot = "ŀ";
var lmoust = "⎰";
var lmoustache = "⎰";
var lnE = "≨";
var lnap = "⪉";
var lnapprox = "⪉";
var lne = "⪇";
var lneq = "⪇";
var lneqq = "≨";
var lnsim = "⋦";
var loang = "⟬";
var loarr = "⇽";
var lobrk = "⟦";
var longleftarrow = "⟵";
var longleftrightarrow = "⟷";
var longmapsto = "⟼";
var longrightarrow = "⟶";
var looparrowleft = "↫";
var looparrowright = "↬";
var lopar = "⦅";
var lopf = "𝕝";
var loplus = "⨭";
var lotimes = "⨴";
var lowast = "∗";
var lowbar = "_";
var loz = "◊";
var lozenge = "◊";
var lozf = "⧫";
var lpar = "(";
var lparlt = "⦓";
var lrarr = "⇆";
var lrcorner = "⌟";
var lrhar = "⇋";
var lrhard = "⥭";
var lrm = "‎";
var lrtri = "⊿";
var lsaquo = "‹";
var lscr = "𝓁";
var lsh = "↰";
var lsim = "≲";
var lsime = "⪍";
var lsimg = "⪏";
var lsqb = "[";
var lsquo = "‘";
var lsquor = "‚";
var lstrok = "ł";
var l = "<";
var lt = "<";
var ltcc = "⪦";
var ltcir = "⩹";
var ltdot = "⋖";
var lthree = "⋋";
var ltimes = "⋉";
var ltlarr = "⥶";
var ltquest = "⩻";
var ltrPar = "⦖";
var ltri = "◃";
var ltrie = "⊴";
var ltrif = "◂";
var lurdshar = "⥊";
var luruhar = "⥦";
var lvertneqq = "≨︀";
var lvnE = "≨︀";
var mDDot = "∺";
var mac = "¯";
var macr = "¯";
var male = "♂";
var malt = "✠";
var maltese = "✠";
var map$2 = "↦";
var mapsto = "↦";
var mapstodown = "↧";
var mapstoleft = "↤";
var mapstoup = "↥";
var marker = "▮";
var mcomma = "⨩";
var mcy = "м";
var mdash = "—";
var measuredangle = "∡";
var mfr = "𝔪";
var mho = "℧";
var micr = "µ";
var micro = "µ";
var mid = "∣";
var midast = "*";
var midcir = "⫰";
var middo = "·";
var middot = "·";
var minus = "−";
var minusb = "⊟";
var minusd = "∸";
var minusdu = "⨪";
var mlcp = "⫛";
var mldr = "…";
var mnplus = "∓";
var models = "⊧";
var mopf = "𝕞";
var mp = "∓";
var mscr = "𝓂";
var mstpos = "∾";
var mu = "μ";
var multimap = "⊸";
var mumap = "⊸";
var nGg = "⋙̸";
var nGt = "≫⃒";
var nGtv = "≫̸";
var nLeftarrow = "⇍";
var nLeftrightarrow = "⇎";
var nLl = "⋘̸";
var nLt = "≪⃒";
var nLtv = "≪̸";
var nRightarrow = "⇏";
var nVDash = "⊯";
var nVdash = "⊮";
var nabla = "∇";
var nacute = "ń";
var nang = "∠⃒";
var nap = "≉";
var napE = "⩰̸";
var napid = "≋̸";
var napos = "ŉ";
var napprox = "≉";
var natur = "♮";
var natural = "♮";
var naturals = "ℕ";
var nbs = " ";
var nbsp = " ";
var nbump = "≎̸";
var nbumpe = "≏̸";
var ncap = "⩃";
var ncaron = "ň";
var ncedil = "ņ";
var ncong = "≇";
var ncongdot = "⩭̸";
var ncup = "⩂";
var ncy = "н";
var ndash = "–";
var ne = "≠";
var neArr = "⇗";
var nearhk = "⤤";
var nearr = "↗";
var nearrow = "↗";
var nedot = "≐̸";
var nequiv = "≢";
var nesear = "⤨";
var nesim = "≂̸";
var nexist = "∄";
var nexists = "∄";
var nfr = "𝔫";
var ngE = "≧̸";
var nge = "≱";
var ngeq = "≱";
var ngeqq = "≧̸";
var ngeqslant = "⩾̸";
var nges = "⩾̸";
var ngsim = "≵";
var ngt = "≯";
var ngtr = "≯";
var nhArr = "⇎";
var nharr = "↮";
var nhpar = "⫲";
var ni = "∋";
var nis = "⋼";
var nisd = "⋺";
var niv = "∋";
var njcy = "њ";
var nlArr = "⇍";
var nlE = "≦̸";
var nlarr = "↚";
var nldr = "‥";
var nle = "≰";
var nleftarrow = "↚";
var nleftrightarrow = "↮";
var nleq = "≰";
var nleqq = "≦̸";
var nleqslant = "⩽̸";
var nles = "⩽̸";
var nless = "≮";
var nlsim = "≴";
var nlt = "≮";
var nltri = "⋪";
var nltrie = "⋬";
var nmid = "∤";
var nopf = "𝕟";
var no = "¬";
var not = "¬";
var notin = "∉";
var notinE = "⋹̸";
var notindot = "⋵̸";
var notinva = "∉";
var notinvb = "⋷";
var notinvc = "⋶";
var notni = "∌";
var notniva = "∌";
var notnivb = "⋾";
var notnivc = "⋽";
var npar = "∦";
var nparallel = "∦";
var nparsl = "⫽⃥";
var npart = "∂̸";
var npolint = "⨔";
var npr = "⊀";
var nprcue = "⋠";
var npre = "⪯̸";
var nprec = "⊀";
var npreceq = "⪯̸";
var nrArr = "⇏";
var nrarr = "↛";
var nrarrc = "⤳̸";
var nrarrw = "↝̸";
var nrightarrow = "↛";
var nrtri = "⋫";
var nrtrie = "⋭";
var nsc = "⊁";
var nsccue = "⋡";
var nsce = "⪰̸";
var nscr = "𝓃";
var nshortmid = "∤";
var nshortparallel = "∦";
var nsim = "≁";
var nsime = "≄";
var nsimeq = "≄";
var nsmid = "∤";
var nspar = "∦";
var nsqsube = "⋢";
var nsqsupe = "⋣";
var nsub = "⊄";
var nsubE = "⫅̸";
var nsube = "⊈";
var nsubset = "⊂⃒";
var nsubseteq = "⊈";
var nsubseteqq = "⫅̸";
var nsucc = "⊁";
var nsucceq = "⪰̸";
var nsup = "⊅";
var nsupE = "⫆̸";
var nsupe = "⊉";
var nsupset = "⊃⃒";
var nsupseteq = "⊉";
var nsupseteqq = "⫆̸";
var ntgl = "≹";
var ntild = "ñ";
var ntilde = "ñ";
var ntlg = "≸";
var ntriangleleft = "⋪";
var ntrianglelefteq = "⋬";
var ntriangleright = "⋫";
var ntrianglerighteq = "⋭";
var nu = "ν";
var num = "#";
var numero = "№";
var numsp = " ";
var nvDash = "⊭";
var nvHarr = "⤄";
var nvap = "≍⃒";
var nvdash = "⊬";
var nvge = "≥⃒";
var nvgt = ">⃒";
var nvinfin = "⧞";
var nvlArr = "⤂";
var nvle = "≤⃒";
var nvlt = "<⃒";
var nvltrie = "⊴⃒";
var nvrArr = "⤃";
var nvrtrie = "⊵⃒";
var nvsim = "∼⃒";
var nwArr = "⇖";
var nwarhk = "⤣";
var nwarr = "↖";
var nwarrow = "↖";
var nwnear = "⤧";
var oS = "Ⓢ";
var oacut = "ó";
var oacute = "ó";
var oast = "⊛";
var ocir = "ô";
var ocirc = "ô";
var ocy = "о";
var odash = "⊝";
var odblac = "ő";
var odiv = "⨸";
var odot = "⊙";
var odsold = "⦼";
var oelig = "œ";
var ofcir = "⦿";
var ofr = "𝔬";
var ogon = "˛";
var ograv = "ò";
var ograve = "ò";
var ogt = "⧁";
var ohbar = "⦵";
var ohm = "Ω";
var oint = "∮";
var olarr = "↺";
var olcir = "⦾";
var olcross = "⦻";
var oline = "‾";
var olt = "⧀";
var omacr = "ō";
var omega = "ω";
var omicron = "ο";
var omid = "⦶";
var ominus = "⊖";
var oopf = "𝕠";
var opar = "⦷";
var operp = "⦹";
var oplus = "⊕";
var or = "∨";
var orarr = "↻";
var ord = "º";
var order = "ℴ";
var orderof = "ℴ";
var ordf = "ª";
var ordm = "º";
var origof = "⊶";
var oror = "⩖";
var orslope = "⩗";
var orv = "⩛";
var oscr = "ℴ";
var oslas = "ø";
var oslash = "ø";
var osol = "⊘";
var otild = "õ";
var otilde = "õ";
var otimes = "⊗";
var otimesas = "⨶";
var oum = "ö";
var ouml = "ö";
var ovbar = "⌽";
var par = "¶";
var para = "¶";
var parallel = "∥";
var parsim = "⫳";
var parsl = "⫽";
var part = "∂";
var pcy = "п";
var percnt = "%";
var period = ".";
var permil = "‰";
var perp = "⊥";
var pertenk = "‱";
var pfr = "𝔭";
var phi = "φ";
var phiv = "ϕ";
var phmmat = "ℳ";
var phone = "☎";
var pi = "π";
var pitchfork = "⋔";
var piv = "ϖ";
var planck = "ℏ";
var planckh = "ℎ";
var plankv = "ℏ";
var plus = "+";
var plusacir = "⨣";
var plusb = "⊞";
var pluscir = "⨢";
var plusdo = "∔";
var plusdu = "⨥";
var pluse = "⩲";
var plusm = "±";
var plusmn = "±";
var plussim = "⨦";
var plustwo = "⨧";
var pm = "±";
var pointint = "⨕";
var popf = "𝕡";
var poun = "£";
var pound = "£";
var pr = "≺";
var prE = "⪳";
var prap = "⪷";
var prcue = "≼";
var pre = "⪯";
var prec = "≺";
var precapprox = "⪷";
var preccurlyeq = "≼";
var preceq = "⪯";
var precnapprox = "⪹";
var precneqq = "⪵";
var precnsim = "⋨";
var precsim = "≾";
var prime = "′";
var primes = "ℙ";
var prnE = "⪵";
var prnap = "⪹";
var prnsim = "⋨";
var prod = "∏";
var profalar = "⌮";
var profline = "⌒";
var profsurf = "⌓";
var prop = "∝";
var propto = "∝";
var prsim = "≾";
var prurel = "⊰";
var pscr = "𝓅";
var psi = "ψ";
var puncsp = " ";
var qfr = "𝔮";
var qint = "⨌";
var qopf = "𝕢";
var qprime = "⁗";
var qscr = "𝓆";
var quaternions = "ℍ";
var quatint = "⨖";
var quest = "?";
var questeq = "≟";
var quo = "\"";
var quot = "\"";
var rAarr = "⇛";
var rArr = "⇒";
var rAtail = "⤜";
var rBarr = "⤏";
var rHar = "⥤";
var race = "∽̱";
var racute = "ŕ";
var radic = "√";
var raemptyv = "⦳";
var rang = "⟩";
var rangd = "⦒";
var range = "⦥";
var rangle = "⟩";
var raqu = "»";
var raquo = "»";
var rarr = "→";
var rarrap = "⥵";
var rarrb = "⇥";
var rarrbfs = "⤠";
var rarrc = "⤳";
var rarrfs = "⤞";
var rarrhk = "↪";
var rarrlp = "↬";
var rarrpl = "⥅";
var rarrsim = "⥴";
var rarrtl = "↣";
var rarrw = "↝";
var ratail = "⤚";
var ratio = "∶";
var rationals = "ℚ";
var rbarr = "⤍";
var rbbrk = "❳";
var rbrace = "}";
var rbrack = "]";
var rbrke = "⦌";
var rbrksld = "⦎";
var rbrkslu = "⦐";
var rcaron = "ř";
var rcedil = "ŗ";
var rceil = "⌉";
var rcub = "}";
var rcy = "р";
var rdca = "⤷";
var rdldhar = "⥩";
var rdquo = "”";
var rdquor = "”";
var rdsh = "↳";
var real = "ℜ";
var realine = "ℛ";
var realpart = "ℜ";
var reals = "ℝ";
var rect = "▭";
var re = "®";
var reg = "®";
var rfisht = "⥽";
var rfloor = "⌋";
var rfr = "𝔯";
var rhard = "⇁";
var rharu = "⇀";
var rharul = "⥬";
var rho = "ρ";
var rhov = "ϱ";
var rightarrow = "→";
var rightarrowtail = "↣";
var rightharpoondown = "⇁";
var rightharpoonup = "⇀";
var rightleftarrows = "⇄";
var rightleftharpoons = "⇌";
var rightrightarrows = "⇉";
var rightsquigarrow = "↝";
var rightthreetimes = "⋌";
var ring = "˚";
var risingdotseq = "≓";
var rlarr = "⇄";
var rlhar = "⇌";
var rlm = "‏";
var rmoust = "⎱";
var rmoustache = "⎱";
var rnmid = "⫮";
var roang = "⟭";
var roarr = "⇾";
var robrk = "⟧";
var ropar = "⦆";
var ropf = "𝕣";
var roplus = "⨮";
var rotimes = "⨵";
var rpar = ")";
var rpargt = "⦔";
var rppolint = "⨒";
var rrarr = "⇉";
var rsaquo = "›";
var rscr = "𝓇";
var rsh = "↱";
var rsqb = "]";
var rsquo = "’";
var rsquor = "’";
var rthree = "⋌";
var rtimes = "⋊";
var rtri = "▹";
var rtrie = "⊵";
var rtrif = "▸";
var rtriltri = "⧎";
var ruluhar = "⥨";
var rx = "℞";
var sacute = "ś";
var sbquo = "‚";
var sc = "≻";
var scE = "⪴";
var scap = "⪸";
var scaron = "š";
var sccue = "≽";
var sce = "⪰";
var scedil = "ş";
var scirc = "ŝ";
var scnE = "⪶";
var scnap = "⪺";
var scnsim = "⋩";
var scpolint = "⨓";
var scsim = "≿";
var scy = "с";
var sdot = "⋅";
var sdotb = "⊡";
var sdote = "⩦";
var seArr = "⇘";
var searhk = "⤥";
var searr = "↘";
var searrow = "↘";
var sec = "§";
var sect = "§";
var semi = ";";
var seswar = "⤩";
var setminus = "∖";
var setmn = "∖";
var sext = "✶";
var sfr = "𝔰";
var sfrown = "⌢";
var sharp = "♯";
var shchcy = "щ";
var shcy = "ш";
var shortmid = "∣";
var shortparallel = "∥";
var sh = "­";
var shy = "­";
var sigma = "σ";
var sigmaf = "ς";
var sigmav = "ς";
var sim = "∼";
var simdot = "⩪";
var sime = "≃";
var simeq = "≃";
var simg = "⪞";
var simgE = "⪠";
var siml = "⪝";
var simlE = "⪟";
var simne = "≆";
var simplus = "⨤";
var simrarr = "⥲";
var slarr = "←";
var smallsetminus = "∖";
var smashp = "⨳";
var smeparsl = "⧤";
var smid = "∣";
var smile = "⌣";
var smt = "⪪";
var smte = "⪬";
var smtes = "⪬︀";
var softcy = "ь";
var sol = "/";
var solb = "⧄";
var solbar = "⌿";
var sopf = "𝕤";
var spades = "♠";
var spadesuit = "♠";
var spar = "∥";
var sqcap = "⊓";
var sqcaps = "⊓︀";
var sqcup = "⊔";
var sqcups = "⊔︀";
var sqsub = "⊏";
var sqsube = "⊑";
var sqsubset = "⊏";
var sqsubseteq = "⊑";
var sqsup = "⊐";
var sqsupe = "⊒";
var sqsupset = "⊐";
var sqsupseteq = "⊒";
var squ = "□";
var square = "□";
var squarf = "▪";
var squf = "▪";
var srarr = "→";
var sscr = "𝓈";
var ssetmn = "∖";
var ssmile = "⌣";
var sstarf = "⋆";
var star = "☆";
var starf = "★";
var straightepsilon = "ϵ";
var straightphi = "ϕ";
var strns = "¯";
var sub = "⊂";
var subE = "⫅";
var subdot = "⪽";
var sube = "⊆";
var subedot = "⫃";
var submult = "⫁";
var subnE = "⫋";
var subne = "⊊";
var subplus = "⪿";
var subrarr = "⥹";
var subset = "⊂";
var subseteq = "⊆";
var subseteqq = "⫅";
var subsetneq = "⊊";
var subsetneqq = "⫋";
var subsim = "⫇";
var subsub = "⫕";
var subsup = "⫓";
var succ = "≻";
var succapprox = "⪸";
var succcurlyeq = "≽";
var succeq = "⪰";
var succnapprox = "⪺";
var succneqq = "⪶";
var succnsim = "⋩";
var succsim = "≿";
var sum = "∑";
var sung = "♪";
var sup = "⊃";
var sup1 = "¹";
var sup2 = "²";
var sup3 = "³";
var supE = "⫆";
var supdot = "⪾";
var supdsub = "⫘";
var supe = "⊇";
var supedot = "⫄";
var suphsol = "⟉";
var suphsub = "⫗";
var suplarr = "⥻";
var supmult = "⫂";
var supnE = "⫌";
var supne = "⊋";
var supplus = "⫀";
var supset = "⊃";
var supseteq = "⊇";
var supseteqq = "⫆";
var supsetneq = "⊋";
var supsetneqq = "⫌";
var supsim = "⫈";
var supsub = "⫔";
var supsup = "⫖";
var swArr = "⇙";
var swarhk = "⤦";
var swarr = "↙";
var swarrow = "↙";
var swnwar = "⤪";
var szli = "ß";
var szlig = "ß";
var target = "⌖";
var tau = "τ";
var tbrk = "⎴";
var tcaron = "ť";
var tcedil = "ţ";
var tcy = "т";
var tdot = "⃛";
var telrec = "⌕";
var tfr = "𝔱";
var there4 = "∴";
var therefore = "∴";
var theta = "θ";
var thetasym = "ϑ";
var thetav = "ϑ";
var thickapprox = "≈";
var thicksim = "∼";
var thinsp = " ";
var thkap = "≈";
var thksim = "∼";
var thor = "þ";
var thorn = "þ";
var tilde = "˜";
var time = "×";
var times = "×";
var timesb = "⊠";
var timesbar = "⨱";
var timesd = "⨰";
var tint = "∭";
var toea = "⤨";
var top = "⊤";
var topbot = "⌶";
var topcir = "⫱";
var topf = "𝕥";
var topfork = "⫚";
var tosa = "⤩";
var tprime = "‴";
var trade = "™";
var triangle = "▵";
var triangledown = "▿";
var triangleleft = "◃";
var trianglelefteq = "⊴";
var triangleq = "≜";
var triangleright = "▹";
var trianglerighteq = "⊵";
var tridot = "◬";
var trie = "≜";
var triminus = "⨺";
var triplus = "⨹";
var trisb = "⧍";
var tritime = "⨻";
var trpezium = "⏢";
var tscr = "𝓉";
var tscy = "ц";
var tshcy = "ћ";
var tstrok = "ŧ";
var twixt = "≬";
var twoheadleftarrow = "↞";
var twoheadrightarrow = "↠";
var uArr = "⇑";
var uHar = "⥣";
var uacut = "ú";
var uacute = "ú";
var uarr = "↑";
var ubrcy = "ў";
var ubreve = "ŭ";
var ucir = "û";
var ucirc = "û";
var ucy = "у";
var udarr = "⇅";
var udblac = "ű";
var udhar = "⥮";
var ufisht = "⥾";
var ufr = "𝔲";
var ugrav = "ù";
var ugrave = "ù";
var uharl = "↿";
var uharr = "↾";
var uhblk = "▀";
var ulcorn = "⌜";
var ulcorner = "⌜";
var ulcrop = "⌏";
var ultri = "◸";
var umacr = "ū";
var um = "¨";
var uml = "¨";
var uogon = "ų";
var uopf = "𝕦";
var uparrow = "↑";
var updownarrow = "↕";
var upharpoonleft = "↿";
var upharpoonright = "↾";
var uplus = "⊎";
var upsi = "υ";
var upsih = "ϒ";
var upsilon = "υ";
var upuparrows = "⇈";
var urcorn = "⌝";
var urcorner = "⌝";
var urcrop = "⌎";
var uring = "ů";
var urtri = "◹";
var uscr = "𝓊";
var utdot = "⋰";
var utilde = "ũ";
var utri = "▵";
var utrif = "▴";
var uuarr = "⇈";
var uum = "ü";
var uuml = "ü";
var uwangle = "⦧";
var vArr = "⇕";
var vBar = "⫨";
var vBarv = "⫩";
var vDash = "⊨";
var vangrt = "⦜";
var varepsilon = "ϵ";
var varkappa = "ϰ";
var varnothing = "∅";
var varphi = "ϕ";
var varpi = "ϖ";
var varpropto = "∝";
var varr = "↕";
var varrho = "ϱ";
var varsigma = "ς";
var varsubsetneq = "⊊︀";
var varsubsetneqq = "⫋︀";
var varsupsetneq = "⊋︀";
var varsupsetneqq = "⫌︀";
var vartheta = "ϑ";
var vartriangleleft = "⊲";
var vartriangleright = "⊳";
var vcy = "в";
var vdash = "⊢";
var vee = "∨";
var veebar = "⊻";
var veeeq = "≚";
var vellip = "⋮";
var verbar = "|";
var vert = "|";
var vfr = "𝔳";
var vltri = "⊲";
var vnsub = "⊂⃒";
var vnsup = "⊃⃒";
var vopf = "𝕧";
var vprop = "∝";
var vrtri = "⊳";
var vscr = "𝓋";
var vsubnE = "⫋︀";
var vsubne = "⊊︀";
var vsupnE = "⫌︀";
var vsupne = "⊋︀";
var vzigzag = "⦚";
var wcirc = "ŵ";
var wedbar = "⩟";
var wedge = "∧";
var wedgeq = "≙";
var weierp = "℘";
var wfr = "𝔴";
var wopf = "𝕨";
var wp = "℘";
var wr = "≀";
var wreath = "≀";
var wscr = "𝓌";
var xcap = "⋂";
var xcirc = "◯";
var xcup = "⋃";
var xdtri = "▽";
var xfr = "𝔵";
var xhArr = "⟺";
var xharr = "⟷";
var xi = "ξ";
var xlArr = "⟸";
var xlarr = "⟵";
var xmap = "⟼";
var xnis = "⋻";
var xodot = "⨀";
var xopf = "𝕩";
var xoplus = "⨁";
var xotime = "⨂";
var xrArr = "⟹";
var xrarr = "⟶";
var xscr = "𝓍";
var xsqcup = "⨆";
var xuplus = "⨄";
var xutri = "△";
var xvee = "⋁";
var xwedge = "⋀";
var yacut = "ý";
var yacute = "ý";
var yacy = "я";
var ycirc = "ŷ";
var ycy = "ы";
var ye = "¥";
var yen = "¥";
var yfr = "𝔶";
var yicy = "ї";
var yopf = "𝕪";
var yscr = "𝓎";
var yucy = "ю";
var yum = "ÿ";
var yuml = "ÿ";
var zacute = "ź";
var zcaron = "ž";
var zcy = "з";
var zdot = "ż";
var zeetrf = "ℨ";
var zeta = "ζ";
var zfr = "𝔷";
var zhcy = "ж";
var zigrarr = "⇝";
var zopf = "𝕫";
var zscr = "𝓏";
var zwj = "‍";
var zwnj = "‌";
var require$$0 = {
	AEli: AEli,
	AElig: AElig,
	AM: AM,
	AMP: AMP,
	Aacut: Aacut,
	Aacute: Aacute,
	Abreve: Abreve,
	Acir: Acir,
	Acirc: Acirc,
	Acy: Acy,
	Afr: Afr,
	Agrav: Agrav,
	Agrave: Agrave,
	Alpha: Alpha,
	Amacr: Amacr,
	And: And,
	Aogon: Aogon,
	Aopf: Aopf,
	ApplyFunction: ApplyFunction,
	Arin: Arin,
	Aring: Aring,
	Ascr: Ascr,
	Assign: Assign,
	Atild: Atild,
	Atilde: Atilde,
	Aum: Aum,
	Auml: Auml,
	Backslash: Backslash,
	Barv: Barv,
	Barwed: Barwed,
	Bcy: Bcy,
	Because: Because,
	Bernoullis: Bernoullis,
	Beta: Beta,
	Bfr: Bfr,
	Bopf: Bopf,
	Breve: Breve,
	Bscr: Bscr,
	Bumpeq: Bumpeq,
	CHcy: CHcy,
	COP: COP,
	COPY: COPY,
	Cacute: Cacute,
	Cap: Cap,
	CapitalDifferentialD: CapitalDifferentialD,
	Cayleys: Cayleys,
	Ccaron: Ccaron,
	Ccedi: Ccedi,
	Ccedil: Ccedil,
	Ccirc: Ccirc,
	Cconint: Cconint,
	Cdot: Cdot,
	Cedilla: Cedilla,
	CenterDot: CenterDot,
	Cfr: Cfr,
	Chi: Chi,
	CircleDot: CircleDot,
	CircleMinus: CircleMinus,
	CirclePlus: CirclePlus,
	CircleTimes: CircleTimes,
	ClockwiseContourIntegral: ClockwiseContourIntegral,
	CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
	CloseCurlyQuote: CloseCurlyQuote,
	Colon: Colon,
	Colone: Colone,
	Congruent: Congruent,
	Conint: Conint,
	ContourIntegral: ContourIntegral,
	Copf: Copf,
	Coproduct: Coproduct,
	CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
	Cross: Cross,
	Cscr: Cscr,
	Cup: Cup,
	CupCap: CupCap,
	DD: DD,
	DDotrahd: DDotrahd,
	DJcy: DJcy,
	DScy: DScy,
	DZcy: DZcy,
	Dagger: Dagger,
	Darr: Darr,
	Dashv: Dashv,
	Dcaron: Dcaron,
	Dcy: Dcy,
	Del: Del,
	Delta: Delta,
	Dfr: Dfr,
	DiacriticalAcute: DiacriticalAcute,
	DiacriticalDot: DiacriticalDot,
	DiacriticalDoubleAcute: DiacriticalDoubleAcute,
	DiacriticalGrave: DiacriticalGrave,
	DiacriticalTilde: DiacriticalTilde,
	Diamond: Diamond,
	DifferentialD: DifferentialD,
	Dopf: Dopf,
	Dot: Dot,
	DotDot: DotDot,
	DotEqual: DotEqual,
	DoubleContourIntegral: DoubleContourIntegral,
	DoubleDot: DoubleDot,
	DoubleDownArrow: DoubleDownArrow,
	DoubleLeftArrow: DoubleLeftArrow,
	DoubleLeftRightArrow: DoubleLeftRightArrow,
	DoubleLeftTee: DoubleLeftTee,
	DoubleLongLeftArrow: DoubleLongLeftArrow,
	DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
	DoubleLongRightArrow: DoubleLongRightArrow,
	DoubleRightArrow: DoubleRightArrow,
	DoubleRightTee: DoubleRightTee,
	DoubleUpArrow: DoubleUpArrow,
	DoubleUpDownArrow: DoubleUpDownArrow,
	DoubleVerticalBar: DoubleVerticalBar,
	DownArrow: DownArrow,
	DownArrowBar: DownArrowBar,
	DownArrowUpArrow: DownArrowUpArrow,
	DownBreve: DownBreve,
	DownLeftRightVector: DownLeftRightVector,
	DownLeftTeeVector: DownLeftTeeVector,
	DownLeftVector: DownLeftVector,
	DownLeftVectorBar: DownLeftVectorBar,
	DownRightTeeVector: DownRightTeeVector,
	DownRightVector: DownRightVector,
	DownRightVectorBar: DownRightVectorBar,
	DownTee: DownTee,
	DownTeeArrow: DownTeeArrow,
	Downarrow: Downarrow,
	Dscr: Dscr,
	Dstrok: Dstrok,
	ENG: ENG,
	ET: ET,
	ETH: ETH,
	Eacut: Eacut,
	Eacute: Eacute,
	Ecaron: Ecaron,
	Ecir: Ecir,
	Ecirc: Ecirc,
	Ecy: Ecy,
	Edot: Edot,
	Efr: Efr,
	Egrav: Egrav,
	Egrave: Egrave,
	Element: Element$2,
	Emacr: Emacr,
	EmptySmallSquare: EmptySmallSquare,
	EmptyVerySmallSquare: EmptyVerySmallSquare,
	Eogon: Eogon,
	Eopf: Eopf,
	Epsilon: Epsilon,
	Equal: Equal,
	EqualTilde: EqualTilde,
	Equilibrium: Equilibrium,
	Escr: Escr,
	Esim: Esim,
	Eta: Eta,
	Eum: Eum,
	Euml: Euml,
	Exists: Exists,
	ExponentialE: ExponentialE,
	Fcy: Fcy,
	Ffr: Ffr,
	FilledSmallSquare: FilledSmallSquare,
	FilledVerySmallSquare: FilledVerySmallSquare,
	Fopf: Fopf,
	ForAll: ForAll,
	Fouriertrf: Fouriertrf,
	Fscr: Fscr,
	GJcy: GJcy,
	G: G,
	GT: GT,
	Gamma: Gamma,
	Gammad: Gammad,
	Gbreve: Gbreve,
	Gcedil: Gcedil,
	Gcirc: Gcirc,
	Gcy: Gcy,
	Gdot: Gdot,
	Gfr: Gfr,
	Gg: Gg,
	Gopf: Gopf,
	GreaterEqual: GreaterEqual,
	GreaterEqualLess: GreaterEqualLess,
	GreaterFullEqual: GreaterFullEqual,
	GreaterGreater: GreaterGreater,
	GreaterLess: GreaterLess,
	GreaterSlantEqual: GreaterSlantEqual,
	GreaterTilde: GreaterTilde,
	Gscr: Gscr,
	Gt: Gt,
	HARDcy: HARDcy,
	Hacek: Hacek,
	Hat: Hat,
	Hcirc: Hcirc,
	Hfr: Hfr,
	HilbertSpace: HilbertSpace,
	Hopf: Hopf,
	HorizontalLine: HorizontalLine,
	Hscr: Hscr,
	Hstrok: Hstrok,
	HumpDownHump: HumpDownHump,
	HumpEqual: HumpEqual,
	IEcy: IEcy,
	IJlig: IJlig,
	IOcy: IOcy,
	Iacut: Iacut,
	Iacute: Iacute,
	Icir: Icir,
	Icirc: Icirc,
	Icy: Icy,
	Idot: Idot,
	Ifr: Ifr,
	Igrav: Igrav,
	Igrave: Igrave,
	Im: Im,
	Imacr: Imacr,
	ImaginaryI: ImaginaryI,
	Implies: Implies,
	Int: Int,
	Integral: Integral,
	Intersection: Intersection,
	InvisibleComma: InvisibleComma,
	InvisibleTimes: InvisibleTimes,
	Iogon: Iogon,
	Iopf: Iopf,
	Iota: Iota,
	Iscr: Iscr,
	Itilde: Itilde,
	Iukcy: Iukcy,
	Ium: Ium,
	Iuml: Iuml,
	Jcirc: Jcirc,
	Jcy: Jcy,
	Jfr: Jfr,
	Jopf: Jopf,
	Jscr: Jscr,
	Jsercy: Jsercy,
	Jukcy: Jukcy,
	KHcy: KHcy,
	KJcy: KJcy,
	Kappa: Kappa,
	Kcedil: Kcedil,
	Kcy: Kcy,
	Kfr: Kfr,
	Kopf: Kopf,
	Kscr: Kscr,
	LJcy: LJcy,
	L: L,
	LT: LT,
	Lacute: Lacute,
	Lambda: Lambda,
	Lang: Lang,
	Laplacetrf: Laplacetrf,
	Larr: Larr,
	Lcaron: Lcaron,
	Lcedil: Lcedil,
	Lcy: Lcy,
	LeftAngleBracket: LeftAngleBracket,
	LeftArrow: LeftArrow,
	LeftArrowBar: LeftArrowBar,
	LeftArrowRightArrow: LeftArrowRightArrow,
	LeftCeiling: LeftCeiling,
	LeftDoubleBracket: LeftDoubleBracket,
	LeftDownTeeVector: LeftDownTeeVector,
	LeftDownVector: LeftDownVector,
	LeftDownVectorBar: LeftDownVectorBar,
	LeftFloor: LeftFloor,
	LeftRightArrow: LeftRightArrow,
	LeftRightVector: LeftRightVector,
	LeftTee: LeftTee,
	LeftTeeArrow: LeftTeeArrow,
	LeftTeeVector: LeftTeeVector,
	LeftTriangle: LeftTriangle,
	LeftTriangleBar: LeftTriangleBar,
	LeftTriangleEqual: LeftTriangleEqual,
	LeftUpDownVector: LeftUpDownVector,
	LeftUpTeeVector: LeftUpTeeVector,
	LeftUpVector: LeftUpVector,
	LeftUpVectorBar: LeftUpVectorBar,
	LeftVector: LeftVector,
	LeftVectorBar: LeftVectorBar,
	Leftarrow: Leftarrow,
	Leftrightarrow: Leftrightarrow,
	LessEqualGreater: LessEqualGreater,
	LessFullEqual: LessFullEqual,
	LessGreater: LessGreater,
	LessLess: LessLess,
	LessSlantEqual: LessSlantEqual,
	LessTilde: LessTilde,
	Lfr: Lfr,
	Ll: Ll,
	Lleftarrow: Lleftarrow,
	Lmidot: Lmidot,
	LongLeftArrow: LongLeftArrow,
	LongLeftRightArrow: LongLeftRightArrow,
	LongRightArrow: LongRightArrow,
	Longleftarrow: Longleftarrow,
	Longleftrightarrow: Longleftrightarrow,
	Longrightarrow: Longrightarrow,
	Lopf: Lopf,
	LowerLeftArrow: LowerLeftArrow,
	LowerRightArrow: LowerRightArrow,
	Lscr: Lscr,
	Lsh: Lsh,
	Lstrok: Lstrok,
	Lt: Lt,
	"Map": "⤅",
	Mcy: Mcy,
	MediumSpace: MediumSpace,
	Mellintrf: Mellintrf,
	Mfr: Mfr,
	MinusPlus: MinusPlus,
	Mopf: Mopf,
	Mscr: Mscr,
	Mu: Mu,
	NJcy: NJcy,
	Nacute: Nacute,
	Ncaron: Ncaron,
	Ncedil: Ncedil,
	Ncy: Ncy,
	NegativeMediumSpace: NegativeMediumSpace,
	NegativeThickSpace: NegativeThickSpace,
	NegativeThinSpace: NegativeThinSpace,
	NegativeVeryThinSpace: NegativeVeryThinSpace,
	NestedGreaterGreater: NestedGreaterGreater,
	NestedLessLess: NestedLessLess,
	NewLine: NewLine,
	Nfr: Nfr,
	NoBreak: NoBreak,
	NonBreakingSpace: NonBreakingSpace,
	Nopf: Nopf,
	Not: Not,
	NotCongruent: NotCongruent,
	NotCupCap: NotCupCap,
	NotDoubleVerticalBar: NotDoubleVerticalBar,
	NotElement: NotElement,
	NotEqual: NotEqual,
	NotEqualTilde: NotEqualTilde,
	NotExists: NotExists,
	NotGreater: NotGreater,
	NotGreaterEqual: NotGreaterEqual,
	NotGreaterFullEqual: NotGreaterFullEqual,
	NotGreaterGreater: NotGreaterGreater,
	NotGreaterLess: NotGreaterLess,
	NotGreaterSlantEqual: NotGreaterSlantEqual,
	NotGreaterTilde: NotGreaterTilde,
	NotHumpDownHump: NotHumpDownHump,
	NotHumpEqual: NotHumpEqual,
	NotLeftTriangle: NotLeftTriangle,
	NotLeftTriangleBar: NotLeftTriangleBar,
	NotLeftTriangleEqual: NotLeftTriangleEqual,
	NotLess: NotLess,
	NotLessEqual: NotLessEqual,
	NotLessGreater: NotLessGreater,
	NotLessLess: NotLessLess,
	NotLessSlantEqual: NotLessSlantEqual,
	NotLessTilde: NotLessTilde,
	NotNestedGreaterGreater: NotNestedGreaterGreater,
	NotNestedLessLess: NotNestedLessLess,
	NotPrecedes: NotPrecedes,
	NotPrecedesEqual: NotPrecedesEqual,
	NotPrecedesSlantEqual: NotPrecedesSlantEqual,
	NotReverseElement: NotReverseElement,
	NotRightTriangle: NotRightTriangle,
	NotRightTriangleBar: NotRightTriangleBar,
	NotRightTriangleEqual: NotRightTriangleEqual,
	NotSquareSubset: NotSquareSubset,
	NotSquareSubsetEqual: NotSquareSubsetEqual,
	NotSquareSuperset: NotSquareSuperset,
	NotSquareSupersetEqual: NotSquareSupersetEqual,
	NotSubset: NotSubset,
	NotSubsetEqual: NotSubsetEqual,
	NotSucceeds: NotSucceeds,
	NotSucceedsEqual: NotSucceedsEqual,
	NotSucceedsSlantEqual: NotSucceedsSlantEqual,
	NotSucceedsTilde: NotSucceedsTilde,
	NotSuperset: NotSuperset,
	NotSupersetEqual: NotSupersetEqual,
	NotTilde: NotTilde,
	NotTildeEqual: NotTildeEqual,
	NotTildeFullEqual: NotTildeFullEqual,
	NotTildeTilde: NotTildeTilde,
	NotVerticalBar: NotVerticalBar,
	Nscr: Nscr,
	Ntild: Ntild,
	Ntilde: Ntilde,
	Nu: Nu,
	OElig: OElig,
	Oacut: Oacut,
	Oacute: Oacute,
	Ocir: Ocir,
	Ocirc: Ocirc,
	Ocy: Ocy,
	Odblac: Odblac,
	Ofr: Ofr,
	Ograv: Ograv,
	Ograve: Ograve,
	Omacr: Omacr,
	Omega: Omega,
	Omicron: Omicron,
	Oopf: Oopf,
	OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
	OpenCurlyQuote: OpenCurlyQuote,
	Or: Or,
	Oscr: Oscr,
	Oslas: Oslas,
	Oslash: Oslash,
	Otild: Otild,
	Otilde: Otilde,
	Otimes: Otimes,
	Oum: Oum,
	Ouml: Ouml,
	OverBar: OverBar,
	OverBrace: OverBrace,
	OverBracket: OverBracket,
	OverParenthesis: OverParenthesis,
	PartialD: PartialD,
	Pcy: Pcy,
	Pfr: Pfr,
	Phi: Phi,
	Pi: Pi,
	PlusMinus: PlusMinus,
	Poincareplane: Poincareplane,
	Popf: Popf,
	Pr: Pr,
	Precedes: Precedes,
	PrecedesEqual: PrecedesEqual,
	PrecedesSlantEqual: PrecedesSlantEqual,
	PrecedesTilde: PrecedesTilde,
	Prime: Prime,
	Product: Product,
	Proportion: Proportion,
	Proportional: Proportional,
	Pscr: Pscr,
	Psi: Psi,
	QUO: QUO,
	QUOT: QUOT,
	Qfr: Qfr,
	Qopf: Qopf,
	Qscr: Qscr,
	RBarr: RBarr,
	RE: RE,
	REG: REG,
	Racute: Racute,
	Rang: Rang,
	Rarr: Rarr,
	Rarrtl: Rarrtl,
	Rcaron: Rcaron,
	Rcedil: Rcedil,
	Rcy: Rcy,
	Re: Re,
	ReverseElement: ReverseElement,
	ReverseEquilibrium: ReverseEquilibrium,
	ReverseUpEquilibrium: ReverseUpEquilibrium,
	Rfr: Rfr,
	Rho: Rho,
	RightAngleBracket: RightAngleBracket,
	RightArrow: RightArrow,
	RightArrowBar: RightArrowBar,
	RightArrowLeftArrow: RightArrowLeftArrow,
	RightCeiling: RightCeiling,
	RightDoubleBracket: RightDoubleBracket,
	RightDownTeeVector: RightDownTeeVector,
	RightDownVector: RightDownVector,
	RightDownVectorBar: RightDownVectorBar,
	RightFloor: RightFloor,
	RightTee: RightTee,
	RightTeeArrow: RightTeeArrow,
	RightTeeVector: RightTeeVector,
	RightTriangle: RightTriangle,
	RightTriangleBar: RightTriangleBar,
	RightTriangleEqual: RightTriangleEqual,
	RightUpDownVector: RightUpDownVector,
	RightUpTeeVector: RightUpTeeVector,
	RightUpVector: RightUpVector,
	RightUpVectorBar: RightUpVectorBar,
	RightVector: RightVector,
	RightVectorBar: RightVectorBar,
	Rightarrow: Rightarrow,
	Ropf: Ropf,
	RoundImplies: RoundImplies,
	Rrightarrow: Rrightarrow,
	Rscr: Rscr,
	Rsh: Rsh,
	RuleDelayed: RuleDelayed,
	SHCHcy: SHCHcy,
	SHcy: SHcy,
	SOFTcy: SOFTcy,
	Sacute: Sacute,
	Sc: Sc,
	Scaron: Scaron,
	Scedil: Scedil,
	Scirc: Scirc,
	Scy: Scy,
	Sfr: Sfr,
	ShortDownArrow: ShortDownArrow,
	ShortLeftArrow: ShortLeftArrow,
	ShortRightArrow: ShortRightArrow,
	ShortUpArrow: ShortUpArrow,
	Sigma: Sigma,
	SmallCircle: SmallCircle,
	Sopf: Sopf,
	Sqrt: Sqrt,
	Square: Square,
	SquareIntersection: SquareIntersection,
	SquareSubset: SquareSubset,
	SquareSubsetEqual: SquareSubsetEqual,
	SquareSuperset: SquareSuperset,
	SquareSupersetEqual: SquareSupersetEqual,
	SquareUnion: SquareUnion,
	Sscr: Sscr,
	Star: Star,
	Sub: Sub,
	Subset: Subset,
	SubsetEqual: SubsetEqual,
	Succeeds: Succeeds,
	SucceedsEqual: SucceedsEqual,
	SucceedsSlantEqual: SucceedsSlantEqual,
	SucceedsTilde: SucceedsTilde,
	SuchThat: SuchThat,
	Sum: Sum,
	Sup: Sup,
	Superset: Superset,
	SupersetEqual: SupersetEqual,
	Supset: Supset,
	THOR: THOR,
	THORN: THORN,
	TRADE: TRADE,
	TSHcy: TSHcy,
	TScy: TScy,
	Tab: Tab,
	Tau: Tau,
	Tcaron: Tcaron,
	Tcedil: Tcedil,
	Tcy: Tcy,
	Tfr: Tfr,
	Therefore: Therefore,
	Theta: Theta,
	ThickSpace: ThickSpace,
	ThinSpace: ThinSpace,
	Tilde: Tilde,
	TildeEqual: TildeEqual,
	TildeFullEqual: TildeFullEqual,
	TildeTilde: TildeTilde,
	Topf: Topf,
	TripleDot: TripleDot,
	Tscr: Tscr,
	Tstrok: Tstrok,
	Uacut: Uacut,
	Uacute: Uacute,
	Uarr: Uarr,
	Uarrocir: Uarrocir,
	Ubrcy: Ubrcy,
	Ubreve: Ubreve,
	Ucir: Ucir,
	Ucirc: Ucirc,
	Ucy: Ucy,
	Udblac: Udblac,
	Ufr: Ufr,
	Ugrav: Ugrav,
	Ugrave: Ugrave,
	Umacr: Umacr,
	UnderBar: UnderBar,
	UnderBrace: UnderBrace,
	UnderBracket: UnderBracket,
	UnderParenthesis: UnderParenthesis,
	Union: Union,
	UnionPlus: UnionPlus,
	Uogon: Uogon,
	Uopf: Uopf,
	UpArrow: UpArrow,
	UpArrowBar: UpArrowBar,
	UpArrowDownArrow: UpArrowDownArrow,
	UpDownArrow: UpDownArrow,
	UpEquilibrium: UpEquilibrium,
	UpTee: UpTee,
	UpTeeArrow: UpTeeArrow,
	Uparrow: Uparrow,
	Updownarrow: Updownarrow,
	UpperLeftArrow: UpperLeftArrow,
	UpperRightArrow: UpperRightArrow,
	Upsi: Upsi,
	Upsilon: Upsilon,
	Uring: Uring,
	Uscr: Uscr,
	Utilde: Utilde,
	Uum: Uum,
	Uuml: Uuml,
	VDash: VDash,
	Vbar: Vbar,
	Vcy: Vcy,
	Vdash: Vdash,
	Vdashl: Vdashl,
	Vee: Vee,
	Verbar: Verbar,
	Vert: Vert,
	VerticalBar: VerticalBar,
	VerticalLine: VerticalLine,
	VerticalSeparator: VerticalSeparator,
	VerticalTilde: VerticalTilde,
	VeryThinSpace: VeryThinSpace,
	Vfr: Vfr,
	Vopf: Vopf,
	Vscr: Vscr,
	Vvdash: Vvdash,
	Wcirc: Wcirc,
	Wedge: Wedge,
	Wfr: Wfr,
	Wopf: Wopf,
	Wscr: Wscr,
	Xfr: Xfr,
	Xi: Xi,
	Xopf: Xopf,
	Xscr: Xscr,
	YAcy: YAcy,
	YIcy: YIcy,
	YUcy: YUcy,
	Yacut: Yacut,
	Yacute: Yacute,
	Ycirc: Ycirc,
	Ycy: Ycy,
	Yfr: Yfr,
	Yopf: Yopf,
	Yscr: Yscr,
	Yuml: Yuml,
	ZHcy: ZHcy,
	Zacute: Zacute,
	Zcaron: Zcaron,
	Zcy: Zcy,
	Zdot: Zdot,
	ZeroWidthSpace: ZeroWidthSpace,
	Zeta: Zeta,
	Zfr: Zfr,
	Zopf: Zopf,
	Zscr: Zscr,
	aacut: aacut,
	aacute: aacute,
	abreve: abreve,
	ac: ac,
	acE: acE,
	acd: acd,
	acir: acir,
	acirc: acirc,
	acut: acut,
	acute: acute,
	acy: acy,
	aeli: aeli,
	aelig: aelig,
	af: af,
	afr: afr,
	agrav: agrav,
	agrave: agrave,
	alefsym: alefsym,
	aleph: aleph,
	alpha: alpha$1,
	amacr: amacr,
	amalg: amalg,
	am: am,
	amp: amp,
	and: and,
	andand: andand,
	andd: andd,
	andslope: andslope,
	andv: andv,
	ang: ang,
	ange: ange,
	angle: angle,
	angmsd: angmsd,
	angmsdaa: angmsdaa,
	angmsdab: angmsdab,
	angmsdac: angmsdac,
	angmsdad: angmsdad,
	angmsdae: angmsdae,
	angmsdaf: angmsdaf,
	angmsdag: angmsdag,
	angmsdah: angmsdah,
	angrt: angrt,
	angrtvb: angrtvb,
	angrtvbd: angrtvbd,
	angsph: angsph,
	angst: angst,
	angzarr: angzarr,
	aogon: aogon,
	aopf: aopf,
	ap: ap,
	apE: apE,
	apacir: apacir,
	ape: ape,
	apid: apid,
	apos: apos,
	approx: approx,
	approxeq: approxeq,
	arin: arin,
	aring: aring,
	ascr: ascr,
	ast: ast,
	asymp: asymp,
	asympeq: asympeq,
	atild: atild,
	atilde: atilde,
	aum: aum,
	auml: auml,
	awconint: awconint,
	awint: awint,
	bNot: bNot,
	backcong: backcong,
	backepsilon: backepsilon,
	backprime: backprime,
	backsim: backsim,
	backsimeq: backsimeq,
	barvee: barvee,
	barwed: barwed,
	barwedge: barwedge,
	bbrk: bbrk,
	bbrktbrk: bbrktbrk,
	bcong: bcong,
	bcy: bcy,
	bdquo: bdquo,
	becaus: becaus,
	because: because,
	bemptyv: bemptyv,
	bepsi: bepsi,
	bernou: bernou,
	beta: beta,
	beth: beth,
	between: between,
	bfr: bfr,
	bigcap: bigcap,
	bigcirc: bigcirc,
	bigcup: bigcup,
	bigodot: bigodot,
	bigoplus: bigoplus,
	bigotimes: bigotimes,
	bigsqcup: bigsqcup,
	bigstar: bigstar,
	bigtriangledown: bigtriangledown,
	bigtriangleup: bigtriangleup,
	biguplus: biguplus,
	bigvee: bigvee,
	bigwedge: bigwedge,
	bkarow: bkarow,
	blacklozenge: blacklozenge,
	blacksquare: blacksquare,
	blacktriangle: blacktriangle,
	blacktriangledown: blacktriangledown,
	blacktriangleleft: blacktriangleleft,
	blacktriangleright: blacktriangleright,
	blank: blank,
	blk12: blk12,
	blk14: blk14,
	blk34: blk34,
	block: block,
	bne: bne,
	bnequiv: bnequiv,
	bnot: bnot,
	bopf: bopf,
	bot: bot,
	bottom: bottom,
	bowtie: bowtie,
	boxDL: boxDL,
	boxDR: boxDR,
	boxDl: boxDl,
	boxDr: boxDr,
	boxH: boxH,
	boxHD: boxHD,
	boxHU: boxHU,
	boxHd: boxHd,
	boxHu: boxHu,
	boxUL: boxUL,
	boxUR: boxUR,
	boxUl: boxUl,
	boxUr: boxUr,
	boxV: boxV,
	boxVH: boxVH,
	boxVL: boxVL,
	boxVR: boxVR,
	boxVh: boxVh,
	boxVl: boxVl,
	boxVr: boxVr,
	boxbox: boxbox,
	boxdL: boxdL,
	boxdR: boxdR,
	boxdl: boxdl,
	boxdr: boxdr,
	boxh: boxh,
	boxhD: boxhD,
	boxhU: boxhU,
	boxhd: boxhd,
	boxhu: boxhu,
	boxminus: boxminus,
	boxplus: boxplus,
	boxtimes: boxtimes,
	boxuL: boxuL,
	boxuR: boxuR,
	boxul: boxul,
	boxur: boxur,
	boxv: boxv,
	boxvH: boxvH,
	boxvL: boxvL,
	boxvR: boxvR,
	boxvh: boxvh,
	boxvl: boxvl,
	boxvr: boxvr,
	bprime: bprime,
	breve: breve,
	brvba: brvba,
	brvbar: brvbar,
	bscr: bscr,
	bsemi: bsemi,
	bsim: bsim,
	bsime: bsime,
	bsol: bsol,
	bsolb: bsolb,
	bsolhsub: bsolhsub,
	bull: bull,
	bullet: bullet,
	bump: bump,
	bumpE: bumpE,
	bumpe: bumpe,
	bumpeq: bumpeq,
	cacute: cacute,
	cap: cap,
	capand: capand,
	capbrcup: capbrcup,
	capcap: capcap,
	capcup: capcup,
	capdot: capdot,
	caps: caps,
	caret: caret,
	caron: caron,
	ccaps: ccaps,
	ccaron: ccaron,
	ccedi: ccedi,
	ccedil: ccedil,
	ccirc: ccirc,
	ccups: ccups,
	ccupssm: ccupssm,
	cdot: cdot,
	cedi: cedi,
	cedil: cedil,
	cemptyv: cemptyv,
	cen: cen,
	cent: cent,
	centerdot: centerdot,
	cfr: cfr,
	chcy: chcy,
	check: check,
	checkmark: checkmark,
	chi: chi,
	cir: cir,
	cirE: cirE,
	circ: circ,
	circeq: circeq,
	circlearrowleft: circlearrowleft,
	circlearrowright: circlearrowright,
	circledR: circledR,
	circledS: circledS,
	circledast: circledast,
	circledcirc: circledcirc,
	circleddash: circleddash,
	cire: cire,
	cirfnint: cirfnint,
	cirmid: cirmid,
	cirscir: cirscir,
	clubs: clubs,
	clubsuit: clubsuit,
	colon: colon,
	colone: colone,
	coloneq: coloneq,
	comma: comma,
	commat: commat,
	comp: comp,
	compfn: compfn,
	complement: complement,
	complexes: complexes,
	cong: cong,
	congdot: congdot,
	conint: conint,
	copf: copf,
	coprod: coprod,
	cop: cop,
	copy: copy,
	copysr: copysr,
	crarr: crarr,
	cross: cross,
	cscr: cscr,
	csub: csub,
	csube: csube,
	csup: csup,
	csupe: csupe,
	ctdot: ctdot,
	cudarrl: cudarrl,
	cudarrr: cudarrr,
	cuepr: cuepr,
	cuesc: cuesc,
	cularr: cularr,
	cularrp: cularrp,
	cup: cup,
	cupbrcap: cupbrcap,
	cupcap: cupcap,
	cupcup: cupcup,
	cupdot: cupdot,
	cupor: cupor,
	cups: cups,
	curarr: curarr,
	curarrm: curarrm,
	curlyeqprec: curlyeqprec,
	curlyeqsucc: curlyeqsucc,
	curlyvee: curlyvee,
	curlywedge: curlywedge,
	curre: curre,
	curren: curren,
	curvearrowleft: curvearrowleft,
	curvearrowright: curvearrowright,
	cuvee: cuvee,
	cuwed: cuwed,
	cwconint: cwconint,
	cwint: cwint,
	cylcty: cylcty,
	dArr: dArr,
	dHar: dHar,
	dagger: dagger,
	daleth: daleth,
	darr: darr,
	dash: dash,
	dashv: dashv,
	dbkarow: dbkarow,
	dblac: dblac,
	dcaron: dcaron,
	dcy: dcy,
	dd: dd,
	ddagger: ddagger,
	ddarr: ddarr,
	ddotseq: ddotseq,
	de: de,
	deg: deg,
	delta: delta,
	demptyv: demptyv,
	dfisht: dfisht,
	dfr: dfr,
	dharl: dharl,
	dharr: dharr,
	diam: diam,
	diamond: diamond,
	diamondsuit: diamondsuit,
	diams: diams,
	die: die,
	digamma: digamma,
	disin: disin,
	div: div,
	divid: divid,
	divide: divide,
	divideontimes: divideontimes,
	divonx: divonx,
	djcy: djcy,
	dlcorn: dlcorn,
	dlcrop: dlcrop,
	dollar: dollar,
	dopf: dopf,
	dot: dot,
	doteq: doteq,
	doteqdot: doteqdot,
	dotminus: dotminus,
	dotplus: dotplus,
	dotsquare: dotsquare,
	doublebarwedge: doublebarwedge,
	downarrow: downarrow,
	downdownarrows: downdownarrows,
	downharpoonleft: downharpoonleft,
	downharpoonright: downharpoonright,
	drbkarow: drbkarow,
	drcorn: drcorn,
	drcrop: drcrop,
	dscr: dscr,
	dscy: dscy,
	dsol: dsol,
	dstrok: dstrok,
	dtdot: dtdot,
	dtri: dtri,
	dtrif: dtrif,
	duarr: duarr,
	duhar: duhar,
	dwangle: dwangle,
	dzcy: dzcy,
	dzigrarr: dzigrarr,
	eDDot: eDDot,
	eDot: eDot,
	eacut: eacut,
	eacute: eacute,
	easter: easter,
	ecaron: ecaron,
	ecir: ecir,
	ecirc: ecirc,
	ecolon: ecolon,
	ecy: ecy,
	edot: edot,
	ee: ee,
	efDot: efDot,
	efr: efr,
	eg: eg,
	egrav: egrav,
	egrave: egrave,
	egs: egs,
	egsdot: egsdot,
	el: el,
	elinters: elinters,
	ell: ell,
	els: els,
	elsdot: elsdot,
	emacr: emacr,
	empty: empty,
	emptyset: emptyset,
	emptyv: emptyv,
	emsp13: emsp13,
	emsp14: emsp14,
	emsp: emsp,
	eng: eng,
	ensp: ensp,
	eogon: eogon,
	eopf: eopf,
	epar: epar,
	eparsl: eparsl,
	eplus: eplus,
	epsi: epsi,
	epsilon: epsilon,
	epsiv: epsiv,
	eqcirc: eqcirc,
	eqcolon: eqcolon,
	eqsim: eqsim,
	eqslantgtr: eqslantgtr,
	eqslantless: eqslantless,
	equals: equals,
	equest: equest,
	equiv: equiv,
	equivDD: equivDD,
	eqvparsl: eqvparsl,
	erDot: erDot,
	erarr: erarr,
	escr: escr,
	esdot: esdot,
	esim: esim,
	eta: eta,
	et: et,
	eth: eth,
	eum: eum,
	euml: euml,
	euro: euro,
	excl: excl,
	exist: exist,
	expectation: expectation,
	exponentiale: exponentiale,
	fallingdotseq: fallingdotseq,
	fcy: fcy,
	female: female,
	ffilig: ffilig,
	fflig: fflig,
	ffllig: ffllig,
	ffr: ffr,
	filig: filig,
	fjlig: fjlig,
	flat: flat,
	fllig: fllig,
	fltns: fltns,
	fnof: fnof,
	fopf: fopf,
	forall: forall,
	fork: fork,
	forkv: forkv,
	fpartint: fpartint,
	frac1: frac1,
	frac12: frac12,
	frac13: frac13,
	frac14: frac14,
	frac15: frac15,
	frac16: frac16,
	frac18: frac18,
	frac23: frac23,
	frac25: frac25,
	frac3: frac3,
	frac34: frac34,
	frac35: frac35,
	frac38: frac38,
	frac45: frac45,
	frac56: frac56,
	frac58: frac58,
	frac78: frac78,
	frasl: frasl,
	frown: frown,
	fscr: fscr,
	gE: gE,
	gEl: gEl,
	gacute: gacute,
	gamma: gamma,
	gammad: gammad,
	gap: gap,
	gbreve: gbreve,
	gcirc: gcirc,
	gcy: gcy,
	gdot: gdot,
	ge: ge,
	gel: gel,
	geq: geq,
	geqq: geqq,
	geqslant: geqslant,
	ges: ges,
	gescc: gescc,
	gesdot: gesdot,
	gesdoto: gesdoto,
	gesdotol: gesdotol,
	gesl: gesl,
	gesles: gesles,
	gfr: gfr,
	gg: gg,
	ggg: ggg,
	gimel: gimel,
	gjcy: gjcy,
	gl: gl,
	glE: glE,
	gla: gla,
	glj: glj,
	gnE: gnE,
	gnap: gnap,
	gnapprox: gnapprox,
	gne: gne,
	gneq: gneq,
	gneqq: gneqq,
	gnsim: gnsim,
	gopf: gopf,
	grave: grave,
	gscr: gscr,
	gsim: gsim,
	gsime: gsime,
	gsiml: gsiml,
	g: g,
	gt: gt,
	gtcc: gtcc,
	gtcir: gtcir,
	gtdot: gtdot,
	gtlPar: gtlPar,
	gtquest: gtquest,
	gtrapprox: gtrapprox,
	gtrarr: gtrarr,
	gtrdot: gtrdot,
	gtreqless: gtreqless,
	gtreqqless: gtreqqless,
	gtrless: gtrless,
	gtrsim: gtrsim,
	gvertneqq: gvertneqq,
	gvnE: gvnE,
	hArr: hArr,
	hairsp: hairsp,
	half: half,
	hamilt: hamilt,
	hardcy: hardcy,
	harr: harr,
	harrcir: harrcir,
	harrw: harrw,
	hbar: hbar,
	hcirc: hcirc,
	hearts: hearts,
	heartsuit: heartsuit,
	hellip: hellip,
	hercon: hercon,
	hfr: hfr,
	hksearow: hksearow,
	hkswarow: hkswarow,
	hoarr: hoarr,
	homtht: homtht,
	hookleftarrow: hookleftarrow,
	hookrightarrow: hookrightarrow,
	hopf: hopf,
	horbar: horbar,
	hscr: hscr,
	hslash: hslash,
	hstrok: hstrok,
	hybull: hybull,
	hyphen: hyphen,
	iacut: iacut,
	iacute: iacute,
	ic: ic,
	icir: icir,
	icirc: icirc,
	icy: icy,
	iecy: iecy,
	iexc: iexc,
	iexcl: iexcl,
	iff: iff,
	ifr: ifr,
	igrav: igrav,
	igrave: igrave,
	ii: ii,
	iiiint: iiiint,
	iiint: iiint,
	iinfin: iinfin,
	iiota: iiota,
	ijlig: ijlig,
	imacr: imacr,
	image: image,
	imagline: imagline,
	imagpart: imagpart,
	imath: imath,
	imof: imof,
	imped: imped,
	"in": "∈",
	incare: incare,
	infin: infin,
	infintie: infintie,
	inodot: inodot,
	int: int,
	intcal: intcal,
	integers: integers,
	intercal: intercal,
	intlarhk: intlarhk,
	intprod: intprod,
	iocy: iocy,
	iogon: iogon,
	iopf: iopf,
	iota: iota,
	iprod: iprod,
	iques: iques,
	iquest: iquest,
	iscr: iscr,
	isin: isin,
	isinE: isinE,
	isindot: isindot,
	isins: isins,
	isinsv: isinsv,
	isinv: isinv,
	it: it,
	itilde: itilde,
	iukcy: iukcy,
	ium: ium,
	iuml: iuml,
	jcirc: jcirc,
	jcy: jcy,
	jfr: jfr,
	jmath: jmath,
	jopf: jopf,
	jscr: jscr,
	jsercy: jsercy,
	jukcy: jukcy,
	kappa: kappa,
	kappav: kappav,
	kcedil: kcedil,
	kcy: kcy,
	kfr: kfr,
	kgreen: kgreen,
	khcy: khcy,
	kjcy: kjcy,
	kopf: kopf,
	kscr: kscr,
	lAarr: lAarr,
	lArr: lArr,
	lAtail: lAtail,
	lBarr: lBarr,
	lE: lE,
	lEg: lEg,
	lHar: lHar,
	lacute: lacute,
	laemptyv: laemptyv,
	lagran: lagran,
	lambda: lambda,
	lang: lang,
	langd: langd,
	langle: langle,
	lap: lap,
	laqu: laqu,
	laquo: laquo,
	larr: larr,
	larrb: larrb,
	larrbfs: larrbfs,
	larrfs: larrfs,
	larrhk: larrhk,
	larrlp: larrlp,
	larrpl: larrpl,
	larrsim: larrsim,
	larrtl: larrtl,
	lat: lat,
	latail: latail,
	late: late,
	lates: lates,
	lbarr: lbarr,
	lbbrk: lbbrk,
	lbrace: lbrace,
	lbrack: lbrack,
	lbrke: lbrke,
	lbrksld: lbrksld,
	lbrkslu: lbrkslu,
	lcaron: lcaron,
	lcedil: lcedil,
	lceil: lceil,
	lcub: lcub,
	lcy: lcy,
	ldca: ldca,
	ldquo: ldquo,
	ldquor: ldquor,
	ldrdhar: ldrdhar,
	ldrushar: ldrushar,
	ldsh: ldsh,
	le: le,
	leftarrow: leftarrow,
	leftarrowtail: leftarrowtail,
	leftharpoondown: leftharpoondown,
	leftharpoonup: leftharpoonup,
	leftleftarrows: leftleftarrows,
	leftrightarrow: leftrightarrow,
	leftrightarrows: leftrightarrows,
	leftrightharpoons: leftrightharpoons,
	leftrightsquigarrow: leftrightsquigarrow,
	leftthreetimes: leftthreetimes,
	leg: leg,
	leq: leq,
	leqq: leqq,
	leqslant: leqslant,
	les: les,
	lescc: lescc,
	lesdot: lesdot,
	lesdoto: lesdoto,
	lesdotor: lesdotor,
	lesg: lesg,
	lesges: lesges,
	lessapprox: lessapprox,
	lessdot: lessdot,
	lesseqgtr: lesseqgtr,
	lesseqqgtr: lesseqqgtr,
	lessgtr: lessgtr,
	lesssim: lesssim,
	lfisht: lfisht,
	lfloor: lfloor,
	lfr: lfr,
	lg: lg,
	lgE: lgE,
	lhard: lhard,
	lharu: lharu,
	lharul: lharul,
	lhblk: lhblk,
	ljcy: ljcy,
	ll: ll,
	llarr: llarr,
	llcorner: llcorner,
	llhard: llhard,
	lltri: lltri,
	lmidot: lmidot,
	lmoust: lmoust,
	lmoustache: lmoustache,
	lnE: lnE,
	lnap: lnap,
	lnapprox: lnapprox,
	lne: lne,
	lneq: lneq,
	lneqq: lneqq,
	lnsim: lnsim,
	loang: loang,
	loarr: loarr,
	lobrk: lobrk,
	longleftarrow: longleftarrow,
	longleftrightarrow: longleftrightarrow,
	longmapsto: longmapsto,
	longrightarrow: longrightarrow,
	looparrowleft: looparrowleft,
	looparrowright: looparrowright,
	lopar: lopar,
	lopf: lopf,
	loplus: loplus,
	lotimes: lotimes,
	lowast: lowast,
	lowbar: lowbar,
	loz: loz,
	lozenge: lozenge,
	lozf: lozf,
	lpar: lpar,
	lparlt: lparlt,
	lrarr: lrarr,
	lrcorner: lrcorner,
	lrhar: lrhar,
	lrhard: lrhard,
	lrm: lrm,
	lrtri: lrtri,
	lsaquo: lsaquo,
	lscr: lscr,
	lsh: lsh,
	lsim: lsim,
	lsime: lsime,
	lsimg: lsimg,
	lsqb: lsqb,
	lsquo: lsquo,
	lsquor: lsquor,
	lstrok: lstrok,
	l: l,
	lt: lt,
	ltcc: ltcc,
	ltcir: ltcir,
	ltdot: ltdot,
	lthree: lthree,
	ltimes: ltimes,
	ltlarr: ltlarr,
	ltquest: ltquest,
	ltrPar: ltrPar,
	ltri: ltri,
	ltrie: ltrie,
	ltrif: ltrif,
	lurdshar: lurdshar,
	luruhar: luruhar,
	lvertneqq: lvertneqq,
	lvnE: lvnE,
	mDDot: mDDot,
	mac: mac,
	macr: macr,
	male: male,
	malt: malt,
	maltese: maltese,
	map: map$2,
	mapsto: mapsto,
	mapstodown: mapstodown,
	mapstoleft: mapstoleft,
	mapstoup: mapstoup,
	marker: marker,
	mcomma: mcomma,
	mcy: mcy,
	mdash: mdash,
	measuredangle: measuredangle,
	mfr: mfr,
	mho: mho,
	micr: micr,
	micro: micro,
	mid: mid,
	midast: midast,
	midcir: midcir,
	middo: middo,
	middot: middot,
	minus: minus,
	minusb: minusb,
	minusd: minusd,
	minusdu: minusdu,
	mlcp: mlcp,
	mldr: mldr,
	mnplus: mnplus,
	models: models,
	mopf: mopf,
	mp: mp,
	mscr: mscr,
	mstpos: mstpos,
	mu: mu,
	multimap: multimap,
	mumap: mumap,
	nGg: nGg,
	nGt: nGt,
	nGtv: nGtv,
	nLeftarrow: nLeftarrow,
	nLeftrightarrow: nLeftrightarrow,
	nLl: nLl,
	nLt: nLt,
	nLtv: nLtv,
	nRightarrow: nRightarrow,
	nVDash: nVDash,
	nVdash: nVdash,
	nabla: nabla,
	nacute: nacute,
	nang: nang,
	nap: nap,
	napE: napE,
	napid: napid,
	napos: napos,
	napprox: napprox,
	natur: natur,
	natural: natural,
	naturals: naturals,
	nbs: nbs,
	nbsp: nbsp,
	nbump: nbump,
	nbumpe: nbumpe,
	ncap: ncap,
	ncaron: ncaron,
	ncedil: ncedil,
	ncong: ncong,
	ncongdot: ncongdot,
	ncup: ncup,
	ncy: ncy,
	ndash: ndash,
	ne: ne,
	neArr: neArr,
	nearhk: nearhk,
	nearr: nearr,
	nearrow: nearrow,
	nedot: nedot,
	nequiv: nequiv,
	nesear: nesear,
	nesim: nesim,
	nexist: nexist,
	nexists: nexists,
	nfr: nfr,
	ngE: ngE,
	nge: nge,
	ngeq: ngeq,
	ngeqq: ngeqq,
	ngeqslant: ngeqslant,
	nges: nges,
	ngsim: ngsim,
	ngt: ngt,
	ngtr: ngtr,
	nhArr: nhArr,
	nharr: nharr,
	nhpar: nhpar,
	ni: ni,
	nis: nis,
	nisd: nisd,
	niv: niv,
	njcy: njcy,
	nlArr: nlArr,
	nlE: nlE,
	nlarr: nlarr,
	nldr: nldr,
	nle: nle,
	nleftarrow: nleftarrow,
	nleftrightarrow: nleftrightarrow,
	nleq: nleq,
	nleqq: nleqq,
	nleqslant: nleqslant,
	nles: nles,
	nless: nless,
	nlsim: nlsim,
	nlt: nlt,
	nltri: nltri,
	nltrie: nltrie,
	nmid: nmid,
	nopf: nopf,
	no: no,
	not: not,
	notin: notin,
	notinE: notinE,
	notindot: notindot,
	notinva: notinva,
	notinvb: notinvb,
	notinvc: notinvc,
	notni: notni,
	notniva: notniva,
	notnivb: notnivb,
	notnivc: notnivc,
	npar: npar,
	nparallel: nparallel,
	nparsl: nparsl,
	npart: npart,
	npolint: npolint,
	npr: npr,
	nprcue: nprcue,
	npre: npre,
	nprec: nprec,
	npreceq: npreceq,
	nrArr: nrArr,
	nrarr: nrarr,
	nrarrc: nrarrc,
	nrarrw: nrarrw,
	nrightarrow: nrightarrow,
	nrtri: nrtri,
	nrtrie: nrtrie,
	nsc: nsc,
	nsccue: nsccue,
	nsce: nsce,
	nscr: nscr,
	nshortmid: nshortmid,
	nshortparallel: nshortparallel,
	nsim: nsim,
	nsime: nsime,
	nsimeq: nsimeq,
	nsmid: nsmid,
	nspar: nspar,
	nsqsube: nsqsube,
	nsqsupe: nsqsupe,
	nsub: nsub,
	nsubE: nsubE,
	nsube: nsube,
	nsubset: nsubset,
	nsubseteq: nsubseteq,
	nsubseteqq: nsubseteqq,
	nsucc: nsucc,
	nsucceq: nsucceq,
	nsup: nsup,
	nsupE: nsupE,
	nsupe: nsupe,
	nsupset: nsupset,
	nsupseteq: nsupseteq,
	nsupseteqq: nsupseteqq,
	ntgl: ntgl,
	ntild: ntild,
	ntilde: ntilde,
	ntlg: ntlg,
	ntriangleleft: ntriangleleft,
	ntrianglelefteq: ntrianglelefteq,
	ntriangleright: ntriangleright,
	ntrianglerighteq: ntrianglerighteq,
	nu: nu,
	num: num,
	numero: numero,
	numsp: numsp,
	nvDash: nvDash,
	nvHarr: nvHarr,
	nvap: nvap,
	nvdash: nvdash,
	nvge: nvge,
	nvgt: nvgt,
	nvinfin: nvinfin,
	nvlArr: nvlArr,
	nvle: nvle,
	nvlt: nvlt,
	nvltrie: nvltrie,
	nvrArr: nvrArr,
	nvrtrie: nvrtrie,
	nvsim: nvsim,
	nwArr: nwArr,
	nwarhk: nwarhk,
	nwarr: nwarr,
	nwarrow: nwarrow,
	nwnear: nwnear,
	oS: oS,
	oacut: oacut,
	oacute: oacute,
	oast: oast,
	ocir: ocir,
	ocirc: ocirc,
	ocy: ocy,
	odash: odash,
	odblac: odblac,
	odiv: odiv,
	odot: odot,
	odsold: odsold,
	oelig: oelig,
	ofcir: ofcir,
	ofr: ofr,
	ogon: ogon,
	ograv: ograv,
	ograve: ograve,
	ogt: ogt,
	ohbar: ohbar,
	ohm: ohm,
	oint: oint,
	olarr: olarr,
	olcir: olcir,
	olcross: olcross,
	oline: oline,
	olt: olt,
	omacr: omacr,
	omega: omega,
	omicron: omicron,
	omid: omid,
	ominus: ominus,
	oopf: oopf,
	opar: opar,
	operp: operp,
	oplus: oplus,
	or: or,
	orarr: orarr,
	ord: ord,
	order: order,
	orderof: orderof,
	ordf: ordf,
	ordm: ordm,
	origof: origof,
	oror: oror,
	orslope: orslope,
	orv: orv,
	oscr: oscr,
	oslas: oslas,
	oslash: oslash,
	osol: osol,
	otild: otild,
	otilde: otilde,
	otimes: otimes,
	otimesas: otimesas,
	oum: oum,
	ouml: ouml,
	ovbar: ovbar,
	par: par,
	para: para,
	parallel: parallel,
	parsim: parsim,
	parsl: parsl,
	part: part,
	pcy: pcy,
	percnt: percnt,
	period: period,
	permil: permil,
	perp: perp,
	pertenk: pertenk,
	pfr: pfr,
	phi: phi,
	phiv: phiv,
	phmmat: phmmat,
	phone: phone,
	pi: pi,
	pitchfork: pitchfork,
	piv: piv,
	planck: planck,
	planckh: planckh,
	plankv: plankv,
	plus: plus,
	plusacir: plusacir,
	plusb: plusb,
	pluscir: pluscir,
	plusdo: plusdo,
	plusdu: plusdu,
	pluse: pluse,
	plusm: plusm,
	plusmn: plusmn,
	plussim: plussim,
	plustwo: plustwo,
	pm: pm,
	pointint: pointint,
	popf: popf,
	poun: poun,
	pound: pound,
	pr: pr,
	prE: prE,
	prap: prap,
	prcue: prcue,
	pre: pre,
	prec: prec,
	precapprox: precapprox,
	preccurlyeq: preccurlyeq,
	preceq: preceq,
	precnapprox: precnapprox,
	precneqq: precneqq,
	precnsim: precnsim,
	precsim: precsim,
	prime: prime,
	primes: primes,
	prnE: prnE,
	prnap: prnap,
	prnsim: prnsim,
	prod: prod,
	profalar: profalar,
	profline: profline,
	profsurf: profsurf,
	prop: prop,
	propto: propto,
	prsim: prsim,
	prurel: prurel,
	pscr: pscr,
	psi: psi,
	puncsp: puncsp,
	qfr: qfr,
	qint: qint,
	qopf: qopf,
	qprime: qprime,
	qscr: qscr,
	quaternions: quaternions,
	quatint: quatint,
	quest: quest,
	questeq: questeq,
	quo: quo,
	quot: quot,
	rAarr: rAarr,
	rArr: rArr,
	rAtail: rAtail,
	rBarr: rBarr,
	rHar: rHar,
	race: race,
	racute: racute,
	radic: radic,
	raemptyv: raemptyv,
	rang: rang,
	rangd: rangd,
	range: range,
	rangle: rangle,
	raqu: raqu,
	raquo: raquo,
	rarr: rarr,
	rarrap: rarrap,
	rarrb: rarrb,
	rarrbfs: rarrbfs,
	rarrc: rarrc,
	rarrfs: rarrfs,
	rarrhk: rarrhk,
	rarrlp: rarrlp,
	rarrpl: rarrpl,
	rarrsim: rarrsim,
	rarrtl: rarrtl,
	rarrw: rarrw,
	ratail: ratail,
	ratio: ratio,
	rationals: rationals,
	rbarr: rbarr,
	rbbrk: rbbrk,
	rbrace: rbrace,
	rbrack: rbrack,
	rbrke: rbrke,
	rbrksld: rbrksld,
	rbrkslu: rbrkslu,
	rcaron: rcaron,
	rcedil: rcedil,
	rceil: rceil,
	rcub: rcub,
	rcy: rcy,
	rdca: rdca,
	rdldhar: rdldhar,
	rdquo: rdquo,
	rdquor: rdquor,
	rdsh: rdsh,
	real: real,
	realine: realine,
	realpart: realpart,
	reals: reals,
	rect: rect,
	re: re,
	reg: reg,
	rfisht: rfisht,
	rfloor: rfloor,
	rfr: rfr,
	rhard: rhard,
	rharu: rharu,
	rharul: rharul,
	rho: rho,
	rhov: rhov,
	rightarrow: rightarrow,
	rightarrowtail: rightarrowtail,
	rightharpoondown: rightharpoondown,
	rightharpoonup: rightharpoonup,
	rightleftarrows: rightleftarrows,
	rightleftharpoons: rightleftharpoons,
	rightrightarrows: rightrightarrows,
	rightsquigarrow: rightsquigarrow,
	rightthreetimes: rightthreetimes,
	ring: ring,
	risingdotseq: risingdotseq,
	rlarr: rlarr,
	rlhar: rlhar,
	rlm: rlm,
	rmoust: rmoust,
	rmoustache: rmoustache,
	rnmid: rnmid,
	roang: roang,
	roarr: roarr,
	robrk: robrk,
	ropar: ropar,
	ropf: ropf,
	roplus: roplus,
	rotimes: rotimes,
	rpar: rpar,
	rpargt: rpargt,
	rppolint: rppolint,
	rrarr: rrarr,
	rsaquo: rsaquo,
	rscr: rscr,
	rsh: rsh,
	rsqb: rsqb,
	rsquo: rsquo,
	rsquor: rsquor,
	rthree: rthree,
	rtimes: rtimes,
	rtri: rtri,
	rtrie: rtrie,
	rtrif: rtrif,
	rtriltri: rtriltri,
	ruluhar: ruluhar,
	rx: rx,
	sacute: sacute,
	sbquo: sbquo,
	sc: sc,
	scE: scE,
	scap: scap,
	scaron: scaron,
	sccue: sccue,
	sce: sce,
	scedil: scedil,
	scirc: scirc,
	scnE: scnE,
	scnap: scnap,
	scnsim: scnsim,
	scpolint: scpolint,
	scsim: scsim,
	scy: scy,
	sdot: sdot,
	sdotb: sdotb,
	sdote: sdote,
	seArr: seArr,
	searhk: searhk,
	searr: searr,
	searrow: searrow,
	sec: sec,
	sect: sect,
	semi: semi,
	seswar: seswar,
	setminus: setminus,
	setmn: setmn,
	sext: sext,
	sfr: sfr,
	sfrown: sfrown,
	sharp: sharp,
	shchcy: shchcy,
	shcy: shcy,
	shortmid: shortmid,
	shortparallel: shortparallel,
	sh: sh,
	shy: shy,
	sigma: sigma,
	sigmaf: sigmaf,
	sigmav: sigmav,
	sim: sim,
	simdot: simdot,
	sime: sime,
	simeq: simeq,
	simg: simg,
	simgE: simgE,
	siml: siml,
	simlE: simlE,
	simne: simne,
	simplus: simplus,
	simrarr: simrarr,
	slarr: slarr,
	smallsetminus: smallsetminus,
	smashp: smashp,
	smeparsl: smeparsl,
	smid: smid,
	smile: smile,
	smt: smt,
	smte: smte,
	smtes: smtes,
	softcy: softcy,
	sol: sol,
	solb: solb,
	solbar: solbar,
	sopf: sopf,
	spades: spades,
	spadesuit: spadesuit,
	spar: spar,
	sqcap: sqcap,
	sqcaps: sqcaps,
	sqcup: sqcup,
	sqcups: sqcups,
	sqsub: sqsub,
	sqsube: sqsube,
	sqsubset: sqsubset,
	sqsubseteq: sqsubseteq,
	sqsup: sqsup,
	sqsupe: sqsupe,
	sqsupset: sqsupset,
	sqsupseteq: sqsupseteq,
	squ: squ,
	square: square,
	squarf: squarf,
	squf: squf,
	srarr: srarr,
	sscr: sscr,
	ssetmn: ssetmn,
	ssmile: ssmile,
	sstarf: sstarf,
	star: star,
	starf: starf,
	straightepsilon: straightepsilon,
	straightphi: straightphi,
	strns: strns,
	sub: sub,
	subE: subE,
	subdot: subdot,
	sube: sube,
	subedot: subedot,
	submult: submult,
	subnE: subnE,
	subne: subne,
	subplus: subplus,
	subrarr: subrarr,
	subset: subset,
	subseteq: subseteq,
	subseteqq: subseteqq,
	subsetneq: subsetneq,
	subsetneqq: subsetneqq,
	subsim: subsim,
	subsub: subsub,
	subsup: subsup,
	succ: succ,
	succapprox: succapprox,
	succcurlyeq: succcurlyeq,
	succeq: succeq,
	succnapprox: succnapprox,
	succneqq: succneqq,
	succnsim: succnsim,
	succsim: succsim,
	sum: sum,
	sung: sung,
	sup: sup,
	sup1: sup1,
	sup2: sup2,
	sup3: sup3,
	supE: supE,
	supdot: supdot,
	supdsub: supdsub,
	supe: supe,
	supedot: supedot,
	suphsol: suphsol,
	suphsub: suphsub,
	suplarr: suplarr,
	supmult: supmult,
	supnE: supnE,
	supne: supne,
	supplus: supplus,
	supset: supset,
	supseteq: supseteq,
	supseteqq: supseteqq,
	supsetneq: supsetneq,
	supsetneqq: supsetneqq,
	supsim: supsim,
	supsub: supsub,
	supsup: supsup,
	swArr: swArr,
	swarhk: swarhk,
	swarr: swarr,
	swarrow: swarrow,
	swnwar: swnwar,
	szli: szli,
	szlig: szlig,
	target: target,
	tau: tau,
	tbrk: tbrk,
	tcaron: tcaron,
	tcedil: tcedil,
	tcy: tcy,
	tdot: tdot,
	telrec: telrec,
	tfr: tfr,
	there4: there4,
	therefore: therefore,
	theta: theta,
	thetasym: thetasym,
	thetav: thetav,
	thickapprox: thickapprox,
	thicksim: thicksim,
	thinsp: thinsp,
	thkap: thkap,
	thksim: thksim,
	thor: thor,
	thorn: thorn,
	tilde: tilde,
	time: time,
	times: times,
	timesb: timesb,
	timesbar: timesbar,
	timesd: timesd,
	tint: tint,
	toea: toea,
	top: top,
	topbot: topbot,
	topcir: topcir,
	topf: topf,
	topfork: topfork,
	tosa: tosa,
	tprime: tprime,
	trade: trade,
	triangle: triangle,
	triangledown: triangledown,
	triangleleft: triangleleft,
	trianglelefteq: trianglelefteq,
	triangleq: triangleq,
	triangleright: triangleright,
	trianglerighteq: trianglerighteq,
	tridot: tridot,
	trie: trie,
	triminus: triminus,
	triplus: triplus,
	trisb: trisb,
	tritime: tritime,
	trpezium: trpezium,
	tscr: tscr,
	tscy: tscy,
	tshcy: tshcy,
	tstrok: tstrok,
	twixt: twixt,
	twoheadleftarrow: twoheadleftarrow,
	twoheadrightarrow: twoheadrightarrow,
	uArr: uArr,
	uHar: uHar,
	uacut: uacut,
	uacute: uacute,
	uarr: uarr,
	ubrcy: ubrcy,
	ubreve: ubreve,
	ucir: ucir,
	ucirc: ucirc,
	ucy: ucy,
	udarr: udarr,
	udblac: udblac,
	udhar: udhar,
	ufisht: ufisht,
	ufr: ufr,
	ugrav: ugrav,
	ugrave: ugrave,
	uharl: uharl,
	uharr: uharr,
	uhblk: uhblk,
	ulcorn: ulcorn,
	ulcorner: ulcorner,
	ulcrop: ulcrop,
	ultri: ultri,
	umacr: umacr,
	um: um,
	uml: uml,
	uogon: uogon,
	uopf: uopf,
	uparrow: uparrow,
	updownarrow: updownarrow,
	upharpoonleft: upharpoonleft,
	upharpoonright: upharpoonright,
	uplus: uplus,
	upsi: upsi,
	upsih: upsih,
	upsilon: upsilon,
	upuparrows: upuparrows,
	urcorn: urcorn,
	urcorner: urcorner,
	urcrop: urcrop,
	uring: uring,
	urtri: urtri,
	uscr: uscr,
	utdot: utdot,
	utilde: utilde,
	utri: utri,
	utrif: utrif,
	uuarr: uuarr,
	uum: uum,
	uuml: uuml,
	uwangle: uwangle,
	vArr: vArr,
	vBar: vBar,
	vBarv: vBarv,
	vDash: vDash,
	vangrt: vangrt,
	varepsilon: varepsilon,
	varkappa: varkappa,
	varnothing: varnothing,
	varphi: varphi,
	varpi: varpi,
	varpropto: varpropto,
	varr: varr,
	varrho: varrho,
	varsigma: varsigma,
	varsubsetneq: varsubsetneq,
	varsubsetneqq: varsubsetneqq,
	varsupsetneq: varsupsetneq,
	varsupsetneqq: varsupsetneqq,
	vartheta: vartheta,
	vartriangleleft: vartriangleleft,
	vartriangleright: vartriangleright,
	vcy: vcy,
	vdash: vdash,
	vee: vee,
	veebar: veebar,
	veeeq: veeeq,
	vellip: vellip,
	verbar: verbar,
	vert: vert,
	vfr: vfr,
	vltri: vltri,
	vnsub: vnsub,
	vnsup: vnsup,
	vopf: vopf,
	vprop: vprop,
	vrtri: vrtri,
	vscr: vscr,
	vsubnE: vsubnE,
	vsubne: vsubne,
	vsupnE: vsupnE,
	vsupne: vsupne,
	vzigzag: vzigzag,
	wcirc: wcirc,
	wedbar: wedbar,
	wedge: wedge,
	wedgeq: wedgeq,
	weierp: weierp,
	wfr: wfr,
	wopf: wopf,
	wp: wp,
	wr: wr,
	wreath: wreath,
	wscr: wscr,
	xcap: xcap,
	xcirc: xcirc,
	xcup: xcup,
	xdtri: xdtri,
	xfr: xfr,
	xhArr: xhArr,
	xharr: xharr,
	xi: xi,
	xlArr: xlArr,
	xlarr: xlarr,
	xmap: xmap,
	xnis: xnis,
	xodot: xodot,
	xopf: xopf,
	xoplus: xoplus,
	xotime: xotime,
	xrArr: xrArr,
	xrarr: xrarr,
	xscr: xscr,
	xsqcup: xsqcup,
	xuplus: xuplus,
	xutri: xutri,
	xvee: xvee,
	xwedge: xwedge,
	yacut: yacut,
	yacute: yacute,
	yacy: yacy,
	ycirc: ycirc,
	ycy: ycy,
	ye: ye,
	yen: yen,
	yfr: yfr,
	yicy: yicy,
	yopf: yopf,
	yscr: yscr,
	yucy: yucy,
	yum: yum,
	yuml: yuml,
	zacute: zacute,
	zcaron: zcaron,
	zcy: zcy,
	zdot: zdot,
	zeetrf: zeetrf,
	zeta: zeta,
	zfr: zfr,
	zhcy: zhcy,
	zigrarr: zigrarr,
	zopf: zopf,
	zscr: zscr,
	zwj: zwj,
	zwnj: zwnj
};

var characterEntities = require$$0;
var decodeEntity_1 = decodeEntity$1;
var own$2 = {}.hasOwnProperty;
function decodeEntity$1(characters) {
  return own$2.call(characterEntities, characters) ? characterEntities[characters] : false;
}

var legacy = require$$0$1;
var invalid = require$$1;
var decimal = isDecimal;
var hexadecimal = isHexadecimal;
var alphanumerical = isAlphanumerical;
var decodeEntity = decodeEntity_1;
var parseEntities_1 = parseEntities;
var own$1 = {}.hasOwnProperty;
var fromCharCode = String.fromCharCode;
var noop$1 = Function.prototype;

// Default settings.
var defaults$1 = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
};

// Characters.
var tab = 9; // '\t'
var lineFeed = 10; // '\n'
var formFeed = 12; // '\f'
var space = 32; // ' '
var ampersand = 38; // '&'
var semicolon = 59; // ';'
var lessThan = 60; // '<'
var equalsTo = 61; // '='
var numberSign = 35; // '#'
var uppercaseX = 88; // 'X'
var lowercaseX = 120; // 'x'
var replacementCharacter = 65533; // '�'

// Reference types.
var name = 'named';
var hexa = 'hexadecimal';
var deci = 'decimal';

// Map of bases.
var bases = {};
bases[hexa] = 16;
bases[deci] = 10;

// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {};
tests[name] = alphanumerical;
tests[deci] = decimal;
tests[hexa] = hexadecimal;

// Warning types.
var namedNotTerminated = 1;
var numericNotTerminated = 2;
var namedEmpty = 3;
var numericEmpty = 4;
var namedUnknown = 5;
var numericDisallowed = 6;
var numericProhibited = 7;

// Warning messages.
var messages = {};
messages[namedNotTerminated] = 'Named character references must be terminated by a semicolon';
messages[numericNotTerminated] = 'Numeric character references must be terminated by a semicolon';
messages[namedEmpty] = 'Named character references cannot be empty';
messages[numericEmpty] = 'Numeric character references cannot be empty';
messages[namedUnknown] = 'Named character references must be known';
messages[numericDisallowed] = 'Numeric character references cannot be disallowed';
messages[numericProhibited] = 'Numeric character references cannot be outside the permissible Unicode range';

// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
  var settings = {};
  var option;
  var key;
  if (!options) {
    options = {};
  }
  for (key in defaults$1) {
    option = options[key];
    settings[key] = option === null || option === undefined ? defaults$1[key] : option;
  }
  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || [];
    settings.position = settings.position.start;
  }
  return parse$1(value, settings);
}

// Parse entities.
// eslint-disable-next-line complexity
function parse$1(value, settings) {
  var additional = settings.additional;
  var nonTerminated = settings.nonTerminated;
  var handleText = settings.text;
  var handleReference = settings.reference;
  var handleWarning = settings.warning;
  var textContext = settings.textContext;
  var referenceContext = settings.referenceContext;
  var warningContext = settings.warningContext;
  var pos = settings.position;
  var indent = settings.indent || [];
  var length = value.length;
  var index = 0;
  var lines = -1;
  var column = pos.column || 1;
  var line = pos.line || 1;
  var queue = '';
  var result = [];
  var entityCharacters;
  var namedEntity;
  var terminated;
  var characters;
  var character;
  var reference;
  var following;
  var warning;
  var reason;
  var output;
  var entity;
  var begin;
  var start;
  var type;
  var test;
  var prev;
  var next;
  var diff;
  var end;
  if (typeof additional === 'string') {
    additional = additional.charCodeAt(0);
  }

  // Cache the current point.
  prev = now();

  // Wrap `handleWarning`.
  warning = handleWarning ? parseError : noop$1;

  // Ensure the algorithm walks over the first character and the end
  // (inclusive).
  index--;
  length++;
  while (++index < length) {
    // If the previous character was a newline.
    if (character === lineFeed) {
      column = indent[lines] || 1;
    }
    character = value.charCodeAt(index);
    if (character === ampersand) {
      following = value.charCodeAt(index + 1);

      // The behaviour depends on the identity of the next character.
      if (following === tab || following === lineFeed || following === formFeed || following === space || following === ampersand || following === lessThan || following !== following || additional && following === additional) {
        // Not a character reference.
        // No characters are consumed, and nothing is returned.
        // This is not an error, either.
        queue += fromCharCode(character);
        column++;
        continue;
      }
      start = index + 1;
      begin = start;
      end = start;
      if (following === numberSign) {
        // Numerical entity.
        end = ++begin;

        // The behaviour further depends on the next character.
        following = value.charCodeAt(end);
        if (following === uppercaseX || following === lowercaseX) {
          // ASCII hex digits.
          type = hexa;
          end = ++begin;
        } else {
          // ASCII digits.
          type = deci;
        }
      } else {
        // Named entity.
        type = name;
      }
      entityCharacters = '';
      entity = '';
      characters = '';
      test = tests[type];
      end--;
      while (++end < length) {
        following = value.charCodeAt(end);
        if (!test(following)) {
          break;
        }
        characters += fromCharCode(following);

        // Check if we can match a legacy named reference.
        // If so, we cache that as the last viable named reference.
        // This ensures we do not need to walk backwards later.
        if (type === name && own$1.call(legacy, characters)) {
          entityCharacters = characters;
          entity = legacy[characters];
        }
      }
      terminated = value.charCodeAt(end) === semicolon;
      if (terminated) {
        end++;
        namedEntity = type === name ? decodeEntity(characters) : false;
        if (namedEntity) {
          entityCharacters = characters;
          entity = namedEntity;
        }
      }
      diff = 1 + end - start;
      if (!terminated && !nonTerminated) ; else if (!characters) {
        // An empty (possible) entity is valid, unless it’s numeric (thus an
        // ampersand followed by an octothorp).
        if (type !== name) {
          warning(numericEmpty, diff);
        }
      } else if (type === name) {
        // An ampersand followed by anything unknown, and not terminated, is
        // invalid.
        if (terminated && !entity) {
          warning(namedUnknown, 1);
        } else {
          // If theres something after an entity name which is not known, cap
          // the reference.
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length;
            diff = 1 + end - begin;
            terminated = false;
          }

          // If the reference is not terminated, warn.
          if (!terminated) {
            reason = entityCharacters ? namedNotTerminated : namedEmpty;
            if (settings.attribute) {
              following = value.charCodeAt(end);
              if (following === equalsTo) {
                warning(reason, diff);
                entity = null;
              } else if (alphanumerical(following)) {
                entity = null;
              } else {
                warning(reason, diff);
              }
            } else {
              warning(reason, diff);
            }
          }
        }
        reference = entity;
      } else {
        if (!terminated) {
          // All non-terminated numeric entities are not rendered, and trigger a
          // warning.
          warning(numericNotTerminated, diff);
        }

        // When terminated and number, parse as either hexadecimal or decimal.
        reference = parseInt(characters, bases[type]);

        // Trigger a warning when the parsed number is prohibited, and replace
        // with replacement character.
        if (prohibited(reference)) {
          warning(numericProhibited, diff);
          reference = fromCharCode(replacementCharacter);
        } else if (reference in invalid) {
          // Trigger a warning when the parsed number is disallowed, and replace
          // by an alternative.
          warning(numericDisallowed, diff);
          reference = invalid[reference];
        } else {
          // Parse the number.
          output = '';

          // Trigger a warning when the parsed number should not be used.
          if (disallowed(reference)) {
            warning(numericDisallowed, diff);
          }

          // Stringify the number.
          if (reference > 0xffff) {
            reference -= 0x10000;
            output += fromCharCode(reference >>> (10 & 0x3ff) | 0xd800);
            reference = 0xdc00 | reference & 0x3ff;
          }
          reference = output + fromCharCode(reference);
        }
      }

      // Found it!
      // First eat the queued characters as normal text, then eat an entity.
      if (reference) {
        flush();
        prev = now();
        index = end - 1;
        column += end - start + 1;
        result.push(reference);
        next = now();
        next.offset++;
        if (handleReference) {
          handleReference.call(referenceContext, reference, {
            start: prev,
            end: next
          }, value.slice(start - 1, end));
        }
        prev = next;
      } else {
        // If we could not find a reference, queue the checked characters (as
        // normal characters), and move the pointer to their end.
        // This is possible because we can be certain neither newlines nor
        // ampersands are included.
        characters = value.slice(start - 1, end);
        queue += characters;
        column += characters.length;
        index = end - 1;
      }
    } else {
      // Handle anything other than an ampersand, including newlines and EOF.
      if (character === 10 // Line feed
      ) {
        line++;
        lines++;
        column = 0;
      }
      if (character === character) {
        queue += fromCharCode(character);
        column++;
      } else {
        flush();
      }
    }
  }

  // Return the reduced nodes.
  return result.join('');

  // Get current position.
  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    };
  }

  // “Throw” a parse-error: a warning.
  function parseError(code, offset) {
    var position = now();
    position.column += offset;
    position.offset += offset;
    handleWarning.call(warningContext, messages[code], position, code);
  }

  // Flush `queue` (normal text).
  // Macro invoked before each entity and at the end of `value`.
  // Does nothing when `queue` is empty.
  function flush() {
    if (queue) {
      result.push(queue);
      if (handleText) {
        handleText.call(textContext, queue, {
          start: prev,
          end: now()
        });
      }
      queue = '';
    }
  }
}

// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
  return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}

// Check if `character` is disallowed.
function disallowed(code) {
  return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}

var prismCore = {exports: {}};

(function (module) {
/// <reference lib="WebWorker"/>

var _self = typeof window !== 'undefined' ? window // if in browser
: typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
: {} // if in node js
;

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = function (_self) {
  // Private helper vars
  var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
  var uniqueId = 0;

  // The grammar object for plaintext
  var plainTextGrammar = {};
  var _ = {
    /**
     * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
     * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
     * additional languages or plugins yourself.
     *
     * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
     *
     * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
     * empty Prism object into the global scope before loading the Prism script like this:
     *
     * ```js
     * window.Prism = window.Prism || {};
     * Prism.manual = true;
     * // add a new <script> to load Prism's script
     * ```
     *
     * @default false
     * @type {boolean}
     * @memberof Prism
     * @public
     */
    manual: _self.Prism && _self.Prism.manual,
    /**
     * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
     * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
     * own worker, you don't want it to do this.
     *
     * By setting this value to `true`, Prism will not add its own listeners to the worker.
     *
     * You obviously have to change this value before Prism executes. To do this, you can add an
     * empty Prism object into the global scope before loading the Prism script like this:
     *
     * ```js
     * window.Prism = window.Prism || {};
     * Prism.disableWorkerMessageHandler = true;
     * // Load Prism's script
     * ```
     *
     * @default false
     * @type {boolean}
     * @memberof Prism
     * @public
     */
    disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
    /**
     * A namespace for utility methods.
     *
     * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
     * change or disappear at any time.
     *
     * @namespace
     * @memberof Prism
     */
    util: {
      encode: function encode(tokens) {
        if (tokens instanceof Token) {
          return new Token(tokens.type, encode(tokens.content), tokens.alias);
        } else if (Array.isArray(tokens)) {
          return tokens.map(encode);
        } else {
          return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
        }
      },
      /**
       * Returns the name of the type of the given value.
       *
       * @param {any} o
       * @returns {string}
       * @example
       * type(null)      === 'Null'
       * type(undefined) === 'Undefined'
       * type(123)       === 'Number'
       * type('foo')     === 'String'
       * type(true)      === 'Boolean'
       * type([1, 2])    === 'Array'
       * type({})        === 'Object'
       * type(String)    === 'Function'
       * type(/abc+/)    === 'RegExp'
       */
      type: function (o) {
        return Object.prototype.toString.call(o).slice(8, -1);
      },
      /**
       * Returns a unique number for the given object. Later calls will still return the same number.
       *
       * @param {Object} obj
       * @returns {number}
       */
      objId: function (obj) {
        if (!obj['__id']) {
          Object.defineProperty(obj, '__id', {
            value: ++uniqueId
          });
        }
        return obj['__id'];
      },
      /**
       * Creates a deep clone of the given object.
       *
       * The main intended use of this function is to clone language definitions.
       *
       * @param {T} o
       * @param {Record<number, any>} [visited]
       * @returns {T}
       * @template T
       */
      clone: function deepClone(o, visited) {
        visited = visited || {};
        var clone;
        var id;
        switch (_.util.type(o)) {
          case 'Object':
            id = _.util.objId(o);
            if (visited[id]) {
              return visited[id];
            }
            clone = /** @type {Record<string, any>} */{};
            visited[id] = clone;
            for (var key in o) {
              if (o.hasOwnProperty(key)) {
                clone[key] = deepClone(o[key], visited);
              }
            }
            return /** @type {any} */clone;
          case 'Array':
            id = _.util.objId(o);
            if (visited[id]) {
              return visited[id];
            }
            clone = [];
            visited[id] = clone;
            (/** @type {Array} */ /** @type {any} */o).forEach(function (v, i) {
              clone[i] = deepClone(v, visited);
            });
            return /** @type {any} */clone;
          default:
            return o;
        }
      },
      /**
       * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
       *
       * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
       *
       * @param {Element} element
       * @returns {string}
       */
      getLanguage: function (element) {
        while (element) {
          var m = lang.exec(element.className);
          if (m) {
            return m[1].toLowerCase();
          }
          element = element.parentElement;
        }
        return 'none';
      },
      /**
       * Sets the Prism `language-xxxx` class of the given element.
       *
       * @param {Element} element
       * @param {string} language
       * @returns {void}
       */
      setLanguage: function (element, language) {
        // remove all `language-xxxx` classes
        // (this might leave behind a leading space)
        element.className = element.className.replace(RegExp(lang, 'gi'), '');

        // add the new `language-xxxx` class
        // (using `classList` will automatically clean up spaces for us)
        element.classList.add('language-' + language);
      },
      /**
       * Returns the script element that is currently executing.
       *
       * This does __not__ work for line script element.
       *
       * @returns {HTMLScriptElement | null}
       */
      currentScript: function () {
        if (typeof document === 'undefined') {
          return null;
        }
        if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
          return /** @type {any} */document.currentScript;
        }

        // IE11 workaround
        // we'll get the src of the current script by parsing IE11's error stack trace
        // this will not work for inline scripts

        try {
          throw new Error();
        } catch (err) {
          // Get file src url from stack. Specifically works with the format of stack traces in IE.
          // A stack will look like this:
          //
          // Error
          //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
          //    at Global code (http://localhost/components/prism-core.js:606:1)

          var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
          if (src) {
            var scripts = document.getElementsByTagName('script');
            for (var i in scripts) {
              if (scripts[i].src == src) {
                return scripts[i];
              }
            }
          }
          return null;
        }
      },
      /**
       * Returns whether a given class is active for `element`.
       *
       * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
       * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
       * given class is just the given class with a `no-` prefix.
       *
       * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
       * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
       * ancestors have the given class or the negated version of it, then the default activation will be returned.
       *
       * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
       * version of it, the class is considered active.
       *
       * @param {Element} element
       * @param {string} className
       * @param {boolean} [defaultActivation=false]
       * @returns {boolean}
       */
      isActive: function (element, className, defaultActivation) {
        var no = 'no-' + className;
        while (element) {
          var classList = element.classList;
          if (classList.contains(className)) {
            return true;
          }
          if (classList.contains(no)) {
            return false;
          }
          element = element.parentElement;
        }
        return !!defaultActivation;
      }
    },
    /**
     * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
     *
     * @namespace
     * @memberof Prism
     * @public
     */
    languages: {
      /**
       * The grammar for plain, unformatted text.
       */
      plain: plainTextGrammar,
      plaintext: plainTextGrammar,
      text: plainTextGrammar,
      txt: plainTextGrammar,
      /**
       * Creates a deep copy of the language with the given id and appends the given tokens.
       *
       * If a token in `redef` also appears in the copied language, then the existing token in the copied language
       * will be overwritten at its original position.
       *
       * ## Best practices
       *
       * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
       * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
       * understand the language definition because, normally, the order of tokens matters in Prism grammars.
       *
       * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
       * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
       *
       * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
       * @param {Grammar} redef The new tokens to append.
       * @returns {Grammar} The new language created.
       * @public
       * @example
       * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
       *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
       *     // at its original position
       *     'comment': { ... },
       *     // CSS doesn't have a 'color' token, so this token will be appended
       *     'color': /\b(?:red|green|blue)\b/
       * });
       */
      extend: function (id, redef) {
        var lang = _.util.clone(_.languages[id]);
        for (var key in redef) {
          lang[key] = redef[key];
        }
        return lang;
      },
      /**
       * Inserts tokens _before_ another token in a language definition or any other grammar.
       *
       * ## Usage
       *
       * This helper method makes it easy to modify existing languages. For example, the CSS language definition
       * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
       * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
       * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
       * this:
       *
       * ```js
       * Prism.languages.markup.style = {
       *     // token
       * };
       * ```
       *
       * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
       * before existing tokens. For the CSS example above, you would use it like this:
       *
       * ```js
       * Prism.languages.insertBefore('markup', 'cdata', {
       *     'style': {
       *         // token
       *     }
       * });
       * ```
       *
       * ## Special cases
       *
       * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
       * will be ignored.
       *
       * This behavior can be used to insert tokens after `before`:
       *
       * ```js
       * Prism.languages.insertBefore('markup', 'comment', {
       *     'comment': Prism.languages.markup.comment,
       *     // tokens after 'comment'
       * });
       * ```
       *
       * ## Limitations
       *
       * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
       * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
       * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
       * deleting properties which is necessary to insert at arbitrary positions.
       *
       * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
       * Instead, it will create a new object and replace all references to the target object with the new one. This
       * can be done without temporarily deleting properties, so the iteration order is well-defined.
       *
       * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
       * you hold the target object in a variable, then the value of the variable will not change.
       *
       * ```js
       * var oldMarkup = Prism.languages.markup;
       * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
       *
       * assert(oldMarkup !== Prism.languages.markup);
       * assert(newMarkup === Prism.languages.markup);
       * ```
       *
       * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
       * object to be modified.
       * @param {string} before The key to insert before.
       * @param {Grammar} insert An object containing the key-value pairs to be inserted.
       * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
       * object to be modified.
       *
       * Defaults to `Prism.languages`.
       * @returns {Grammar} The new grammar object.
       * @public
       */
      insertBefore: function (inside, before, insert, root) {
        root = root || (/** @type {any} */_.languages);
        var grammar = root[inside];
        /** @type {Grammar} */
        var ret = {};
        for (var token in grammar) {
          if (grammar.hasOwnProperty(token)) {
            if (token == before) {
              for (var newToken in insert) {
                if (insert.hasOwnProperty(newToken)) {
                  ret[newToken] = insert[newToken];
                }
              }
            }

            // Do not insert token which also occur in insert. See #1525
            if (!insert.hasOwnProperty(token)) {
              ret[token] = grammar[token];
            }
          }
        }
        var old = root[inside];
        root[inside] = ret;

        // Update references in other language definitions
        _.languages.DFS(_.languages, function (key, value) {
          if (value === old && key != inside) {
            this[key] = ret;
          }
        });
        return ret;
      },
      // Traverse a language definition with Depth First Search
      DFS: function DFS(o, callback, type, visited) {
        visited = visited || {};
        var objId = _.util.objId;
        for (var i in o) {
          if (o.hasOwnProperty(i)) {
            callback.call(o, i, o[i], type || i);
            var property = o[i];
            var propertyType = _.util.type(property);
            if (propertyType === 'Object' && !visited[objId(property)]) {
              visited[objId(property)] = true;
              DFS(property, callback, null, visited);
            } else if (propertyType === 'Array' && !visited[objId(property)]) {
              visited[objId(property)] = true;
              DFS(property, callback, i, visited);
            }
          }
        }
      }
    },
    plugins: {},
    /**
     * This is the most high-level function in Prism’s API.
     * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
     * each one of them.
     *
     * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
     *
     * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
     * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
     * @memberof Prism
     * @public
     */
    highlightAll: function (async, callback) {
      _.highlightAllUnder(document, async, callback);
    },
    /**
     * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
     * {@link Prism.highlightElement} on each one of them.
     *
     * The following hooks will be run:
     * 1. `before-highlightall`
     * 2. `before-all-elements-highlight`
     * 3. All hooks of {@link Prism.highlightElement} for each element.
     *
     * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
     * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
     * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
     * @memberof Prism
     * @public
     */
    highlightAllUnder: function (container, async, callback) {
      var env = {
        callback: callback,
        container: container,
        selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
      };
      _.hooks.run('before-highlightall', env);
      env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
      _.hooks.run('before-all-elements-highlight', env);
      for (var i = 0, element; element = env.elements[i++];) {
        _.highlightElement(element, async === true, env.callback);
      }
    },
    /**
     * Highlights the code inside a single element.
     *
     * The following hooks will be run:
     * 1. `before-sanity-check`
     * 2. `before-highlight`
     * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
     * 4. `before-insert`
     * 5. `after-highlight`
     * 6. `complete`
     *
     * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
     * the element's language.
     *
     * @param {Element} element The element containing the code.
     * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
     * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
     * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
     * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
     *
     * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
     * asynchronous highlighting to work. You can build your own bundle on the
     * [Download page](https://prismjs.com/download.html).
     * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
     * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
     * @memberof Prism
     * @public
     */
    highlightElement: function (element, async, callback) {
      // Find language
      var language = _.util.getLanguage(element);
      var grammar = _.languages[language];

      // Set language on the element, if not present
      _.util.setLanguage(element, language);

      // Set language on the parent, for styling
      var parent = element.parentElement;
      if (parent && parent.nodeName.toLowerCase() === 'pre') {
        _.util.setLanguage(parent, language);
      }
      var code = element.textContent;
      var env = {
        element: element,
        language: language,
        grammar: grammar,
        code: code
      };
      function insertHighlightedCode(highlightedCode) {
        env.highlightedCode = highlightedCode;
        _.hooks.run('before-insert', env);
        env.element.innerHTML = env.highlightedCode;
        _.hooks.run('after-highlight', env);
        _.hooks.run('complete', env);
        callback && callback.call(env.element);
      }
      _.hooks.run('before-sanity-check', env);

      // plugins may change/add the parent/element
      parent = env.element.parentElement;
      if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
        parent.setAttribute('tabindex', '0');
      }
      if (!env.code) {
        _.hooks.run('complete', env);
        callback && callback.call(env.element);
        return;
      }
      _.hooks.run('before-highlight', env);
      if (!env.grammar) {
        insertHighlightedCode(_.util.encode(env.code));
        return;
      }
      if (async && _self.Worker) {
        var worker = new Worker(_.filename);
        worker.onmessage = function (evt) {
          insertHighlightedCode(evt.data);
        };
        worker.postMessage(JSON.stringify({
          language: env.language,
          code: env.code,
          immediateClose: true
        }));
      } else {
        insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
      }
    },
    /**
     * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
     * and the language definitions to use, and returns a string with the HTML produced.
     *
     * The following hooks will be run:
     * 1. `before-tokenize`
     * 2. `after-tokenize`
     * 3. `wrap`: On each {@link Token}.
     *
     * @param {string} text A string with the code to be highlighted.
     * @param {Grammar} grammar An object containing the tokens to use.
     *
     * Usually a language definition like `Prism.languages.markup`.
     * @param {string} language The name of the language definition passed to `grammar`.
     * @returns {string} The highlighted HTML.
     * @memberof Prism
     * @public
     * @example
     * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
     */
    highlight: function (text, grammar, language) {
      var env = {
        code: text,
        grammar: grammar,
        language: language
      };
      _.hooks.run('before-tokenize', env);
      if (!env.grammar) {
        throw new Error('The language "' + env.language + '" has no grammar.');
      }
      env.tokens = _.tokenize(env.code, env.grammar);
      _.hooks.run('after-tokenize', env);
      return Token.stringify(_.util.encode(env.tokens), env.language);
    },
    /**
     * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
     * and the language definitions to use, and returns an array with the tokenized code.
     *
     * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
     *
     * This method could be useful in other contexts as well, as a very crude parser.
     *
     * @param {string} text A string with the code to be highlighted.
     * @param {Grammar} grammar An object containing the tokens to use.
     *
     * Usually a language definition like `Prism.languages.markup`.
     * @returns {TokenStream} An array of strings and tokens, a token stream.
     * @memberof Prism
     * @public
     * @example
     * let code = `var foo = 0;`;
     * let tokens = Prism.tokenize(code, Prism.languages.javascript);
     * tokens.forEach(token => {
     *     if (token instanceof Prism.Token && token.type === 'number') {
     *         console.log(`Found numeric literal: ${token.content}`);
     *     }
     * });
     */
    tokenize: function (text, grammar) {
      var rest = grammar.rest;
      if (rest) {
        for (var token in rest) {
          grammar[token] = rest[token];
        }
        delete grammar.rest;
      }
      var tokenList = new LinkedList();
      addAfter(tokenList, tokenList.head, text);
      matchGrammar(text, tokenList, grammar, tokenList.head, 0);
      return toArray(tokenList);
    },
    /**
     * @namespace
     * @memberof Prism
     * @public
     */
    hooks: {
      all: {},
      /**
       * Adds the given callback to the list of callbacks for the given hook.
       *
       * The callback will be invoked when the hook it is registered for is run.
       * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
       *
       * One callback function can be registered to multiple hooks and the same hook multiple times.
       *
       * @param {string} name The name of the hook.
       * @param {HookCallback} callback The callback function which is given environment variables.
       * @public
       */
      add: function (name, callback) {
        var hooks = _.hooks.all;
        hooks[name] = hooks[name] || [];
        hooks[name].push(callback);
      },
      /**
       * Runs a hook invoking all registered callbacks with the given environment variables.
       *
       * Callbacks will be invoked synchronously and in the order in which they were registered.
       *
       * @param {string} name The name of the hook.
       * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
       * @public
       */
      run: function (name, env) {
        var callbacks = _.hooks.all[name];
        if (!callbacks || !callbacks.length) {
          return;
        }
        for (var i = 0, callback; callback = callbacks[i++];) {
          callback(env);
        }
      }
    },
    Token: Token
  };
  _self.Prism = _;

  // Typescript note:
  // The following can be used to import the Token type in JSDoc:
  //
  //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

  /**
   * Creates a new token.
   *
   * @param {string} type See {@link Token#type type}
   * @param {string | TokenStream} content See {@link Token#content content}
   * @param {string|string[]} [alias] The alias(es) of the token.
   * @param {string} [matchedStr=""] A copy of the full string this token was created from.
   * @class
   * @global
   * @public
   */
  function Token(type, content, alias, matchedStr) {
    /**
     * The type of the token.
     *
     * This is usually the key of a pattern in a {@link Grammar}.
     *
     * @type {string}
     * @see GrammarToken
     * @public
     */
    this.type = type;
    /**
     * The strings or tokens contained by this token.
     *
     * This will be a token stream if the pattern matched also defined an `inside` grammar.
     *
     * @type {string | TokenStream}
     * @public
     */
    this.content = content;
    /**
     * The alias(es) of the token.
     *
     * @type {string|string[]}
     * @see GrammarToken
     * @public
     */
    this.alias = alias;
    // Copy of the full string this token was created from
    this.length = (matchedStr || '').length | 0;
  }

  /**
   * A token stream is an array of strings and {@link Token Token} objects.
   *
   * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
   * them.
   *
   * 1. No adjacent strings.
   * 2. No empty strings.
   *
   *    The only exception here is the token stream that only contains the empty string and nothing else.
   *
   * @typedef {Array<string | Token>} TokenStream
   * @global
   * @public
   */

  /**
   * Converts the given token or token stream to an HTML representation.
   *
   * The following hooks will be run:
   * 1. `wrap`: On each {@link Token}.
   *
   * @param {string | Token | TokenStream} o The token or token stream to be converted.
   * @param {string} language The name of current language.
   * @returns {string} The HTML representation of the token or token stream.
   * @memberof Token
   * @static
   */
  Token.stringify = function stringify(o, language) {
    if (typeof o == 'string') {
      return o;
    }
    if (Array.isArray(o)) {
      var s = '';
      o.forEach(function (e) {
        s += stringify(e, language);
      });
      return s;
    }
    var env = {
      type: o.type,
      content: stringify(o.content, language),
      tag: 'span',
      classes: ['token', o.type],
      attributes: {},
      language: language
    };
    var aliases = o.alias;
    if (aliases) {
      if (Array.isArray(aliases)) {
        Array.prototype.push.apply(env.classes, aliases);
      } else {
        env.classes.push(aliases);
      }
    }
    _.hooks.run('wrap', env);
    var attributes = '';
    for (var name in env.attributes) {
      attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
    }
    return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
  };

  /**
   * @param {RegExp} pattern
   * @param {number} pos
   * @param {string} text
   * @param {boolean} lookbehind
   * @returns {RegExpExecArray | null}
   */
  function matchPattern(pattern, pos, text, lookbehind) {
    pattern.lastIndex = pos;
    var match = pattern.exec(text);
    if (match && lookbehind && match[1]) {
      // change the match to remove the text matched by the Prism lookbehind group
      var lookbehindLength = match[1].length;
      match.index += lookbehindLength;
      match[0] = match[0].slice(lookbehindLength);
    }
    return match;
  }

  /**
   * @param {string} text
   * @param {LinkedList<string | Token>} tokenList
   * @param {any} grammar
   * @param {LinkedListNode<string | Token>} startNode
   * @param {number} startPos
   * @param {RematchOptions} [rematch]
   * @returns {void}
   * @private
   *
   * @typedef RematchOptions
   * @property {string} cause
   * @property {number} reach
   */
  function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
    for (var token in grammar) {
      if (!grammar.hasOwnProperty(token) || !grammar[token]) {
        continue;
      }
      var patterns = grammar[token];
      patterns = Array.isArray(patterns) ? patterns : [patterns];
      for (var j = 0; j < patterns.length; ++j) {
        if (rematch && rematch.cause == token + ',' + j) {
          return;
        }
        var patternObj = patterns[j];
        var inside = patternObj.inside;
        var lookbehind = !!patternObj.lookbehind;
        var greedy = !!patternObj.greedy;
        var alias = patternObj.alias;
        if (greedy && !patternObj.pattern.global) {
          // Without the global flag, lastIndex won't work
          var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
          patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
        }

        /** @type {RegExp} */
        var pattern = patternObj.pattern || patternObj;
        for (
        // iterate the token list and keep track of the current token/string position
        var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next) {
          if (rematch && pos >= rematch.reach) {
            break;
          }
          var str = currentNode.value;
          if (tokenList.length > text.length) {
            // Something went terribly wrong, ABORT, ABORT!
            return;
          }
          if (str instanceof Token) {
            continue;
          }
          var removeCount = 1; // this is the to parameter of removeBetween
          var match;
          if (greedy) {
            match = matchPattern(pattern, pos, text, lookbehind);
            if (!match || match.index >= text.length) {
              break;
            }
            var from = match.index;
            var to = match.index + match[0].length;
            var p = pos;

            // find the node that contains the match
            p += currentNode.value.length;
            while (from >= p) {
              currentNode = currentNode.next;
              p += currentNode.value.length;
            }
            // adjust pos (and p)
            p -= currentNode.value.length;
            pos = p;

            // the current node is a Token, then the match starts inside another Token, which is invalid
            if (currentNode.value instanceof Token) {
              continue;
            }

            // find the last node which is affected by this match
            for (var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next) {
              removeCount++;
              p += k.value.length;
            }
            removeCount--;

            // replace with the new match
            str = text.slice(pos, p);
            match.index -= pos;
          } else {
            match = matchPattern(pattern, 0, str, lookbehind);
            if (!match) {
              continue;
            }
          }

          // eslint-disable-next-line no-redeclare
          var from = match.index;
          var matchStr = match[0];
          var before = str.slice(0, from);
          var after = str.slice(from + matchStr.length);
          var reach = pos + str.length;
          if (rematch && reach > rematch.reach) {
            rematch.reach = reach;
          }
          var removeFrom = currentNode.prev;
          if (before) {
            removeFrom = addAfter(tokenList, removeFrom, before);
            pos += before.length;
          }
          removeRange(tokenList, removeFrom, removeCount);
          var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
          currentNode = addAfter(tokenList, removeFrom, wrapped);
          if (after) {
            addAfter(tokenList, currentNode, after);
          }
          if (removeCount > 1) {
            // at least one Token object was removed, so we have to do some rematching
            // this can only happen if the current pattern is greedy

            /** @type {RematchOptions} */
            var nestedRematch = {
              cause: token + ',' + j,
              reach: reach
            };
            matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

            // the reach might have been extended because of the rematching
            if (rematch && nestedRematch.reach > rematch.reach) {
              rematch.reach = nestedRematch.reach;
            }
          }
        }
      }
    }
  }

  /**
   * @typedef LinkedListNode
   * @property {T} value
   * @property {LinkedListNode<T> | null} prev The previous node.
   * @property {LinkedListNode<T> | null} next The next node.
   * @template T
   * @private
   */

  /**
   * @template T
   * @private
   */
  function LinkedList() {
    /** @type {LinkedListNode<T>} */
    var head = {
      value: null,
      prev: null,
      next: null
    };
    /** @type {LinkedListNode<T>} */
    var tail = {
      value: null,
      prev: head,
      next: null
    };
    head.next = tail;

    /** @type {LinkedListNode<T>} */
    this.head = head;
    /** @type {LinkedListNode<T>} */
    this.tail = tail;
    this.length = 0;
  }

  /**
   * Adds a new node with the given value to the list.
   *
   * @param {LinkedList<T>} list
   * @param {LinkedListNode<T>} node
   * @param {T} value
   * @returns {LinkedListNode<T>} The added node.
   * @template T
   */
  function addAfter(list, node, value) {
    // assumes that node != list.tail && values.length >= 0
    var next = node.next;
    var newNode = {
      value: value,
      prev: node,
      next: next
    };
    node.next = newNode;
    next.prev = newNode;
    list.length++;
    return newNode;
  }
  /**
   * Removes `count` nodes after the given node. The given node will not be removed.
   *
   * @param {LinkedList<T>} list
   * @param {LinkedListNode<T>} node
   * @param {number} count
   * @template T
   */
  function removeRange(list, node, count) {
    var next = node.next;
    for (var i = 0; i < count && next !== list.tail; i++) {
      next = next.next;
    }
    node.next = next;
    next.prev = node;
    list.length -= i;
  }
  /**
   * @param {LinkedList<T>} list
   * @returns {T[]}
   * @template T
   */
  function toArray(list) {
    var array = [];
    var node = list.head.next;
    while (node !== list.tail) {
      array.push(node.value);
      node = node.next;
    }
    return array;
  }
  if (!_self.document) {
    if (!_self.addEventListener) {
      // in Node.js
      return _;
    }
    if (!_.disableWorkerMessageHandler) {
      // In worker
      _self.addEventListener('message', function (evt) {
        var message = JSON.parse(evt.data);
        var lang = message.language;
        var code = message.code;
        var immediateClose = message.immediateClose;
        _self.postMessage(_.highlight(code, _.languages[lang], lang));
        if (immediateClose) {
          _self.close();
        }
      }, false);
    }
    return _;
  }

  // Get current script and highlight
  var script = _.util.currentScript();
  if (script) {
    _.filename = script.src;
    if (script.hasAttribute('data-manual')) {
      _.manual = true;
    }
  }
  function highlightAutomaticallyCallback() {
    if (!_.manual) {
      _.highlightAll();
    }
  }
  if (!_.manual) {
    // If the document state is "loading", then we'll use DOMContentLoaded.
    // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
    // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
    // might take longer one animation frame to execute which can create a race condition where only some plugins have
    // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
    // See https://github.com/PrismJS/prism/issues/2102
    var readyState = document.readyState;
    if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
      document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
    } else {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(highlightAutomaticallyCallback);
      } else {
        window.setTimeout(highlightAutomaticallyCallback, 16);
      }
    }
  }
  return _;
}(_self);
if (module.exports) {
  module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof commonjsGlobal !== 'undefined') {
  commonjsGlobal.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */
}(prismCore));

var markup_1 = markup$1;
markup$1.displayName = 'markup';
markup$1.aliases = ['html', 'mathml', 'svg', 'xml', 'ssml', 'atom', 'rss'];
function markup$1(Prism) {
  Prism.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: true
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: true
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: true,
      inside: {
        'internal-subset': {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: true,
          greedy: true,
          inside: null // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: true
        },
        punctuation: /^<!|>$|[[\]]/,
        'doctype-tag': /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: true
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: true,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        'special-attr': [],
        'attr-value': {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [{
              pattern: /^=/,
              alias: 'attr-equals'
            }, /"|'/]
          }
        },
        punctuation: /\/?>/,
        'attr-name': {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [{
      pattern: /&[\da-z]{1,8};/i,
      alias: 'named-entity'
    }, /&#x?[\da-f]{1,8};/i]
  };
  Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
  Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup; // Plugin to make entity title show the real entity, idea by Roman Komarov
  Prism.hooks.add('wrap', function (env) {
    if (env.type === 'entity') {
      env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    }
  });
  Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function addInlined(tagName, lang) {
      var includedCdataInside = {};
      includedCdataInside['language-' + lang] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: true,
        inside: Prism.languages[lang]
      };
      includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
      var inside = {
        'included-cdata': {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: includedCdataInside
        }
      };
      inside['language-' + lang] = {
        pattern: /[\s\S]+/,
        inside: Prism.languages[lang]
      };
      var def = {};
      def[tagName] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () {
          return tagName;
        }), 'i'),
        lookbehind: true,
        greedy: true,
        inside: inside
      };
      Prism.languages.insertBefore('markup', 'cdata', def);
    }
  });
  Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function (attrName, lang) {
      Prism.languages.markup.tag.inside['special-attr'].push({
        pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
        lookbehind: true,
        inside: {
          'attr-name': /^[^\s=]+/,
          'attr-value': {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: true,
                alias: [lang, 'language-' + lang],
                inside: Prism.languages[lang]
              },
              punctuation: [{
                pattern: /^=/,
                alias: 'attr-equals'
              }, /"|'/]
            }
          }
        }
      });
    }
  });
  Prism.languages.html = Prism.languages.markup;
  Prism.languages.mathml = Prism.languages.markup;
  Prism.languages.svg = Prism.languages.markup;
  Prism.languages.xml = Prism.languages.extend('markup', {});
  Prism.languages.ssml = Prism.languages.xml;
  Prism.languages.atom = Prism.languages.xml;
  Prism.languages.rss = Prism.languages.xml;
}

var css_1 = css$2;
css$2.displayName = 'css';
css$2.aliases = [];
function css$2(Prism) {
  (function (Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          'selector-function-argument': {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: true,
            alias: 'selector'
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: true
          } // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
        greedy: true,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp('^' + string.source + '$'),
            alias: 'url'
          }
        }
      },
      selector: {
        pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
        lookbehind: true
      },
      string: {
        pattern: string,
        greedy: true
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: true
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: true
      },
      punctuation: /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
      markup.tag.addInlined('style', 'css');
      markup.tag.addAttribute('style', 'css');
    }
  })(Prism);
}

var clike_1 = clike$1;
clike$1.displayName = 'clike';
clike$1.aliases = [];
function clike$1(Prism) {
  Prism.languages.clike = {
    comment: [{
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: true,
      greedy: true
    }, {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: true,
      greedy: true
    }],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    'class-name': {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: true,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  };
}

var javascript_1 = javascript;
javascript.displayName = 'javascript';
javascript.aliases = ['js'];
function javascript(Prism) {
  Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [Prism.languages.clike['class-name'], {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
      lookbehind: true
    }],
    keyword: [{
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: true
    }, {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: true
    }],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(/(^|[^\w$])/.source + '(?:' + (
      // constant
      /NaN|Infinity/.source + '|' +
      // binary integer
      /0[bB][01]+(?:_[01]+)*n?/.source + '|' +
      // octal integer
      /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' +
      // hexadecimal integer
      /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' +
      // decimal bigint
      /\d+(?:_\d+)*n/.source + '|' +
      // decimal number (integer or float) but no bigint
      /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
      lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  });
  Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
  Prism.languages.insertBefore('javascript', 'keyword', {
    regex: {
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
      lookbehind: true,
      greedy: true,
      inside: {
        'regex-source': {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: true,
          alias: 'language-regex',
          inside: Prism.languages.regex
        },
        'regex-delimiter': /^\/|\/$/,
        'regex-flags': /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: 'function'
    },
    parameter: [{
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: true,
      inside: Prism.languages.javascript
    }, {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: true,
      inside: Prism.languages.javascript
    }, {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: true,
      inside: Prism.languages.javascript
    }, {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: true,
      inside: Prism.languages.javascript
    }],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  });
  Prism.languages.insertBefore('javascript', 'string', {
    hashbang: {
      pattern: /^#!.*/,
      greedy: true,
      alias: 'comment'
    },
    'template-string': {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: true,
      inside: {
        'template-punctuation': {
          pattern: /^`|`$/,
          alias: 'string'
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: true,
          inside: {
            'interpolation-punctuation': {
              pattern: /^\$\{|\}$/,
              alias: 'punctuation'
            },
            rest: Prism.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    'string-property': {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: true,
      greedy: true,
      alias: 'property'
    }
  });
  Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: true,
      alias: 'property'
    }
  });
  if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript'); // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
  }
  Prism.languages.js = Prism.languages.javascript;
}

/* global window, self */

// istanbul ignore next - Don't allow Prism to run on page load in browser or
// to start messaging from workers.
var ctx = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof commonjsGlobal === 'object' ? commonjsGlobal : {};
var restore = capture();
ctx.Prism = {
  manual: true,
  disableWorkerMessageHandler: true
};

// Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
var h = hastscript;
var decode = parseEntities_1;
var Prism = prismCore.exports;
var markup = markup_1;
var css$1 = css_1;
var clike = clike_1;
var js = javascript_1;
restore();
var own = {}.hasOwnProperty;

// Inherit.
function Refractor() {}
Refractor.prototype = Prism;

// Construct.
var refract = new Refractor();

// Expose.
var core = refract;

// Create.
refract.highlight = highlight;
refract.register = register;
refract.alias = alias;
refract.registered = registered;
refract.listLanguages = listLanguages;

// Register bundled grammars.
register(markup);
register(css$1);
register(clike);
register(js);
refract.util.encode = encode;
refract.Token.stringify = stringify;
function register(grammar) {
  if (typeof grammar !== 'function' || !grammar.displayName) {
    throw new Error('Expected `function` for `grammar`, got `' + grammar + '`');
  }

  // Do not duplicate registrations.
  if (refract.languages[grammar.displayName] === undefined) {
    grammar(refract);
  }
}
function alias(name, alias) {
  var languages = refract.languages;
  var map = name;
  var key;
  var list;
  var length;
  var index;
  if (alias) {
    map = {};
    map[name] = alias;
  }
  for (key in map) {
    list = map[key];
    list = typeof list === 'string' ? [list] : list;
    length = list.length;
    index = -1;
    while (++index < length) {
      languages[list[index]] = languages[key];
    }
  }
}
function highlight(value, name) {
  var sup = Prism.highlight;
  var grammar;
  if (typeof value !== 'string') {
    throw new Error('Expected `string` for `value`, got `' + value + '`');
  }

  // `name` is a grammar object.
  if (refract.util.type(name) === 'Object') {
    grammar = name;
    name = null;
  } else {
    if (typeof name !== 'string') {
      throw new Error('Expected `string` for `name`, got `' + name + '`');
    }
    if (own.call(refract.languages, name)) {
      grammar = refract.languages[name];
    } else {
      throw new Error('Unknown language: `' + name + '` is not registered');
    }
  }
  return sup.call(this, value, grammar, name);
}
function registered(language) {
  if (typeof language !== 'string') {
    throw new Error('Expected `string` for `language`, got `' + language + '`');
  }
  return own.call(refract.languages, language);
}
function listLanguages() {
  var languages = refract.languages;
  var list = [];
  var language;
  for (language in languages) {
    if (own.call(languages, language) && typeof languages[language] === 'object') {
      list.push(language);
    }
  }
  return list;
}
function stringify(value, language, parent) {
  var env;
  if (typeof value === 'string') {
    return {
      type: 'text',
      value: value
    };
  }
  if (refract.util.type(value) === 'Array') {
    return stringifyAll(value, language);
  }
  env = {
    type: value.type,
    content: refract.Token.stringify(value.content, language, parent),
    tag: 'span',
    classes: ['token', value.type],
    attributes: {},
    language: language,
    parent: parent
  };
  if (value.alias) {
    env.classes = env.classes.concat(value.alias);
  }
  refract.hooks.run('wrap', env);
  return h(env.tag + '.' + env.classes.join('.'), attributes(env.attributes), env.content);
}
function stringifyAll(values, language) {
  var result = [];
  var length = values.length;
  var index = -1;
  var value;
  while (++index < length) {
    value = values[index];
    if (value !== '' && value !== null && value !== undefined) {
      result.push(value);
    }
  }
  index = -1;
  length = result.length;
  while (++index < length) {
    value = result[index];
    result[index] = refract.Token.stringify(value, language, result);
  }
  return result;
}
function encode(tokens) {
  return tokens;
}
function attributes(attrs) {
  var key;
  for (key in attrs) {
    attrs[key] = decode(attrs[key]);
  }
  return attrs;
}
function capture() {
  var defined = 'Prism' in ctx;
  /* istanbul ignore next */
  var current = defined ? ctx.Prism : undefined;
  return restore;
  function restore() {
    /* istanbul ignore else - Clean leaks after Prism. */
    if (defined) {
      ctx.Prism = current;
    } else {
      delete ctx.Prism;
    }
    defined = undefined;
    current = undefined;
  }
}

var SyntaxHighlighter$1 = highlight$1(core, {});
SyntaxHighlighter$1.registerLanguage = function (_, language) {
  return core.register(language);
};
SyntaxHighlighter$1.alias = function (name, aliases) {
  return core.alias(name, aliases);
};
var SyntaxHighlighter$2 = SyntaxHighlighter$1;

var bash_1 = bash;
bash.displayName = 'bash';
bash.aliases = ['shell'];
function bash(Prism) {
  (function (Prism) {
    // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
    // + LC_ALL, RANDOM, REPLY, SECONDS.
    // + make sure PS1..4 are here as they are not always set,
    // - some useless things.
    var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
    var commandAfterHeredoc = {
      pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
      lookbehind: true,
      alias: 'punctuation',
      // this looks reasonably well in all themes
      inside: null // see below
    };
    var insideString = {
      bash: commandAfterHeredoc,
      environment: {
        pattern: RegExp('\\$' + envVars),
        alias: 'constant'
      },
      variable: [
      // [0]: Arithmetic Environment
      {
        pattern: /\$?\(\([\s\S]+?\)\)/,
        greedy: true,
        inside: {
          // If there is a $ sign at the beginning highlight $(( and )) as variable
          variable: [{
            pattern: /(^\$\(\([\s\S]+)\)\)/,
            lookbehind: true
          }, /^\$\(\(/],
          number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
          // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
          operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
          // If there is no $ sign at the beginning highlight (( and )) as punctuation
          punctuation: /\(\(?|\)\)?|,|;/
        }
      },
      // [1]: Command Substitution
      {
        pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
        greedy: true,
        inside: {
          variable: /^\$\(|^`|\)$|`$/
        }
      },
      // [2]: Brace expansion
      {
        pattern: /\$\{[^}]+\}/,
        greedy: true,
        inside: {
          operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
          punctuation: /[\[\]]/,
          environment: {
            pattern: RegExp('(\\{)' + envVars),
            lookbehind: true,
            alias: 'constant'
          }
        }
      }, /\$(?:\w+|[#?*!@$])/],
      // Escape sequences from echo and printf's manuals, and escaped quotes.
      entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
    };
    Prism.languages.bash = {
      shebang: {
        pattern: /^#!\s*\/.*/,
        alias: 'important'
      },
      comment: {
        pattern: /(^|[^"{\\$])#.*/,
        lookbehind: true
      },
      'function-name': [
      // a) function foo {
      // b) foo() {
      // c) function foo() {
      // but not “foo {”
      {
        // a) and c)
        pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
        lookbehind: true,
        alias: 'function'
      }, {
        // b)
        pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
        alias: 'function'
      }],
      // Highlight variable names as variables in for and select beginnings.
      'for-or-select': {
        pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
        alias: 'variable',
        lookbehind: true
      },
      // Highlight variable names as variables in the left-hand part
      // of assignments (“=” and “+=”).
      'assign-left': {
        pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
        inside: {
          environment: {
            pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
            lookbehind: true,
            alias: 'constant'
          }
        },
        alias: 'variable',
        lookbehind: true
      },
      string: [
      // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
      {
        pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
        lookbehind: true,
        greedy: true,
        inside: insideString
      },
      // Here-document with quotes around the tag
      // → No expansion (so no “inside”).
      {
        pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
        lookbehind: true,
        greedy: true,
        inside: {
          bash: commandAfterHeredoc
        }
      },
      // “Normal” string
      {
        // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
        pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
        lookbehind: true,
        greedy: true,
        inside: insideString
      }, {
        // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
        pattern: /(^|[^$\\])'[^']*'/,
        lookbehind: true,
        greedy: true
      }, {
        // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
        pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
        greedy: true,
        inside: {
          entity: insideString.entity
        }
      }],
      environment: {
        pattern: RegExp('\\$?' + envVars),
        alias: 'constant'
      },
      variable: insideString.variable,
      function: {
        pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
        lookbehind: true
      },
      keyword: {
        pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
        lookbehind: true
      },
      // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
      builtin: {
        pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
        lookbehind: true,
        // Alias added to make those easier to distinguish from strings.
        alias: 'class-name'
      },
      boolean: {
        pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
        lookbehind: true
      },
      'file-descriptor': {
        pattern: /\B&\d\b/,
        alias: 'important'
      },
      operator: {
        // Lots of redirections here, but not just that.
        pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
        inside: {
          'file-descriptor': {
            pattern: /^\d/,
            alias: 'important'
          }
        }
      },
      punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
      number: {
        pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
        lookbehind: true
      }
    };
    commandAfterHeredoc.inside = Prism.languages.bash;
    /* Patterns in command substitution. */
    var toBeCopied = ['comment', 'function-name', 'for-or-select', 'assign-left', 'string', 'environment', 'function', 'keyword', 'builtin', 'boolean', 'file-descriptor', 'operator', 'punctuation', 'number'];
    var inside = insideString.variable[1].inside;
    for (var i = 0; i < toBeCopied.length; i++) {
      inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
    }
    Prism.languages.shell = Prism.languages.bash;
  })(Prism);
}

var bash$1 = bash_1;

var hcl_1 = hcl;
hcl.displayName = 'hcl';
hcl.aliases = [];
function hcl(Prism) {
  Prism.languages.hcl = {
    comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
    heredoc: {
      pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
      greedy: true,
      alias: 'string'
    },
    keyword: [{
      pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
      inside: {
        type: {
          pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
          lookbehind: true,
          alias: 'variable'
        }
      }
    }, {
      pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
      inside: {
        type: {
          pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
          lookbehind: true,
          alias: 'variable'
        }
      }
    }, /[\w-]+(?=\s+\{)/],
    property: [/[-\w\.]+(?=\s*=(?!=))/, /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/],
    string: {
      pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
      greedy: true,
      inside: {
        interpolation: {
          pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
          lookbehind: true,
          inside: {
            type: {
              pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
              lookbehind: true,
              alias: 'variable'
            },
            keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
            function: /\w+(?=\()/,
            string: {
              pattern: /"(?:\\[\s\S]|[^\\"])*"/,
              greedy: true
            },
            number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
            punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
          }
        }
      }
    },
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
    boolean: /\b(?:false|true)\b/i,
    punctuation: /[=\[\]{}]/
  };
}

var hcl$1 = hcl_1;

var json_1 = json;
json.displayName = 'json';
json.aliases = ['webmanifest'];
function json(Prism) {
  // https://www.json.org/json-en.html
  Prism.languages.json = {
    property: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
      lookbehind: true,
      greedy: true
    },
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
      lookbehind: true,
      greedy: true
    },
    comment: {
      pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      greedy: true
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
      pattern: /\bnull\b/,
      alias: 'keyword'
    }
  };
  Prism.languages.webmanifest = Prism.languages.json;
}

var json$1 = json_1;

var jsx_1 = jsx$1;
jsx$1.displayName = 'jsx';
jsx$1.aliases = [];
function jsx$1(Prism) {
  (function (Prism) {
    var javascript = Prism.util.clone(Prism.languages.javascript);
    var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
    var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
    var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    /**
     * @param {string} source
     * @param {string} [flags]
     */
    function re(source, flags) {
      source = source.replace(/<S>/g, function () {
        return space;
      }).replace(/<BRACES>/g, function () {
        return braces;
      }).replace(/<SPREAD>/g, function () {
        return spread;
      });
      return RegExp(source, flags);
    }
    spread = re(spread).source;
    Prism.languages.jsx = Prism.languages.extend('markup', javascript);
    Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
    Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
    Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
    Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
    Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
    Prism.languages.insertBefore('inside', 'attr-name', {
      spread: {
        pattern: re(/<SPREAD>/.source),
        inside: Prism.languages.jsx
      }
    }, Prism.languages.jsx.tag);
    Prism.languages.insertBefore('inside', 'special-attr', {
      script: {
        // Allow for two levels of nesting
        pattern: re(/=<BRACES>/.source),
        alias: 'language-javascript',
        inside: {
          'script-punctuation': {
            pattern: /^=(?=\{)/,
            alias: 'punctuation'
          },
          rest: Prism.languages.jsx
        }
      }
    }, Prism.languages.jsx.tag); // The following will handle plain text inside tags
    var stringifyToken = function (token) {
      if (!token) {
        return '';
      }
      if (typeof token === 'string') {
        return token;
      }
      if (typeof token.content === 'string') {
        return token.content;
      }
      return token.content.map(stringifyToken).join('');
    };
    var walkTokens = function (tokens) {
      var openedTags = [];
      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var notTagNorBrace = false;
        if (typeof token !== 'string') {
          if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
            // We found a tag, now find its kind
            if (token.content[0].content[0].content === '</') {
              // Closing tag
              if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) {
                // Pop matching opening tag
                openedTags.pop();
              }
            } else {
              if (token.content[token.content.length - 1].content === '/>') ; else {
                // Opening tag
                openedTags.push({
                  tagName: stringifyToken(token.content[0].content[1]),
                  openedBraces: 0
                });
              }
            }
          } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') {
            // Here we might have entered a JSX context inside a tag
            openedTags[openedTags.length - 1].openedBraces++;
          } else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') {
            // Here we might have left a JSX context inside a tag
            openedTags[openedTags.length - 1].openedBraces--;
          } else {
            notTagNorBrace = true;
          }
        }
        if (notTagNorBrace || typeof token === 'string') {
          if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
            // Here we are inside a tag, and not inside a JSX context.
            // That's plain text: drop any tokens matched.
            var plainText = stringifyToken(token); // And merge text with adjacent text
            if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
              plainText += stringifyToken(tokens[i + 1]);
              tokens.splice(i + 1, 1);
            }
            if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
              plainText = stringifyToken(tokens[i - 1]) + plainText;
              tokens.splice(i - 1, 1);
              i--;
            }
            tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
          }
        }
        if (token.content && typeof token.content !== 'string') {
          walkTokens(token.content);
        }
      }
    };
    Prism.hooks.add('after-tokenize', function (env) {
      if (env.language !== 'jsx' && env.language !== 'tsx') {
        return;
      }
      walkTokens(env.tokens);
    });
  })(Prism);
}

var jsx$2 = jsx_1;

var yaml_1 = yaml;
yaml.displayName = 'yaml';
yaml.aliases = ['yml'];
function yaml(Prism) {
  (function (Prism) {
    // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
    // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
    var anchorOrAlias = /[*&][^\s[\]{},]+/; // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
    var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/; // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
    var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)'; // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
    // This is a simplified version that doesn't support "#" and multiline keys
    // All these long scarry character classes are simplified versions of YAML's characters
    var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function () {
      return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    });
    var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    /**
     *
     * @param {string} value
     * @param {string} [flags]
     * @returns {RegExp}
     */
    function createValuePattern(value, flags) {
      flags = (flags || '').replace(/m/g, '') + 'm'; // add m flag
      var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function () {
        return properties;
      }).replace(/<<value>>/g, function () {
        return value;
      });
      return RegExp(pattern, flags);
    }
    Prism.languages.yaml = {
      scalar: {
        pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function () {
          return properties;
        })),
        lookbehind: true,
        alias: 'string'
      },
      comment: /#.*/,
      key: {
        pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function () {
          return properties;
        }).replace(/<<key>>/g, function () {
          return '(?:' + plainKey + '|' + string + ')';
        })),
        lookbehind: true,
        greedy: true,
        alias: 'atrule'
      },
      directive: {
        pattern: /(^[ \t]*)%.+/m,
        lookbehind: true,
        alias: 'important'
      },
      datetime: {
        pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
        lookbehind: true,
        alias: 'number'
      },
      boolean: {
        pattern: createValuePattern(/false|true/.source, 'i'),
        lookbehind: true,
        alias: 'important'
      },
      null: {
        pattern: createValuePattern(/null|~/.source, 'i'),
        lookbehind: true,
        alias: 'important'
      },
      string: {
        pattern: createValuePattern(string),
        lookbehind: true,
        greedy: true
      },
      number: {
        pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
        lookbehind: true
      },
      tag: tag,
      important: anchorOrAlias,
      punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    };
    Prism.languages.yml = Prism.languages.yaml;
  })(Prism);
}

var yaml$1 = yaml_1;

var _excluded$3 = ["children"];
SyntaxHighlighter$2.registerLanguage('json', json$1);
SyntaxHighlighter$2.registerLanguage('javascript', javascript_1);
SyntaxHighlighter$2.registerLanguage('jsx', jsx$2);
SyntaxHighlighter$2.registerLanguage('yaml', yaml$1);
SyntaxHighlighter$2.registerLanguage('bash', bash$1);
SyntaxHighlighter$2.registerLanguage('hcl', hcl$1);
var style = function style() {
  var wordBreak = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "normal";
  return {
    "code[class*=\"language-\"]": {
      "color": "var(--text-primary)",
      "background": "none",
      "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      "fontSize": "0.875em",
      "textAlign": "left",
      "whiteSpace": "pre",
      "wordSpacing": "normal",
      "wordBreak": wordBreak,
      "wordWrap": "normal",
      "lineHeight": "1.5",
      "MozTabSize": "4",
      "OTabSize": "4",
      "tabSize": "4",
      "WebkitHyphens": "none",
      "MozHyphens": "none",
      "msHyphens": "none",
      "hyphens": "none"
    },
    "pre[class*=\"language-\"]": {
      "color": "var(--text-primary)",
      "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
      "fontSize": "0.875em",
      "textAlign": "left",
      "whiteSpace": "pre",
      "wordSpacing": "normal",
      "wordBreak": "normal",
      "wordWrap": "normal",
      "lineHeight": "1.5",
      "MozTabSize": "4",
      "OTabSize": "4",
      "tabSize": "4",
      "WebkitHyphens": "none",
      "MozHyphens": "none",
      "msHyphens": "none",
      "hyphens": "none"
    },
    "pre[class*=\"language-\"]::-moz-selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "pre[class*=\"language-\"] ::-moz-selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "code[class*=\"language-\"]::-moz-selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "code[class*=\"language-\"] ::-moz-selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "pre[class*=\"language-\"]::selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "pre[class*=\"language-\"] ::selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "code[class*=\"language-\"]::selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    "code[class*=\"language-\"] ::selection": {
      "textShadow": "none",
      "background": "var(--hover-background)"
    },
    ":not(pre) > code[class*=\"language-\"]": {
      "background": "transparent",
      "padding": ".1em",
      "borderRadius": ".3em",
      "whiteSpace": "normal"
    },
    "comment": {
      "color": "var(--text-secondary)"
    },
    "prolog": {
      "color": "var(--text-secondary)"
    },
    "doctype": {
      "color": "var(--text-secondary)"
    },
    "cdata": {
      "color": "var(--text-secondary)"
    },
    "punctuation": {
      "color": "var(--text-title)"
    },
    "namespace": {
      "Opacity": ".7"
    },
    "property": {
      "color": "var(--text-button-primary-hover)"
    },
    "tag": {
      "color": "var(--chart-10)"
    },
    "boolean": {
      "color": "var(--warning)"
    },
    "number": {
      "color": "var(--info)"
    },
    "constant": {
      "color": "var(--chart-10)"
    },
    "symbol": {
      "color": "var(--chart-10)"
    },
    "deleted": {
      "color": "var(--chart-10)"
    },
    "selector": {
      "color": "var(--success)"
    },
    "attr-name": {
      "color": "var(--success)"
    },
    "string": {
      "color": "var(--success)"
    },
    "char": {
      "color": "var(--success)"
    },
    "builtin": {
      "color": "var(--success)"
    },
    "inserted": {
      "color": "var(--success)"
    },
    "operator": {
      "color": "var(--text-title)"
    },
    "entity": {
      "color": "var(--success)"
    },
    "url": {
      "color": "var(--chart-6)"
    },
    ".language-css .token.string": {
      "color": "var(--chart-6)"
    },
    ".style .token.string": {
      "color": "var(--chart-6)"
    },
    "atrule": {
      "color": "var(--text-button-primary-hover)"
    },
    "attr-value": {
      "color": "var(--chart-3)"
    },
    "keyword :not(null)": {
      "color": "var(--chart-3)"
    },
    "function": {
      "color": "var(--chart-7)"
    },
    "class-name": {
      "color": "var(--error)"
    },
    "regex": {
      "color": "var(--warning)"
    },
    "important": {
      "color": "var(--warning)",
      "fontWeight": "bold"
    },
    "variable": {
      "color": "var(--warning)"
    },
    "bold": {
      "fontWeight": "bold"
    },
    "italic": {
      "fontStyle": "italic"
    }
  };
};
var SyntaxHighlighter = /*#__PURE__*/React__default.memo(function (_ref) {
  var _children = _ref.children,
    props = _objectWithoutProperties$2(_ref, _excluded$3);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    children = _useState2[0],
    setChildren = _useState2[1];
  useEffect(function () {
    var children = _$1.isObject(_children) ? JSON.stringify(_children, null, 4) : _children;
    setChildren(children);
  }, [_children]);
  return children && /*#__PURE__*/React__default.createElement(SyntaxHighlighter$2, _extends$j({
    style: style(props.wordbreak)
  }, props), children);
});

var styles$l = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","container":"OverviewBanner-module_container__1QVhi","info-item":"OverviewBanner-module_info-item__1zikk","divider":"OverviewBanner-module_divider__2hCgJ","icon":"OverviewBanner-module_icon__3D8mA","value":"OverviewBanner-module_value__2iOaC","label":"OverviewBanner-module_label__1f5vp","bgshimmer":"OverviewBanner-module_bgshimmer__2VoA1"};

var _excluded$2 = ["className", "icon", "label", "value", "removeDivider", "style"],
  _excluded2 = ["children", "className", "customInfoItemComp", "infoItems"];
var DefaultInfoItem = function DefaultInfoItem(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    label = _ref.label,
    value = _ref.value,
    removeDivider = _ref.removeDivider,
    style = _ref.style,
    props = _objectWithoutProperties$2(_ref, _excluded$2);
  var Icon = icon;
  return /*#__PURE__*/React__default.createElement("div", _extends$j({
    className: classNames(typography.body14, styles$l["info-item"], _defineProperty$3({}, styles$l["divider"], !removeDivider), className),
    style: style
  }, props), /*#__PURE__*/React__default.createElement(Icon, {
    className: styles$l["icon"]
  }), /*#__PURE__*/React__default.createElement("div", {
    title: typeof value === 'string' ? value : "",
    className: styles$l["value"]
  }, value), /*#__PURE__*/React__default.createElement("div", {
    className: styles$l["label"]
  }, label));
};
var OverviewBanner = (function (_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$customInfoItemC = _ref2.customInfoItemComp,
    customInfoItemComp = _ref2$customInfoItemC === void 0 ? DefaultInfoItem : _ref2$customInfoItemC,
    infoItems = _ref2.infoItems,
    props = _objectWithoutProperties$2(_ref2, _excluded2);
  var Item = customInfoItemComp;
  return /*#__PURE__*/React__default.createElement("div", _extends$j({
    className: classNames(styles$l["container"], className)
  }, props), infoItems && infoItems.map(function (item, i) {
    return /*#__PURE__*/React__default.createElement(Item, _extends$j({
      key: i,
      icon: item.icon,
      label: item.label,
      value: item.value
    }, item));
  }), !infoItems && children);
});

var styles$k = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"InlineNotification-module_base__1IRZM","icon":"InlineNotification-module_icon__3Ssy2","success":"InlineNotification-module_success__p9kjW","error":"InlineNotification-module_error__Bhagi","urgent":"InlineNotification-module_urgent__1f24u","warning":"InlineNotification-module_warning__2eAFP","info":"InlineNotification-module_info__2mIVh","critical":"InlineNotification-module_critical__1Ov_A","disabled":"InlineNotification-module_disabled__1MuMU","bgshimmer":"InlineNotification-module_bgshimmer__tnQYl"};

const iconTypeMapper = {
    error: { icon: ErrorIcon },
    warning: { icon: NoticeTriangleIcon },
    success: { icon: SuccessIcon },
    info: { icon: InfoIcon },
    urgent: { icon: NoticeTriangleIcon },
    critical: { icon: NoticeIcon }
};
var InlineNotification = (_a) => {
    var { children, type, className, style, prefix, isDisabled, dataTestId } = _a, rest = __rest(_a, ["children", "type", "className", "style", "prefix", "isDisabled", "dataTestId"]);
    const Icon = iconTypeMapper[type].icon;
    return (jsxs("div", Object.assign({ className: classNames(styles$k["base"], styles$k[type], { [styles$k.disabled]: isDisabled }, className), "data-testid": dataTestId, style: style }, rest, { children: [jsx$3(Icon, { className: styles$k["icon"] }), jsxs(Span, { children: [prefix && jsxs(Span, { bold: true, children: [prefix, ": "] }), children] })] })));
};

var styles$j = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"Breadcrumbs-module_base__1G3bh","wrapper":"Breadcrumbs-module_wrapper__1g16L","dots":"Breadcrumbs-module_dots__2UcQ1","last-crumb":"Breadcrumbs-module_last-crumb__1gAYN"};

var LastCrumb = function LastCrumb(_ref) {
  var child = _ref.child;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$j['last-crumb']
  }, child);
};
var Crumb = function Crumb(_ref2) {
  var child = _ref2.child,
    isOverflow = _ref2.isOverflow;
  if (isOverflow) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$j.wrapper
    }, child, /*#__PURE__*/React__default.createElement(Tooltip$1, null, child.props.children));
  } else {
    return child;
  }
};
var Breadcrumbs = /*#__PURE__*/React__default.memo(function (_ref3) {
  var children = _ref3.children,
    className = _ref3.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstChildOverflow = _useState2[0],
    setFirstChildIsOverflow = _useState2[1];
  var ref = useRef(null);
  var childrenArray = _$1.isArray(children) ? children : [children];
  useLayoutEffect(function () {
    setTimeout(function () {
      if (ref.current && ref.current.isConnected) {
        var firstChild = ref.current.childNodes[0];
        setFirstChildIsOverflow(firstChild.scrollWidth > firstChild.clientWidth);
      }
    });
  }, []);
  if (!children || childrenArray.length === 0) {
    return "";
  }
  var collapsedGroup = null;
  if (childrenArray.length > 3) {
    collapsedGroup = childrenArray.slice(1, childrenArray.length - 1);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$j.base, className),
    ref: ref
  }, !collapsedGroup && childrenArray.map(function (child, index) {
    var isLast = index === childrenArray.length - 1;
    if (isLast) {
      return /*#__PURE__*/React__default.createElement(LastCrumb, {
        key: index,
        child: child
      });
    } else {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: index
      }, /*#__PURE__*/React__default.createElement(Crumb, {
        child: child,
        isOverflow: index === 0 && isFirstChildOverflow
      }), /*#__PURE__*/React__default.createElement(BreadcrumbsArrowIcon, {
        color: "secondary"
      }));
    }
  }), collapsedGroup && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Crumb, {
    child: childrenArray[0],
    isOverflow: isFirstChildOverflow
  }), /*#__PURE__*/React__default.createElement(BreadcrumbsArrowIcon, {
    color: "secondary"
  }), /*#__PURE__*/React__default.createElement(Popover$1, {
    Content: ActionMenuContent$1,
    horizontalPlacement: "right",
    Trigger: function Trigger() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$j["dots"]
      }, /*#__PURE__*/React__default.createElement("svg", {
        width: "20",
        height: "10",
        viewBox: "0 0 20 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M7.5 5C7.5 5.69036 6.94036 6.25 6.25 6.25C5.55964 6.25 5 5.69036 5 5C5 4.30964 5.55964 3.75 6.25 3.75C6.94036 3.75 7.5 4.30964 7.5 5ZM11.25 5C11.25 5.69036 10.6904 6.25 10 6.25C9.30964 6.25 8.75 5.69036 8.75 5C8.75 4.30964 9.30964 3.75 10 3.75C10.6904 3.75 11.25 4.30964 11.25 5ZM13.75 6.25C14.4404 6.25 15 5.69036 15 5C15 4.30964 14.4404 3.75 13.75 3.75C13.0596 3.75 12.5 4.30964 12.5 5C12.5 5.69036 13.0596 6.25 13.75 6.25Z",
        fill: "var(--icon-primary)"
      })));
    }
  }, collapsedGroup), /*#__PURE__*/React__default.createElement(BreadcrumbsArrowIcon, {
    color: "secondary"
  }), /*#__PURE__*/React__default.createElement(LastCrumb, {
    child: childrenArray[childrenArray.length - 1]
  })));
});

var _excluded$1 = ["text", "download", "onDownload", "includeLabel", "dataTestId"];
var FormFieldDownloadButton = function FormFieldDownloadButton(_ref) {
  var contents = _ref.contents,
    fileName = _ref.fileName,
    onDownload = _ref.onDownload,
    includeLabel = _ref.includeLabel,
    dataTestId = _ref.dataTestId;
  var onClick = onDownload ? onDownload : function () {
    return saveToDisk({
      contents: contents,
      fileName: fileName
    });
  };
  return /*#__PURE__*/React__default.createElement(FormFieldInputButton$1, {
    Icon: DownloadIcon,
    onClick: onClick,
    dataTestId: dataTestId,
    label: includeLabel ? "Download" : undefined
  });
};
var FormFieldCopyButton = function FormFieldCopyButton(_ref2) {
  var _text = _ref2.text,
    includeLabel = _ref2.includeLabel,
    dataTestId = _ref2.dataTestId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showBubble = _useState2[0],
    setShowBubble = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    bubblePosition = _useState4[0],
    setBubblePosition = _useState4[1];
  var buttonRef = /*#__PURE__*/React__default.createRef();
  var bubbleRef = /*#__PURE__*/React__default.createRef();
  var text = _$1.isObject(_text) ? JSON.stringify(_text, null, 4) : _text;
  useEffect(function () {
    if (showBubble && buttonRef.current) {
      var _buttonRef$current$ge = buttonRef.current.getBoundingClientRect(),
        top = _buttonRef$current$ge.top,
        left = _buttonRef$current$ge.left,
        width = _buttonRef$current$ge.width;
      var maxWidth = document.body.clientWidth;
      var isLeft = false;
      if (left + width + 60 > maxWidth) {
        isLeft = true;
      }
      setBubblePosition({
        top: top - 31,
        left: left + (isLeft ? 0 : width),
        isLeft: isLeft
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBubble]);
  return /*#__PURE__*/React__default.createElement(CopyToClipboard, {
    text: text,
    onCopy: function onCopy() {
      setShowBubble(true);
      setTimeout(function () {
        setShowBubble(false);
      });
    }
  }, /*#__PURE__*/React__default.createElement(FormFieldInputButton$1, {
    dataTestId: dataTestId,
    Icon: CopyIcon,
    ref: buttonRef,
    label: includeLabel ? "Copy" : undefined
  }, /*#__PURE__*/React__default.createElement(CSSTransition, {
    nodeRef: bubbleRef,
    "in": showBubble,
    unmountOnExit: true,
    timeout: 1000
  }, /*#__PURE__*/React__default.createElement("span", {
    ref: bubbleRef,
    style: {
      position: "absolute"
    }
  }, /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React__default.createElement("div", {
    className: classNames(copyButtonStyles['bubble'], _defineProperty$3({}, copyButtonStyles['left'], bubblePosition.isLeft)),
    style: {
      top: bubblePosition.top,
      left: bubblePosition.left
    }
  }, /*#__PURE__*/React__default.createElement(TooltipContent, null, "Copied!")), getRootComponent())))));
};
var FormFieldCopyAndDownload = (function (_ref3) {
  var text = _ref3.text,
    download = _ref3.download,
    onDownload = _ref3.onDownload,
    includeLabel = _ref3.includeLabel,
    dataTestId = _ref3.dataTestId,
    rest = _objectWithoutProperties$2(_ref3, _excluded$1);
  return /*#__PURE__*/React__default.createElement(FormFieldInputNew, _extends$j({
    dataTestId: dataTestId && "".concat(dataTestId, "-input")
  }, rest, {
    value: text,
    inputButtons: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (download || onDownload) && /*#__PURE__*/React__default.createElement(FormFieldDownloadButton, {
      includeLabel: includeLabel,
      onDownload: onDownload,
      contents: download.contents,
      fileName: download.fileName,
      dataTestId: dataTestId && "".concat(dataTestId, "-download-button")
    }), /*#__PURE__*/React__default.createElement(FormFieldCopyButton, {
      dataTestId: dataTestId && "".concat(dataTestId, "-copy-button"),
      includeLabel: includeLabel,
      text: text
    }))
  }));
});

var styles$i = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","blue-fill":"svgs-module_blue-fill__2if_G","blue-stroke":"svgs-module_blue-stroke__2S96f","blue":"svgs-module_blue__mI3Az","circle-border-icon":"svgs-module_circle-border-icon__37Icm","error":"svgs-module_error__3XPJD","warning":"svgs-module_warning__HTGgK","success":"svgs-module_success__23cTC","disabled":"svgs-module_disabled__2woJZ"};

var _excluded = ["children", "border", "style"];
var IconsCircleBorder = /*#__PURE__*/React__default.memo(function (_ref) {
  var children = _ref.children,
    border = _ref.border,
    style = _ref.style,
    rest = _objectWithoutProperties$2(_ref, _excluded);
  var customStyle = _objectSpread2({}, style);
  var borderColor = null;
  if (border > 0) {
    customStyle.borderWidth = border;
  }
  React__default.Children.map(children, function (child) {
    var _child$props;
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return child;
    }
    if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.color) {
      var _child$props2;
      borderColor = (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.color;
    }
  });
  return /*#__PURE__*/React__default.createElement("div", _extends$j({
    className: classNames(styles$i["circle-border-icon"], _defineProperty$3({}, styles$i[borderColor], borderColor)),
    style: customStyle
  }, rest), children);
});
var IconsCircleBorder$1 = IconsCircleBorder;

var styles$h = {"base":"RoundFilterButton-module_base__1YGlQ","is-active":"RoundFilterButton-module_is-active__3iPXS"};

var RoundFilterButton = function RoundFilterButton(_ref) {
  var children = _ref.children,
    count = _ref.count,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    className: classNames(styles$h.base, _defineProperty$3({}, styles$h['is-active'], isActive)),
    onClick: onClick,
    disabled: isDisabled
  }, children, !!count && /*#__PURE__*/React__default.createElement("span", null, "(", count, ")"));
};
var RoundFilterButton$1 = RoundFilterButton;

var ChoiceSelector = /*#__PURE__*/React__default.memo(function (_ref) {
  var children = _ref.children,
    selectedChoice = _ref.selectedChoice,
    setChoice = _ref.setChoice,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: style
  }, children.map(function (child) {
    if (!child) return;
    return /*#__PURE__*/React__default.cloneElement(child, {
      key: child.props.choiceKey,
      isSelected: child.props.choiceKey === selectedChoice,
      setSelected: function setSelected() {
        return setChoice(child.props.choiceKey);
      },
      hasSelection: !_$1.isNil(selectedChoice)
    });
  }));
});
var ChoiceSelector$1 = ChoiceSelector;

var zwoopOffset$1 = 5;
var calculateWidth = function calculateWidth(childrenRef) {
  return childrenRef.current.children[0].getBoundingClientRect().width;
};
var SlideInChoiceSelector$2 = /*#__PURE__*/React__default.memo(function (_ref) {
  var className = _ref.className,
    style = _ref.style,
    currentSlideId = _ref.currentSlideId,
    children = _ref.children,
    lengthRef = _ref.lengthRef,
    gap = _ref.gap;
  var childrenRef = useRef();
  var parentRef = useRef();
  var isIn = !!currentSlideId;
  if (!isIn) return "";
  return /*#__PURE__*/React__default.createElement(SwitchTransition, null, /*#__PURE__*/React__default.createElement(Transition, {
    key: currentSlideId,
    nodeRef: parentRef,
    timeout: 400,
    appear: true,
    onEnter: function onEnter(isAppearing) {
      if (isAppearing) {
        parentRef.current.style.opacity = 0;
      }
      var length = lengthRef.current;
      var typeCardWidth = calculateWidth(childrenRef);
      parentRef.current.style.width = "".concat(length * typeCardWidth + (length - 1) * gap, "px");
      _$1.map(childrenRef.current.children, function (el, index) {
        el.style.left = "".concat(zwoopOffset$1 * index, "px");
        el.style.position = "absolute";
        el.style.transition = "left 400ms cubic-bezier(0.25, 0.8, 0.25, 1)";
      });
    },
    onEntering: function onEntering(isAppearing) {
      var last = parentRef.current;
      setTimeout(function () {
        if (parentRef.current && last === parentRef.current) {
          var typeCardWidth = calculateWidth(childrenRef);
          _$1.map(childrenRef.current.children, function (el, index) {
            el.style.left = "".concat(index * typeCardWidth + index * gap, "px");
          });
        }
      }, isAppearing ? 200 : 100);
      if (isAppearing) {
        setTimeout(function () {
          parentRef.current.style.opacity = 1;
        });
      }
    },
    onEntered: function onEntered() {
      _$1.map(childrenRef.current.children, function (el) {
        el.style.position = "initial";
      });
    },
    onExiting: function onExiting() {
      _$1.map(childrenRef.current.children, function (el, index) {
        el.style.left = "".concat(zwoopOffset$1 * index, "px");
        el.style.position = "absolute";
      });
      var length = lengthRef.current;
      var typeCardWidth = calculateWidth(childrenRef);
      parentRef.current.style.width = "".concat(length * typeCardWidth + (length - 1) * gap, "px");
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: style,
    ref: parentRef
  }, children({
    childrenRef: childrenRef
  }))));
});
var SlideInChoiceSelector$3 = SlideInChoiceSelector$2;

var zwoopOffset = 5;
var calculateHeight = function calculateHeight(childrenRef) {
  return childrenRef.current.children[0].getBoundingClientRect().height;
};
var SlideInChoiceSelector = /*#__PURE__*/React__default.memo(function (_ref) {
  var className = _ref.className,
    style = _ref.style,
    currentSlideId = _ref.currentSlideId,
    children = _ref.children,
    lengthRef = _ref.lengthRef,
    gap = _ref.gap;
  var childrenRef = useRef();
  var parentRef = useRef();
  var isIn = !!currentSlideId;
  if (!isIn) return "";
  return /*#__PURE__*/React__default.createElement(SwitchTransition, null, /*#__PURE__*/React__default.createElement(Transition, {
    key: currentSlideId,
    nodeRef: parentRef,
    timeout: 400,
    appear: true,
    onEnter: function onEnter(isAppearing) {
      if (isAppearing) {
        parentRef.current.style.opacity = 0;
      }
      var length = lengthRef.current;
      var typeCardHeight = calculateHeight(childrenRef);
      parentRef.current.style.minHeight = "".concat(length * typeCardHeight + (length - 1) * gap, "px");
      _$1.map(childrenRef.current.children, function (el, index) {
        el.style.top = "".concat(zwoopOffset * index, "px");
        el.style.position = "absolute";
        el.style.transition = "top 400ms cubic-bezier(0.25, 0.8, 0.25, 1)";
      });
    },
    onEntering: function onEntering(isAppearing) {
      var last = parentRef.current;
      setTimeout(function () {
        if (parentRef.current && last === parentRef.current) {
          var typeCardHeight = calculateHeight(childrenRef);
          _$1.map(childrenRef.current.children, function (el, index) {
            el.style.top = "".concat(index * typeCardHeight + index * gap, "px");
          });
        }
      }, isAppearing ? 200 : 100);
      if (isAppearing) {
        setTimeout(function () {
          parentRef.current.style.opacity = 1;
        });
      }
    },
    onEntered: function onEntered() {
      _$1.map(childrenRef.current.children, function (el) {
        el.style.position = "initial";
      });
    },
    onExiting: function onExiting() {
      _$1.map(childrenRef.current.children, function (el, index) {
        el.style.top = "".concat(zwoopOffset * index, "px");
        el.style.position = "absolute";
      });
      var length = lengthRef.current;
      var typeCardHeight = calculateHeight(childrenRef);
      parentRef.current.style.minHeight = "".concat(length * typeCardHeight + (length - 1) * gap, "px");
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: className,
    style: style,
    ref: parentRef
  }, children({
    childrenRef: childrenRef
  }))));
});
var SlideInChoiceSelector$1 = SlideInChoiceSelector;

var TabColumnContent = /*#__PURE__*/React__default.memo(function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$K['column-content'], className),
    style: style
  }, children);
});
var TabColumnContent$1 = TabColumnContent;

var styles$g = {"base":"Chevron-module_base__2Nc5I","md":"Chevron-module_md__hZGFL","left":"Chevron-module_left__1G9gt","right":"Chevron-module_right__zgRRs","active":"Chevron-module_active__188MM","sm":"Chevron-module_sm__359bT","on-color":"Chevron-module_on-color__21uNU","secondary":"Chevron-module_secondary__263nL","primary":"Chevron-module_primary__1n3TW","tertiary":"Chevron-module_tertiary__2jLHC","disabled":"Chevron-module_disabled__1k7DE"};

var Chevron = React__default.memo(({ isActive, color = "secondary", size = "md" }) => {
    return jsxs("span", { className: classNames(styles$g.base, styles$g[color], styles$g[size]), children: [jsx$3("span", { className: classNames(styles$g.left, { [styles$g.active]: isActive }) }), jsx$3("span", { className: classNames(styles$g.right, { [styles$g.active]: isActive }) })] });
});

var styles$f = {"base":"SummaryHeader-module_base__3gD_2","variant-01":"SummaryHeader-module_variant-01__1jIww","variant-04":"SummaryHeader-module_variant-04__3dOtv","summaryLoader":"SummaryHeader-module_summaryLoader__upu3z"};

const SummaryHeaderLoader = () => {
    return jsx$3("div", { className: styles$f.summaryLoader, children: jsx$3(ComponentLoader, {}) });
};
const SummaryHeader = ({ children, className, style, variant = "variant-01", dataTestId }) => {
    return jsx$3("div", { className: classNames(styles$f.base, styles$f[variant], className), style: style, "data-testid": dataTestId, children: children });
};

var styles$e = {"square":"MetricItem-module_square__1p1Hd","chart-1":"MetricItem-module_chart-1__sul5I","chart-2":"MetricItem-module_chart-2__2VO76","chart-3":"MetricItem-module_chart-3__2Iz0W","chart-4":"MetricItem-module_chart-4__28fyi","chart-5":"MetricItem-module_chart-5__hOfxh","chart-6":"MetricItem-module_chart-6__2QAYz","chart-7":"MetricItem-module_chart-7__2LETZ","chart-8":"MetricItem-module_chart-8__2RuRO","chart-9":"MetricItem-module_chart-9__1KoeY","chart-10":"MetricItem-module_chart-10__3jZLF","chart-11":"MetricItem-module_chart-11__1cmLn","chart-disabled":"MetricItem-module_chart-disabled__3_AhV","metricItemStyle1Base":"MetricItem-module_metricItemStyle1Base__3Nw35","metricItemStyle2Base":"MetricItem-module_metricItemStyle2Base__3eHVf","loadingMask":"MetricItem-module_loadingMask__a1JzJ","bgshimmer":"MetricItem-module_bgshimmer__8vy3d","summaryValueWithIcon":"MetricItem-module_summaryValueWithIcon__2cKS-","summaryValue":"MetricItem-module_summaryValue__33RTF","error":"MetricItem-module_error__3C96G","success":"MetricItem-module_success__1Ryey","warning":"MetricItem-module_warning__3dT6p","info":"MetricItem-module_info__1Zu_Z","metricItemStyle3Base":"MetricItem-module_metricItemStyle3Base__2HLol","valueTooltip":"MetricItem-module_valueTooltip__1DKD7","valueCopy":"MetricItem-module_valueCopy__2nkS9","noIcon":"MetricItem-module_noIcon__223up","summaryMetricValues":"MetricItem-module_summaryMetricValues__zHqgS","metricItemStyle4Base":"MetricItem-module_metricItemStyle4Base__xs5gx"};

var styles$d = {"solid-icon":"Icons-module_solid-icon__1QF7c","bg-i1":"Icons-module_bg-i1__YS-rP","bg-chart-1":"Icons-module_bg-chart-1__1PKiO","bg-i2":"Icons-module_bg-i2__3JTUz","bg-chart-2":"Icons-module_bg-chart-2__2hQgj","bg-i3":"Icons-module_bg-i3__21p_p","bg-chart-3":"Icons-module_bg-chart-3__3TF3C","default":"Icons-module_default__2viug","bg-i4":"Icons-module_bg-i4__1PwDz","bg-chart-4":"Icons-module_bg-chart-4__1e8Pr","bg-i5":"Icons-module_bg-i5__3rL-j","bg-chart-5":"Icons-module_bg-chart-5__1TQOp","bg-i6":"Icons-module_bg-i6__3lhEj","bg-chart-6":"Icons-module_bg-chart-6__19n-C","bg-i7":"Icons-module_bg-i7__qFG7u","bg-chart-7":"Icons-module_bg-chart-7__FDyfw","bg-i8":"Icons-module_bg-i8__RI0BO","bg-chart-8":"Icons-module_bg-chart-8__3Mp2F","bg-i9":"Icons-module_bg-i9__1Sly8","bg-chart-9":"Icons-module_bg-chart-9__2uBgG","bg-i10":"Icons-module_bg-i10__2qrYq","bg-chart-10":"Icons-module_bg-chart-10___e5yV","bg-chart-11":"Icons-module_bg-chart-11__3Jlw8","bg-disabled":"Icons-module_bg-disabled__3H3gH","bg-chart-disabled":"Icons-module_bg-chart-disabled__fztNr","bg-chart-background":"Icons-module_bg-chart-background__2pwG0","solid-circle-icon":"Icons-module_solid-circle-icon__1gD7U Icons-module_solid-icon__1QF7c","solid-square-icon":"Icons-module_solid-square-icon__17cB6 Icons-module_solid-icon__1QF7c"};

const SolidCircleIcon = React__default.memo(({ bgColor, children }) => {
    return jsx$3("div", { className: classNames(styles$d['solid-circle-icon'], bgColor ? styles$d[`bg-${bgColor}`] : styles$d.default), "data-component": "SolidIcon", children: children });
});
const SolidSquareIcon = React__default.memo(({ bgColor, children }) => {
    return jsx$3("div", { className: classNames(styles$d['solid-square-icon'], bgColor ? styles$d[`bg-${bgColor}`] : styles$d.default), "data-component": "SolidIcon", children: children });
});

const MetricItemStyle1 = ({ value, unit, label, color, isDisabled, dataTestId }) => {
    return jsxs("div", { className: styles$e.metricItemStyle1Base, "data-testid": dataTestId, children: [jsxs(Span, { bold: true, color: isDisabled ? "text-disabled" : undefined, children: [value, " ", unit && unit] }), jsx$3("div", { className: classNames(styles$e.square, styles$e[isDisabled ? "chart-disabled" : color]) }), jsx$3(Span, { color: isDisabled ? "text-disabled" : undefined, children: label })] });
};
const MetricItemStyle2 = ({ label, color, dataTestId }) => {
    return jsxs("div", { className: styles$e.metricItemStyle2Base, "data-testid": dataTestId, children: [jsx$3("div", { className: classNames(styles$e.square, styles$e[color]) }), jsx$3(Span, { children: label })] });
};
const MetricItemStyle3 = ({ Icon, value, valueTooltip, valueHasCopy, label, className, style, iconBgColor, unit, valueColor, isLoading, isDisabled, dataTestId }) => {
    const valueText = value === undefined ? "N/A" : value;
    return jsxs("div", { "data-testid": dataTestId, className: classNames(styles$e.metricItemStyle3Base, className, { [styles$e.noIcon]: !Icon }), style: style, children: [Icon && jsx$3(SolidSquareIcon, { bgColor: iconBgColor, children: jsx$3(Icon, {}) }), jsxs("div", { className: styles$e.summaryMetricValues, children: [isLoading && jsxs("div", { className: styles$e.loadingMask, children: [jsx$3("div", {}), "\u00A0"] }), !isLoading &&
                        jsxs("div", { "data-testid": dataTestId && `${dataTestId}-value`, className: classNames(styles$e.summaryValue, valueColor && styles$e[valueColor]), children: [jsxs("span", { style: { color: isDisabled ? "var(--text-disabled)" : "" }, children: [valueText, unit && jsx$3("span", { children: unit })] }), valueTooltip && jsx$3(Tooltip$1, { className: styles$e.valueTooltip, children: valueTooltip }), valueHasCopy && jsx$3(CopyButton$1, { dataTestId: dataTestId && `${dataTestId}-copy-button`, className: styles$e.valueCopy, text: value })] }), jsx$3(Span, { level: 14, "data-testid": dataTestId && `${dataTestId}-label`, style: { color: isDisabled ? "var(--text-disabled)" : "" }, ellipsis: true, children: label })] })] });
};
const MetricItemStyle4 = ({ value, label, className, style, isLoading, ValueIcon, valueIconColor = "text", dataTestId }) => {
    const valueText = value === undefined ? "N/A" : value;
    return jsx$3("div", { "data-testid": dataTestId, className: classNames(styles$e.metricItemStyle4Base, className), style: style, children: jsxs("div", { className: styles$e.summaryMetricValues, children: [isLoading && jsxs("div", { className: styles$e.loadingMask, children: [jsx$3("div", {}), "\u00A0"] }), !isLoading &&
                    jsxs("div", { className: styles$e.summaryValueWithIcon, "data-testid": dataTestId && `${dataTestId}-value`, children: [ValueIcon && ValueIcon !== InlineLoader && jsx$3(ValueIcon, { size: 20, color: valueIconColor }), ValueIcon === InlineLoader &&
                                jsx$3(ValueIcon, { style: { width: 16, height: 16, position: "relative", top: -1 } }), jsx$3(Span, { title: valueText.toString(), bold: true, ellipsis: true, children: valueText })] }), jsx$3(Span, { "data-testid": dataTestId && `${dataTestId}-label`, level: 14, ellipsis: true, children: label })] }) });
};

var styles$c = {"var_lg":"184","var_sm":"144","base":"DonutChart-module_base__1fqex","lg":"DonutChart-module_lg__2XP4L","sm":"DonutChart-module_sm__fFfpl","total":"DonutChart-module_total__370V1"};

const emptyColorsToken = ["chart-disabled"];
const fullColorsToken = ["chart-1", "chart-2", "chart-3", "chart-4", "chart-5", "chart-6", "chart-7", "chart-8", "chart-9", "chart-10", "chart-11"];
const emptyColors = emptyColorsToken.map(token => `var(--${token})`);
const fullColors = fullColorsToken.map(token => `var(--${token})`);
const hexToRgb = hex => hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16));

/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function round(v) {
  return v + 0.5 | 0;
}
const lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}
const map$1 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  a: 10,
  b: 11,
  c: 12,
  d: 13,
  e: 14,
  f: 15
};
const hex = [...'0123456789ABCDEF'];
const h1 = b => hex[b & 0xF];
const h2 = b => hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = b => (b & 0xF0) >> 4 === (b & 0xF);
const isShort = v => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === '#') {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
const alpha = (a, f) => a < 255 ? f(a) : '';
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
  const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
  const rgb = hsl2rgbn(h, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }
  return rgb;
}
function hueValue(r, g, b, d, max) {
  if (r === max) {
    return (g - b) / d + (g < b ? 6 : 0);
  }
  if (g === max) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s, d;
  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }
  return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
  return (h % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === 'hwb') {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === 'hsv') {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a: a
  };
}
function rotate(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
  x: 'dark',
  Z: 'light',
  Y: 're',
  X: 'blu',
  W: 'gr',
  V: 'medium',
  U: 'slate',
  A: 'ee',
  T: 'ol',
  S: 'or',
  B: 'ra',
  C: 'lateg',
  D: 'ights',
  R: 'in',
  Q: 'turquois',
  E: 'hi',
  P: 'ro',
  O: 'al',
  N: 'le',
  M: 'de',
  L: 'yello',
  F: 'en',
  K: 'ch',
  G: 'arks',
  H: 'ea',
  I: 'ightg',
  J: 'wh'
};
const names$1 = {
  OiceXe: 'f0f8ff',
  antiquewEte: 'faebd7',
  aqua: 'ffff',
  aquamarRe: '7fffd4',
  azuY: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '0',
  blanKedOmond: 'ffebcd',
  Xe: 'ff',
  XeviTet: '8a2be2',
  bPwn: 'a52a2a',
  burlywood: 'deb887',
  caMtXe: '5f9ea0',
  KartYuse: '7fff00',
  KocTate: 'd2691e',
  cSO: 'ff7f50',
  cSnflowerXe: '6495ed',
  cSnsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: 'ffff',
  xXe: '8b',
  xcyan: '8b8b',
  xgTMnPd: 'b8860b',
  xWay: 'a9a9a9',
  xgYF: '6400',
  xgYy: 'a9a9a9',
  xkhaki: 'bdb76b',
  xmagFta: '8b008b',
  xTivegYF: '556b2f',
  xSange: 'ff8c00',
  xScEd: '9932cc',
  xYd: '8b0000',
  xsOmon: 'e9967a',
  xsHgYF: '8fbc8f',
  xUXe: '483d8b',
  xUWay: '2f4f4f',
  xUgYy: '2f4f4f',
  xQe: 'ced1',
  xviTet: '9400d3',
  dAppRk: 'ff1493',
  dApskyXe: 'bfff',
  dimWay: '696969',
  dimgYy: '696969',
  dodgerXe: '1e90ff',
  fiYbrick: 'b22222',
  flSOwEte: 'fffaf0',
  foYstWAn: '228b22',
  fuKsia: 'ff00ff',
  gaRsbSo: 'dcdcdc',
  ghostwEte: 'f8f8ff',
  gTd: 'ffd700',
  gTMnPd: 'daa520',
  Way: '808080',
  gYF: '8000',
  gYFLw: 'adff2f',
  gYy: '808080',
  honeyMw: 'f0fff0',
  hotpRk: 'ff69b4',
  RdianYd: 'cd5c5c',
  Rdigo: '4b0082',
  ivSy: 'fffff0',
  khaki: 'f0e68c',
  lavFMr: 'e6e6fa',
  lavFMrXsh: 'fff0f5',
  lawngYF: '7cfc00',
  NmoncEffon: 'fffacd',
  ZXe: 'add8e6',
  ZcSO: 'f08080',
  Zcyan: 'e0ffff',
  ZgTMnPdLw: 'fafad2',
  ZWay: 'd3d3d3',
  ZgYF: '90ee90',
  ZgYy: 'd3d3d3',
  ZpRk: 'ffb6c1',
  ZsOmon: 'ffa07a',
  ZsHgYF: '20b2aa',
  ZskyXe: '87cefa',
  ZUWay: '778899',
  ZUgYy: '778899',
  ZstAlXe: 'b0c4de',
  ZLw: 'ffffe0',
  lime: 'ff00',
  limegYF: '32cd32',
  lRF: 'faf0e6',
  magFta: 'ff00ff',
  maPon: '800000',
  VaquamarRe: '66cdaa',
  VXe: 'cd',
  VScEd: 'ba55d3',
  VpurpN: '9370db',
  VsHgYF: '3cb371',
  VUXe: '7b68ee',
  VsprRggYF: 'fa9a',
  VQe: '48d1cc',
  VviTetYd: 'c71585',
  midnightXe: '191970',
  mRtcYam: 'f5fffa',
  mistyPse: 'ffe4e1',
  moccasR: 'ffe4b5',
  navajowEte: 'ffdead',
  navy: '80',
  Tdlace: 'fdf5e6',
  Tive: '808000',
  TivedBb: '6b8e23',
  Sange: 'ffa500',
  SangeYd: 'ff4500',
  ScEd: 'da70d6',
  pOegTMnPd: 'eee8aa',
  pOegYF: '98fb98',
  pOeQe: 'afeeee',
  pOeviTetYd: 'db7093',
  papayawEp: 'ffefd5',
  pHKpuff: 'ffdab9',
  peru: 'cd853f',
  pRk: 'ffc0cb',
  plum: 'dda0dd',
  powMrXe: 'b0e0e6',
  purpN: '800080',
  YbeccapurpN: '663399',
  Yd: 'ff0000',
  Psybrown: 'bc8f8f',
  PyOXe: '4169e1',
  saddNbPwn: '8b4513',
  sOmon: 'fa8072',
  sandybPwn: 'f4a460',
  sHgYF: '2e8b57',
  sHshell: 'fff5ee',
  siFna: 'a0522d',
  silver: 'c0c0c0',
  skyXe: '87ceeb',
  UXe: '6a5acd',
  UWay: '708090',
  UgYy: '708090',
  snow: 'fffafa',
  sprRggYF: 'ff7f',
  stAlXe: '4682b4',
  tan: 'd2b48c',
  teO: '8080',
  tEstN: 'd8bfd8',
  tomato: 'ff6347',
  Qe: '40e0d0',
  viTet: 'ee82ee',
  JHt: 'f5deb3',
  wEte: 'ffffff',
  wEtesmoke: 'f5f5f5',
  Lw: 'ffff00',
  LwgYF: '9acd32'
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map[k]);
    }
    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 0xFF, k >> 8 & 0xFF, k & 0xFF];
  }
  return unpacked;
}
let names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}
function rgbString(v) {
  return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = v => v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = v => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate$1(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}
function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone$2(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = {
    r: 0,
    g: 0,
    b: 0,
    a: 255
  };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = {
        r: input[0],
        g: input[1],
        b: input[2],
        a: 255
      };
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone$2(input, {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    });
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === 'r') {
    return rgbParse(str);
  }
  return hueParse(str);
}
class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === 'object') {
      v = fromObject(input);
    } else if (type === 'string') {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone$2(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : undefined;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : undefined;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : undefined;
  }
  mix(color, weight) {
    if (color) {
      const c1 = this.rgb;
      const c2 = color.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
      w2 = 1 - w1;
      c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color, t) {
    if (color) {
      this._rgb = interpolate$1(this._rgb, color._rgb, t);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
}

/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */

/**
 * @namespace Chart.helpers
 */ /**
    * An empty function that can be used, for example, for optional callback.
    */
function noop() {
  /* noop */}
/**
 * Returns a unique id, sequentially generated from a global variable.
 */
const uid = (() => {
  let id = 0;
  return () => id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */
function isNullOrUndef(value) {
  return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */
function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type = Object.prototype.toString.call(value);
  if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') {
    return true;
  }
  return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */
function isObject$1(value) {
  return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */
function isNumberFinite(value) {
  return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */
function valueOrDefault(value, defaultValue) {
  return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension) => typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension) => typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === 'function') {
    return fn.apply(thisArg, args);
  }
}
function each(loopable, fn, thisArg, reverse) {
  let i, len, keys;
  if (isArray(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject$1(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */
function clone$1(source) {
  if (isArray(source)) {
    return source.map(clone$1);
  }
  if (isObject$1(source)) {
    const target = Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k = 0;
    for (; k < klen; ++k) {
      target[keys[k]] = clone$1(source[keys[k]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */
function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject$1(tval) && isObject$1(sval)) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
  } else {
    target[key] = clone$1(sval);
  }
}
function merge(target, source, options) {
  const sources = isArray(source) ? source : [source];
  const ilen = sources.length;
  if (!isObject$1(target)) {
    return target;
  }
  options = options || {};
  const merger = options.merger || _merger;
  let current;
  for (let i = 0; i < ilen; ++i) {
    current = sources[i];
    if (!isObject$1(current)) {
      continue;
    }
    const keys = Object.keys(current);
    for (let k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, current, options);
    }
  }
  return target;
}
function mergeIf(target, source) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return merge(target, source, {
    merger: _mergerIf
  });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject$1(tval) && isObject$1(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone$1(sval);
  }
}
// resolveObjectKey resolver cache
const keyResolvers = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  '': v => v,
  // default resolvers
  x: o => o.x,
  y: o => o.y
};
/**
 * @private
 */
function _splitKey(key) {
  const parts = key.split('.');
  const keys = [];
  let tmp = '';
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith('\\')) {
      tmp = tmp.slice(0, -1) + '.';
    } else {
      keys.push(tmp);
      tmp = '';
    }
  }
  return keys;
}
function _getKeyResolver(key) {
  const keys = _splitKey(key);
  return obj => {
    for (const k of keys) {
      if (k === '') {
        break;
      }
      obj = obj && obj[k];
    }
    return obj;
  };
}
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
/**
 * @private
 */
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = value => typeof value !== 'undefined';
const isFunction = value => typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b) => {
  if (a.size !== b.size) {
    return false;
  }
  for (const item of a) {
    if (!b.has(item)) {
      return false;
    }
  }
  return true;
};
/**
 * @param e - The event
 * @private
 */
function _isClickEvent(e) {
  return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}

/**
 * @alias Chart.helpers.math
 * @namespace
 */
const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */
function niceNum(range) {
  const roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
  const niceRange = Math.pow(10, Math.floor(log10(range)));
  const fraction = range / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a, b) => a - b).pop();
  return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */
function isNonPrimitive(n) {
  return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function isNumber(n) {
  return !isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
  const rounded = Math.round(x);
  return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */
function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }
  let e = 1;
  let p = 0;
  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }
  return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < -0.5 * PI) {
    angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */
function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */
function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */
function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  const a = _normalizeAngle(angle);
  const s = _normalizeAngle(start);
  const e = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s - a);
  const angleToEnd = _normalizeAngle(e - a);
  const startToAngle = _normalizeAngle(a - s);
  const endToAngle = _normalizeAngle(a - e);
  return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */
function _limitValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */
function _isBetween(value, start, end, epsilon = 1e-6) {
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
  cmp = cmp || (index => table[index] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = lo + hi >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return {
    lo,
    hi
  };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */
const _lookupByKey = (table, key, value, last) => _lookup(table, value, last ? index => {
  const ti = table[index][key];
  return ti < value || ti === value && table[index + 1][key] === value;
} : index => table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */
const _rlookupByKey = (table, key, value) => _lookup(table, value, index => table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */
function _filterBetween(values, min, max) {
  let start = 0;
  let end = values.length;
  while (start < end && values[start] < min) {
    start++;
  }
  while (end > start && values[end - 1] > max) {
    end--;
  }
  return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, '_chartjs', {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [listener]
    }
  });
  arrayEvents.forEach(key => {
    const method = '_onData' + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach(object => {
          if (typeof object[method] === 'function') {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index = listeners.indexOf(listener);
  if (index !== -1) {
    listeners.splice(index, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach(key => {
    delete array[key];
  });
  delete array._chartjs;
}
/**
 * @param items
 */
function _arrayUnique(items) {
  const set = new Set(items);
  if (set.size === items.length) {
    return items;
  }
  return Array.from(set);
}
/**
* Request animation polyfill
*/
const requestAnimFrame = function () {
  if (typeof window === 'undefined') {
    return function (callback) {
      return callback();
    };
  }
  return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */
function throttled(fn, thisArg) {
  let argsToUse = [];
  let ticking = false;
  return function (...args) {
    // Save the args for use later
    argsToUse = args;
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, argsToUse);
      });
    }
  };
}
/**
 * Debounces calling `fn` for `delay` ms
 */
function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */
const _toLeftRightCenter = align => align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */
const _alignStartEnd = (align, start, end) => align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */
const _textX = (align, left, right, rtl) => {
  const check = rtl ? 'left' : 'right';
  return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const {
      iScale,
      vScale,
      _parsed
    } = meta;
    const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
    const axis = iScale.axis;
    const {
      min,
      max,
      minDefined,
      maxDefined
    } = iScale.getUserBounds();
    if (minDefined) {
      start = Math.min(
      // @ts-expect-error Need to type _parsed
      _lookupByKey(_parsed, axis, min).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo);
      if (spanGaps) {
        const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex(point => !isNullOrUndef(point[vScale.axis]));
        start -= Math.max(0, distanceToDefinedLo);
      }
      start = _limitValue(start, 0, pointCount - 1);
    }
    if (maxDefined) {
      let end = Math.max(
      // @ts-expect-error Need to type _parsed
      _lookupByKey(_parsed, iScale.axis, max, true).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1);
      if (spanGaps) {
        const distanceToDefinedHi = _parsed.slice(end - 1).findIndex(point => !isNullOrUndef(point[vScale.axis]));
        end += Math.max(0, distanceToDefinedHi);
      }
      count = _limitValue(end, start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }
  return {
    start,
    count
  };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */
function _scaleRangesChanged(meta) {
  const {
    xScale,
    yScale,
    _scaleRanges
  } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
const atEdge = t => t === 0 || t === 1;
const elasticIn = (t, s, p) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p) => Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */
const effects = {
  linear: t => t,
  easeInQuad: t => t * t,
  easeOutQuad: t => -t * (t - 2),
  easeInOutQuad: t => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: t => t * t * t,
  easeOutCubic: t => (t -= 1) * t * t + 1,
  easeInOutCubic: t => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: t => t * t * t * t,
  easeOutQuart: t => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: t => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: t => t * t * t * t * t,
  easeOutQuint: t => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: t => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: t => -Math.cos(t * HALF_PI) + 1,
  easeOutSine: t => Math.sin(t * HALF_PI),
  easeInOutSine: t => -0.5 * (Math.cos(PI * t) - 1),
  easeInExpo: t => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: t => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: t => atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: t => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: t => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: t => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: t => atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
  easeOutElastic: t => atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
  easeInOutElastic(t) {
    const s = 0.1125;
    const p = 0.45;
    return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack(t) {
    const s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack(t) {
    const s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack(t) {
    let s = 1.70158;
    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
    }
    return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
  },
  easeInBounce: t => 1 - effects.easeOutBounce(1 - t),
  easeOutBounce(t) {
    const m = 7.5625;
    const d = 2.75;
    if (t < 1 / d) {
      return m * t * t;
    }
    if (t < 2 / d) {
      return m * (t -= 1.5 / d) * t + 0.75;
    }
    if (t < 2.5 / d) {
      return m * (t -= 2.25 / d) * t + 0.9375;
    }
    return m * (t -= 2.625 / d) * t + 0.984375;
  },
  easeInOutBounce: t => t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
  if (value && typeof value === 'object') {
    const type = value.toString();
    return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
  }
  return false;
}
function color(value) {
  return isPatternOrGradient(value) ? value : new Color(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : new Color(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = ['x', 'y', 'borderWidth', 'radius', 'tension'];
const colors = ['color', 'borderColor', 'backgroundColor'];
function applyAnimationsDefaults(defaults) {
  defaults.set('animation', {
    delay: undefined,
    duration: 1000,
    easing: 'easeOutQuart',
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
  });
  defaults.describe('animation', {
    _fallback: false,
    _indexable: false,
    _scriptable: name => name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
  });
  defaults.set('animations', {
    colors: {
      type: 'color',
      properties: colors
    },
    numbers: {
      type: 'number',
      properties: numbers
    }
  });
  defaults.describe('animations', {
    _fallback: 'animation'
  });
  defaults.set('transitions', {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: 'transparent'
        },
        visible: {
          type: 'boolean',
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: 'transparent'
        },
        visible: {
          type: 'boolean',
          easing: 'linear',
          fn: v => v | 0
        }
      }
    }
  });
}
function applyLayoutsDefaults(defaults) {
  defaults.set('layout', {
    autoPadding: true,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
  options = options || {};
  const cacheKey = locale + JSON.stringify(options);
  let formatter = intlCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter);
  }
  return formatter;
}
function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}
const formatters = {
  values(value) {
    return isArray(value) ? value : '' + value;
  },
  numeric(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e+15) {
        notation = 'scientific';
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = {
      notation,
      minimumFractionDigits: numDecimal,
      maximumFractionDigits: numDecimal
    };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }
    const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if ([1, 2, 3, 5, 10, 15].includes(remain) || index > 0.8 * ticks.length) {
      return formatters.numeric.call(this, tickValue, index, ticks);
    }
    return '';
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = {
  formatters
};
function applyScaleDefaults(defaults) {
  defaults.set('scale', {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: 'ticks',
    clip: true,
    grace: 0,
    grid: {
      display: true,
      lineWidth: 1,
      drawOnChartArea: true,
      drawTicks: true,
      tickLength: 8,
      tickWidth: (_ctx, options) => options.lineWidth,
      tickColor: (_ctx, options) => options.color,
      offset: false
    },
    border: {
      display: true,
      dash: [],
      dashOffset: 0.0,
      width: 1
    },
    title: {
      display: false,
      text: '',
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: false,
      textStrokeWidth: 0,
      textStrokeColor: '',
      padding: 3,
      display: true,
      autoSkip: true,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ticks.formatters.values,
      minor: {},
      major: {},
      align: 'center',
      crossAlign: 'near',
      showLabelBackdrop: false,
      backdropColor: 'rgba(255, 255, 255, 0.75)',
      backdropPadding: 2
    }
  });
  defaults.route('scale.ticks', 'color', '', 'color');
  defaults.route('scale.grid', 'color', '', 'borderColor');
  defaults.route('scale.border', 'color', '', 'borderColor');
  defaults.route('scale.title', 'color', '', 'color');
  defaults.describe('scale', {
    _fallback: false,
    _scriptable: name => !name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
    _indexable: name => name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
  });
  defaults.describe('scales', {
    _fallback: 'scale'
  });
  defaults.describe('scale.ticks', {
    _scriptable: name => name !== 'backdropPadding' && name !== 'callback',
    _indexable: name => name !== 'backdropPadding'
  });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys = key.split('.');
  for (let i = 0, n = keys.length; i < n; ++i) {
    const k = keys[i];
    node = node[k] || (node[k] = Object.create(null));
  }
  return node;
}
function set(root, scope, values) {
  if (typeof scope === 'string') {
    return merge(getScope$1(root, scope), values);
  }
  return merge(getScope$1(root, ''), scope);
}
class Defaults {
  constructor(_descriptors, _appliers) {
    this.animation = undefined;
    this.backgroundColor = 'rgba(0,0,0,0.1)';
    this.borderColor = 'rgba(0,0,0,0.1)';
    this.color = '#666';
    this.datasets = {};
    this.devicePixelRatio = context => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: 'normal',
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = 'x';
    this.interaction = {
      mode: 'nearest',
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = undefined;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors);
    this.apply(_appliers);
  }
  set(scope, values) {
    return set(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set(descriptors, scope, values);
  }
  override(scope, values) {
    return set(overrides, scope, values);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = '_' + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject$1(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
  apply(appliers) {
    appliers.forEach(apply => apply(this));
  }
}
var defaults = /* #__PURE__ */new Defaults({
  _scriptable: name => !name.startsWith('on'),
  _indexable: name => name !== 'events',
  hover: {
    _fallback: 'interaction'
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
}, [applyAnimationsDefaults, applyLayoutsDefaults, applyScaleDefaults]);

/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    // Undefined strings and arrays should not be measured
    if (thing !== undefined && thing !== null && !isArray(thing)) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      // if it is an array lets measure each element
      // to do maybe simplify this function a bit so we can do this more recursively?
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        // Undefined strings and arrays should not be measured
        if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */
function clearCanvas(canvas, ctx) {
  if (!ctx && !canvas) {
    return;
  }
  ctx = ctx || canvas.getContext('2d');
  ctx.save();
  // canvas.width and canvas.height do not consider the canvas transform,
  // while clearRect does
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x, y) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
  let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === 'object') {
    type = style.toString();
    if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    // Default includes circle
    default:
      if (w) {
        ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
      } else {
        ctx.arc(x, y, radius, 0, TAU);
      }
      ctx.closePath();
      break;
    case 'triangle':
      width = w ? w / 2 : radius;
      ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      ctx.closePath();
      break;
    case 'rectRounded':
      // NOTE: the rounded rect implementation changed to use `arc` instead of
      // `quadraticCurveTo` since it generates better results when rect is
      // almost a circle. 0.516 (instead of 0.5) produces results with visually
      // closer proportion to the previous impl and it is inscribed in the
      // circle with `radius`. For more details, see the following PRs:
      // https://github.com/chartjs/Chart.js/issues/5597
      // https://github.com/chartjs/Chart.js/issues/5858
      cornerRadius = radius * 0.516;
      size = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size;
      xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      yOffset = Math.sin(rad + QUARTER_PI) * size;
      yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case 'rect':
      if (!rotation) {
        size = Math.SQRT1_2 * radius;
        width = w ? w / 2 : size;
        ctx.rect(x - width, y - size, 2 * width, 2 * size);
        break;
      }
      rad += QUARTER_PI;
    /* falls through */
    case 'rectRot':
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      ctx.closePath();
      break;
    case 'crossRot':
      rad += QUARTER_PI;
    /* falls through */
    case 'cross':
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case 'star':
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      rad += QUARTER_PI;
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case 'line':
      xOffset = w ? w / 2 : Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      break;
    case 'dash':
      ctx.moveTo(x, y);
      ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
      break;
    case false:
      ctx.closePath();
      break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5; // margin - default is to match rounded decimals
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
/**
 * @private
 */
function _steppedLineTo(ctx, previous, target, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === 'middle') {
    const midpoint = (previous.x + target.x) / 2.0;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === 'after' !== !!flip) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */
function _bezierCurveTo(ctx, previous, target, flip) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    /**
    * Now that IE11 support has been dropped, we can use more
    * of the TextMetrics object. The actual bounding boxes
    * are unflagged in Chrome, Firefox, Edge, and Safari so they
    * can be safely used.
    * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
    */
    const metrics = ctx.measureText(line);
    const left = x - metrics.actualBoundingBoxLeft;
    const right = x + metrics.actualBoundingBoxRight;
    const top = y - metrics.actualBoundingBoxAscent;
    const bottom = y + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function drawBackdrop(ctx, opts) {
  const oldColor = ctx.fillStyle;
  ctx.fillStyle = opts.color;
  ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
  ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */
function renderText(ctx, text, x, y, font, opts = {}) {
  const lines = isArray(text) ? text : [text];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
  let i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line = lines[i];
    if (opts.backdrop) {
      drawBackdrop(ctx, opts.backdrop);
    }
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x, y, opts.maxWidth);
    }
    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += Number(font.lineHeight);
  }
  ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */
function addRoundedRectPath(ctx, rect) {
  const {
    x,
    y,
    w,
    h,
    radius
  } = rect;
  // top left arc
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
  // line from top left to bottom left
  ctx.lineTo(x, y + h - radius.bottomLeft);
  // bottom left arc
  ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  // line from bottom left to bottom right
  ctx.lineTo(x + w - radius.bottomRight, y + h);
  // bottom right arc
  ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  // line from bottom right to top right
  ctx.lineTo(x + w, y + radius.topRight);
  // top right arc
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  // line from top right to top left
  ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
    * Converts the given line height `value` in pixels for a specific font `size`.
    * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
    * @param size - The font size (in pixels) used to resolve relative `value`.
    * @returns The effective line height in pixels (size * 1.2 if value is invalid).
    * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
    * @since 2.7.0
    */
function toLineHeight(value, size) {
  const matches = ('' + value).match(LINE_HEIGHT);
  if (!matches || matches[1] === 'normal') {
    return size * 1.2;
  }
  value = +matches[2];
  switch (matches[3]) {
    case 'px':
      return value;
    case '%':
      value /= 100;
      break;
  }
  return size * value;
}
const numberOrZero = v => +v || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject$1(props);
  const keys = objProps ? Object.keys(props) : props;
  const read = isObject$1(value) ? objProps ? prop => valueOrDefault(value[prop], value[props[prop]]) : prop => value[prop] : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read(prop));
  }
  return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */
function toTRBL(value) {
  return _readValueToProps(value, {
    top: 'y',
    right: 'x',
    bottom: 'y',
    left: 'x'
  });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */
function toTRBLCorners(value) {
  return _readValueToProps(value, ['topLeft', 'topRight', 'bottomLeft', 'bottomRight']);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults.font;
  let size = valueOrDefault(options.size, fallback.size);
  if (typeof size === 'string') {
    size = parseInt(size, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !('' + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = undefined;
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ''
  };
  font.string = toFontString(font);
  return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */
function resolve(inputs, context, index, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === undefined) {
      continue;
    }
    if (context !== undefined && typeof value === 'function') {
      value = value(context);
      cacheable = false;
    }
    if (index !== undefined && isArray(value)) {
      value = value[index % value.length];
      cacheable = false;
    }
    if (value !== undefined) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */
function _addGrace(minmax, grace, beginAtZero) {
  const {
    min,
    max
  } = minmax;
  const change = toDimension(grace, (max - min) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min, -Math.abs(change)),
    max: keepZero(max, change)
  };
}
function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}

/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */
function _createResolver(scopes, prefixes = [''], rootScopes, fallback, getTarget = () => scopes[0]) {
  const finalRootScopes = rootScopes || scopes;
  if (typeof fallback === 'undefined') {
    fallback = _resolve('_fallback', scopes);
  }
  const cache = {
    [Symbol.toStringTag]: 'Object',
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: finalRootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: scope => _createResolver([scope, ...scopes], prefixes, finalRootScopes, fallback)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop]; // remove from cache
      delete target._keys; // remove cached keys
      delete scopes[0][prop]; // remove from top level scope
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop) {
      return _cached(target, prop, () => _resolveWithPrefixes(prop, prefixes, scopes, target));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value; // set to top level scope + cache
      delete target._keys; // remove cached keys
      return true;
    }
  });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: ctx => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: scope => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop]; // remove from cache
      delete proxy[prop]; // remove from proxy
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop, receiver) {
      return _cached(target, prop, () => _resolveWithContext(target, prop, receiver));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
        enumerable: true,
        configurable: true
      } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      proxy[prop] = value; // set to proxy
      delete target[prop]; // remove from cache
      return true;
    }
  });
}
/**
 * @private
 */
function _descriptors(proxy, defaults = {
  scriptable: true,
  indexable: true
}) {
  const {
    _scriptable = defaults.scriptable,
    _indexable = defaults.indexable,
    _allKeys = defaults.allKeys
  } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
const readKey = (prefix, name) => prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value) => isObject$1(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
  if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') {
    return target[prop];
  }
  const value = resolve();
  // cache the resolved value
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const {
    _proxy,
    _context,
    _subProxy,
    _descriptors: descriptors
  } = target;
  let value = _proxy[prop]; // resolve from proxy
  // resolve with context
  if (isFunction(value) && descriptors.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
  }
  return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
  const {
    _proxy,
    _context,
    _subProxy,
    _stack
  } = target;
  if (_stack.has(prop)) {
    throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
  }
  _stack.add(prop);
  let value = getValue(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const {
    _proxy,
    _context,
    _subProxy,
    _descriptors: descriptors
  } = target;
  if (typeof _context.index !== 'undefined' && isIndexable(prop)) {
    return value[_context.index % value.length];
  } else if (isObject$1(value[0])) {
    // Array of objects, return array or resolvers
    const arr = value;
    const scopes = _proxy._scopes.filter(s => s !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent) => key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) {
        // When we reach the descriptor that defines a new _fallback, return that.
        // The fallback will resume to that new scope.
        return fallback;
      }
    } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) {
      // Fallback to `false` results to `false`, when falling back to different key.
      // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [...parentScopes, ...rootScopes];
  const set = new Set();
  set.add(value);
  let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (typeof fallback !== 'undefined' && fallback !== prop) {
    key = addScopesFromKey(set, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(Array.from(set), [''], rootScopes, fallback, () => subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray(target) && isObject$1(value)) {
    // For array of objects, the object is used to store updated values
    return value;
  }
  return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix of prefixes) {
    value = _resolve(readKey(prefix, prop), scopes);
    if (typeof value !== 'undefined') {
      return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (typeof value !== 'undefined') {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set = new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter(k => !k.startsWith('_'))) {
      set.add(key);
    }
  }
  return Array.from(set);
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
const getValueAxis = indexAxis => indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  // Props to Rob Spencer at scaled innovation for his post on splining between points
  // http://scaledinnovation.com/analytics/splines/aboutSplines.html
  // This function must also respect "skipped" points
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  // If all points are the same, s01 & s02 will be inf
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t * s01; // scaling factor for triangle Ta
  const fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
/**
 * Adjust tangents to ensure monotonic properties
 */
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */
function splineCurveMonotone(points, indexAxis = 'x') {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  // Calculate slopes (deltaK) and initialize tangents (mK)
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
  return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
/**
 * @private
 */
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  // Only consider points that are drawn in case the spanGaps option is used
  if (options.spanGaps) {
    points = points.filter(pt => !pt.skip);
  }
  if (options.cubicInterpolationMode === 'monotone') {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}

/**
 * @private
 */
function _isDomSupported() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === '[object ShadowRoot]') {
    parent = parent.host;
  }
  return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === 'string') {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf('%') !== -1) {
      // percentage * size in dimension
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
const getComputedStyle$1 = element => element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle$1(el).getPropertyValue(property);
}
const positions = ['top', 'right', 'bottom', 'left'];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? '-' + suffix : '';
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
const useOffsetPos = (x, y, target) => (x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */
function getCanvasPosition(e, canvas) {
  const touches = e.touches;
  const source = touches && touches.length ? touches[0] : e;
  const {
    offsetX,
    offsetY
  } = source;
  let box = false;
  let x, y;
  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }
  return {
    x,
    y,
    box
  };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */
function getRelativePosition(event, chart) {
  if ('native' in event) {
    return event;
  }
  const {
    canvas,
    currentDevicePixelRatio
  } = chart;
  const style = getComputedStyle$1(canvas);
  const borderBox = style.boxSizing === 'border-box';
  const paddings = getPositionedStyle(style, 'padding');
  const borders = getPositionedStyle(style, 'border', 'width');
  const {
    x,
    y,
    box
  } = getCanvasPosition(event, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let {
    width,
    height
  } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height) {
  let maxWidth, maxHeight;
  if (width === undefined || height === undefined) {
    const container = canvas && _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect(); // this is the border box of the container
      const containerStyle = getComputedStyle$1(container);
      const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
      const containerPadding = getPositionedStyle(containerStyle, 'padding');
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
    }
  }
  return {
    width,
    height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
const round1 = v => Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle$1(canvas);
  const margins = getPositionedStyle(style, 'margin');
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let {
    width,
    height
  } = containerSize;
  if (style.boxSizing === 'content-box') {
    const borders = getPositionedStyle(style, 'border', 'width');
    const paddings = getPositionedStyle(style, 'padding');
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
  if (width && !height) {
    // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
  }
  const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
  if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
    height = containerSize.height;
    width = round1(Math.floor(height * aspectRatio));
  }
  return {
    width,
    height
  };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = Math.floor(chart.height);
  chart.width = Math.floor(chart.width);
  const canvas = chart.canvas;
  // If no style has been set on the canvas, the render size is used as display size,
  // making the chart visually bigger, so let's enforce it to the "correct" values.
  // See https://github.com/chartjs/Chart.js/issues/3575
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
const supportsEventListenerOptions = function () {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    if (_isDomSupported()) {
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    }
  } catch (e) {
    // continue regardless of error
  }
  return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : undefined;
}

/**
 * @private
 */
function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}
/**
 * @private
 */
function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
  };
}
/**
 * @private
 */
function _bezierInterpolation(p1, p2, t, mode) {
  const cp1 = {
    x: p1.cp2x,
    y: p1.cp2y
  };
  const cp2 = {
    x: p2.cp1x,
    y: p2.cp1y
  };
  const a = _pointInLine(p1, cp1, t);
  const b = _pointInLine(cp1, cp2, t);
  const c = _pointInLine(cp2, p2, t);
  const d = _pointInLine(a, b, t);
  const e = _pointInLine(b, c, t);
  return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function (rectX, width) {
  return {
    x(x) {
      return rectX + rectX + width - x;
    },
    setWidth(w) {
      width = w;
    },
    textAlign(align) {
      if (align === 'center') {
        return align;
      }
      return align === 'right' ? 'left' : 'right';
    },
    xPlus(x, value) {
      return x - value;
    },
    leftForLtr(x, itemWidth) {
      return x - itemWidth;
    }
  };
};
const getLeftToRightAdapter = function () {
  return {
    x(x) {
      return x;
    },
    setWidth(w) {},
    textAlign(align) {
      return align;
    },
    xPlus(x, value) {
      return x + value;
    },
    leftForLtr(x, _itemWidth) {
      return x;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === 'ltr' || direction === 'rtl') {
    style = ctx.canvas.style;
    original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
    style.setProperty('direction', direction, 'important');
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== undefined) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty('direction', original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === 'angle') {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a, b) => a - b,
    normalize: x => x
  };
}
function normalizeSegment({
  start,
  end,
  count,
  loop,
  style
}) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const {
    property,
    start: startBound,
    end: endBound
  } = bounds;
  const {
    between,
    normalize
  } = propertyFn(property);
  const count = points.length;
  let {
    start,
    end,
    loop
  } = segment;
  let i, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return {
    start,
    end,
    loop,
    style: segment.style
  };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [segment];
  }
  const {
    property,
    start: startBound,
    end: endBound
  } = bounds;
  const count = points.length;
  const {
    compare,
    between,
    normalize
  } = propertyFn(property);
  const {
    start,
    end,
    loop,
    style
  } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start, prev = start; i <= end; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({
        start: subStart,
        end: i,
        loop,
        count,
        style
      }));
      subStart = null;
    }
    prev = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({
      start: subStart,
      end,
      loop,
      count,
      style
    }));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return {
    start,
    end
  };
}
function solidSegments(points, start, max, loop) {
  const count = points.length;
  const result = [];
  let last = start;
  let prev = points[start];
  let end;
  for (end = start + 1; end <= max; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({
          start: start % count,
          end: (end - 1) % count,
          loop
        });
        start = last = cur.stop ? end : null;
      }
    } else {
      last = end;
      if (prev.skip) {
        start = end;
      }
    }
    prev = cur;
  }
  if (last !== null) {
    result.push({
      start: start % count,
      end: last % count,
      loop
    });
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const {
    start,
    end
  } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [{
      start,
      end,
      loop
    }], points, segmentOptions);
  }
  const max = end < start ? end + count : end;
  const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const {
    _datasetIndex: datasetIndex,
    options: {
      spanGaps
    }
  } = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i = start;
  function addStyle(s, e, l, st) {
    const dir = spanGaps ? -1 : 1;
    if (s === e) {
      return;
    }
    s += count;
    while (points[s % count].skip) {
      s -= dir;
    }
    while (points[e % count].skip) {
      e += dir;
    }
    if (s % count !== e % count) {
      result.push({
        start: s % count,
        end: e % count,
        loop: l,
        style: st
      });
      prevStyle = st;
      start = e % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev = points[start % count];
    let style;
    for (i = start + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext(chartContext, {
        type: 'segment',
        p0: prev,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
      prev = pt;
      prevStyle = style;
    }
    if (start < i - 1) {
      addStyle(start, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  if (!prevStyle) {
    return false;
  }
  const cache = [];
  const replacer = function (key, value) {
    if (!isPatternOrGradient(value)) {
      return value;
    }
    if (!cache.includes(value)) {
      cache.push(value);
    }
    return cache.indexOf(value);
  };
  return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class Animator {
  constructor() {
    this._request = null;
    this._charts = new Map();
    this._running = false;
    this._lastDate = undefined;
  }
  _notify(chart, anims, date, type) {
    const callbacks = anims.listeners[type];
    const numSteps = anims.duration;
    callbacks.forEach(fn => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw) {
        chart.draw();
        this._notify(chart, anims, date, 'progress');
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, 'complete');
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), 'complete');
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
}
var animator = /* #__PURE__ */new Animator();
const transparent = 'transparent';
const interpolators = {
  boolean(from, to, factor) {
    return factor > 0.5 ? to : from;
  },
  color(from, to, factor) {
    const c0 = color(from || transparent);
    const c1 = c0.valid && color(to || transparent);
    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
  },
  number(from, to, factor) {
    return from + (to - from) * factor;
  }
};
class Animation {
  constructor(cfg, target, prop, to) {
    const currentValue = target[prop];
    to = resolve([cfg.to, to, currentValue, cfg.from]);
    const from = resolve([cfg.from, currentValue, to]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from;
    this._to = to;
    this._promises = undefined;
  }
  active() {
    return this._active;
  }
  update(cfg, to, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([cfg.to, to, currentValue, cfg.from]);
      this._from = resolve([cfg.from, currentValue, to]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from = this._from;
    const loop = this._loop;
    const to = this._to;
    let factor;
    this._active = from !== to && (loop || elapsed < duration);
    if (!this._active) {
      this._target[prop] = to;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from;
      return;
    }
    factor = elapsed / duration % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from, to, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({
        res,
        rej
      });
    });
  }
  _notify(resolved) {
    const method = resolved ? 'res' : 'rej';
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
}
class Animations {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject$1(config)) {
      return;
    }
    const animationOptions = Object.keys(defaults.animation);
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach(key => {
      const cfg = config[key];
      if (!isObject$1(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [key]).forEach(prop => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {});
    }
    return animations;
  }
  _createAnimations(target, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === '$') {
        continue;
      }
      if (prop === 'options') {
        animations.push(...this._animateOptions(target, values));
        continue;
      }
      const value = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values) {
    if (this._properties.size === 0) {
      Object.assign(target, values);
      return;
    }
    const animations = this._createAnimations(target, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
}
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target.options;
  if (!options) {
    target.options = newOptions;
    return;
  }
  if (options.$shared) {
    target.options = options = Object.assign({}, options, {
      $shared: false,
      $animations: {}
    });
  }
  return options;
}
function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min = opts.min === undefined ? allowedOverflow : 0;
  const max = opts.max === undefined ? allowedOverflow : 0;
  return {
    start: reverse ? max : min,
    end: reverse ? min : max
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x = scaleClip(xScale, allowedOverflow);
  const y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}
function toClip(value) {
  let t, r, b, l;
  if (isObject$1(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }
  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
  const keys = stack.keys;
  const singleMode = options.mode === 'single';
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  let found = false;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      found = true;
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
      value += otherValue;
    }
  }
  if (!found && !options.all) {
    return 0;
  }
  return value;
}
function convertObjectDataToArray(data, meta) {
  const {
    iScale,
    vScale
  } = meta;
  const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
  const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
  const keys = Object.keys(data);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      [iAxisKey]: key,
      [vAxisKey]: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const {
    min,
    max,
    minDefined,
    maxDefined
  } = scale.getUserBounds();
  return {
    min: minDefined ? min : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
  for (const meta of vScale.getMatchingVisibleMetas(type).reverse()) {
    const value = stack[meta.index];
    if (positive && value > 0 || !positive && value < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const {
    chart,
    _cachedMeta: meta
  } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const {
    iScale,
    vScale,
    index: datasetIndex
  } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const {
      [iAxis]: index,
      [vAxis]: value
    } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
    const visualValues = stack._visualValues || (stack._visualValues = {});
    visualValues[datasetIndex] = value;
  }
}
function getFirstScaleId(chart, axis) {
  const scales = chart.scales;
  return Object.keys(scales).filter(key => scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
  return createContext(parent, {
    active: false,
    dataset: undefined,
    datasetIndex: index,
    index,
    mode: 'default',
    type: 'dataset'
  });
}
function createDataContext(parent, index, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index,
    parsed: undefined,
    raw: undefined,
    element,
    index,
    mode: 'default',
    type: 'data'
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) {
      return;
    }
    delete stacks[axis][datasetIndex];
    if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) {
      delete stacks[axis]._visualValues[datasetIndex];
    }
  }
}
const isDirectUpdateMode = mode => mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && {
  keys: getSortedDatasetIndices(chart, true),
  values: null
};
class DatasetController {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = undefined;
    this._parsing = false;
    this._data = undefined;
    this._objectData = undefined;
    this._sharedOptions = undefined;
    this._drawStart = undefined;
    this._drawCount = undefined;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = undefined;
    this._syncList = [];
    this.datasetElementType = new.target.datasetElementType;
    this.dataElementType = new.target.dataElementType;
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
    if (this.options.fill && !this.chart.isPluginEnabled('filler')) {
      console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x, y, r) => axis === 'x' ? x : axis === 'r' ? r : y;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, 'x'));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, 'y'));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, 'r'));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update('reset');
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject$1(data)) {
      const meta = this._cachedMeta;
      this._data = convertObjectDataToArray(data, meta);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
      meta._stacked = isStacked(meta.vScale, meta);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const {
      _cachedMeta: meta,
      _data: data
    } = this;
    const {
      iScale,
      _stacked
    } = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data.length ? true : meta._sorted;
    let prev = start > 0 && meta._parsed[start - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start])) {
        parsed = this.parseArrayData(meta, data, start, count);
      } else if (isObject$1(data[start])) {
        parsed = this.parseObjectData(meta, data, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start, count) {
    const {
      iScale,
      vScale
    } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index], index),
        [vAxis]: vScale.parse(data[index], index)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const {
      xScale,
      yScale
    } = meta;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      item = data[index];
      parsed[i] = {
        x: xScale.parse(item[0], index),
        y: yScale.parse(item[1], index)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const {
      xScale,
      yScale
    } = meta;
    const {
      xAxisKey = 'x',
      yAxisKey = 'y'
    } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      item = data[index];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index)
      };
    }
    return parsed;
  }
  getParsed(index) {
    return this._cachedMeta._parsed[index];
  }
  getDataElement(index) {
    return this._cachedMeta.data[index];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]._visualValues
    };
    return applyStack(stack, value, meta.index, {
      mode
    });
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    const parsedValue = parsed[scale.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values = stack && parsed._stacks[scale.axis];
    if (stack && values) {
      stack.values = values;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range.min = Math.min(range.min, value);
    range.max = Math.max(range.max, value);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack = createStack(canStack, meta, this.chart);
    const range = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    const {
      min: otherMin,
      max: otherMax
    } = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range, scale, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range, scale, parsed, stack);
        break;
      }
    }
    return range;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale.axis];
      if (isNumberFinite(value)) {
        values.push(value);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index);
    return {
      label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
      value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || 'default');
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {}
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || elements.length - start;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i = start; i < start + count; ++i) {
      const element = elements[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active.length; ++i) {
      active[i].draw(ctx, area);
    }
  }
  getStyle(index, active) {
    const mode = active ? 'active' : 'default';
    return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
  }
  getContext(index, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index >= 0 && index < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
      context.parsed = this.getParsed(index);
      context.raw = dataset.data[index];
      context.index = context.dataIndex = index;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index);
  }
  _resolveElementOptions(elementType, mode = 'default', index) {
    const active = mode === 'active';
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + '-' + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active ? [`${elementType}Hover`, 'hover', elementType, ''] : [elementType, ''];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names = Object.keys(defaults.elements[elementType]);
    const context = () => this.getContext(index, active, mode);
    const values = config.resolveNamedOptions(scopes, names, context, prefixes);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start, mode) {
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return {
      sharedOptions,
      includeOptions
    };
  }
  updateElement(element, index, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index, mode, active) {
    element.active = active;
    const options = this.getStyle(index, active);
    this._resolveAnimations(index, mode, active).update(element, {
      options: !active && this.getSharedOptions(options) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index) {
    this._setStyle(element, index, 'active', false);
  }
  setHoverStyle(element, datasetIndex, index) {
    this._setStyle(element, index, 'active', true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, undefined, 'active', false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, undefined, 'active', true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end = start + count;
    let i;
    const move = arr => {
      arr.length += count;
      for (i = arr.length - 1; i >= end; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data);
    for (i = start; i < end; ++i) {
      data[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data, start, count, 'reset');
    }
  }
  updateElements(element, start, count, mode) {}
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([this.index, ...args]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync(['_insertElements', this.getDataset().data.length - count, count]);
  }
  _onDataPop() {
    this._sync(['_removeElements', this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(['_removeElements', 0, 1]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync(['_removeElements', start, count]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync(['_insertElements', start, newCount]);
    }
  }
  _onDataUnshift() {
    this._sync(['_insertElements', 0, arguments.length]);
  }
}
function getAllScaleValues(scale, type) {
  if (!scale._cache.$bar) {
    const visibleMetas = scale.getMatchingVisibleMetas(type);
    let values = [];
    for (let i = 0, ilen = visibleMetas.length; i < ilen; i++) {
      values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
    }
    scale._cache.$bar = _arrayUnique(values.sort((a, b) => a - b));
  }
  return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
  const scale = meta.iScale;
  const values = getAllScaleValues(scale, meta.type);
  let min = scale._length;
  let i, ilen, curr, prev;
  const updateMinAndPrev = () => {
    if (curr === 32767 || curr === -32768) {
      return;
    }
    if (defined(prev)) {
      min = Math.min(min, Math.abs(curr - prev) || min);
    }
    prev = curr;
  };
  for (i = 0, ilen = values.length; i < ilen; ++i) {
    curr = scale.getPixelForValue(values[i]);
    updateMinAndPrev();
  }
  prev = undefined;
  for (i = 0, ilen = scale.ticks.length; i < ilen; ++i) {
    curr = scale.getPixelForTick(i);
    updateMinAndPrev();
  }
  return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
  const thickness = options.barThickness;
  let size, ratio;
  if (isNullOrUndef(thickness)) {
    size = ruler.min * options.categoryPercentage;
    ratio = options.barPercentage;
  } else {
    size = thickness * stackCount;
    ratio = 1;
  }
  return {
    chunk: size / stackCount,
    ratio,
    start: ruler.pixels[index] - size / 2
  };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
  const pixels = ruler.pixels;
  const curr = pixels[index];
  let prev = index > 0 ? pixels[index - 1] : null;
  let next = index < pixels.length - 1 ? pixels[index + 1] : null;
  const percent = options.categoryPercentage;
  if (prev === null) {
    prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
  }
  if (next === null) {
    next = curr + curr - prev;
  }
  const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
  const size = Math.abs(next - prev) / 2 * percent;
  return {
    chunk: size / stackCount,
    ratio: options.barPercentage,
    start
  };
}
function parseFloatBar(entry, item, vScale, i) {
  const startValue = vScale.parse(entry[0], i);
  const endValue = vScale.parse(entry[1], i);
  const min = Math.min(startValue, endValue);
  const max = Math.max(startValue, endValue);
  let barStart = min;
  let barEnd = max;
  if (Math.abs(min) > Math.abs(max)) {
    barStart = max;
    barEnd = min;
  }
  item[vScale.axis] = barEnd;
  item._custom = {
    barStart,
    barEnd,
    start: startValue,
    end: endValue,
    min,
    max
  };
}
function parseValue(entry, item, vScale, i) {
  if (isArray(entry)) {
    parseFloatBar(entry, item, vScale, i);
  } else {
    item[vScale.axis] = vScale.parse(entry, i);
  }
  return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
  const iScale = meta.iScale;
  const vScale = meta.vScale;
  const labels = iScale.getLabels();
  const singleScale = iScale === vScale;
  const parsed = [];
  let i, ilen, item, entry;
  for (i = start, ilen = start + count; i < ilen; ++i) {
    entry = data[i];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
    parsed.push(parseValue(entry, item, vScale, i));
  }
  return parsed;
}
function isFloatBar(custom) {
  return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
  if (size !== 0) {
    return sign(size);
  }
  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
  let reverse, start, end, top, bottom;
  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start = 'left';
    end = 'right';
  } else {
    reverse = properties.base < properties.y;
    start = 'bottom';
    end = 'top';
  }
  if (reverse) {
    top = 'end';
    bottom = 'start';
  } else {
    top = 'start';
    bottom = 'end';
  }
  return {
    start,
    end,
    reverse,
    top,
    bottom
  };
}
function setBorderSkipped(properties, options, stack, index) {
  let edge = options.borderSkipped;
  const res = {};
  if (!edge) {
    properties.borderSkipped = res;
    return;
  }
  if (edge === true) {
    properties.borderSkipped = {
      top: true,
      right: true,
      bottom: true,
      left: true
    };
    return;
  }
  const {
    start,
    end,
    reverse,
    top,
    bottom
  } = borderProps(properties);
  if (edge === 'middle' && stack) {
    properties.enableBorderRadius = true;
    if ((stack._top || 0) === index) {
      edge = top;
    } else if ((stack._bottom || 0) === index) {
      edge = bottom;
    } else {
      res[parseEdge(bottom, start, end, reverse)] = true;
      edge = top;
    }
  }
  res[parseEdge(edge, start, end, reverse)] = true;
  properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
  if (reverse) {
    edge = swap(edge, a, b);
    edge = startEnd(edge, b, a);
  } else {
    edge = startEnd(edge, a, b);
  }
  return edge;
}
function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
  return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, {
  inflateAmount
}, ratio) {
  properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
  static id = 'bar';
  static defaults = {
    datasetElementType: false,
    dataElementType: 'bar',
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
      numbers: {
        type: 'number',
        properties: ['x', 'y', 'base', 'width', 'height']
      }
    }
  };
  static overrides = {
    scales: {
      _index_: {
        type: 'category',
        offset: true,
        grid: {
          offset: true
        }
      },
      _value_: {
        type: 'linear',
        beginAtZero: true
      }
    }
  };
  parsePrimitiveData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseArrayData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseObjectData(meta, data, start, count) {
    const {
      iScale,
      vScale
    } = meta;
    const {
      xAxisKey = 'x',
      yAxisKey = 'y'
    } = this._parsing;
    const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
    const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
    const parsed = [];
    let i, ilen, item, obj;
    for (i = start, ilen = start + count; i < ilen; ++i) {
      obj = data[i];
      item = {};
      item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
      parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
    }
    return parsed;
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    super.updateRangeFromParsed(range, scale, parsed, stack);
    const custom = parsed._custom;
    if (custom && scale === this._cachedMeta.vScale) {
      range.min = Math.min(range.min, custom.min);
      range.max = Math.max(range.max, custom.max);
    }
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const {
      iScale,
      vScale
    } = meta;
    const parsed = this.getParsed(index);
    const custom = parsed._custom;
    const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
    return {
      label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
      value
    };
  }
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
    const meta = this._cachedMeta;
    meta.stack = this.getDataset().stack;
  }
  update(mode) {
    const meta = this._cachedMeta;
    this.updateElements(meta.data, 0, meta.data.length, mode);
  }
  updateElements(bars, start, count, mode) {
    const reset = mode === 'reset';
    const {
      index,
      _cachedMeta: {
        vScale
      }
    } = this;
    const base = vScale.getBasePixel();
    const horizontal = vScale.isHorizontal();
    const ruler = this._getRuler();
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    for (let i = start; i < start + count; i++) {
      const parsed = this.getParsed(i);
      const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {
        base,
        head: base
      } : this._calculateBarValuePixels(i);
      const ipixels = this._calculateBarIndexPixels(i, ruler);
      const stack = (parsed._stacks || {})[vScale.axis];
      const properties = {
        horizontal,
        base: vpixels.base,
        enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
        x: horizontal ? vpixels.head : ipixels.center,
        y: horizontal ? ipixels.center : vpixels.head,
        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
      }
      const options = properties.options || bars[i].options;
      setBorderSkipped(properties, options, stack, index);
      setInflateAmount(properties, options, ruler.ratio);
      this.updateElement(bars[i], i, properties, mode);
    }
  }
  _getStacks(last, dataIndex) {
    const {
      iScale
    } = this._cachedMeta;
    const metasets = iScale.getMatchingVisibleMetas(this._type).filter(meta => meta.controller.options.grouped);
    const stacked = iScale.options.stacked;
    const stacks = [];
    const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
    const iScaleValue = currentParsed && currentParsed[iScale.axis];
    const skipNull = meta => {
      const parsed = meta._parsed.find(item => item[iScale.axis] === iScaleValue);
      const val = parsed && parsed[meta.vScale.axis];
      if (isNullOrUndef(val) || isNaN(val)) {
        return true;
      }
    };
    for (const meta of metasets) {
      if (dataIndex !== undefined && skipNull(meta)) {
        continue;
      }
      if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
        stacks.push(meta.stack);
      }
      if (meta.index === last) {
        break;
      }
    }
    if (!stacks.length) {
      stacks.push(undefined);
    }
    return stacks;
  }
  _getStackCount(index) {
    return this._getStacks(undefined, index).length;
  }
  _getStackIndex(datasetIndex, name, dataIndex) {
    const stacks = this._getStacks(datasetIndex, dataIndex);
    const index = name !== undefined ? stacks.indexOf(name) : -1;
    return index === -1 ? stacks.length - 1 : index;
  }
  _getRuler() {
    const opts = this.options;
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const pixels = [];
    let i, ilen;
    for (i = 0, ilen = meta.data.length; i < ilen; ++i) {
      pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
    }
    const barThickness = opts.barThickness;
    const min = barThickness || computeMinSampleSize(meta);
    return {
      min,
      pixels,
      start: iScale._startPixel,
      end: iScale._endPixel,
      stackCount: this._getStackCount(),
      scale: iScale,
      grouped: opts.grouped,
      ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
    };
  }
  _calculateBarValuePixels(index) {
    const {
      _cachedMeta: {
        vScale,
        _stacked,
        index: datasetIndex
      },
      options: {
        base: baseValue,
        minBarLength
      }
    } = this;
    const actualBase = baseValue || 0;
    const parsed = this.getParsed(index);
    const custom = parsed._custom;
    const floating = isFloatBar(custom);
    let value = parsed[vScale.axis];
    let start = 0;
    let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
    let head, size;
    if (length !== value) {
      start = length - value;
      length = value;
    }
    if (floating) {
      value = custom.barStart;
      length = custom.barEnd - custom.barStart;
      if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
        start = 0;
      }
      start += value;
    }
    const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
    let base = vScale.getPixelForValue(startValue);
    if (this.chart.getDataVisibility(index)) {
      head = vScale.getPixelForValue(start + length);
    } else {
      head = base;
    }
    size = head - base;
    if (Math.abs(size) < minBarLength) {
      size = barSign(size, vScale, actualBase) * minBarLength;
      if (value === actualBase) {
        base -= size / 2;
      }
      const startPixel = vScale.getPixelForDecimal(0);
      const endPixel = vScale.getPixelForDecimal(1);
      const min = Math.min(startPixel, endPixel);
      const max = Math.max(startPixel, endPixel);
      base = Math.max(Math.min(base, max), min);
      head = base + size;
      if (_stacked && !floating) {
        parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
      }
    }
    if (base === vScale.getPixelForValue(actualBase)) {
      const halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
      base += halfGrid;
      size -= halfGrid;
    }
    return {
      size,
      base,
      head,
      center: head + size / 2
    };
  }
  _calculateBarIndexPixels(index, ruler) {
    const scale = ruler.scale;
    const options = this.options;
    const skipNull = options.skipNull;
    const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
    let center, size;
    if (ruler.grouped) {
      const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
      const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
      const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
      center = range.start + range.chunk * stackIndex + range.chunk / 2;
      size = Math.min(maxBarThickness, range.chunk * range.ratio);
    } else {
      center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
      size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
    }
    return {
      base: center - size / 2,
      head: center + size / 2,
      center,
      size
    };
  }
  draw() {
    const meta = this._cachedMeta;
    const vScale = meta.vScale;
    const rects = meta.data;
    const ilen = rects.length;
    let i = 0;
    for (; i < ilen; ++i) {
      if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) {
        rects[i].draw(this._ctx);
      }
    }
  }
}
function getRatioAndOffset(rotation, circumference, cutout) {
  let ratioX = 1;
  let ratioY = 1;
  let offsetX = 0;
  let offsetY = 0;
  if (circumference < TAU) {
    const startAngle = rotation;
    const endAngle = startAngle + circumference;
    const startX = Math.cos(startAngle);
    const startY = Math.sin(startAngle);
    const endX = Math.cos(endAngle);
    const endY = Math.sin(endAngle);
    const calcMax = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
    const calcMin = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
    const maxX = calcMax(0, startX, endX);
    const maxY = calcMax(HALF_PI, startY, endY);
    const minX = calcMin(PI, startX, endX);
    const minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }
  return {
    ratioX,
    ratioY,
    offsetX,
    offsetY
  };
}
class DoughnutController extends DatasetController {
  static id = 'doughnut';
  static defaults = {
    datasetElementType: false,
    dataElementType: 'arc',
    animation: {
      animateRotate: true,
      animateScale: false
    },
    animations: {
      numbers: {
        type: 'number',
        properties: ['circumference', 'endAngle', 'innerRadius', 'outerRadius', 'startAngle', 'x', 'y', 'offset', 'borderWidth', 'spacing']
      }
    },
    cutout: '50%',
    rotation: 0,
    circumference: 360,
    radius: '100%',
    spacing: 0,
    indexAxis: 'r'
  };
  static descriptors = {
    _scriptable: name => name !== 'spacing',
    _indexable: name => name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
  };
  static overrides = {
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          generateLabels(chart) {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              const {
                labels: {
                  pointStyle,
                  color
                }
              } = chart.legend.options;
              return data.labels.map((label, i) => {
                const meta = chart.getDatasetMeta(0);
                const style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  fontColor: color,
                  lineWidth: style.borderWidth,
                  pointStyle: pointStyle,
                  hidden: !chart.getDataVisibility(i),
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick(e, legendItem, legend) {
          legend.chart.toggleDataVisibility(legendItem.index);
          legend.chart.update();
        }
      }
    }
  };
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.enableOptionSharing = true;
    this.innerRadius = undefined;
    this.outerRadius = undefined;
    this.offsetX = undefined;
    this.offsetY = undefined;
  }
  linkScales() {}
  parse(start, count) {
    const data = this.getDataset().data;
    const meta = this._cachedMeta;
    if (this._parsing === false) {
      meta._parsed = data;
    } else {
      let getter = i => +data[i];
      if (isObject$1(data[start])) {
        const {
          key = 'value'
        } = this._parsing;
        getter = i => +resolveObjectKey(data[i], key);
      }
      let i, ilen;
      for (i = start, ilen = start + count; i < ilen; ++i) {
        meta._parsed[i] = getter(i);
      }
    }
  }
  _getRotation() {
    return toRadians(this.options.rotation - 90);
  }
  _getCircumference() {
    return toRadians(this.options.circumference);
  }
  _getRotationExtents() {
    let min = TAU;
    let max = -TAU;
    for (let i = 0; i < this.chart.data.datasets.length; ++i) {
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const controller = this.chart.getDatasetMeta(i).controller;
        const rotation = controller._getRotation();
        const circumference = controller._getCircumference();
        min = Math.min(min, rotation);
        max = Math.max(max, rotation + circumference);
      }
    }
    return {
      rotation: min,
      circumference: max - min
    };
  }
  update(mode) {
    const chart = this.chart;
    const {
      chartArea
    } = chart;
    const meta = this._cachedMeta;
    const arcs = meta.data;
    const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
    const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
    const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
    const chartWeight = this._getRingWeight(this.index);
    const {
      circumference,
      rotation
    } = this._getRotationExtents();
    const {
      ratioX,
      ratioY,
      offsetX,
      offsetY
    } = getRatioAndOffset(rotation, circumference, cutout);
    const maxWidth = (chartArea.width - spacing) / ratioX;
    const maxHeight = (chartArea.height - spacing) / ratioY;
    const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
    const outerRadius = toDimension(this.options.radius, maxRadius);
    const innerRadius = Math.max(outerRadius * cutout, 0);
    const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
    this.offsetX = offsetX * outerRadius;
    this.offsetY = offsetY * outerRadius;
    meta.total = this.calculateTotal();
    this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
    this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _circumference(i, reset) {
    const opts = this.options;
    const meta = this._cachedMeta;
    const circumference = this._getCircumference();
    if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
      return 0;
    }
    return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === 'reset';
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const animateScale = reset && animationOpts.animateScale;
    const innerRadius = animateScale ? 0 : this.innerRadius;
    const outerRadius = animateScale ? 0 : this.outerRadius;
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    let startAngle = this._getRotation();
    let i;
    for (i = 0; i < start; ++i) {
      startAngle += this._circumference(i, reset);
    }
    for (i = start; i < start + count; ++i) {
      const circumference = this._circumference(i, reset);
      const arc = arcs[i];
      const properties = {
        x: centerX + this.offsetX,
        y: centerY + this.offsetY,
        startAngle,
        endAngle: startAngle + circumference,
        circumference,
        outerRadius,
        innerRadius
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
      }
      startAngle += circumference;
      this.updateElement(arc, i, properties, mode);
    }
  }
  calculateTotal() {
    const meta = this._cachedMeta;
    const metaData = meta.data;
    let total = 0;
    let i;
    for (i = 0; i < metaData.length; i++) {
      const value = meta._parsed[i];
      if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
        total += Math.abs(value);
      }
    }
    return total;
  }
  calculateCircumference(value) {
    const total = this._cachedMeta.total;
    if (total > 0 && !isNaN(value)) {
      return TAU * (Math.abs(value) / total);
    }
    return 0;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index], chart.options.locale);
    return {
      label: labels[index] || '',
      value
    };
  }
  getMaxBorderWidth(arcs) {
    let max = 0;
    const chart = this.chart;
    let i, ilen, meta, controller, options;
    if (!arcs) {
      for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          meta = chart.getDatasetMeta(i);
          arcs = meta.data;
          controller = meta.controller;
          break;
        }
      }
    }
    if (!arcs) {
      return 0;
    }
    for (i = 0, ilen = arcs.length; i < ilen; ++i) {
      options = controller.resolveDataElementOptions(i);
      if (options.borderAlign !== 'inner') {
        max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
      }
    }
    return max;
  }
  getMaxOffset(arcs) {
    let max = 0;
    for (let i = 0, ilen = arcs.length; i < ilen; ++i) {
      const options = this.resolveDataElementOptions(i);
      max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
    }
    return max;
  }
  _getRingWeightOffset(datasetIndex) {
    let ringWeightOffset = 0;
    for (let i = 0; i < datasetIndex; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        ringWeightOffset += this._getRingWeight(i);
      }
    }
    return ringWeightOffset;
  }
  _getRingWeight(datasetIndex) {
    return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
class LineController extends DatasetController {
  static id = 'line';
  static defaults = {
    datasetElementType: 'line',
    dataElementType: 'point',
    showLine: true,
    spanGaps: false
  };
  static overrides = {
    scales: {
      _index_: {
        type: 'category'
      },
      _value_: {
        type: 'linear'
      }
    }
  };
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const {
      dataset: line,
      data: points = [],
      _dataset
    } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let {
      start,
      count
    } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, undefined, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === 'reset';
    const {
      iScale,
      vScale,
      _stacked,
      _dataset
    } = this._cachedMeta;
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const {
      spanGaps,
      segment
    } = this.options;
    const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
    const end = start + count;
    const pointsCount = points.length;
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = 0; i < pointsCount; ++i) {
      const point = points[i];
      const properties = directUpdate ? point : {};
      if (i < start || i >= end) {
        properties.skip = true;
        continue;
      }
      const parsed = this.getParsed(i);
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
}

/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */
function abstract() {
  throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */
class DateAdapterBase {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(members) {
    Object.assign(DateAdapterBase.prototype, members);
  }
  options;
  constructor(options) {
    this.options = options || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {}
  formats() {
    return abstract();
  }
  parse() {
    return abstract();
  }
  format() {
    return abstract();
  }
  add() {
    return abstract();
  }
  diff() {
    return abstract();
  }
  startOf() {
    return abstract();
  }
  endOf() {
    return abstract();
  }
}
var adapters = {
  _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
  const {
    controller,
    data,
    _sorted
  } = metaset;
  const iScale = controller._cachedMeta.iScale;
  const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
  if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      const result = lookupMethod(data, axis, value);
      if (spanGaps) {
        const {
          vScale
        } = controller._cachedMeta;
        const {
          _parsed
        } = metaset;
        const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex(point => !isNullOrUndef(point[vScale.axis]));
        result.lo -= Math.max(0, distanceToDefinedLo);
        const distanceToDefinedHi = _parsed.slice(result.hi).findIndex(point => !isNullOrUndef(point[vScale.axis]));
        result.hi += Math.max(0, distanceToDefinedHi);
      }
      return result;
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range = typeof el.getRange === 'function' && el.getRange(axis);
      if (range) {
        const start = lookupMethod(data, axis, value - range);
        const end = lookupMethod(data, axis, value + range);
        return {
          lo: start.lo,
          hi: end.hi
        };
      }
    }
  }
  return {
    lo: 0,
    hi: data.length - 1
  };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const {
      index,
      data
    } = metasets[i];
    const {
      lo,
      hi
    } = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf('x') !== -1;
  const useY = axis.indexOf('y') !== -1;
  return function (pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return items;
  }
  const evaluationFunc = function (element, datasetIndex, index) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index
      });
    }
  };
  evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index) {
    const {
      startAngle,
      endAngle
    } = element.getProps(['startAngle', 'endAngle'], useFinalPosition);
    const {
      angle
    } = getAngleFromPoint(element, {
      x: position.x,
      y: position.y
    });
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({
        element,
        datasetIndex,
        index
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index) {
    const inRange = element.inRange(position.x, position.y, useFinalPosition);
    if (intersect && !inRange) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange) {
      return;
    }
    const distance = distanceMetric(position, center);
    if (distance < minDistance) {
      items = [{
        element,
        datasetIndex,
        index
      }];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({
        element,
        datasetIndex,
        index
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return [];
  }
  return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index) => {
    if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index
      });
      intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'x';
      const includeInvisible = options.includeInvisible || false;
      const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      const elements = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach(meta => {
        const index = items[0].index;
        const element = meta.data[index];
        if (element && !element.skip) {
          elements.push({
            element,
            datasetIndex: meta.index,
            index
          });
        }
      });
      return elements;
    },
    dataset(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      const includeInvisible = options.includeInvisible || false;
      let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data.length; ++i) {
          items.push({
            element: data[i],
            datasetIndex,
            index: i
          });
        }
      }
      return items;
    },
    point(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      const includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      const includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
    },
    y(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
    }
  }
};
const STATIC_POSITIONS = ['left', 'top', 'right', 'bottom'];
function filterByPosition(array, position) {
  return array.filter(v => v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter(v => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a, b) => {
    const v0 = reverse ? b : a;
    const v1 = reverse ? a : b;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    ({
      position: pos,
      options: {
        stack,
        stackWeight = 1
      }
    } = box);
    layoutBoxes.push({
      index: i,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && pos + stack,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts) {
  const stacks = {};
  for (const wrap of layouts) {
    const {
      stack,
      pos,
      stackWeight
    } = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts, params) {
  const stacks = buildStacks(layouts);
  const {
    vBoxMaxWidth,
    hBoxMaxHeight
  } = params;
  let i, ilen, layout;
  for (i = 0, ilen = layouts.length; i < ilen; ++i) {
    layout = layouts[i];
    const {
      fullSize
    } = layout.box;
    const stack = stacks[layout.stack];
    const factor = stack && layout.stackWeight / stack.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter(wrap => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
  const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, 'chartArea'),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const {
    pos,
    box
  } = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject$1(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack = stacks[layout.stack] || {
      size: 0,
      count: 1
    };
    stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? {
    same: widthChanged,
    other: heightChanged
  } : {
    same: heightChanged,
    other: widthChanged
  };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos('top');
  chartArea.x += updatePos('left');
  updatePos('right');
  updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions) {
    const margin = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    positions.forEach(pos => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout, box, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box = layout.box;
    box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
    const {
      same,
      other
    } = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height;
  box.width = width;
  box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let {
    x,
    y
  } = chartArea;
  for (const layout of boxes) {
    const box = layout.box;
    const stack = stacks[layout.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    };
    const weight = layout.stackWeight / stack.weight || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height = stack.size || box.height;
      if (defined(stack.start)) {
        y = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
      } else {
        setBoxDims(box, chartArea.left + stack.placed, y, width, height);
      }
      stack.start = y;
      stack.placed += width;
      y = box.bottom;
    } else {
      const height = chartArea.h * weight;
      const width = stack.size || box.width;
      if (defined(stack.start)) {
        x = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x, chartArea.top + stack.placed, width, height);
      }
      stack.start = x;
      stack.placed += height;
      x = box.right;
    }
  }
  chartArea.x = x;
  chartArea.y = y;
}
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || 'top';
    item.weight = item.weight || 0;
    item._layers = item._layers || function () {
      return [{
        z: 0,
        draw(chartArea) {
          item.draw(chartArea);
        }
      }];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index !== -1) {
      chart.boxes.splice(index, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, box => {
      if (typeof box.beforeLayout === 'function') {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, layout => {
      const box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class BasePlatform {
  acquireContext(canvas, aspectRatio) {}
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type, listener) {}
  removeEventListener(chart, type, listener) {}
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height, aspectRatio) {
    width = Math.max(0, width || element.width);
    height = height || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext('2d') || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
}
const EXPANDO_KEY = '$chartjs';
const EVENT_TYPES = {
  touchstart: 'mousedown',
  touchmove: 'mousemove',
  touchend: 'mouseup',
  pointerenter: 'mouseenter',
  pointerdown: 'mousedown',
  pointermove: 'mousemove',
  pointerup: 'mouseup',
  pointerleave: 'mouseout',
  pointerout: 'mouseout'
};
const isNullOrEmpty = value => value === null || value === '';
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute('height');
  const renderWidth = canvas.getAttribute('width');
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || 'block';
  style.boxSizing = style.boxSizing || 'border-box';
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, 'width');
    if (displayWidth !== undefined) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === '') {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, 'height');
      if (displayHeight !== undefined) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;
function addListener(node, type, listener) {
  if (node) {
    node.addEventListener(type, listener, eventListenerOptions);
  }
}
function removeListener(chart, type, listener) {
  if (chart && chart.canvas) {
    chart.canvas.removeEventListener(type, listener, eventListenerOptions);
  }
}
function fromNativeEvent(event, chart) {
  const type = EVENT_TYPES[event.type] || event.type;
  const {
    x,
    y
  } = getRelativePosition(event, chart);
  return {
    type,
    chart,
    native: event,
    x: x !== undefined ? x : null,
    y: y !== undefined ? y : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver(entries => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
function createDetachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver(entries => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener('resize', onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener('resize', onWindowResize);
  }
}
function createResizeObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height) => {
    const w = container.clientWidth;
    listener(width, height);
    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver(entries => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height = entry.contentRect.height;
    if (width === 0 && height === 0) {
      return;
    }
    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type === 'resize') {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type, listener) {
  const canvas = chart.canvas;
  const proxy = throttled(event => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart);
  addListener(canvas, type, proxy);
  return proxy;
}
class DomPlatform extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext('2d');
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY].initial;
    ['height', 'width'].forEach(prop => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach(key => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY];
    return true;
  }
  addEventListener(chart, type, listener) {
    this.removeEventListener(chart, type);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers[type] || createProxyAndListen;
    proxies[type] = handler(chart, type, listener);
  }
  removeEventListener(chart, type) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type];
    if (!proxy) {
      return;
    }
    const handlers = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers[type] || removeListener;
    handler(chart, type, proxy);
    proxies[type] = undefined;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height, aspectRatio) {
    return getMaximumSize(canvas, width, height, aspectRatio);
  }
  isAttached(canvas) {
    const container = canvas && _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
}
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
class Element$1 {
  static defaults = {};
  static defaultRoutes = undefined;
  x;
  y;
  active = false;
  options;
  $animations;
  tooltipPosition(useFinalPosition) {
    const {
      x,
      y
    } = this.getProps(['x', 'y'], useFinalPosition);
    return {
      x,
      y
    };
  }
  hasValue() {
    return isNumber(this.x) && isNumber(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      // let's not create an object, if not needed
      return this;
    }
    const ret = {};
    props.forEach(prop => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
}
function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const determinedMaxTicks = determineMaxTicks(scale);
  const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i;
  spacing = Math.ceil(spacing);
  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start;
  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }
  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }
  return diff;
}
const reverseAlign = align => align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset) => edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit) => Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex = Math.min(index, length - 1);
  const start = scale._startPixel;
  const end = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex);
  let offset;
  if (offsetGridLines) {
    if (length === 1) {
      offset = Math.max(lineValue - start, end - lineValue);
    } else if (index === 0) {
      offset = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
    }
    lineValue += validIndex < index ? offset : -offset;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, cache => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext(parent, {
    scale,
    type: 'scale'
  });
}
function createTickContext(parent, index, tick) {
  return createContext(parent, {
    tick,
    index,
    type: 'tick'
  });
}
function titleAlign(align, position, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position !== 'right' || !reverse && position === 'right') {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset, position, align) {
  const {
    top,
    left,
    bottom,
    right,
    chart
  } = scale;
  const {
    chartArea,
    scales
  } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height = bottom - top;
  const width = right - left;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject$1(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
    } else if (position === 'center') {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
    } else {
      titleY = offsetFromEdge(scale, position, offset);
    }
    maxWidth = right - left;
  } else {
    if (isObject$1(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
    } else if (position === 'center') {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
    } else {
      titleX = offsetFromEdge(scale, position, offset);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position === 'left' ? -HALF_PI : HALF_PI;
  }
  return {
    titleX,
    titleY,
    maxWidth,
    rotation
  };
}
class Scale extends Element$1 {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = undefined;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.width = undefined;
    this.height = undefined;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = undefined;
    this.maxHeight = undefined;
    this.paddingTop = undefined;
    this.paddingBottom = undefined;
    this.paddingLeft = undefined;
    this.paddingRight = undefined;
    this.axis = undefined;
    this.labelRotation = undefined;
    this.min = undefined;
    this.max = undefined;
    this._range = undefined;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = undefined;
    this._endPixel = undefined;
    this._reversePixels = false;
    this._userMax = undefined;
    this._userMin = undefined;
    this._suggestedMax = undefined;
    this._suggestedMin = undefined;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = undefined;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index) {
    return raw;
  }
  getUserBounds() {
    let {
      _userMin,
      _userMax,
      _suggestedMin,
      _suggestedMax
    } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let {
      min,
      max,
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let range;
    if (minDefined && maxDefined) {
      return {
        min,
        max
      };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min = Math.min(min, range.min);
      }
      if (!maxDefined) {
        max = Math.max(max, range.max);
      }
    }
    min = maxDefined && min > max ? max : min;
    max = minDefined && min > max ? min : max;
    return {
      min: finiteOrDefault(min, finiteOrDefault(max, min)),
      max: finiteOrDefault(max, finiteOrDefault(min, max))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  getLabelItems(chartArea = this.chart.chartArea) {
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    return items;
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [this]);
  }
  update(maxWidth, maxHeight, margins) {
    const {
      beginAtZero,
      grace,
      ticks: tickOpts
    } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [this]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [this]);
  }
  beforeDataLimits() {
    this._callHooks('beforeDataLimits');
  }
  determineDataLimits() {}
  afterDataLimits() {
    this._callHooks('afterDataLimits');
  }
  beforeBuildTicks() {
    this._callHooks('beforeBuildTicks');
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks('afterBuildTicks');
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [tick.value, i, ticks], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {}
  beforeFit() {
    callback(this.options.beforeFit, [this]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const {
      chart,
      options: {
        ticks: tickOpts,
        title: titleOpts,
        grid: gridOpts
      }
    } = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const {
          first,
          last,
          widest,
          highest
        } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last, sin, cos) {
    const {
      ticks: {
        align,
        padding
      },
      position
    } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position !== 'top' && this.axis === 'x';
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last.width;
        }
      } else if (align === 'start') {
        paddingRight = last.width;
      } else if (align === 'end') {
        paddingLeft = first.width;
      } else if (align !== 'inner') {
        paddingLeft = first.width / 2;
        paddingRight = last.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last.height / 2;
      let paddingBottom = first.height / 2;
      if (align === 'start') {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === 'end') {
        paddingTop = last.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const {
      axis,
      position
    } = this.options;
    return position === 'top' || position === 'bottom' || axis === 'x';
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length, maxTicksLimit) {
    const {
      ctx,
      _longestTextCache: caches
    } = this;
    const widths = [];
    const heights = [];
    const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
    for (i = 0; i < length; i += increment) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {
        data: {},
        gc: []
      };
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = idx => ({
      width: widths[idx] || 0,
      height: heights[idx] || 0
    });
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index) {
    return NaN;
  }
  getValueForPixel(pixel) {}
  getPixelForTick(index) {
    const ticks = this.ticks;
    if (index < 0 || index > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const {
      min,
      max
    } = this;
    return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
  }
  getContext(index) {
    const ticks = this.ticks || [];
    if (index >= 0 && index < ticks.length) {
      const tick = ticks[index];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w = labelSizes ? labelSizes.widest.width + padding : 0;
    const h = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== 'auto') {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const {
      grid,
      position,
      border
    } = options;
    const offset = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = borderOpts.display ? borderOpts.width : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function (pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position === 'top') {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position === 'bottom') {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position === 'left') {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position === 'right') {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === 'x') {
      if (position === 'center') {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === 'y') {
      if (position === 'center') {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const context = this.getContext(i);
      const optsAtIndex = grid.setContext(context);
      const optsAtIndexBorder = border.setContext(context);
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndexBorder.dash || [];
      const borderDashOffset = optsAtIndexBorder.dashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset);
      if (lineValue === undefined) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const {
      position,
      ticks: optionTicks
    } = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const {
      align,
      crossAlign,
      padding,
      mirror
    } = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = 'middle';
    if (position === 'top') {
      y = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === 'bottom') {
      y = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === 'left') {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (position === 'right') {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (axis === 'x') {
      if (position === 'center') {
        y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === 'y') {
      if (position === 'center') {
        x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject$1(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        x = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === 'y') {
      if (align === 'start') {
        textBaseline = 'top';
      } else if (align === 'end') {
        textBaseline = 'bottom';
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x = pixel;
        if (textAlign === 'inner') {
          if (i === ilen - 1) {
            tickTextAlign = !this.options.reverse ? 'right' : 'left';
          } else if (i === 0) {
            tickTextAlign = !this.options.reverse ? 'left' : 'right';
          } else {
            tickTextAlign = 'center';
          }
        }
        if (position === 'top') {
          if (crossAlign === 'near' || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === 'center') {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === 'near' || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === 'center') {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
          x += lineHeight / 2 * Math.sin(rotation);
        }
      } else {
        y = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top = textOffset - labelPadding.top;
        let left = 0 - labelPadding.left;
        switch (textBaseline) {
          case 'middle':
            top -= height / 2;
            break;
          case 'bottom':
            top -= height;
            break;
        }
        switch (textAlign) {
          case 'center':
            left -= width / 2;
            break;
          case 'right':
            left -= width;
            break;
          case 'inner':
            if (i === ilen - 1) {
              left -= width;
            } else if (i > 0) {
              left -= width / 2;
            }
            break;
        }
        backdrop = {
          left,
          top,
          width: width + labelPadding.width,
          height: height + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        label,
        font,
        textOffset,
        options: {
          rotation,
          color,
          strokeColor,
          strokeWidth,
          textAlign: tickTextAlign,
          textBaseline,
          translation: [x, y],
          backdrop
        }
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const {
      position,
      ticks
    } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position === 'top' ? 'left' : 'right';
    }
    let align = 'center';
    if (ticks.align === 'start') {
      align = 'left';
    } else if (ticks.align === 'end') {
      align = 'right';
    } else if (ticks.align === 'inner') {
      align = 'inner';
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const {
      position,
      ticks: {
        crossAlign,
        mirror,
        padding
      }
    } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x;
    if (position === 'left') {
      if (mirror) {
        x = this.right + padding;
        if (crossAlign === 'near') {
          textAlign = 'left';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x += widest / 2;
        } else {
          textAlign = 'right';
          x += widest;
        }
      } else {
        x = this.right - tickAndPadding;
        if (crossAlign === 'near') {
          textAlign = 'right';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x -= widest / 2;
        } else {
          textAlign = 'left';
          x = this.left;
        }
      }
    } else if (position === 'right') {
      if (mirror) {
        x = this.left + padding;
        if (crossAlign === 'near') {
          textAlign = 'right';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x -= widest / 2;
        } else {
          textAlign = 'left';
          x -= widest;
        }
      } else {
        x = this.left + tickAndPadding;
        if (crossAlign === 'near') {
          textAlign = 'left';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x += widest / 2;
        } else {
          textAlign = 'right';
          x = this.right;
        }
      }
    } else {
      textAlign = 'right';
    }
    return {
      textAlign,
      x
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position = this.options.position;
    if (position === 'left' || position === 'right') {
      return {
        top: 0,
        left: this.left,
        bottom: chart.height,
        right: this.right
      };
    }
    if (position === 'top' || position === 'bottom') {
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: chart.width
      };
    }
  }
  drawBackground() {
    const {
      ctx,
      options: {
        backgroundColor
      },
      left,
      top,
      width,
      height
    } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index = ticks.findIndex(t => t.value === value);
    if (index >= 0) {
      const opts = grid.setContext(this.getContext(index));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine({
            x: item.x1,
            y: item.y1
          }, {
            x: item.x2,
            y: item.y2
          }, item);
        }
        if (grid.drawTicks) {
          drawLine({
            x: item.tx1,
            y: item.ty1
          }, {
            x: item.tx2,
            y: item.ty2
          }, {
            color: item.tickColor,
            width: item.tickWidth,
            borderDash: item.tickBorderDash,
            borderDashOffset: item.tickBorderDashOffset
          });
        }
      }
    }
  }
  drawBorder() {
    const {
      chart,
      ctx,
      options: {
        border,
        grid
      }
    } = this;
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = border.display ? borderOpts.width : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.width;
    ctx.strokeStyle = borderOpts.color;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this.getLabelItems(chartArea);
    for (const item of items) {
      const renderTextOptions = item.options;
      const tickFont = item.font;
      const label = item.label;
      const y = item.textOffset;
      renderText(ctx, label, 0, y, tickFont, renderTextOptions);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const {
      ctx,
      options: {
        position,
        title,
        reverse
      }
    } = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset = font.lineHeight / 2;
    if (position === 'bottom' || position === 'center' || isObject$1(position)) {
      offset += padding.bottom;
      if (isArray(title.text)) {
        offset += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset += padding.top;
    }
    const {
      titleX,
      titleY,
      maxWidth,
      rotation
    } = titleArgs(this, offset, position, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position, reverse),
      textBaseline: 'middle',
      translation: [titleX, titleY]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    const bz = valueOrDefault(opts.border && opts.border.z, 0);
    if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
      return [{
        z: tz,
        draw: chartArea => {
          this.draw(chartArea);
        }
      }];
    }
    return [{
      z: gz,
      draw: chartArea => {
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawTitle();
      }
    }, {
      z: bz,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: tz,
      draw: chartArea => {
        this.drawLabels(chartArea);
      }
    }];
  }
  getMatchingVisibleMetas(type) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + 'AxisID';
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type || meta.type === type)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index) {
    const opts = this.options.ticks.setContext(this.getContext(index));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
}
class TypedRegistry {
  constructor(type, scope, override) {
    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = Object.create(null);
  }
  isForType(type) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id = item.id;
    const scope = this.scope + '.' + id;
    if (!id) {
      throw new Error('class does not have id: ' + item);
    }
    if (id in items) {
      return scope;
    }
    items[id] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id) {
    return this.items[id];
  }
  unregister(item) {
    const items = this.items;
    const id = item.id;
    const scope = this.scope;
    if (id in items) {
      delete items[id];
    }
    if (scope && id in defaults[scope]) {
      delete defaults[scope][id];
      if (this.override) {
        delete overrides[id];
      }
    }
  }
}
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge(Object.create(null), [parentScope ? defaults.get(parentScope) : {}, defaults.get(scope), item.defaults]);
  defaults.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach(property => {
    const propertyParts = property.split('.');
    const sourceName = propertyParts.pop();
    const sourceScope = [scope].concat(propertyParts).join('.');
    const parts = routes[property].split('.');
    const targetName = parts.pop();
    const targetScope = parts.join('.');
    defaults.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return 'id' in proto && 'defaults' in proto;
}
class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
    this.elements = new TypedRegistry(Element$1, 'elements');
    this.plugins = new TypedRegistry(Object, 'plugins');
    this.scales = new TypedRegistry(Scale, 'scales');
    this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...args) {
    this._each('register', args);
  }
  remove(...args) {
    this._each('unregister', args);
  }
  addControllers(...args) {
    this._each('register', args, this.controllers);
  }
  addElements(...args) {
    this._each('register', args, this.elements);
  }
  addPlugins(...args) {
    this._each('register', args, this.plugins);
  }
  addScales(...args) {
    this._each('register', args, this.scales);
  }
  getController(id) {
    return this._get(id, this.controllers, 'controller');
  }
  getElement(id) {
    return this._get(id, this.elements, 'element');
  }
  getPlugin(id) {
    return this._get(id, this.plugins, 'plugin');
  }
  getScale(id) {
    return this._get(id, this.scales, 'scale');
  }
  removeControllers(...args) {
    this._each('unregister', args, this.controllers);
  }
  removeElements(...args) {
    this._each('unregister', args, this.elements);
  }
  removePlugins(...args) {
    this._each('unregister', args, this.plugins);
  }
  removeScales(...args) {
    this._each('unregister', args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [...args].forEach(arg => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each(arg, item => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry, component) {
    const camelMethod = _capitalize(method);
    callback(component['before' + camelMethod], [], component);
    registry[method](component);
    callback(component['after' + camelMethod], [], component);
  }
  _getRegistryForType(type) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id, typedRegistry, type) {
    const item = typedRegistry.get(id);
    if (item === undefined) {
      throw new Error('"' + id + '" is not a registered ' + type + '.');
    }
    return item;
  }
}
var registry = /* #__PURE__ */new Registry();
class PluginService {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === 'beforeInit') {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, 'install');
    }
    const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors, chart, hook, args);
    if (hook === 'afterDestroy') {
      this._notify(descriptors, chart, 'stop');
      this._notify(this._init, chart, 'uninstall');
    }
    return result;
  }
  _notify(descriptors, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors) {
      const plugin = descriptor.plugin;
      const method = plugin[hook];
      const params = [chart, args, descriptor.options];
      if (callback(method, params, plugin) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = undefined;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors = this._cache;
    const diff = (a, b) => a.filter(x => !b.some(y => x.plugin.id === y.plugin.id));
    this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
    this._notify(diff(descriptors, previousDescriptors), chart, 'start');
  }
}
function allPlugins(config) {
  const localIds = {};
  const plugins = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins.push(registry.getPlugin(keys[i]));
  }
  const local = config.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin = local[i];
    if (plugins.indexOf(plugin) === -1) {
      plugins.push(plugin);
      localIds[plugin.id] = true;
    }
  }
  return {
    plugins,
    localIds
  };
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, {
  plugins,
  localIds
}, options, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin of plugins) {
    const id = plugin.id;
    const opts = getOpts(options[id], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin,
      options: pluginOpts(chart.config, {
        plugin,
        local: localIds[id]
      }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, {
  plugin,
  local
}, opts, context) {
  const keys = config.pluginScopeKeys(plugin);
  const scopes = config.getOptionScopes(opts, keys);
  if (local && plugin.defaults) {
    scopes.push(plugin.defaults);
  }
  return config.createResolver(scopes, context, [''], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type, options) {
  const datasetDefaults = defaults.datasets[type] || {};
  const datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
  let axis = id;
  if (id === '_index_') {
    axis = indexAxis;
  } else if (id === '_value_') {
    axis = indexAxis === 'x' ? 'y' : 'x';
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
  if (id === 'x' || id === 'y' || id === 'r') {
    return id;
  }
}
function axisFromPosition(position) {
  if (position === 'top' || position === 'bottom') {
    return 'x';
  }
  if (position === 'left' || position === 'right') {
    return 'y';
  }
}
function determineAxis(id, ...scaleOptions) {
  if (idMatchesAxis(id)) {
    return id;
  }
  for (const opts of scaleOptions) {
    const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
    if (axis) {
      return axis;
    }
  }
  throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
  if (dataset[axis + 'AxisID'] === id) {
    return {
      axis
    };
  }
}
function retrieveAxisFromDatasets(id, config) {
  if (config.data && config.data.datasets) {
    const boundDs = config.data.datasets.filter(d => d.xAxisID === id || d.yAxisID === id);
    if (boundDs.length) {
      return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
  }
  return {};
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || {
    scales: {}
  };
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const scales = Object.create(null);
  Object.keys(configScales).forEach(id => {
    const scaleConf = configScales[id];
    if (!isObject$1(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
    }
    const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), defaults.scales[scaleConf.type]);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    scales[id] = mergeIf(Object.create(null), [{
      axis
    }, scaleConf, defaultScaleOptions[axis], defaultScaleOptions[defaultId]]);
  });
  config.data.datasets.forEach(dataset => {
    const type = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    const datasetDefaults = overrides[type] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach(defaultID => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id = dataset[axis + 'AxisID'] || axis;
      scales[id] = scales[id] || Object.create(null);
      mergeIf(scales[id], [{
        axis
      }, configScales[id], defaultScaleOptions[defaultID]]);
    });
  });
  Object.keys(scales).forEach(key => {
    const scale = scales[key];
    mergeIf(scale, [defaults.scales[scale.type], defaults.scale]);
  });
  return scales;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
const addIfFound = (set, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== undefined) {
    set.add(opts);
  }
};
class Config {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = new Map();
    this._resolverCache = new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type) {
    this._config.type = type;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(datasetType, () => [[`datasets.${datasetType}`, '']]);
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(`${datasetType}.transition.${transition}`, () => [[`datasets.${datasetType}.transitions.${transition}`, `transitions.${transition}`], [`datasets.${datasetType}`, '']]);
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(`${datasetType}-${elementType}`, () => [[`datasets.${datasetType}.elements.${elementType}`, `datasets.${datasetType}`, `elements.${elementType}`, '']]);
  }
  pluginScopeKeys(plugin) {
    const id = plugin.id;
    const type = this.type;
    return cachedKeys(`${type}-plugin-${id}`, () => [[`plugins.${id}`, ...(plugin.additionalOptionScopes || [])]]);
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const {
      options,
      type
    } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = new Set();
    keyLists.forEach(keys => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach(key => addIfFound(scopes, mainScope, key));
      }
      keys.forEach(key => addIfFound(scopes, options, key));
      keys.forEach(key => addIfFound(scopes, overrides[type] || {}, key));
      keys.forEach(key => addIfFound(scopes, defaults, key));
      keys.forEach(key => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const {
      options,
      type
    } = this;
    return [options, overrides[type] || {}, defaults.datasets[type] || {}, {
      type
    }, defaults, descriptors];
  }
  resolveNamedOptions(scopes, names, context, prefixes = ['']) {
    const result = {
      $shared: true
    };
    const {
      resolver,
      subPrefixes
    } = getResolver(this._resolverCache, scopes, prefixes);
    let options = resolver;
    if (needContext(resolver, names)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [''], descriptorDefaults) {
    const {
      resolver
    } = getResolver(this._resolverCache, scopes, prefixes);
    return isObject$1(context) ? _attachContext(resolver, context, undefined, descriptorDefaults) : resolver;
  }
}
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter(p => !p.toLowerCase().includes('hover'))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
const hasFunction = value => isObject$1(value) && Object.getOwnPropertyNames(value).some(key => isFunction(value[key]));
function needContext(proxy, names) {
  const {
    isScriptable,
    isIndexable
  } = _descriptors(proxy);
  for (const prop of names) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
      return true;
    }
  }
  return false;
}
var version = "4.4.8";
const KNOWN_POSITIONS = ['top', 'bottom', 'left', 'right', 'chartArea'];
function positionIsHorizontal(position, axis) {
  return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
  return function (a, b) {
    return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  chart.notifyPlugins('afterRender');
  callback(animationOptions && animationOptions.onComplete, [context], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [context], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === 'string') {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
const instances = {};
const getChart = key => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter(c => c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === 'mouseout') {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e;
}
function getSizeForArea(scale, chartArea, field) {
  return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
  const {
    xScale,
    yScale
  } = meta;
  if (xScale && yScale) {
    return {
      left: getSizeForArea(xScale, chartArea, 'left'),
      right: getSizeForArea(xScale, chartArea, 'right'),
      top: getSizeForArea(yScale, chartArea, 'top'),
      bottom: getSizeForArea(yScale, chartArea, 'bottom')
    };
  }
  return chartArea;
}
class Chart$1 {
  static defaults = defaults;
  static instances = instances;
  static overrides = overrides;
  static registry = registry;
  static version = version;
  static getChart = getChart;
  static register(...items) {
    registry.add(...items);
    invalidatePlugins();
  }
  static unregister(...items) {
    registry.remove(...items);
    invalidatePlugins();
  }
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = undefined;
    this.boxes = [];
    this.currentDevicePixelRatio = undefined;
    this.chartArea = undefined;
    this._active = [];
    this._lastEvent = undefined;
    this._listeners = {};
    this._responsiveListeners = undefined;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = undefined;
    this.$context = undefined;
    this._doResize = debounce(mode => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, 'complete', onAnimationsComplete);
    animator.listen(this, 'progress', onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const {
      options: {
        aspectRatio,
        maintainAspectRatio
      },
      width,
      height,
      _aspectRatio
    } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height ? width / height : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  get registry() {
    return registry;
  }
  _initialize() {
    this.notifyPlugins('beforeInit');
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins('afterInit');
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height) {
    if (!animator.running(this)) {
      this._resize(width, height);
    } else {
      this._resizeBeforeDraw = {
        width,
        height
      };
    }
  }
  _resize(width, height) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? 'resize' : 'attach';
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins('resize', {
      size: newSize
    });
    callback(options.onResize, [this, newSize], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales = this.scales;
    const updated = Object.keys(scales).reduce((obj, id) => {
      obj[id] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(Object.keys(scaleOpts).map(id => {
        const scaleOptions = scaleOpts[id];
        const axis = determineAxis(id, scaleOptions);
        const isRadial = axis === 'r';
        const isHorizontal = axis === 'x';
        return {
          options: scaleOptions,
          dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
          dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
        };
      }));
    }
    each(items, item => {
      const scaleOptions = item.options;
      const id = scaleOptions.id;
      const axis = determineAxis(id, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id] = true;
      let scale = null;
      if (id in scales && scales[id].type === scaleType) {
        scale = scales[id];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id) => {
      if (!hasUpdated) {
        delete scales[id];
      }
    });
    each(scales, scale => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a, b) => a.index - b.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
  }
  _removeUnreferencedMetasets() {
    const {
      _metasets: metasets,
      data: {
        datasets
      }
    } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index) => {
      if (datasets.filter(x => x === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type = dataset.type || this.config.type;
      if (meta.type && meta.type !== type) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = '' + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type);
        const {
          datasetElementType,
          dataElementType
        } = defaults.datasets[type];
        Object.assign(ControllerClass, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins('reset');
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins('beforeUpdate', {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins('beforeElementsUpdate');
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const {
        controller
      } = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, controller => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins('afterUpdate', {
      mode
    });
    this._layers.sort(compare2Level('z', '_idx'));
    const {
      _active,
      _lastEvent
    } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, scale => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const {
      _hiddenIndices
    } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const {
      method,
      start,
      count
    } of changes) {
      const move = method === '_removeElements' ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = idx => new Set(_dataChanges.filter(c => c[0] === idx).map((c, i) => i + ',' + c.splice(1).join(',')));
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet).map(c => c.split(',')).map(a => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins('beforeLayout', {
      cancelable: true
    }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, box => {
      if (noArea && box.position === 'chartArea') {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index) => {
      item._idx = index;
    });
    this.notifyPlugins('afterLayout');
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins('beforeDatasetsUpdate', {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({
        datasetIndex: i
      }) : mode);
    }
    this.notifyPlugins('afterDatasetsUpdate', {
      mode
    });
  }
  _updateDataset(index, mode) {
    const meta = this.getDatasetMeta(index);
    const args = {
      meta,
      index,
      mode,
      cancelable: true
    };
    if (this.notifyPlugins('beforeDatasetUpdate', args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins('afterDatasetUpdate', args);
  }
  render() {
    if (this.notifyPlugins('beforeRender', {
      cancelable: true
    }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({
        chart: this
      });
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const {
        width,
        height
      } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null;
      this._resize(width, height);
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins('beforeDraw', {
      cancelable: true
    }) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins('afterDraw');
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins('beforeDatasetsDraw', {
      cancelable: true
    }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins('afterDatasetsDraw');
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = getDatasetArea(meta, this.chartArea);
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins('beforeDatasetDraw', args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins('afterDatasetDraw', args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === 'function') {
      return method(this, e, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter(x => x && x._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, {
      chart: this,
      type: 'chart'
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index) {
    this._hiddenIndices[index] = !this._hiddenIndices[index];
  }
  getDataVisibility(index) {
    return !this._hiddenIndices[index];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? 'show' : 'hide';
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(undefined, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, {
        visible
      });
      this.update(ctx => ctx.datasetIndex === datasetIndex ? mode : undefined);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins('beforeDestroy');
    const {
      canvas,
      ctx
    } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    delete instances[this.id];
    this.notifyPlugins('afterDestroy');
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type, listener) => {
      platform.addEventListener(this, type, listener);
      listeners[type] = listener;
    };
    const listener = (e, x, y) => {
      e.offsetX = x;
      e.offsetY = y;
      this._eventHandler(e);
    };
    each(this.options.events, type => _add(type, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type, listener) => {
      platform.addEventListener(this, type, listener);
      listeners[type] = listener;
    };
    const _remove = (type, listener) => {
      if (listeners[type]) {
        platform.removeEventListener(this, type, listener);
        delete listeners[type];
      }
    };
    const listener = (width, height) => {
      if (this.canvas) {
        this.resize(width, height);
      }
    };
    let detached;
    const attached = () => {
      _remove('attach', attached);
      this.attached = true;
      this.resize();
      _add('resize', listener);
      _add('detach', detached);
    };
    detached = () => {
      this.attached = false;
      _remove('resize', listener);
      this._stop();
      this._resize(0, 0);
      _add('attach', attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._responsiveListeners = undefined;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? 'set' : 'remove';
    let meta, item, i, ilen;
    if (mode === 'dataset') {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller['_' + prefix + 'DatasetHoverStyle']();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({
      datasetIndex,
      index
    }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error('No dataset found at index ' + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index],
        index
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  isPluginEnabled(pluginId) {
    return this._plugins._cache.filter(p => p.plugin.id === pluginId).length === 1;
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a, b) => a.filter(x => !b.some(y => x.datasetIndex === y.datasetIndex && x.index === y.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e, replay) {
    const args = {
      event: e,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e)
    };
    const eventFilter = plugin => (plugin.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins('afterEvent', args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e, replay, inChartArea) {
    const {
      _active: lastActive = [],
      options
    } = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e);
    const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [e, active, this], this);
      if (isClick) {
        callback(options.onClick, [e, active, this], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
}
function invalidatePlugins() {
  return each(Chart$1.instances, chart => chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
  const {
    startAngle,
    pixelMargin,
    x,
    y,
    outerRadius,
    innerRadius
  } = element;
  let angleMargin = pixelMargin / outerRadius;
  // Draw an inner border by clipping the arc and drawing a double-width border
  // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }
  ctx.closePath();
  ctx.clip();
}
function toRadiusCorners(value) {
  return _readValueToProps(value, ['outerStart', 'outerEnd', 'innerStart', 'innerEnd']);
}
/**
 * Parse border radius from the provided options
 */
function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  const o = toRadiusCorners(arc.options.borderRadius);
  const halfThickness = (outerRadius - innerRadius) / 2;
  const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
  // Outer limits are complicated. We want to compute the available angular distance at
  // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
  // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
  //
  // If the borderRadius is large, that value can become negative.
  // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
  // we know that the thickness term will dominate and compute the limits at that point
  const computeOuterLimit = val => {
    const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };
  return {
    outerStart: computeOuterLimit(o.outerStart),
    outerEnd: computeOuterLimit(o.outerEnd),
    innerStart: _limitValue(o.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
  };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */
function rThetaToXY(r, theta, x, y) {
  return {
    x: x + r * Math.cos(theta),
    y: y + r * Math.sin(theta)
  };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */
function pathArc(ctx, element, offset, spacing, end, circular) {
  const {
    x,
    y,
    startAngle: start,
    pixelMargin,
    innerRadius: innerR
  } = element;
  const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
  const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
  let spacingOffset = 0;
  const alpha = end - start;
  if (spacing) {
    // When spacing is present, it is the same for all items
    // So we adjust the start and end angle of the arc such that
    // the distance is the same as it would be without the spacing
    const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
    const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
    const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
    spacingOffset = (alpha - adjustedAngle) / 2;
  }
  const beta = Math.max(0.001, alpha * outerRadius - offset / PI) / outerRadius;
  const angleOffset = (alpha - beta) / 2;
  const startAngle = start + angleOffset + spacingOffset;
  const endAngle = end - angleOffset - spacingOffset;
  const {
    outerStart,
    outerEnd,
    innerStart,
    innerEnd
  } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
  const outerStartAdjustedRadius = outerRadius - outerStart;
  const outerEndAdjustedRadius = outerRadius - outerEnd;
  const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  const innerStartAdjustedRadius = innerRadius + innerStart;
  const innerEndAdjustedRadius = innerRadius + innerEnd;
  const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  if (circular) {
    // The first arc segments from point 1 to point a to point 2
    const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
    ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
    ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
    // The corner segment from point 2 to point 3
    if (outerEnd > 0) {
      const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
    }
    // The line from point 3 to point 4
    const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
    ctx.lineTo(p4.x, p4.y);
    // The corner segment from point 4 to point 5
    if (innerEnd > 0) {
      const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
    }
    // The inner arc from point 5 to point b to point 6
    const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
    ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
    ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
    // The corner segment from point 6 to point 7
    if (innerStart > 0) {
      const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
    }
    // The line from point 7 to point 8
    const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
    ctx.lineTo(p8.x, p8.y);
    // The corner segment from point 8 to point 1
    if (outerStart > 0) {
      const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
    }
  } else {
    ctx.moveTo(x, y);
    const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
    const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
    ctx.lineTo(outerStartX, outerStartY);
    const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
    const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
    ctx.lineTo(outerEndX, outerEndY);
  }
  ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
  const {
    fullCircles,
    startAngle,
    circumference
  } = element;
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.fill();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + (circumference % TAU || TAU);
    }
  }
  pathArc(ctx, element, offset, spacing, endAngle, circular);
  ctx.fill();
  return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
  const {
    fullCircles,
    startAngle,
    circumference,
    options
  } = element;
  const {
    borderWidth,
    borderJoinStyle,
    borderDash,
    borderDashOffset
  } = options;
  const inner = options.borderAlign === 'inner';
  if (!borderWidth) {
    return;
  }
  ctx.setLineDash(borderDash || []);
  ctx.lineDashOffset = borderDashOffset;
  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || 'round';
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || 'bevel';
  }
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.stroke();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + (circumference % TAU || TAU);
    }
  }
  if (inner) {
    clipArc(ctx, element, endAngle);
  }
  if (!fullCircles) {
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
  }
}
class ArcElement extends Element$1 {
  static id = 'arc';
  static defaults = {
    borderAlign: 'center',
    borderColor: '#fff',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
  };
  static defaultRoutes = {
    backgroundColor: 'backgroundColor'
  };
  static descriptors = {
    _scriptable: true,
    _indexable: name => name !== 'borderDash'
  };
  circumference;
  endAngle;
  fullCircles;
  innerRadius;
  outerRadius;
  pixelMargin;
  startAngle;
  constructor(cfg) {
    super();
    this.options = undefined;
    this.circumference = undefined;
    this.startAngle = undefined;
    this.endAngle = undefined;
    this.innerRadius = undefined;
    this.outerRadius = undefined;
    this.pixelMargin = 0;
    this.fullCircles = 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(chartX, chartY, useFinalPosition) {
    const point = this.getProps(['x', 'y'], useFinalPosition);
    const {
      angle,
      distance
    } = getAngleFromPoint(point, {
      x: chartX,
      y: chartY
    });
    const {
      startAngle,
      endAngle,
      innerRadius,
      outerRadius,
      circumference
    } = this.getProps(['startAngle', 'endAngle', 'innerRadius', 'outerRadius', 'circumference'], useFinalPosition);
    const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
    const _circumference = valueOrDefault(circumference, endAngle - startAngle);
    const nonZeroBetween = _angleBetween(angle, startAngle, endAngle) && startAngle !== endAngle;
    const betweenAngles = _circumference >= TAU || nonZeroBetween;
    const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
    return betweenAngles && withinRadius;
  }
  getCenterPoint(useFinalPosition) {
    const {
      x,
      y,
      startAngle,
      endAngle,
      innerRadius,
      outerRadius
    } = this.getProps(['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius'], useFinalPosition);
    const {
      offset,
      spacing
    } = this.options;
    const halfAngle = (startAngle + endAngle) / 2;
    const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
    return {
      x: x + Math.cos(halfAngle) * halfRadius,
      y: y + Math.sin(halfAngle) * halfRadius
    };
  }
  tooltipPosition(useFinalPosition) {
    return this.getCenterPoint(useFinalPosition);
  }
  draw(ctx) {
    const {
      options,
      circumference
    } = this;
    const offset = (options.offset || 0) / 4;
    const spacing = (options.spacing || 0) / 2;
    const circular = options.circular;
    this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
    this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
    if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
      return;
    }
    ctx.save();
    const halfAngle = (this.startAngle + this.endAngle) / 2;
    ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
    const fix = 1 - Math.sin(Math.min(PI, circumference || 0));
    const radiusOffset = offset * fix;
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    drawArc(ctx, this, radiusOffset, spacing, circular);
    drawBorder(ctx, this, radiusOffset, spacing, circular);
    ctx.restore();
  }
}
function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const {
    start: paramsStart = 0,
    end: paramsEnd = count - 1
  } = params;
  const {
    start: segmentStart,
    end: segmentEnd
  } = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line, segment, params) {
  const {
    points,
    options
  } = line;
  const {
    count,
    start,
    loop,
    ilen
  } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let {
    move = true,
    reverse
  } = params || {};
  let i, point, prev;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const {
    count,
    start,
    ilen
  } = pathVars(points, segment, params);
  const {
    move = true,
    reverse
  } = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = index => (start + (reverse ? ilen - index : index)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x = point.x;
    const y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }
    lastY = y;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
  const {
    segments,
    options
  } = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, {
      start,
      end: start + count - 1
    })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}
class LineElement extends Element$1 {
  static id = 'line';
  static defaults = {
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: 'default',
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
  };
  static defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
  };
  static descriptors = {
    _scriptable: true,
    _indexable: name => name !== 'borderDash' && name !== 'fill'
  };
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = undefined;
    this._chart = undefined;
    this._loop = undefined;
    this._fullLoop = undefined;
    this._path = undefined;
    this._points = undefined;
    this._segments = undefined;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, {
      property,
      start: value,
      end: value
    });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const {
        start,
        end
      } = segments[i];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || this.points.length - start;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, {
        start,
        end: start + count - 1
      });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = undefined;
    }
  }
}
function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const {
    [axis]: value
  } = el.getProps([axis], useFinalPosition);
  return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element$1 {
  static id = 'point';
  parsed;
  skip;
  stop;
  /**
  * @type {any}
  */
  static defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: 'circle',
    radius: 3,
    rotation: 0
  };
  /**
  * @type {any}
  */
  static defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
  };
  constructor(cfg) {
    super();
    this.options = undefined;
    this.parsed = undefined;
    this.skip = undefined;
    this.stop = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const {
      x,
      y
    } = this.getProps(['x', 'y'], useFinalPosition);
    return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, 'x', useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, 'y', useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const {
      x,
      y
    } = this.getProps(['x', 'y'], useFinalPosition);
    return {
      x,
      y
    };
  }
  size(options) {
    options = options || this.options || {};
    let radius = options.radius || 0;
    radius = Math.max(radius, radius && options.hoverRadius || 0);
    const borderWidth = radius && options.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    // @ts-expect-error Fallbacks should never be hit in practice
    return options.radius + options.hitRadius;
  }
}
function getBarBounds(bar, useFinalPosition) {
  const {
    x,
    y,
    base,
    width,
    height
  } = bar.getProps(['x', 'y', 'base', 'width', 'height'], useFinalPosition);
  let left, right, top, bottom, half;
  if (bar.horizontal) {
    half = height / 2;
    left = Math.min(x, base);
    right = Math.max(x, base);
    top = y - half;
    bottom = y + half;
  } else {
    half = width / 2;
    left = x - half;
    right = x + half;
    top = Math.min(y, base);
    bottom = Math.max(y, base);
  }
  return {
    left,
    top,
    right,
    bottom
  };
}
function skipOrLimit(skip, value, min, max) {
  return skip ? 0 : _limitValue(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
  const value = bar.options.borderWidth;
  const skip = bar.borderSkipped;
  const o = toTRBL(value);
  return {
    t: skipOrLimit(skip.top, o.top, 0, maxH),
    r: skipOrLimit(skip.right, o.right, 0, maxW),
    b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
    l: skipOrLimit(skip.left, o.left, 0, maxW)
  };
}
function parseBorderRadius(bar, maxW, maxH) {
  const {
    enableBorderRadius
  } = bar.getProps(['enableBorderRadius']);
  const value = bar.options.borderRadius;
  const o = toTRBLCorners(value);
  const maxR = Math.min(maxW, maxH);
  const skip = bar.borderSkipped;
  const enableBorder = enableBorderRadius || isObject$1(value);
  return {
    topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
  };
}
function boundingRects(bar) {
  const bounds = getBarBounds(bar);
  const width = bounds.right - bounds.left;
  const height = bounds.bottom - bounds.top;
  const border = parseBorderWidth(bar, width / 2, height / 2);
  const radius = parseBorderRadius(bar, width / 2, height / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height,
      radius
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
      }
    }
  };
}
function inRange(bar, x, y, useFinalPosition) {
  const skipX = x === null;
  const skipY = y === null;
  const skipBoth = skipX && skipY;
  const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
  return bounds && (skipX || _isBetween(x, bounds.left, bounds.right)) && (skipY || _isBetween(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
  return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
  const x = rect.x !== refRect.x ? -amount : 0;
  const y = rect.y !== refRect.y ? -amount : 0;
  const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
  const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
  return {
    x: rect.x + x,
    y: rect.y + y,
    w: rect.w + w,
    h: rect.h + h,
    radius: rect.radius
  };
}
class BarElement extends Element$1 {
  static id = 'bar';
  static defaults = {
    borderSkipped: 'start',
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: 'auto',
    pointStyle: undefined
  };
  static defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
  };
  constructor(cfg) {
    super();
    this.options = undefined;
    this.horizontal = undefined;
    this.base = undefined;
    this.width = undefined;
    this.height = undefined;
    this.inflateAmount = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  draw(ctx) {
    const {
      inflateAmount,
      options: {
        borderColor,
        backgroundColor
      }
    } = this;
    const {
      inner,
      outer
    } = boundingRects(this);
    const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
    ctx.save();
    if (outer.w !== inner.w || outer.h !== inner.h) {
      ctx.beginPath();
      addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
      ctx.clip();
      addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
      ctx.fillStyle = borderColor;
      ctx.fill('evenodd');
    }
    ctx.beginPath();
    addRectPath(ctx, inflateRect(inner, inflateAmount));
    ctx.fillStyle = backgroundColor;
    ctx.fill();
    ctx.restore();
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange(this, null, mouseY, useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const {
      x,
      y,
      base,
      horizontal
    } = this.getProps(['x', 'y', 'base', 'horizontal'], useFinalPosition);
    return {
      x: horizontal ? (x + base) / 2 : x,
      y: horizontal ? y : (y + base) / 2
    };
  }
  getRange(axis) {
    return axis === 'x' ? this.width / 2 : this.height / 2;
  }
}
function _segments(line, target, property) {
  const segments = line.segments;
  const points = line.points;
  const tpoints = target.points;
  const parts = [];
  for (const segment of segments) {
    let {
      start,
      end
    } = segment;
    end = _findSegmentEnd(start, end, points);
    const bounds = _getBounds(property, points[start], points[end], segment.loop);
    if (!target.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start],
        end: points[end]
      });
      continue;
    }
    const targetSegments = _boundSegments(target, bounds);
    for (const tgt of targetSegments) {
      const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, 'start', Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, 'end', Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function _getBounds(property, first, last, loop) {
  if (loop) {
    return;
  }
  let start = first[property];
  let end = last[property];
  if (property === 'angle') {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }
  return {
    property,
    start,
    end
  };
}
function _pointsFromSegments(boundary, line) {
  const {
    x = null,
    y = null
  } = boundary || {};
  const linePoints = line.points;
  const points = [];
  line.segments.forEach(({
    start,
    end
  }) => {
    end = _findSegmentEnd(start, end, linePoints);
    const first = linePoints[start];
    const last = linePoints[end];
    if (y !== null) {
      points.push({
        x: first.x,
        y
      });
      points.push({
        x: last.x,
        y
      });
    } else if (x !== null) {
      points.push({
        x,
        y: first.y
      });
      points.push({
        x,
        y: last.y
      });
    }
  });
  return points;
}
function _findSegmentEnd(start, end, points) {
  for (; end > start; end--) {
    const point = points[end];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end;
}
function _getEdge(a, b, prop, fn) {
  if (a && b) {
    return fn(a[prop], b[prop]);
  }
  return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
  let points = [];
  let _loop = false;
  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line);
  }
  return points.length ? new LineElement({
    points,
    options: {
      tension: 0
    },
    _loop,
    _fullLoop: _loop
  }) : null;
}
function _shouldApplyFill(source) {
  return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
  const source = sources[index];
  let fill = source.fill;
  const visited = [index];
  let target;
  if (!propagate) {
    return fill;
  }
  while (fill !== false && visited.indexOf(fill) === -1) {
    if (!isNumberFinite(fill)) {
      return fill;
    }
    target = sources[fill];
    if (!target) {
      return false;
    }
    if (target.visible) {
      return fill;
    }
    visited.push(fill);
    fill = target.fill;
  }
  return false;
}
function _decodeFill(line, index, count) {
  const fill = parseFillOption(line);
  if (isObject$1(fill)) {
    return isNaN(fill.value) ? false : fill;
  }
  let target = parseFloat(fill);
  if (isNumberFinite(target) && Math.floor(target) === target) {
    return decodeTargetIndex(fill[0], index, target, count);
  }
  return ['origin', 'start', 'end', 'stack', 'shape'].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
  if (firstCh === '-' || firstCh === '+') {
    target = index + target;
  }
  if (target === index || target < 0 || target >= count) {
    return false;
  }
  return target;
}
function _getTargetPixel(fill, scale) {
  let pixel = null;
  if (fill === 'start') {
    pixel = scale.bottom;
  } else if (fill === 'end') {
    pixel = scale.top;
  } else if (isObject$1(fill)) {
    pixel = scale.getPixelForValue(fill.value);
  } else if (scale.getBasePixel) {
    pixel = scale.getBasePixel();
  }
  return pixel;
}
function _getTargetValue(fill, scale, startValue) {
  let value;
  if (fill === 'start') {
    value = startValue;
  } else if (fill === 'end') {
    value = scale.options.reverse ? scale.min : scale.max;
  } else if (isObject$1(fill)) {
    value = fill.value;
  } else {
    value = scale.getBaseValue();
  }
  return value;
}
function parseFillOption(line) {
  const options = line.options;
  const fillOption = options.fill;
  let fill = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill === undefined) {
    fill = !!options.backgroundColor;
  }
  if (fill === false || fill === null) {
    return false;
  }
  if (fill === true) {
    return 'origin';
  }
  return fill;
}
function _buildStackLine(source) {
  const {
    scale,
    index,
    line
  } = source;
  const points = [];
  const segments = line.segments;
  const sourcePoints = line.points;
  const linesBelow = getLinesBelow(scale, index);
  linesBelow.push(_createBoundaryLine({
    x: null,
    y: scale.bottom
  }, line));
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({
    points,
    options: {}
  });
}
function getLinesBelow(scale, index) {
  const below = [];
  const metas = scale.getMatchingVisibleMetas('line');
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    if (meta.index === index) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line = linesBelow[j];
    const {
      first,
      last,
      point
    } = findPoint(line, sourcePoint, 'x');
    if (!point || first && last) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
  const point = line.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line.segments;
  const linePoints = line.points;
  let first = false;
  let last = false;
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last = pointValue === lastValue;
      break;
    }
  }
  return {
    first,
    last,
    point
  };
}
class simpleArc {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const {
      x,
      y,
      radius
    } = this;
    bounds = bounds || {
      start: 0,
      end: TAU
    };
    ctx.arc(x, y, radius, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const {
      x,
      y,
      radius
    } = this;
    const angle = point.angle;
    return {
      x: x + Math.cos(angle) * radius,
      y: y + Math.sin(angle) * radius,
      angle
    };
  }
}
function _getTarget(source) {
  const {
    chart,
    fill,
    line
  } = source;
  if (isNumberFinite(fill)) {
    return getLineByIndex(chart, fill);
  }
  if (fill === 'stack') {
    return _buildStackLine(source);
  }
  if (fill === 'shape') {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
  const meta = chart.getDatasetMeta(index);
  const visible = meta && chart.isDatasetVisible(index);
  return visible ? meta.dataset : null;
}
function computeBoundary(source) {
  const scale = source.scale || {};
  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
  const {
    scale = {},
    fill
  } = source;
  const pixel = _getTargetPixel(fill, scale);
  if (isNumberFinite(pixel)) {
    const horizontal = scale.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }
  return null;
}
function computeCircularBoundary(source) {
  const {
    scale,
    fill
  } = source;
  const options = scale.options;
  const length = scale.getLabels().length;
  const start = options.reverse ? scale.max : scale.min;
  const value = _getTargetValue(fill, scale, start);
  const target = [];
  if (options.grid.circular) {
    const center = scale.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value)
    });
  }
  for (let i = 0; i < length; ++i) {
    target.push(scale.getPointPositionForValue(i, value));
  }
  return target;
}
function _drawfill(ctx, source, area) {
  const target = _getTarget(source);
  const {
    line,
    scale,
    axis
  } = source;
  const lineOpts = line.options;
  const fillOption = lineOpts.fill;
  const color = lineOpts.backgroundColor;
  const {
    above = color,
    below = color
  } = fillOption || {};
  if (target && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, {
      line,
      target,
      above,
      below,
      area,
      scale,
      axis
    });
    unclipArea(ctx);
  }
}
function doFill(ctx, cfg) {
  const {
    line,
    target,
    above,
    below,
    area,
    scale
  } = cfg;
  const property = line._loop ? 'angle' : cfg.axis;
  ctx.save();
  if (property === 'x' && below !== above) {
    clipVertical(ctx, target, area.top);
    fill(ctx, {
      line,
      target,
      color: above,
      scale,
      property
    });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target, area.bottom);
  }
  fill(ctx, {
    line,
    target,
    color: below,
    scale,
    property
  });
  ctx.restore();
}
function clipVertical(ctx, target, clipY) {
  const {
    segments,
    points
  } = target;
  let first = true;
  let lineLoop = false;
  ctx.beginPath();
  for (const segment of segments) {
    const {
      start,
      end
    } = segment;
    const firstPoint = points[start];
    const lastPoint = points[_findSegmentEnd(start, end, points)];
    if (first) {
      ctx.moveTo(firstPoint.x, firstPoint.y);
      first = false;
    } else {
      ctx.lineTo(firstPoint.x, clipY);
      ctx.lineTo(firstPoint.x, firstPoint.y);
    }
    lineLoop = !!target.pathSegment(ctx, segment, {
      move: lineLoop
    });
    if (lineLoop) {
      ctx.closePath();
    } else {
      ctx.lineTo(lastPoint.x, clipY);
    }
  }
  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function fill(ctx, cfg) {
  const {
    line,
    target,
    property,
    color,
    scale
  } = cfg;
  const segments = _segments(line, target, property);
  for (const {
    source: src,
    target: tgt,
    start,
    end
  } of segments) {
    const {
      style: {
        backgroundColor = color
      } = {}
    } = src;
    const notShape = target !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
    ctx.beginPath();
    const lineLoop = !!line.pathSegment(ctx, src);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target, end, property);
      }
      const targetLoop = !!target.pathSegment(ctx, tgt, {
        move: lineLoop,
        reverse: true
      });
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target, start, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? 'evenodd' : 'nonzero');
    ctx.restore();
  }
}
function clipBounds(ctx, scale, bounds) {
  const {
    top,
    bottom
  } = scale.chart.chartArea;
  const {
    property,
    start,
    end
  } = bounds || {};
  if (property === 'x') {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target, point, property) {
  const interpolatedPoint = target.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
var index = {
  id: 'filler',
  afterDatasetsUpdate(chart, _args, options) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i, line, source;
    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line = meta.dataset;
      source = null;
      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: _decodeFill(line, i, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i = 0; i < count; ++i) {
      source = sources[i];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = _resolveTarget(sources, i, options.propagate);
    }
  },
  beforeDraw(chart, _args, options) {
    const draw = options.drawTime === 'beforeDraw';
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw && source.fill) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== 'beforeDatasetsDraw') {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (_shouldApplyFill(source)) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options) {
    const source = args.meta.$filler;
    if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') {
      return;
    }
    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: 'beforeDatasetDraw'
  }
};
const getBoxSize = (labelOpts, fontSize) => {
  let {
    boxHeight = fontSize,
    boxWidth = fontSize
  } = labelOpts;
  if (labelOpts.usePointStyle) {
    boxHeight = Math.min(boxHeight, fontSize);
    boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
  }
  return {
    boxWidth,
    boxHeight,
    itemHeight: Math.max(fontSize, boxHeight)
  };
};
const itemsEqual = (a, b) => a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element$1 {
  constructor(config) {
    super();
    this._added = false;
    this.legendHitBoxes = [];
    this._hoveredItem = null;
    this.doughnutMode = false;
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this.legendItems = undefined;
    this.columnSizes = undefined;
    this.lineWidths = undefined;
    this.maxHeight = undefined;
    this.maxWidth = undefined;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.height = undefined;
    this.width = undefined;
    this._margins = undefined;
    this.position = undefined;
    this.weight = undefined;
    this.fullSize = undefined;
  }
  update(maxWidth, maxHeight, margins) {
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins;
    this.setDimensions();
    this.buildLabels();
    this.fit();
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = this._margins.left;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = this._margins.top;
      this.bottom = this.height;
    }
  }
  buildLabels() {
    const labelOpts = this.options.labels || {};
    let legendItems = callback(labelOpts.generateLabels, [this.chart], this) || [];
    if (labelOpts.filter) {
      legendItems = legendItems.filter(item => labelOpts.filter(item, this.chart.data));
    }
    if (labelOpts.sort) {
      legendItems = legendItems.sort((a, b) => labelOpts.sort(a, b, this.chart.data));
    }
    if (this.options.reverse) {
      legendItems.reverse();
    }
    this.legendItems = legendItems;
  }
  fit() {
    const {
      options,
      ctx
    } = this;
    if (!options.display) {
      this.width = this.height = 0;
      return;
    }
    const labelOpts = options.labels;
    const labelFont = toFont(labelOpts.font);
    const fontSize = labelFont.size;
    const titleHeight = this._computeTitleHeight();
    const {
      boxWidth,
      itemHeight
    } = getBoxSize(labelOpts, fontSize);
    let width, height;
    ctx.font = labelFont.string;
    if (this.isHorizontal()) {
      width = this.maxWidth;
      height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    } else {
      height = this.maxHeight;
      width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
    }
    this.width = Math.min(width, options.maxWidth || this.maxWidth);
    this.height = Math.min(height, options.maxHeight || this.maxHeight);
  }
  _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
    const {
      ctx,
      maxWidth,
      options: {
        labels: {
          padding
        }
      }
    } = this;
    const hitboxes = this.legendHitBoxes = [];
    const lineWidths = this.lineWidths = [0];
    const lineHeight = itemHeight + padding;
    let totalHeight = titleHeight;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    let row = -1;
    let top = -lineHeight;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
      if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
        totalHeight += lineHeight;
        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
        top += lineHeight;
        row++;
      }
      hitboxes[i] = {
        left: 0,
        top,
        row,
        width: itemWidth,
        height: itemHeight
      };
      lineWidths[lineWidths.length - 1] += itemWidth + padding;
    });
    return totalHeight;
  }
  _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
    const {
      ctx,
      maxHeight,
      options: {
        labels: {
          padding
        }
      }
    } = this;
    const hitboxes = this.legendHitBoxes = [];
    const columnSizes = this.columnSizes = [];
    const heightLimit = maxHeight - titleHeight;
    let totalWidth = padding;
    let currentColWidth = 0;
    let currentColHeight = 0;
    let left = 0;
    let col = 0;
    this.legendItems.forEach((legendItem, i) => {
      const {
        itemWidth,
        itemHeight
      } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
      if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
        totalWidth += currentColWidth + padding;
        columnSizes.push({
          width: currentColWidth,
          height: currentColHeight
        });
        left += currentColWidth + padding;
        col++;
        currentColWidth = currentColHeight = 0;
      }
      hitboxes[i] = {
        left,
        top: currentColHeight,
        col,
        width: itemWidth,
        height: itemHeight
      };
      currentColWidth = Math.max(currentColWidth, itemWidth);
      currentColHeight += itemHeight + padding;
    });
    totalWidth += currentColWidth;
    columnSizes.push({
      width: currentColWidth,
      height: currentColHeight
    });
    return totalWidth;
  }
  adjustHitBoxes() {
    if (!this.options.display) {
      return;
    }
    const titleHeight = this._computeTitleHeight();
    const {
      legendHitBoxes: hitboxes,
      options: {
        align,
        labels: {
          padding
        },
        rtl
      }
    } = this;
    const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
    if (this.isHorizontal()) {
      let row = 0;
      let left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
      for (const hitbox of hitboxes) {
        if (row !== hitbox.row) {
          row = hitbox.row;
          left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
        }
        hitbox.top += this.top + titleHeight + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
        left += hitbox.width + padding;
      }
    } else {
      let col = 0;
      let top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
      for (const hitbox of hitboxes) {
        if (hitbox.col !== col) {
          col = hitbox.col;
          top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
        }
        hitbox.top = top;
        hitbox.left += this.left + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
        top += hitbox.height + padding;
      }
    }
  }
  isHorizontal() {
    return this.options.position === 'top' || this.options.position === 'bottom';
  }
  draw() {
    if (this.options.display) {
      const ctx = this.ctx;
      clipArea(ctx, this);
      this._draw();
      unclipArea(ctx);
    }
  }
  _draw() {
    const {
      options: opts,
      columnSizes,
      lineWidths,
      ctx
    } = this;
    const {
      align,
      labels: labelOpts
    } = opts;
    const defaultColor = defaults.color;
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const labelFont = toFont(labelOpts.font);
    const {
      padding
    } = labelOpts;
    const fontSize = labelFont.size;
    const halfFontSize = fontSize / 2;
    let cursor;
    this.drawTitle();
    ctx.textAlign = rtlHelper.textAlign('left');
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 0.5;
    ctx.font = labelFont.string;
    const {
      boxWidth,
      boxHeight,
      itemHeight
    } = getBoxSize(labelOpts, fontSize);
    const drawLegendBox = function (x, y, legendItem) {
      if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
        return;
      }
      ctx.save();
      const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
      ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
      ctx.lineCap = valueOrDefault(legendItem.lineCap, 'butt');
      ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
      ctx.lineJoin = valueOrDefault(legendItem.lineJoin, 'miter');
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
      ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
      if (labelOpts.usePointStyle) {
        const drawOptions = {
          radius: boxHeight * Math.SQRT2 / 2,
          pointStyle: legendItem.pointStyle,
          rotation: legendItem.rotation,
          borderWidth: lineWidth
        };
        const centerX = rtlHelper.xPlus(x, boxWidth / 2);
        const centerY = y + halfFontSize;
        drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
      } else {
        const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
        const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
        const borderRadius = toTRBLCorners(legendItem.borderRadius);
        ctx.beginPath();
        if (Object.values(borderRadius).some(v => v !== 0)) {
          addRoundedRectPath(ctx, {
            x: xBoxLeft,
            y: yBoxTop,
            w: boxWidth,
            h: boxHeight,
            radius: borderRadius
          });
        } else {
          ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
        }
        ctx.fill();
        if (lineWidth !== 0) {
          ctx.stroke();
        }
      }
      ctx.restore();
    };
    const fillText = function (x, y, legendItem) {
      renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
        strikethrough: legendItem.hidden,
        textAlign: rtlHelper.textAlign(legendItem.textAlign)
      });
    };
    const isHorizontal = this.isHorizontal();
    const titleHeight = this._computeTitleHeight();
    if (isHorizontal) {
      cursor = {
        x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
        y: this.top + padding + titleHeight,
        line: 0
      };
    } else {
      cursor = {
        x: this.left + padding,
        y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
        line: 0
      };
    }
    overrideTextDirection(this.ctx, opts.textDirection);
    const lineHeight = itemHeight + padding;
    this.legendItems.forEach((legendItem, i) => {
      ctx.strokeStyle = legendItem.fontColor;
      ctx.fillStyle = legendItem.fontColor;
      const textWidth = ctx.measureText(legendItem.text).width;
      const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
      const width = boxWidth + halfFontSize + textWidth;
      let x = cursor.x;
      let y = cursor.y;
      rtlHelper.setWidth(this.width);
      if (isHorizontal) {
        if (i > 0 && x + width + padding > this.right) {
          y = cursor.y += lineHeight;
          cursor.line++;
          x = cursor.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
        }
      } else if (i > 0 && y + lineHeight > this.bottom) {
        x = cursor.x = x + columnSizes[cursor.line].width + padding;
        cursor.line++;
        y = cursor.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
      }
      const realX = rtlHelper.x(x);
      drawLegendBox(realX, y, legendItem);
      x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
      fillText(rtlHelper.x(x), y, legendItem);
      if (isHorizontal) {
        cursor.x += width + padding;
      } else if (typeof legendItem.text !== 'string') {
        const fontLineHeight = labelFont.lineHeight;
        cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
      } else {
        cursor.y += lineHeight;
      }
    });
    restoreTextDirection(this.ctx, opts.textDirection);
  }
  drawTitle() {
    const opts = this.options;
    const titleOpts = opts.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    if (!titleOpts.display) {
      return;
    }
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const ctx = this.ctx;
    const position = titleOpts.position;
    const halfFontSize = titleFont.size / 2;
    const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
    let y;
    let left = this.left;
    let maxWidth = this.width;
    if (this.isHorizontal()) {
      maxWidth = Math.max(...this.lineWidths);
      y = this.top + topPaddingPlusHalfFontSize;
      left = _alignStartEnd(opts.align, left, this.right - maxWidth);
    } else {
      const maxHeight = this.columnSizes.reduce((acc, size) => Math.max(acc, size.height), 0);
      y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
    }
    const x = _alignStartEnd(position, left, left + maxWidth);
    ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
    ctx.textBaseline = 'middle';
    ctx.strokeStyle = titleOpts.color;
    ctx.fillStyle = titleOpts.color;
    ctx.font = titleFont.string;
    renderText(ctx, titleOpts.text, x, y, titleFont);
  }
  _computeTitleHeight() {
    const titleOpts = this.options.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
  }
  _getLegendItemAt(x, y) {
    let i, hitBox, lh;
    if (_isBetween(x, this.left, this.right) && _isBetween(y, this.top, this.bottom)) {
      lh = this.legendHitBoxes;
      for (i = 0; i < lh.length; ++i) {
        hitBox = lh[i];
        if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
          return this.legendItems[i];
        }
      }
    }
    return null;
  }
  handleEvent(e) {
    const opts = this.options;
    if (!isListened(e.type, opts)) {
      return;
    }
    const hoveredItem = this._getLegendItemAt(e.x, e.y);
    if (e.type === 'mousemove' || e.type === 'mouseout') {
      const previous = this._hoveredItem;
      const sameItem = itemsEqual(previous, hoveredItem);
      if (previous && !sameItem) {
        callback(opts.onLeave, [e, previous, this], this);
      }
      this._hoveredItem = hoveredItem;
      if (hoveredItem && !sameItem) {
        callback(opts.onHover, [e, hoveredItem, this], this);
      }
    } else if (hoveredItem) {
      callback(opts.onClick, [e, hoveredItem, this], this);
    }
  }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
  const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
  const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
  return {
    itemWidth,
    itemHeight
  };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
  let legendItemText = legendItem.text;
  if (legendItemText && typeof legendItemText !== 'string') {
    legendItemText = legendItemText.reduce((a, b) => a.length > b.length ? a : b);
  }
  return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
  let itemHeight = _itemHeight;
  if (typeof legendItem.text !== 'string') {
    itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
  }
  return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
  const labelHeight = legendItem.text ? legendItem.text.length : 0;
  return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
  if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) {
    return true;
  }
  if (opts.onClick && (type === 'click' || type === 'mouseup')) {
    return true;
  }
  return false;
}
var plugin_legend = {
  id: 'legend',
  _element: Legend,
  start(chart, _args, options) {
    const legend = chart.legend = new Legend({
      ctx: chart.ctx,
      options,
      chart
    });
    layouts.configure(chart, legend, options);
    layouts.addBox(chart, legend);
  },
  stop(chart) {
    layouts.removeBox(chart, chart.legend);
    delete chart.legend;
  },
  beforeUpdate(chart, _args, options) {
    const legend = chart.legend;
    layouts.configure(chart, legend, options);
    legend.options = options;
  },
  afterUpdate(chart) {
    const legend = chart.legend;
    legend.buildLabels();
    legend.adjustHitBoxes();
  },
  afterEvent(chart, args) {
    if (!args.replay) {
      chart.legend.handleEvent(args.event);
    }
  },
  defaults: {
    display: true,
    position: 'top',
    align: 'center',
    fullSize: true,
    reverse: false,
    weight: 1000,
    onClick(e, legendItem, legend) {
      const index = legendItem.datasetIndex;
      const ci = legend.chart;
      if (ci.isDatasetVisible(index)) {
        ci.hide(index);
        legendItem.hidden = true;
      } else {
        ci.show(index);
        legendItem.hidden = false;
      }
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: ctx => ctx.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(chart) {
        const datasets = chart.data.datasets;
        const {
          labels: {
            usePointStyle,
            pointStyle,
            textAlign,
            color,
            useBorderRadius,
            borderRadius
          }
        } = chart.legend.options;
        return chart._getSortedDatasetMetas().map(meta => {
          const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
          const borderWidth = toPadding(style.borderWidth);
          return {
            text: datasets[meta.index].label,
            fillStyle: style.backgroundColor,
            fontColor: color,
            hidden: !meta.visible,
            lineCap: style.borderCapStyle,
            lineDash: style.borderDash,
            lineDashOffset: style.borderDashOffset,
            lineJoin: style.borderJoinStyle,
            lineWidth: (borderWidth.width + borderWidth.height) / 4,
            strokeStyle: style.borderColor,
            pointStyle: pointStyle || style.pointStyle,
            rotation: style.rotation,
            textAlign: textAlign || style.textAlign,
            borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
            datasetIndex: meta.index
          };
        }, this);
      }
    },
    title: {
      color: ctx => ctx.chart.options.color,
      display: false,
      position: 'center',
      text: ''
    }
  },
  descriptors: {
    _scriptable: name => !name.startsWith('on'),
    labels: {
      _scriptable: name => !['generateLabels', 'filter', 'sort'].includes(name)
    }
  }
};
class Title extends Element$1 {
  constructor(config) {
    super();
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this._padding = undefined;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.width = undefined;
    this.height = undefined;
    this.position = undefined;
    this.weight = undefined;
    this.fullSize = undefined;
  }
  update(maxWidth, maxHeight) {
    const opts = this.options;
    this.left = 0;
    this.top = 0;
    if (!opts.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = maxWidth;
    this.height = this.bottom = maxHeight;
    const lineCount = isArray(opts.text) ? opts.text.length : 1;
    this._padding = toPadding(opts.padding);
    const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
    if (this.isHorizontal()) {
      this.height = textSize;
    } else {
      this.width = textSize;
    }
  }
  isHorizontal() {
    const pos = this.options.position;
    return pos === 'top' || pos === 'bottom';
  }
  _drawArgs(offset) {
    const {
      top,
      left,
      bottom,
      right,
      options
    } = this;
    const align = options.align;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (this.isHorizontal()) {
      titleX = _alignStartEnd(align, left, right);
      titleY = top + offset;
      maxWidth = right - left;
    } else {
      if (options.position === 'left') {
        titleX = left + offset;
        titleY = _alignStartEnd(align, bottom, top);
        rotation = PI * -0.5;
      } else {
        titleX = right - offset;
        titleY = _alignStartEnd(align, top, bottom);
        rotation = PI * 0.5;
      }
      maxWidth = bottom - top;
    }
    return {
      titleX,
      titleY,
      maxWidth,
      rotation
    };
  }
  draw() {
    const ctx = this.ctx;
    const opts = this.options;
    if (!opts.display) {
      return;
    }
    const fontOpts = toFont(opts.font);
    const lineHeight = fontOpts.lineHeight;
    const offset = lineHeight / 2 + this._padding.top;
    const {
      titleX,
      titleY,
      maxWidth,
      rotation
    } = this._drawArgs(offset);
    renderText(ctx, opts.text, 0, 0, fontOpts, {
      color: opts.color,
      maxWidth,
      rotation,
      textAlign: _toLeftRightCenter(opts.align),
      textBaseline: 'middle',
      translation: [titleX, titleY]
    });
  }
}
function createTitle(chart, titleOpts) {
  const title = new Title({
    ctx: chart.ctx,
    options: titleOpts,
    chart
  });
  layouts.configure(chart, title, titleOpts);
  layouts.addBox(chart, title);
  chart.titleBlock = title;
}
var plugin_title = {
  id: 'title',
  _element: Title,
  start(chart, _args, options) {
    createTitle(chart, options);
  },
  stop(chart) {
    const titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate(chart, _args, options) {
    const title = chart.titleBlock;
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: 'center',
    display: false,
    font: {
      weight: 'bold'
    },
    fullSize: true,
    padding: 10,
    position: 'top',
    text: '',
    weight: 2000
  },
  defaultRoutes: {
    color: 'color'
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
const positioners = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let xSet = new Set();
    let y = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        xSet.add(pos.x);
        y += pos.y;
        ++count;
      }
    }
    if (count === 0 || xSet.size === 0) {
      return false;
    }
    const xAverage = [...xSet].reduce((a, b) => a + b) / xSet.size;
    return {
      x: xAverage,
      y: y / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x = eventPosition.x;
    let y = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d = distanceBetweenPoints(eventPosition, center);
        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }
    return {
      x,
      y
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
    return str.split('\n');
  }
  return str;
}
function createTooltipItem(chart, item) {
  const {
    element,
    datasetIndex,
    index
  } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const {
    label,
    value
  } = controller.getLabelAndValue(index);
  return {
    chart,
    label,
    parsed: controller.getParsed(index),
    raw: chart.data.datasets[datasetIndex].data[index],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const {
    body,
    footer,
    title
  } = tooltip;
  const {
    boxWidth,
    boxHeight
  } = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function (line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, bodyItem => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {
    width,
    height
  };
}
function determineYAlign(chart, size) {
  const {
    y,
    height
  } = size;
  if (y < height / 2) {
    return 'top';
  } else if (y > chart.height - height / 2) {
    return 'bottom';
  }
  return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
  const {
    x,
    width
  } = size;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === 'left' && x + width + caret > chart.width) {
    return true;
  }
  if (xAlign === 'right' && x - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size, yAlign) {
  const {
    x,
    width
  } = size;
  const {
    width: chartWidth,
    chartArea: {
      left,
      right
    }
  } = chart;
  let xAlign = 'center';
  if (yAlign === 'center') {
    xAlign = x <= (left + right) / 2 ? 'left' : 'right';
  } else if (x <= width / 2) {
    xAlign = 'left';
  } else if (x >= chartWidth - width / 2) {
    xAlign = 'right';
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = 'center';
  }
  return xAlign;
}
function determineAlignment(chart, options, size) {
  const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign
  };
}
function alignX(size, xAlign) {
  let {
    x,
    width
  } = size;
  if (xAlign === 'right') {
    x -= width;
  } else if (xAlign === 'center') {
    x -= width / 2;
  }
  return x;
}
function alignY(size, yAlign, paddingAndSize) {
  let {
    y,
    height
  } = size;
  if (yAlign === 'top') {
    y += paddingAndSize;
  } else if (yAlign === 'bottom') {
    y -= height + paddingAndSize;
  } else {
    y -= height / 2;
  }
  return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
  const {
    caretSize,
    caretPadding,
    cornerRadius
  } = options;
  const {
    xAlign,
    yAlign
  } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const {
    topLeft,
    topRight,
    bottomLeft,
    bottomRight
  } = toTRBLCorners(cornerRadius);
  let x = alignX(size, xAlign);
  const y = alignY(size, yAlign, paddingAndSize);
  if (yAlign === 'center') {
    if (xAlign === 'left') {
      x += paddingAndSize;
    } else if (xAlign === 'right') {
      x -= paddingAndSize;
    }
  } else if (xAlign === 'left') {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === 'right') {
    x += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
  return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip,
    tooltipItems,
    type: 'tooltip'
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
  beforeTitle: noop,
  title(tooltipItems) {
    if (tooltipItems.length > 0) {
      const item = tooltipItems[0];
      const labels = item.chart.data.labels;
      const labelCount = labels ? labels.length : 0;
      if (this && this.options && this.options.mode === 'dataset') {
        return item.dataset.label || '';
      } else if (item.label) {
        return item.label;
      } else if (labelCount > 0 && item.dataIndex < labelCount) {
        return labels[item.dataIndex];
      }
    }
    return '';
  },
  afterTitle: noop,
  beforeBody: noop,
  beforeLabel: noop,
  label(tooltipItem) {
    if (this && this.options && this.options.mode === 'dataset') {
      return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
    }
    let label = tooltipItem.dataset.label || '';
    if (label) {
      label += ': ';
    }
    const value = tooltipItem.formattedValue;
    if (!isNullOrUndef(value)) {
      label += value;
    }
    return label;
  },
  labelColor(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      borderColor: options.borderColor,
      backgroundColor: options.backgroundColor,
      borderWidth: options.borderWidth,
      borderDash: options.borderDash,
      borderDashOffset: options.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      pointStyle: options.pointStyle,
      rotation: options.rotation
    };
  },
  afterLabel: noop,
  afterBody: noop,
  beforeFooter: noop,
  footer: noop,
  afterFooter: noop
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
  const result = callbacks[name].call(ctx, arg);
  if (typeof result === 'undefined') {
    return defaultCallbacks[name].call(ctx, arg);
  }
  return result;
}
class Tooltip extends Element$1 {
  static positioners = positioners;
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = undefined;
    this._size = undefined;
    this._cachedAnimations = undefined;
    this._tooltipItems = [];
    this.$animations = undefined;
    this.$context = undefined;
    this.chart = config.chart;
    this.options = config.options;
    this.dataPoints = undefined;
    this.title = undefined;
    this.beforeBody = undefined;
    this.body = undefined;
    this.afterBody = undefined;
    this.footer = undefined;
    this.xAlign = undefined;
    this.yAlign = undefined;
    this.x = undefined;
    this.y = undefined;
    this.height = undefined;
    this.width = undefined;
    this.caretX = undefined;
    this.caretY = undefined;
    this.labelColors = undefined;
    this.labelPointStyles = undefined;
    this.labelTextColors = undefined;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = undefined;
    this.$context = undefined;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const {
      callbacks
    } = options;
    const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
    const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
    const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
  }
  getBody(tooltipItems, options) {
    const {
      callbacks
    } = options;
    const bodyItems = [];
    each(tooltipItems, context => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
      pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
      pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
  }
  getFooter(tooltipItems, options) {
    const {
      callbacks
    } = options;
    const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
    const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
    const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active[i]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index, array) => options.filter(element, index, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a, b) => options.itemSort(a, b, data));
    }
    each(tooltipItems, context => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
      labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
      labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position = positioners[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, size);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size.width,
        height: size.height,
        caretX: position.x,
        caretY: position.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = undefined;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, {
        chart: this.chart,
        tooltip: this,
        replay
      });
    }
  }
  drawCaret(tooltipPoint, ctx, size, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size, options) {
    const {
      xAlign,
      yAlign
    } = this;
    const {
      caretSize,
      cornerRadius
    } = options;
    const {
      topLeft,
      topRight,
      bottomLeft,
      bottomRight
    } = toTRBLCorners(cornerRadius);
    const {
      x: ptX,
      y: ptY
    } = tooltipPoint;
    const {
      width,
      height
    } = size;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === 'center') {
      y2 = ptY + height / 2;
      if (xAlign === 'left') {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === 'left') {
        x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === 'right') {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === 'top') {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return {
      x1,
      x2,
      x3,
      y1,
      y2,
      y3
    };
  }
  drawTitle(pt, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = 'middle';
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length) {
          pt.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options) {
    const labelColor = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const {
      boxHeight,
      boxWidth
    } = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, 'left', options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColor.borderColor;
      ctx.fillStyle = labelColor.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject$1(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
      ctx.strokeStyle = labelColor.borderColor;
      ctx.setLineDash(labelColor.borderDash || []);
      ctx.lineDashOffset = labelColor.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
      const borderRadius = toTRBLCorners(labelColor.borderRadius);
      if (Object.values(borderRadius).some(v => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options) {
    const {
      body
    } = this;
    const {
      bodySpacing,
      bodyAlign,
      displayColors,
      boxHeight,
      boxWidth,
      boxPadding
    } = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function (line) {
      ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = 'middle';
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.footerAlign, options);
      pt.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = 'middle';
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options) {
    const {
      xAlign,
      yAlign
    } = this;
    const {
      x,
      y
    } = pt;
    const {
      width,
      height
    } = tooltipSize;
    const {
      topLeft,
      topRight,
      bottomLeft,
      bottomRight
    } = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x + topLeft, y);
    if (yAlign === 'top') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width - topRight, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
    if (yAlign === 'center' && xAlign === 'right') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width, y + height - bottomRight);
    ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
    if (yAlign === 'bottom') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + bottomLeft, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
    if (yAlign === 'center' && xAlign === 'left') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x, y + topLeft);
    ctx.quadraticCurveTo(x, y, x + topLeft, y);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position = positioners[options.position].call(this, this._active, this._eventPosition);
      if (!position) {
        return;
      }
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size.width;
        this.height = size.height;
        this.caretX = position.x;
        this.caretY = position.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options);
      this.drawBody(pt, ctx, options);
      this.drawFooter(pt, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({
      datasetIndex,
      index
    }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error('Cannot find a dataset at index ' + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index],
        index
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e.x,
          y: e.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive.filter(i => this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e) {
    const {
      caretX,
      caretY,
      options
    } = this;
    const position = positioners[options.position].call(this, active, e);
    return position !== false && (caretX !== position.x || caretY !== position.y);
  }
}
var plugin_tooltip = {
  id: 'tooltip',
  _element: Tooltip,
  positioners,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip({
        chart,
        options
      });
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins('beforeTooltipDraw', {
        ...args,
        cancelable: true
      }) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins('afterTooltipDraw', args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: 'average',
    backgroundColor: 'rgba(0,0,0,0.8)',
    titleColor: '#fff',
    titleFont: {
      weight: 'bold'
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: 'left',
    bodyColor: '#fff',
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: 'left',
    footerColor: '#fff',
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: 'bold'
    },
    footerAlign: 'left',
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: '#fff',
    displayColors: true,
    boxPadding: 0,
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: 'easeOutQuart'
    },
    animations: {
      numbers: {
        type: 'number',
        properties: ['x', 'y', 'width', 'height', 'caretX', 'caretY']
      },
      opacity: {
        easing: 'linear',
        duration: 200
      }
    },
    callbacks: defaultCallbacks
  },
  defaultRoutes: {
    bodyFont: 'font',
    footerFont: 'font',
    titleFont: 'font'
  },
  descriptors: {
    _scriptable: name => name !== 'filter' && name !== 'itemSort' && name !== 'external',
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: 'animation'
    }
  },
  additionalOptionScopes: ['interaction']
};
const addIfString = (labels, raw, index, addedLabels) => {
  if (typeof raw === 'string') {
    index = labels.push(raw) - 1;
    addedLabels.unshift({
      index,
      label: raw
    });
  } else if (isNaN(raw)) {
    index = null;
  }
  return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index, addedLabels);
  }
  const last = labels.lastIndexOf(raw);
  return first !== last ? index : first;
}
const validIndex = (index, max) => index === null ? null : _limitValue(Math.round(index), 0, max);
function _getLabelForValue(value) {
  const labels = this.getLabels();
  if (value >= 0 && value < labels.length) {
    return labels[value];
  }
  return value;
}
class CategoryScale extends Scale {
  static id = 'category';
  static defaults = {
    ticks: {
      callback: _getLabelForValue
    }
  };
  constructor(cfg) {
    super(cfg);
    this._startValue = undefined;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const {
        index,
        label
      } of added) {
        if (labels[index] === label) {
          labels.splice(index, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, valueOrDefault(index, raw), this._addedLabels);
    return validIndex(index, labels.length - 1);
  }
  determineDataLimits() {
    const {
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let {
      min,
      max
    } = this.getMinMax(true);
    if (this.options.bounds === 'ticks') {
      if (!minDefined) {
        min = 0;
      }
      if (!maxDefined) {
        max = this.getLabels().length - 1;
      }
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const min = this.min;
    const max = this.max;
    const offset = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
    this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
    this._startValue = this.min - (offset ? 0.5 : 0);
    for (let value = min; value <= max; value++) {
      ticks.push({
        value
      });
    }
    return ticks;
  }
  getLabelForValue(value) {
    return _getLabelForValue.call(this, value);
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== 'number') {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index) {
    const ticks = this.ticks;
    if (index < 0 || index > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const {
    bounds,
    step,
    min,
    max,
    precision,
    count,
    maxTicks,
    maxDigits,
    includeBounds
  } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const {
    min: rmin,
    max: rmax
  } = dataRange;
  const minDefined = !isNullOrUndef(min);
  const maxDefined = !isNullOrUndef(max);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [{
      value: rmin
    }, {
      value: rmax
    }];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === 'ticks') {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1000)) {
    numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
    spacing = (max - min) / numSpaces;
    niceMin = min;
    niceMax = max;
  } else if (countDefined) {
    niceMin = minDefined ? min : niceMin;
    niceMax = maxDefined ? max : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min) {
      ticks.push({
        value: min
      });
      if (niceMin < min) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
    if (maxDefined && tickValue > max) {
      break;
    }
    ticks.push({
      value: tickValue
    });
  }
  if (maxDefined && includeBounds && niceMax !== max) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max;
    } else {
      ticks.push({
        value: max
      });
    }
  } else if (!maxDefined || niceMax === max) {
    ticks.push({
      value: niceMax
    });
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, {
  horizontal,
  minRotation
}) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
  const length = 0.75 * minSpacing * ('' + value).length;
  return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = undefined;
    this.end = undefined;
    this._startValue = undefined;
    this._endValue = undefined;
    this._valueRange = 0;
  }
  parse(raw, index) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const {
      beginAtZero
    } = this.options;
    const {
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let {
      min,
      max
    } = this;
    const setMin = v => min = minDefined ? min : v;
    const setMax = v => max = maxDefined ? max : v;
    if (beginAtZero) {
      const minSign = sign(min);
      const maxSign = sign(max);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min === max) {
      let offset = max === 0 ? 1 : Math.abs(max * 0.05);
      setMax(max + offset);
      if (!beginAtZero) {
        setMin(min - offset);
      }
    }
    this.min = min;
    this.max = max;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let {
      maxTicksLimit,
      stepSize
    } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1000) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1000;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === 'ticks') {
      _setMinAndMaxByKey(ticks, this, 'value');
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset;
      end += offset;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
}
class LinearScale extends LinearScaleBase {
  static id = 'linear';
  static defaults = {
    ticks: {
      callback: Ticks.formatters.numeric
    }
  };
  determineDataLimits() {
    const {
      min,
      max
    } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? min : 0;
    this.max = isNumberFinite(max) ? max : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
}
const log10Floor = v => Math.floor(log10(v));
const changeExponent = (v, m) => Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, log10Floor(tickVal));
  return remain === 1;
}
function steps(min, max, rangeExp) {
  const rangeStep = Math.pow(10, rangeExp);
  const start = Math.floor(min / rangeStep);
  const end = Math.ceil(max / rangeStep);
  return end - start;
}
function startExp(min, max) {
  const range = max - min;
  let rangeExp = log10Floor(range);
  while (steps(min, max, rangeExp) > 10) {
    rangeExp++;
  }
  while (steps(min, max, rangeExp) < 10) {
    rangeExp--;
  }
  return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, {
  min,
  max
}) {
  min = finiteOrDefault(generationOptions.min, min);
  const ticks = [];
  const minExp = log10Floor(min);
  let exp = startExp(min, max);
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  const stepSize = Math.pow(10, exp);
  const base = minExp > exp ? Math.pow(10, minExp) : 0;
  const start = Math.round((min - base) * precision) / precision;
  const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
  let significand = Math.floor((start - offset) / Math.pow(10, exp));
  let value = finiteOrDefault(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
  while (value < max) {
    ticks.push({
      value,
      major: isMajor(value),
      significand
    });
    if (significand >= 10) {
      significand = significand < 15 ? 15 : 20;
    } else {
      significand++;
    }
    if (significand >= 20) {
      exp++;
      significand = 2;
      precision = exp >= 0 ? 1 : precision;
    }
    value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
  }
  const lastTick = finiteOrDefault(generationOptions.max, value);
  ticks.push({
    value: lastTick,
    major: isMajor(lastTick),
    significand
  });
  return ticks;
}
class LogarithmicScale extends Scale {
  static id = 'logarithmic';
  static defaults = {
    ticks: {
      callback: Ticks.formatters.logarithmic,
      major: {
        enabled: true
      }
    }
  };
  constructor(cfg) {
    super(cfg);
    this.start = undefined;
    this.end = undefined;
    this._startValue = undefined;
    this._valueRange = 0;
  }
  parse(raw, index) {
    const value = LinearScaleBase.prototype.parse.apply(this, [raw, index]);
    if (value === 0) {
      this._zero = true;
      return undefined;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const {
      min,
      max
    } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? Math.max(0, min) : null;
    this.max = isNumberFinite(max) ? Math.max(0, max) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
      this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const {
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let min = this.min;
    let max = this.max;
    const setMin = v => min = minDefined ? min : v;
    const setMax = v => max = maxDefined ? max : v;
    if (min === max) {
      if (min <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(changeExponent(min, -1));
        setMax(changeExponent(max, +1));
      }
    }
    if (min <= 0) {
      setMin(changeExponent(max, -1));
    }
    if (max <= 0) {
      setMax(changeExponent(min, +1));
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === 'ticks') {
      _setMinAndMaxByKey(ticks, this, 'value');
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === undefined ? '0' : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value) {
    if (value === undefined || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
}
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [label];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size, min, max) {
  if (angle === min || angle === max) {
    return {
      start: pos - size / 2,
      end: pos + size / 2
    };
  } else if (angle < min || angle > max) {
    return {
      start: pos - size,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x = 0;
  let y = 0;
  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }
  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}
function createPointLabelItem(scale, index, itemOpts) {
  const outerDistance = scale.drawingArea;
  const {
    extra,
    additionalAngle,
    padding,
    size
  } = itemOpts;
  const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
  const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
  const y = yForAngle(pointLabelPosition.y, size.h, angle);
  const textAlign = getTextAlignForAngle(angle);
  const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
  return {
    visible: true,
    x: pointLabelPosition.x,
    y,
    textAlign,
    left,
    top: y,
    right: left + size.w,
    bottom: y + size.h
  };
}
function isNotOverlapped(item, area) {
  if (!area) {
    return true;
  }
  const {
    left,
    top,
    right,
    bottom
  } = item;
  const apexesInArea = _isPointInArea({
    x: left,
    y: top
  }, area) || _isPointInArea({
    x: left,
    y: bottom
  }, area) || _isPointInArea({
    x: right,
    y: top
  }, area) || _isPointInArea({
    x: right,
    y: bottom
  }, area);
  return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const {
    centerPointLabels,
    display
  } = opts.pointLabels;
  const itemOpts = {
    extra: getTickBackdropHeight(opts) / 2,
    additionalAngle: centerPointLabels ? PI / valueCount : 0
  };
  let area;
  for (let i = 0; i < valueCount; i++) {
    itemOpts.padding = padding[i];
    itemOpts.size = labelSizes[i];
    const item = createPointLabelItem(scale, i, itemOpts);
    items.push(item);
    if (display === 'auto') {
      item.visible = isNotOverlapped(item, area);
      if (item.visible) {
        area = item;
      }
    }
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return 'center';
  } else if (angle < 180) {
    return 'left';
  }
  return 'right';
}
function leftForTextAlign(x, w, align) {
  if (align === 'right') {
    x -= w;
  } else if (align === 'center') {
    x -= w / 2;
  }
  return x;
}
function yForAngle(y, h, angle) {
  if (angle === 90 || angle === 270) {
    y -= h / 2;
  } else if (angle > 270 || angle < 90) {
    y -= h;
  }
  return y;
}
function drawPointLabelBox(ctx, opts, item) {
  const {
    left,
    top,
    right,
    bottom
  } = item;
  const {
    backdropColor
  } = opts;
  if (!isNullOrUndef(backdropColor)) {
    const borderRadius = toTRBLCorners(opts.borderRadius);
    const padding = toPadding(opts.backdropPadding);
    ctx.fillStyle = backdropColor;
    const backdropLeft = left - padding.left;
    const backdropTop = top - padding.top;
    const backdropWidth = right - left + padding.width;
    const backdropHeight = bottom - top + padding.height;
    if (Object.values(borderRadius).some(v => v !== 0)) {
      ctx.beginPath();
      addRoundedRectPath(ctx, {
        x: backdropLeft,
        y: backdropTop,
        w: backdropWidth,
        h: backdropHeight,
        radius: borderRadius
      });
      ctx.fill();
    } else {
      ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
  }
}
function drawPointLabels(scale, labelCount) {
  const {
    ctx,
    options: {
      pointLabels
    }
  } = scale;
  for (let i = labelCount - 1; i >= 0; i--) {
    const item = scale._pointLabelItems[i];
    if (!item.visible) {
      continue;
    }
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    drawPointLabelBox(ctx, optsAtIndex, item);
    const plFont = toFont(optsAtIndex.font);
    const {
      x,
      y,
      textAlign
    } = item;
    renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
      color: optsAtIndex.color,
      textAlign: textAlign,
      textBaseline: 'middle'
    });
  }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
  const {
    ctx
  } = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const {
    color,
    lineWidth
  } = gridLineOpts;
  if (!circular && !labelCount || !color || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(borderOpts.dash || []);
  ctx.lineDashOffset = borderOpts.dashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index, label) {
  return createContext(parent, {
    label,
    index,
    type: 'pointLabel'
  });
}
class RadialLinearScale extends LinearScaleBase {
  static id = 'radialLinear';
  static defaults = {
    display: true,
    animate: true,
    position: 'chartArea',
    angleLines: {
      display: true,
      lineWidth: 1,
      borderDash: [],
      borderDashOffset: 0.0
    },
    grid: {
      circular: false
    },
    startAngle: 0,
    ticks: {
      showLabelBackdrop: true,
      callback: Ticks.formatters.numeric
    },
    pointLabels: {
      backdropColor: undefined,
      backdropPadding: 2,
      display: true,
      font: {
        size: 10
      },
      callback(label) {
        return label;
      },
      padding: 5,
      centerPointLabels: false
    }
  };
  static defaultRoutes = {
    'angleLines.color': 'borderColor',
    'pointLabels.color': 'color',
    'ticks.color': 'color'
  };
  static descriptors = {
    angleLines: {
      _fallback: 'grid'
    }
  };
  constructor(cfg) {
    super(cfg);
    this.xCenter = undefined;
    this.yCenter = undefined;
    this.drawingArea = undefined;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w = this.width = this.maxWidth - padding.width;
    const h = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w, h) / 2);
  }
  determineDataLimits() {
    const {
      min,
      max
    } = this.getMinMax(false);
    this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
    this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value, index) => {
      const label = callback(this.options.pointLabels.callback, [value, index], this);
      return label || label === 0 ? label : '';
    }).filter((v, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index) {
    const pointLabels = this._pointLabels || [];
    if (index >= 0 && index < pointLabels.length) {
      const pointLabel = pointLabels[index];
      return createPointLabelContext(this.getContext(), index, pointLabel);
    }
  }
  getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index, value) {
    return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index) {
    return this.getPointPositionForValue(index || 0, this.getBaseValue());
  }
  getPointLabelPosition(index) {
    const {
      left,
      top,
      right,
      bottom
    } = this._pointLabelItems[index];
    return {
      left,
      top,
      right,
      bottom
    };
  }
  drawBackground() {
    const {
      backgroundColor,
      grid: {
        circular
      }
    } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const {
      angleLines,
      grid,
      border
    } = opts;
    const labelCount = this._pointLabels.length;
    let i, offset, position;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index) => {
        if (index !== 0 || index === 0 && this.min < 0) {
          offset = this.getDistanceFromCenterForValue(tick.value);
          const context = this.getContext(index);
          const optsAtIndex = grid.setContext(context);
          const optsAtIndexBorder = border.setContext(context);
          drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const {
          color,
          lineWidth
        } = optsAtIndex;
        if (!lineWidth || !color) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
        position = this.getPointPosition(i, offset);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {}
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    this.ticks.forEach((tick, index) => {
      if (index === 0 && this.min >= 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index));
      const tickFont = toFont(optsAtIndex.font);
      offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
      }
      renderText(ctx, tick.label, 0, -offset, tickFont, {
        color: optsAtIndex.color,
        strokeColor: optsAtIndex.textStrokeColor,
        strokeWidth: optsAtIndex.textStrokeWidth
      });
    });
    ctx.restore();
  }
  drawTitle() {}
}
const INTERVALS = {
  millisecond: {
    common: true,
    size: 1,
    steps: 1000
  },
  second: {
    common: true,
    size: 1000,
    steps: 60
  },
  minute: {
    common: true,
    size: 60000,
    steps: 60
  },
  hour: {
    common: true,
    size: 3600000,
    steps: 24
  },
  day: {
    common: true,
    size: 86400000,
    steps: 30
  },
  week: {
    common: false,
    size: 604800000,
    steps: 4
  },
  month: {
    common: true,
    size: 2.628e9,
    steps: 12
  },
  quarter: {
    common: false,
    size: 7.884e9,
    steps: 4
  },
  year: {
    common: true,
    size: 3.154e10
  }
};
const UNITS = /* #__PURE__ */Object.keys(INTERVALS);
function sorter(a, b) {
  return a - b;
}
function parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const {
    parser,
    round,
    isoWeekday
  } = scale._parseOpts;
  let value = input;
  if (typeof parser === 'function') {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round) {
    value = round === 'week' && (isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const {
      lo,
      hi
    } = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last = ticks[ticks.length - 1].value;
  let major, index;
  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index = map[major];
    if (index >= 0) {
      ticks[index].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map = {};
  const ilen = values.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
  static id = 'time';
  static defaults = {
    bounds: 'data',
    adapters: {},
    time: {
      parser: false,
      unit: false,
      round: false,
      isoWeekday: false,
      minUnit: 'millisecond',
      displayFormats: {}
    },
    ticks: {
      source: 'auto',
      callback: false,
      major: {
        enabled: false
      }
    }
  };
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = 'day';
    this._majorUnit = undefined;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = undefined;
  }
  init(scaleOpts, opts = {}) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index) {
    if (raw === undefined) {
      return null;
    }
    return parse(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || 'day';
    let {
      min,
      max,
      minDefined,
      maxDefined
    } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min = Math.min(min, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max = Math.max(max, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') {
        _applyBounds(this.getMinMax(false));
      }
    }
    min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
    max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min, max - 1);
    this.max = Math.max(min + 1, max);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min = arr[0];
      max = arr[arr.length - 1];
    }
    return {
      min,
      max
    };
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === 'ticks' && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min = this.min;
    const max = this.max;
    const ticks = _filterBetween(timestamps, min, max);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map(tick => +tick.value));
    }
  }
  initOffsets(timestamps = []) {
    let start = 0;
    let end = 0;
    let first, last;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last;
      } else {
        end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit);
    end = _limitValue(end, 0, limit);
    this._offsets = {
      start,
      end,
      factor: 1 / (start + 1 + end)
    };
  }
  _generate() {
    const adapter = this._adapter;
    const min = this.min;
    const max = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
    const stepSize = valueOrDefault(options.ticks.stepSize, 1);
    const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber(weekday) || weekday === true;
    const ticks = {};
    let first = min;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, 'isoWeek', weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
    if (adapter.diff(max, min, minor) > 100000 * stepSize) {
      throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
    }
    const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
    for (time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max || options.bounds === 'ticks' || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort(sorter).map(x => +x);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  format(value, format) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const fmt = format || formats[unit];
    return this._adapter.format(value, fmt);
  }
  _tickFormatFunction(time, index, ticks, format) {
    const options = this.options;
    const formatter = options.ticks.callback;
    if (formatter) {
      return callback(formatter, [time, index, ticks], this);
    }
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index];
    const major = majorUnit && majorFormat && tick && tick.major;
    return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [exampleTime], this._majorUnit), format);
    const size = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse(this, labels[i]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
}
function interpolate(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({
        lo,
        hi
      } = _lookupByKey(table, 'pos', val));
    }
    ({
      pos: prevSource,
      time: prevTarget
    } = table[lo]);
    ({
      pos: nextSource,
      time: nextTarget
    } = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({
        lo,
        hi
      } = _lookupByKey(table, 'time', val));
    }
    ({
      time: prevSource,
      pos: prevTarget
    } = table[lo]);
    ({
      time: nextSource,
      pos: nextTarget
    } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
  static id = 'timeseries';
  static defaults = TimeScale.defaults;
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = undefined;
    this._tableRange = undefined;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate(table, this.min);
    this._tableRange = interpolate(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const {
      min,
      max
    } = this;
    const items = [];
    const table = [];
    let i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min && curr <= max) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [{
        time: min,
        pos: 0
      }, {
        time: max,
        pos: 1
      }];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({
          time: curr,
          pos: i / (ilen - 1)
        });
      }
    }
    return table;
  }
  _generate() {
    const min = this.min;
    const max = this.max;
    let timestamps = super.getDataTimestamps();
    if (!timestamps.includes(min) || !timestamps.length) {
      timestamps.splice(0, 0, min);
    }
    if (!timestamps.includes(max) || timestamps.length === 1) {
      timestamps.push(max);
    }
    return timestamps.sort((a, b) => a - b);
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
  }
}

const defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function setOptions(chart, nextOptions) {
  const options = chart.options;
  if (options && nextOptions) {
    Object.assign(options, nextOptions);
  }
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
  let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
  const addedDatasets = [];
  currentData.datasets = nextDatasets.map(nextDataset => {
    // given the new set, find it's current match
    const currentDataset = currentData.datasets.find(dataset => dataset[datasetIdKey] === nextDataset[datasetIdKey]);
    // There is no original to update, so simply add new one
    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return {
        ...nextDataset
      };
    }
    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
function cloneData(data) {
  let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
  const nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
}
function ChartComponent(props, ref) {
  const {
    height = 150,
    width = 300,
    redraw = false,
    datasetIdKey,
    type,
    data,
    options,
    plugins = [],
    fallbackContent,
    updateMode,
    ...canvasProps
  } = props;
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const renderChart = () => {
    if (!canvasRef.current) return;
    chartRef.current = new Chart$1(canvasRef.current, {
      type,
      data: cloneData(data, datasetIdKey),
      options: options && {
        ...options
      },
      plugins
    });
    reforwardRef(ref, chartRef.current);
  };
  const destroyChart = () => {
    reforwardRef(ref, null);
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };
  useEffect(() => {
    if (!redraw && chartRef.current && options) {
      setOptions(chartRef.current, options);
    }
  }, [redraw, options]);
  useEffect(() => {
    if (!redraw && chartRef.current) {
      setLabels(chartRef.current.config.data, data.labels);
    }
  }, [redraw, data.labels]);
  useEffect(() => {
    if (!redraw && chartRef.current && data.datasets) {
      setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }
  }, [redraw, data.datasets]);
  useEffect(() => {
    if (!chartRef.current) return;
    if (redraw) {
      destroyChart();
      setTimeout(renderChart);
    } else {
      chartRef.current.update(updateMode);
    }
  }, [redraw, options, data.labels, data.datasets, updateMode]);
  useEffect(() => {
    if (!chartRef.current) return;
    destroyChart();
    setTimeout(renderChart);
  }, [type]);
  useEffect(() => {
    renderChart();
    return () => destroyChart();
  }, []);
  return /*#__PURE__*/React__default.createElement("canvas", {
    ref: canvasRef,
    role: "img",
    height: height,
    width: width,
    ...canvasProps
  }, fallbackContent);
}
const Chart = /*#__PURE__*/forwardRef(ChartComponent);
function createTypedChart(type, registerables) {
  Chart$1.register(registerables);
  return /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(Chart, {
    ...props,
    ref: ref,
    type: type
  }));
}
const Line = /* #__PURE__ */createTypedChart('line', LineController);
const Bar = /* #__PURE__ */createTypedChart('bar', BarController);
const Doughnut = /* #__PURE__ */createTypedChart('doughnut', DoughnutController);

Chart$1.register(ArcElement);
const Total = ({ valueFormatter, label, unit: _unit, value: _value, width }) => {
    const [isSmallText, setSmallText] = useState(false);
    let unit = _unit;
    let value = _value;
    if (valueFormatter) {
        const formatted = valueFormatter(Number.isFinite(value) ? value : Number.parseFloat(value));
        unit = formatted.unit;
        value = formatted.value;
    }
    return jsxs("div", { className: styles$c.total, children: [jsx$3(Measure, { bounds: true, children: ({ measureRef, contentRect }) => {
                    if (contentRect.bounds.width > (width - 40) && !isSmallText) {
                        setTimeout(() => {
                            setSmallText(true);
                        });
                    }
                    return jsxs("div", { ref: measureRef, children: [jsx$3(Heading, { level: isSmallText ? 24 : 32, style: { lineHeight: isSmallText ? "28px" : "32px" }, children: value }), unit &&
                                jsx$3(Heading, { level: isSmallText ? 16 : 20, bold: false, style: { lineHeight: "24px" }, children: unit })] });
                } }), label && jsx$3(Span, { children: label })] });
};
const DonutChart = React__default.memo(({ showTotal = true, data, unit, value, label, valueFormatter, colors = fullColorsToken, size = "lg", includeTotalRing = false, totalRingColor = "chart-disabled" }) => {
    const tokens = useCurrentTheme().tokens;
    const isMulti = Array.isArray(data[0]);
    const sizePx = styles$c[`var_${size}`];
    const sum = isMulti ? _$1.sum(data[0]) : _$1.sum(data);
    let cutout = "80%";
    if (sum === 0) {
        cutout = "82%";
    }
    else if (isMulti) {
        cutout = "64%";
    }
    const options = {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
            padding: 0
        },
        cutout,
        borderAlign: "inner",
        borderColor: tokens["--content-background"],
        borderWidth: sum === 0 ? 0 : 1,
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            }
        }
    };
    const _data = sum === 0 ? {
        labels: [],
        datasets: [{
                data: [1],
                backgroundColor: [tokens["--chart-disabled"]]
            }]
    } : {
        labels: [],
        datasets: (isMulti ? data : [data]).map((values, index) => {
            let weight = undefined;
            if (isMulti || includeTotalRing) {
                weight = index === 0 ? 0.57 : 0.43;
            }
            return {
                data: values,
                backgroundColor: (Array.isArray(colors[0]) ? colors[index] : colors).map(color => tokens[`--${color}`]),
                weight
            };
        })
    };
    if (includeTotalRing && sum !== 0) {
        _data.datasets = _data.datasets.concat([{
                data: [sum],
                backgroundColor: [tokens[`--${totalRingColor}`]],
                weight: 0.1,
                // @ts-ignore
                borderWidth: 0
            }]);
    }
    return jsxs("div", { className: classNames(styles$c.base, styles$c[size]), children: [jsx$3(Doughnut, { options: options, data: _data }), showTotal && jsx$3(Total, { width: sizePx, valueFormatter: valueFormatter, label: label, unit: unit, value: value !== undefined ? value : sum })] });
});

var styles$b = {"base":"ChartStyles-module_base__1FScU","legend":"ChartStyles-module_legend__1I4bc","box":"ChartStyles-module_box__1qsTz","noData":"ChartStyles-module_noData__1o_kg"};

Chart$1.register(CategoryScale, LinearScale, BarElement, plugin_title, plugin_tooltip, plugin_legend);
const BarChart = React__default.memo(({ color = "chart-3", data, categories, height = 200, yTickFormatter }) => {
    const tokens = useCurrentTheme().tokens;
    const options = {
        responsive: true,
        barThickness: 16,
        borderRadius: 16,
        maintainAspectRatio: false,
        resizeDelay: 50,
        layout: {
            padding: 0
        },
        scales: {
            x: {
                border: {
                    color: tokens["--border"]
                },
                grid: {
                    display: false
                },
                ticks: {
                    padding: 0,
                    backdropPadding: 0,
                    color: tokens["--text-primary"],
                    font: {
                        size: 13,
                        lineHeight: "20px",
                        family: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`
                    }
                }
            },
            y: {
                border: {
                    color: tokens["--border"]
                },
                grid: {
                    color: tokens["--border"],
                    tickLength: 0
                },
                ticks: {
                    padding: 16,
                    backdropPadding: 0,
                    color: tokens["--text-primary"],
                    callback: yTickFormatter,
                    font: {
                        size: 13,
                        lineHeight: "20px",
                        family: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`
                    }
                }
            }
        },
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            }
        }
    };
    return jsx$3("div", { className: styles$b.base, style: { height: height }, children: jsx$3(Bar, { options: options, data: {
                labels: categories,
                datasets: [{
                        data,
                        backgroundColor: tokens[`--${color}`]
                    }]
            } }) });
});

Chart$1.register(CategoryScale, LinearScale, PointElement, LineElement, plugin_title, plugin_tooltip, index);
const LineGraph = React__default.memo(({ color = "chart-9", data, height = 200, categories, yTickFormatter, legend }) => {
    const [chartContext, setChartContext] = useState(null);
    const tokens = useCurrentTheme().tokens;
    const state = useMemo(() => {
        if (!chartContext) {
            return {
                options: {
                    responsive: true,
                    maintainAspectRatio: false
                }, data: { labels: categories, datasets: [] }
            };
        }
        const gradient = () => {
            const colorAsRgb = hexToRgb(tokens[`--${color}`]);
            const gradient = chartContext.createLinearGradient(0, 0, 0, legend ? height - 20 : height);
            gradient.addColorStop(0, `rgba(${colorAsRgb[0]},${colorAsRgb[1]},${colorAsRgb[2]}, 0.1)`);
            gradient.addColorStop(1, `rgba(${colorAsRgb[0]},${colorAsRgb[1]},${colorAsRgb[2]}, 0)`);
            return gradient;
        };
        const labels = categories;
        const datasets = (!Array.isArray(data[0]) ? [data] : data).map((values, index, arr) => {
            let colorRgb = Array.isArray(color) ? tokens[`--${color[index]}`] : tokens[`--${color}`];
            return {
                data: values,
                pointBackgroundColor: colorRgb,
                backgroundColor: arr.length === 1 ? undefined : colorRgb,
                fill: arr.length === 1,
                pointBorderColor: tokens["--content-background"],
                borderColor: colorRgb,
                label: legend === null || legend === void 0 ? void 0 : legend[index]
            };
        });
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            resizeDelay: 50,
            layout: {
                padding: 0
            },
            fill: true,
            elements: {
                line: {
                    backgroundColor: datasets.length > 1 ? "transparent" : gradient()
                },
                point: {
                    radius: 6,
                    pointHoverRadius: 8,
                    pointHoverBorderWidth: 2,
                    pointHoverBorderColor: tokens["--content-background"],
                    borderWidth: 2,
                    borderColor: tokens["--content-background"]
                }
            },
            scales: {
                x: {
                    border: {
                        color: tokens["--border"]
                    },
                    grid: {
                        display: false
                    },
                    ticks: {
                        padding: 0,
                        backdropPadding: 0,
                        color: tokens["--text-primary"],
                        font: {
                            size: 13,
                            lineHeight: "20px",
                            family: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`
                        }
                    }
                },
                y: {
                    border: {
                        color: tokens["--border"]
                    },
                    grid: {
                        color: tokens["--border"],
                        tickLength: 0
                    },
                    ticks: {
                        padding: 16,
                        backdropPadding: 0,
                        color: tokens["--text-primary"],
                        callback: yTickFormatter,
                        font: {
                            size: 13,
                            lineHeight: "20px",
                            family: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`
                        }
                    }
                }
            },
            plugins: {
                tooltip: {
                    enabled: false
                },
                legend: {
                    display: false
                }
            }
        };
        return { options, data: { labels, datasets } };
    }, [tokens, data, categories, legend, color, height, yTickFormatter, chartContext]);
    return jsxs("div", { className: styles$b.base, style: { height: legend ? height - 20 : height }, children: [legend && jsx$3("div", { className: styles$b.legend, children: legend.map((label, index) => {
                    const backgroundColor = Array.isArray(color) ? color[index] : color;
                    return jsxs("div", { children: [jsx$3("div", { className: styles$b.box, style: { backgroundColor: `var(--${backgroundColor})` } }), jsx$3(Span, { level: 13, children: label })] }, label);
                }) }), jsx$3(Line, { ref: chart => (chart === null || chart === void 0 ? void 0 : chart.ctx) && setChartContext(chart.ctx), options: state.options, data: state.data })] });
});

Chart$1.register(CategoryScale, LinearScale, BarElement, plugin_title, plugin_tooltip, plugin_legend);
const NoDataGraph = React__default.memo(({ categories, height = 200, yTickFormatter, noDataLabel = "No data", NoDataIcon = FileIcon, yMin, yMax }) => {
    const tokens = useCurrentTheme().tokens;
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        resizeDelay: 50,
        layout: {
            padding: 0
        },
        scales: {
            x: {
                border: {
                    color: tokens["--border"]
                },
                grid: {
                    display: false
                },
                ticks: {
                    padding: 0,
                    backdropPadding: 0,
                    color: tokens["--text-disabled"],
                    font: {
                        size: 13,
                        lineHeight: "20px",
                        family: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`
                    }
                }
            },
            y: {
                min: yMin,
                max: yMax,
                border: {
                    color: tokens["--border"]
                },
                grid: {
                    display: false
                },
                ticks: {
                    padding: 16,
                    backdropPadding: 0,
                    color: tokens["--text-disabled"],
                    callback: yTickFormatter,
                    font: {
                        size: 13,
                        lineHeight: "20px",
                        family: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`
                    }
                }
            }
        },
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            }
        }
    };
    return jsxs("div", { className: styles$b.base, style: { height: height }, children: [jsx$3(Bar, { options: options, data: {
                    labels: categories,
                    datasets: []
                } }), jsxs("div", { className: styles$b.noData, children: [jsx$3(NoDataIcon, { style: { marginBottom: 4 }, color: "icon-tertiary" }), jsx$3(Span, { color: "text-secondary", children: noDataLabel })] })] });
});

var styles$a = {"base":"ComparisonChart-module_base__2nFfX","datumContainer":"ComparisonChart-module_datumContainer__2HmTh","datum":"ComparisonChart-module_datum__1P8Qu","column":"ComparisonChart-module_column__3ryLo","hasData":"ComparisonChart-module_hasData__3OOfq","xLabel":"ComparisonChart-module_xLabel__3BB_2","yLabel":"ComparisonChart-module_yLabel__G3Lg6"};

const ComparisonChart = React__default.memo(({ colors, data, categories, height = 200, yTickFormatter }) => {
    let max = 0;
    for (const datum of data) {
        max = Math.max(max, datum);
    }
    const hasData = max > 0;
    return jsx$3("div", { className: styles$a.base, style: { height }, children: data.map((datum, index) => {
            const percentage = hasData ? (datum / max) * 100 : 100;
            let backgroundColor = fullColors[index];
            if (hasData) {
                if (colors) {
                    backgroundColor = `var(--${colors[index]})`;
                }
            }
            else {
                backgroundColor = emptyColors[0];
            }
            return jsxs("div", { className: classNames(styles$a.column, { [styles$a.hasData]: hasData }), children: [jsxs("div", { className: styles$a.datumContainer, children: [hasData && jsx$3("div", { className: styles$a.yLabel, style: { top: `${100 - percentage}%` }, children: jsx$3(Span, { bold: true, children: yTickFormatter ? yTickFormatter(datum, index, data) : datum }) }), jsx$3("div", { className: styles$a.datum, style: { height: `${percentage}%`, backgroundColor } })] }), jsx$3("div", { className: styles$a.xLabel, children: jsx$3(Span, { bold: true, ellipsis: true, title: categories[index], color: hasData ? undefined : "text-disabled", children: categories[index] }) })] }, index);
        }) });
});

var styles$9 = {"base":"HorizontalRatioBar-module_base__2xu97","chart-1":"HorizontalRatioBar-module_chart-1__1vHY9","chart-2":"HorizontalRatioBar-module_chart-2__2FKwE","chart-3":"HorizontalRatioBar-module_chart-3__2LQU9","chart-4":"HorizontalRatioBar-module_chart-4__2ok9E","chart-5":"HorizontalRatioBar-module_chart-5__dCnJh","chart-6":"HorizontalRatioBar-module_chart-6__xM2FH","chart-7":"HorizontalRatioBar-module_chart-7__346wH","chart-8":"HorizontalRatioBar-module_chart-8__Wxjcv","chart-9":"HorizontalRatioBar-module_chart-9__dkqIF","chart-10":"HorizontalRatioBar-module_chart-10__2jTyW","chart-11":"HorizontalRatioBar-module_chart-11__3os7R"};

const HorizontalRatioBar = ({ color = "chart-3", percent }) => {
    if (percent > 0.1 && percent < 2) {
        percent = 2;
    }
    else if (percent < 0.1) {
        percent = 0;
    }
    else if (percent > 100) {
        percent = 100;
    }
    return jsx$3("div", { className: classNames(styles$9.base, styles$9[color]), children: jsx$3("div", { style: { width: `${percent}%` } }) });
};

const setExternalLinkTracker = ({ trackExternalLink: _trackExternalLink }) => {
};
const ExternalLink = (_a) => {
    var { children, className, style, color, variant, large, disabled, tooltip, href, title, newTab = true, includeArrow, arrowStyle, onClick, dataTestId } = _a, rest = __rest(_a, ["children", "className", "style", "color", "variant", "large", "disabled", "tooltip", "href", "title", "newTab", "includeArrow", "arrowStyle", "onClick", "dataTestId"]);
    const baseClassName = getBaseClassName({ color, variant });
    const _className = classNames(baseClassName, className, { [styles$1c.large]: large });
    return jsxs("a", Object.assign({ href: disabled ? "" : href, onClick: disabled ? e => {
            e.preventDefault();
        } : (e) => {
            if (onClick) {
                onClick(e);
            }
        }, className: _className }, rest, { title: title, style: style, target: newTab ? "_blank" : undefined, rel: newTab ? "noopener noreferrer" : undefined, "data-testid": dataTestId, children: [children, includeArrow && jsx$3(ExternalLinkIcon, { style: Object.assign({ margin: "3px 0 0 8px", width: 13.5, height: 13.5 }, arrowStyle) }), tooltip && jsx$3(Tooltip$1, { children: tooltip })] }));
};

var styles$8 = {"base":"BulletList-module_base__2ev7T","li":"BulletList-module_li__11ZT1","popover-li":"BulletList-module_popover-li__3u5lp","bullet":"BulletList-module_bullet__ODpUP","popover-bullet":"BulletList-module_popover-bullet__1sq0A"};

const PopoverBulletList = (_a) => {
    var { liClassName, bulletClassName, children } = _a, rest = __rest(_a, ["liClassName", "bulletClassName", "children"]);
    return jsx$3(BulletList, Object.assign({ liClassName: classNames(liClassName, styles$8['popover-li']), bulletClassName: classNames(liClassName, styles$8['popover-bullet']) }, rest, { children: children }));
};
const BulletList = ({ children: _children = [], className, style, liClassName, bulletClassName, liStyle, dataTestId }) => {
    const children = _$1.isArray(_children) ? _children : [_children];
    return jsx$3("ul", { className: classNames(styles$8.base, className), "data-testid": dataTestId, style: style, children: children.map((child, index) => {
            return child && jsxs("li", { className: classNames(styles$8.li, liClassName), style: liStyle, "data-testid": dataTestId && `${dataTestId}-bullet-point-${index}`, children: [jsx$3("div", { className: classNames(styles$8.bullet, bulletClassName) }), jsx$3(Span, { children: child })] }, index);
        }) });
};

var styles$7 = {"base":"NumberedList-module_base__1aYx7","include-titles":"NumberedList-module_include-titles__3ldWt","divider":"NumberedList-module_divider__2iQfs","text":"NumberedList-module_text__3Ze6Y","li":"NumberedList-module_li__2FhO1"};

const NumberedList = ({ children: _children = [], className, style, liClassName, liStyle, includeTitles, dataTestId }) => {
    const children = _$1.isArray(_children) ? _children : [_children];
    return jsx$3("ul", { className: classNames(styles$7.base, className, { [styles$7['include-titles']]: includeTitles }), "data-testid": dataTestId, style: style, children: children.map((child, index) => {
            return child && jsxs("li", { "data-testid": dataTestId && `${dataTestId}-list-item-${index}`, className: classNames(styles$7.li, liClassName), style: liStyle, children: [jsx$3(Span, { bold: true, color: includeTitles ? "text-title" : undefined, children: index + 1 }), jsx$3("div", { className: styles$7["divider"] }), jsx$3("span", { className: styles$7['text'], children: child })] }, index);
        }) });
};

var styles$6 = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","modal":"ProviderTagsModal-module_modal__QaXFB","widget-row":"ProviderTagsModal-module_widget-row__3d-WW","sublabel-row":"ProviderTagsModal-module_sublabel-row__247yD","tags-grid-header":"ProviderTagsModal-module_tags-grid-header__17hBX","tags-grid":"ProviderTagsModal-module_tags-grid__1H8-M","selection-tags-grid-header":"ProviderTagsModal-module_selection-tags-grid-header__3MYLW","selection-tags-grid":"ProviderTagsModal-module_selection-tags-grid__3jGtp","bgshimmer":"ProviderTagsModal-module_bgshimmer__2tcLr"};

var lodash_min = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
(function () {
  function n(n, t, r) {
    switch (r.length) {
      case 0:
        return n.call(t);
      case 1:
        return n.call(t, r[0]);
      case 2:
        return n.call(t, r[0], r[1]);
      case 3:
        return n.call(t, r[0], r[1], r[2]);
    }
    return n.apply(t, r);
  }
  function t(n, t, r, e) {
    for (var u = -1, i = null == n ? 0 : n.length; ++u < i;) {
      var o = n[u];
      t(e, o, r(o), n);
    }
    return e;
  }
  function r(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e && t(n[r], r, n) !== !1;);
    return n;
  }
  function e(n, t) {
    for (var r = null == n ? 0 : n.length; r-- && t(n[r], r, n) !== !1;);
    return n;
  }
  function u(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e;) if (!t(n[r], r, n)) return !1;
    return !0;
  }
  function i(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length, u = 0, i = []; ++r < e;) {
      var o = n[r];
      t(o, r, n) && (i[u++] = o);
    }
    return i;
  }
  function o(n, t) {
    return !!(null == n ? 0 : n.length) && y(n, t, 0) > -1;
  }
  function f(n, t, r) {
    for (var e = -1, u = null == n ? 0 : n.length; ++e < u;) if (r(t, n[e])) return !0;
    return !1;
  }
  function c(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length, u = Array(e); ++r < e;) u[r] = t(n[r], r, n);
    return u;
  }
  function a(n, t) {
    for (var r = -1, e = t.length, u = n.length; ++r < e;) n[u + r] = t[r];
    return n;
  }
  function l(n, t, r, e) {
    var u = -1,
      i = null == n ? 0 : n.length;
    for (e && i && (r = n[++u]); ++u < i;) r = t(r, n[u], u, n);
    return r;
  }
  function s(n, t, r, e) {
    var u = null == n ? 0 : n.length;
    for (e && u && (r = n[--u]); u--;) r = t(r, n[u], u, n);
    return r;
  }
  function h(n, t) {
    for (var r = -1, e = null == n ? 0 : n.length; ++r < e;) if (t(n[r], r, n)) return !0;
    return !1;
  }
  function p(n) {
    return n.split("");
  }
  function _(n) {
    return n.match($t) || [];
  }
  function v(n, t, r) {
    var e;
    return r(n, function (n, r, u) {
      if (t(n, r, u)) return e = r, !1;
    }), e;
  }
  function g(n, t, r, e) {
    for (var u = n.length, i = r + (e ? 1 : -1); e ? i-- : ++i < u;) if (t(n[i], i, n)) return i;
    return -1;
  }
  function y(n, t, r) {
    return t === t ? Z(n, t, r) : g(n, b, r);
  }
  function d(n, t, r, e) {
    for (var u = r - 1, i = n.length; ++u < i;) if (e(n[u], t)) return u;
    return -1;
  }
  function b(n) {
    return n !== n;
  }
  function w(n, t) {
    var r = null == n ? 0 : n.length;
    return r ? k(n, t) / r : Cn;
  }
  function m(n) {
    return function (t) {
      return null == t ? X : t[n];
    };
  }
  function x(n) {
    return function (t) {
      return null == n ? X : n[t];
    };
  }
  function j(n, t, r, e, u) {
    return u(n, function (n, u, i) {
      r = e ? (e = !1, n) : t(r, n, u, i);
    }), r;
  }
  function A(n, t) {
    var r = n.length;
    for (n.sort(t); r--;) n[r] = n[r].value;
    return n;
  }
  function k(n, t) {
    for (var r, e = -1, u = n.length; ++e < u;) {
      var i = t(n[e]);
      i !== X && (r = r === X ? i : r + i);
    }
    return r;
  }
  function O(n, t) {
    for (var r = -1, e = Array(n); ++r < n;) e[r] = t(r);
    return e;
  }
  function I(n, t) {
    return c(t, function (t) {
      return [t, n[t]];
    });
  }
  function R(n) {
    return n ? n.slice(0, H(n) + 1).replace(Lt, "") : n;
  }
  function z(n) {
    return function (t) {
      return n(t);
    };
  }
  function E(n, t) {
    return c(t, function (t) {
      return n[t];
    });
  }
  function S(n, t) {
    return n.has(t);
  }
  function W(n, t) {
    for (var r = -1, e = n.length; ++r < e && y(t, n[r], 0) > -1;);
    return r;
  }
  function L(n, t) {
    for (var r = n.length; r-- && y(t, n[r], 0) > -1;);
    return r;
  }
  function C(n, t) {
    for (var r = n.length, e = 0; r--;) n[r] === t && ++e;
    return e;
  }
  function U(n) {
    return "\\" + Yr[n];
  }
  function B(n, t) {
    return null == n ? X : n[t];
  }
  function T(n) {
    return Nr.test(n);
  }
  function $(n) {
    return Pr.test(n);
  }
  function D(n) {
    for (var t, r = []; !(t = n.next()).done;) r.push(t.value);
    return r;
  }
  function M(n) {
    var t = -1,
      r = Array(n.size);
    return n.forEach(function (n, e) {
      r[++t] = [e, n];
    }), r;
  }
  function F(n, t) {
    return function (r) {
      return n(t(r));
    };
  }
  function N(n, t) {
    for (var r = -1, e = n.length, u = 0, i = []; ++r < e;) {
      var o = n[r];
      o !== t && o !== cn || (n[r] = cn, i[u++] = r);
    }
    return i;
  }
  function P(n) {
    var t = -1,
      r = Array(n.size);
    return n.forEach(function (n) {
      r[++t] = n;
    }), r;
  }
  function q(n) {
    var t = -1,
      r = Array(n.size);
    return n.forEach(function (n) {
      r[++t] = [n, n];
    }), r;
  }
  function Z(n, t, r) {
    for (var e = r - 1, u = n.length; ++e < u;) if (n[e] === t) return e;
    return -1;
  }
  function K(n, t, r) {
    for (var e = r + 1; e--;) if (n[e] === t) return e;
    return e;
  }
  function V(n) {
    return T(n) ? J(n) : _e(n);
  }
  function G(n) {
    return T(n) ? Y(n) : p(n);
  }
  function H(n) {
    for (var t = n.length; t-- && Ct.test(n.charAt(t)););
    return t;
  }
  function J(n) {
    for (var t = Mr.lastIndex = 0; Mr.test(n);) ++t;
    return t;
  }
  function Y(n) {
    return n.match(Mr) || [];
  }
  function Q(n) {
    return n.match(Fr) || [];
  }
  var X,
    nn = "4.17.21",
    tn = 200,
    rn = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",
    en = "Expected a function",
    un = "Invalid `variable` option passed into `_.template`",
    on = "__lodash_hash_undefined__",
    fn = 500,
    cn = "__lodash_placeholder__",
    an = 1,
    ln = 2,
    sn = 4,
    hn = 1,
    pn = 2,
    _n = 1,
    vn = 2,
    gn = 4,
    yn = 8,
    dn = 16,
    bn = 32,
    wn = 64,
    mn = 128,
    xn = 256,
    jn = 512,
    An = 30,
    kn = "...",
    On = 800,
    In = 16,
    Rn = 1,
    zn = 2,
    En = 3,
    Sn = 1 / 0,
    Wn = 9007199254740991,
    Ln = 1.7976931348623157e308,
    Cn = NaN,
    Un = 4294967295,
    Bn = Un - 1,
    Tn = Un >>> 1,
    $n = [["ary", mn], ["bind", _n], ["bindKey", vn], ["curry", yn], ["curryRight", dn], ["flip", jn], ["partial", bn], ["partialRight", wn], ["rearg", xn]],
    Dn = "[object Arguments]",
    Mn = "[object Array]",
    Fn = "[object AsyncFunction]",
    Nn = "[object Boolean]",
    Pn = "[object Date]",
    qn = "[object DOMException]",
    Zn = "[object Error]",
    Kn = "[object Function]",
    Vn = "[object GeneratorFunction]",
    Gn = "[object Map]",
    Hn = "[object Number]",
    Jn = "[object Null]",
    Yn = "[object Object]",
    Qn = "[object Promise]",
    Xn = "[object Proxy]",
    nt = "[object RegExp]",
    tt = "[object Set]",
    rt = "[object String]",
    et = "[object Symbol]",
    ut = "[object Undefined]",
    it = "[object WeakMap]",
    ot = "[object WeakSet]",
    ft = "[object ArrayBuffer]",
    ct = "[object DataView]",
    at = "[object Float32Array]",
    lt = "[object Float64Array]",
    st = "[object Int8Array]",
    ht = "[object Int16Array]",
    pt = "[object Int32Array]",
    _t = "[object Uint8Array]",
    vt = "[object Uint8ClampedArray]",
    gt = "[object Uint16Array]",
    yt = "[object Uint32Array]",
    dt = /\b__p \+= '';/g,
    bt = /\b(__p \+=) '' \+/g,
    wt = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
    mt = /&(?:amp|lt|gt|quot|#39);/g,
    xt = /[&<>"']/g,
    jt = RegExp(mt.source),
    At = RegExp(xt.source),
    kt = /<%-([\s\S]+?)%>/g,
    Ot = /<%([\s\S]+?)%>/g,
    It = /<%=([\s\S]+?)%>/g,
    Rt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    zt = /^\w*$/,
    Et = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    St = /[\\^$.*+?()[\]{}|]/g,
    Wt = RegExp(St.source),
    Lt = /^\s+/,
    Ct = /\s/,
    Ut = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    Bt = /\{\n\/\* \[wrapped with (.+)\] \*/,
    Tt = /,? & /,
    $t = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
    Dt = /[()=,{}\[\]\/\s]/,
    Mt = /\\(\\)?/g,
    Ft = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
    Nt = /\w*$/,
    Pt = /^[-+]0x[0-9a-f]+$/i,
    qt = /^0b[01]+$/i,
    Zt = /^\[object .+?Constructor\]$/,
    Kt = /^0o[0-7]+$/i,
    Vt = /^(?:0|[1-9]\d*)$/,
    Gt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    Ht = /($^)/,
    Jt = /['\n\r\u2028\u2029\\]/g,
    Yt = "\\ud800-\\udfff",
    Qt = "\\u0300-\\u036f",
    Xt = "\\ufe20-\\ufe2f",
    nr = "\\u20d0-\\u20ff",
    tr = Qt + Xt + nr,
    rr = "\\u2700-\\u27bf",
    er = "a-z\\xdf-\\xf6\\xf8-\\xff",
    ur = "\\xac\\xb1\\xd7\\xf7",
    ir = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
    or = "\\u2000-\\u206f",
    fr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    cr = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    ar = "\\ufe0e\\ufe0f",
    lr = ur + ir + or + fr,
    sr = "['\u2019]",
    hr = "[" + Yt + "]",
    pr = "[" + lr + "]",
    _r = "[" + tr + "]",
    vr = "\\d+",
    gr = "[" + rr + "]",
    yr = "[" + er + "]",
    dr = "[^" + Yt + lr + vr + rr + er + cr + "]",
    br = "\\ud83c[\\udffb-\\udfff]",
    wr = "(?:" + _r + "|" + br + ")",
    mr = "[^" + Yt + "]",
    xr = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    jr = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    Ar = "[" + cr + "]",
    kr = "\\u200d",
    Or = "(?:" + yr + "|" + dr + ")",
    Ir = "(?:" + Ar + "|" + dr + ")",
    Rr = "(?:" + sr + "(?:d|ll|m|re|s|t|ve))?",
    zr = "(?:" + sr + "(?:D|LL|M|RE|S|T|VE))?",
    Er = wr + "?",
    Sr = "[" + ar + "]?",
    Wr = "(?:" + kr + "(?:" + [mr, xr, jr].join("|") + ")" + Sr + Er + ")*",
    Lr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
    Cr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
    Ur = Sr + Er + Wr,
    Br = "(?:" + [gr, xr, jr].join("|") + ")" + Ur,
    Tr = "(?:" + [mr + _r + "?", _r, xr, jr, hr].join("|") + ")",
    $r = RegExp(sr, "g"),
    Dr = RegExp(_r, "g"),
    Mr = RegExp(br + "(?=" + br + ")|" + Tr + Ur, "g"),
    Fr = RegExp([Ar + "?" + yr + "+" + Rr + "(?=" + [pr, Ar, "$"].join("|") + ")", Ir + "+" + zr + "(?=" + [pr, Ar + Or, "$"].join("|") + ")", Ar + "?" + Or + "+" + Rr, Ar + "+" + zr, Cr, Lr, vr, Br].join("|"), "g"),
    Nr = RegExp("[" + kr + Yt + tr + ar + "]"),
    Pr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
    qr = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
    Zr = -1,
    Kr = {};
  Kr[at] = Kr[lt] = Kr[st] = Kr[ht] = Kr[pt] = Kr[_t] = Kr[vt] = Kr[gt] = Kr[yt] = !0, Kr[Dn] = Kr[Mn] = Kr[ft] = Kr[Nn] = Kr[ct] = Kr[Pn] = Kr[Zn] = Kr[Kn] = Kr[Gn] = Kr[Hn] = Kr[Yn] = Kr[nt] = Kr[tt] = Kr[rt] = Kr[it] = !1;
  var Vr = {};
  Vr[Dn] = Vr[Mn] = Vr[ft] = Vr[ct] = Vr[Nn] = Vr[Pn] = Vr[at] = Vr[lt] = Vr[st] = Vr[ht] = Vr[pt] = Vr[Gn] = Vr[Hn] = Vr[Yn] = Vr[nt] = Vr[tt] = Vr[rt] = Vr[et] = Vr[_t] = Vr[vt] = Vr[gt] = Vr[yt] = !0, Vr[Zn] = Vr[Kn] = Vr[it] = !1;
  var Gr = {
      "\xc0": "A",
      "\xc1": "A",
      "\xc2": "A",
      "\xc3": "A",
      "\xc4": "A",
      "\xc5": "A",
      "\xe0": "a",
      "\xe1": "a",
      "\xe2": "a",
      "\xe3": "a",
      "\xe4": "a",
      "\xe5": "a",
      "\xc7": "C",
      "\xe7": "c",
      "\xd0": "D",
      "\xf0": "d",
      "\xc8": "E",
      "\xc9": "E",
      "\xca": "E",
      "\xcb": "E",
      "\xe8": "e",
      "\xe9": "e",
      "\xea": "e",
      "\xeb": "e",
      "\xcc": "I",
      "\xcd": "I",
      "\xce": "I",
      "\xcf": "I",
      "\xec": "i",
      "\xed": "i",
      "\xee": "i",
      "\xef": "i",
      "\xd1": "N",
      "\xf1": "n",
      "\xd2": "O",
      "\xd3": "O",
      "\xd4": "O",
      "\xd5": "O",
      "\xd6": "O",
      "\xd8": "O",
      "\xf2": "o",
      "\xf3": "o",
      "\xf4": "o",
      "\xf5": "o",
      "\xf6": "o",
      "\xf8": "o",
      "\xd9": "U",
      "\xda": "U",
      "\xdb": "U",
      "\xdc": "U",
      "\xf9": "u",
      "\xfa": "u",
      "\xfb": "u",
      "\xfc": "u",
      "\xdd": "Y",
      "\xfd": "y",
      "\xff": "y",
      "\xc6": "Ae",
      "\xe6": "ae",
      "\xde": "Th",
      "\xfe": "th",
      "\xdf": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010a": "C",
      "\u010c": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010b": "c",
      "\u010d": "c",
      "\u010e": "D",
      "\u0110": "D",
      "\u010f": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011a": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011b": "e",
      "\u011c": "G",
      "\u011e": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011d": "g",
      "\u011f": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012a": "I",
      "\u012c": "I",
      "\u012e": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012b": "i",
      "\u012d": "i",
      "\u012f": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013b": "L",
      "\u013d": "L",
      "\u013f": "L",
      "\u0141": "L",
      "\u013a": "l",
      "\u013c": "l",
      "\u013e": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014a": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014b": "n",
      "\u014c": "O",
      "\u014e": "O",
      "\u0150": "O",
      "\u014d": "o",
      "\u014f": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015a": "S",
      "\u015c": "S",
      "\u015e": "S",
      "\u0160": "S",
      "\u015b": "s",
      "\u015d": "s",
      "\u015f": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016a": "U",
      "\u016c": "U",
      "\u016e": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016b": "u",
      "\u016d": "u",
      "\u016f": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017b": "Z",
      "\u017d": "Z",
      "\u017a": "z",
      "\u017c": "z",
      "\u017e": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017f": "s"
    },
    Hr = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    },
    Jr = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    },
    Yr = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    },
    Qr = parseFloat,
    Xr = parseInt,
    ne = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
    te = "object" == typeof self && self && self.Object === Object && self,
    re = ne || te || Function("return this")(),
    ee = exports && !exports.nodeType && exports,
    ue = ee && "object" == 'object' && module && !module.nodeType && module,
    ie = ue && ue.exports === ee,
    oe = ie && ne.process,
    fe = function () {
      try {
        var n = ue && ue.require && ue.require("util").types;
        return n ? n : oe && oe.binding && oe.binding("util");
      } catch (n) {}
    }(),
    ce = fe && fe.isArrayBuffer,
    ae = fe && fe.isDate,
    le = fe && fe.isMap,
    se = fe && fe.isRegExp,
    he = fe && fe.isSet,
    pe = fe && fe.isTypedArray,
    _e = m("length"),
    ve = x(Gr),
    ge = x(Hr),
    ye = x(Jr),
    de = function p(x) {
      function Z(n) {
        if (cc(n) && !bh(n) && !(n instanceof Ct)) {
          if (n instanceof Y) return n;
          if (bl.call(n, "__wrapped__")) return eo(n);
        }
        return new Y(n);
      }
      function J() {}
      function Y(n, t) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = X;
      }
      function Ct(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Un, this.__views__ = [];
      }
      function $t() {
        var n = new Ct(this.__wrapped__);
        return n.__actions__ = Tu(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Tu(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Tu(this.__views__), n;
      }
      function Yt() {
        if (this.__filtered__) {
          var n = new Ct(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function Qt() {
        var n = this.__wrapped__.value(),
          t = this.__dir__,
          r = bh(n),
          e = t < 0,
          u = r ? n.length : 0,
          i = Oi(0, u, this.__views__),
          o = i.start,
          f = i.end,
          c = f - o,
          a = e ? f : o - 1,
          l = this.__iteratees__,
          s = l.length,
          h = 0,
          p = Hl(c, this.__takeCount__);
        if (!r || !e && u == c && p == c) return wu(n, this.__actions__);
        var _ = [];
        n: for (; c-- && h < p;) {
          a += t;
          for (var v = -1, g = n[a]; ++v < s;) {
            var y = l[v],
              d = y.iteratee,
              b = y.type,
              w = d(g);
            if (b == zn) g = w;else if (!w) {
              if (b == Rn) continue n;
              break n;
            }
          }
          _[h++] = g;
        }
        return _;
      }
      function Xt(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.clear(); ++t < r;) {
          var e = n[t];
          this.set(e[0], e[1]);
        }
      }
      function nr() {
        this.__data__ = is ? is(null) : {}, this.size = 0;
      }
      function tr(n) {
        var t = this.has(n) && delete this.__data__[n];
        return this.size -= t ? 1 : 0, t;
      }
      function rr(n) {
        var t = this.__data__;
        if (is) {
          var r = t[n];
          return r === on ? X : r;
        }
        return bl.call(t, n) ? t[n] : X;
      }
      function er(n) {
        var t = this.__data__;
        return is ? t[n] !== X : bl.call(t, n);
      }
      function ur(n, t) {
        var r = this.__data__;
        return this.size += this.has(n) ? 0 : 1, r[n] = is && t === X ? on : t, this;
      }
      function ir(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.clear(); ++t < r;) {
          var e = n[t];
          this.set(e[0], e[1]);
        }
      }
      function or() {
        this.__data__ = [], this.size = 0;
      }
      function fr(n) {
        var t = this.__data__,
          r = Wr(t, n);
        return !(r < 0) && (r == t.length - 1 ? t.pop() : Ll.call(t, r, 1), --this.size, !0);
      }
      function cr(n) {
        var t = this.__data__,
          r = Wr(t, n);
        return r < 0 ? X : t[r][1];
      }
      function ar(n) {
        return Wr(this.__data__, n) > -1;
      }
      function lr(n, t) {
        var r = this.__data__,
          e = Wr(r, n);
        return e < 0 ? (++this.size, r.push([n, t])) : r[e][1] = t, this;
      }
      function sr(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.clear(); ++t < r;) {
          var e = n[t];
          this.set(e[0], e[1]);
        }
      }
      function hr() {
        this.size = 0, this.__data__ = {
          hash: new Xt(),
          map: new (ts || ir)(),
          string: new Xt()
        };
      }
      function pr(n) {
        var t = xi(this, n).delete(n);
        return this.size -= t ? 1 : 0, t;
      }
      function _r(n) {
        return xi(this, n).get(n);
      }
      function vr(n) {
        return xi(this, n).has(n);
      }
      function gr(n, t) {
        var r = xi(this, n),
          e = r.size;
        return r.set(n, t), this.size += r.size == e ? 0 : 1, this;
      }
      function yr(n) {
        var t = -1,
          r = null == n ? 0 : n.length;
        for (this.__data__ = new sr(); ++t < r;) this.add(n[t]);
      }
      function dr(n) {
        return this.__data__.set(n, on), this;
      }
      function br(n) {
        return this.__data__.has(n);
      }
      function wr(n) {
        this.size = (this.__data__ = new ir(n)).size;
      }
      function mr() {
        this.__data__ = new ir(), this.size = 0;
      }
      function xr(n) {
        var t = this.__data__,
          r = t.delete(n);
        return this.size = t.size, r;
      }
      function jr(n) {
        return this.__data__.get(n);
      }
      function Ar(n) {
        return this.__data__.has(n);
      }
      function kr(n, t) {
        var r = this.__data__;
        if (r instanceof ir) {
          var e = r.__data__;
          if (!ts || e.length < tn - 1) return e.push([n, t]), this.size = ++r.size, this;
          r = this.__data__ = new sr(e);
        }
        return r.set(n, t), this.size = r.size, this;
      }
      function Or(n, t) {
        var r = bh(n),
          e = !r && dh(n),
          u = !r && !e && mh(n),
          i = !r && !e && !u && Oh(n),
          o = r || e || u || i,
          f = o ? O(n.length, hl) : [],
          c = f.length;
        for (var a in n) !t && !bl.call(n, a) || o && ("length" == a || u && ("offset" == a || "parent" == a) || i && ("buffer" == a || "byteLength" == a || "byteOffset" == a) || Ci(a, c)) || f.push(a);
        return f;
      }
      function Ir(n) {
        var t = n.length;
        return t ? n[tu(0, t - 1)] : X;
      }
      function Rr(n, t) {
        return Xi(Tu(n), Mr(t, 0, n.length));
      }
      function zr(n) {
        return Xi(Tu(n));
      }
      function Er(n, t, r) {
        (r === X || Gf(n[t], r)) && (r !== X || t in n) || Br(n, t, r);
      }
      function Sr(n, t, r) {
        var e = n[t];
        bl.call(n, t) && Gf(e, r) && (r !== X || t in n) || Br(n, t, r);
      }
      function Wr(n, t) {
        for (var r = n.length; r--;) if (Gf(n[r][0], t)) return r;
        return -1;
      }
      function Lr(n, t, r, e) {
        return ys(n, function (n, u, i) {
          t(e, n, r(n), i);
        }), e;
      }
      function Cr(n, t) {
        return n && $u(t, Pc(t), n);
      }
      function Ur(n, t) {
        return n && $u(t, qc(t), n);
      }
      function Br(n, t, r) {
        "__proto__" == t && Tl ? Tl(n, t, {
          configurable: !0,
          enumerable: !0,
          value: r,
          writable: !0
        }) : n[t] = r;
      }
      function Tr(n, t) {
        for (var r = -1, e = t.length, u = il(e), i = null == n; ++r < e;) u[r] = i ? X : Mc(n, t[r]);
        return u;
      }
      function Mr(n, t, r) {
        return n === n && (r !== X && (n = n <= r ? n : r), t !== X && (n = n >= t ? n : t)), n;
      }
      function Fr(n, t, e, u, i, o) {
        var f,
          c = t & an,
          a = t & ln,
          l = t & sn;
        if (e && (f = i ? e(n, u, i, o) : e(n)), f !== X) return f;
        if (!fc(n)) return n;
        var s = bh(n);
        if (s) {
          if (f = zi(n), !c) return Tu(n, f);
        } else {
          var h = zs(n),
            p = h == Kn || h == Vn;
          if (mh(n)) return Iu(n, c);
          if (h == Yn || h == Dn || p && !i) {
            if (f = a || p ? {} : Ei(n), !c) return a ? Mu(n, Ur(f, n)) : Du(n, Cr(f, n));
          } else {
            if (!Vr[h]) return i ? n : {};
            f = Si(n, h, c);
          }
        }
        o || (o = new wr());
        var _ = o.get(n);
        if (_) return _;
        o.set(n, f), kh(n) ? n.forEach(function (r) {
          f.add(Fr(r, t, e, r, n, o));
        }) : jh(n) && n.forEach(function (r, u) {
          f.set(u, Fr(r, t, e, u, n, o));
        });
        var v = l ? a ? di : yi : a ? qc : Pc,
          g = s ? X : v(n);
        return r(g || n, function (r, u) {
          g && (u = r, r = n[u]), Sr(f, u, Fr(r, t, e, u, n, o));
        }), f;
      }
      function Nr(n) {
        var t = Pc(n);
        return function (r) {
          return Pr(r, n, t);
        };
      }
      function Pr(n, t, r) {
        var e = r.length;
        if (null == n) return !e;
        for (n = ll(n); e--;) {
          var u = r[e],
            i = t[u],
            o = n[u];
          if (o === X && !(u in n) || !i(o)) return !1;
        }
        return !0;
      }
      function Gr(n, t, r) {
        if ("function" != typeof n) throw new pl(en);
        return Ws(function () {
          n.apply(X, r);
        }, t);
      }
      function Hr(n, t, r, e) {
        var u = -1,
          i = o,
          a = !0,
          l = n.length,
          s = [],
          h = t.length;
        if (!l) return s;
        r && (t = c(t, z(r))), e ? (i = f, a = !1) : t.length >= tn && (i = S, a = !1, t = new yr(t));
        n: for (; ++u < l;) {
          var p = n[u],
            _ = null == r ? p : r(p);
          if (p = e || 0 !== p ? p : 0, a && _ === _) {
            for (var v = h; v--;) if (t[v] === _) continue n;
            s.push(p);
          } else i(t, _, e) || s.push(p);
        }
        return s;
      }
      function Jr(n, t) {
        var r = !0;
        return ys(n, function (n, e, u) {
          return r = !!t(n, e, u);
        }), r;
      }
      function Yr(n, t, r) {
        for (var e = -1, u = n.length; ++e < u;) {
          var i = n[e],
            o = t(i);
          if (null != o && (f === X ? o === o && !bc(o) : r(o, f))) var f = o,
            c = i;
        }
        return c;
      }
      function ne(n, t, r, e) {
        var u = n.length;
        for (r = kc(r), r < 0 && (r = -r > u ? 0 : u + r), e = e === X || e > u ? u : kc(e), e < 0 && (e += u), e = r > e ? 0 : Oc(e); r < e;) n[r++] = t;
        return n;
      }
      function te(n, t) {
        var r = [];
        return ys(n, function (n, e, u) {
          t(n, e, u) && r.push(n);
        }), r;
      }
      function ee(n, t, r, e, u) {
        var i = -1,
          o = n.length;
        for (r || (r = Li), u || (u = []); ++i < o;) {
          var f = n[i];
          t > 0 && r(f) ? t > 1 ? ee(f, t - 1, r, e, u) : a(u, f) : e || (u[u.length] = f);
        }
        return u;
      }
      function ue(n, t) {
        return n && bs(n, t, Pc);
      }
      function oe(n, t) {
        return n && ws(n, t, Pc);
      }
      function fe(n, t) {
        return i(t, function (t) {
          return uc(n[t]);
        });
      }
      function _e(n, t) {
        t = ku(t, n);
        for (var r = 0, e = t.length; null != n && r < e;) n = n[no(t[r++])];
        return r && r == e ? n : X;
      }
      function de(n, t, r) {
        var e = t(n);
        return bh(n) ? e : a(e, r(n));
      }
      function we(n) {
        return null == n ? n === X ? ut : Jn : Bl && Bl in ll(n) ? ki(n) : Ki(n);
      }
      function me(n, t) {
        return n > t;
      }
      function xe(n, t) {
        return null != n && bl.call(n, t);
      }
      function je(n, t) {
        return null != n && t in ll(n);
      }
      function Ae(n, t, r) {
        return n >= Hl(t, r) && n < Gl(t, r);
      }
      function ke(n, t, r) {
        for (var e = r ? f : o, u = n[0].length, i = n.length, a = i, l = il(i), s = 1 / 0, h = []; a--;) {
          var p = n[a];
          a && t && (p = c(p, z(t))), s = Hl(p.length, s), l[a] = !r && (t || u >= 120 && p.length >= 120) ? new yr(a && p) : X;
        }
        p = n[0];
        var _ = -1,
          v = l[0];
        n: for (; ++_ < u && h.length < s;) {
          var g = p[_],
            y = t ? t(g) : g;
          if (g = r || 0 !== g ? g : 0, !(v ? S(v, y) : e(h, y, r))) {
            for (a = i; --a;) {
              var d = l[a];
              if (!(d ? S(d, y) : e(n[a], y, r))) continue n;
            }
            v && v.push(y), h.push(g);
          }
        }
        return h;
      }
      function Oe(n, t, r, e) {
        return ue(n, function (n, u, i) {
          t(e, r(n), u, i);
        }), e;
      }
      function Ie(t, r, e) {
        r = ku(r, t), t = Gi(t, r);
        var u = null == t ? t : t[no(jo(r))];
        return null == u ? X : n(u, t, e);
      }
      function Re(n) {
        return cc(n) && we(n) == Dn;
      }
      function ze(n) {
        return cc(n) && we(n) == ft;
      }
      function Ee(n) {
        return cc(n) && we(n) == Pn;
      }
      function Se(n, t, r, e, u) {
        return n === t || (null == n || null == t || !cc(n) && !cc(t) ? n !== n && t !== t : We(n, t, r, e, Se, u));
      }
      function We(n, t, r, e, u, i) {
        var o = bh(n),
          f = bh(t),
          c = o ? Mn : zs(n),
          a = f ? Mn : zs(t);
        c = c == Dn ? Yn : c, a = a == Dn ? Yn : a;
        var l = c == Yn,
          s = a == Yn,
          h = c == a;
        if (h && mh(n)) {
          if (!mh(t)) return !1;
          o = !0, l = !1;
        }
        if (h && !l) return i || (i = new wr()), o || Oh(n) ? pi(n, t, r, e, u, i) : _i(n, t, c, r, e, u, i);
        if (!(r & hn)) {
          var p = l && bl.call(n, "__wrapped__"),
            _ = s && bl.call(t, "__wrapped__");
          if (p || _) {
            var v = p ? n.value() : n,
              g = _ ? t.value() : t;
            return i || (i = new wr()), u(v, g, r, e, i);
          }
        }
        return !!h && (i || (i = new wr()), vi(n, t, r, e, u, i));
      }
      function Le(n) {
        return cc(n) && zs(n) == Gn;
      }
      function Ce(n, t, r, e) {
        var u = r.length,
          i = u,
          o = !e;
        if (null == n) return !i;
        for (n = ll(n); u--;) {
          var f = r[u];
          if (o && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
        }
        for (; ++u < i;) {
          f = r[u];
          var c = f[0],
            a = n[c],
            l = f[1];
          if (o && f[2]) {
            if (a === X && !(c in n)) return !1;
          } else {
            var s = new wr();
            if (e) var h = e(a, l, c, n, t, s);
            if (!(h === X ? Se(l, a, hn | pn, e, s) : h)) return !1;
          }
        }
        return !0;
      }
      function Ue(n) {
        return !(!fc(n) || Di(n)) && (uc(n) ? kl : Zt).test(to(n));
      }
      function Be(n) {
        return cc(n) && we(n) == nt;
      }
      function Te(n) {
        return cc(n) && zs(n) == tt;
      }
      function $e(n) {
        return cc(n) && oc(n.length) && !!Kr[we(n)];
      }
      function De(n) {
        return "function" == typeof n ? n : null == n ? La : "object" == typeof n ? bh(n) ? Ze(n[0], n[1]) : qe(n) : Fa(n);
      }
      function Me(n) {
        if (!Mi(n)) return Vl(n);
        var t = [];
        for (var r in ll(n)) bl.call(n, r) && "constructor" != r && t.push(r);
        return t;
      }
      function Fe(n) {
        if (!fc(n)) return Zi(n);
        var t = Mi(n),
          r = [];
        for (var e in n) ("constructor" != e || !t && bl.call(n, e)) && r.push(e);
        return r;
      }
      function Ne(n, t) {
        return n < t;
      }
      function Pe(n, t) {
        var r = -1,
          e = Hf(n) ? il(n.length) : [];
        return ys(n, function (n, u, i) {
          e[++r] = t(n, u, i);
        }), e;
      }
      function qe(n) {
        var t = ji(n);
        return 1 == t.length && t[0][2] ? Ni(t[0][0], t[0][1]) : function (r) {
          return r === n || Ce(r, n, t);
        };
      }
      function Ze(n, t) {
        return Bi(n) && Fi(t) ? Ni(no(n), t) : function (r) {
          var e = Mc(r, n);
          return e === X && e === t ? Nc(r, n) : Se(t, e, hn | pn);
        };
      }
      function Ke(n, t, r, e, u) {
        n !== t && bs(t, function (i, o) {
          if (u || (u = new wr()), fc(i)) Ve(n, t, o, r, Ke, e, u);else {
            var f = e ? e(Ji(n, o), i, o + "", n, t, u) : X;
            f === X && (f = i), Er(n, o, f);
          }
        }, qc);
      }
      function Ve(n, t, r, e, u, i, o) {
        var f = Ji(n, r),
          c = Ji(t, r),
          a = o.get(c);
        if (a) return Er(n, r, a), X;
        var l = i ? i(f, c, r + "", n, t, o) : X,
          s = l === X;
        if (s) {
          var h = bh(c),
            p = !h && mh(c),
            _ = !h && !p && Oh(c);
          l = c, h || p || _ ? bh(f) ? l = f : Jf(f) ? l = Tu(f) : p ? (s = !1, l = Iu(c, !0)) : _ ? (s = !1, l = Wu(c, !0)) : l = [] : gc(c) || dh(c) ? (l = f, dh(f) ? l = Rc(f) : fc(f) && !uc(f) || (l = Ei(c))) : s = !1;
        }
        s && (o.set(c, l), u(l, c, e, i, o), o.delete(c)), Er(n, r, l);
      }
      function Ge(n, t) {
        var r = n.length;
        if (r) return t += t < 0 ? r : 0, Ci(t, r) ? n[t] : X;
      }
      function He(n, t, r) {
        t = t.length ? c(t, function (n) {
          return bh(n) ? function (t) {
            return _e(t, 1 === n.length ? n[0] : n);
          } : n;
        }) : [La];
        var e = -1;
        return t = c(t, z(mi())), A(Pe(n, function (n, r, u) {
          return {
            criteria: c(t, function (t) {
              return t(n);
            }),
            index: ++e,
            value: n
          };
        }), function (n, t) {
          return Cu(n, t, r);
        });
      }
      function Je(n, t) {
        return Ye(n, t, function (t, r) {
          return Nc(n, r);
        });
      }
      function Ye(n, t, r) {
        for (var e = -1, u = t.length, i = {}; ++e < u;) {
          var o = t[e],
            f = _e(n, o);
          r(f, o) && fu(i, ku(o, n), f);
        }
        return i;
      }
      function Qe(n) {
        return function (t) {
          return _e(t, n);
        };
      }
      function Xe(n, t, r, e) {
        var u = e ? d : y,
          i = -1,
          o = t.length,
          f = n;
        for (n === t && (t = Tu(t)), r && (f = c(n, z(r))); ++i < o;) for (var a = 0, l = t[i], s = r ? r(l) : l; (a = u(f, s, a, e)) > -1;) f !== n && Ll.call(f, a, 1), Ll.call(n, a, 1);
        return n;
      }
      function nu(n, t) {
        for (var r = n ? t.length : 0, e = r - 1; r--;) {
          var u = t[r];
          if (r == e || u !== i) {
            var i = u;
            Ci(u) ? Ll.call(n, u, 1) : yu(n, u);
          }
        }
        return n;
      }
      function tu(n, t) {
        return n + Nl(Ql() * (t - n + 1));
      }
      function ru(n, t, r, e) {
        for (var u = -1, i = Gl(Fl((t - n) / (r || 1)), 0), o = il(i); i--;) o[e ? i : ++u] = n, n += r;
        return o;
      }
      function eu(n, t) {
        var r = "";
        if (!n || t < 1 || t > Wn) return r;
        do t % 2 && (r += n), t = Nl(t / 2), t && (n += n); while (t);
        return r;
      }
      function uu(n, t) {
        return Ls(Vi(n, t, La), n + "");
      }
      function iu(n) {
        return Ir(ra(n));
      }
      function ou(n, t) {
        var r = ra(n);
        return Xi(r, Mr(t, 0, r.length));
      }
      function fu(n, t, r, e) {
        if (!fc(n)) return n;
        t = ku(t, n);
        for (var u = -1, i = t.length, o = i - 1, f = n; null != f && ++u < i;) {
          var c = no(t[u]),
            a = r;
          if ("__proto__" === c || "constructor" === c || "prototype" === c) return n;
          if (u != o) {
            var l = f[c];
            a = e ? e(l, c, f) : X, a === X && (a = fc(l) ? l : Ci(t[u + 1]) ? [] : {});
          }
          Sr(f, c, a), f = f[c];
        }
        return n;
      }
      function cu(n) {
        return Xi(ra(n));
      }
      function au(n, t, r) {
        var e = -1,
          u = n.length;
        t < 0 && (t = -t > u ? 0 : u + t), r = r > u ? u : r, r < 0 && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0;
        for (var i = il(u); ++e < u;) i[e] = n[e + t];
        return i;
      }
      function lu(n, t) {
        var r;
        return ys(n, function (n, e, u) {
          return r = t(n, e, u), !r;
        }), !!r;
      }
      function su(n, t, r) {
        var e = 0,
          u = null == n ? e : n.length;
        if ("number" == typeof t && t === t && u <= Tn) {
          for (; e < u;) {
            var i = e + u >>> 1,
              o = n[i];
            null !== o && !bc(o) && (r ? o <= t : o < t) ? e = i + 1 : u = i;
          }
          return u;
        }
        return hu(n, t, La, r);
      }
      function hu(n, t, r, e) {
        var u = 0,
          i = null == n ? 0 : n.length;
        if (0 === i) return 0;
        t = r(t);
        for (var o = t !== t, f = null === t, c = bc(t), a = t === X; u < i;) {
          var l = Nl((u + i) / 2),
            s = r(n[l]),
            h = s !== X,
            p = null === s,
            _ = s === s,
            v = bc(s);
          if (o) var g = e || _;else g = a ? _ && (e || h) : f ? _ && h && (e || !p) : c ? _ && h && !p && (e || !v) : !p && !v && (e ? s <= t : s < t);
          g ? u = l + 1 : i = l;
        }
        return Hl(i, Bn);
      }
      function pu(n, t) {
        for (var r = -1, e = n.length, u = 0, i = []; ++r < e;) {
          var o = n[r],
            f = t ? t(o) : o;
          if (!r || !Gf(f, c)) {
            var c = f;
            i[u++] = 0 === o ? 0 : o;
          }
        }
        return i;
      }
      function _u(n) {
        return "number" == typeof n ? n : bc(n) ? Cn : +n;
      }
      function vu(n) {
        if ("string" == typeof n) return n;
        if (bh(n)) return c(n, vu) + "";
        if (bc(n)) return vs ? vs.call(n) : "";
        var t = n + "";
        return "0" == t && 1 / n == -Sn ? "-0" : t;
      }
      function gu(n, t, r) {
        var e = -1,
          u = o,
          i = n.length,
          c = !0,
          a = [],
          l = a;
        if (r) c = !1, u = f;else if (i >= tn) {
          var s = t ? null : ks(n);
          if (s) return P(s);
          c = !1, u = S, l = new yr();
        } else l = t ? [] : a;
        n: for (; ++e < i;) {
          var h = n[e],
            p = t ? t(h) : h;
          if (h = r || 0 !== h ? h : 0, c && p === p) {
            for (var _ = l.length; _--;) if (l[_] === p) continue n;
            t && l.push(p), a.push(h);
          } else u(l, p, r) || (l !== a && l.push(p), a.push(h));
        }
        return a;
      }
      function yu(n, t) {
        return t = ku(t, n), n = Gi(n, t), null == n || delete n[no(jo(t))];
      }
      function du(n, t, r, e) {
        return fu(n, t, r(_e(n, t)), e);
      }
      function bu(n, t, r, e) {
        for (var u = n.length, i = e ? u : -1; (e ? i-- : ++i < u) && t(n[i], i, n););
        return r ? au(n, e ? 0 : i, e ? i + 1 : u) : au(n, e ? i + 1 : 0, e ? u : i);
      }
      function wu(n, t) {
        var r = n;
        return r instanceof Ct && (r = r.value()), l(t, function (n, t) {
          return t.func.apply(t.thisArg, a([n], t.args));
        }, r);
      }
      function mu(n, t, r) {
        var e = n.length;
        if (e < 2) return e ? gu(n[0]) : [];
        for (var u = -1, i = il(e); ++u < e;) for (var o = n[u], f = -1; ++f < e;) f != u && (i[u] = Hr(i[u] || o, n[f], t, r));
        return gu(ee(i, 1), t, r);
      }
      function xu(n, t, r) {
        for (var e = -1, u = n.length, i = t.length, o = {}; ++e < u;) {
          r(o, n[e], e < i ? t[e] : X);
        }
        return o;
      }
      function ju(n) {
        return Jf(n) ? n : [];
      }
      function Au(n) {
        return "function" == typeof n ? n : La;
      }
      function ku(n, t) {
        return bh(n) ? n : Bi(n, t) ? [n] : Cs(Ec(n));
      }
      function Ou(n, t, r) {
        var e = n.length;
        return r = r === X ? e : r, !t && r >= e ? n : au(n, t, r);
      }
      function Iu(n, t) {
        if (t) return n.slice();
        var r = n.length,
          e = zl ? zl(r) : new n.constructor(r);
        return n.copy(e), e;
      }
      function Ru(n) {
        var t = new n.constructor(n.byteLength);
        return new Rl(t).set(new Rl(n)), t;
      }
      function zu(n, t) {
        return new n.constructor(t ? Ru(n.buffer) : n.buffer, n.byteOffset, n.byteLength);
      }
      function Eu(n) {
        var t = new n.constructor(n.source, Nt.exec(n));
        return t.lastIndex = n.lastIndex, t;
      }
      function Su(n) {
        return _s ? ll(_s.call(n)) : {};
      }
      function Wu(n, t) {
        return new n.constructor(t ? Ru(n.buffer) : n.buffer, n.byteOffset, n.length);
      }
      function Lu(n, t) {
        if (n !== t) {
          var r = n !== X,
            e = null === n,
            u = n === n,
            i = bc(n),
            o = t !== X,
            f = null === t,
            c = t === t,
            a = bc(t);
          if (!f && !a && !i && n > t || i && o && c && !f && !a || e && o && c || !r && c || !u) return 1;
          if (!e && !i && !a && n < t || a && r && u && !e && !i || f && r && u || !o && u || !c) return -1;
        }
        return 0;
      }
      function Cu(n, t, r) {
        for (var e = -1, u = n.criteria, i = t.criteria, o = u.length, f = r.length; ++e < o;) {
          var c = Lu(u[e], i[e]);
          if (c) {
            if (e >= f) return c;
            return c * ("desc" == r[e] ? -1 : 1);
          }
        }
        return n.index - t.index;
      }
      function Uu(n, t, r, e) {
        for (var u = -1, i = n.length, o = r.length, f = -1, c = t.length, a = Gl(i - o, 0), l = il(c + a), s = !e; ++f < c;) l[f] = t[f];
        for (; ++u < o;) (s || u < i) && (l[r[u]] = n[u]);
        for (; a--;) l[f++] = n[u++];
        return l;
      }
      function Bu(n, t, r, e) {
        for (var u = -1, i = n.length, o = -1, f = r.length, c = -1, a = t.length, l = Gl(i - f, 0), s = il(l + a), h = !e; ++u < l;) s[u] = n[u];
        for (var p = u; ++c < a;) s[p + c] = t[c];
        for (; ++o < f;) (h || u < i) && (s[p + r[o]] = n[u++]);
        return s;
      }
      function Tu(n, t) {
        var r = -1,
          e = n.length;
        for (t || (t = il(e)); ++r < e;) t[r] = n[r];
        return t;
      }
      function $u(n, t, r, e) {
        var u = !r;
        r || (r = {});
        for (var i = -1, o = t.length; ++i < o;) {
          var f = t[i],
            c = e ? e(r[f], n[f], f, r, n) : X;
          c === X && (c = n[f]), u ? Br(r, f, c) : Sr(r, f, c);
        }
        return r;
      }
      function Du(n, t) {
        return $u(n, Is(n), t);
      }
      function Mu(n, t) {
        return $u(n, Rs(n), t);
      }
      function Fu(n, r) {
        return function (e, u) {
          var i = bh(e) ? t : Lr,
            o = r ? r() : {};
          return i(e, n, mi(u, 2), o);
        };
      }
      function Nu(n) {
        return uu(function (t, r) {
          var e = -1,
            u = r.length,
            i = u > 1 ? r[u - 1] : X,
            o = u > 2 ? r[2] : X;
          for (i = n.length > 3 && "function" == typeof i ? (u--, i) : X, o && Ui(r[0], r[1], o) && (i = u < 3 ? X : i, u = 1), t = ll(t); ++e < u;) {
            var f = r[e];
            f && n(t, f, e, i);
          }
          return t;
        });
      }
      function Pu(n, t) {
        return function (r, e) {
          if (null == r) return r;
          if (!Hf(r)) return n(r, e);
          for (var u = r.length, i = t ? u : -1, o = ll(r); (t ? i-- : ++i < u) && e(o[i], i, o) !== !1;);
          return r;
        };
      }
      function qu(n) {
        return function (t, r, e) {
          for (var u = -1, i = ll(t), o = e(t), f = o.length; f--;) {
            var c = o[n ? f : ++u];
            if (r(i[c], c, i) === !1) break;
          }
          return t;
        };
      }
      function Zu(n, t, r) {
        function e() {
          return (this && this !== re && this instanceof e ? i : n).apply(u ? r : this, arguments);
        }
        var u = t & _n,
          i = Gu(n);
        return e;
      }
      function Ku(n) {
        return function (t) {
          t = Ec(t);
          var r = T(t) ? G(t) : X,
            e = r ? r[0] : t.charAt(0),
            u = r ? Ou(r, 1).join("") : t.slice(1);
          return e[n]() + u;
        };
      }
      function Vu(n) {
        return function (t) {
          return l(Ra(ca(t).replace($r, "")), n, "");
        };
      }
      function Gu(n) {
        return function () {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new n();
            case 1:
              return new n(t[0]);
            case 2:
              return new n(t[0], t[1]);
            case 3:
              return new n(t[0], t[1], t[2]);
            case 4:
              return new n(t[0], t[1], t[2], t[3]);
            case 5:
              return new n(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var r = gs(n.prototype),
            e = n.apply(r, t);
          return fc(e) ? e : r;
        };
      }
      function Hu(t, r, e) {
        function u() {
          for (var o = arguments.length, f = il(o), c = o, a = wi(u); c--;) f[c] = arguments[c];
          var l = o < 3 && f[0] !== a && f[o - 1] !== a ? [] : N(f, a);
          return o -= l.length, o < e ? oi(t, r, Qu, u.placeholder, X, f, l, X, X, e - o) : n(this && this !== re && this instanceof u ? i : t, this, f);
        }
        var i = Gu(t);
        return u;
      }
      function Ju(n) {
        return function (t, r, e) {
          var u = ll(t);
          if (!Hf(t)) {
            var i = mi(r, 3);
            t = Pc(t), r = function (n) {
              return i(u[n], n, u);
            };
          }
          var o = n(t, r, e);
          return o > -1 ? u[i ? t[o] : o] : X;
        };
      }
      function Yu(n) {
        return gi(function (t) {
          var r = t.length,
            e = r,
            u = Y.prototype.thru;
          for (n && t.reverse(); e--;) {
            var i = t[e];
            if ("function" != typeof i) throw new pl(en);
            if (u && !o && "wrapper" == bi(i)) var o = new Y([], !0);
          }
          for (e = o ? e : r; ++e < r;) {
            i = t[e];
            var f = bi(i),
              c = "wrapper" == f ? Os(i) : X;
            o = c && $i(c[0]) && c[1] == (mn | yn | bn | xn) && !c[4].length && 1 == c[9] ? o[bi(c[0])].apply(o, c[3]) : 1 == i.length && $i(i) ? o[f]() : o.thru(i);
          }
          return function () {
            var n = arguments,
              e = n[0];
            if (o && 1 == n.length && bh(e)) return o.plant(e).value();
            for (var u = 0, i = r ? t[u].apply(this, n) : e; ++u < r;) i = t[u].call(this, i);
            return i;
          };
        });
      }
      function Qu(n, t, r, e, u, i, o, f, c, a) {
        function l() {
          for (var y = arguments.length, d = il(y), b = y; b--;) d[b] = arguments[b];
          if (_) var w = wi(l),
            m = C(d, w);
          if (e && (d = Uu(d, e, u, _)), i && (d = Bu(d, i, o, _)), y -= m, _ && y < a) {
            return oi(n, t, Qu, l.placeholder, r, d, N(d, w), f, c, a - y);
          }
          var x = h ? r : this,
            j = p ? x[n] : n;
          return y = d.length, f ? d = Hi(d, f) : v && y > 1 && d.reverse(), s && c < y && (d.length = c), this && this !== re && this instanceof l && (j = g || Gu(j)), j.apply(x, d);
        }
        var s = t & mn,
          h = t & _n,
          p = t & vn,
          _ = t & (yn | dn),
          v = t & jn,
          g = p ? X : Gu(n);
        return l;
      }
      function Xu(n, t) {
        return function (r, e) {
          return Oe(r, n, t(e), {});
        };
      }
      function ni(n, t) {
        return function (r, e) {
          var u;
          if (r === X && e === X) return t;
          if (r !== X && (u = r), e !== X) {
            if (u === X) return e;
            "string" == typeof r || "string" == typeof e ? (r = vu(r), e = vu(e)) : (r = _u(r), e = _u(e)), u = n(r, e);
          }
          return u;
        };
      }
      function ti(t) {
        return gi(function (r) {
          return r = c(r, z(mi())), uu(function (e) {
            var u = this;
            return t(r, function (t) {
              return n(t, u, e);
            });
          });
        });
      }
      function ri(n, t) {
        t = t === X ? " " : vu(t);
        var r = t.length;
        if (r < 2) return r ? eu(t, n) : t;
        var e = eu(t, Fl(n / V(t)));
        return T(t) ? Ou(G(e), 0, n).join("") : e.slice(0, n);
      }
      function ei(t, r, e, u) {
        function i() {
          for (var r = -1, c = arguments.length, a = -1, l = u.length, s = il(l + c), h = this && this !== re && this instanceof i ? f : t; ++a < l;) s[a] = u[a];
          for (; c--;) s[a++] = arguments[++r];
          return n(h, o ? e : this, s);
        }
        var o = r & _n,
          f = Gu(t);
        return i;
      }
      function ui(n) {
        return function (t, r, e) {
          return e && "number" != typeof e && Ui(t, r, e) && (r = e = X), t = Ac(t), r === X ? (r = t, t = 0) : r = Ac(r), e = e === X ? t < r ? 1 : -1 : Ac(e), ru(t, r, e, n);
        };
      }
      function ii(n) {
        return function (t, r) {
          return "string" == typeof t && "string" == typeof r || (t = Ic(t), r = Ic(r)), n(t, r);
        };
      }
      function oi(n, t, r, e, u, i, o, f, c, a) {
        var l = t & yn,
          s = l ? o : X,
          h = l ? X : o,
          p = l ? i : X,
          _ = l ? X : i;
        t |= l ? bn : wn, t &= ~(l ? wn : bn), t & gn || (t &= ~(_n | vn));
        var v = [n, t, u, p, s, _, h, f, c, a],
          g = r.apply(X, v);
        return $i(n) && Ss(g, v), g.placeholder = e, Yi(g, n, t);
      }
      function fi(n) {
        var t = al[n];
        return function (n, r) {
          if (n = Ic(n), r = null == r ? 0 : Hl(kc(r), 292), r && Zl(n)) {
            var e = (Ec(n) + "e").split("e");
            return e = (Ec(t(e[0] + "e" + (+e[1] + r))) + "e").split("e"), +(e[0] + "e" + (+e[1] - r));
          }
          return t(n);
        };
      }
      function ci(n) {
        return function (t) {
          var r = zs(t);
          return r == Gn ? M(t) : r == tt ? q(t) : I(t, n(t));
        };
      }
      function ai(n, t, r, e, u, i, o, f) {
        var c = t & vn;
        if (!c && "function" != typeof n) throw new pl(en);
        var a = e ? e.length : 0;
        if (a || (t &= ~(bn | wn), e = u = X), o = o === X ? o : Gl(kc(o), 0), f = f === X ? f : kc(f), a -= u ? u.length : 0, t & wn) {
          var l = e,
            s = u;
          e = u = X;
        }
        var h = c ? X : Os(n),
          p = [n, t, r, e, u, l, s, i, o, f];
        if (h && qi(p, h), n = p[0], t = p[1], r = p[2], e = p[3], u = p[4], f = p[9] = p[9] === X ? c ? 0 : n.length : Gl(p[9] - a, 0), !f && t & (yn | dn) && (t &= ~(yn | dn)), t && t != _n) _ = t == yn || t == dn ? Hu(n, t, f) : t != bn && t != (_n | bn) || u.length ? Qu.apply(X, p) : ei(n, t, r, e);else var _ = Zu(n, t, r);
        return Yi((h ? ms : Ss)(_, p), n, t);
      }
      function li(n, t, r, e) {
        return n === X || Gf(n, gl[r]) && !bl.call(e, r) ? t : n;
      }
      function si(n, t, r, e, u, i) {
        return fc(n) && fc(t) && (i.set(t, n), Ke(n, t, X, si, i), i.delete(t)), n;
      }
      function hi(n) {
        return gc(n) ? X : n;
      }
      function pi(n, t, r, e, u, i) {
        var o = r & hn,
          f = n.length,
          c = t.length;
        if (f != c && !(o && c > f)) return !1;
        var a = i.get(n),
          l = i.get(t);
        if (a && l) return a == t && l == n;
        var s = -1,
          p = !0,
          _ = r & pn ? new yr() : X;
        for (i.set(n, t), i.set(t, n); ++s < f;) {
          var v = n[s],
            g = t[s];
          if (e) var y = o ? e(g, v, s, t, n, i) : e(v, g, s, n, t, i);
          if (y !== X) {
            if (y) continue;
            p = !1;
            break;
          }
          if (_) {
            if (!h(t, function (n, t) {
              if (!S(_, t) && (v === n || u(v, n, r, e, i))) return _.push(t);
            })) {
              p = !1;
              break;
            }
          } else if (v !== g && !u(v, g, r, e, i)) {
            p = !1;
            break;
          }
        }
        return i.delete(n), i.delete(t), p;
      }
      function _i(n, t, r, e, u, i, o) {
        switch (r) {
          case ct:
            if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
            n = n.buffer, t = t.buffer;
          case ft:
            return !(n.byteLength != t.byteLength || !i(new Rl(n), new Rl(t)));
          case Nn:
          case Pn:
          case Hn:
            return Gf(+n, +t);
          case Zn:
            return n.name == t.name && n.message == t.message;
          case nt:
          case rt:
            return n == t + "";
          case Gn:
            var f = M;
          case tt:
            var c = e & hn;
            if (f || (f = P), n.size != t.size && !c) return !1;
            var a = o.get(n);
            if (a) return a == t;
            e |= pn, o.set(n, t);
            var l = pi(f(n), f(t), e, u, i, o);
            return o.delete(n), l;
          case et:
            if (_s) return _s.call(n) == _s.call(t);
        }
        return !1;
      }
      function vi(n, t, r, e, u, i) {
        var o = r & hn,
          f = yi(n),
          c = f.length;
        if (c != yi(t).length && !o) return !1;
        for (var a = c; a--;) {
          var l = f[a];
          if (!(o ? l in t : bl.call(t, l))) return !1;
        }
        var s = i.get(n),
          h = i.get(t);
        if (s && h) return s == t && h == n;
        var p = !0;
        i.set(n, t), i.set(t, n);
        for (var _ = o; ++a < c;) {
          l = f[a];
          var v = n[l],
            g = t[l];
          if (e) var y = o ? e(g, v, l, t, n, i) : e(v, g, l, n, t, i);
          if (!(y === X ? v === g || u(v, g, r, e, i) : y)) {
            p = !1;
            break;
          }
          _ || (_ = "constructor" == l);
        }
        if (p && !_) {
          var d = n.constructor,
            b = t.constructor;
          d != b && "constructor" in n && "constructor" in t && !("function" == typeof d && d instanceof d && "function" == typeof b && b instanceof b) && (p = !1);
        }
        return i.delete(n), i.delete(t), p;
      }
      function gi(n) {
        return Ls(Vi(n, X, _o), n + "");
      }
      function yi(n) {
        return de(n, Pc, Is);
      }
      function di(n) {
        return de(n, qc, Rs);
      }
      function bi(n) {
        for (var t = n.name + "", r = fs[t], e = bl.call(fs, t) ? r.length : 0; e--;) {
          var u = r[e],
            i = u.func;
          if (null == i || i == n) return u.name;
        }
        return t;
      }
      function wi(n) {
        return (bl.call(Z, "placeholder") ? Z : n).placeholder;
      }
      function mi() {
        var n = Z.iteratee || Ca;
        return n = n === Ca ? De : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function xi(n, t) {
        var r = n.__data__;
        return Ti(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
      }
      function ji(n) {
        for (var t = Pc(n), r = t.length; r--;) {
          var e = t[r],
            u = n[e];
          t[r] = [e, u, Fi(u)];
        }
        return t;
      }
      function Ai(n, t) {
        var r = B(n, t);
        return Ue(r) ? r : X;
      }
      function ki(n) {
        var t = bl.call(n, Bl),
          r = n[Bl];
        try {
          n[Bl] = X;
          var e = !0;
        } catch (n) {}
        var u = xl.call(n);
        return e && (t ? n[Bl] = r : delete n[Bl]), u;
      }
      function Oi(n, t, r) {
        for (var e = -1, u = r.length; ++e < u;) {
          var i = r[e],
            o = i.size;
          switch (i.type) {
            case "drop":
              n += o;
              break;
            case "dropRight":
              t -= o;
              break;
            case "take":
              t = Hl(t, n + o);
              break;
            case "takeRight":
              n = Gl(n, t - o);
          }
        }
        return {
          start: n,
          end: t
        };
      }
      function Ii(n) {
        var t = n.match(Bt);
        return t ? t[1].split(Tt) : [];
      }
      function Ri(n, t, r) {
        t = ku(t, n);
        for (var e = -1, u = t.length, i = !1; ++e < u;) {
          var o = no(t[e]);
          if (!(i = null != n && r(n, o))) break;
          n = n[o];
        }
        return i || ++e != u ? i : (u = null == n ? 0 : n.length, !!u && oc(u) && Ci(o, u) && (bh(n) || dh(n)));
      }
      function zi(n) {
        var t = n.length,
          r = new n.constructor(t);
        return t && "string" == typeof n[0] && bl.call(n, "index") && (r.index = n.index, r.input = n.input), r;
      }
      function Ei(n) {
        return "function" != typeof n.constructor || Mi(n) ? {} : gs(El(n));
      }
      function Si(n, t, r) {
        var e = n.constructor;
        switch (t) {
          case ft:
            return Ru(n);
          case Nn:
          case Pn:
            return new e(+n);
          case ct:
            return zu(n, r);
          case at:
          case lt:
          case st:
          case ht:
          case pt:
          case _t:
          case vt:
          case gt:
          case yt:
            return Wu(n, r);
          case Gn:
            return new e();
          case Hn:
          case rt:
            return new e(n);
          case nt:
            return Eu(n);
          case tt:
            return new e();
          case et:
            return Su(n);
        }
      }
      function Wi(n, t) {
        var r = t.length;
        if (!r) return n;
        var e = r - 1;
        return t[e] = (r > 1 ? "& " : "") + t[e], t = t.join(r > 2 ? ", " : " "), n.replace(Ut, "{\n/* [wrapped with " + t + "] */\n");
      }
      function Li(n) {
        return bh(n) || dh(n) || !!(Cl && n && n[Cl]);
      }
      function Ci(n, t) {
        var r = typeof n;
        return t = null == t ? Wn : t, !!t && ("number" == r || "symbol" != r && Vt.test(n)) && n > -1 && n % 1 == 0 && n < t;
      }
      function Ui(n, t, r) {
        if (!fc(r)) return !1;
        var e = typeof t;
        return !!("number" == e ? Hf(r) && Ci(t, r.length) : "string" == e && t in r) && Gf(r[t], n);
      }
      function Bi(n, t) {
        if (bh(n)) return !1;
        var r = typeof n;
        return !("number" != r && "symbol" != r && "boolean" != r && null != n && !bc(n)) || zt.test(n) || !Rt.test(n) || null != t && n in ll(t);
      }
      function Ti(n) {
        var t = typeof n;
        return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== n : null === n;
      }
      function $i(n) {
        var t = bi(n),
          r = Z[t];
        if ("function" != typeof r || !(t in Ct.prototype)) return !1;
        if (n === r) return !0;
        var e = Os(r);
        return !!e && n === e[0];
      }
      function Di(n) {
        return !!ml && ml in n;
      }
      function Mi(n) {
        var t = n && n.constructor;
        return n === ("function" == typeof t && t.prototype || gl);
      }
      function Fi(n) {
        return n === n && !fc(n);
      }
      function Ni(n, t) {
        return function (r) {
          return null != r && r[n] === t && (t !== X || n in ll(r));
        };
      }
      function Pi(n) {
        var t = Cf(n, function (n) {
            return r.size === fn && r.clear(), n;
          }),
          r = t.cache;
        return t;
      }
      function qi(n, t) {
        var r = n[1],
          e = t[1],
          u = r | e,
          i = u < (_n | vn | mn),
          o = e == mn && r == yn || e == mn && r == xn && n[7].length <= t[8] || e == (mn | xn) && t[7].length <= t[8] && r == yn;
        if (!i && !o) return n;
        e & _n && (n[2] = t[2], u |= r & _n ? 0 : gn);
        var f = t[3];
        if (f) {
          var c = n[3];
          n[3] = c ? Uu(c, f, t[4]) : f, n[4] = c ? N(n[3], cn) : t[4];
        }
        return f = t[5], f && (c = n[5], n[5] = c ? Bu(c, f, t[6]) : f, n[6] = c ? N(n[5], cn) : t[6]), f = t[7], f && (n[7] = f), e & mn && (n[8] = null == n[8] ? t[8] : Hl(n[8], t[8])), null == n[9] && (n[9] = t[9]), n[0] = t[0], n[1] = u, n;
      }
      function Zi(n) {
        var t = [];
        if (null != n) for (var r in ll(n)) t.push(r);
        return t;
      }
      function Ki(n) {
        return xl.call(n);
      }
      function Vi(t, r, e) {
        return r = Gl(r === X ? t.length - 1 : r, 0), function () {
          for (var u = arguments, i = -1, o = Gl(u.length - r, 0), f = il(o); ++i < o;) f[i] = u[r + i];
          i = -1;
          for (var c = il(r + 1); ++i < r;) c[i] = u[i];
          return c[r] = e(f), n(t, this, c);
        };
      }
      function Gi(n, t) {
        return t.length < 2 ? n : _e(n, au(t, 0, -1));
      }
      function Hi(n, t) {
        for (var r = n.length, e = Hl(t.length, r), u = Tu(n); e--;) {
          var i = t[e];
          n[e] = Ci(i, r) ? u[i] : X;
        }
        return n;
      }
      function Ji(n, t) {
        if (("constructor" !== t || "function" != typeof n[t]) && "__proto__" != t) return n[t];
      }
      function Yi(n, t, r) {
        var e = t + "";
        return Ls(n, Wi(e, ro(Ii(e), r)));
      }
      function Qi(n) {
        var t = 0,
          r = 0;
        return function () {
          var e = Jl(),
            u = In - (e - r);
          if (r = e, u > 0) {
            if (++t >= On) return arguments[0];
          } else t = 0;
          return n.apply(X, arguments);
        };
      }
      function Xi(n, t) {
        var r = -1,
          e = n.length,
          u = e - 1;
        for (t = t === X ? e : t; ++r < t;) {
          var i = tu(r, u),
            o = n[i];
          n[i] = n[r], n[r] = o;
        }
        return n.length = t, n;
      }
      function no(n) {
        if ("string" == typeof n || bc(n)) return n;
        var t = n + "";
        return "0" == t && 1 / n == -Sn ? "-0" : t;
      }
      function to(n) {
        if (null != n) {
          try {
            return dl.call(n);
          } catch (n) {}
          try {
            return n + "";
          } catch (n) {}
        }
        return "";
      }
      function ro(n, t) {
        return r($n, function (r) {
          var e = "_." + r[0];
          t & r[1] && !o(n, e) && n.push(e);
        }), n.sort();
      }
      function eo(n) {
        if (n instanceof Ct) return n.clone();
        var t = new Y(n.__wrapped__, n.__chain__);
        return t.__actions__ = Tu(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
      }
      function uo(n, t, r) {
        t = (r ? Ui(n, t, r) : t === X) ? 1 : Gl(kc(t), 0);
        var e = null == n ? 0 : n.length;
        if (!e || t < 1) return [];
        for (var u = 0, i = 0, o = il(Fl(e / t)); u < e;) o[i++] = au(n, u, u += t);
        return o;
      }
      function io(n) {
        for (var t = -1, r = null == n ? 0 : n.length, e = 0, u = []; ++t < r;) {
          var i = n[t];
          i && (u[e++] = i);
        }
        return u;
      }
      function oo() {
        var n = arguments.length;
        if (!n) return [];
        for (var t = il(n - 1), r = arguments[0], e = n; e--;) t[e - 1] = arguments[e];
        return a(bh(r) ? Tu(r) : [r], ee(t, 1));
      }
      function fo(n, t, r) {
        var e = null == n ? 0 : n.length;
        return e ? (t = r || t === X ? 1 : kc(t), au(n, t < 0 ? 0 : t, e)) : [];
      }
      function co(n, t, r) {
        var e = null == n ? 0 : n.length;
        return e ? (t = r || t === X ? 1 : kc(t), t = e - t, au(n, 0, t < 0 ? 0 : t)) : [];
      }
      function ao(n, t) {
        return n && n.length ? bu(n, mi(t, 3), !0, !0) : [];
      }
      function lo(n, t) {
        return n && n.length ? bu(n, mi(t, 3), !0) : [];
      }
      function so(n, t, r, e) {
        var u = null == n ? 0 : n.length;
        return u ? (r && "number" != typeof r && Ui(n, t, r) && (r = 0, e = u), ne(n, t, r, e)) : [];
      }
      function ho(n, t, r) {
        var e = null == n ? 0 : n.length;
        if (!e) return -1;
        var u = null == r ? 0 : kc(r);
        return u < 0 && (u = Gl(e + u, 0)), g(n, mi(t, 3), u);
      }
      function po(n, t, r) {
        var e = null == n ? 0 : n.length;
        if (!e) return -1;
        var u = e - 1;
        return r !== X && (u = kc(r), u = r < 0 ? Gl(e + u, 0) : Hl(u, e - 1)), g(n, mi(t, 3), u, !0);
      }
      function _o(n) {
        return (null == n ? 0 : n.length) ? ee(n, 1) : [];
      }
      function vo(n) {
        return (null == n ? 0 : n.length) ? ee(n, Sn) : [];
      }
      function go(n, t) {
        return (null == n ? 0 : n.length) ? (t = t === X ? 1 : kc(t), ee(n, t)) : [];
      }
      function yo(n) {
        for (var t = -1, r = null == n ? 0 : n.length, e = {}; ++t < r;) {
          var u = n[t];
          e[u[0]] = u[1];
        }
        return e;
      }
      function bo(n) {
        return n && n.length ? n[0] : X;
      }
      function wo(n, t, r) {
        var e = null == n ? 0 : n.length;
        if (!e) return -1;
        var u = null == r ? 0 : kc(r);
        return u < 0 && (u = Gl(e + u, 0)), y(n, t, u);
      }
      function mo(n) {
        return (null == n ? 0 : n.length) ? au(n, 0, -1) : [];
      }
      function xo(n, t) {
        return null == n ? "" : Kl.call(n, t);
      }
      function jo(n) {
        var t = null == n ? 0 : n.length;
        return t ? n[t - 1] : X;
      }
      function Ao(n, t, r) {
        var e = null == n ? 0 : n.length;
        if (!e) return -1;
        var u = e;
        return r !== X && (u = kc(r), u = u < 0 ? Gl(e + u, 0) : Hl(u, e - 1)), t === t ? K(n, t, u) : g(n, b, u, !0);
      }
      function ko(n, t) {
        return n && n.length ? Ge(n, kc(t)) : X;
      }
      function Oo(n, t) {
        return n && n.length && t && t.length ? Xe(n, t) : n;
      }
      function Io(n, t, r) {
        return n && n.length && t && t.length ? Xe(n, t, mi(r, 2)) : n;
      }
      function Ro(n, t, r) {
        return n && n.length && t && t.length ? Xe(n, t, X, r) : n;
      }
      function zo(n, t) {
        var r = [];
        if (!n || !n.length) return r;
        var e = -1,
          u = [],
          i = n.length;
        for (t = mi(t, 3); ++e < i;) {
          var o = n[e];
          t(o, e, n) && (r.push(o), u.push(e));
        }
        return nu(n, u), r;
      }
      function Eo(n) {
        return null == n ? n : Xl.call(n);
      }
      function So(n, t, r) {
        var e = null == n ? 0 : n.length;
        return e ? (r && "number" != typeof r && Ui(n, t, r) ? (t = 0, r = e) : (t = null == t ? 0 : kc(t), r = r === X ? e : kc(r)), au(n, t, r)) : [];
      }
      function Wo(n, t) {
        return su(n, t);
      }
      function Lo(n, t, r) {
        return hu(n, t, mi(r, 2));
      }
      function Co(n, t) {
        var r = null == n ? 0 : n.length;
        if (r) {
          var e = su(n, t);
          if (e < r && Gf(n[e], t)) return e;
        }
        return -1;
      }
      function Uo(n, t) {
        return su(n, t, !0);
      }
      function Bo(n, t, r) {
        return hu(n, t, mi(r, 2), !0);
      }
      function To(n, t) {
        if (null == n ? 0 : n.length) {
          var r = su(n, t, !0) - 1;
          if (Gf(n[r], t)) return r;
        }
        return -1;
      }
      function $o(n) {
        return n && n.length ? pu(n) : [];
      }
      function Do(n, t) {
        return n && n.length ? pu(n, mi(t, 2)) : [];
      }
      function Mo(n) {
        var t = null == n ? 0 : n.length;
        return t ? au(n, 1, t) : [];
      }
      function Fo(n, t, r) {
        return n && n.length ? (t = r || t === X ? 1 : kc(t), au(n, 0, t < 0 ? 0 : t)) : [];
      }
      function No(n, t, r) {
        var e = null == n ? 0 : n.length;
        return e ? (t = r || t === X ? 1 : kc(t), t = e - t, au(n, t < 0 ? 0 : t, e)) : [];
      }
      function Po(n, t) {
        return n && n.length ? bu(n, mi(t, 3), !1, !0) : [];
      }
      function qo(n, t) {
        return n && n.length ? bu(n, mi(t, 3)) : [];
      }
      function Zo(n) {
        return n && n.length ? gu(n) : [];
      }
      function Ko(n, t) {
        return n && n.length ? gu(n, mi(t, 2)) : [];
      }
      function Vo(n, t) {
        return t = "function" == typeof t ? t : X, n && n.length ? gu(n, X, t) : [];
      }
      function Go(n) {
        if (!n || !n.length) return [];
        var t = 0;
        return n = i(n, function (n) {
          if (Jf(n)) return t = Gl(n.length, t), !0;
        }), O(t, function (t) {
          return c(n, m(t));
        });
      }
      function Ho(t, r) {
        if (!t || !t.length) return [];
        var e = Go(t);
        return null == r ? e : c(e, function (t) {
          return n(r, X, t);
        });
      }
      function Jo(n, t) {
        return xu(n || [], t || [], Sr);
      }
      function Yo(n, t) {
        return xu(n || [], t || [], fu);
      }
      function Qo(n) {
        var t = Z(n);
        return t.__chain__ = !0, t;
      }
      function Xo(n, t) {
        return t(n), n;
      }
      function nf(n, t) {
        return t(n);
      }
      function tf() {
        return Qo(this);
      }
      function rf() {
        return new Y(this.value(), this.__chain__);
      }
      function ef() {
        this.__values__ === X && (this.__values__ = jc(this.value()));
        var n = this.__index__ >= this.__values__.length;
        return {
          done: n,
          value: n ? X : this.__values__[this.__index__++]
        };
      }
      function uf() {
        return this;
      }
      function of(n) {
        for (var t, r = this; r instanceof J;) {
          var e = eo(r);
          e.__index__ = 0, e.__values__ = X, t ? u.__wrapped__ = e : t = e;
          var u = e;
          r = r.__wrapped__;
        }
        return u.__wrapped__ = n, t;
      }
      function ff() {
        var n = this.__wrapped__;
        if (n instanceof Ct) {
          var t = n;
          return this.__actions__.length && (t = new Ct(this)), t = t.reverse(), t.__actions__.push({
            func: nf,
            args: [Eo],
            thisArg: X
          }), new Y(t, this.__chain__);
        }
        return this.thru(Eo);
      }
      function cf() {
        return wu(this.__wrapped__, this.__actions__);
      }
      function af(n, t, r) {
        var e = bh(n) ? u : Jr;
        return r && Ui(n, t, r) && (t = X), e(n, mi(t, 3));
      }
      function lf(n, t) {
        return (bh(n) ? i : te)(n, mi(t, 3));
      }
      function sf(n, t) {
        return ee(yf(n, t), 1);
      }
      function hf(n, t) {
        return ee(yf(n, t), Sn);
      }
      function pf(n, t, r) {
        return r = r === X ? 1 : kc(r), ee(yf(n, t), r);
      }
      function _f(n, t) {
        return (bh(n) ? r : ys)(n, mi(t, 3));
      }
      function vf(n, t) {
        return (bh(n) ? e : ds)(n, mi(t, 3));
      }
      function gf(n, t, r, e) {
        n = Hf(n) ? n : ra(n), r = r && !e ? kc(r) : 0;
        var u = n.length;
        return r < 0 && (r = Gl(u + r, 0)), dc(n) ? r <= u && n.indexOf(t, r) > -1 : !!u && y(n, t, r) > -1;
      }
      function yf(n, t) {
        return (bh(n) ? c : Pe)(n, mi(t, 3));
      }
      function df(n, t, r, e) {
        return null == n ? [] : (bh(t) || (t = null == t ? [] : [t]), r = e ? X : r, bh(r) || (r = null == r ? [] : [r]), He(n, t, r));
      }
      function bf(n, t, r) {
        var e = bh(n) ? l : j,
          u = arguments.length < 3;
        return e(n, mi(t, 4), r, u, ys);
      }
      function wf(n, t, r) {
        var e = bh(n) ? s : j,
          u = arguments.length < 3;
        return e(n, mi(t, 4), r, u, ds);
      }
      function mf(n, t) {
        return (bh(n) ? i : te)(n, Uf(mi(t, 3)));
      }
      function xf(n) {
        return (bh(n) ? Ir : iu)(n);
      }
      function jf(n, t, r) {
        return t = (r ? Ui(n, t, r) : t === X) ? 1 : kc(t), (bh(n) ? Rr : ou)(n, t);
      }
      function Af(n) {
        return (bh(n) ? zr : cu)(n);
      }
      function kf(n) {
        if (null == n) return 0;
        if (Hf(n)) return dc(n) ? V(n) : n.length;
        var t = zs(n);
        return t == Gn || t == tt ? n.size : Me(n).length;
      }
      function Of(n, t, r) {
        var e = bh(n) ? h : lu;
        return r && Ui(n, t, r) && (t = X), e(n, mi(t, 3));
      }
      function If(n, t) {
        if ("function" != typeof t) throw new pl(en);
        return n = kc(n), function () {
          if (--n < 1) return t.apply(this, arguments);
        };
      }
      function Rf(n, t, r) {
        return t = r ? X : t, t = n && null == t ? n.length : t, ai(n, mn, X, X, X, X, t);
      }
      function zf(n, t) {
        var r;
        if ("function" != typeof t) throw new pl(en);
        return n = kc(n), function () {
          return --n > 0 && (r = t.apply(this, arguments)), n <= 1 && (t = X), r;
        };
      }
      function Ef(n, t, r) {
        t = r ? X : t;
        var e = ai(n, yn, X, X, X, X, X, t);
        return e.placeholder = Ef.placeholder, e;
      }
      function Sf(n, t, r) {
        t = r ? X : t;
        var e = ai(n, dn, X, X, X, X, X, t);
        return e.placeholder = Sf.placeholder, e;
      }
      function Wf(n, t, r) {
        function e(t) {
          var r = h,
            e = p;
          return h = p = X, d = t, v = n.apply(e, r);
        }
        function u(n) {
          return d = n, g = Ws(f, t), b ? e(n) : v;
        }
        function i(n) {
          var r = n - y,
            e = n - d,
            u = t - r;
          return w ? Hl(u, _ - e) : u;
        }
        function o(n) {
          var r = n - y,
            e = n - d;
          return y === X || r >= t || r < 0 || w && e >= _;
        }
        function f() {
          var n = fh();
          return o(n) ? c(n) : (g = Ws(f, i(n)), X);
        }
        function c(n) {
          return g = X, m && h ? e(n) : (h = p = X, v);
        }
        function a() {
          g !== X && As(g), d = 0, h = y = p = g = X;
        }
        function l() {
          return g === X ? v : c(fh());
        }
        function s() {
          var n = fh(),
            r = o(n);
          if (h = arguments, p = this, y = n, r) {
            if (g === X) return u(y);
            if (w) return As(g), g = Ws(f, t), e(y);
          }
          return g === X && (g = Ws(f, t)), v;
        }
        var h,
          p,
          _,
          v,
          g,
          y,
          d = 0,
          b = !1,
          w = !1,
          m = !0;
        if ("function" != typeof n) throw new pl(en);
        return t = Ic(t) || 0, fc(r) && (b = !!r.leading, w = "maxWait" in r, _ = w ? Gl(Ic(r.maxWait) || 0, t) : _, m = "trailing" in r ? !!r.trailing : m), s.cancel = a, s.flush = l, s;
      }
      function Lf(n) {
        return ai(n, jn);
      }
      function Cf(n, t) {
        if ("function" != typeof n || null != t && "function" != typeof t) throw new pl(en);
        var r = function () {
          var e = arguments,
            u = t ? t.apply(this, e) : e[0],
            i = r.cache;
          if (i.has(u)) return i.get(u);
          var o = n.apply(this, e);
          return r.cache = i.set(u, o) || i, o;
        };
        return r.cache = new (Cf.Cache || sr)(), r;
      }
      function Uf(n) {
        if ("function" != typeof n) throw new pl(en);
        return function () {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, t[0]);
            case 2:
              return !n.call(this, t[0], t[1]);
            case 3:
              return !n.call(this, t[0], t[1], t[2]);
          }
          return !n.apply(this, t);
        };
      }
      function Bf(n) {
        return zf(2, n);
      }
      function Tf(n, t) {
        if ("function" != typeof n) throw new pl(en);
        return t = t === X ? t : kc(t), uu(n, t);
      }
      function $f(t, r) {
        if ("function" != typeof t) throw new pl(en);
        return r = null == r ? 0 : Gl(kc(r), 0), uu(function (e) {
          var u = e[r],
            i = Ou(e, 0, r);
          return u && a(i, u), n(t, this, i);
        });
      }
      function Df(n, t, r) {
        var e = !0,
          u = !0;
        if ("function" != typeof n) throw new pl(en);
        return fc(r) && (e = "leading" in r ? !!r.leading : e, u = "trailing" in r ? !!r.trailing : u), Wf(n, t, {
          leading: e,
          maxWait: t,
          trailing: u
        });
      }
      function Mf(n) {
        return Rf(n, 1);
      }
      function Ff(n, t) {
        return ph(Au(t), n);
      }
      function Nf() {
        if (!arguments.length) return [];
        var n = arguments[0];
        return bh(n) ? n : [n];
      }
      function Pf(n) {
        return Fr(n, sn);
      }
      function qf(n, t) {
        return t = "function" == typeof t ? t : X, Fr(n, sn, t);
      }
      function Zf(n) {
        return Fr(n, an | sn);
      }
      function Kf(n, t) {
        return t = "function" == typeof t ? t : X, Fr(n, an | sn, t);
      }
      function Vf(n, t) {
        return null == t || Pr(n, t, Pc(t));
      }
      function Gf(n, t) {
        return n === t || n !== n && t !== t;
      }
      function Hf(n) {
        return null != n && oc(n.length) && !uc(n);
      }
      function Jf(n) {
        return cc(n) && Hf(n);
      }
      function Yf(n) {
        return n === !0 || n === !1 || cc(n) && we(n) == Nn;
      }
      function Qf(n) {
        return cc(n) && 1 === n.nodeType && !gc(n);
      }
      function Xf(n) {
        if (null == n) return !0;
        if (Hf(n) && (bh(n) || "string" == typeof n || "function" == typeof n.splice || mh(n) || Oh(n) || dh(n))) return !n.length;
        var t = zs(n);
        if (t == Gn || t == tt) return !n.size;
        if (Mi(n)) return !Me(n).length;
        for (var r in n) if (bl.call(n, r)) return !1;
        return !0;
      }
      function nc(n, t) {
        return Se(n, t);
      }
      function tc(n, t, r) {
        r = "function" == typeof r ? r : X;
        var e = r ? r(n, t) : X;
        return e === X ? Se(n, t, X, r) : !!e;
      }
      function rc(n) {
        if (!cc(n)) return !1;
        var t = we(n);
        return t == Zn || t == qn || "string" == typeof n.message && "string" == typeof n.name && !gc(n);
      }
      function ec(n) {
        return "number" == typeof n && Zl(n);
      }
      function uc(n) {
        if (!fc(n)) return !1;
        var t = we(n);
        return t == Kn || t == Vn || t == Fn || t == Xn;
      }
      function ic(n) {
        return "number" == typeof n && n == kc(n);
      }
      function oc(n) {
        return "number" == typeof n && n > -1 && n % 1 == 0 && n <= Wn;
      }
      function fc(n) {
        var t = typeof n;
        return null != n && ("object" == t || "function" == t);
      }
      function cc(n) {
        return null != n && "object" == typeof n;
      }
      function ac(n, t) {
        return n === t || Ce(n, t, ji(t));
      }
      function lc(n, t, r) {
        return r = "function" == typeof r ? r : X, Ce(n, t, ji(t), r);
      }
      function sc(n) {
        return vc(n) && n != +n;
      }
      function hc(n) {
        if (Es(n)) throw new fl(rn);
        return Ue(n);
      }
      function pc(n) {
        return null === n;
      }
      function _c(n) {
        return null == n;
      }
      function vc(n) {
        return "number" == typeof n || cc(n) && we(n) == Hn;
      }
      function gc(n) {
        if (!cc(n) || we(n) != Yn) return !1;
        var t = El(n);
        if (null === t) return !0;
        var r = bl.call(t, "constructor") && t.constructor;
        return "function" == typeof r && r instanceof r && dl.call(r) == jl;
      }
      function yc(n) {
        return ic(n) && n >= -Wn && n <= Wn;
      }
      function dc(n) {
        return "string" == typeof n || !bh(n) && cc(n) && we(n) == rt;
      }
      function bc(n) {
        return "symbol" == typeof n || cc(n) && we(n) == et;
      }
      function wc(n) {
        return n === X;
      }
      function mc(n) {
        return cc(n) && zs(n) == it;
      }
      function xc(n) {
        return cc(n) && we(n) == ot;
      }
      function jc(n) {
        if (!n) return [];
        if (Hf(n)) return dc(n) ? G(n) : Tu(n);
        if (Ul && n[Ul]) return D(n[Ul]());
        var t = zs(n);
        return (t == Gn ? M : t == tt ? P : ra)(n);
      }
      function Ac(n) {
        if (!n) return 0 === n ? n : 0;
        if (n = Ic(n), n === Sn || n === -Sn) {
          return (n < 0 ? -1 : 1) * Ln;
        }
        return n === n ? n : 0;
      }
      function kc(n) {
        var t = Ac(n),
          r = t % 1;
        return t === t ? r ? t - r : t : 0;
      }
      function Oc(n) {
        return n ? Mr(kc(n), 0, Un) : 0;
      }
      function Ic(n) {
        if ("number" == typeof n) return n;
        if (bc(n)) return Cn;
        if (fc(n)) {
          var t = "function" == typeof n.valueOf ? n.valueOf() : n;
          n = fc(t) ? t + "" : t;
        }
        if ("string" != typeof n) return 0 === n ? n : +n;
        n = R(n);
        var r = qt.test(n);
        return r || Kt.test(n) ? Xr(n.slice(2), r ? 2 : 8) : Pt.test(n) ? Cn : +n;
      }
      function Rc(n) {
        return $u(n, qc(n));
      }
      function zc(n) {
        return n ? Mr(kc(n), -Wn, Wn) : 0 === n ? n : 0;
      }
      function Ec(n) {
        return null == n ? "" : vu(n);
      }
      function Sc(n, t) {
        var r = gs(n);
        return null == t ? r : Cr(r, t);
      }
      function Wc(n, t) {
        return v(n, mi(t, 3), ue);
      }
      function Lc(n, t) {
        return v(n, mi(t, 3), oe);
      }
      function Cc(n, t) {
        return null == n ? n : bs(n, mi(t, 3), qc);
      }
      function Uc(n, t) {
        return null == n ? n : ws(n, mi(t, 3), qc);
      }
      function Bc(n, t) {
        return n && ue(n, mi(t, 3));
      }
      function Tc(n, t) {
        return n && oe(n, mi(t, 3));
      }
      function $c(n) {
        return null == n ? [] : fe(n, Pc(n));
      }
      function Dc(n) {
        return null == n ? [] : fe(n, qc(n));
      }
      function Mc(n, t, r) {
        var e = null == n ? X : _e(n, t);
        return e === X ? r : e;
      }
      function Fc(n, t) {
        return null != n && Ri(n, t, xe);
      }
      function Nc(n, t) {
        return null != n && Ri(n, t, je);
      }
      function Pc(n) {
        return Hf(n) ? Or(n) : Me(n);
      }
      function qc(n) {
        return Hf(n) ? Or(n, !0) : Fe(n);
      }
      function Zc(n, t) {
        var r = {};
        return t = mi(t, 3), ue(n, function (n, e, u) {
          Br(r, t(n, e, u), n);
        }), r;
      }
      function Kc(n, t) {
        var r = {};
        return t = mi(t, 3), ue(n, function (n, e, u) {
          Br(r, e, t(n, e, u));
        }), r;
      }
      function Vc(n, t) {
        return Gc(n, Uf(mi(t)));
      }
      function Gc(n, t) {
        if (null == n) return {};
        var r = c(di(n), function (n) {
          return [n];
        });
        return t = mi(t), Ye(n, r, function (n, r) {
          return t(n, r[0]);
        });
      }
      function Hc(n, t, r) {
        t = ku(t, n);
        var e = -1,
          u = t.length;
        for (u || (u = 1, n = X); ++e < u;) {
          var i = null == n ? X : n[no(t[e])];
          i === X && (e = u, i = r), n = uc(i) ? i.call(n) : i;
        }
        return n;
      }
      function Jc(n, t, r) {
        return null == n ? n : fu(n, t, r);
      }
      function Yc(n, t, r, e) {
        return e = "function" == typeof e ? e : X, null == n ? n : fu(n, t, r, e);
      }
      function Qc(n, t, e) {
        var u = bh(n),
          i = u || mh(n) || Oh(n);
        if (t = mi(t, 4), null == e) {
          var o = n && n.constructor;
          e = i ? u ? new o() : [] : fc(n) && uc(o) ? gs(El(n)) : {};
        }
        return (i ? r : ue)(n, function (n, r, u) {
          return t(e, n, r, u);
        }), e;
      }
      function Xc(n, t) {
        return null == n || yu(n, t);
      }
      function na(n, t, r) {
        return null == n ? n : du(n, t, Au(r));
      }
      function ta(n, t, r, e) {
        return e = "function" == typeof e ? e : X, null == n ? n : du(n, t, Au(r), e);
      }
      function ra(n) {
        return null == n ? [] : E(n, Pc(n));
      }
      function ea(n) {
        return null == n ? [] : E(n, qc(n));
      }
      function ua(n, t, r) {
        return r === X && (r = t, t = X), r !== X && (r = Ic(r), r = r === r ? r : 0), t !== X && (t = Ic(t), t = t === t ? t : 0), Mr(Ic(n), t, r);
      }
      function ia(n, t, r) {
        return t = Ac(t), r === X ? (r = t, t = 0) : r = Ac(r), n = Ic(n), Ae(n, t, r);
      }
      function oa(n, t, r) {
        if (r && "boolean" != typeof r && Ui(n, t, r) && (t = r = X), r === X && ("boolean" == typeof t ? (r = t, t = X) : "boolean" == typeof n && (r = n, n = X)), n === X && t === X ? (n = 0, t = 1) : (n = Ac(n), t === X ? (t = n, n = 0) : t = Ac(t)), n > t) {
          var e = n;
          n = t, t = e;
        }
        if (r || n % 1 || t % 1) {
          var u = Ql();
          return Hl(n + u * (t - n + Qr("1e-" + ((u + "").length - 1))), t);
        }
        return tu(n, t);
      }
      function fa(n) {
        return Qh(Ec(n).toLowerCase());
      }
      function ca(n) {
        return n = Ec(n), n && n.replace(Gt, ve).replace(Dr, "");
      }
      function aa(n, t, r) {
        n = Ec(n), t = vu(t);
        var e = n.length;
        r = r === X ? e : Mr(kc(r), 0, e);
        var u = r;
        return r -= t.length, r >= 0 && n.slice(r, u) == t;
      }
      function la(n) {
        return n = Ec(n), n && At.test(n) ? n.replace(xt, ge) : n;
      }
      function sa(n) {
        return n = Ec(n), n && Wt.test(n) ? n.replace(St, "\\$&") : n;
      }
      function ha(n, t, r) {
        n = Ec(n), t = kc(t);
        var e = t ? V(n) : 0;
        if (!t || e >= t) return n;
        var u = (t - e) / 2;
        return ri(Nl(u), r) + n + ri(Fl(u), r);
      }
      function pa(n, t, r) {
        n = Ec(n), t = kc(t);
        var e = t ? V(n) : 0;
        return t && e < t ? n + ri(t - e, r) : n;
      }
      function _a(n, t, r) {
        n = Ec(n), t = kc(t);
        var e = t ? V(n) : 0;
        return t && e < t ? ri(t - e, r) + n : n;
      }
      function va(n, t, r) {
        return r || null == t ? t = 0 : t && (t = +t), Yl(Ec(n).replace(Lt, ""), t || 0);
      }
      function ga(n, t, r) {
        return t = (r ? Ui(n, t, r) : t === X) ? 1 : kc(t), eu(Ec(n), t);
      }
      function ya() {
        var n = arguments,
          t = Ec(n[0]);
        return n.length < 3 ? t : t.replace(n[1], n[2]);
      }
      function da(n, t, r) {
        return r && "number" != typeof r && Ui(n, t, r) && (t = r = X), (r = r === X ? Un : r >>> 0) ? (n = Ec(n), n && ("string" == typeof t || null != t && !Ah(t)) && (t = vu(t), !t && T(n)) ? Ou(G(n), 0, r) : n.split(t, r)) : [];
      }
      function ba(n, t, r) {
        return n = Ec(n), r = null == r ? 0 : Mr(kc(r), 0, n.length), t = vu(t), n.slice(r, r + t.length) == t;
      }
      function wa(n, t, r) {
        var e = Z.templateSettings;
        r && Ui(n, t, r) && (t = X), n = Ec(n), t = Sh({}, t, e, li);
        var u,
          i,
          o = Sh({}, t.imports, e.imports, li),
          f = Pc(o),
          c = E(o, f),
          a = 0,
          l = t.interpolate || Ht,
          s = "__p += '",
          h = sl((t.escape || Ht).source + "|" + l.source + "|" + (l === It ? Ft : Ht).source + "|" + (t.evaluate || Ht).source + "|$", "g"),
          p = "//# sourceURL=" + (bl.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Zr + "]") + "\n";
        n.replace(h, function (t, r, e, o, f, c) {
          return e || (e = o), s += n.slice(a, c).replace(Jt, U), r && (u = !0, s += "' +\n__e(" + r + ") +\n'"), f && (i = !0, s += "';\n" + f + ";\n__p += '"), e && (s += "' +\n((__t = (" + e + ")) == null ? '' : __t) +\n'"), a = c + t.length, t;
        }), s += "';\n";
        var _ = bl.call(t, "variable") && t.variable;
        if (_) {
          if (Dt.test(_)) throw new fl(un);
        } else s = "with (obj) {\n" + s + "\n}\n";
        s = (i ? s.replace(dt, "") : s).replace(bt, "$1").replace(wt, "$1;"), s = "function(" + (_ || "obj") + ") {\n" + (_ ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (u ? ", __e = _.escape" : "") + (i ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + s + "return __p\n}";
        var v = Xh(function () {
          return cl(f, p + "return " + s).apply(X, c);
        });
        if (v.source = s, rc(v)) throw v;
        return v;
      }
      function ma(n) {
        return Ec(n).toLowerCase();
      }
      function xa(n) {
        return Ec(n).toUpperCase();
      }
      function ja(n, t, r) {
        if (n = Ec(n), n && (r || t === X)) return R(n);
        if (!n || !(t = vu(t))) return n;
        var e = G(n),
          u = G(t);
        return Ou(e, W(e, u), L(e, u) + 1).join("");
      }
      function Aa(n, t, r) {
        if (n = Ec(n), n && (r || t === X)) return n.slice(0, H(n) + 1);
        if (!n || !(t = vu(t))) return n;
        var e = G(n);
        return Ou(e, 0, L(e, G(t)) + 1).join("");
      }
      function ka(n, t, r) {
        if (n = Ec(n), n && (r || t === X)) return n.replace(Lt, "");
        if (!n || !(t = vu(t))) return n;
        var e = G(n);
        return Ou(e, W(e, G(t))).join("");
      }
      function Oa(n, t) {
        var r = An,
          e = kn;
        if (fc(t)) {
          var u = "separator" in t ? t.separator : u;
          r = "length" in t ? kc(t.length) : r, e = "omission" in t ? vu(t.omission) : e;
        }
        n = Ec(n);
        var i = n.length;
        if (T(n)) {
          var o = G(n);
          i = o.length;
        }
        if (r >= i) return n;
        var f = r - V(e);
        if (f < 1) return e;
        var c = o ? Ou(o, 0, f).join("") : n.slice(0, f);
        if (u === X) return c + e;
        if (o && (f += c.length - f), Ah(u)) {
          if (n.slice(f).search(u)) {
            var a,
              l = c;
            for (u.global || (u = sl(u.source, Ec(Nt.exec(u)) + "g")), u.lastIndex = 0; a = u.exec(l);) var s = a.index;
            c = c.slice(0, s === X ? f : s);
          }
        } else if (n.indexOf(vu(u), f) != f) {
          var h = c.lastIndexOf(u);
          h > -1 && (c = c.slice(0, h));
        }
        return c + e;
      }
      function Ia(n) {
        return n = Ec(n), n && jt.test(n) ? n.replace(mt, ye) : n;
      }
      function Ra(n, t, r) {
        return n = Ec(n), t = r ? X : t, t === X ? $(n) ? Q(n) : _(n) : n.match(t) || [];
      }
      function za(t) {
        var r = null == t ? 0 : t.length,
          e = mi();
        return t = r ? c(t, function (n) {
          if ("function" != typeof n[1]) throw new pl(en);
          return [e(n[0]), n[1]];
        }) : [], uu(function (e) {
          for (var u = -1; ++u < r;) {
            var i = t[u];
            if (n(i[0], this, e)) return n(i[1], this, e);
          }
        });
      }
      function Ea(n) {
        return Nr(Fr(n, an));
      }
      function Sa(n) {
        return function () {
          return n;
        };
      }
      function Wa(n, t) {
        return null == n || n !== n ? t : n;
      }
      function La(n) {
        return n;
      }
      function Ca(n) {
        return De("function" == typeof n ? n : Fr(n, an));
      }
      function Ua(n) {
        return qe(Fr(n, an));
      }
      function Ba(n, t) {
        return Ze(n, Fr(t, an));
      }
      function Ta(n, t, e) {
        var u = Pc(t),
          i = fe(t, u);
        null != e || fc(t) && (i.length || !u.length) || (e = t, t = n, n = this, i = fe(t, Pc(t)));
        var o = !(fc(e) && "chain" in e && !e.chain),
          f = uc(n);
        return r(i, function (r) {
          var e = t[r];
          n[r] = e, f && (n.prototype[r] = function () {
            var t = this.__chain__;
            if (o || t) {
              var r = n(this.__wrapped__);
              return (r.__actions__ = Tu(this.__actions__)).push({
                func: e,
                args: arguments,
                thisArg: n
              }), r.__chain__ = t, r;
            }
            return e.apply(n, a([this.value()], arguments));
          });
        }), n;
      }
      function $a() {
        return re._ === this && (re._ = Al), this;
      }
      function Da() {}
      function Ma(n) {
        return n = kc(n), uu(function (t) {
          return Ge(t, n);
        });
      }
      function Fa(n) {
        return Bi(n) ? m(no(n)) : Qe(n);
      }
      function Na(n) {
        return function (t) {
          return null == n ? X : _e(n, t);
        };
      }
      function Pa() {
        return [];
      }
      function qa() {
        return !1;
      }
      function Za() {
        return {};
      }
      function Ka() {
        return "";
      }
      function Va() {
        return !0;
      }
      function Ga(n, t) {
        if (n = kc(n), n < 1 || n > Wn) return [];
        var r = Un,
          e = Hl(n, Un);
        t = mi(t), n -= Un;
        for (var u = O(e, t); ++r < n;) t(r);
        return u;
      }
      function Ha(n) {
        return bh(n) ? c(n, no) : bc(n) ? [n] : Tu(Cs(Ec(n)));
      }
      function Ja(n) {
        var t = ++wl;
        return Ec(n) + t;
      }
      function Ya(n) {
        return n && n.length ? Yr(n, La, me) : X;
      }
      function Qa(n, t) {
        return n && n.length ? Yr(n, mi(t, 2), me) : X;
      }
      function Xa(n) {
        return w(n, La);
      }
      function nl(n, t) {
        return w(n, mi(t, 2));
      }
      function tl(n) {
        return n && n.length ? Yr(n, La, Ne) : X;
      }
      function rl(n, t) {
        return n && n.length ? Yr(n, mi(t, 2), Ne) : X;
      }
      function el(n) {
        return n && n.length ? k(n, La) : 0;
      }
      function ul(n, t) {
        return n && n.length ? k(n, mi(t, 2)) : 0;
      }
      x = null == x ? re : be.defaults(re.Object(), x, be.pick(re, qr));
      var il = x.Array,
        ol = x.Date,
        fl = x.Error,
        cl = x.Function,
        al = x.Math,
        ll = x.Object,
        sl = x.RegExp,
        hl = x.String,
        pl = x.TypeError,
        _l = il.prototype,
        vl = cl.prototype,
        gl = ll.prototype,
        yl = x["__core-js_shared__"],
        dl = vl.toString,
        bl = gl.hasOwnProperty,
        wl = 0,
        ml = function () {
          var n = /[^.]+$/.exec(yl && yl.keys && yl.keys.IE_PROTO || "");
          return n ? "Symbol(src)_1." + n : "";
        }(),
        xl = gl.toString,
        jl = dl.call(ll),
        Al = re._,
        kl = sl("^" + dl.call(bl).replace(St, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        Ol = ie ? x.Buffer : X,
        Il = x.Symbol,
        Rl = x.Uint8Array,
        zl = Ol ? Ol.allocUnsafe : X,
        El = F(ll.getPrototypeOf, ll),
        Sl = ll.create,
        Wl = gl.propertyIsEnumerable,
        Ll = _l.splice,
        Cl = Il ? Il.isConcatSpreadable : X,
        Ul = Il ? Il.iterator : X,
        Bl = Il ? Il.toStringTag : X,
        Tl = function () {
          try {
            var n = Ai(ll, "defineProperty");
            return n({}, "", {}), n;
          } catch (n) {}
        }(),
        $l = x.clearTimeout !== re.clearTimeout && x.clearTimeout,
        Dl = ol && ol.now !== re.Date.now && ol.now,
        Ml = x.setTimeout !== re.setTimeout && x.setTimeout,
        Fl = al.ceil,
        Nl = al.floor,
        Pl = ll.getOwnPropertySymbols,
        ql = Ol ? Ol.isBuffer : X,
        Zl = x.isFinite,
        Kl = _l.join,
        Vl = F(ll.keys, ll),
        Gl = al.max,
        Hl = al.min,
        Jl = ol.now,
        Yl = x.parseInt,
        Ql = al.random,
        Xl = _l.reverse,
        ns = Ai(x, "DataView"),
        ts = Ai(x, "Map"),
        rs = Ai(x, "Promise"),
        es = Ai(x, "Set"),
        us = Ai(x, "WeakMap"),
        is = Ai(ll, "create"),
        os = us && new us(),
        fs = {},
        cs = to(ns),
        as = to(ts),
        ls = to(rs),
        ss = to(es),
        hs = to(us),
        ps = Il ? Il.prototype : X,
        _s = ps ? ps.valueOf : X,
        vs = ps ? ps.toString : X,
        gs = function () {
          function n() {}
          return function (t) {
            if (!fc(t)) return {};
            if (Sl) return Sl(t);
            n.prototype = t;
            var r = new n();
            return n.prototype = X, r;
          };
        }();
      Z.templateSettings = {
        escape: kt,
        evaluate: Ot,
        interpolate: It,
        variable: "",
        imports: {
          _: Z
        }
      }, Z.prototype = J.prototype, Z.prototype.constructor = Z, Y.prototype = gs(J.prototype), Y.prototype.constructor = Y, Ct.prototype = gs(J.prototype), Ct.prototype.constructor = Ct, Xt.prototype.clear = nr, Xt.prototype.delete = tr, Xt.prototype.get = rr, Xt.prototype.has = er, Xt.prototype.set = ur, ir.prototype.clear = or, ir.prototype.delete = fr, ir.prototype.get = cr, ir.prototype.has = ar, ir.prototype.set = lr, sr.prototype.clear = hr, sr.prototype.delete = pr, sr.prototype.get = _r, sr.prototype.has = vr, sr.prototype.set = gr, yr.prototype.add = yr.prototype.push = dr, yr.prototype.has = br, wr.prototype.clear = mr, wr.prototype.delete = xr, wr.prototype.get = jr, wr.prototype.has = Ar, wr.prototype.set = kr;
      var ys = Pu(ue),
        ds = Pu(oe, !0),
        bs = qu(),
        ws = qu(!0),
        ms = os ? function (n, t) {
          return os.set(n, t), n;
        } : La,
        xs = Tl ? function (n, t) {
          return Tl(n, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Sa(t),
            writable: !0
          });
        } : La,
        js = uu,
        As = $l || function (n) {
          return re.clearTimeout(n);
        },
        ks = es && 1 / P(new es([, -0]))[1] == Sn ? function (n) {
          return new es(n);
        } : Da,
        Os = os ? function (n) {
          return os.get(n);
        } : Da,
        Is = Pl ? function (n) {
          return null == n ? [] : (n = ll(n), i(Pl(n), function (t) {
            return Wl.call(n, t);
          }));
        } : Pa,
        Rs = Pl ? function (n) {
          for (var t = []; n;) a(t, Is(n)), n = El(n);
          return t;
        } : Pa,
        zs = we;
      (ns && zs(new ns(new ArrayBuffer(1))) != ct || ts && zs(new ts()) != Gn || rs && zs(rs.resolve()) != Qn || es && zs(new es()) != tt || us && zs(new us()) != it) && (zs = function (n) {
        var t = we(n),
          r = t == Yn ? n.constructor : X,
          e = r ? to(r) : "";
        if (e) switch (e) {
          case cs:
            return ct;
          case as:
            return Gn;
          case ls:
            return Qn;
          case ss:
            return tt;
          case hs:
            return it;
        }
        return t;
      });
      var Es = yl ? uc : qa,
        Ss = Qi(ms),
        Ws = Ml || function (n, t) {
          return re.setTimeout(n, t);
        },
        Ls = Qi(xs),
        Cs = Pi(function (n) {
          var t = [];
          return 46 === n.charCodeAt(0) && t.push(""), n.replace(Et, function (n, r, e, u) {
            t.push(e ? u.replace(Mt, "$1") : r || n);
          }), t;
        }),
        Us = uu(function (n, t) {
          return Jf(n) ? Hr(n, ee(t, 1, Jf, !0)) : [];
        }),
        Bs = uu(function (n, t) {
          var r = jo(t);
          return Jf(r) && (r = X), Jf(n) ? Hr(n, ee(t, 1, Jf, !0), mi(r, 2)) : [];
        }),
        Ts = uu(function (n, t) {
          var r = jo(t);
          return Jf(r) && (r = X), Jf(n) ? Hr(n, ee(t, 1, Jf, !0), X, r) : [];
        }),
        $s = uu(function (n) {
          var t = c(n, ju);
          return t.length && t[0] === n[0] ? ke(t) : [];
        }),
        Ds = uu(function (n) {
          var t = jo(n),
            r = c(n, ju);
          return t === jo(r) ? t = X : r.pop(), r.length && r[0] === n[0] ? ke(r, mi(t, 2)) : [];
        }),
        Ms = uu(function (n) {
          var t = jo(n),
            r = c(n, ju);
          return t = "function" == typeof t ? t : X, t && r.pop(), r.length && r[0] === n[0] ? ke(r, X, t) : [];
        }),
        Fs = uu(Oo),
        Ns = gi(function (n, t) {
          var r = null == n ? 0 : n.length,
            e = Tr(n, t);
          return nu(n, c(t, function (n) {
            return Ci(n, r) ? +n : n;
          }).sort(Lu)), e;
        }),
        Ps = uu(function (n) {
          return gu(ee(n, 1, Jf, !0));
        }),
        qs = uu(function (n) {
          var t = jo(n);
          return Jf(t) && (t = X), gu(ee(n, 1, Jf, !0), mi(t, 2));
        }),
        Zs = uu(function (n) {
          var t = jo(n);
          return t = "function" == typeof t ? t : X, gu(ee(n, 1, Jf, !0), X, t);
        }),
        Ks = uu(function (n, t) {
          return Jf(n) ? Hr(n, t) : [];
        }),
        Vs = uu(function (n) {
          return mu(i(n, Jf));
        }),
        Gs = uu(function (n) {
          var t = jo(n);
          return Jf(t) && (t = X), mu(i(n, Jf), mi(t, 2));
        }),
        Hs = uu(function (n) {
          var t = jo(n);
          return t = "function" == typeof t ? t : X, mu(i(n, Jf), X, t);
        }),
        Js = uu(Go),
        Ys = uu(function (n) {
          var t = n.length,
            r = t > 1 ? n[t - 1] : X;
          return r = "function" == typeof r ? (n.pop(), r) : X, Ho(n, r);
        }),
        Qs = gi(function (n) {
          var t = n.length,
            r = t ? n[0] : 0,
            e = this.__wrapped__,
            u = function (t) {
              return Tr(t, n);
            };
          return !(t > 1 || this.__actions__.length) && e instanceof Ct && Ci(r) ? (e = e.slice(r, +r + (t ? 1 : 0)), e.__actions__.push({
            func: nf,
            args: [u],
            thisArg: X
          }), new Y(e, this.__chain__).thru(function (n) {
            return t && !n.length && n.push(X), n;
          })) : this.thru(u);
        }),
        Xs = Fu(function (n, t, r) {
          bl.call(n, r) ? ++n[r] : Br(n, r, 1);
        }),
        nh = Ju(ho),
        th = Ju(po),
        rh = Fu(function (n, t, r) {
          bl.call(n, r) ? n[r].push(t) : Br(n, r, [t]);
        }),
        eh = uu(function (t, r, e) {
          var u = -1,
            i = "function" == typeof r,
            o = Hf(t) ? il(t.length) : [];
          return ys(t, function (t) {
            o[++u] = i ? n(r, t, e) : Ie(t, r, e);
          }), o;
        }),
        uh = Fu(function (n, t, r) {
          Br(n, r, t);
        }),
        ih = Fu(function (n, t, r) {
          n[r ? 0 : 1].push(t);
        }, function () {
          return [[], []];
        }),
        oh = uu(function (n, t) {
          if (null == n) return [];
          var r = t.length;
          return r > 1 && Ui(n, t[0], t[1]) ? t = [] : r > 2 && Ui(t[0], t[1], t[2]) && (t = [t[0]]), He(n, ee(t, 1), []);
        }),
        fh = Dl || function () {
          return re.Date.now();
        },
        ch = uu(function (n, t, r) {
          var e = _n;
          if (r.length) {
            var u = N(r, wi(ch));
            e |= bn;
          }
          return ai(n, e, t, r, u);
        }),
        ah = uu(function (n, t, r) {
          var e = _n | vn;
          if (r.length) {
            var u = N(r, wi(ah));
            e |= bn;
          }
          return ai(t, e, n, r, u);
        }),
        lh = uu(function (n, t) {
          return Gr(n, 1, t);
        }),
        sh = uu(function (n, t, r) {
          return Gr(n, Ic(t) || 0, r);
        });
      Cf.Cache = sr;
      var hh = js(function (t, r) {
          r = 1 == r.length && bh(r[0]) ? c(r[0], z(mi())) : c(ee(r, 1), z(mi()));
          var e = r.length;
          return uu(function (u) {
            for (var i = -1, o = Hl(u.length, e); ++i < o;) u[i] = r[i].call(this, u[i]);
            return n(t, this, u);
          });
        }),
        ph = uu(function (n, t) {
          return ai(n, bn, X, t, N(t, wi(ph)));
        }),
        _h = uu(function (n, t) {
          return ai(n, wn, X, t, N(t, wi(_h)));
        }),
        vh = gi(function (n, t) {
          return ai(n, xn, X, X, X, t);
        }),
        gh = ii(me),
        yh = ii(function (n, t) {
          return n >= t;
        }),
        dh = Re(function () {
          return arguments;
        }()) ? Re : function (n) {
          return cc(n) && bl.call(n, "callee") && !Wl.call(n, "callee");
        },
        bh = il.isArray,
        wh = ce ? z(ce) : ze,
        mh = ql || qa,
        xh = ae ? z(ae) : Ee,
        jh = le ? z(le) : Le,
        Ah = se ? z(se) : Be,
        kh = he ? z(he) : Te,
        Oh = pe ? z(pe) : $e,
        Ih = ii(Ne),
        Rh = ii(function (n, t) {
          return n <= t;
        }),
        zh = Nu(function (n, t) {
          if (Mi(t) || Hf(t)) return $u(t, Pc(t), n), X;
          for (var r in t) bl.call(t, r) && Sr(n, r, t[r]);
        }),
        Eh = Nu(function (n, t) {
          $u(t, qc(t), n);
        }),
        Sh = Nu(function (n, t, r, e) {
          $u(t, qc(t), n, e);
        }),
        Wh = Nu(function (n, t, r, e) {
          $u(t, Pc(t), n, e);
        }),
        Lh = gi(Tr),
        Ch = uu(function (n, t) {
          n = ll(n);
          var r = -1,
            e = t.length,
            u = e > 2 ? t[2] : X;
          for (u && Ui(t[0], t[1], u) && (e = 1); ++r < e;) for (var i = t[r], o = qc(i), f = -1, c = o.length; ++f < c;) {
            var a = o[f],
              l = n[a];
            (l === X || Gf(l, gl[a]) && !bl.call(n, a)) && (n[a] = i[a]);
          }
          return n;
        }),
        Uh = uu(function (t) {
          return t.push(X, si), n(Mh, X, t);
        }),
        Bh = Xu(function (n, t, r) {
          null != t && "function" != typeof t.toString && (t = xl.call(t)), n[t] = r;
        }, Sa(La)),
        Th = Xu(function (n, t, r) {
          null != t && "function" != typeof t.toString && (t = xl.call(t)), bl.call(n, t) ? n[t].push(r) : n[t] = [r];
        }, mi),
        $h = uu(Ie),
        Dh = Nu(function (n, t, r) {
          Ke(n, t, r);
        }),
        Mh = Nu(function (n, t, r, e) {
          Ke(n, t, r, e);
        }),
        Fh = gi(function (n, t) {
          var r = {};
          if (null == n) return r;
          var e = !1;
          t = c(t, function (t) {
            return t = ku(t, n), e || (e = t.length > 1), t;
          }), $u(n, di(n), r), e && (r = Fr(r, an | ln | sn, hi));
          for (var u = t.length; u--;) yu(r, t[u]);
          return r;
        }),
        Nh = gi(function (n, t) {
          return null == n ? {} : Je(n, t);
        }),
        Ph = ci(Pc),
        qh = ci(qc),
        Zh = Vu(function (n, t, r) {
          return t = t.toLowerCase(), n + (r ? fa(t) : t);
        }),
        Kh = Vu(function (n, t, r) {
          return n + (r ? "-" : "") + t.toLowerCase();
        }),
        Vh = Vu(function (n, t, r) {
          return n + (r ? " " : "") + t.toLowerCase();
        }),
        Gh = Ku("toLowerCase"),
        Hh = Vu(function (n, t, r) {
          return n + (r ? "_" : "") + t.toLowerCase();
        }),
        Jh = Vu(function (n, t, r) {
          return n + (r ? " " : "") + Qh(t);
        }),
        Yh = Vu(function (n, t, r) {
          return n + (r ? " " : "") + t.toUpperCase();
        }),
        Qh = Ku("toUpperCase"),
        Xh = uu(function (t, r) {
          try {
            return n(t, X, r);
          } catch (n) {
            return rc(n) ? n : new fl(n);
          }
        }),
        np = gi(function (n, t) {
          return r(t, function (t) {
            t = no(t), Br(n, t, ch(n[t], n));
          }), n;
        }),
        tp = Yu(),
        rp = Yu(!0),
        ep = uu(function (n, t) {
          return function (r) {
            return Ie(r, n, t);
          };
        }),
        up = uu(function (n, t) {
          return function (r) {
            return Ie(n, r, t);
          };
        }),
        ip = ti(c),
        op = ti(u),
        fp = ti(h),
        cp = ui(),
        ap = ui(!0),
        lp = ni(function (n, t) {
          return n + t;
        }, 0),
        sp = fi("ceil"),
        hp = ni(function (n, t) {
          return n / t;
        }, 1),
        pp = fi("floor"),
        _p = ni(function (n, t) {
          return n * t;
        }, 1),
        vp = fi("round"),
        gp = ni(function (n, t) {
          return n - t;
        }, 0);
      return Z.after = If, Z.ary = Rf, Z.assign = zh, Z.assignIn = Eh, Z.assignInWith = Sh, Z.assignWith = Wh, Z.at = Lh, Z.before = zf, Z.bind = ch, Z.bindAll = np, Z.bindKey = ah, Z.castArray = Nf, Z.chain = Qo, Z.chunk = uo, Z.compact = io, Z.concat = oo, Z.cond = za, Z.conforms = Ea, Z.constant = Sa, Z.countBy = Xs, Z.create = Sc, Z.curry = Ef, Z.curryRight = Sf, Z.debounce = Wf, Z.defaults = Ch, Z.defaultsDeep = Uh, Z.defer = lh, Z.delay = sh, Z.difference = Us, Z.differenceBy = Bs, Z.differenceWith = Ts, Z.drop = fo, Z.dropRight = co, Z.dropRightWhile = ao, Z.dropWhile = lo, Z.fill = so, Z.filter = lf, Z.flatMap = sf, Z.flatMapDeep = hf, Z.flatMapDepth = pf, Z.flatten = _o, Z.flattenDeep = vo, Z.flattenDepth = go, Z.flip = Lf, Z.flow = tp, Z.flowRight = rp, Z.fromPairs = yo, Z.functions = $c, Z.functionsIn = Dc, Z.groupBy = rh, Z.initial = mo, Z.intersection = $s, Z.intersectionBy = Ds, Z.intersectionWith = Ms, Z.invert = Bh, Z.invertBy = Th, Z.invokeMap = eh, Z.iteratee = Ca, Z.keyBy = uh, Z.keys = Pc, Z.keysIn = qc, Z.map = yf, Z.mapKeys = Zc, Z.mapValues = Kc, Z.matches = Ua, Z.matchesProperty = Ba, Z.memoize = Cf, Z.merge = Dh, Z.mergeWith = Mh, Z.method = ep, Z.methodOf = up, Z.mixin = Ta, Z.negate = Uf, Z.nthArg = Ma, Z.omit = Fh, Z.omitBy = Vc, Z.once = Bf, Z.orderBy = df, Z.over = ip, Z.overArgs = hh, Z.overEvery = op, Z.overSome = fp, Z.partial = ph, Z.partialRight = _h, Z.partition = ih, Z.pick = Nh, Z.pickBy = Gc, Z.property = Fa, Z.propertyOf = Na, Z.pull = Fs, Z.pullAll = Oo, Z.pullAllBy = Io, Z.pullAllWith = Ro, Z.pullAt = Ns, Z.range = cp, Z.rangeRight = ap, Z.rearg = vh, Z.reject = mf, Z.remove = zo, Z.rest = Tf, Z.reverse = Eo, Z.sampleSize = jf, Z.set = Jc, Z.setWith = Yc, Z.shuffle = Af, Z.slice = So, Z.sortBy = oh, Z.sortedUniq = $o, Z.sortedUniqBy = Do, Z.split = da, Z.spread = $f, Z.tail = Mo, Z.take = Fo, Z.takeRight = No, Z.takeRightWhile = Po, Z.takeWhile = qo, Z.tap = Xo, Z.throttle = Df, Z.thru = nf, Z.toArray = jc, Z.toPairs = Ph, Z.toPairsIn = qh, Z.toPath = Ha, Z.toPlainObject = Rc, Z.transform = Qc, Z.unary = Mf, Z.union = Ps, Z.unionBy = qs, Z.unionWith = Zs, Z.uniq = Zo, Z.uniqBy = Ko, Z.uniqWith = Vo, Z.unset = Xc, Z.unzip = Go, Z.unzipWith = Ho, Z.update = na, Z.updateWith = ta, Z.values = ra, Z.valuesIn = ea, Z.without = Ks, Z.words = Ra, Z.wrap = Ff, Z.xor = Vs, Z.xorBy = Gs, Z.xorWith = Hs, Z.zip = Js, Z.zipObject = Jo, Z.zipObjectDeep = Yo, Z.zipWith = Ys, Z.entries = Ph, Z.entriesIn = qh, Z.extend = Eh, Z.extendWith = Sh, Ta(Z, Z), Z.add = lp, Z.attempt = Xh, Z.camelCase = Zh, Z.capitalize = fa, Z.ceil = sp, Z.clamp = ua, Z.clone = Pf, Z.cloneDeep = Zf, Z.cloneDeepWith = Kf, Z.cloneWith = qf, Z.conformsTo = Vf, Z.deburr = ca, Z.defaultTo = Wa, Z.divide = hp, Z.endsWith = aa, Z.eq = Gf, Z.escape = la, Z.escapeRegExp = sa, Z.every = af, Z.find = nh, Z.findIndex = ho, Z.findKey = Wc, Z.findLast = th, Z.findLastIndex = po, Z.findLastKey = Lc, Z.floor = pp, Z.forEach = _f, Z.forEachRight = vf, Z.forIn = Cc, Z.forInRight = Uc, Z.forOwn = Bc, Z.forOwnRight = Tc, Z.get = Mc, Z.gt = gh, Z.gte = yh, Z.has = Fc, Z.hasIn = Nc, Z.head = bo, Z.identity = La, Z.includes = gf, Z.indexOf = wo, Z.inRange = ia, Z.invoke = $h, Z.isArguments = dh, Z.isArray = bh, Z.isArrayBuffer = wh, Z.isArrayLike = Hf, Z.isArrayLikeObject = Jf, Z.isBoolean = Yf, Z.isBuffer = mh, Z.isDate = xh, Z.isElement = Qf, Z.isEmpty = Xf, Z.isEqual = nc, Z.isEqualWith = tc, Z.isError = rc, Z.isFinite = ec, Z.isFunction = uc, Z.isInteger = ic, Z.isLength = oc, Z.isMap = jh, Z.isMatch = ac, Z.isMatchWith = lc, Z.isNaN = sc, Z.isNative = hc, Z.isNil = _c, Z.isNull = pc, Z.isNumber = vc, Z.isObject = fc, Z.isObjectLike = cc, Z.isPlainObject = gc, Z.isRegExp = Ah, Z.isSafeInteger = yc, Z.isSet = kh, Z.isString = dc, Z.isSymbol = bc, Z.isTypedArray = Oh, Z.isUndefined = wc, Z.isWeakMap = mc, Z.isWeakSet = xc, Z.join = xo, Z.kebabCase = Kh, Z.last = jo, Z.lastIndexOf = Ao, Z.lowerCase = Vh, Z.lowerFirst = Gh, Z.lt = Ih, Z.lte = Rh, Z.max = Ya, Z.maxBy = Qa, Z.mean = Xa, Z.meanBy = nl, Z.min = tl, Z.minBy = rl, Z.stubArray = Pa, Z.stubFalse = qa, Z.stubObject = Za, Z.stubString = Ka, Z.stubTrue = Va, Z.multiply = _p, Z.nth = ko, Z.noConflict = $a, Z.noop = Da, Z.now = fh, Z.pad = ha, Z.padEnd = pa, Z.padStart = _a, Z.parseInt = va, Z.random = oa, Z.reduce = bf, Z.reduceRight = wf, Z.repeat = ga, Z.replace = ya, Z.result = Hc, Z.round = vp, Z.runInContext = p, Z.sample = xf, Z.size = kf, Z.snakeCase = Hh, Z.some = Of, Z.sortedIndex = Wo, Z.sortedIndexBy = Lo, Z.sortedIndexOf = Co, Z.sortedLastIndex = Uo, Z.sortedLastIndexBy = Bo, Z.sortedLastIndexOf = To, Z.startCase = Jh, Z.startsWith = ba, Z.subtract = gp, Z.sum = el, Z.sumBy = ul, Z.template = wa, Z.times = Ga, Z.toFinite = Ac, Z.toInteger = kc, Z.toLength = Oc, Z.toLower = ma, Z.toNumber = Ic, Z.toSafeInteger = zc, Z.toString = Ec, Z.toUpper = xa, Z.trim = ja, Z.trimEnd = Aa, Z.trimStart = ka, Z.truncate = Oa, Z.unescape = Ia, Z.uniqueId = Ja, Z.upperCase = Yh, Z.upperFirst = Qh, Z.each = _f, Z.eachRight = vf, Z.first = bo, Ta(Z, function () {
        var n = {};
        return ue(Z, function (t, r) {
          bl.call(Z.prototype, r) || (n[r] = t);
        }), n;
      }(), {
        chain: !1
      }), Z.VERSION = nn, r(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (n) {
        Z[n].placeholder = Z;
      }), r(["drop", "take"], function (n, t) {
        Ct.prototype[n] = function (r) {
          r = r === X ? 1 : Gl(kc(r), 0);
          var e = this.__filtered__ && !t ? new Ct(this) : this.clone();
          return e.__filtered__ ? e.__takeCount__ = Hl(r, e.__takeCount__) : e.__views__.push({
            size: Hl(r, Un),
            type: n + (e.__dir__ < 0 ? "Right" : "")
          }), e;
        }, Ct.prototype[n + "Right"] = function (t) {
          return this.reverse()[n](t).reverse();
        };
      }), r(["filter", "map", "takeWhile"], function (n, t) {
        var r = t + 1,
          e = r == Rn || r == En;
        Ct.prototype[n] = function (n) {
          var t = this.clone();
          return t.__iteratees__.push({
            iteratee: mi(n, 3),
            type: r
          }), t.__filtered__ = t.__filtered__ || e, t;
        };
      }), r(["head", "last"], function (n, t) {
        var r = "take" + (t ? "Right" : "");
        Ct.prototype[n] = function () {
          return this[r](1).value()[0];
        };
      }), r(["initial", "tail"], function (n, t) {
        var r = "drop" + (t ? "" : "Right");
        Ct.prototype[n] = function () {
          return this.__filtered__ ? new Ct(this) : this[r](1);
        };
      }), Ct.prototype.compact = function () {
        return this.filter(La);
      }, Ct.prototype.find = function (n) {
        return this.filter(n).head();
      }, Ct.prototype.findLast = function (n) {
        return this.reverse().find(n);
      }, Ct.prototype.invokeMap = uu(function (n, t) {
        return "function" == typeof n ? new Ct(this) : this.map(function (r) {
          return Ie(r, n, t);
        });
      }), Ct.prototype.reject = function (n) {
        return this.filter(Uf(mi(n)));
      }, Ct.prototype.slice = function (n, t) {
        n = kc(n);
        var r = this;
        return r.__filtered__ && (n > 0 || t < 0) ? new Ct(r) : (n < 0 ? r = r.takeRight(-n) : n && (r = r.drop(n)), t !== X && (t = kc(t), r = t < 0 ? r.dropRight(-t) : r.take(t - n)), r);
      }, Ct.prototype.takeRightWhile = function (n) {
        return this.reverse().takeWhile(n).reverse();
      }, Ct.prototype.toArray = function () {
        return this.take(Un);
      }, ue(Ct.prototype, function (n, t) {
        var r = /^(?:filter|find|map|reject)|While$/.test(t),
          e = /^(?:head|last)$/.test(t),
          u = Z[e ? "take" + ("last" == t ? "Right" : "") : t],
          i = e || /^find/.test(t);
        u && (Z.prototype[t] = function () {
          var t = this.__wrapped__,
            o = e ? [1] : arguments,
            f = t instanceof Ct,
            c = o[0],
            l = f || bh(t),
            s = function (n) {
              var t = u.apply(Z, a([n], o));
              return e && h ? t[0] : t;
            };
          l && r && "function" == typeof c && 1 != c.length && (f = l = !1);
          var h = this.__chain__,
            p = !!this.__actions__.length,
            _ = i && !h,
            v = f && !p;
          if (!i && l) {
            t = v ? t : new Ct(this);
            var g = n.apply(t, o);
            return g.__actions__.push({
              func: nf,
              args: [s],
              thisArg: X
            }), new Y(g, h);
          }
          return _ && v ? n.apply(this, o) : (g = this.thru(s), _ ? e ? g.value()[0] : g.value() : g);
        });
      }), r(["pop", "push", "shift", "sort", "splice", "unshift"], function (n) {
        var t = _l[n],
          r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
          e = /^(?:pop|shift)$/.test(n);
        Z.prototype[n] = function () {
          var n = arguments;
          if (e && !this.__chain__) {
            var u = this.value();
            return t.apply(bh(u) ? u : [], n);
          }
          return this[r](function (r) {
            return t.apply(bh(r) ? r : [], n);
          });
        };
      }), ue(Ct.prototype, function (n, t) {
        var r = Z[t];
        if (r) {
          var e = r.name + "";
          bl.call(fs, e) || (fs[e] = []), fs[e].push({
            name: t,
            func: r
          });
        }
      }), fs[Qu(X, vn).name] = [{
        name: "wrapper",
        func: X
      }], Ct.prototype.clone = $t, Ct.prototype.reverse = Yt, Ct.prototype.value = Qt, Z.prototype.at = Qs, Z.prototype.chain = tf, Z.prototype.commit = rf, Z.prototype.next = ef, Z.prototype.plant = of, Z.prototype.reverse = ff, Z.prototype.toJSON = Z.prototype.valueOf = Z.prototype.value = cf, Z.prototype.first = Z.prototype.head, Ul && (Z.prototype[Ul] = uf), Z;
    },
    be = de();
  ue ? ((ue.exports = be)._ = be, ee._ = be) : re._ = be;
}).call(commonjsGlobal);
}(lodash_min, lodash_min.exports));

var _mapping = {};

/** Used to map aliases to their real names. */

(function (exports) {
exports.aliasToReal = {
  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',
  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',
  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': ['assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create', 'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow', 'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll', 'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome', 'rest', 'reverse', 'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart', 'uniqueId', 'words', 'zipAll'],
  '2': ['add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith', 'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith', 'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN', 'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference', 'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq', 'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex', 'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach', 'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get', 'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection', 'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy', 'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty', 'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit', 'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial', 'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll', 'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove', 'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex', 'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy', 'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight', 'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars', 'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith', 'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject', 'zipObjectDeep'],
  '3': ['assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith', 'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr', 'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith', 'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth', 'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd', 'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight', 'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy', 'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy', 'xorWith', 'zipWith'],
  '4': ['fill', 'setWith', 'updateWith']
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': {
    'start': 0
  },
  'assignAllWith': {
    'start': 0
  },
  'assignInAll': {
    'start': 0
  },
  'assignInAllWith': {
    'start': 0
  },
  'defaultsAll': {
    'start': 0
  },
  'defaultsDeepAll': {
    'start': 0
  },
  'invokeArgs': {
    'start': 2
  },
  'invokeArgsMap': {
    'start': 2
  },
  'mergeAll': {
    'start': 0
  },
  'mergeAllWith': {
    'start': 0
  },
  'partial': {
    'start': 1
  },
  'partialRight': {
    'start': 1
  },
  'without': {
    'start': 1
  },
  'zipAll': {
    'start': 0
  }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = function () {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
    object = exports.aliasToReal,
    result = {};
  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}();

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};
}(_mapping));

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */

var placeholder = {};

var mapping = _mapping,
  fallbackHolder = placeholder;

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2 ? function (a, b) {
    return func.apply(undefined, arguments);
  } : function (a) {
    return func.apply(undefined, arguments);
  };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2 ? function (a, b) {
    return func(a, b);
  } : function (a) {
    return func(a);
  };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
    result = Array(length);
  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function (object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function () {
    var length = arguments.length,
      lastIndex = length - 1,
      args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
      otherArgs = args.slice(0, start);
    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function () {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
    isObj = name === Object(name);
  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError();
  }
  options || (options = {});
  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };
  var defaultHolder = isLib ? func : fallbackHolder,
    forceCurry = 'curry' in options && options.curry,
    forceFixed = 'fixed' in options && options.fixed,
    forceRearg = 'rearg' in options && options.rearg,
    pristine = isLib ? func.runInContext() : undefined;
  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };
  var ary = helpers.ary,
    assign = helpers.assign,
    clone = helpers.clone,
    curry = helpers.curry,
    each = helpers.forEach,
    isArray = helpers.isArray,
    isError = helpers.isError,
    isFunction = helpers.isFunction,
    isWeakMap = helpers.isWeakMap,
    keys = helpers.keys,
    rearg = helpers.rearg,
    toInteger = helpers.toInteger,
    toPath = helpers.toPath;
  var aryMethodKeys = keys(mapping.aryMethod);
  var wrappers = {
    'castArray': function (castArray) {
      return function () {
        var value = arguments[0];
        return isArray(value) ? castArray(cloneArray(value)) : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function (iteratee) {
      return function () {
        var func = arguments[0],
          arity = arguments[1],
          result = iteratee(func, arity),
          length = result.length;
        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? arity - 2 : 1;
          return length && length <= arity ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function (mixin) {
      return function (source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function (key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });
        mixin(func, Object(source));
        each(pairs, function (pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function (nthArg) {
      return function (n) {
        var arity = n < 0 ? 1 : toInteger(n) + 1;
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function (rearg) {
      return function (func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function (runInContext) {
      return function (context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
        start = data && data.start;
      return start === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]) ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n]) : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);
    var index = -1,
      length = path.length,
      lastIndex = length - 1,
      result = clone(Object(object)),
      nested = result;
    while (nested != null && ++index < length) {
      var key = path[index],
        value = nested[key];
      if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
      methodName = mapping.remap[realName] || realName,
      oldOptions = options;
    return function (options) {
      var newUtil = isLib ? pristine : helpers,
        newFunc = isLib ? pristine[methodName] : func,
        newOptions = assign(assign({}, oldOptions), options);
      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function (func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function (func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function () {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : length - 1;
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
      realName = mapping.aliasToReal[name] || name,
      wrapped = func,
      wrapper = wrappers[realName];
    if (wrapper) {
      wrapped = wrapper(func);
    } else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      } else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      } else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function (aryKey) {
      each(mapping.aryMethod[aryKey], function (otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
            afterRearg = data && data.afterRearg;
          result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });
    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function () {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function (aryKey) {
    each(mapping.aryMethod[aryKey], function (key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function (key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function (pair) {
    _[pair[0]] = pair[1];
  });
  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function (key) {
    each(mapping.realToAlias[key] || [], function (alias) {
      _[alias] = _[key];
    });
  });
  return _;
}
var _baseConvert = baseConvert;

var _ = lodash_min.exports.runInContext();
var fp = _baseConvert(_, _);

var AddNewTagButton = function AddNewTagButton(_ref) {
  var resourceLabelSingular = _ref.resourceLabelSingular,
    form = _ref.form,
    isDisabled = _ref.isDisabled,
    disabledAddTooltip = _ref.disabledAddTooltip;
    _ref.max;
    var dataTestId = _ref.dataTestId;
  var handleFormChange = form.handleFormChange,
    formState = form.formState;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$2, {
    tooltipLeft: true,
    "data-testid": dataTestId && "".concat(dataTestId, "-button"),
    tooltip: isDisabled ? disabledAddTooltip : null,
    disabled: isDisabled,
    variant: "text",
    onClick: function onClick() {
      handleFormChange((formState.tags || []).concat([{
        key: "",
        value: ""
      }]), {
        name: "tags"
      });
    }
  }, "+ Add new ", resourceLabelSingular));
};
var ProviderTagsGridHeader = function ProviderTagsGridHeader(_ref2) {
  var resourceLabelSingular = _ref2.resourceLabelSingular,
    keyName = _ref2.keyName,
    valueName = _ref2.valueName,
    dataTestId = _ref2.dataTestId;
  var valueHeader = resourceLabelSingular ? "".concat(resourceLabelSingular, " value") : valueName;
  var keyHeader = resourceLabelSingular ? "".concat(resourceLabelSingular, " key") : keyName;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": dataTestId && "".concat(dataTestId, "-tags-key-value-row"),
    className: styles$6['tags-grid-header']
  }, /*#__PURE__*/React__default.createElement(Text, {
    "data-testid": dataTestId && "".concat(dataTestId, "-tags-key-header"),
    bold: true
  }, keyHeader, " "), /*#__PURE__*/React__default.createElement(Text, {
    "data-testid": dataTestId && "".concat(dataTestId, "-tags-value-header"),
    bold: true
  }, valueHeader));
};
var ProviderTagsGrid = function ProviderTagsGrid(_ref3) {
  var form = _ref3.form,
    keyPlaceholder = _ref3.keyPlaceholder,
    valuePlaceholder = _ref3.valuePlaceholder,
    dataTestId = _ref3.dataTestId;
  var formState = form.formState,
    formErrors = form.formErrors,
    handleFormChange = form.handleFormChange,
    submissionAttempted = form.submissionAttempted;
  var tags = formState.tags;
  var dirty = useRef({});
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['tags-grid']
  }, _$1.reduceRight(tags.length > 0 ? tags : [{
    key: "",
    value: ""
  }], function (accumulator, tag, index) {
    var keyInError = formErrors["tags[".concat(index, "].key")];
    var valueInError = formErrors["tags[".concat(index, "].value")];
    var keyDirty = dirty.current["[".concat(index, "].key")];
    var valueDirty = dirty.current["[".concat(index, "].value")];
    return accumulator.concat(/*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(FormFieldInputNew, {
      form: form,
      onChange: function onChange(e) {
        dirty.current["[".concat(index, "].key")] = true;
        handleFormChange(fp.set("[".concat(index, "].key"), e.target.value)(tags), {
          name: "tags"
        });
      },
      value: tag.key,
      showError: keyInError && (submissionAttempted || keyDirty),
      errorMessage: formErrors["tags[".concat(index, "].key")],
      placeholder: keyPlaceholder,
      style: {
        marginBottom: 0
      },
      dataTestId: dataTestId && "".concat(dataTestId, "-tag-key-").concat(tag.key)
    }), /*#__PURE__*/React__default.createElement(FormFieldInputNew, {
      form: form,
      onChange: function onChange(e) {
        dirty.current["[".concat(index, "].value")] = true;
        handleFormChange(fp.set("[".concat(index, "].value"), e.target.value)(tags), {
          name: "tags"
        });
      },
      value: tag.value,
      showError: valueInError && (submissionAttempted || valueDirty),
      errorMessage: formErrors["tags[".concat(index, "].value")],
      placeholder: valuePlaceholder,
      style: {
        marginBottom: 0
      },
      dataTestId: dataTestId && "".concat(dataTestId, "-tag-value-").concat(tag.value)
    }), tags.length > 0 && /*#__PURE__*/React__default.createElement(Button$2, {
      "data-testid": 'remove-tag-button',
      variant: "icon",
      color: "secondary",
      onClick: function onClick() {
        handleFormChange([].concat(_toConsumableArray$1(tags.slice(0, index)), _toConsumableArray$1(tags.slice(index + 1))), {
          name: "tags"
        });
      }
    }, /*#__PURE__*/React__default.createElement(CloseIcon, null))));
  }, []));
};
var ProviderTagsWidget = /*#__PURE__*/React__default.memo(function (_ref4) {
  var _ref4$resourceLabelSi = _ref4.resourceLabelSingular,
    resourceLabelSingular = _ref4$resourceLabelSi === void 0 ? "tag" : _ref4$resourceLabelSi,
    _ref4$resourceLabelPl = _ref4.resourceLabelPlural,
    resourceLabelPlural = _ref4$resourceLabelPl === void 0 ? "tags" : _ref4$resourceLabelPl,
    onChange = _ref4.onChange,
    keyPlaceholder = _ref4.keyPlaceholder,
    valuePlaceholder = _ref4.valuePlaceholder,
    max = _ref4.max,
    maxLabel = _ref4.maxLabel,
    disabledAddTooltip = _ref4.disabledAddTooltip,
    validator = _ref4.validator,
    _ref4$defaultValue = _ref4.defaultValue,
    defaultValue = _ref4$defaultValue === void 0 ? [] : _ref4$defaultValue,
    _form = _ref4.form,
    dataTestId = _ref4.dataTestId;
  var createdForm = useForm({
    tags: defaultValue
  }, validator);
  var form = _form || createdForm;
  useEffect(function () {
    if (onChange) {
      onChange(form.formState.tags);
    }
  }, [form]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['widget-row']
  }, /*#__PURE__*/React__default.createElement(AddNewTagButton, {
    dataTestId: dataTestId && "".concat(dataTestId, "-add-new-tag"),
    resourceLabelSingular: resourceLabelSingular,
    disabledAddTooltip: disabledAddTooltip,
    isDisabled: max && form.formState.tags.length >= max,
    form: form,
    max: max
  })), (maxLabel || max) && /*#__PURE__*/React__default.createElement(Text, {
    "data-testid": dataTestId && "".concat(dataTestId, "-maximum-tags-text"),
    style: {
      marginBottom: 24
    }
  }, "You can add up to ", maxLabel || max, " ", resourceLabelPlural, "."), /*#__PURE__*/React__default.createElement(ProviderTagsGridHeader, {
    dataTestId: dataTestId && "".concat(dataTestId, "-grid-header"),
    resourceLabelSingular: resourceLabelSingular
  }), /*#__PURE__*/React__default.createElement(ProviderTagsGrid, {
    dataTestId: dataTestId && "".concat(dataTestId, "-grid"),
    form: form,
    keyPlaceholder: keyPlaceholder,
    valuePlaceholder: valuePlaceholder
  }));
});
var tagsDefault = [{
  key: "",
  value: ""
}];
var ProviderTagsModal = /*#__PURE__*/React__default.memo(function (_ref5) {
  var _ref5$resourceLabelSi = _ref5.resourceLabelSingular,
    resourceLabelSingular = _ref5$resourceLabelSi === void 0 ? "tag" : _ref5$resourceLabelSi,
    _ref5$resourceLabelPl = _ref5.resourceLabelPlural,
    resourceLabelPlural = _ref5$resourceLabelPl === void 0 ? "tags" : _ref5$resourceLabelPl,
    modalHeader = _ref5.modalHeader,
    closeTrigger = _ref5.closeTrigger,
    onSave = _ref5.onSave,
    keyPlaceholder = _ref5.keyPlaceholder,
    valuePlaceholder = _ref5.valuePlaceholder,
    max = _ref5.max,
    disabledAddTooltip = _ref5.disabledAddTooltip,
    validator = _ref5.validator,
    fixedHeight = _ref5.fixedHeight,
    _ref5$defaultValue = _ref5.defaultValue,
    defaultValue = _ref5$defaultValue === void 0 ? tagsDefault : _ref5$defaultValue;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var form = useForm({
    tags: defaultValue
  }, validator);
  var handleFormSubmit = form.handleFormSubmit,
    handleFormChange = form.handleFormChange;
  var handleTagChange = function handleTagChange(tags) {
    handleFormChange(tags, {
      name: "tags"
    });
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    className: styles$6.modal,
    style: fixedHeight ? {
      maxHeight: fixedHeight
    } : undefined
  }, /*#__PURE__*/React__default.createElement(Header, null, modalHeader ? modalHeader : "Add ".concat(resourceLabelPlural)), /*#__PURE__*/React__default.createElement(Content$1, null, /*#__PURE__*/React__default.createElement(ProviderTagsWidget, {
    resourceLabelSingular: resourceLabelSingular,
    resourceLabelPlural: resourceLabelPlural,
    keyPlaceholder: keyPlaceholder,
    valuePlaceholder: valuePlaceholder,
    max: max,
    disabledAddTooltip: disabledAddTooltip,
    onChange: handleTagChange,
    defaultValue: form.formState.tags
  })), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Button$2, {
    isSubmitting: isSubmitting,
    color: "primary",
    onClick: handleFormSubmit(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var input, returnValue;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            input = form.formState.tags;
            returnValue = onSave(input) || Promise.resolve();
            _context.prev = 3;
            _context.next = 6;
            return returnValue;
          case 6:
            closeTrigger();
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            setIsSubmitting(false);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    })))
  }, "Save"), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "secondary",
    onClick: closeTrigger
  }, "Cancel")));
});
var ViewProviderTagsModal = /*#__PURE__*/React__default.memo(function (_ref7) {
  var _ref7$resourceLabelPl = _ref7.resourceLabelPlural,
    resourceLabelPlural = _ref7$resourceLabelPl === void 0 ? "Tags" : _ref7$resourceLabelPl,
    closeTrigger = _ref7.closeTrigger,
    tags = _ref7.tags,
    SubLabel = _ref7.SubLabel,
    fixedHeight = _ref7.fixedHeight,
    dataTestId = _ref7.dataTestId;
  return /*#__PURE__*/React__default.createElement(Modal, {
    className: styles$6.modal,
    style: fixedHeight ? {
      maxHeight: fixedHeight
    } : undefined
  }, /*#__PURE__*/React__default.createElement(Header, null, "View ", resourceLabelPlural), /*#__PURE__*/React__default.createElement(Content$1, null, SubLabel && /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['sublabel-row']
  }, /*#__PURE__*/React__default.createElement(SubLabel, null)), /*#__PURE__*/React__default.createElement(ProviderTagsGridHeader, {
    dataTestId: dataTestId && "".concat(dataTestId, "-grid-header"),
    resourceLabelPlural: resourceLabelPlural
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['tags-grid']
  }, _$1.map(tags, function (tag, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(FormFieldInputNew, {
      value: tag.key,
      disabled: true,
      dataTestId: dataTestId
    }), /*#__PURE__*/React__default.createElement(FormFieldInputNew, {
      value: tag.value,
      disabled: true,
      dataTestId: dataTestId
    }), /*#__PURE__*/React__default.createElement("div", null));
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Button$2, {
    color: "primary",
    onClick: closeTrigger
  }, "Close")));
});
var ProviderTagsModal$1 = ProviderTagsModal;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key];
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache: Cache,
  split: split,
  normalizePath: normalizePath,
  setter: function (path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index = 0;
      var len = parts.length;
      var data = obj;
      while (index < len - 1) {
        var part = parts[index];
        if (part === '__proto__' || part === 'constructor' || part === 'prototype') {
          return obj;
        }
        data = data[parts[index++]];
      }
      data[parts[index]] = value;
    });
  },
  getter: function (path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data) {
      var index = 0,
        len = parts.length;
      while (index < len) {
        if (data != null || !safe) data = data[parts[index++]];else return;
      }
      return data;
    });
  },
  join: function (segments) {
    return segments.reduce(function (path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
    }, '');
  },
  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(path, split(path).map(function (part) {
    return part.replace(CLEAN_QUOTES_REGEX, '$2');
  }));
}
function split(path) {
  return path.match(SPLIT_REGEX) || [''];
}
function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}

const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const words = str => str.match(reWords) || [];
const upperFirst = str => str[0].toUpperCase() + str.slice(1);
const join = (str, d) => words(str).join(d).toLowerCase();
const camelCase = str => words(str).reduce((acc, next) => `${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const pascalCase = str => upperFirst(camelCase(str));
const snakeCase = str => join(str, '_');
const kebabCase = str => join(str, '-');
const sentenceCase = str => upperFirst(join(str, ' '));
const titleCase = str => words(str).map(upperFirst).join(' ');
var tinyCase = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase
};

var toposort$2 = {exports: {}};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$2.exports = function (edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$2.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length,
    sorted = new Array(cursor),
    visited = {},
    i = cursor
    // Better data structures make algorithm much faster.
    ,
    outgoingEdges = makeOutgoingEdges(edges),
    nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function (edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    }
  });
  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }
  return sorted;
  function visit(node, i, predecessors) {
    if (predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch (e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep);
    }
    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
    }
    if (visited[i]) return;
    visited[i] = true;
    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);
    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i);
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr) {
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res;
}

var toposort$1 = toposort$2.exports;

const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = 'Error';
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    // Attempt to make the path more friendly for error message interpolation.
    const path = params.label || params.path || 'this';
    // Store the original path under `originalPath` so it isn't lost to custom
    // message functions; e.g., ones provided in `setLocale()` calls.
    params = Object.assign({}, params, {
      path,
      originalPath: params.path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = 'Error';
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}
let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.';
    return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
let tuple = {
  notType: params => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = obj => obj && obj.__isYupSchema__;
class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}
const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;
const isAbsent = value => value == null;
function createValidation(config) {
  function validate({
    value,
    path = '',
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (const key of Object.keys(nextParams)) nextParams[key] = resolve(nextParams[key]);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}
function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}
class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src, seen = new Map()) {
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent,
    parentPath,
    originalParent,
    options
  }) {
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;
const returnsTrue = () => true;
function create$8(spec) {
  return new MixedSchema(spec);
}
class MixedSchema extends Schema {
  constructor(spec) {
    super(typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec));
  }
}
create$8.prototype = MixedSchema.prototype;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  const struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}

//
// Number Interfaces
//

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
DateSchema.prototype;

// @ts-expect-error
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort$1.array(Array.from(nodes), edges).reverse();
}
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
const parseJson = (value, _, ctx) => {
  if (typeof value !== 'string') {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return ctx.isType(parsed) ? parsed : value;
};

// @ts-ignore
function deepPartial(schema) {
  if ('fields' in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    const nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...propertyExpr.normalizePath(p)];
  if (path.length === 1) return path[0] in obj;
  let last = path.pop();
  let parent = propertyExpr.getter(propertyExpr.join(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: 'object',
      check(value) {
        return isObject(value) || typeof value === 'function';
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);

    //should ignore nulls here
    if (value === undefined) return this.getDefault(options);
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
    let intermediateValue = {}; // is filled during the transform below
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = prop in value;
      if (field) {
        let fieldValue;
        let inputValue = value[prop];

        // safe to mutate since this is fired in sequence
        innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ?
        // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, fieldErrors => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === undefined ? schemaOrRef : target;
    }
    return next.withMutation(s =>
    // XXX: excludes here is wrong
    s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
  }
  _getDefault(options) {
    if ('default' in this.spec) {
      return super._getDefault(options);
    }

    // if there is no default set invent one
    if (!this._nodes.length) {
      return undefined;
    }
    let dft = {};
    this._nodes.forEach(key => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    // XXX: this carries over edges which may not be what you want
    if (excludedEdges) next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation(next => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }

      // XXX: excludes here is wrong
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(([a, b]) => keys.includes(a) && keys.includes(b)));
  }
  omit(keys) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys.includes(key)) continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform(obj => {
      if (!obj) return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }

  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(message) {
    return this.test({
      name: 'exact',
      exclusive: true,
      message: message || object.exact,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return unknownKeys.length === 0 || this.createError({
          params: {
            properties: unknownKeys.join(', ')
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: true
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== 'boolean') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => {
      if (!obj) return obj;
      const result = {};
      for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCase.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCase.snakeCase);
  }
  constantCase() {
    return this.transformKeys(key => tinyCase.snakeCase(key).toUpperCase());
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(next.fields)) {
      var _innerOptions2;
      let innerOptions = options;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;

var TagSelectionGridHeader = function TagSelectionGridHeader(_ref) {
  var keyName = _ref.keyName,
    valueName = _ref.valueName;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['selection-tags-grid-header']
  }, /*#__PURE__*/React__default.createElement(Text, {
    bold: true
  }, keyName), /*#__PURE__*/React__default.createElement(Text, {
    bold: true
  }, valueName));
};
var TagSelectionGrid = function TagSelectionGrid(_ref2) {
  var form = _ref2.form,
    _ref2$keyName = _ref2.keyName,
    keyName = _ref2$keyName === void 0 ? "key" : _ref2$keyName,
    _ref2$valueName = _ref2.valueName,
    valueName = _ref2$valueName === void 0 ? "value" : _ref2$valueName;
  var formState = form.formState,
    handleFormChange = form.handleFormChange;
  var tagSelection = formState.tagSelection;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['selection-tags-grid']
  }, _$1.map(tagSelection, function (tag, index) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: tag.checked,
      name: "checked",
      form: form,
      onChange: function onChange() {
        var checkedState = tagSelection[index].checked;
        handleFormChange(fp.set("[".concat(index, "].checked"), !checkedState)(tagSelection), {
          name: "tagSelection"
        });
      }
    })), /*#__PURE__*/React__default.createElement(FormFieldInputNew, {
      value: tag[keyName],
      name: keyName,
      disabled: true
    }), /*#__PURE__*/React__default.createElement(FormFieldInputNew, {
      value: tag[valueName],
      disabled: true,
      name: valueName
    }));
  }));
};
var validation = create$3().shape({
  tagSelection: create$8().test({
    test: function test(tags) {
      return !!_$1.find(tags, {
        checked: true
      });
    },
    message: "At least one must be selected"
  })
});
var TagSelectionModal = /*#__PURE__*/React__default.memo(function (_ref3) {
  var _ref3$keyName = _ref3.keyName,
    keyName = _ref3$keyName === void 0 ? "Key" : _ref3$keyName,
    _ref3$valueName = _ref3.valueName,
    valueName = _ref3$valueName === void 0 ? 'Value' : _ref3$valueName,
    closeTrigger = _ref3.closeTrigger,
    onSave = _ref3.onSave,
    tags = _ref3.tags,
    SubLabel = _ref3.SubLabel,
    fixedHeight = _ref3.fixedHeight;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var form = useForm({
    tagSelection: tags
  }, validation);
  var handleFormSubmit = form.handleFormSubmit,
    formErrors = form.formErrors,
    submissionAttempted = form.submissionAttempted;
  return /*#__PURE__*/React__default.createElement(Modal, {
    className: styles$6.modal,
    style: fixedHeight ? {
      maxHeight: fixedHeight
    } : undefined
  }, /*#__PURE__*/React__default.createElement(Header, null, "View ", keyName), /*#__PURE__*/React__default.createElement(Content$1, null, SubLabel && /*#__PURE__*/React__default.createElement("div", {
    className: styles$6['sublabel-row']
  }, /*#__PURE__*/React__default.createElement(SubLabel, null)), /*#__PURE__*/React__default.createElement(TagSelectionGridHeader, {
    keyName: keyName,
    valueName: valueName
  }), /*#__PURE__*/React__default.createElement(TagSelectionGrid, {
    form: form
  })), /*#__PURE__*/React__default.createElement(ModalFooter, {
    error: submissionAttempted ? formErrors.tagSelection : null
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    isSubmitting: isSubmitting,
    color: "primary",
    onClick: handleFormSubmit(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var returnValue;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            returnValue = onSave(form.formState.tagSelection) || Promise.resolve();
            _context.prev = 2;
            _context.next = 5;
            return returnValue;
          case 5:
            closeTrigger();
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            setIsSubmitting(false);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 8]]);
    })))
  }, "Save"), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "secondary",
    onClick: closeTrigger
  }, "Cancel")));
});
var TagSelectionModal$1 = TagSelectionModal;

var styles$5 = {"review-grid":"ReviewWidget-module_review-grid__1ODTm","auto-size":"ReviewWidget-module_auto-size__SCWl2","bgshimmer":"ReviewWidget-module_bgshimmer__3mXt8"};

var ReviewGrid = /*#__PURE__*/React__default.memo(function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    autosize = _ref.autosize,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": dataTestId,
    className: classNames(styles$5['review-grid'], _defineProperty$3({}, styles$5['auto-size'], autosize), className),
    style: style
  }, children);
});
var ReviewWidget = /*#__PURE__*/React__default.memo(function (_ref2) {
  var sections = _ref2.sections,
    _ref2$children = _ref2.children,
    _children = _ref2$children === void 0 ? [] : _ref2$children,
    style = _ref2.style,
    dataTestId = _ref2.dataTestId;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentSection = _useState2[0],
    setCurrentSection = _useState2[1];
  var children = _$1.isArray(_children) ? _children : [_children];
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$5.base,
    style: style
  }, /*#__PURE__*/React__default.createElement(InnerTab, {
    dataTestId: dataTestId,
    expand: true,
    variant: "card"
  }, sections.map(function (section, index) {
    return /*#__PURE__*/React__default.createElement(InnerTab.Button, {
      dataTestId: dataTestId && "".concat(dataTestId, "-").concat(section, "-tab"),
      key: index,
      isActive: currentSection === index,
      onClick: function onClick() {
        setCurrentSection(index);
      }
    }, section);
  })), children[currentSection]);
});
var ReviewWidget$1 = ReviewWidget;

var styles$4 = {"row":"DnDReorderTable-module_row__3KQcL","disabled":"DnDReorderTable-module_disabled__ra3w5","indexColumn":"DnDReorderTable-module_indexColumn__2mFHL","deleteColumn":"DnDReorderTable-module_deleteColumn__1RaV6","header-row":"DnDReorderTable-module_header-row__3gi3A","header-cell":"DnDReorderTable-module_header-cell__1gyy3","header-cell-popover-trigger":"DnDReorderTable-module_header-cell-popover-trigger__2Av62"};

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const DefaultCellRenderer = ({ value }) => {
    return jsx$3(Fragment, { children: value });
};
const RenderHeaderCell = ({ column }) => {
    return jsxs("div", { className: styles$4['header-cell'], children: [jsx$3("span", { children: column.header }), column.popoverText && jsx$3(Popover$1, Object.assign({ triggerClassName: styles$4['header-cell-popover-trigger'], triggerOnClick: true }, column.popoverProps, { children: column.popoverText }))] });
};
const RowContentsRenderer = ({ row, columns, rows, index }) => {
    return jsx$3(Fragment, { children: columns.map(column => {
            const Renderer = column.Renderer || DefaultCellRenderer;
            const value = _$1.isString(row) ? row : (column.accessor ? _$1.get(row, column.accessor) : row[column.id]);
            return jsx$3("div", { children: jsx$3(Renderer, { value: value, row: row, index: index, rows: rows }) }, column.id);
        }) });
};
const DnDReorderTable = React__default.memo(({ rows, columns, updateRows, minRows = 0, isDisabled }) => {
    const containerRef = useRef(null);
    const [dragProps, setDragProps] = useState([]);
    const onPointerDown = useCallback(e => {
        var _a;
        if (!e.target.getAttribute("data-drag-handle") && !((_a = e.target.parentNode) === null || _a === void 0 ? void 0 : _a.getAttribute("data-drag-handle"))) {
            return;
        }
        const handle = e.target.closest("[data-drag-handle]");
        const dragItemIndex = handle.getAttribute("data-drag-handle");
        let movement = 0;
        const startIndex = Number.parseInt(dragItemIndex);
        let endIndex = startIndex;
        handle.setPointerCapture(e.pointerId);
        const startDetails = Array.from(containerRef.current.childNodes).map(node => {
            return node.getBoundingClientRect();
        });
        const pointerMoveListener = (e) => {
            movement = movement + e.movementY;
            const handleRect = handle.getBoundingClientRect();
            endIndex = startIndex;
            if (movement > 0) {
                const newHandleBottom = handleRect.y + handleRect.height + e.movementY;
                const lastIndex = findLastIndex(startDetails, (rect, index) => {
                    if (index !== startIndex) {
                        const nodeHalf = rect.y + rect.height / 2;
                        return newHandleBottom > nodeHalf;
                    }
                });
                if (lastIndex !== -1) {
                    endIndex = lastIndex;
                }
            }
            else if (movement < 0) {
                const newHandleTop = handleRect.y + e.movementY;
                const firstIndex = findIndex$1(startDetails, (rect, index) => {
                    if (index < startIndex) {
                        const nodeHalf = rect.y + rect.height / 2;
                        return newHandleTop < nodeHalf;
                    }
                });
                if (firstIndex !== -1) {
                    endIndex = firstIndex;
                }
            }
            const newDragProps = startDetails.map((rect, index) => {
                if (index === startIndex) {
                    return {
                        transform: `translateY(${movement}px)`,
                        position: "relative",
                        zIndex: 1,
                        pointerEvents: "none",
                        userSelect: "none"
                    };
                }
                else {
                    if (index < startIndex && index < endIndex) { //if started before, end before => stay
                        return {
                            transform: `translateY(0)`
                        };
                    }
                    else if (index < startIndex && index >= endIndex) { //if started before, end after => go down
                        return {
                            transform: `translateY(${handleRect.height}px)`
                        };
                    }
                    else if (index > startIndex && index > endIndex) { //if started after, end after => stay
                        return {
                            transform: `translateY(0)`
                        };
                    }
                    else if (index > startIndex && index <= endIndex) { //if started after, end before => go up
                        return {
                            transform: `translateY(${-1 * handleRect.height}px)`
                        };
                    }
                }
            });
            setDragProps(newDragProps);
        };
        const pointerUpListener = () => {
            setDragProps([]);
            handle.releasePointerCapture(e.pointerId);
            document.removeEventListener("pointermove", pointerMoveListener);
            document.removeEventListener("pointerup", pointerUpListener);
            if (startIndex !== endIndex) {
                updateRows(reorder(rows, startIndex, endIndex));
            }
        };
        document.addEventListener("pointermove", pointerMoveListener);
        document.addEventListener("pointerup", pointerUpListener);
    }, [updateRows, rows]);
    return jsxs("div", { children: [jsxs("div", { style: { gridTemplateColumns: `24px repeat(${columns.length}, 1fr) 52px` }, className: styles$4['header-row'], children: [jsx$3("div", { children: "#" }), columns.map(column => {
                        return jsx$3(RenderHeaderCell, { column: column }, column.id);
                    }), jsx$3("div", {})] }), jsx$3("div", { ref: containerRef, style: { position: "relative" }, children: rows.map((row, index) => {
                    return jsxs("div", { style: Object.assign({ gridTemplateColumns: `24px repeat(${columns.length}, 1fr) 52px` }, dragProps[index]), className: classNames(styles$4.row, { [styles$4.disabled]: isDisabled }), "data-drag-handle": index, onPointerDown: isDisabled ? undefined : onPointerDown, children: [jsx$3("div", { className: styles$4.indexColumn, children: index + 1 }), jsx$3(RowContentsRenderer, { columns: columns, row: row, rows: rows, index: index }), jsx$3("div", { className: styles$4.deleteColumn, children: !isDisabled && jsx$3(Button$2, { variant: "icon", color: "secondary", onClick: () => updateRows([...rows.slice(0, index), ...rows.slice(index + 1)]), disabled: rows.length <= minRows, children: jsx$3(CloseIcon, {}) }) })] }, index);
                }) })] });
});

var styles$3 = {"base":"AccordionCard-module_base__160B6","header":"AccordionCard-module_header__3aXa8","hoverable":"AccordionCard-module_hoverable__3SbpM","disabled":"AccordionCard-module_disabled__2HzYq","clickable":"AccordionCard-module_clickable__eSVmd","title":"AccordionCard-module_title__2bPdZ","title-popover":"AccordionCard-module_title-popover__5zJpe","animation":"AccordionCard-module_animation__3JKz2","accordion-card-content":"AccordionCard-module_accordion-card-content__2qjoL","accordion-table":"AccordionCard-module_accordion-table__2EBe6","is-grouped":"AccordionCard-module_is-grouped__3Nlcw","multi-value":"AccordionCard-module_multi-value__1mbMp","loader":"AccordionCard-module_loader__NugCD","bgshimmer":"AccordionCard-module_bgshimmer__wqDiP"};

var styles$2 = {"base":"ComponentRenderError-module_base__35DeL"};

var ComponentRenderError = function ComponentRenderError(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.base
  }, children);
};
var ComponentRenderError$1 = ComponentRenderError;

var AccordionContext = /*#__PURE__*/React__default.createContext(null);
var useAccordionContext = function useAccordionContext() {
  return useContext(AccordionContext);
};
var AccordionController = /*#__PURE__*/React__default.memo(function (_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    openChildren = _useState2[0],
    setOpenChildren = _useState2[1];
  var idRef = useRef(crypto.randomUUID());
  var toggleOpenChild = useCallback(function (childId) {
    return setOpenChildren(function (prev) {
      if (prev !== null && prev !== void 0 && prev[childId]) {
        return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty$3({}, childId, false));
      } else {
        return _defineProperty$3({}, childId, true);
      }
    });
  }, [setOpenChildren]);
  var controller = useMemo(function () {
    return {
      openChildren: openChildren,
      toggleOpenChild: toggleOpenChild,
      setOpenChildren: setOpenChildren,
      id: idRef.current,
      closeAll: function closeAll() {
        setOpenChildren(null);
      }
    };
  }, [openChildren, toggleOpenChild, idRef, setOpenChildren]);
  return /*#__PURE__*/React__default.createElement(AccordionContext.Provider, {
    value: controller
  }, children);
});
var AccordionTable = /*#__PURE__*/React__default.memo(function (_ref3) {
  var children = _ref3.children,
    _ref3$isGrouped = _ref3.isGrouped,
    isGrouped = _ref3$isGrouped === void 0 ? false : _ref3$isGrouped,
    dataTestId = _ref3.dataTestId;
  var context = useAccordionContext();
  var ref = useRef();
  useEffect(function () {
    var accordionTableHeaderStyle = window.document.createElement('style');
    accordionTableHeaderStyle.type = 'text/css';
    getStyleRoot().appendChild(accordionTableHeaderStyle);
    if (context !== null && context !== void 0 && context.id) {
      var max = 0;
      var _iterator = _createForOfIteratorHelper(ref.current.getElementsByClassName("at-".concat(context.id))),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var card = _step.value;
          max = Math.max(card.clientWidth, max);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      accordionTableHeaderStyle.innerHTML = ".".concat(styles$3.header, ".ah-").concat(context.id, " {\n                grid-template-columns: minmax(").concat(max, "px, max-content) 1fr max-content max-content max-content;\n            }");
    }
    return function () {
      getStyleRoot().removeChild(accordionTableHeaderStyle);
    };
  }, [context === null || context === void 0 ? void 0 : context.id]);
  if (!context) {
    return /*#__PURE__*/React__default.createElement(ComponentRenderError$1, null, "Accordion Table Rendered outside AccordionController!");
  }
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: classNames(styles$3['accordion-table'], _defineProperty$3({}, styles$3['is-grouped'], isGrouped)),
    "data-testid": dataTestId
  }, children);
});
var AccordionCardContent = /*#__PURE__*/React__default.memo(function (_ref4) {
  var children = _ref4.children,
    className = _ref4.className,
    style = _ref4.style,
    dataTestId = _ref4.dataTestId;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$3['accordion-card-content'], className),
    style: style,
    "data-testid": dataTestId
  }, children);
});
var AccordionValue = /*#__PURE__*/React__default.memo(function (_ref5) {
  var value = _ref5.value,
    ValueContent = _ref5.ValueContent,
    isDisabled = _ref5.isDisabled,
    dataTestId = _ref5.dataTestId;
  if (_$1.isArray(value)) {
    var values = value.filter(function (value) {
      return !!value;
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$3['multi-value']
    }, values.map(function (value, index) {
      return /*#__PURE__*/React__default.createElement(Span, {
        color: isDisabled ? "text-disabled" : undefined,
        key: index
      }, value);
    }), /*#__PURE__*/React__default.createElement(Tooltip$1, null, values.join(", ")));
  } else if (ValueContent) {
    return /*#__PURE__*/React__default.createElement(ValueContent, {
      isDisabled: isDisabled
    });
  } else {
    return /*#__PURE__*/React__default.createElement(Span, {
      title: value,
      ellipsis: true,
      color: isDisabled ? "text-disabled" : undefined,
      "data-testid": dataTestId
    }, value);
  }
});

/**
 * isDisabled affects value/title appearance and prevents selection but does not prevent expand
 * isExpandDisabled prevents only expand
 * isLoading sets both isDisabled and isExpandDisabled
 *
 * If an AccordionCard can be expanded, and it doesnt have select option or left/right widgets, then click on the header will expand
 * If the card is selectable or has left/right widgets, only click on arrow will expand
 */
var AccordionCard = /*#__PURE__*/React__default.memo(function (_ref6) {
  var title = _ref6.title,
    value = _ref6.value,
    ValueContent = _ref6.ValueContent,
    isLoading = _ref6.isLoading,
    LeftWidget = _ref6.LeftWidget,
    RightWidget = _ref6.RightWidget,
    children = _ref6.children,
    className = _ref6.className,
    style = _ref6.style,
    headerClassName = _ref6.headerClassName,
    headerStyle = _ref6.headerStyle,
    _isDisabled = _ref6.isDisabled,
    _isExpandDisabled = _ref6.isExpandDisabled,
    isSelected = _ref6.isSelected,
    onSelect = _ref6.onSelect,
    name = _ref6.name,
    tooltip = _ref6.tooltip,
    dataTestId = _ref6.dataTestId;
  var context = useAccordionContext();
  if (!context) {
    return /*#__PURE__*/React__default.createElement(ComponentRenderError$1, null, "Accordion Card Rendered outside AccordionController!");
  }
  var openChildren = context.openChildren,
    toggleOpenChild = context.toggleOpenChild;
  var isExpandDisabled = _isExpandDisabled || isLoading;
  var isDisabled = _isDisabled || isLoading;
  var id = useRef(name || crypto.randomUUID());
  var isOpen = openChildren === null || openChildren === void 0 ? void 0 : openChildren[id.current];
  var canOpen = !!children && !isExpandDisabled;
  var hasInnerContent = !!children;
  var hasInnerControls = LeftWidget || RightWidget || onSelect;
  var showValue = (value || ValueContent) && !isOpen && !isLoading;
  var HeaderComponent = canOpen && !hasInnerControls ? "button" : "div";
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$3.base, className),
    style: style,
    "data-testid": dataTestId
  }, /*#__PURE__*/React__default.createElement(HeaderComponent, {
    className: classNames(styles$3.header, headerClassName, "ah-".concat(context.id), _defineProperty$3(_defineProperty$3(_defineProperty$3({}, styles$3['hoverable'], !isOpen && !isDisabled), styles$3['clickable'], canOpen && !hasInnerControls), styles$3['disabled'], isDisabled)),
    style: headerStyle,
    onClick: canOpen && !hasInnerControls ? function () {
      return toggleOpenChild(id.current);
    } : undefined
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$3['title'], " at-").concat(context.id)
  }, onSelect && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "none",
    onClick: onSelect,
    disabled: isDisabled
  }, /*#__PURE__*/React__default.createElement(CheckComponent, {
    isSelected: isSelected,
    isHoverable: true,
    isDisabled: isDisabled
  })), tooltip && /*#__PURE__*/React__default.createElement(Popover$1, {
    triggerClassName: styles$3["title-popover"]
  }, tooltip), /*#__PURE__*/React__default.createElement(Span, {
    bold: true,
    color: isDisabled ? "text-disabled" : undefined
  }, title)), showValue && /*#__PURE__*/React__default.createElement(AccordionValue, {
    value: value,
    ValueContent: ValueContent,
    isDisabled: isDisabled,
    dataTestId: dataTestId && "".concat(dataTestId, "-value")
  }), !showValue && !isLoading && /*#__PURE__*/React__default.createElement("div", null), isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.loader
  }, /*#__PURE__*/React__default.createElement(ThreeDotLoader, null), /*#__PURE__*/React__default.createElement(Span, {
    color: "text-disabled"
  }, "Loading data")), LeftWidget ? /*#__PURE__*/React__default.createElement(LeftWidget, null) : /*#__PURE__*/React__default.createElement("div", null), RightWidget ? /*#__PURE__*/React__default.createElement(RightWidget, null) : /*#__PURE__*/React__default.createElement("div", null), hasInnerContent && !hasInnerControls && /*#__PURE__*/React__default.createElement(TransitionChevron, {
    isActive: isOpen,
    wide: true,
    color: "icon-secondary"
  }), hasInnerContent && hasInnerControls && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "none",
    disabled: !canOpen,
    onClick: function onClick() {
      return toggleOpenChild(id.current);
    }
  }, /*#__PURE__*/React__default.createElement(TransitionChevron, {
    isActive: isOpen,
    wide: true,
    color: "icon-secondary"
  })), !hasInnerContent && /*#__PURE__*/React__default.createElement("div", null)), /*#__PURE__*/React__default.createElement(lib.UnmountClosed, {
    isOpened: isOpen,
    theme: {
      collapse: styles$3['animation']
    }
  }, children));
});
var AccordionCard$1 = AccordionCard;

var useHover = function useHover() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHover = _useState2[1];
  return {
    isHovered: isHovered,
    hoverParentProps: {
      onMouseEnter: function onMouseEnter() {
        return setIsHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHover(false);
      }
    }
  };
};
var useHover$1 = useHover;

var styles$1 = {"white":"#fff","backgroundGrey":"#F5F5F5","whiteGrey":"#fbfbfb","textGrey":"#404040","textDarkGrey":"#838383","lightBorder":"#e0e0e0","mediumBorder":"#c8c8c8","darkBorder":"rgba(167, 167, 167, 0.6549019608)","disabledGrey":"#c8c8c8","textGreyDisabled":"#c8c8c8","inputFieldBorder":"rgba(167, 167, 167, 0.6549019608)","menuDivider":"#e4e4e4","primaryBlue":"#006dc9","primaryBlueHover":"#2359a3","primaryBlueDisabled":"#93b3e5","secondaryBlueDisabled":"#edf4ff","secondaryBlueHover":"#F2F7FF","accentBlue":"#1fa0ff","accentBlueLight":"#98d5ff","errorRed":"#da1e27","errorBackground":"#fff5f5","successGreen":"#27d397","successBackground":"#f2fcf9","informationBlue":"#00c4ff","informationBackground":"#f0f7ff","warningOrange":"#eb6d12","warningBackground":"#fff6ef","base":"FixedLeftNav-module_base__1owhU","header":"FixedLeftNav-module_header__fQRPZ","links":"FixedLeftNav-module_links__2B5EL","link":"FixedLeftNav-module_link__c1pxp","link-selected":"FixedLeftNav-module_link-selected__1AYO3","drop-down-icon":"FixedLeftNav-module_drop-down-icon__M6kx7","external-icon":"FixedLeftNav-module_external-icon__lKcNq","secondary-external-icon":"FixedLeftNav-module_secondary-external-icon__3XYea","secondary-nav":"FixedLeftNav-module_secondary-nav__1yZui","secondary-link":"FixedLeftNav-module_secondary-link__Ngb_H","secondary-link-selected":"FixedLeftNav-module_secondary-link-selected__3OYMN","label":"FixedLeftNav-module_label__1wF3d","bgshimmer":"FixedLeftNav-module_bgshimmer__2CkFh"};

var SecondaryNavInternal = function SecondaryNavInternal(_ref) {
  var href = _ref.href,
    Icon = _ref.Icon,
    title = _ref.title,
    Component = _ref.Component,
    label = _ref.label;
  return /*#__PURE__*/React__default.createElement(Component, {
    to: href,
    className: styles$1['secondary-link'],
    activeClassName: styles$1['secondary-link-selected']
  }, Icon && /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("span", null, title), label && /*#__PURE__*/React__default.createElement(Label, {
    text: label
  }));
};
var SecondaryExternalNav = function SecondaryExternalNav(_ref2) {
  var linkKey = _ref2.linkKey,
    Icon = _ref2.Icon,
    title = _ref2.title,
    Component = _ref2.Component,
    NavIcon = _ref2.NavIcon,
    label = _ref2.label;
  return /*#__PURE__*/React__default.createElement(Component, {
    className: styles$1['secondary-link'],
    linkKey: linkKey,
    newTab: true
  }, Icon && /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("span", null, title), /*#__PURE__*/React__default.createElement(NavIcon, {
    className: styles$1['secondary-external-icon']
  }), label && /*#__PURE__*/React__default.createElement(Label, {
    text: label
  }));
};
var NavDropDown = function NavDropDown(_ref3) {
  var Icon = _ref3.Icon,
    title = _ref3.title,
    onMouseOver = _ref3.onMouseOver,
    NavIcon = _ref3.NavIcon;
  return /*#__PURE__*/React__default.createElement("button", {
    className: styles$1['link'],
    onMouseOver: onMouseOver
  }, /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("span", null, title), /*#__PURE__*/React__default.createElement(NavIcon, {
    className: styles$1['drop-down-icon']
  }));
};
var NavExternal = function NavExternal(_ref4) {
  var linkKey = _ref4.linkKey,
    Icon = _ref4.Icon,
    title = _ref4.title,
    Component = _ref4.Component,
    NavIcon = _ref4.NavIcon,
    label = _ref4.label;
  return /*#__PURE__*/React__default.createElement(Component, {
    className: styles$1['link'],
    linkKey: linkKey,
    newTab: true
  }, /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("span", null, title), /*#__PURE__*/React__default.createElement(NavIcon, {
    className: styles$1['external-icon']
  }), label && /*#__PURE__*/React__default.createElement(Label, {
    text: label
  }));
};
var NavInternal = function NavInternal(_ref5) {
  var to = _ref5.to,
    Icon = _ref5.Icon,
    title = _ref5.title,
    Component = _ref5.Component,
    label = _ref5.label;
  return /*#__PURE__*/React__default.createElement(Component, {
    to: to,
    className: styles$1['link'],
    activeClassName: styles$1['link-selected']
  }, /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("span", null, title), label && /*#__PURE__*/React__default.createElement(Label, {
    text: label
  }));
};
var NavAction = function NavAction(_ref6) {
  var Icon = _ref6.Icon,
    title = _ref6.title,
    onClick = _ref6.onClick,
    label = _ref6.label;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "".concat(styles$1['link']),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Icon, null), /*#__PURE__*/React__default.createElement("span", null, title), label && /*#__PURE__*/React__default.createElement(Label, {
    text: label
  }));
};
var Label = function Label(_ref7) {
  var text = _ref7.text;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$1['label']
  }, text);
};
var _default = /*#__PURE__*/function (_Component) {
  function _default(props) {
    var _this;
    _classCallCheck$2(this, _default);
    _this = _callSuper(this, _default, [props]);
    _this.state = {};
    return _this;
  }
  _inherits$2(_default, _Component);
  return _createClass$2(_default, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mainLinks = _this$props.mainLinks,
        InternalLink = _this$props.InternalLink,
        ExternalLink = _this$props.ExternalLink,
        HeaderButton = _this$props.HeaderButton,
        ArrowIcon = _this$props.ArrowIcon,
        ExternalLinkIcon = _this$props.ExternalLinkIcon;
      return /*#__PURE__*/React__default.createElement("div", {
        onMouseLeave: function onMouseLeave() {
          _this2.setState({
            openDropDown: null
          });
        }
      }, /*#__PURE__*/React__default.createElement("nav", {
        className: styles$1['base']
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1['header']
      }, /*#__PURE__*/React__default.createElement(HeaderButton, null)), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1['links']
      }, mainLinks.map(function (_ref8) {
        var isExternalLink = _ref8.isExternalLink,
          isDropdown = _ref8.isDropdown,
          isAction = _ref8.isAction,
          href = _ref8.href,
          linkKey = _ref8.linkKey,
          Icon = _ref8.Icon,
          title = _ref8.title,
          onClick = _ref8.onClick,
          links = _ref8.links,
          label = _ref8.label;
        return /*#__PURE__*/React__default.createElement("div", {
          key: title,
          onMouseOver: function onMouseOver(el) {
            _this2.setState({
              openDropDown: null
            });
          }
        }, isDropdown && /*#__PURE__*/React__default.createElement(NavDropDown, {
          NavIcon: ArrowIcon,
          Icon: Icon,
          title: title,
          links: links,
          key: title,
          onMouseOver: function onMouseOver(el) {
            el.stopPropagation();
            if (_this2.state.openDropDown !== links) {
              _this2.setState({
                openDropDown: links,
                dropDownTop: el.currentTarget.getBoundingClientRect().top
              });
            }
          }
        }), isAction && /*#__PURE__*/React__default.createElement(NavAction, {
          label: label,
          Icon: Icon,
          title: title,
          onClick: onClick,
          key: title,
          onMouseOver: function onMouseOver(el) {
            _this2.setState({
              openDropDown: null
            });
          }
        }), isExternalLink && /*#__PURE__*/React__default.createElement(NavExternal, {
          label: label,
          NavIcon: ExternalLinkIcon,
          Component: ExternalLink,
          linkKey: linkKey,
          Icon: Icon,
          title: title,
          key: title,
          onMouseOver: function onMouseOver(el) {
            _this2.setState({
              openDropDown: null
            });
          }
        }), !isDropdown && !isAction && !isExternalLink && /*#__PURE__*/React__default.createElement(NavInternal, {
          label: label,
          Component: InternalLink,
          to: href,
          Icon: Icon,
          title: title,
          key: title,
          onMouseOver: function onMouseOver(el) {
            _this2.setState({
              openDropDown: null
            });
          }
        }));
      }))), this.state.openDropDown && /*#__PURE__*/React__default.createElement("nav", {
        className: styles$1['secondary-nav'],
        style: {
          top: this.state.dropDownTop,
          maxHeight: "calc(100% - ".concat(this.state.dropDownTop, "px)")
        }
      }, this.state.openDropDown.map(function (_ref9) {
        var isExternalLink = _ref9.isExternalLink,
          Icon = _ref9.Icon,
          title = _ref9.title,
          href = _ref9.href,
          linkKey = _ref9.linkKey,
          label = _ref9.label;
        if (isExternalLink) {
          return /*#__PURE__*/React__default.createElement(SecondaryExternalNav, {
            label: label,
            NavIcon: ExternalLinkIcon,
            Component: ExternalLink,
            Icon: Icon,
            title: title,
            linkKey: linkKey,
            key: title
          });
        } else {
          return /*#__PURE__*/React__default.createElement(SecondaryNavInternal, {
            label: label,
            Component: InternalLink,
            Icon: Icon,
            title: title,
            href: href,
            key: title
          });
        }
      })));
    }
  }]);
}(Component);

var styles = {"base":"CodeSnippet-module_base__3nXYY","allow-break":"CodeSnippet-module_allow-break__2Qzlt","copy":"CodeSnippet-module_copy__3g5sc","content":"CodeSnippet-module_content__GY1Fs","bgshimmer":"CodeSnippet-module_bgshimmer__3hjH_"};

var CodeSnippet = /*#__PURE__*/React__default.memo(function (_ref) {
  var text = _ref.text,
    className = _ref.className,
    style = _ref.style,
    highLightLanguage = _ref.highLightLanguage,
    contentClassName = _ref.contentClassName,
    contentStyle = _ref.contentStyle,
    allowBreak = _ref.allowBreak,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.base, className, _defineProperty$3({}, styles["allow-break"], allowBreak)),
    style: style,
    "data-testid": dataTestId
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.content, contentClassName),
    style: contentStyle
  }, !highLightLanguage && /*#__PURE__*/React__default.createElement("code", null, text), highLightLanguage && /*#__PURE__*/React__default.createElement(SyntaxHighlighter, {
    language: highLightLanguage
  }, text)), /*#__PURE__*/React__default.createElement(CopyButton$1, {
    className: styles.copy,
    text: text,
    color: "secondary"
  }));
});
var CodeSnippet$1 = CodeSnippet;

var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;
  if (props == null || !hasOwn.call(props, 'css')) {
    return React.createElement.apply(undefined, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return React.createElement.apply(null, createElementArgArray);
};
(function (_jsx) {
  var JSX;
  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}

const standardScroll = (width = 11) => css `
  scrollbar-color: var(--scroller) var(--scroller-track);
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: ${width}px;
    height: ${width}px;
  }
;

  &::-webkit-scrollbar-track {
    background-color: var(--scroller-track);
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--scroller);
  }
`;
const small = (styles) => css `
  @media (max-width: 1366px) {
    ${styles}
  }
`;
const medium = (styles) => css `
  @media (max-width: 1690px) {
    ${styles}
  }
`;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	standardScroll: standardScroll,
	small: small,
	medium: medium
});

const Layout = {
    Content,
    Container,
    Column: Column$1,
    Page,
    BreadcrumbsContainer,
    BreadcrumbsWidgets,
    FixedPanel: FixedPanel$1,
    StickyContainer: StickyContainer$1,
    Grid,
    GridItem,
    GridBreak,
    SplitPane
};

export { AccordionCard$1 as AccordionCard, AccordionCardContent, AccordionController, AccordionTable, ActionMenu, ActionMenuButtonStyle, AddNewTagButton, BarChart, Breadcrumbs, BulletList, Button$2 as Button, ButtonStyleMenuPopover, ButtonsGroup, Card, CardContent, CardContentLoading, CardHeader, CardMetricContent, CardRadioGroup$1 as CardRadioGroup, CardTableContent, CardTableItem, CardTitle, CardWidgets, CheckComponent, Checkbox, CheckboxFilter, Chevron, ChoiceSelector$1 as ChoiceSelector, ClickAway, CodeSnippet$1 as CodeSnippet, CommonCellAtoms, CommonCellRenderers, CommonColumns, ComparisonChart, ComponentLazy, ComponentLoader, CopyButton$1 as CopyButton, CopyMenuItem, DefaultInfoItem, DialogLazy, DisableScroll, DnDReorderTable, DontExit$1 as DontExit, DonutChart, DropdownButton, DropdownFilter, ExternalLink, ExternalTableFilters, FieldError, _default as FixedLeftNav, FormFieldCopyAndDownload, FormFieldCopyButton, FormFieldDownloadButton, FormFieldInline, FormFieldInputButton$1 as FormFieldInputButton, FormFieldInputNew, FormFieldSelect$1 as FormFieldSelect, FormFieldTextArea, FormFieldUploadFile, Formidable, Heading, HorizontalRatioBar, IconsCircleBorder$1 as IconsCircleBorder, InlineLoader, InlineNotification, InlineSelector, InnerNav$1 as InnerNav, InnerTab, Layout, LineGraph, LoadingCard, LoadingMask, MainLoader, MenuItem, MenuPopover$1 as MenuPopover, MenuTriggerIcon, MetricItemStyle1, MetricItemStyle2, MetricItemStyle3, MetricItemStyle4, Modal, Content$1 as ModalContent, ModalFooter, Header as ModalHeader, NoDataGraph, NoForm, NotAvailableCellData, Notice, Notification, Notifications, NumberedList, OptionalGroup, OptionalGroupAccordion, OverviewBanner, Popover$1 as Popover, PopoverBulletList, PopoverContext, PopoverMechanism, ProgressLoader, ProviderTagsGrid, ProviderTagsGridHeader, ProviderTagsModal$1 as ProviderTagsModal, ProviderTagsWidget, RadioButton, RadioSelection, RadioSelectionGroup, ReviewGrid, ReviewWidget$1 as ReviewWidget, RoundDropdownButton, RoundFilterButton$1 as RoundFilterButton, SearchWidget, SelectableCard, SlideInChoiceSelector$1 as SlideDownChoiceSelector, SlideInChoiceSelector$3 as SlideInChoiceSelector, Slider$1 as Slider, SlidingHeaderMenu, SlidingManagementWidget, SlidingManagementWidgetBackButton, SlidingManagementWidgetHeader, SlidingMenu, SolidCircleIcon, SolidSquareIcon, SpaceBetween, Span, StyledLink, SubTable$1 as SubTable, SummaryHeader, SummaryHeaderLoader, MetricItemStyle3 as SummaryHeaderMetricItem, SvgLazy, SyntaxHighlighter, TabColumnContent$1 as TabColumnContent, TabHeader, TabLinks, TabWidgets$1 as TabWidgets, TabWithNav, TabWithNavContent, TabWithNavContentContainer, Table$1 as Table, TableCounter, TablePager, TableWidgets, Tag, TagSelectionGrid, TagSelectionGridHeader, TagSelectionModal$1 as TagSelectionModal, Text, TextWithArrowTrigger, ThemeProvider, ThreeDotLoader, Toggle, Tooltip$1 as Tooltip, TooltipListContent, TransitionChevron, ViewProviderTagsModal, WidgetDivider, Wizard$1 as Wizard, WizardContent$1 as WizardContent, WizardFooter$1 as WizardFooter, WizardHeader$1 as WizardHeader, WizardHeaderTitle$1 as WizardHeaderTitle, WizardStepTransitionRenderer, WizardSteps$1 as WizardSteps, WizardTransition, closeActivePopover$1 as closeActivePopover, emotion as emotionMixins, extractErrorMessage, fadeClassNames, getRootComponent, getStyleRoot, height, initModalTargetListener, matchPropType, readFileFromEvent, removeMainLoader, saveToDisk, setExternalLinkTracker, setLinkProvider, setRootComponent, setStyleRoot, slideLtrAbsoluteClassNames, slideLtrClassNames, slideRtlAbsoluteClassNames, slideRtlClassNames, slideTopToBottomClassNames, standardDuration, standardEasing, styles$v as tableStyles, useAccordionContext, useActionMenu, useBodyClass$1 as useBodyClass, useCurrentTheme, useForm, useHover$1 as useHover, useModal, useOptionEnsure$1 as useOptionEnsure, usePoller, useSelectionStateToForm$1 as useSelectionStateToForm, useTable, useTimeout, useWizard, useWizardController, yupValidator };
//# sourceMappingURL=index.js.map
